export const options = {
  "KINTAI new": {
    "image_url": "../upload_images/Artnova/Sofas/KINTAI new/main.jpg",
    "product_url": "https://www.artnova.website/en/art/337/kintai-new.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/KINTAI new/main.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/1.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/2.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/3.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/4.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/5.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/6.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/7.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/8.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/9.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/10.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/11.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/12.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/13.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/14.jpg",
      "../upload_images/Artnova/Sofas/KINTAI new/15.jpg"
    ],
    "description": "כרכים אווריריים וצורות פיסוליות יוצרים משחק, ומחיים את הקווים המזמינים של מערכת הספות KINTAI. המושבים והמשענות משתלבים בצורה חלקה במארג חדש ובלתי צפוי של צורות. קימורים נדיבים מתקיימים בהרמוניה עם גאומטריות אדריכליות, המגדירים סגנון עכשווי וחדשני. אישיות חזקה ובעלת אופי אופנתי.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 28528,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "SKYLINE new": {
    "image_url": "../upload_images/Artnova/Sofas/SKYLINE new/main.jpg",
    "product_url": "https://www.artnova.website/en/art/356/skyline-new.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/SKYLINE new/main.jpg",
      "../upload_images/Artnova/Sofas/SKYLINE new/1.jpg",
      "../upload_images/Artnova/Sofas/SKYLINE new/2.jpg",
      "../upload_images/Artnova/Sofas/SKYLINE new/3.jpg",
      "../upload_images/Artnova/Sofas/SKYLINE new/4.jpg",
      "../upload_images/Artnova/Sofas/SKYLINE new/5.jpg",
      "../upload_images/Artnova/Sofas/SKYLINE new/6.jpg"
    ],
    "description": "קווים מחמירים, גמישות עיצובית גבוהה ואלגנטיות נצחית מגדירים את Skyline - מערכת ישיבה הנפרסת על בסיס פאנל דק ואוורירי. גב, משענות יד ופריטים משלימים משתלבים ליצירת מספר תצורות שונות והבמה האידיאלית לכריות רכות - אלמנטים רכים המשתלבים בקווים הנקיים של מערכת הישיבה. שילוב של בדים, קטיפות ועורות מזכיר טקסטורות עדינות ומובהקות המאפשרות פרויקטים בלעדיים וייחודיים.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 25381,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "CURVE new": {
    "image_url": "../upload_images/Artnova/Sofas/CURVE new/main.jpg",
    "product_url": "https://www.artnova.website/en/art/333/curve-new.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/CURVE new/main.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/1.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/2.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/3.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/4.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/5.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/6.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/7.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/8.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/9.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/10.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/11.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/12.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/13.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/14.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/15.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/16.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/17.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/18.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/19.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/20.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/21.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/22.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/23.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/24.jpg",
      "../upload_images/Artnova/Sofas/CURVE new/25.jpg"
    ],
    "description": "קוּרב הוא מערכת איים המאופיינת בצורה ארוטית בשילוב עם נפחים רכים, פיסוליים ונעימים. מערכת אלמנטים גמישים המשחקים ומלווים זה את זה בקומבינציות מקוריות ואלגנטיות: ארכיפלגים של איים בהשראת צורות אורגניות של הטבע. הגב המוביל והנייד מעשיר את מערכת הספות ומבטיח חופש תנועה ונוחות מוחלטת. המושב עוטף, הגב מקבל ועוקב אחר הגוף, ויוצר חללים שהם ארגונומיים, פרטיים, מזמינים ורב-תכליתיים.\n\nהארכיפלג המפתה של אלמנטים חדשניים הופך את חללי הבית, מרכך את הקווים המסורתיים בעזרת חושניות ורכות, ויוצר דינמיקות חדשות של מגורים ואסתטיקה בתוך הבית.\n\nקומפוזיציות גמישות נצמדות לקירות, מתעדנות מערכים אורתוגונליים נוקשים ויוצרות פתרונות מעוגלים ועוטפים שמבטיחים מקוריות ופונקציונליות. צורות מפתות ומיוחדות מביעות סגנון אסתטי רוחבי המתאים ומתעשר לפי הטעם של מקומות שונים.\n\nהקווים הרכים והמרקם של בדים מעודנים מגדירים עולם נעים ומרחף שמקרין אלגנטיות נצחית.\n\nבפשטות ויזואלית לכאורה, חומרים חדשניים וטכנולוגיות ייצור מתוחכמות מסתירים את הגמישות הקיצונית של השימוש ואת ההנאה מתענוג בלתי צפוי ועדיין מפתה באותה מידה. קוּרב הוא מערכת ספות היוצרת חלל ביתי חדש ומפתה: מפתיע, מרגיע ושלו.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 19960,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BYRON": {
    "image_url": "../upload_images/Artnova/Sofas/BYRON/main.jpg",
    "product_url": "https://www.artnova.website/en/art/319/byron.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/BYRON/main.jpg",
      "../upload_images/Artnova/Sofas/BYRON/1.jpg",
      "../upload_images/Artnova/Sofas/BYRON/2.jpg",
      "../upload_images/Artnova/Sofas/BYRON/3.jpg",
      "../upload_images/Artnova/Sofas/BYRON/4.jpg",
      "../upload_images/Artnova/Sofas/BYRON/5.jpg",
      "../upload_images/Artnova/Sofas/BYRON/6.jpg",
      "../upload_images/Artnova/Sofas/BYRON/7.jpg",
      "../upload_images/Artnova/Sofas/BYRON/8.jpg",
      "../upload_images/Artnova/Sofas/BYRON/9.jpg",
      "../upload_images/Artnova/Sofas/BYRON/10.jpg",
      "../upload_images/Artnova/Sofas/BYRON/11.jpg",
      "../upload_images/Artnova/Sofas/BYRON/12.jpg",
      "../upload_images/Artnova/Sofas/BYRON/13.jpg",
      "../upload_images/Artnova/Sofas/BYRON/14.jpg",
      "../upload_images/Artnova/Sofas/BYRON/15.jpg",
      "../upload_images/Artnova/Sofas/BYRON/16.jpg"
    ],
    "description": "משחק מתוחכם בין המבנה הקליל והאלגנטי לבין הקריאה המרגיעה של הרולים, באיכות חומרים מעודנת, מאפיין את הרוח החדשנית של פרויקט ביירון. קווים הרמוניים וקשיחות פורמלית משתלבים יחד ליצירת מערכת ישיבה בעלת אופי סיכוני חזק.\n\nהאסתטיקה החדה והמתוחכמת מסתירה חומרים חדשניים ומסורתיים אשר משתלבים במיומנות ליצירת נוחות עליונה. המושב המזמין, הכריות הארגונומיות ואפשרויות העומק השונות (92 ו-102 ס\"מ) מאפשרים יצירת ספה המתאימה לכל צורך ברגיעה או אירוח.\n\nהשילוב של משענות יד קונבנציונליות או רולים ניידים מפצל את ההרכב, ויוצר סגנון דינמי ומכוון מאוד לפרויקט. הבוקה של החומרים והטקסטורות המוצגים באוסף מביאים לחיים מגוון רחב של תערובות יצירתיות. תערובות בלתי רגילות, הממותנות על ידי האופי ההרמוני של ביירון, שתמיד מפגין טעם מאוזן ומעודן.\n\nהיקום של אביזרים ופריטים משלימים המסתובבים סביב ביירון מרומם את הגמישות וההבעה הקומפוזיטית שלו. המשחק של שולחנות צד חופפים, חומרים וצבעים חוזרים מגדיר סגנון מושך ואישי לפנים המגורים.\n\nהשילוב של טכנולוגיה וידע-איך יוצר חפצים ייחודיים, עשירים בקסם. הקווים המכריעים והדקים של בסיס האלומיניום רצים לאורך ביירון, משתלבים בשיחה עם גימורי עור ובד בלעדיים: תפרי פיפינג יוצרים נפחים מדויקים ומביעים חייטות משובחת.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 25231,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BLUM": {
    "image_url": "../upload_images/Artnova/Sofas/BLUM/main.jpg",
    "product_url": "https://www.artnova.website/en/art/206/blum.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/BLUM/main.jpg",
      "../upload_images/Artnova/Sofas/BLUM/1.jpg",
      "../upload_images/Artnova/Sofas/BLUM/2.jpg",
      "../upload_images/Artnova/Sofas/BLUM/3.jpg",
      "../upload_images/Artnova/Sofas/BLUM/4.jpg",
      "../upload_images/Artnova/Sofas/BLUM/5.jpg",
      "../upload_images/Artnova/Sofas/BLUM/6.jpg",
      "../upload_images/Artnova/Sofas/BLUM/7.jpg",
      "../upload_images/Artnova/Sofas/BLUM/8.jpg"
    ],
    "description": "חזות קלילה, פרטים מעוצבים במיומנות ונוחות הישיבה מייצגים את האיכויות החיוניות של BLUM.\n\nBLUM מחבקת את הגוף בזכות שילוביה השונים של תמיכה קונבנציונאלית וחדשנית מריפודים שונים ומשענת גב ארגונומית.\n\nBLUM מציעה תמיכה ארגונומית גבוהה המאפיינת חומרים מסורתיים וקצף פוליאוריתן חדשני. ספה בהתאמה אישית המשלבת מסורת וטכנולוגיה, יחד עם פתרונות מבניים חדשניים.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 18345,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "CLOUD Limited Edition": {
    "image_url": "../upload_images/Artnova/Sofas/CLOUD Limited Edition/main.jpg",
    "product_url": "https://www.artnova.website/en/art/294/cloud-limited-edition.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/CLOUD Limited Edition/main.jpg",
      "../upload_images/Artnova/Sofas/CLOUD Limited Edition/1.jpg",
      "../upload_images/Artnova/Sofas/CLOUD Limited Edition/2.jpg",
      "../upload_images/Artnova/Sofas/CLOUD Limited Edition/3.jpg",
      "../upload_images/Artnova/Sofas/CLOUD Limited Edition/4.jpg",
      "../upload_images/Artnova/Sofas/CLOUD Limited Edition/5.jpg"
    ],
    "description": "החוזק העוטף של הגב תורם עצמו למשחק של שילובי חומרים. CLOUD LE הוא מהדורה מוגבלת שמבדלת את עצמה בזכות השילוב של חומרים שונים במבנה הספה.\n\nבדים, רקמות, עור או קטיפה יכולים להשתלב ליצירת משחק של צבעים או דוגמאות בתוך הגב. כל פרויקט של ספה וסלון יכול להיות מותאם אישית על ידי תיאום חומרים ומרקמים, ליצירת תמונה מתוחכמת וייחודית.\n\nרקמות משוכללות על שניל מעוררות צורות אייקוניות בעיצוב של Art Nova. CLOUD LE מכוסה בבדים חדשים רקומים הדגשים את האלגנטיות והיוקרה של הפרויקט.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 29997,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "CLOUD": {
    "image_url": "../upload_images/Artnova/Sofas/CLOUD/main.jpg",
    "product_url": "https://www.artnova.website/en/art/225/cloud.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/CLOUD/main.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/1.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/2.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/3.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/4.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/5.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/6.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/7.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/8.jpg",
      "../upload_images/Artnova/Sofas/CLOUD/9.jpg"
    ],
    "description": "מהות האלגנטיות. ספת קלאוד מייצגת עיצוב עכשווי של טוהר, המביא נגיעה מהעבר. צורות חדשות לחלוטין, המשתחקות בין משענות הגב והמושבים, יוצרות סביבה מעודנת ומסוגננת.\n\nמשענות גב ארגונומיות הניתנות להתאמה חדשנית עוקבות אחר הקווים הטבעיים של הגוף ומספקות את האירוח האולטימטיבי לראשכם. שולחנות צד ואביזרים משפרים את התכונות והנוחות. החומרים הטובים ביותר, תוצרת מחקר איטלקי, יוצרים את הריפוד של CLOUD: ספה שתופסת אותך מיד.\n\nמערכת הישיבה CLOUD משלבת שני נשמות: הקווים המסורתיים והמרגיעים והמזמינים והנקיים, וזו החדשנית והטכנולוגית של מבנה האלומיניום והעץ המאפשר ליצור מערכת בסיסים ומשענות מודולרית.\n\nמשענות הגב והידיים מתכופפות ומחבקות את הבסיסים במשחק חדשני והרמוני של קווים מעוגלים. שילובים של עקומות גבוהות ונמוכות מבחינים בין אלמנטים של ספה זו. כל הרכב והרכב הוא ייחודי ובולט בזכות קו המתאר המקורי שלו.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 25017,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "COSY": {
    "image_url": "../upload_images/Artnova/Sofas/COSY/main.jpg",
    "product_url": "https://www.artnova.website/en/art/295/cosy.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/COSY/main.jpg",
      "../upload_images/Artnova/Sofas/COSY/1.jpg",
      "../upload_images/Artnova/Sofas/COSY/2.jpg",
      "../upload_images/Artnova/Sofas/COSY/3.jpg",
      "../upload_images/Artnova/Sofas/COSY/4.jpg",
      "../upload_images/Artnova/Sofas/COSY/5.jpg",
      "../upload_images/Artnova/Sofas/COSY/6.jpg",
      "../upload_images/Artnova/Sofas/COSY/7.jpg",
      "../upload_images/Artnova/Sofas/COSY/8.jpg",
      "../upload_images/Artnova/Sofas/COSY/9.jpg",
      "../upload_images/Artnova/Sofas/COSY/10.jpg",
      "../upload_images/Artnova/Sofas/COSY/11.jpg",
      "../upload_images/Artnova/Sofas/COSY/12.jpg",
      "../upload_images/Artnova/Sofas/COSY/13.jpg"
    ],
    "description": "מערכת הספות Cosy היא עיצוב עכשווי וחדשני של הצעות קלאסיות וקווים וינטג'. העיצוב המיומן של הקימורים והריפוד יוצר משחק מקורי ומהפנט של נפחים. האסתטיקה מדברת על רכות, אירוח, מסורת וחדשנות.\n\nמשענות הגב והידיים מתעקלות ברכות ועשירות בהשבחות תפירה. קפלים וסידור אורך מקורי מבליטים את העקמומיות, מעניקים למוצר מראה ייחודי ואייקוני. \n\nהמושבים היחידה, ארוכים ומורחקים מהקרקע, משלבים בקלות בין קלילות ויציבות. כריות רכות מסוג Hi-tex משלימות סוג של נוחות שזוכה מיד לאהדת המשתמש.\n\nהאסתטיקה האלגנטית והנעימה מאופיינת בנפחים רכים ונדיבים, מועצמים על ידי תפירת קצה ייחודית שמדגישה ומשפרת צורות. שילובי הבדים והעור מתארים ניחוח מתוחכם וייחודי.\n\nCosy היא מערכת של אלמנטים מודולריים שבזכות 5 בסיסים, 2 משענות גב ו-1 משענת יד מאפשרת אינספור גרסאות של ספות וקונפיגורציות. עיצובים סגורים או פתוחים ניתנים לשינוי והפיכת כיוונים לפי הרוח לאורך זמן. המושבים מצוידים במערכת מסילה מקורית שמאפשרת חיבור של משענות ידיים וגב בכל נקודה של הבסיס.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 27680,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "FILIPH": {
    "image_url": "../upload_images/Artnova/Sofas/FILIPH/main.jpg",
    "product_url": "https://www.artnova.website/en/art/201/filiph.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/FILIPH/main.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/1.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/2.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/3.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/4.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/5.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/6.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/7.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/8.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/9.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/10.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/11.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/12.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/13.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/14.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/15.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/16.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/17.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/18.jpg",
      "../upload_images/Artnova/Sofas/FILIPH/19.jpg"
    ],
    "description": "משנה את הדרך לחוות את הספה שלך, עם חומרים חדשניים שמיד תופסים את תשומת הלב שלך. היא מתאפיינת בהיעדר חלוקה נוקשה בין ימין ושמאל, קדימה ואחורה. סידור משענות הגב הניתנות להזזה חופשי לחלוטין ומבטיח את מירב הנוחות במרחב המחיה שלך.\n\nFILIPH מאפשר לנו לפנק את הצרכים והרצונות שלנו בכל הנוגע לפונקציונליות ותנועה. משענות הגב יכולות להיות ממוקמות בתצורות שונות, מכורסה קטנה ועד מאריכה, מבישיבה רשמית ועד נינוחה, מהופכות לשיחות פנים אל פנים או להפוך לשזלונג, ולבסוף למיטה גדולה ויציבה.\n\nמצולעים בלתי סדירים וסימטריים משתלבים זה עם זה להגדיר חלל דינמי ופונקציונלי. הצורה המחומשת נבדקה להשתלב באופן מושלם עם ספות בעומק של 110 או 125 ס\"מ. היא רב-תכליתית וניתנת למיקום ימינה או שמאלה לפי רצונך.\n\nשילוב בלתי צפוי של עור ובד מחזק את הסגנון המעודן אך הנעים של הספה. אלמנטים ניידים וכריות בעלי גמישות טבעית לערבב מרקמים וחומרים שונים, ויוצרים זר ריחות חושים מתוחכם.\n\nהעיצוב הפיסולי של FILIPH מתאפיין באלגנטיות פרשנית, בזכות השילוב של הצורות הרכות והזורמות עם הקווים המחמירים. הבסיס הזוויתי, בזווית של 45°, מעניק תחושת קלילות מופלאה.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 11680,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "FILIPH AIR": {
    "image_url": "../upload_images/Artnova/Sofas/FILIPH AIR/main.jpg",
    "product_url": "https://www.artnova.website/en/art/286/filiph-air.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/FILIPH AIR/main.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/1.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/2.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/3.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/4.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/5.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/6.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/7.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/8.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/9.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/10.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/11.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/12.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/13.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/14.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/15.jpg",
      "../upload_images/Artnova/Sofas/FILIPH AIR/16.jpg"
    ],
    "description": "התפתחות מערכת FILIPH מפרשת טעמים אסתטיים שונים, המתעשרים בגרסה חדשה המאופיינת בקלות נשגבת ובאיזון פורמלי. הגב ת ניתנות להזזה נוחה לאורך האי הגדול שנראה תלוי ומסוגל להתאים את עצמו לחללים פנימיים ולדרישות נוחות אישיות, מכורסה קומפקטית לשזלונג דו-פנים.\n\nהמושבים המרחבים המוצעים במגוון עומקים נראים תלויים ומאווררים, בזכות בסיס ההחלקה המקורי שתוכנן להשתלב ולהישאר מוסתר מרוב הזוויות. חומרי ישיבה חדשנ יים (MEMOSOFF) משלימים את מראה הבסיס, מעניקים רכות, נוחות וסדר.\n\nצורות טרפזיות חדשות של הבסיסים מונחות זו לצד זו ויוצרות חללים דינאמיים ופונקציונליים. הבסיסים סימטריים, הפיכים וניתנים גם לשילוב עם אלמנטים לינאריים. משענת גב חדשה ניתנת להזזה ולקיפול ויכולה להכיל שני אנשים, ויוצרת משחק נחמד של נפחים יחד עם הבסיסים.\n\nשולחנות הלומינוס פיליפ מציירים את הבדים, מעצימים צבעים ומרקמים. מערכת לד נסתרת יוצרת אווירות חדשות ולא צפו יות של סצינות תאורה.\n",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 25579,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "FILIPH OUTDOOR": {
    "image_url": "../upload_images/Artnova/Sofas/FILIPH OUTDOOR/main.jpg",
    "product_url": "https://www.artnova.website/en/art/288/filiph-outdoor.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/FILIPH OUTDOOR/main.jpg",
      "../upload_images/Artnova/Sofas/FILIPH OUTDOOR/1.jpg",
      "../upload_images/Artnova/Sofas/FILIPH OUTDOOR/2.jpg",
      "../upload_images/Artnova/Sofas/FILIPH OUTDOOR/3.jpg",
      "../upload_images/Artnova/Sofas/FILIPH OUTDOOR/4.jpg"
    ],
    "description": "מעוצב ונבנה עם החומרים החדשניים ביותר המתאימים לשימוש באוויר הפתוח: FILIPH OUTDOOR הוא פתרון מבריק לפטיו גדול, מרפסת קטנה, להגדרות אינטימיות ליד הבריכה, או פשוט על מרפסת של וילה המשקיפה אל הים.\nהצורות הרכות והפיסוליות שלו והשימוש הגמיש מדגישים את איכות הספה, ומאפשרים לך ליהנות ממנה בכל פעם, בין אם באוויר הפתוח ובין אם בתוך הבית.\nאוסף של בדים ייחודיים לשימוש חוץ משלים את המאפיינים נגד תנאי מזג אוויר שונים.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 11381,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "GLAM": {
    "image_url": "../upload_images/Artnova/Coffee and side tables/GLAM/main.jpg",
    "product_url": "https://www.artnova.website/en/art/313/glam.html",
    "image_urls": [
      "../upload_images/Artnova/Coffee and side tables/GLAM/main.jpg",
      "../upload_images/Artnova/Coffee and side tables/GLAM/1.jpg",
      "../upload_images/Artnova/Coffee and side tables/GLAM/2.jpg",
      "../upload_images/Artnova/Coffee and side tables/GLAM/3.jpg",
      "../upload_images/Artnova/Coffee and side tables/GLAM/4.jpg",
      "../upload_images/Artnova/Coffee and side tables/GLAM/5.jpg",
      "../upload_images/Artnova/Coffee and side tables/GLAM/6.jpg",
      "../upload_images/Artnova/Coffee and side tables/GLAM/7.jpg"
    ],
    "description": "אלמנטים חומריים עם צורות חיוניות ממוקמות ומקצועיות בתבונה, יוצרים פריטים יקרים ומעודנים. טוהרן של הקווים ואיכות החומר מעשירים אוסף של שולחנות על-זמניים.",
    "company_name": "Artnova",
    "original_category": "Coffee and side tables",
    "price": 19179,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "OLTRE": {
    "image_url": "../upload_images/Artnova/Sofas/OLTRE/main.jpg",
    "product_url": "https://www.artnova.website/en/art/202/oltre.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/OLTRE/main.jpg",
      "../upload_images/Artnova/Sofas/OLTRE/1.jpg",
      "../upload_images/Artnova/Sofas/OLTRE/2.jpg",
      "../upload_images/Artnova/Sofas/OLTRE/3.jpg",
      "../upload_images/Artnova/Sofas/OLTRE/4.jpg",
      "../upload_images/Artnova/Sofas/OLTRE/5.jpg",
      "../upload_images/Artnova/Sofas/OLTRE/6.jpg"
    ],
    "description": "צורות רכות ופיסוליות, לצד פרטים מותאמים אישית בגוון מעודן, מתארים את הספה הייחודית והמעוצבת באלגנטיות הזו. השוליים משרטטים את המבנה ומדגישים את הפרופיל, נותנים ממד קפדני לקווים המעוקלים שלה. תכונות טבעיות וזורמות של נוצות פלומתיות מעניקות רכות ונוחות אולטימטיביות. בסיס המבנה דוהה אל הקרקע, ויוצר רושם של נפח \"אווירי\".\n\nבגרסת העור הסצנוגרפית שלו, OLTRE מציג ריפוד ייחודי עם תפרים חדים, המדגישים את הטבע המופלא של העור. המשטחים הרחבים של המבנה מאפשרים לך להעריך את המקורות והעבודות של החומרים היקרים.\n\nOLTRE מזכיר סילואטות וגימורים קלאסיים, אך מבלבל בעיצוב חדש ואותנטי. פרטים מעודנים, בדים חלקים וכריות גלי יוצרים ניגוד תחושתי בלתי צפוי.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 23039,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "SHABBY": {
    "image_url": "../upload_images/Artnova/Sofas/SHABBY/main.jpg",
    "product_url": "https://www.artnova.website/en/art/210/shabby.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/SHABBY/main.jpg",
      "../upload_images/Artnova/Sofas/SHABBY/1.jpg",
      "../upload_images/Artnova/Sofas/SHABBY/2.jpg",
      "../upload_images/Artnova/Sofas/SHABBY/3.jpg",
      "../upload_images/Artnova/Sofas/SHABBY/4.jpg"
    ],
    "description": "נוצות ופשתן מדגימות רכות אלגנטית: SHABBY הוא מוצר מבוצע בלעדית. מאופיין בניגוד חד בין קוויו החושניים וכריותיו הרכות. נוכחות של תפרים מותאמים במיוחד מגדירה נפחים נוחים של ריפוד רך. הכריות, בזמן שהן ממוקמות באופן חופשי, משתלבות עם צורות, אריגים וצבעים זורמים, ומדגישות את טבעה הנוח של הנוצה. ספות והרכבים בהתאמה אישית מוקדשים לאלו שאוהבים ומעריכים שילובי טקסטיל בלתי צפויים.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 26694,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "SQUARE LINE": {
    "image_url": "../upload_images/Artnova/Sofas/SQUARE LINE/main.jpg",
    "product_url": "https://www.artnova.website/en/art/203/square-line.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/SQUARE LINE/main.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/1.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/2.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/3.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/4.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/5.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/6.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/7.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/8.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/9.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/10.jpg",
      "../upload_images/Artnova/Sofas/SQUARE LINE/11.jpg"
    ],
    "description": "מוקפד, אך בו זמנית רך בצורה מהנה, SQUARE LINE מגדיר אלגנטיות טהורה. הכריות במידות ובצפיפויות שונות, מקיפות את משענת הגב, מבלי לחסום את העיצוב הקווי העדין. שילובי כריות שונים מאפשרים תצורות מסורתיות או קומפוזיציות טקסטיל רכות ומתוחכמות.\n\nהגרסה הבלעדית של SQUARE LINE STEEL מציגה גימור יקר בזכות הבסיס המתכתי המעוצב בצורה מעולה. אביזרים מעור ובדים ייחודיים משתלבים עם הבסיס המתכתי, ויוצרים דימוי ייחודי ומעודן של ספה.\n\nSQUARE LINE מתאים בצורה מושלמת לגוף הודות לגובה ולעומק הניתנים להתאמה אישית, יחד עם צפיפויות שונות של חומרים ריפוד מודרניים ומסורתיים. שתי עומקים ושני גבהים, שלושה חומרים ריפוד שונים לכריות המושב ושתי כריות משענת שונות, תורמים ליצירת 24 שילובי נוחות שונים: התאמה אישית מוחלטת של מראה ופונקציה.\n\nהמסורת והטכנולוגיה מדגישות מראה מעוצב במדויק ונוחות בלתי צפויה. נוצות ושערות משלימות את הריפוד החדשני בקצף זיכרון, פולילטקס ומיקרופייבר Hi-tex. בדים מסורתיים או וינטג', עורות יקרים, אביזרים ידידותיים לסביבה ומתכת, קטיפה ופשתן: יוצרים תערובת של טקסטורות עכשוויות ובלעדיות.\n\nמוקף בכריות חופשיות במידות שונות, SQUARE LINE מתאפיין בניגוד בולט בין קווים ישרים לרכות. הכריות מקיפות את הגב ותומכות בראש, שומרות על אסתטיקה קלה: השען את גופך על ידי קיפולו לתוך הריפוד הנוצתי הבלתי מוחש.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 27544,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "WILL": {
    "image_url": "../upload_images/Artnova/Sofas/WILL/main.jpg",
    "product_url": "https://www.artnova.website/en/art/208/will.html",
    "image_urls": [
      "../upload_images/Artnova/Sofas/WILL/main.jpg",
      "../upload_images/Artnova/Sofas/WILL/1.jpg",
      "../upload_images/Artnova/Sofas/WILL/2.jpg",
      "../upload_images/Artnova/Sofas/WILL/3.jpg",
      "../upload_images/Artnova/Sofas/WILL/4.jpg",
      "../upload_images/Artnova/Sofas/WILL/5.jpg",
      "../upload_images/Artnova/Sofas/WILL/6.jpg",
      "../upload_images/Artnova/Sofas/WILL/7.jpg"
    ],
    "description": "הקונסטרוקציה הקלה וכריות הישיבה הארוכות מציגות דימוי \"אוורירי\" של ספה. תיפורי הבד עוברים דרך הצורות הרכות של הקונסטרוקציה והכריות, ומדגישים את הקווים המודרניים של WILL. משענת היד ומשענת הגב מתחברות לקונסטרוקציה, ויוצרות משחק עדין של נפחים מצטלבים.",
    "company_name": "Artnova",
    "original_category": "Sofas",
    "price": 10365,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "INDY TAILOR": {
    "image_url": "../upload_images/Artnova/Beds/INDY TAILOR/main.jpg",
    "product_url": "https://www.artnova.website/en/art/293/indy-tailor.html",
    "image_urls": [
      "../upload_images/Artnova/Beds/INDY TAILOR/main.jpg",
      "../upload_images/Artnova/Beds/INDY TAILOR/1.jpg",
      "../upload_images/Artnova/Beds/INDY TAILOR/2.jpg",
      "../upload_images/Artnova/Beds/INDY TAILOR/3.jpg",
      "../upload_images/Artnova/Beds/INDY TAILOR/4.jpg",
      "../upload_images/Artnova/Beds/INDY TAILOR/5.jpg",
      "../upload_images/Artnova/Beds/INDY TAILOR/6.jpg",
      "../upload_images/Artnova/Beds/INDY TAILOR/7.jpg",
      "../upload_images/Artnova/Beds/INDY TAILOR/8.jpg"
    ],
    "description": "עידון מסגרות העץ המיוצרים במיומנות יוצר נפחים בד סצנוגרפיים אך לעולם לא מכבידים. ראש מיטה גדול עם \"כנפיים\" מחבק רגעי הרפיה, משולב עם בסיס טקסטיל רך ומעוצב.\n\nעץ ובד משולבים במומחיות במיטה זו עם כיסויים נשלפים.\n\nאביזרים וספסלים משלימים את הפרויקט ואת האלמנטים הדקורטיביים, כדי לרהט חלל פנים עכשווי.",
    "company_name": "Artnova",
    "original_category": "Beds",
    "price": 26940,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "INDY": {
    "image_url": "../upload_images/Artnova/Beds/INDY/main.jpg",
    "product_url": "https://www.artnova.website/en/art/281/indy.html",
    "image_urls": [
      "../upload_images/Artnova/Beds/INDY/main.jpg",
      "../upload_images/Artnova/Beds/INDY/1.jpg",
      "../upload_images/Artnova/Beds/INDY/2.jpg",
      "../upload_images/Artnova/Beds/INDY/3.jpg",
      "../upload_images/Artnova/Beds/INDY/4.jpg",
      "../upload_images/Artnova/Beds/INDY/5.jpg",
      "../upload_images/Artnova/Beds/INDY/6.jpg"
    ],
    "description": "מסגרות עץ מעודנות כולאות כרכים מרהיבים של טקסטיל. ראש מיטה גדול עם \"כנפיים\" שמחבקות רגעי מנוחה, נשען על בסיס תלוי כדי להבליט את הקלות של העיצוב. עץ ובד מוצאים את הסינרגיה שלהם במיטה עם כיסויים נשלפים.\n\nאינדי מורכב ממערכת של ראשי מיטה ובסיסים שעוצבו במיוחד, ומקלים על עיצוב פנים בכל סוגי החללים. ראשי מיטה רחבים או צרים, בסיסים מעץ ובד או מרופדים לחלוטין עם מיכל, משתלבים ליצירת הדגם האולטימטיבי של המיטה.",
    "company_name": "Artnova",
    "original_category": "Beds",
    "price": 15760,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "BOLD": {
    "image_url": "../upload_images/Artnova/Beds/BOLD/main.jpg",
    "product_url": "https://www.artnova.website/en/art/211/bold.html",
    "image_urls": [
      "../upload_images/Artnova/Beds/BOLD/main.jpg",
      "../upload_images/Artnova/Beds/BOLD/1.jpg",
      "../upload_images/Artnova/Beds/BOLD/2.jpg",
      "../upload_images/Artnova/Beds/BOLD/3.jpg",
      "../upload_images/Artnova/Beds/BOLD/4.jpg"
    ],
    "description": "\"בַּלָּטָה גְּדוֹלָה\" מתארת את ראש המיטה הרך והחובק, שתוכנן להניח את הראש בכל רגע. הבד הנופל, מועשר בתפרים ייחודיים המדגישים את האופי השלומפרי-שיקי. בסיס המיטה הוא גבוה, נוח ויכול להסתיר אחסון אופציונלי.",
    "company_name": "Artnova",
    "original_category": "Beds",
    "price": 27831,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "ISLAND BED": {
    "image_url": "../upload_images/Artnova/Beds/ISLAND BED/main.jpg",
    "product_url": "https://www.artnova.website/en/art/205/island-bed.html",
    "image_urls": [
      "../upload_images/Artnova/Beds/ISLAND BED/main.jpg",
      "../upload_images/Artnova/Beds/ISLAND BED/1.jpg",
      "../upload_images/Artnova/Beds/ISLAND BED/2.jpg",
      "../upload_images/Artnova/Beds/ISLAND BED/3.jpg",
      "../upload_images/Artnova/Beds/ISLAND BED/4.jpg",
      "../upload_images/Artnova/Beds/ISLAND BED/5.jpg"
    ],
    "description": "המיטה משנה את דמותה המסורתית והופכת לאי הכולל מזרן ואלמנטים פונקציונליים שניתנים להחלפה חופשית. מיטת האי מגדילה את מרחב המחייה מבלי להעמיס על החדר המסורתי.",
    "company_name": "Artnova",
    "original_category": "Beds",
    "price": 16011,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "HELEN": {
    "image_url": "../upload_images/Artnova/Armchairs/HELEN/main.jpg",
    "product_url": "https://www.artnova.website/en/art/321/helen.html",
    "image_urls": [
      "../upload_images/Artnova/Armchairs/HELEN/main.jpg",
      "../upload_images/Artnova/Armchairs/HELEN/1.jpg",
      "../upload_images/Artnova/Armchairs/HELEN/2.jpg",
      "../upload_images/Artnova/Armchairs/HELEN/3.jpg",
      "../upload_images/Artnova/Armchairs/HELEN/4.jpg",
      "../upload_images/Artnova/Armchairs/HELEN/5.jpg",
      "../upload_images/Artnova/Armchairs/HELEN/6.jpg",
      "../upload_images/Artnova/Armchairs/HELEN/7.jpg"
    ],
    "description": "משטחים מעוקלים ונפחים נוזליים משתלבים זה בזה, מתארים פרויקט של כורסאות ורסטיליות בעיצוב מעודן ועכשווי. העיצוב המיומן של הצורות מסתיר מושב נוח בממדים מאוד קומפקטיים ומאפשר לתכנן חללים אינטימיים וממוקדים, כמו גם להעשיר סביבות חשובות. הכורסה הלן מאופיינת במשענת גב מעוקלת שמתמשכת בעדינות והופכת לידיות נוחות. הקווים ההרמוניים והנפחים הרכים שמתארים את הכורסאות הלן משפרים את השילובים החומריים ואת הניסיון התחפושתי של ART NOVA.",
    "company_name": "Artnova",
    "original_category": "Armchairs",
    "price": 25918,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "CELINE": {
    "image_url": "../upload_images/Artnova/Armchairs/CELINE/main.jpg",
    "product_url": "https://www.artnova.website/en/art/300/celine.html",
    "image_urls": [
      "../upload_images/Artnova/Armchairs/CELINE/main.jpg",
      "../upload_images/Artnova/Armchairs/CELINE/1.jpg",
      "../upload_images/Artnova/Armchairs/CELINE/2.jpg",
      "../upload_images/Artnova/Armchairs/CELINE/3.jpg",
      "../upload_images/Artnova/Armchairs/CELINE/4.jpg",
      "../upload_images/Artnova/Armchairs/CELINE/5.jpg",
      "../upload_images/Artnova/Armchairs/CELINE/6.jpg",
      "../upload_images/Artnova/Armchairs/CELINE/7.jpg"
    ],
    "description": "סלין היא קולקציה של כיסאות צדפה אלגנטיים באופן בלעדי, המציעה תחושה מושלמת של נוחות והגנה.\n\nנפחים מזמינים, קלים ותיאטרליים הם התכונות המבחינות של המבנים המעודנים והיוקרתיים הללו.\n\nבסיס סיבוב מעץ מדגיש את האיכות והטכנולוגיה של העיצוב.",
    "company_name": "Artnova",
    "original_category": "Armchairs",
    "price": 20118,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "TULIP": {
    "image_url": "../upload_images/Artnova/Armchairs/TULIP/main.jpg",
    "product_url": "https://www.artnova.website/en/art/280/tulip.html",
    "image_urls": [
      "../upload_images/Artnova/Armchairs/TULIP/main.jpg",
      "../upload_images/Artnova/Armchairs/TULIP/1.jpg",
      "../upload_images/Artnova/Armchairs/TULIP/2.jpg",
      "../upload_images/Artnova/Armchairs/TULIP/3.jpg"
    ],
    "description": "טוליפ היא כורסה עם קונכייה אלגנטית במיוחד, המציעה תחושת נוחות והגנה מוחלטת. נפחים מזמינים, קלים וסצנתיים הם התכונות המאפיינות את המבנה המעודן והיוקרתי הזה. בסיס עץ מסתובב מדגיש את האיכות והטכנולוגיה של העיצוב.",
    "company_name": "Artnova",
    "original_category": "Armchairs",
    "price": 16773,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "LOVE CHAIR": {
    "image_url": "../upload_images/Artnova/Armchairs/LOVE CHAIR/main.jpg",
    "product_url": "https://www.artnova.website/en/art/209/love-chair.html",
    "image_urls": [
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/main.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/1.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/2.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/3.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/4.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/5.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/6.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/7.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/8.jpg",
      "../upload_images/Artnova/Armchairs/LOVE CHAIR/9.jpg"
    ],
    "description": "צורות חיוניות ומעודנות מציירות כורסה שמאפשרת ישיבה ליותר מאורח אחד. כריות רכות עוטפות את הגוף ומדגישות את המבנה המעוגל. כיסא האהבה זמין בשלושה קטרים שונים וגרסה ייעודית של הדום.",
    "company_name": "Artnova",
    "original_category": "Armchairs",
    "price": 21783,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "GENTLEMAN": {
    "image_url": "../upload_images/Artnova/Armchairs/GENTLEMAN/main.jpg",
    "product_url": "https://www.artnova.website/en/art/207/gentleman.html",
    "image_urls": [
      "../upload_images/Artnova/Armchairs/GENTLEMAN/main.jpg",
      "../upload_images/Artnova/Armchairs/GENTLEMAN/1.jpg",
      "../upload_images/Artnova/Armchairs/GENTLEMAN/2.jpg",
      "../upload_images/Artnova/Armchairs/GENTLEMAN/3.jpg",
      "../upload_images/Artnova/Armchairs/GENTLEMAN/4.jpg"
    ],
    "description": "כורסה בסגנון ברז'ר שמזכירה את הנוחות של העבר אך מציגה עיצוב חדש וקליל ובלעדי. קווים מעוגלים מזמינים לשבת ומגדירים חלל אינטימי ופרטי. המשענת הגבוהה וההדום הנוח מאפשרים רגיעה בכל מצב. הפרטים והגימורים מספרים על תפירה וחדשנות.",
    "company_name": "Artnova",
    "original_category": "Armchairs",
    "price": 18636,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "DYNAMIC+ new": {
    "image_url": "../upload_images/Artnova/Coffee and side tables/DYNAMIC+ new/main.jpg",
    "product_url": "https://www.artnova.website/en/art/358/dynamic-new.html",
    "image_urls": [
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC+ new/main.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC+ new/1.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC+ new/2.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC+ new/3.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC+ new/4.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC+ new/5.JPG",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC+ new/6.JPG"
    ],
    "description": "דינאמיק+ מייצגים את ההתפתחות של שולחנות ההרמה של Art Nova. המשטחים העליונים גדלים, והופכים לשולחנות עבודה אמיתיים עבור שפע הפעילויות שמתקיימות באזור המגורים. המנגנונים הייחודיים מוכפלים, כשהם מוסתרים בבסיס גדול יותר בקוטר.\n\nשולחנות הצד הניתנים להרים דינאמיק+ בגדלים חדשים וחשובים משלימים את סידור הפנים, וממלאים את הצרכים היומיומיים שלנו: משולחנות קפה טהורים ומעודנים ועד לשולחנות עבודה פרקטיים.",
    "company_name": "Artnova",
    "original_category": "Coffee and side tables",
    "price": 24311,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "BOBBIN new": {
    "image_url": "../upload_images/Artnova/Coffee and side tables/BOBBIN new/main.jpg",
    "product_url": "https://www.artnova.website/en/art/339/bobbin-new.html",
    "image_urls": [
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/main.jpg",
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/1.jpg",
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/2.jpg",
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/3.jpg",
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/4.jpg",
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/5.jpg",
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/6.jpg",
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/7.jpg",
      "../upload_images/Artnova/Coffee and side tables/BOBBIN new/8.jpg"
    ],
    "description": "בהשראת הקווים האיקוניים של פריטי לבוש היסטוריים ונוצרו מתבניות ייצור היסטוריות מוחזרות, שולחנות הצד והקפה BOBBIN הם פריטי ריהוט שמחבקים את הטעם ומשלימים את הצורות של קולקציית הספות Art Nova, והופכים לחלק אינטגרלי מהאסתטיקה והתפקודיות של מערכות הספות Curve ו-Kintai.",
    "company_name": "Artnova",
    "original_category": "Coffee and side tables",
    "price": 27911,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "FLARE TABLE COLLECTION": {
    "image_url": "../upload_images/Artnova/Coffee and side tables/FLARE TABLE COLLECTION/main.jpg",
    "product_url": "https://www.artnova.website/en/art/312/flare-table-collection.html",
    "image_urls": [
      "../upload_images/Artnova/Coffee and side tables/FLARE TABLE COLLECTION/main.jpg",
      "../upload_images/Artnova/Coffee and side tables/FLARE TABLE COLLECTION/1.jpg",
      "../upload_images/Artnova/Coffee and side tables/FLARE TABLE COLLECTION/2.jpg",
      "../upload_images/Artnova/Coffee and side tables/FLARE TABLE COLLECTION/3.jpg",
      "../upload_images/Artnova/Coffee and side tables/FLARE TABLE COLLECTION/4.jpg"
    ],
    "description": "אוסף של שולחנות מזדמנים בגבהים שונים ובמידות עליונים מגוונות המציעים עיצוב מקורי ומרתק, שנוצר כהסתכלות עכשווית על שולחנות צד צרפתיים קלאסיים מהמאה ה-17 בעלי שלוש רגליים. הרגליים הקלות, האלגנטיות והדינמיות מתקפלות ומתרחבות בעדינות ויכולות לתמוך במשטחים עגולים בקטרים של 52 ו-60 ס\"מ, בגבהים של 49 ו-61 ס\"מ מהרצפה, המיועדים לפונקציות שונות. בסיס האלומיניום המוצק זמין בשלושה גימורים שונים, יחד עם 9 סוגים שונים של חומרים לעליונים, מה שמאפשר שילובים מרהיבים.",
    "company_name": "Artnova",
    "original_category": "Coffee and side tables",
    "price": 17431,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "FILIPH TABLE COLLECTION": {
    "image_url": "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/main.jpg",
    "product_url": "https://www.artnova.website/en/art/316/filiph-table-collection.html",
    "image_urls": [
      "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/main.jpg",
      "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/1.jpg",
      "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/2.jpg",
      "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/3.jpg",
      "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/4.jpg",
      "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/5.jpg",
      "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/6.jpg",
      "../upload_images/Artnova/Coffee and side tables/FILIPH TABLE COLLECTION/7.jpg"
    ],
    "description": "אוסף של שולחנות ופופים עם אישיות חזקה משלים את טווח פיליפ עם פונקציונליות וסגנון, באמצעות שילוב של חומרים וקונפיגורציות שונות.\n\nגבהים, צורות וגדלים שונים של משטחים מכפילים את אפשרויות השימוש: בשילוב עם ספות או ליצירת משחקי הדגשה ומדרגות מקוריים.\n\nהמשטחים העשויים מעור טבעי או צבועים בגוונים הבלעדיים הבאים: גרפיט, כסף, לונדון, אוטניו, טופ, ופאנגו.\n\nקונסולת האוכל של פיליפ היא אובייקט שנועד לספק את ההרגלים החדשים של חיים באזור המגורים ובספה. בשילוב עם מערכת גביים ניידת, הוא מתאים לשולחן אוכל, שולחן עבודה או פשוט שולחן קפה ארגונומי להפסקות עם חברים.",
    "company_name": "Artnova",
    "original_category": "Coffee and side tables",
    "price": 10424,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "DYNAMIC": {
    "image_url": "../upload_images/Artnova/Coffee and side tables/DYNAMIC/main.jpg",
    "product_url": "https://www.artnova.website/en/art/320/dynamic.html",
    "image_urls": [
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/main.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/1.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/2.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/3.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/4.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/5.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/6.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/7.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/8.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/9.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/10.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/11.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/12.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/13.jpg",
      "../upload_images/Artnova/Coffee and side tables/DYNAMIC/14.jpg"
    ],
    "description": "חלק עליון רב-גוני, חופשי לזוז בהתאם לשימושים ולתפקודים שמשתנים עם הזמן ועוקבים אחרי רצונות: Dynamic הוא שיאה של פרויקט שחוקר סגנונות חיים חדשים במרחב הפנים. הרבה יותר משולחן פשוט.\n\nהאזור המגורים משנה תרחישים ותפקודי שימוש פשוט על ידי שינוי מיקום וגובה של אלמנטים הריהוט. על ידי מנגנון מתוחכם אך אינטואיטיבי, שולחנות Dynamic מאפשרים להתאים את גובה החלק העליון בהתאם לשימוש: משולחן קפה, שולחן אוכל ועד לשולחן צדדי, שולחן עבודה או משטח עבודה. ניידות משענות הגב גם מאפשרת ליצור ישיבה נוחה המותאמת לכל שינוי בתפקוד.\n\nהשימוש הרב-גוני מובטח על ידי מנגנון בלעדי, שפותח על ידי ARTNOVA, המאפשר להפוך את משטח המנחה השטוח מגובה של 38 ס\"מ ל-72 ס\"מ, בתנועה חלקה, הניתנת להתאמה בכל מצב.",
    "company_name": "Artnova",
    "original_category": "Coffee and side tables",
    "price": 10450,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Belts": {
    "description": "עוצבה על ידי מתאו צורזנוני עבור Carpanese Home, Belts היא ספסל למרגלות המיטה עם פרופיל רך ומכוון, שמבנהו מעץ מלא, מאופיין בפינות מעוגלות, מכיל כרית רכה המחוברת באמצעות שני רצועות עור שמדגישות את הניקיון הפורמלי ומקנות לו את שמו.\nורסטילית ופונקציונלית, Belts מתאימה למגוון רחב של סביבות וסגנונות הודות למגוון הרחב של אפשרויות ההתאמה האישית הזמינות, מגימורי העץ ועד לאינספור המרקמים והצבעים של הבדים בקטלוג. Belts מיוצרת בשתי מידות, סטנדרט ו-XL, עם או בלי כריות רולר.\nספסל מרופד מעץ מלא אפר, ברצועות עור. התחתית עשויה עץ פורניר אפר, תת-התחתית עשויה עץ לבוד צפצפה, והמושב עשוי פוליאוריתן מוקצף עם ציפוי עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Belts/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/belts/40",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 26973,
    "filter_category": "-",
    "placement": "-"
  },
  "Belts XL": {
    "description": "עוצבה על ידי מתאו זורזנוני עבור Carpanese Home, Belts XL היא ספסל מיטה עם פרופיל רך ועגול. המבנה שלה מעץ מלא, המאפיין פינות מעוגלות, מכיל כרית רכה שמחוברת באמצעות שתי רצועות עור המדגישות את הניקיון הפורמלי שלה ומכאן נובע שמה.\nרב שימושית ופונקציונלית, Belts XL מתאימה לסביבות שונות ולסגנונות שונים בזכות מגוון רחב של אפשרויות התאמה אישית, מגימורי העץ ועד למרקמים ולצבעים הרבים של הבדים שבקטלוג. Belts XL זמינה עם או בלי כריות גליל, בעוד שהגרסה הסטנדרטית, עם מידות קטנות יותר, מסופקת ללא כריות.\nספסל מרופד מעץ מלא של עץ מילה, רצועות עור. תחתית מלוח עץ מילה עם ציפוי פורניר, תחתית מלוח דיקט של צפצפה, מושב מפוליאוריתן מוקצף עם כיסוי עור או בד. כריות גליל אופציונליות.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/7.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Belts XL/8.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/belts-xl/38",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 28039,
    "filter_category": "-",
    "placement": "-"
  },
  "Betty": {
    "description": "תוכנן על ידי ג'ורג'יו בונאגורו עבור Carpanese Home, בטי היא כורסה מרופדת בעלת צורות נדיבות שמאפיינה העיקרי טמון במשען הגב המקיף המשתלב בשני משעני יד נוחים. העגוליות של הצורות, המודגשת על ידי בסיס מעוקל מעץ וקיימת גם בעות'מאן התואם, מעניקה לסט תחושת נוחות, אלגנטיות ורוגע. השם — בהשראת בטי קטרו, דמות משמעותית עבור מעצב-העל איב סן לורן — מרמז על אידיאל של אלגנטיות בלתי-מכוונת, נצחית, מעבר לאופנות.\nכורסה ועות'מאן מעץ רב-שכבתי מוסמך EPA, אשוח, פייברבורד דחוס. מרופדים בפוליאוריתן עם תאים פתוחים ושכבות דאקרון, קפיצים מרצועות אלסטיות. מעוקלים בשכבות עץ צפצפה ושבבי עץ מעובדים מצופים באש. ריפוד מעור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Betty/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Betty/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Betty/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Betty/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Betty/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Betty/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/betty/49",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 23435,
    "filter_category": "-",
    "placement": "-"
  },
  "Bridge": {
    "description": "עוצבה על ידי מתיאו זורזנוני עבור קרפנזה הום, כורסא בְּרִידְז' משלבת עור מעובד בעבודת יד עם מבנה צינורי מעץ, ויוצרת — יחד עם הכריות מבד רך של המושב והמשענת — איזון מושלם בין חומרים ומרקמים. צורה, פונקציה ונוחות מתאחדים במבנה עוטף שמסוגל להקרין אלגנטיות נינוחה המתאימה בקלות לסגנונות ולסביבות מגוונות.\nכורסא עם רצועות עור. מבנה מבוק עמיד, קרקעית שכבות של צפצפה, ידיות וקרקעית מושב מצופות עור. מרופדת בקצף מעוצב ונוצות אווז לבן. ריפוד עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bridge/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bridge/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bridge/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bridge/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bridge/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bridge/51",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 18375,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble 2P regular-light": {
    "description": "מעוצב על ידי מתאו זורזנוני עבור Carpanese Home, Bubble היא קבוצת מושבים עם קווים רכים ומעוגלים השראה מהאסתטיקה הנוחה של שנות השבעים. בנויה סביב נפח מרופד ואפשרי למודולציה יחידה, Bubble מאפשרת קונפיגורציות רבות כמענה לתכונות ולצרכים של סביבות עכשוויות. מושבים עם או בלי משענת יד ובעומקים שונים, פופים לשימוש כאלמנטים בודדים או כחיבורים לספות פינתיות, כיסאות נוח או כורסאות נוחות עם גב כפול. טווח רחב ורב-תכליתי של אלמנטים לפתרונות גמישים, הניתנים לשינויים לפי הזמן והמקום, זמינים בשתי גרסאות, עם בסיס מבני מעץ מכופף הנראה יותר במדגישה על ידי השילוב עם בדים, או ללא בסיס למראה קל יותר שטוב גם לשימוש חיצוני.\nBubble לשני אנשים היא ספה במידות קטנות הרכבת מ שני אלמנטים מרופדים עם משענת יד, נוכחותה הבולטת מובלטת בצורות מנעות ופרופורציות מתוכננות בפירוט מושלם.\nספת 2 מקומות מרופדת עם או בלי גב מעוגל ובסיס מעץ. מבנה מרובד רב-שכבתי מוסמך EPA, אשוח, לוח קשה. מרופדת בפוליאוריתן תאים פתוחים ודקרון, עם רצועות קפיצים אלסטיים. מעוקל בשכבות של אשור מצופים באפר. רגליים מעץ צבוע שחור. עולה בעור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/7.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/8.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 2P regular-light/9.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-2p/42",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 23628,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble 3P regular-light": {
    "description": "מעוצב על ידי מתאו זורזנוני עבור קרפנזה הום, Bubble היא משפחה של מושבים בקווים רכים ומעוגלים בהשראת האסתטיקה הנוחה של שנות השבעים. בנויה סביב נפח מרופד יחיד מודולרי, Bubble מאפשרת תצורות רבות ומגוונות בתגובה לדרישות ולמאפיינים של הסביבות המודרניות. מושבים עם או בלי ידית ובעומקים שונים, פופים לשימוש כאלמנטים בודדים או כמחברי ספות בזווית, צ'ייס לונג או כורסאות נוחות עם משענת כפולה. מגוון רחב ורב-תכליתי של אלמנטים לפתרונות גמישים, ניתנים להתאמה מחדש במשך הזמן ובמרחב, זמינים בשתי גרסאות, עם בסיס מבני בעץ מכופף הנראה באופן בולט יותר בזכות השילוב עם בדי הריפוד, או ללא בסיס לקו קליל יותר המושלם גם לשימוש חיצוני.\nBubble בת שלושה מושבים היא ספה המורכבת משלושה אלמנטים מרופדים עם ידיות צד, נוכחותה הבולטת מוצגת באמצעות הצורות המזמינות והפרופורציות המדויקות עד לפרטים הקטנים ביותר.\nספת שלושה מושבים מרופדת עם או בלי קימורים ובסיס עץ. מבנה מלוחות רב-שכבתיים מוסמכים על ידי EPA, אשוח, פאזייט. מרופד בפוליאוריתן תאי פתוח ובשכבות דאקרון, קפיצים עם רצועות אלסטיות. קימורים משכבות עץ אשור מולחם באש. רגליים מעץ צבוע שחור. ריפוד מעור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/7.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble 3P regular-light/8.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-3p/41",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 21437,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble C regular-light": {
    "description": "עוצב על ידי מתיאו זורזנוני עבור Carpanese Home, Bubble היא משפחה של מושבים עם קווים רכים ומעוגלים בהשראת האסתטיקה הנוחה של שנות השבעים. בנויה סביב נפח מרופד יחיד הניתן להתאמה, Bubble מאפשרת תצורות רבות בתגובה למאפיינים ולצרכים של סביבות עכשוויות. מושבים עם או בלי משענות יד ובעלי עומקים שונים, פופים לשימוש כאלמנטים יחידים או כחלק מספות פינתיות, שזלונגים או כורסאות נוחות עם משענת כפולה. מגוון רחב ורב-צורות של אלמנטים לפתרונות גמישים, הניתנים להתאמה מחדש עם הזמן ובמרחב, זמינה בשתי גרסאות, עם בסיס מבני מעץ מכופף המודגש בשילוב עם בדי הריפוד, או ללא בסיס למראה קל יותר המתאים גם לחוץ.\n\nBubble C היא כורסה בממדים נדיבים, קצת מושב קצת שזלונג, עם נוכחות בלתי רגילה של שתי משענות. פרט שמדגיש את הגמישות והתחושה של קבלת פנים. פיסולית כשהיא לבדה, פונקציונלית כאשר משולבת עם מודולים נוספים של מערכת Bubble.\n\nמודול פינת ספה מרופדת עם משענת כפולה, עם או בלי קימורים ובסיס עץ. \nמבנה מלוח שכבות מוסמך EPA, אשוח, פאיסייט. מרופד בפוליאוריתן בעל תאים פתוחים ושכבות של דקרון, קפיצים ברצועות אלסטיות. קימורים בשכבות של עץ אשור מכוסה באש. רגליים מעץ צבוע שחור. ריפוד בעור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble C regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble C regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble C regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble C regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble C regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble C regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble C regular-light/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble C regular-light/7.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-c/47",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 16217,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble DX regular-light": {
    "description": "עוצב על ידי מתיאו זורזנוני עבור Carpanese Home, Bubble היא משפחת מושבים בעלי קווים רכים ועגולים המושפעים מהאסתטיקה הנוחה של שנות השבעים. בנויה סביב נפח יחיד מרופד הניתן להתאמה, Bubble מאפשרת מגוון רחב של תצורות המתאימות לתכונות ולצרכים של סביבות מודרניות. מושבים עם או בלי משענת יד ובעומקים שונים, פופים לשימוש כיחידות בודדות או כמחברים לספות פינתיות, כיסאות שזלונג או כורסאות נוחות עם משענת כפולה. קו רחב ורב-גווני של פריטים לפתרונות גמישים, שניתן לשנותם לאורך זמן ובמרחב, זמין בשתי גרסאות: עם בסיס מבני מעץ מכופף המודגש על ידי השילוב עם בדים מכסים, או ללא בסיס ליצירת קו קל יותר, אידיאלי גם לשימוש חיצוני.\n\nBubble DX היא כורסה בממדים מצומצמים המאפיינת בנוכחות משענת יד בודדת בצידה הימני. פיסולית בפני עצמה, פונקציונלית כאשר היא משולבת עם מודולים אחרים של מערכת Bubble.\n\nכורסה בודדת / מודול ספה מרופד עם משענת יד ימנית, עם או בלי מעקלים ובסיס עץ. מבנה מרבדים מעובדי EPA, אשוח, פייזייט. מרופד בפוליאוריתן תאי פתוח ושכבות דאקרון, קפיצים עם חגורות אלסטיות. מעוקלים משכבות של אדר מפוחמות ומכוסות באשכרון. רגליים מעץ צבוע שחור. מַרְאֶה עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble DX regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble DX regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble DX regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble DX regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble DX regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble DX regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble DX regular-light/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-dx/46",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 27284,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble P regular-light": {
    "description": "עוצב על ידי מתאו זורזנוני עבור חברת Carpanese Home, Bubble היא משפחה של מושבים בקוים רכים ועגולים המושפעים מהאסתטיקה הנוחה של שנות השבעים. בנויה סביב נפח מרופד יחיד הניתן להתאמה, Bubble מאפשרת תצורות רבות ומגוונות המתאימות למאפיינים ולצרכים של חללים עכשוויים. מושבים עם או בלי ידיות ובעומקים שונים, פופים לשימוש כאלמנטים בודדים או כחלק מספות פינתיות, כורסאות מרווחות עם משענת כפולה. טווח רחב ורב-תכליתי של אלמנטים לפתרונות גמישים הניתנים לשינוי במרחב ובזמן, זמין בשתי גרסאות: עם בסיס מבני מעץ מכופף המובלט בשילוב עם בדים לריפוד, או ללא בסיס עבור קו קליל המתאים גם לחוץ. \n\nBubble P היא כורסה במידות נוחות עם משענת רכה וידית כפולה. פיסולית בנפרד, פונקציונלית כאשר מחוברת למודולים אחרים של מערכת Bubble. כורסה מרופדת עם ידיות, עם או בלי קימורים ובסיס עץ. מבנה מעץ רב שכבתי מאושר EPA, אשוח, פייסיט. מרופדת עם פוליאוריתן תאי פתוח ושכבות דקרון, קפיצי רצועות אלסטיות. מכופפים בשכבות של עץ אשור מרופד בעץ אפר. רגליים מעץ צבוע שחור. ריפוד עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble P regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble P regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble P regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble P regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble P regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble P regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble P regular-light/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble P regular-light/7.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-p/43",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 23048,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble Pouff regular-light": {
    "description": "עוצב על ידי מתאו זורזנוני עבור Carpanese Home, Bubble היא משפחת מושבים עם קווים רכים ומעוגלים בהשראת האסתטיקה הנוחה של שנות השבעים. בנויה סביב נפח מרופד מודולרי יחיד, Bubble מאפשרת קונפיגורציות מרובות כתגובה לתכונות ולצרכים של חללים עכשוויים. מושבים עם או בלי משענת יד ועמוקים שונים, פופים לשימוש כאלמנטים יחידים או כחיבור לספות פינתיות,  chaise longue או כורסאות נוחות עם משענת כפולה. מגוון רחב ודינמי של אלמנטים עבור פתרונות גמישים הניתנים לשירוג לזמן ולמקום, זמינה בשתי גרסאות: עם בסיס מעץ כפוף המודגש בשילוב עם בדי הריפוד, או ללא בסיס לקו קליל יותר המושלם גם לחוץ.\n\nBubble Pouf הוא האימרה הפאס-פרטוט של משפחת הרהיטים המרופדים בעלי אותו שם. הצורה המעוגלת אך המהותית של הפוף הזה הופכת אותו לאלמנט דינמי, פיסולי כאשר נעשה בו שימוש יחיד, ופונקציונלי כשהוא משתלב עם אלמנטים נוספים במערכת Bubble.\n\nפוף יחיד / מודול ספה מרופד, עם או בלי קשתות ובסיס עץ.\nמבנה משכבות עץ מוסמך EPA, אשוח, וחומר פייזי. מרופד בפוליאוריתן עם תאים פתוחים ושכבות דאקרון, קפיצים ורצועות אלסטיות. קשתות משכבות עץ אשור מכופפות מצופות באשור פרוס. רגלי עץ צבועות בשחור. ריפוד עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Pouff regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Pouff regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Pouff regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Pouff regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Pouff regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Pouff regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Pouff regular-light/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-pouff/48",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 24592,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble SX regular-light": {
    "description": "עוצב על ידי מתאו זורזנוני עבור קרפנזה הום, Bubble היא משפחת מושבים בעלת קווים רכים ומעוגלים המושפעת מהאסתטיקה הנוחה של שנות השבעים. בנויה סביב כרך מרופד יחיד שניתן להתאמה, Bubble מאפשרת קונפיגורציות מרובות בתגובה לתכונות ולצרכים של הסביבות המודרניות. מושבים עם או בלי משענת יד ובעומקים שונים, פוף שניתן להשתמש בו כאלמנט יחיד או כצומת לספות פינתיות, שזלונג או כורסאות נוחות עם משענת כפולה. טווח רחב ומגוון של אלמנטים לפתרונות גמישים שניתן לשנותם בזמן ובמרחב, זמין בשתי גרסאות, עם בסיס מבני מעץ מעוקל שהופך בולט יותר בשילוב עם בדים מרפדים, או ללא בסיס לקו קליל יותר המתאים גם לשימוש חיצוני.\n\nBubble SX היא כורסה בעלת מימדים קטנים המאפיינת בנוכחות של משענת יד יחידה בצד שמאל. פיסולית לבדה, פונקציונלית כשהיא משולבת עם מודולים אחרים במערכת Bubble.\n\nכורסה יחידה / מודול ספה מרופד עם משענת יד שמאלית, עם או בלי קשתות ובסיס מעץ. מבנה מסנדוויץ' מאושר EPA, אשוח, פייסיט. מרופד בפוליאוריתן פתוח תאים ושכבות דקרון, קפיצים מרצועות אלסטיות. קשתות בשכבות של בוק קלוף מצופה באשור. רגליים מעץ צבוע שחור. ריפוד מעור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble SX regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble SX regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble SX regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble SX regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble SX regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble SX regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble SX regular-light/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble SX regular-light/7.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-sx/45",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 29169,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble Slim regular-light": {
    "description": "עוצב על ידי מתאו זורזנוני עבור Carpanese Home, Bubble היא משפחת כורסאות עם קווים רכים ועגולים, בהשראת האסתטיקה הנוחה של שנות השבעים. בנויה סביב נפח מרופד יחיד הניתן למודולציה, Bubble מאפשרת תצורות רבות בתגובה למאפיינים ולצורכי הסביבות העכשוויות. כורסאות עם או בלי ידיות ובעומקים שונים, פופים לשימוש כאלמנטים יחידים או כמחברים לספות פינתיות, שזלונג או כורסאות נוחות עם שני משענות. מגוון רחב ורב-תכליתי של אלמנטים לפתרונות גמישים, הניתנים לתצורה מחדש לאורך הזמן והמרחב, זמינים בשני גרסאות: עם בסיס מבני מעץ מעוגל הבולט בשילוב עם בדי הריפוד, או ללא בסיס לקו קל יותר, אידיאלי גם לשימוש חוץ. Bubble Slim היא כורסה קטנה עם משענת גב רכה וללא ידיות. פיסולית לבד, פונקציונלית כאשר משולבת עם מודולים אחרים ממערכת Bubble. \nכורסה יחידה / מודול ספה מרופד ללא ידיות, עם או בלי קימורים ובסיס עץ. מבנה מסנדוויץ' מוסמך EPA, אשוח, פייברבורד. מרופדת בפוליאוריתן בתאים פתוחים ושכבות דאקרון, רצועות אלסטיות להחזקת הקפיצים. קימורים בשכבות דיקט אשור מצופה אבן. רגליים מעץ צבוע שחור. ריפוד עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/7.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/8.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble Slim regular-light/9.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-slim/44",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 20795,
    "filter_category": "-",
    "placement": "-"
  },
  "Bubble System regular-light": {
    "description": "עוצב על ידי מתאו זורזנוני עבור Carpanese Home, Bubble היא משפחה של מושבים עם קווים רכים ועגולים המושפעים מהאסתטיקה הנוחה של שנות השבעים. בנויה סביב נפח מרופד אחד מודולרי, Bubble מאפשרת שלל תצורות בהתאם לתכונות ולצרכים של סביבות מודרניות. מושבים עם או בלי משענות יד ובעומקים שונים, הדומים שניתן להשתמש בהם כאלמנטים בודדים או כחלק מספות פינתיות, שזלונג או כורסאות נוחות עם שני גב. מגוון רחב ורב-תכליתי של אלמנטים לפתרונות גמישים, הניתנים לשינוי מחדש בזמן ובמקום, זמינים בשני וריאנטים, עם בסיס מבני מעץ מכופף שהופך להדגשה על ידי השילוב עם בדי הריפוד, או בלי בסיס לקו קליל יותר המתאים גם לחוץ.\n\nמערכות Bubble מורכבות מאלמנטים מרופדים עם או בלי משענות יד צדדיות, שצורתם הבולטת מודגשת על ידי הקווים המקבלים והפרופורציות שנקבעו בקפדנות מירבית.\n\nספות וכורסאות מרופדות עם או בלי קימורים ובסיס עץ. מבנים משכבת עץ רב-שכבתית מוסמכת EPA, אשוח, וקשת פלג. מרופדות בפוליאוריתן בתאים פתוחים ומעוצבות בדקרון, רצועות אלסטיות לקפיצים. קשתות בשכבות עץ עבה מכופף ממוסגרות באפר. רגליים מעץ צבוע שחור. ריפוד עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/7.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/8.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/9.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Bubble System regular-light/10.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/bubble-system/39",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 23149,
    "filter_category": "-",
    "placement": "-"
  },
  "Cusco 3P": {
    "description": "עוצב על ידי ג'ורג'יו בונאגורו עבור קרפנזה הום, הספה קוסקו נולדה ממערכת מודולרית של אלמנטים שהושפעו מהחומות הציקלופיות של הערים העתיקות באמריקה הלטינית. הצורות הרחבות, הגיאומטריות והמשלימות של האלמנטים, שתוכננו להשתלב זו בזו כמו חומות לבנים, יוצרות מקומות ישיבה, מפרקים ומשענות גב רב-צורתיות. פתרונות התפתחותיים חופשיים מתבניות שנועדו לחיות במרחב, נוחים ומזמינים במבט קדמי, בלתי צפויים ובעלי השפעה במבט צדדי או בזווית. מערכת כביכול פשוטה שבה רעיון, אסתטיקה, טכניקות ייצור ואיכות מתכנסים ליצירת פרויקט בעל ערך שזכה בשנת 2022 בפרס ADA — Archiproducts Design Award, ההכרה שמאגדת מדי שנה את המוחות היצירתיים המובילים באדריכלות ובעיצוב ומעניקה פרסים על האיכות הגבוהה של העיצוב, החדשנות והאיזון הנכון בין פונקציונליות, טכנולוגיה ויופי.\n\nספה שניים, שלושה או ארבעה מושבים בלוח רב-שכבתי מאושר EPA, אשוח, פאיז. ריפוד ב-polyurethane תאים פתוחים ונדפי דקרון, קפיצים רצועות אלסטיות. כיסוי עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/7.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/8.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/9.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco 3P/10.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/cusco-3p/36",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 12771,
    "filter_category": "-",
    "placement": "-"
  },
  "Cusco XXL": {
    "description": "מעוצב על ידי ג'ורג'יו בונאגורו עבור קרפנזה הום, ספת Cusco נולדה ממערכת מודולרית של אלמנטים בהשראת חומות הענקים של הערים העתיקות באמריקה הלטינית. הצורות הרחבות, הגיאומטריות והמשלימות של הריפודים, שתוכננו להשתלב זו בזו כמו חומות לבנים, יוצרות מושבים, חיבורים ומשענות גב רבגוניות. פתרונות מתקדמים המשוחררים מתבניות, המיועדים לחיות במרחב, נוחים ומזמינים מנקודת מבט חזיתית, מפתיעים ובעלי השפעה מנקודת מבט צדדית או אלכסונית. מערכת שנראית פשוטה על פניה, בה קונספט, אסתטיקה, טכניקות ייצור ואיכות מתלכדים כדי ליצור פרויקט בעל ערך שזכה בשנת 2022 בפרס ADA — Archiproducts Design Award, ההכרה המאחדת מדי שנה את המוחות היצירתיים ביותר בתחום האדריכלות והעיצוב ומעניקה פרסים על איכות עיצוב גבוהה, חדשנות ואיזון נכון בין פונקציונליות, טכנולוגיה ויופי.\nספות וספת פינה מבוצעות ב- EPA מוסמך, אשוח, פאיסייט. ריפוד בפוליאוריתן עם תאים פתוחים ושכבות דקרון, מערכת קפיצי רצועות אלסטיות. ריפוד עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/5.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/6.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/7.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/8.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/9.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Cusco XXL/10.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/cusco-xxl/37",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 11291,
    "filter_category": "-",
    "placement": "-"
  },
  "Gaston": {
    "description": "מעוצבת על ידי Carpanese Home, גסטון היא כורסה בעלת צורות רחבות ומעוגלות שהמאפיין העיקרי שלה טמון במבנה המתכתי הצבוע שמשמש גם כבסיס וגם כאלמנט פורמלי. הנפחים הרחבים של המושב, המוקפים במשענת כפולה ומרופדת, מודגשים יותר על ידי הרגליים המתכתיות שמרימות את המושב מהרצפה ורומזות לעולם הכיסאות. אלגנטית ונוחה, גסטון היא הפתרון לחללי מגורים מקוריים, פתוחים לשפות ריהוט חדשות.\nכורסה עשויה משכבות עץ רב-שכבתיות עם תעודת EPA, אשוח, פייסייט ואיירפלקס. מרופדת עם פוליאוריתן בתאים פתוחים ושכבות של דקרון, עם קפיצים מרצועות גמישות. מבנה ממתכת צבועה. משטח כיסוי מעור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Gaston/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Gaston/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Gaston/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Gaston/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Gaston/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/gaston/50",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 26886,
    "filter_category": "-",
    "placement": "-"
  },
  "Rocha A & B": {
    "description": "מעוצבים על ידי ג'ורג'ו בונאגורו עבור Carpanese Home, הפופים Rocha מאופיינים בצורות פיסוליות המושרות מסלעים. מורכבים משני חלקים משלימים המתחברים ליצירת מושב, הפופים זמינים בבד, או בבד ועור, כתוספת ריהוט רב-שימושית שניתן להשתמש בה במצבים שונים וסביבות שונות.\nפוף עשוי משכבות עץ מוסמכות EPA, אשוח, פייזיט ואיירפלקס. מרופד בפוליאוריתן עם תאים פתוחים וחומר ממולא של דאקרון, קפיצים ורצועות אלסטיות. כיסוי עור או בד.",
    "image_url": "../upload_images/Carpanese/DIVANI E POLTRONE/Rocha A & B/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/DIVANI E POLTRONE/Rocha A & B/1.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Rocha A & B/2.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Rocha A & B/3.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Rocha A & B/4.jpg",
      "../upload_images/Carpanese/DIVANI E POLTRONE/Rocha A & B/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/divani-e-poltrone/rocha/52",
    "company_name": "Carpanese",
    "original_category": "DIVANI E POLTRONE",
    "price": 14923,
    "filter_category": "-",
    "placement": "-"
  },
  "Annette": {
    "description": "מעוצבת על ידי Carpanese Home, Annette היא כורסה בעלת צורות עדינות ואלגנטיות, המאופיינת ברגליים מוצקות מעץ אשור מלא ובמושב נוח שהופך אפילו יותר נוח בזכות משענת כפולה מרופדת עוטפת. מצופה בעור או בבד, Annette מתאימה לתצורות ולמצבים שונים, מחדר האוכל למשרד הביתי, מהסלון לאזור השינה.\n\nכורסה במולטי-שכבה מאושרת על ידי EPA, עשויה מעץ אשוח, פזית ו-airflex, בסיס מעץ אשור מלא. מרופדת בפוליאוריתן עם תאים פתוחים ושכבות דאקרון, תמיכה באמצעות רצועות אלסטיות. ציפוי עור או בד.",
    "image_url": "../upload_images/Carpanese/SEDIE/Annette/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SEDIE/Annette/1.jpg",
      "../upload_images/Carpanese/SEDIE/Annette/2.jpg",
      "../upload_images/Carpanese/SEDIE/Annette/3.jpg",
      "../upload_images/Carpanese/SEDIE/Annette/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/sedie/annette/56",
    "company_name": "Carpanese",
    "original_category": "SEDIE",
    "price": 12144,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Birkin": {
    "description": "עם המראה האסתטי החלק והאלגנטי שלה, הכיסא Birkin, שעוצב על ידי מאטאו זורזנוני עבור Carpanese Home, משתלב בצורה טבעית בכל סביבה ביתית. פרופיל המושב — הכמעט מדמה תנועה קלה של הצורה הנוצרת על ידי הקו המתעקל של משענת היד והרגליים האחוריות המוארכות — יוצר איזון מושלם בין מבנה לנוחות, בין מוצקות לחן. הכיסא עשוי עץ מלא, והמושב והמשענת מכוסים בבד רך שניתן להתאמה אישית.\nכיסא מעץ מילה מלא, בסיס דיקט ליבנה, משענת עשויה מוטות פלדה, המושב והמשענת מרופדים בגומי. כיסוי עור או בד.",
    "image_url": "../upload_images/Carpanese/SEDIE/Birkin/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SEDIE/Birkin/1.jpg",
      "../upload_images/Carpanese/SEDIE/Birkin/2.jpg",
      "../upload_images/Carpanese/SEDIE/Birkin/3.jpg",
      "../upload_images/Carpanese/SEDIE/Birkin/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/sedie/birkin/54",
    "company_name": "Carpanese",
    "original_category": "SEDIE",
    "price": 21441,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Georgette": {
    "description": "מעוצבת על ידי Carpanese Home, גרג'ט היא כיסא בעל צורות מעוגלות, כאשר המאפיין המרכזי הוא משענת הגב הכפולה המשמשת כתמיכה ואלמנט עיצובי. הנפחים הקלים והמוארים של המושב הופכים לנוחים הודות לריפוד הקל, מה שהופך את גרג'ט לכיסא המושלם לחדר האוכל או למשרד ביתי אלגנטי אך בלתי פורמלי.\nהכיסא עשוי משכבה מרובדת מוסמכת EPA, פאהסייט ו-airflex. מרופד בפוליאוריתן בעל תאים פתוחים ושכבות דקרון. המבנה עשוי מתכת צבועה. הכיסוי עשוי עור או בד.",
    "image_url": "../upload_images/Carpanese/SEDIE/Georgette/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SEDIE/Georgette/1.jpg",
      "../upload_images/Carpanese/SEDIE/Georgette/2.jpg",
      "../upload_images/Carpanese/SEDIE/Georgette/3.jpg",
      "../upload_images/Carpanese/SEDIE/Georgette/4.jpg",
      "../upload_images/Carpanese/SEDIE/Georgette/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/sedie/georgette/55",
    "company_name": "Carpanese",
    "original_category": "SEDIE",
    "price": 13536,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Manta D": {
    "description": "נחשבה עבור משרד ביתי עכשווי ועוצבה על ידי מתאו צורזנוני עבור קרפנסה הום, פולטרונת הסיבוב מנטה D היא כורסה מתברגות עם מראה מעודן ורב תכליתי שבה העור המעובד ביד משמש כמבנה ותמיכה למושב ולמשענת המרופדים ולשני המסעדים מעץ מלא, יוצרים משחק מעניין של חומרים מלאים וריקים. הבסיס המתכתי בצורת כוכב עם גלגלים ניידים, ניתן כוונון גובה הודות לידית שנמצאת מתחת למושב, מאפשר תנועה קלה במהלך שעות העבודה.\n\nכורסה מתברגת מעץ שכבות אושרו על ידי EPA, אורן, פאי אייט ועץ מסעדי אפר, מחוברת למושב עם שלושה להבי מתכת מצופות בעור. בסיס לקה שחור, קרני אלומיניום מלוטשים וצבועים, עמוד מתכת כרומיום מבריק, גלגלי גומי, עם הגבהת גז. מרופדת עם פוליאוריתן תאים פתוחים ושכבות דקרון. כיסוי עור או בד.",
    "image_url": "../upload_images/Carpanese/SEDIE/Manta D/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SEDIE/Manta D/1.jpg",
      "../upload_images/Carpanese/SEDIE/Manta D/2.jpg",
      "../upload_images/Carpanese/SEDIE/Manta D/3.jpg",
      "../upload_images/Carpanese/SEDIE/Manta D/4.jpg",
      "../upload_images/Carpanese/SEDIE/Manta D/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/sedie/manta-d/58",
    "company_name": "Carpanese",
    "original_category": "SEDIE",
    "price": 28940,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Manta P": {
    "description": "מיועדת למשרד ביתי עכשווי ומעוצבת על ידי מתאו זורזנוני עבור Carpanese Home, כורסת Manta P היא כורסה מסתובבת עם ניחוח מעודן ורב-תכליתי שבה העור המיוצר בעבודת יד מהווה מבנה ותמיכה למושב ולמשענת המרופדים ולשני ידיות העץ המלא, ויוצרת משחק מעניין של מלאות וריקות בחומר. הרגליים המעוצבות במבנה פרמידלי, גם הן מעץ מלא, מקנות יציבות לכיסא תוך הדגשה על רמת תשומת הלב הגבוהה לפרטים שבהם הצורה עוקבת בצורה מושלמת אחר הפונקציה.\nהאלגנטיות של כורסת Manta P הופכת אותה לאלמנט אידיאלי בכל חללי הבית, מהמטבח ועד אזור האוכל, ומדגישה תפיסה של \"חיים בבית\" הדואגת לרב-תכליתיות של הרהיטים בזמן ובמרחב.\nכורסה בריבוד רב-שכבי עם תעודת EPA, אשוח ולוח סיבית דחוסה. רגליים וידיות מעץ מילה מלא. מחוברת למושב בשלוש להבי מתכת מצופות בעור. מרופדת עם פוליאוריתן בתאים פתוחים ושכבות דאקרון. ציפוי עור או בד.",
    "image_url": "../upload_images/Carpanese/SEDIE/Manta P/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SEDIE/Manta P/1.jpg",
      "../upload_images/Carpanese/SEDIE/Manta P/2.jpg",
      "../upload_images/Carpanese/SEDIE/Manta P/3.jpg",
      "../upload_images/Carpanese/SEDIE/Manta P/4.jpg",
      "../upload_images/Carpanese/SEDIE/Manta P/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/sedie/manta-p/57",
    "company_name": "Carpanese",
    "original_category": "SEDIE",
    "price": 19938,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Panda": {
    "description": "מעוצבת על ידי מתיאו זורזנוני עבור Carpanese Home, פנדָה היא כורסה נוחה ועוטפת ששמה נגזר מה-\"כתמים\" של הבד המוטמעים במבנה. עשויה כולה מעץ מלא מלוטש, ולאחר מכן נחצבה בעבודת יד כדי לאפשר להוספת הריפודים לאורך פרופיל הכורסה, פנדָה משחקת עם הניגודיות של הצבעים שהם למעשה ניגודים בין חומרים שונים ותחושות מגע שונות. פתרונות עיצוביים להענקת ייחודיות גם לצורות הטהורות ביותר.\nכורסה עם מבנה מעץ מילה מלא. מושב מרופד עשוי מגומי עם סטרץ' וקטיפה, רצועות אלסטיות. משענות ידיים מרופדות עם גומי. הריפוד עשוי מעור או בד.",
    "image_url": "../upload_images/Carpanese/SEDIE/Panda/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SEDIE/Panda/1.jpg",
      "../upload_images/Carpanese/SEDIE/Panda/2.jpg",
      "../upload_images/Carpanese/SEDIE/Panda/3.jpg",
      "../upload_images/Carpanese/SEDIE/Panda/4.jpg",
      "../upload_images/Carpanese/SEDIE/Panda/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/sedie/panda/53",
    "company_name": "Carpanese",
    "original_category": "SEDIE",
    "price": 25694,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Royal": {
    "description": "מעוצבת על ידי Carpanese Home, Royal היא כורסה מסתובבת עם משענת גבוהה ארגונומית ושני משענות יד נוחות. כולה מכוסה בבד או עור, Royal תוכננה עבור משרד ביתי מודרני שבו פרקטיות, אלגנטיות ונוחות משתלבים יחד כדי ליצור אווירה מקצועית ונעימה גם בבית.\n\nכורסה מסתובבת עשויה משכבות עץ רב שכבתי מוסמך EPA, עץ אשוח, פייברבורד ו-Airflex. מרופדת בפוליאוריתן פתוח תאים ופד דקרון, עם מערכת קפיצים אלסטית. בסיס מסתובב מאלומיניום מרופד, גלגלים מצופים גומי והעלאת גז. כיסוי מעור או בד.",
    "image_url": "../upload_images/Carpanese/SEDIE/Royal/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SEDIE/Royal/1.jpg",
      "../upload_images/Carpanese/SEDIE/Royal/2.jpg",
      "../upload_images/Carpanese/SEDIE/Royal/3.jpg"
    ],
    "product_url": "https://carpanesehome.com/sedie/royal/59",
    "company_name": "Carpanese",
    "original_category": "SEDIE",
    "price": 12731,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Alma H": {
    "description": "עוצב על ידי Carpanese Home, Alma H הוא ארון בעל פרופורציות נדיבות, אשר מאפיינו העיקרי טמון בדיאלוג בין צורות מחמירות ופירוטים מעוגלים. המרקם העגול של השיש שמאפיין את דלתות החזית מעשיר ומרכך את מבנה העץ של הארון, כמו גם רגלי המתכת, המסתיימות במבנה חצי עגול, שנראה כאילו הן כוללות את הנפח הרחב של הרהיט. הפנים, שתוכנן לבטא את הפונקציונליות המרבית, מחליף בין מדפי זכוכית למגירות מצופות ב-econabuk. לכות צבעוניות ומתכות צבועות משלימות את העיצוב.\n\nארון גבוה מעץ מכווץ ולוחות סיבי עץ מצופי קנלטו משוחזר. צירים מבוקרים, מתכות צבועות. מדפי זכוכית בעובי 8 מ\"מ. שיש מוקל מצופה עם honeycomb בעובי 10 מ\"מ. תחתיות המגירות מכוסות באפשרות econabuk אופציונלית.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma H/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma H/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma H/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma H/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma H/4.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma H/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/alma-h/60",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 22585,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Alma L": {
    "description": "מתוכננת על ידי Carpanese Home, Alma L היא ארון צדדי בעל פרופורציות נדיבות, שהמאפיין העיקרי שלו מצוי בדיאלוג בין צורות מסודרות לפרטים מעוגלים. האינטראסים בחצי עיגול של שיש המאפיינים את הדלתות הקדמיות מעשירים ומרככים את מבנה העץ של הארון, כמו כן הרגליים ממתכת, שבסופם יש גם מבנה חצי עיגול, נראות שמכילות את הנפח הרחב של הרהיט. הפנים, מתוכנן לבטא את התפקוד המקסימלי, משלב מדפי זכוכית ומגירות מצופות באקונבוק. לכות צבעוניות ומתכות צבועות משלימות את הרהיט.\nארון צדדי מלוחות עץ ודפי סיבים מעץ מצופה קנלטו מוקדם. צירים עם בולמי זעזועים, מתכות צבועות. מדפי זכוכית בעובי של 8 מ\"מ. שיש מוקל מצמיד עם Honeycomb בעובי של 10 מ\"מ. תחתיות המגירות מרופדות באקונבוק כאופציה.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma L/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma L/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma L/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Alma L/3.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/alma-l/61",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 29147,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Althea C": {
    "description": "מתוכננת על ידי Carpanese Home, אלתיאה C היא קונסולה שהמאפיין העיקרי שלה הוא הדיאלוג בין צורות קפדניות ופרטים מעוגלים. שני אינטרסים ממתכת מקוריים חוצים את כל פני השטח של הרהיט, מהחלק העליון ועד למגירות, ומסתיימים בשתי ידיות שימושיות. שני מגירות נשלפות מרופדות באקונאבוק משלימים את מבנה הרהיט ומדגישים את הצד הפונקציונלי שלו.  \nקונסולה מפנלים של סיבי עץ, מגירות מעץ טנגניקה מצופה, תחתיות מגירות מעץ טנגניקה מצופה או פנלים של סיבי עץ. מסילות נשלפות לחלוטין ניתנות לכוונון, מתכות צבועות. תחתיות המגירות מצופות באקונאבוק.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea C/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea C/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea C/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea C/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea C/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/althea-c/70",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 18088,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Althea D": {
    "description": "עוצב על ידי Carpanese Home, Althea D הוא שידה שהמאפיין העיקרי שלה טמון בדיאלוג של צורות קפדניות ופרטים מעוקלים. שני אינטרסים מתכתיים מקוריים עוברים על פני כל שטח הרהיט, מהחלק העליון ועד למגירות, ומסתיימים בידיות נוחות. שש מגירות בעלות נפחים נדיבים ומרופדות בבד דמוי עור משלימות את מבנה הרהיט ומדגישות את הצד הפונקציונלי שלו.\nהשידה עשויה מלוחות סיבי עץ, מגירות מעץ מלא מצופה טנגניקה, תחתיות מגירות מעץ מלא מצופה טנגניקה או לוחות סיבי עץ. מסילות נשלפות ומתכווננות, מתכות צבועות. תחתיות המגירות מרופדות בבד דמוי עור.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea D/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea D/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea D/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea D/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea D/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/althea-d/68",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 13992,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Althea N": {
    "description": "מתוכנן על ידי Carpanese Home, Althea N הוא שידה אשר מאפיינה העיקרי טמון בדיאלוג שבין צורות קפדניות לפרטים מעוגלים. גימור מתכת מקורי עובר לאורך כל שטח הרהיט, מהחלק העליון ועד למגירה, ומסתיים בידית שימושית. המגירה בנפח נדיב ומרופדת ב-econabuk, פרט אלגנטי נסתר.\n\nהשידה עשויה מלוחות סיבי עץ, המגירות עשויות מעץ מבוקע מצופה טנגניקה, תחתיות המגירות מעץ מבוקע מצופה טנגניקה או מלוחות סיבי עץ. מנגנוני פתיחה/סגירה מתכווננים לחלוטין, מתכות צבועות. תחתיות המגירות מרופדות ב-econabuk.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea N/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea N/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea N/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea N/3.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/althea-n/67",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 12726,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Althea V": {
    "description": "מתוכנן על ידי Carpanese Home, ה-Althea V הוא שולחן יופי שמאפיינו העיקרי טמון בדיאלוג בין צורות קפדניות לפרטים מעוגלים. שני אינטרסטים מתכתיים מקוריים מקשטים את כל פני השטח של הרהיט, מהחלק העליון ועד למגירה, ומסתיימים בשתי ידיות מעשיות. שני מגירות מצוידות בתאים לאחסון תכשיטים וטבעות מרופדים באקונאבוק ושני מראות עגולות בגדלים שונים משלימות את מבנה הרהיט, ומדגישות את האיזון האסתטי והפונקציונלי של שולחן היופי. \nשולחן יופי עשוי לוחות סיבים מעץ, מגירות מלוחי עץ טנגניקה מצופים פייבר ולוחות סיבי עץ. מסילות נשלפות לחלוטין ומתכווננות, מתכות צבועות ומראות. תאי מגירות, תאי תכשיטים ותאי טבעות פנימיים מרופדים באקונאבוק.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea V/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea V/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea V/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea V/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea V/4.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Althea V/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/althea-v/69",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 10155,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Delorean": {
    "description": "אלגנטית ומתוחכמת, הקונסולה Delorean - Vanity Desk שעוצבה על ידי Matteo Zorzenoni עבור Carpanese Home, מתבטאת בקווים מעוקלים ומחודדים. רגליים דקיקות מעץ, כמו כנפיים מוכנות להיפרש כלפי חוץ, מסתיימות בבסיס מעוקל שתומך במשטח מעוצב מעץ, לכה או שיש, אליו מחובר מראה עגולה. רוח מינימליסטית ותשומת לב לחומרים הופכים כך למפתח לפרשנות עכשווית של רהיט על-זמני, פונקציונלי ונשי.\nשולחן איפור עם מראה. מבנה מעץ אפר, מבנה המסגרות למראה עשוי לוחות סיבית עץ. תת-משטח מלוחות סיבית עץ מצופים טנגניקה. דפנות וגב המגירה ממסגרת לוחות עץ מצופים טנגניקה. תחתית המגירה מלוחות לבוד צפצפה מרופדת בדמוי נובק. פתיחת המגירה ידנית עם סגירה רכה ומסילות שליפה מלאה מתכווננות. זמין עם משטח צבוע בגוון אחיד מט או משטח שיש בעובי 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/delorean/71",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 16937,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Delorean Light": {
    "description": "אלגנטי ומתוחכם, שולחן האיפור Delorean - Vanity Desk שעוצב על ידי מתיאו זורזנוני עבור Carpanese Home מתבטא בקווים מעוקלים ודקים. רגלי עץ דקות, כמו כנפיים המוכנות להיפרש כלפי חוץ, מסתיימות בבסיס מעוקל שתומך בשולחן מעוצב במראה עץ, לכה או שיש שאליו ניתן לחבר מראה עגולה, וכך להפוך את הרהיט הכללי לשולחן איפור אלגנטי. רוח מינימליסטית ותשומת לב לחומרים הופכות למפתח להבנה מחודשת ועכשווית של רהיט על זמני, פונקציונלי ונשי.\n\nשולחן מעץ מילה. תחתית העשויה לוחות סיבי עץ מצופים בטנגניקה. צדדים וגב המגירה עשויים רצועות עץ מצופים בטנגניקה. תחתית המגירה עשויה שכבות רב-שכבתיות של צפצפה מרופדות באיקונאבוק. המגירה נפתחת ידנית עם סגירה רכה ומסילות הניתנות לכוונון מלא. זמין עם שולחן מצופה לכה מט או שולחן שיש בעובי של 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean Light/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean Light/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean Light/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean Light/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Delorean Light/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/delorean-light/72",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 25934,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Erice C": {
    "description": "עוצב על ידי ג'ורג'יו בונאגורו עבור קרפנזה הום ב-2022, \"אריצה\" היא קולקציה של שולחנות קטנים וקונסולות בצורות ובגדלים שונים, המאופיינת ברגליים רחבות ובמשטחים עם קווים מעוגלים המתחברים בצורה שנראית לא סדירה. משחק עדין של חיבורים גיאומטריים משקף את החיבור של האבנים הענקיות האופייניות לחומות הציקלופיות, ונותן ל-\"אריצה\" דינמיות בלתי צפויה של הצורות. משטחי השולחנות – הנוצרים בשני מפלסים, משטח תחתון מעץ יחד עם משטח עליון משיש או עץ – בשילוב עם הרגליים המונוליטיות, הופכים את \"אריצה\" לקולקציה עם חותם פיסולי בלתי ניתן לערעור.\n\n\"אריצה C\" היא קונסולה רב-שימושית בממדים נדיבים באורך אך בעומק מוגבל. אידיאלית לעיצוב כל חלל, מהסלון ועד לחדר השינה, ולחיונית להגדרת חללים היברידיים וחללי מעבר כמו כניסות, מסדרונות, ואזורי מבואות הודות לנפחים החסכוניים במקום.\n\nקונסולה מפנלים מסיבי עץ מצופים עץ אשוח. זמינה עם משטח עץ או משטח שיש בעובי של 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice C/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice C/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice C/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice C/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice C/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/erice-c/63",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 22966,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Erice D": {
    "description": "עוצבה על ידי ג'ורג'יו בונאגורו עבור קרפאנזה הום בשנת 2023, המזנון Erice D מצטרף לאוסף של שולחנות קפה וקונסולות בצורות ובגדלים שונים שעוצבו בשנה הקודמת ומתאפיינים ברגליים רחבות ומשטחים בעלי קווים מעוגלים המשולבים בצורה שלכאורה אינה סדירה.\nבתכנון המזנון Erice D נעשה שימוש באותם סגנונות ובמבנה כולו מעץ מלא ומשטחים משיש או מעץ, המזנון Erice D משחזר את המשחק העדין של השתלבות גיאומטרית בהשראת השילוב המתוחכם של האבנים הענקיות האופייניות לחומות ה\"סייקלופיות\" אבל מוסיף נפחים שימושיים לאחסון.\nהדינמיות הבלתי צפויה של הצורות שנגרמת ממפגש בין המשטחים, הרגליים המונוליתיות והנפחים הנדיבים עושים את Erice D למזנון עם טביעת אצבע פיסולית בלתי ניתנת להכחשה.\nמזנון מפנלים של סיבי עץ מצופים בעץ אשור. תא פנימי סודי מאחורי הרגל המרכזית. זמין עם משטח עליון מעץ או משטח עליון משיש בעובי של 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice D/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice D/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice D/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice D/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice D/4.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Erice D/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/erice-d/62",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 17765,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Trio D L": {
    "description": "פונקציונליות ואסתטיקה מגדירות את Trio D L, שידה שעוצבה על ידי מתאו צורזנוני עבור Carpanese Home.\nהניגוד בין הגוף המרכזי של הרהיט - צבעוני, מרובע ומהותי - לבין הרגליים מעץ בקווים רכים שתומכים בו ומופיעות כאיורים על המשטח העליון, הופכים את השידה הזו ליוצאת דופן במינה, מיועדת לחדר השינה אך יכולה להשתלב בקלות בכניסה מרווחת או באזור המגורים.\nזמין בשני גדלים, Trio D L באורך 160 ס\"מ ו-Trio D S באורך 120 ס\"מ, Trio ניתן להתאמה אישית בבחירה בין הגימורים השונים של העץ, הצבעים של הלכה ובין הסוגים השונים של השיש עבור המשטח העליון.\nשידה עם חלקים מסיביים, רגליים וידיות מעץ מילה. תכולה, מגירות ומשטח עליון מפנלים של סיבי עץ. דפנות וגב המגירה מצופים בלוח גזם טנגניקה. תחתית המגירות משכבות רב-שכבתיות של צפצפות, מרופדות באקונאבוק. מסילות פתיחה כוללת ניתנות לכיוונון. מבנה לכה מט, זמין עם משטח עליון בלכה מט או משטח שיש בעובי 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D L/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D L/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D L/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D L/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D L/4.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D L/5.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D L/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/trio-d-l/64",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 26253,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Trio D S": {
    "description": "פונקציונליות ואסתטיקה מגדירות את Trio D S, שידה שנועדה על ידי מטאו צורזנוני עבור Carpanese Home. הניגוד בין גוף המרכזי של הרהיט - הצבעוני, המלבני והמינימליסטי - לבין הרגליים העשויות מעץ עם קווים רכים שתומכות בו ומופיעות כאינטרזיות על המרפסת העליונה, הופכות אותו לייחודי מסוגו. רהיט זה תוכנן לחדר השינה אך ניתן למקם אותו בקלות גם בכניסה מרווחת או באזור המגורים. זמין בשני גדלים, Trio D L באורך של 160 ס”מ ו-Trio D S באורך של 120 ס”מ. Trio ניתנת להתאמה אישית בבחירת הגימורים השונים של העץ, הצבעים של הציפוי ובחירה בין סוגי השיש השונים למשטח העליון.\n\nקומודה עם חלקים מסיביים, רגליים וידיות מעץ מילה. תחתית, מיכלי מגירות ומשטח עליון עשויים מלוחות סיבי עץ. דפנות וגב המגירה עשויים מלוחות עץ דקים מצופים טנגן. תחתית המגירות עשויה מלוחות מרובת שכבות של עץ צפצפה, מרופדות באיקונבוק. מסילות להוצאה מלאה מתכווננות. מבנה מצופה לכה מט, זמין עם משטח עליון מצופה לכה מט או משטח שיש בעובי 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D S/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D S/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D S/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D S/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D S/4.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D S/5.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D S/6.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio D S/7.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/trio-d-s/65",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 26518,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Trio N": {
    "description": "פונקציונליות ואסתטיקה מגדירות את דגם Trio N, שידת לילה שעוצבה על ידי מתאו זורזנוני עבור Carpanese Home. הניגוד בין הגוף המרכזי של הרהיט — צבעוני, מרובע וחיוני — לבין הרגליים מעץ בקווים רכים שתומכות בו ובולטות כתבליטים עלהמישור העליון, הופכים פריט ייחודי זה למיוחד במינו, כשנועד לחדר השינה.\nדגם Trio N ניתן להתאמה אישית תוך בחירה בין מגוון הגימורים של העץ, צבעי הציפוי והסוגים השונים של השיש לחלק העליון.\nשידת לילה עם חלקים מסיביים, רגליים וידיות מעץ אלון. תאים פנימיים, מגירות וחלק עליון עשויים לוחות סיבי עץ. דפנות וגב המגירה מלוחות למינציה עם ציפוי טאנגניקה. תחתית המגירות מלוחות מרובי שכבות של צפצפה ומרופדים בבד econabuk. מסילות מגירות ניתנות לכוונון ותומכות בפתיחה מלאה. המבנה עם ציפוי מט, זמין עם משטח עליון עם ציפוי מט או משטח עליון של שיש בעובי 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio N/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio N/1.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio N/2.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio N/3.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio N/4.jpg",
      "../upload_images/Carpanese/CREDENZE E CONSOLLE/Trio N/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/credenze-e-consolle/trio-n/66",
    "company_name": "Carpanese",
    "original_category": "CREDENZE E CONSOLLE",
    "price": 15395,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Imperial R": {
    "description": "עוצב על ידי Carpanese Home, Imperial R הוא שולחן אוכל עגול בממדים גדולים שהמאפיין המרכזי שלו טמון במשחק מדויק של שיבוצים בצורה, בחומרים ובשקיפויות. הבסיסים הגליליים - עשויים על ידי הצמדת חלק ממתאקרילאט בגוון חם של עישון לריפוד עור עם תפרי תיפורים מחוברים ברצועת מתכת צבועה - מעזים לשלב התאמות לא שגרתיות. המשטח מזכוכית מחוסמת, גם הוא בגוון עישון, משלים את המבנה ומאפשר להבליט את הצורות המעוגלות של הבסיסים וליצור משחק גיאומטריות מעניין ובלתי צפוי על פני השולחן.\nשולחן אוכל עגול מחומרים מרוכבים של עץ, מבנה הגלילים מצופה חומרים מרוכבים של עץ ודיקט של צפצפה. גלילי פולימתילמטקרילט של מתיל, לוח פלדה, מתכות צבועות. זכוכית מחוסמת בעובי 12 מ\"מ, גומיות סיליקון דבקיות. ריפוד בקצף פוליאוריתן משולב עם ולוטין ואקרילן סיליקוני מ-100% פוליאסטר. כיסוי מעור או בד.",
    "image_url": "../upload_images/Carpanese/TAVOLI/Imperial R/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLI/Imperial R/1.jpg",
      "../upload_images/Carpanese/TAVOLI/Imperial R/2.jpg",
      "../upload_images/Carpanese/TAVOLI/Imperial R/3.jpg",
      "../upload_images/Carpanese/TAVOLI/Imperial R/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavoli/imperial-r-/76",
    "company_name": "Carpanese",
    "original_category": "TAVOLI",
    "price": 27148,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Imperial S": {
    "description": "עוצב על ידי Carpanese Home, Imperial S הוא שולחן אוכל מלבני בממדים רחבים שהמאפיין העיקרי שלו טמון במשחק מדוקדק של אינטרסים בצורה, בחומרים ובשקיפות. הבסיסים הגליליים — עשויים מחלק אחד של מתאקרילט בגוונים חמים של פומיי עם ריפוד עור תפור המחוברים ברצועת מתכת צבועה — מעזים לעשות שילובים בלתי צפויים. פלטת הזכוכית המוקשחת, שגם היא בצבע פומיי, משלימה את המבנה תוך הבלטת הצורות המעוגלות של הבסיסים ויצירת משחק גאומטרי מעניין ולא צפוי על המשטח העליון.\n\nCarpanese Home זכתה בפרס Archiproducts Design Award 2021 בקטגוריית רהיטים עבור השולחן Imperial S.\n\nשולחן אוכל מלבני עשוי פאנלי סיבי עץ, מבנה הצילינדרים מרופד בפאנלי סיבי עץ ודיקט צפצפה. גלילי פולימתילמתאקרילט, פלטת פלדה, מתכות צבועות, זכוכית מחוסמת בעובי 12 מ\"מ, רפידות סיליקון דביקות. ריפוד עשוי פוליאוריתן מוקצף עם קטיפה ואטמת סיליקון עשויה פוליאסטר 100%. כיסוי עשוי עור או בד.",
    "image_url": "../upload_images/Carpanese/TAVOLI/Imperial S/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLI/Imperial S/1.jpg",
      "../upload_images/Carpanese/TAVOLI/Imperial S/2.jpg",
      "../upload_images/Carpanese/TAVOLI/Imperial S/3.jpg",
      "../upload_images/Carpanese/TAVOLI/Imperial S/4.jpg",
      "../upload_images/Carpanese/TAVOLI/Imperial S/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavoli/imperial-s/75",
    "company_name": "Carpanese",
    "original_category": "TAVOLI",
    "price": 15743,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Ladybug": {
    "description": "מעוצב על ידי מתאו זורזנוני עבור Carpanese Home, Ladybug הוא שולחן בעל ממדים נדיבים המאופיין בקווים רכים וזורמים. רגליים גליליות המבצבצות מעל המשטח, מזכירות את כנפי הפרת משה רבנו והן אלו שנתנו לשולחן את שמו, מעניקות למשטח העליון מראה גרפי ופיסולי.\nזמין בגימורים שונים, עץ, לכה או משטח עליון משיש, Ladybug מציג את טבעו כריהוט חיוני עם עידון פורמלי מחושב.\nשולחן האוכל עם בסיס מעץ מילה או לכה, משולב עם משטח עליון מעץ מילה, לכה מט או משיש בעובי 20 מ\"מ. משטח תמיכה תחתון לציפוי שיש מלכה מט בצבע תואם לשיש. להבים בצורת \"T\" מברזל, לוחות מתכת צבועים.",
    "image_url": "../upload_images/Carpanese/TAVOLI/Ladybug/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLI/Ladybug/1.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/2.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/3.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/4.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/5.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/6.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/7.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/8.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/9.jpg",
      "../upload_images/Carpanese/TAVOLI/Ladybug/10.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavoli/ladybug/73",
    "company_name": "Carpanese",
    "original_category": "TAVOLI",
    "price": 20856,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Linea T": {
    "description": "פונקציונליות ואסתטיקה מסונכנים בשולחן Linea T, שולחן מהאוסף הנושא את אותו השם שעוצב על ידי מתיאו זורזנוני עבור Carpanese Home, בעל קונוטציות גרפיות חזקות. הרגליים העשויות עץ, הממוקמות בניצב זו לזו, בולטות כשני שיבוצים על המשטח ומגדירות את האסתטיקה המינימליסטית שלו, שהופכת לעוד יותר אותנטית בזכות השילוב בין שני חומרים יוקרתיים כמו לכה לחלק העליון ועץ לרגליים. שילובים כרומטיים / חומריים שיודעים להדגיש קווים צורניים על-זמניים בדיאלוג פתוח עם עיצוב השולחן המודרני.\n\nשולחן אוכל מעץ מילה מוצק ופנלים מסיבי עץ מצופים פורניר מילה. זמין עם משטח מעץ מילה או מלכה מט או משיש בעובי 20 מ\"מ. תומך תת-משטח עבור משטח שיש מלוכה מט בגוון שיש. פלטות מתכת צבועה.",
    "image_url": "../upload_images/Carpanese/TAVOLI/Linea T/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLI/Linea T/1.jpg",
      "../upload_images/Carpanese/TAVOLI/Linea T/2.jpg",
      "../upload_images/Carpanese/TAVOLI/Linea T/3.jpg",
      "../upload_images/Carpanese/TAVOLI/Linea T/4.jpg",
      "../upload_images/Carpanese/TAVOLI/Linea T/5.jpg",
      "../upload_images/Carpanese/TAVOLI/Linea T/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavoli/linea-t/74",
    "company_name": "Carpanese",
    "original_category": "TAVOLI",
    "price": 28267,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Athena H & L": {
    "description": "מעוצב על ידי Carpanese Home, Athena הוא שולחן צד בעל נשמה מולטימטריאלית. מורכב מבסיס עגול משיש, משטח זכוכית מחוסמת וגוף מרכזי מעץ ומתכת, השולחן הזה זמין בשני גבהים — Athena H & L — משחק עם הרכב של צורות עגולות המורכבות מחומרים שונים ובצבעים שונים. התוצאה היא שולחן צד גמיש, פסלי, שניתן להשתמש בו כפריט בודד או בזוג.\n\nשולחן צד גבוה ושולחן צד נמוך מעץ אגוז מלא, זכוכית מחוסמת בעובי 12 מ\"מ ומשטח שיש בעובי 20 מ\"מ לבחירה. מתכות צבועות.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Athena H & L/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Athena H & L/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Athena H & L/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Athena H & L/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Athena H & L/4.jpg",
      "../upload_images/Carpanese/TAVOLINI/Athena H & L/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/athena/85",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 15217,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Erice R": {
    "description": "נוצרה על ידי ג'ורג'ו בונאגורו עבור Carpanese Home בשנת 2022, Erice היא קולקציה של שולחנות קפה וקונסוליות בצורות וגדלים שונים, המתאפיינת ברגליים רחבות ומשטחים עם קווים מעוגלים שמתמזגים בצורה שנראית לא סדירה. משחק עדין של חיבורים גיאומטריים משקף את ההצמדות של האבנים הגדולות האופייניות לחומות הקיקלופיות, מה שמעניק ל-Erice דינמיות בלתי צפויה של הצורות. משטחי השולחנות – המורכבים משני מפלסים, תחתון מעץ מחובר למשטח עליון משיש או עץ – יחד עם הרגליים המונוליתיות, הופכים את Erice לקולקציה עם טביעת רגל פסלית בלתי ניתנת לערעור.\n\nErice R הוא שולחן קפה נמוך בצורת עיגול, אידיאלי לריהוט אזור המגורים. פשוט אך עם אופי כשמשתמשים בו לבד, פסלי ומפתיע בפונקציונליות שלו כשהוא משולב עם שני הדגמים האחרים בקולקציה: Erice S, בצורת ריבוע, ו-Erice XL, בצורת מלבן. מכלול מורכב של צורות, גבהים וחומרים בזכות האפשרות להתאים אישית את משטחי השולחנות בגימורי עץ שונים וסוגי וצבעי שיש שונים.\n\nשולחן קפה נמוך עגול מפאנלים של סיבי עץ מצופים אפר. זמין עם משטח עץ או שיש בעובי של 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Erice R/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Erice R/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice R/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice R/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice R/4.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice R/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/erice-r/78",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 13637,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Erice S": {
    "description": "מעוצב על ידי ג'ורג'יו בונגורו עבור קארפאנזה הום בשנת 2022, אריצ'ה היא קולקציה של שולחנות קטנים וקונסולות בצורות ובגדלים שונים המתאפיינת ברגליים רחבות ובמשטחים עם קווים מעוגלים המשתלבים בצורה שנראית לא סדירה. משחק טבעי של השתלות גאומטריות משקף את החיבור בין האבנים הענקיות האופייניות לחומות קיקלופיות, ומעניק לאריצ'ה דינמיות בלתי צפויה של הצורות. המשטחים של השולחנות — עשויים משני מפלסים, מפלס תחתון מעץ המשולב עם משטח עליון משיש או מעץ — יחד עם הרגליים המונוליטיות, הופכים את אריצ'ה לקולקציה בעלת חותם פיסולי בלתי ניתן לערעור.\n\nאריצ'ה S הוא שולחן נמוך בצורה מרובעת, אידיאלי לריהוט אזור המגורים. מינימליסטי אך בעל אופי כשמשתמשים בו לבד, פיסולי ומפתיע מאוד בפונקציונליות כשהוא משתלב עם שני הדגמים הנוספים של הקולקציה: אריצ'ה R, בצורה מעגלית, ואריצ'ה XL, בצורה מלבנית. מכלול מורכב של צורה, גבהים וחומרים הודות לאפשרות ההתאמה האישית של המשטחים עם גימורים שונים בעץ וסוגים וצבעים שונים של שיש.\n\nשולחן מרובע בלוחות סיבי עץ מצופים בעץ מילה. זמין עם משטח עץ או שיש בעובי 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Erice S/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Erice S/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice S/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice S/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice S/4.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice S/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/erice-s/77",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 24247,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Erice XL": {
    "description": "עוצב על ידי ג'ורג'יו בונאגורו עבור Carpanese Home בשנת 2022, Erice היא קולקציה של שולחנות קפה וקונסולות בצורות ובגדלים שונים, המאופיינת ברגליים רחבות ומשטחים בקווים מעוגלים המשתלבים בצורה שנראית לכאורה לא סדירה. משחק דק של חיבורים גאומטריים משקף את השתלבות האבנים הענקיות הטיפוסיות לחומות הציקלופיות ונותן ל-Erice דינמיות בלתי צפויה של הצורות. המשטחים של השולחנות — עשויים משני מפלסים, תחתונים מעץ ומשטח עליון משיש או עץ — יחד עם הרגליים המונוליטיות, הופכים את Erice לקולקציה בעלת טביעת יד פיסולית בלתי ניתנת לערעור.\n\nErice XL הוא שולחן קפה נמוך בצורת מלבן, אידאלי לריהוט אזור המגורים. פרקטי אך בעל אופי כשהוא בשימוש כיחידה בודדת, פיסולי ומפתיע במידת הפעילות כאשר הוא מחובר לשני הדגמים הנוספים בקולקציה: Erice S, בצורת ריבוע, ו-Erice R, בצורת עיגול. יחד הם יוצרים מערך משולב בצורות, גבהים וחומרים הודות לאפשרות להתאים אישית את המשטחים של השולחנות בגימורים שונים של עץ ובסוגים וצבעים שונים של שיש.\n\nשולחן קפה נמוך מלבני מפנלים של סיבי עץ מצופים באש. זמין עם משטח עץ או שיש בעובי של 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Erice XL/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Erice XL/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice XL/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice XL/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice XL/4.jpg",
      "../upload_images/Carpanese/TAVOLINI/Erice XL/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/erice-xl/79",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 27100,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Imperial L": {
    "description": "תוכנן על ידי Carpanese Home, Imperial L הוא שולחן קפה רחב שבו המאפיין העיקרי טמון בצורות המעוגלות והשקופות של הבסיסים והמשטח. משחק של חפיפות בין צורות וחומרים הופך את הבסיסים הצילינדריים במתאקרילט לאלמנטים גרפיים, ומעניק למשטח הזכוכית מראה בלתי צפוי ומסקרן. פריט ייחודי לסלונים לא שגרתיים.\n\nשולחן קפה עשוי לוחות סיבי עץ, גלילים של פולימתילמתאקרילט של מתיל, מתכות צבועות. זכוכית מחוסמת בעובי 12 מ\"מ, מדבקות סיליקון להגנה.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Imperial L/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Imperial L/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Imperial L/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Imperial L/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Imperial L/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/imperial-l/84",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 22382,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Milestone": {
    "description": "כפי שמרמז השם Milestone, הפרט שמאפיין את שולחן הקפה שעוצב על ידי ג'ורג'יו בונאגורו עבור Carpanese Home הוא בסיס נדיב באבן טבעית המעוצבת בצורה שמעניקה יציבות ומקוריות למבנה הגלי של השולחן. בזכות האפשרות לשלב ציפויי צבע או גימורי עץ עם אבנים או שיש, Milestone נבדל בגמישותו, מה שהופך אותו לפריט רב-שימושי בכל חללי הבית, אובייקט קטן וגדול שאפשר ליהנות ממנו 24 שעות ביממה.\nשולחן קטן מעץ מלא ומלוחות סיבי עץ. רגל ופלטה מעץ מלא או עם ציפוי צבע, זמין עם בסיס צבע מט או משיש.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Milestone/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Milestone/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Milestone/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Milestone/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Milestone/4.jpg",
      "../upload_images/Carpanese/TAVOLINI/Milestone/5.jpg",
      "../upload_images/Carpanese/TAVOLINI/Milestone/6.jpg",
      "../upload_images/Carpanese/TAVOLINI/Milestone/7.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/milestone/80",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 16340,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Pebble L": {
    "description": "עוצב על ידי ג'ורג'יו בונאגורו עבור Carpanese Home, Peeble היא משפחה של שולחנות קפה בהשראת הצורות האורגניות, לעולם לא מושלמות, של האבנים הקטנות שמעוצבות על ידי המים. מיוצרים בשלוש גבהים שונים ועם פלטות בשלושה גדלים שונים, Peeble מבטא את הגמישות שלו בזכות הסיומות השונות והשילובים הכרומטיים המגוונים. הפלטות הלכות או משיש והבסיסים השונים מאפשרים התאמה אישית מלאה של השולחן לחופש שימוש מלא בכל סביבה בבית.\n\nPeeble L הוא שולחן קפה נמוך עם ממדים נדיבים המאופיין בצורות אורגניות, לא מושלמות למראה אך נעימות במיוחד למגע. הוא פשוט ופונקציונלי כאשר משתמשים בו לבד, Peeble L הופך ליצירת פיסול עם השפעה דרמטית כאשר משולב עם שני הדגמים הנוספים: Peeble M ו-Peeble S. מכלול מרכב בצורות, בגבהים וחומרים שניתן להרכיב ולעצב מחדש על פי הצורך ועל פי ההשראה.\n\nשולחן קפה נמוך ו/או בצורת סגלגל מלוחות סיבים מעץ. בסיס צבוע במראה מט, זמין עם פלטה צבועה במראה מט או משיש בעובי של 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Pebble L/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Pebble L/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble L/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble L/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble L/4.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble L/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/pebble-l/81",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 18165,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Pebble M": {
    "description": "עוצב על ידי ג'יורג'יו בונאגורו עבור Carpanese Home, Peeble היא משפחה של שולחנות קפה בהשראת הצורות האורגניות, לא מושלמות לעולם, של האבנים הקטנות המעצובות על ידי המים. מיוצרים בשלושה גבהים שונים ובשלושה גדלים של משטחי עבודה, Peeble מבטא באופן מרבי את גמישותו בזכות הגימורים השונים והשילובים הצבעוניים. המשטחים המצופים בלכה או בשיש והבסיסים השונים מאפשרים התאמה אישית מלאה של השולחן ליצירת חופש מוחלט לשימוש בכל סביבה בבית. Peeble M הוא שולחן קפה נמוך במידות נדיבות המתאפיין בבסיס תמיכה רחב ומשטח עבודה בצורות אורגניות, לא מושלמות למראה, מדהים להפליא במגע. חיוני ופונקציונלי כשהוא משמש לבד, Peeble M הופך לחתיכת פיסול מרשימה כשמצרפים אליו את שני הדגמים האחרים: Peeble S ו-Peeble L. מערכת משולבת בצורות, גבהים וחומרים לשילוב והרכבה מחדש לפי הצורך והיצירתיות.\nשולחן קפה אובלי בלוחות סיבי עץ. בסיס מצופה לכה מט, זמין עם משטח מצופה לכה מט או בשיש בעובי 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Pebble M/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Pebble M/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble M/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble M/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble M/4.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble M/5.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble M/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/pebble-m/82",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 10916,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Pebble S": {
    "description": "מעוצב על ידי ג'ורג'ו בונאגורו עבור Carpanese Home, Peeble היא משפחת שולחנות קפה בהשראת הצורות האורגניות, שמעולם לא הושלמו, של האבנים הקטנות המעוצבות על ידי המים. מיוצרים בשלושה גבהים שונים ועם משטחים בשלושה גדלים שונים, Peeble מציע את מרב הגמישות הודות לגימורים וכיוונים צבעוניים שונים. המשטחים הלכה או השיש ובסיסים שונים מאפשרים התאמה אישית מלאה של הרהיט לשימוש חופשי בכל סביבה בבית. Peeble S הוא שולחן קפה נמוך במידות קומפקטיות המתאפיין בפרופורציה בלתי רגילה בין בסיס התמיכה לאטופים בצורות אורגניות, לא מושלמות למראה, אך נעימות במיוחד למגע. חיוני ופונקציונלי כאשר משתמשים בו בפני עצמו, Peeble S הופך ליצירה פיסולית בעלת השפעה דרמטית כאשר מצרפים אליו את הדגמים האחרים: Peeble M ו-Peeble L. קבוצה מורכבת בצורות שונות, גבהים וחומרים שניתן להרכיב ולפרק לפי הצורך וההשראה.\nשולחן קפה סגלגל מעץ סיבי. בסיס לכה מט, זמין עם משטח לכה מט או משיש בעובי של 20 מ\"מ.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Pebble S/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Pebble S/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble S/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble S/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble S/4.jpg",
      "../upload_images/Carpanese/TAVOLINI/Pebble S/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/pebble-s/83",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 19149,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Rialto H & L": {
    "description": "מעוצב על ידי Carpanese Home, Rialto הוא שולחן צד שמורכב משני חלקים: גליל אליפטי שטוח עשוי מעץ ופרופיל מרובע ממתכת צבועה. האיחוד בין שני חלקים אלו, שלמרות שהם סותרים בצורתם והחומר מהם הם עשויים, הוא המפתח ליציבות והחוזק של Rialto, שולחן צד שמשתלב עם משטח זכוכית מחוסמת בגוון חם מעושן. זמין בשני גדלים — H & L — Rialto יכול לשמש לבד או בזוג.\nשולחן צד גבוה ושולחן צד נמוך עשויים מלוחות סיבי עץ, פלטת פלדה ומתכות צבועות. זכוכית מחוסמת בעובי של 12 מ\"מ.",
    "image_url": "../upload_images/Carpanese/TAVOLINI/Rialto H & L/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/TAVOLINI/Rialto H & L/1.jpg",
      "../upload_images/Carpanese/TAVOLINI/Rialto H & L/2.jpg",
      "../upload_images/Carpanese/TAVOLINI/Rialto H & L/3.jpg",
      "../upload_images/Carpanese/TAVOLINI/Rialto H & L/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/tavolini/rialto/86",
    "company_name": "Carpanese",
    "original_category": "TAVOLINI",
    "price": 14816,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Erice L": {
    "description": "מעוצבת על ידי ג'יורג'יו בונאגורו עבור Carpanese Home בשנת 2023, הספריה Erice L מצטרפת לאוסף השולחנות והקונסולות בצורות וגדלים שונים שעוצבו בשנה הקודמת ומאפיינת רגליים רחבות ומשטחים בקווים עגולים המחוברים בצורה לכאורה לא סדירה.\nמעוצבת באותם סגנונות ועם מבנה שלם מעץ מלא ומשטחים משיש או מעץ, הספריה Erice L מציגה שוב את משחק ההשתלבות העדין של החיבורים הגיאומטריים בהשראת השילוב של האבנים הענקיות האופייניות לחומות הציקלופיות. הדינמיות הבלתי צפויה של הצורות הנוצרת מהמפגש בין המשטחים והרגליים המונוליטיות הופכת את Erice L לספריה בעלת טביעת אצבע פיסולית בלתי ניתנת להכחשה.\nקיר ספריה בלוחות סיבי עץ ממוסגרים בעץ מבהיר. מדפים זמינים בעץ או בשיש בעובי של 20 מ\"מ ומדף תחתון מעץ מבהיר.",
    "image_url": "../upload_images/Carpanese/LIBRERIE/Erice L/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/LIBRERIE/Erice L/1.jpg",
      "../upload_images/Carpanese/LIBRERIE/Erice L/2.jpg",
      "../upload_images/Carpanese/LIBRERIE/Erice L/3.jpg",
      "../upload_images/Carpanese/LIBRERIE/Erice L/4.jpg",
      "../upload_images/Carpanese/LIBRERIE/Erice L/5.jpg",
      "../upload_images/Carpanese/LIBRERIE/Erice L/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/librerie/erice-l/87",
    "company_name": "Carpanese",
    "original_category": "LIBRERIE",
    "price": 24176,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Arthur S & XL": {
    "description": "נתוכננו על ידי Carpanese Home, ארתור היא שולחן כתיבה בעל צורות פיסוליות שבהן החיפוש אחר אסתטיקה לא קונבנציונלית משלב מקוריות ופונקציונליות.\nהשולחן זמין בשני גדלים — S עם מגירות ו-XL עם חצי אי רחב, פשרה בין קרדנצה למגירות — ארתור מתאפיין בבסיס מעוקל ובמגירות עם תפרים, שניהם מצופים בעור. חלקו העליון של השולחן והפרופילים של כל הרהיט עשויים מעץ, דבר המדגיש את הדו-שיח בין חומרים ותחושות מישוש שונות.\nשולחנות כתיבה עשויים פאנלים של סיבי עץ ורב-שכבות של צפצפה עם פורניר מעץ מהונדס. למגירות יש מנעול ותחתיתן מרופדת ב-econabuk. המתכות צבועות. הריפוד עשוי מקצף בעובי של 1 ס\"מ. כיסוי העור.",
    "image_url": "../upload_images/Carpanese/SCRIVANIE/Arthur S & XL/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SCRIVANIE/Arthur S & XL/1.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Arthur S & XL/2.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Arthur S & XL/3.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Arthur S & XL/4.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Arthur S & XL/5.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Arthur S & XL/6.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Arthur S & XL/7.jpg"
    ],
    "product_url": "https://carpanesehome.com/scrivanie/arthur/89",
    "company_name": "Carpanese",
    "original_category": "SCRIVANIE",
    "price": 10998,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Linea D": {
    "description": "פונקציונליות ואסתטיקה מסונתזות בקו D, שולחן הכתיבה מאותה קולקציה שעוצבה על ידי מתאו זורזנוני עבור קרפנזה הום, בעלת קונוטציה גרפית חזקה. רגלי העץ הממוקמות בזווית ישרה זו לזו, בולטות כשתי טבועות על המשטח ומגדירות את האסתטיקה המינימליסטית שלו. לשיפור נוסף של הרהיט, קיים שידה מעץ —— המתאפיינת בחיבורים עדינים ומחוברת לרגל כאלמנט מרחף —— שמשלבת את עיצוב המשטח ומוסיפה לאובייקט תחושה כללית של קלילות. שילובים חומריים המסוגלים להדגיש את הקו הצורני הנצחי מתכתבים עם העיצוב העכשווי של שולחן הכתיבה, ליצירת תפיסה חדשה של המשרד בבית.\nשולחן כתיבה מעץ אֹורָן מלא ולוחות סיבי עץ מצופים אֹורָן. ניתן להשגה עם משטח עץ אֹורָן או לכה מט. פלטות ממתכת צבועה. שני מגירות עם מערכת דחיפה-משיכה ותחתית מרופדת באֶקוֹנָבּוק. מעבר כבלים דרך הרגל הצדדית אופציונלי.",
    "image_url": "../upload_images/Carpanese/SCRIVANIE/Linea D/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/SCRIVANIE/Linea D/1.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Linea D/2.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Linea D/3.jpg",
      "../upload_images/Carpanese/SCRIVANIE/Linea D/4.jpg"
    ],
    "product_url": "https://carpanesehome.com/scrivanie/linea-d/88",
    "company_name": "Carpanese",
    "original_category": "SCRIVANIE",
    "price": 21967,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Lips S & XL": {
    "description": "עוצב על ידי מתיאו זורזנוני עבור קרפנזה הום, המיטה Lips משלבת צורות מעוקלות, משטחים רכים ותשומת לב קפדנית לפרטים העוברת בכל המבנה. ראש המיטה המרופד — זמין בשני גדלים, L ו-XL — מקבל במרכזו קורה מעץ המעצבת שתי שפתיים גדולות שממנה נגזר שם המיטה, בעוד הרגליים המעוצבות מעץ מלא שמחזיקות אותה מדמות את פריסתן של שתי כנפיים. לפי בקשה, ראש המיטה בגרסת XL יכול להכיל שני מדפים קטנים מעץ.\n\nמסגרת המיטה, פשוטה יותר בצורתה, מציגה רגליים בקווים נקיים המעוצבים בצורה מושלמת כדי לקבל את בד הכיסוי, בעוד הכיסוי הדק מעץ מלא מדגיש את קווי המתאר של המיטה כולה.\n\nמיטה עם חלקים מסיביים מעץ מילה ומבנה רב-שכבתי מוסמך EPA, אשוח ופאיזיט. מרופדת בפוליאוריטן עם תאים פתוחים ורפידות דקרון, קפיצים עם רצועות אלסטיות. ריפוד מעור או בד.",
    "image_url": "../upload_images/Carpanese/LETTI/Lips S & XL/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/LETTI/Lips S & XL/1.jpg",
      "../upload_images/Carpanese/LETTI/Lips S & XL/2.jpg",
      "../upload_images/Carpanese/LETTI/Lips S & XL/3.jpg",
      "../upload_images/Carpanese/LETTI/Lips S & XL/4.jpg",
      "../upload_images/Carpanese/LETTI/Lips S & XL/5.jpg",
      "../upload_images/Carpanese/LETTI/Lips S & XL/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/letti/lips/90",
    "company_name": "Carpanese",
    "original_category": "LETTI",
    "price": 22490,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Papillon L & XL": {
    "description": "תוכנן על ידי Carpanese Home, Papillon הוא מיטה המאופיינת בשני ראשי מיטה חופפים בממדים גדולים המכוסים במלואם בעור או בבד עבודת יד מוקפדת. רצועת מתכת דקה וצבועה, כאילו הייתה חוט, מסמנת את הקצב של הממדים ומחברת בין שני ראשי המיטה הזמינים בשתי גרסאות, L או XL. בסיס המיטה משחזר חלקית את עבודת העור או הבד ומדגיש את תשומת הלב המרבית שניתנה לפרט העיצוב הקטן ביותר.\n\nהמיטה עשויה מעץ מרוכב בעוביים משתנים ומרופדת בפוליאוריתן מוקצף. בסיס המיטה עשוי לוחות סיבי עץ צבועים בשחור ומתכות צבועות. הכיסוי עשוי עור או בד.",
    "image_url": "../upload_images/Carpanese/LETTI/Papillon L & XL/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/LETTI/Papillon L & XL/1.jpg",
      "../upload_images/Carpanese/LETTI/Papillon L & XL/2.jpg",
      "../upload_images/Carpanese/LETTI/Papillon L & XL/3.jpg",
      "../upload_images/Carpanese/LETTI/Papillon L & XL/4.jpg",
      "../upload_images/Carpanese/LETTI/Papillon L & XL/5.jpg",
      "../upload_images/Carpanese/LETTI/Papillon L & XL/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/letti/papillon/92",
    "company_name": "Carpanese",
    "original_category": "LETTI",
    "price": 19461,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Yves": {
    "description": "אלגנטיות ונוחות רכה של הצורות מאפיינות את המיטה איב, שעוצבה על ידי ג'ורג'יו בונאגורו עבור קרפנזה הום. הקווים הרחבים של המיטה מדגישים עיצוב מזמין ולא פורמלי, שהופך למתוחכם יותר על ידי ארבע רגלי עץ מלא מגולפות המשמשות כעמודי תמך למבנה כולו ומעניקות נופך עשיר וחם לכלל העיצוב. המיטה תוכננה בהתאם לרעיון של עיצוב ורסטילי, ואיב מתאימה לקונטקסטים עכשוויים או קלאסיים, ומאשרת את מקומה כגיבורה האמיתית של אזור השינה.\nהמיטה מורכבת מחלקים מסיביים מעץ מילה וממבנה רב-שכבתי מוסמך EPA, אשוח ופספח (פייברבורד). המיטה מרופדת בפוליאוריתן פתוח תאים ובשכבות של דקרון. המרכב כולל קפיצים אלסטיים. ריפוד מעור או בד.",
    "image_url": "../upload_images/Carpanese/LETTI/Yves/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/LETTI/Yves/1.jpg",
      "../upload_images/Carpanese/LETTI/Yves/2.jpg",
      "../upload_images/Carpanese/LETTI/Yves/3.jpg",
      "../upload_images/Carpanese/LETTI/Yves/4.jpg",
      "../upload_images/Carpanese/LETTI/Yves/5.jpg"
    ],
    "product_url": "https://carpanesehome.com/letti/yves/91",
    "company_name": "Carpanese",
    "original_category": "LETTI",
    "price": 18812,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Reflex S & M": {
    "description": "עוצב על ידי Carpanese Home, המראה Reflex מורכב מהמון מראות עגולות קטנות בגדלים שונים המוגדרות על ידי פרופיל דק ממתכת צבועה. כמו משחק תוסס של בועות שעולות במהירות לשמיים, Reflex - זמין בשני פורמטים, M ו-S - מקשט ומאפיין, ומעניק את העיקול הנכון לחללים שונים בבית.\nמראות עם פנלים מעץ סיבי, מבנה ממתכת צבועה.",
    "image_url": "../upload_images/Carpanese/ACCESSORI/Reflex S & M/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/ACCESSORI/Reflex S & M/1.jpg",
      "../upload_images/Carpanese/ACCESSORI/Reflex S & M/2.jpg",
      "../upload_images/Carpanese/ACCESSORI/Reflex S & M/3.jpg",
      "../upload_images/Carpanese/ACCESSORI/Reflex S & M/4.jpg",
      "../upload_images/Carpanese/ACCESSORI/Reflex S & M/5.jpg",
      "../upload_images/Carpanese/ACCESSORI/Reflex S & M/6.jpg"
    ],
    "product_url": "https://carpanesehome.com/accessori/reflex/94",
    "company_name": "Carpanese",
    "original_category": "ACCESSORI",
    "price": 26936,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Shine": {
    "description": "המראה Shine, עשויה כולה מעץ מלא, היא דוגמא מושלמת לאומנות הנגרות. המראה שעוצבה על ידי מתאו זורזנוני עבור Carpanese Home, מאופיינת בפרופיל מעגלי שעוטף את המראה והופך בחלקו התחתון למדף קטן. פרט פונקציונלי שהופך למאפיין אסתטי.\nמראה, מבנה עץ עשויה מעץ אפר ודיקט צפצפה.",
    "image_url": "../upload_images/Carpanese/ACCESSORI/Shine/main.jpg",
    "image_urls": [
      "../upload_images/Carpanese/ACCESSORI/Shine/1.jpg",
      "../upload_images/Carpanese/ACCESSORI/Shine/2.jpg",
      "../upload_images/Carpanese/ACCESSORI/Shine/3.jpg",
      "../upload_images/Carpanese/ACCESSORI/Shine/4.jpg",
      "../upload_images/Carpanese/ACCESSORI/Shine/5.jpg",
      "../upload_images/Carpanese/ACCESSORI/Shine/6.jpg",
      "../upload_images/Carpanese/ACCESSORI/Shine/7.jpg"
    ],
    "product_url": "https://carpanesehome.com/accessori/shine/93",
    "company_name": "Carpanese",
    "original_category": "ACCESSORI",
    "price": 15071,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Alexander Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Alexander Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/alexander-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/18.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/17.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/16.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/15.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/14.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/13.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/12.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/11.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/10.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/9.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/8.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/7.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/19.png",
      "../upload_images/Domkapa/Armchairs/Alexander Armchair/20.png"
    ],
    "description": "Alexander היא פתרון חדשני ביותר הקשור לצורה פונקציונלית ומסורתית למדי. מבנה עוצמתי ומחבק שבו גב גבוה מתחבר בחלקלקות למושב ומסתיים בבסיס מסתובב. הידיות ומשענות הגב ביצירה זו מתעקמות קלות כלפי חוץ, מזמינות את כולם לשבת. הדגש פה הוא על התמיכה הנוספת בגב, שמוחזקת על ידי משקל נגד מתכתי מפואר הניתן לכוונון גובה ולייצור בגימור שונה.\nהכורסה הנצחית הזו מתאימה בצורה מושלמת את החומרים שלה ליצירה יחידה במינה, במיוחד כאשר היא מוצגת בתפרי קרוס-תפרים.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 11869,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Alice Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Alice Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/product/alice-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Alice Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/9.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/8.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/7.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Alice Armchair/10.png"
    ],
    "description": "עיצוב שנבנה לנוחות במרחבים מסחריים, אליס היא כורסא קומפקטית ועגולה שמתאימה לכל חדר. המאפיין שלה הוא סיבוב הבסיס האחורי שתמיד חוזר לנקודת ההתחלה שלו, כדי לשמור על המיקום הנכון לאחר השימוש. פריט זה משודרג על ידי עבודה תפורה מהמעלה הראשונה שמעריכה את הפרטים הקטנים, במיוחד התפר האופקי על הגב שמתיישב באופן מושלם עם גובה המושב.\nתשומת הלב לפרטים, הגודל והנוחות הופכים את אליס לכורסא האולטימטיבית לפרויקטים מסחריים.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 16014,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Edison Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Edison Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/edison-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Edison Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Edison Armchair/7.jpg",
      "../upload_images/Domkapa/Armchairs/Edison Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Edison Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Edison Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Edison Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Edison Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Edison Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Edison Armchair/8.png"
    ],
    "description": "כורסא זו היא התגלמות הנוחות והסגנון המשולבים. הן הגב והן המושב מציגים עקומה קלה כדי להעלות את רמת הנוחות שלך בעת הישיבה על כורסת Edison. המבנה בעל ארבעת הרגליים מפלדה בטקסטורת שחור תומך במושב המרופד, ליצירה פשוטה אך מושכת שתשדרג את היופי של כל פרויקט עיצובי.\nכורסא Edison מתאימה לשימוש במגורים ובפרויקטים חוזיים וניתנת להתאמה אישית בכל אלמנט.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 25880,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Elba Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Elba Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchair/elba-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Elba Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/11.png",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/9.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/8.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/7.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Elba Armchair/10.png"
    ],
    "description": "איזו כורסה עם עיצוב על-זמני היא האלבה! בצורה אגסית, פריט זה חושף קווים נדיבים ומראה חלק. המושב כולל כרית ריפוד נוספת כמו גם משענת הגב. שתי הכריות הללו מספקות נוחות מרבית. לכורסת האלבה יש תכונה מדהימה: לא רק שהבסיס המשולש עשוי ביד מפלדת אל-חלד, אלא הוא גם מסתובב, כך שניתן למקם את הכורסה לכיוון הרצוי ולהסתובב בזווית של 360 מעלות.\nאתם יכולים להתאים לכורסה זו את הדום האלבה, מהאוסף אותו, לנוחות ותמיכה נוספים.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 11863,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Eva Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Eva Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/eva-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Eva Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Eva Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Eva Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Eva Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Eva Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Eva Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Eva Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Eva Armchair/7.png"
    ],
    "description": "Eva היא מחווה לטכניקות הייצור המסורתיות של פורטוגל. המבנה העשוי עץ כולל חלק אחורי וצדי של רטן, מושלם להוסיף נגיעה של בוהו-שיק לפרויקט העיצוב שלך. על מנת להעצים את היופי והנוחות של הכורסה, שני כריות מרופדות ממוקמות על המושב והגב של הכורסה.\nניתן לשלב את כורסה Eva עם פריטים שונים מאותה קולקציה, כמו כיסאות וכיסאות בר/דלפק.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 10767,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Hubert Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Hubert Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/hubert-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/18.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/17.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/14.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/13.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/12.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/11.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/10.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/9.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/8.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/7.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/15.png",
      "../upload_images/Domkapa/Armchairs/Hubert Armchair/16.png"
    ],
    "description": "איזו יצירת אמנות מופלאה היא כורסה Hubert. פריט מורכב עם תשומת לב לפרטים המשלב קווים רכים עם הקשיחות של המבנה המתכתי. משענת הגב מחולקת על ידי טכניקת תפירה עדינה לשלושה חלקים שונים, כולם מרופדים בנוצות וקצף רך במיוחד, מה שהופך אותה לפריט נוח במיוחד. כורסה Hubert מובלטת על ידי צורה ארגונומית, עם גימור עדין של פסי תפירה לאורך משענת הגב. \nזה יהיה הפריט הבולט בפרויקט העיצוב הפנים שלך.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 28797,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Juliet Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Juliet Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/juliet-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/7.jpg",
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Juliet Armchair/8.png"
    ],
    "description": "מושלמת לפרויקטים עכשוויים, ג'ולייט היא כורסה עגולה עם עקומות ופרופורציות רכות. המבנה הפלדה מספק נופח קשיח יותר, בעוד המושב המרופד הנוח מאזן את החלק ומעניק תוצאה של איכות ונוחות גבוהה. כורסה זו מתאפיינת בעיקול עדין שמודגש בטכניקות תפירה אלגנטיות. כורסה ג'ולייט ניתנת לשילוב עם הספה מאותה קולקציה ולהתאמה אישית במידות, חומרים וגימורים.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 21259,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Legacy Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Legacy Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/legacy-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/7.jpg",
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Legacy Armchair/8.png"
    ],
    "description": "כיסא כורסה מהמם זה הוא תוצאה של פתרונות חדשניים המחוברים לצורות פונקציונליות ונעימות, המתמזגים בעבודת אומנות הרמונית. ללא משענות יד, הגב הרחב מתמזג בצורה חלקה אל תוך המבנה. על הגב, קו מינימליסטי תפור מלמעלה למטה, המעצים את היופי של העיצוב הפשוט.\nLegacy הוא כיסא כורסה מזמין, מרופד במלואו וניתן להתאמה אישית, המבטיח להשלים את הטעם המשובח שלכם.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 21132,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Megan Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Megan Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/megan-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Megan Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Megan Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Megan Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Megan Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Megan Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Megan Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Megan Armchair/1.jpg",
      "../upload_images/Domkapa/Armchairs/Megan Armchair/7.png"
    ],
    "description": "בסגנון מינימליסטי ומובחן, כורסאת Megan היא עיצוב נצחי שמעולם אינו יוצא מהאופנה. זהו אלמנט אסתטי כמו גם פתרון פרקטי לצרכי חיי היומיום שלך. עם מבנה עשוי עץ, הגב הקמור העמוק זורם לתוך משענות היד בעיצוב מלאכת יד הרמוני. היא כוללת גם שתי תפרים יחידים עליונים לנוחות נוספת.\nכורסאת Megan, בהגדרתה על ידי קווים עוטפים ועקומות רכות, היא הבחירה המועדפת למקומות מגורים ולמקומות ציבוריים כאחד.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 12269,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Ruth Armchair": {
    "image_url": "../upload_images/Domkapa/Armchairs/Ruth Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/ruth-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Armchairs/Ruth Armchair/main.jpg",
      "../upload_images/Domkapa/Armchairs/Ruth Armchair/6.jpg",
      "../upload_images/Domkapa/Armchairs/Ruth Armchair/5.jpg",
      "../upload_images/Domkapa/Armchairs/Ruth Armchair/4.jpg",
      "../upload_images/Domkapa/Armchairs/Ruth Armchair/3.jpg",
      "../upload_images/Domkapa/Armchairs/Ruth Armchair/2.jpg",
      "../upload_images/Domkapa/Armchairs/Ruth Armchair/1.jpg"
    ],
    "description": "רות' היא שילוב הרמוני של גימורים שונים שנוצרו כמושב אידיאלי הן לפרויקטים למגורים והן לפרויקטים ציבוריים. המשענת והמושב זורמים ללא הפסקה אל משענת היד ליצירת רגעים של רגיעה מרבית. בסיס העץ, שניתן להתאמה אישית לגימורים מתכתיים, משלב אלגנטיות ונוחות. ישנם שני קווים תפורים לרוחב המשענת עבור עמידות גבוהה ועיצוב דקיק.  \nניתן לשלב פריט זה עם כיסא האוכל רות' במושגים של חלל פתוח ופרויקטים בעיצוב עכשווי.",
    "company_name": "Domkapa",
    "original_category": "Armchairs",
    "price": 12695,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Aniston Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Aniston Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/aniston-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Aniston Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/16.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/15.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/14.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/13.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/12.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/17.png",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/18.png",
      "../upload_images/Domkapa/Sofas/Aniston Sofa/19.png"
    ],
    "description": "ספת Aniston היא רהיט בעיצוב מודרני שבו קווים מלבניים מתמזגים בהרמוניה עם זוויות נועזות. נתמכת על ידי מספר רגלי טרפז מפלדת אל חלד, שתי המשענות רחבות ומרופדות לנוחות נוספת. לאורך הגב, כריות מרופדות מתחברות יחד ליצירת פיסת ישיבה מושלמת המזמינה אותך לחוות רגעי אושר.\nזמינה בגרסת שתי מושבים, שלושה מושבים וגרסת שזלונג, פיסת ריהוט זו היא התוספת המושלמת לכל סלון.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 12391,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Beaumont Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Beaumont Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/beaumont-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/13.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/12.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/14.png",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/15.png",
      "../upload_images/Domkapa/Sofas/Beaumont Sofa/16.png"
    ],
    "description": "ספת Beaumont חוקרת את היופי שבפשטות המשתלבת עם הפונקציונליות במערכת הפתיחה החד-תנועתית שלה. העיצוב המכני החדשני הזה מפנה מקום למיטה מזמינה, ומבטיח חווית נוחות אולטימטיבית שמעולם לא ידעת שאתה זקוק לה. המוצר מיוצר מחומרים באיכות גבוהה ובטכניקות תפירה מהטובות ביותר, וזמין בשלושה מידות שונות, משלבים בין ספה מסורתית למיטה מודרנית מבלי להתפשר על העיצוב.\nספת Beaumont ועיצובה הייחודי הופכים אותה ליצירה אידיאלית לכל חלל מגורים.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 26547,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Chloe Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Chloe Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/chloe-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Chloe Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/12.png",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/13.png",
      "../upload_images/Domkapa/Sofas/Chloe Sofa/14.png"
    ],
    "description": "Chloe היא יצירת עיצוב יוצאת דופן עם איזון אסתטי מרשים וחומרים מעודנים. זמינה בגרסאות דו-מושב, תלת-מושב וצ'ייס-לונג, היא כוללת בסיס מעץ או מתכת ומושב ומשענת מרופדים שיכולים לשדרג כל חדר. קו תפר מחלק את המוצר להרכבה והובלה קלים בעוד שתפר עליון כפול מעניק למוצר נגיעה יוקרתית.\nהקימורים הרכים נשמרים בכל אלמנט של ספת Chloe, מה שהופך אותה ליצירת הצהרה בכל פרויקט.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 20511,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Disruption Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Disruption Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/disruption-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Disruption Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/23.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/22.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/21.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/20.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/19.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/18.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/17.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/16.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/15.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/14.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/13.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/12.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/24.png",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/25.png",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/26.png",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/27.png",
      "../upload_images/Domkapa/Sofas/Disruption Sofa/28.png"
    ],
    "description": "Disruption היא ספה מודולרית, מרופדת כולה, עם עיצוב מינימליסטי ופרופורציות ארגונומיות. מערכת זו כוללת ספות במגוון גדלים, מפוף עד שזלונג, שניתן לשלב ליצירת פתרונות שונים. המושב הוא כרית גבוהה וניתן להוסיף גם משענות יד על ידי בחירה בגרסת הכורסה.  \nמעוגלת ומתוחכמת, ספת Disruption יוצרת חללים נעימים עם קווים מפתים.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 24398,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Edward Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Edward Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/edward-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Edward Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/68.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/67.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/66.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/65.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/64.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/63.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/62.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/61.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/60.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/59.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/58.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/57.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/56.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/55.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/54.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/53.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/52.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/51.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/50.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/49.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/48.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/47.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/46.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/45.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/44.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/43.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/42.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/41.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/40.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/39.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/38.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/37.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/36.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/35.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/34.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/33.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/32.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/31.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/30.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/29.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/28.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/27.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/26.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/25.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/24.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/23.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/22.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/21.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/20.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/19.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/18.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/17.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/16.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/15.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/14.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/13.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/12.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Edward Sofa/69.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/70.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/71.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/72.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/73.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/74.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/75.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/76.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/77.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/78.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/79.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/80.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/81.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/82.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/83.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/84.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/85.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/86.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/87.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/88.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/89.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/90.png",
      "../upload_images/Domkapa/Sofas/Edward Sofa/91.png"
    ],
    "description": "ספת Edward שואבת השראה מהשאיפה להתנתק מחיי הקוסמופוליטיות. הספה הזו מגלמת מערכת מודולרית עם מגוון רחב של אלמנטים, שמאפשרת לכם לשחק עם תצורות ולבנות ספה לפי טעמכם, מבלי לוותר לעולם על נוחות. העיצוב המינימליסטי הזה עם הפרופורציות הנדיבות יש לו אופי ייחודי בזכות הרב-שימושיות שלו, במיוחד בשילוב עם אביזרים שונים, כגון מתקן למגזינים, משענת ראש ושולחן צד.\nבהענקת גמישות קומפוזיציונית מרבית, ספת Edward מאפשרת לכם לשחק עם מבחר רחב של מודולים לתוצאות בלתי מוגבלות.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 19181,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Juliet Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Juliet Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/juliet-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Juliet Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Juliet Sofa/9.png"
    ],
    "description": "בהשראת תפיסת האלגנטיות, הנוחות והאינטימיות, ספת ג'ולייט היא רהיט מעוגל הנתמך בארבע רגלי פלדה וצינורות. מאופיינת בעיקולים רכים ופרופורציות מאוזנות, משענת הגב מתרחבת לצידי הספה ויוצרת משענות יד עדינות ואלגנטיות. גולת הכותרת של רהיט זה מתבטאת במדרונות המרופדים בקפידה, המודגשים באמצעות רצועות אופקיות של תפרי הוט-קוטור.\nספה זו מזמינה ומציעה נוחות אינסופית והיא מרשימה במיוחד בצבע עור בורדו. מושלמת לפרויקטים עכשוויים.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 27814,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Matthew Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Matthew Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/matthew-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Matthew Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/19.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/18.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/17.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/16.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/15.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/14.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/13.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/12.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/20.png",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/21.png",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/22.png",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/23.png",
      "../upload_images/Domkapa/Sofas/Matthew Sofa/24.png"
    ],
    "description": "ספה מינימליסטית אך מובחנת היא הדרך הטובה ביותר לתאר את ספת Matthew. עם עבודת תפרים שמחברת בין כל מרכיב של היצירה הזו, ספת Matthew זמינה במידות ותצורות שונות, כולל גרסה עם שזלונג ואפילו אפשרות לכורסה. גולת הכותרת של ספת Matthew היא המנגנון השקט המשולב שמאפשר לך לקפל את מסעדי הידיים ואת משענת הגב בזווית הנוחה ביותר עבורך. עם רגליים ממתכת פשוטות, ספת Matthew היא עיצוב חדשני שישדרג את פרויקט העיצוב שלך.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 22935,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Olivia Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Olivia Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/olivia-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Olivia Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/17.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/16.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/15.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/14.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/13.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/12.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/18.png",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/19.png",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/20.png",
      "../upload_images/Domkapa/Sofas/Olivia Sofa/21.png"
    ],
    "description": "אוליביה היא התוספת החדשה לאוסף הספות המודולריות של Domkapa. הספה המודולרית כוללת ארבעה מודולים מובחנים, והיא בולטת מכמה סיבות. ראשית, אוליביה מרופדת כולה, כולל רגליה, בהתאמה לריפוד המושב והגב. בנוסף, רוב המודולים מציגים גב קמור, שהוא אידיאלי למקומות בעייתיים מבחינה ארגונומית. בתור ספה מודולרית, אוליביה מאפשרת לך להגדיר וליצור תצורות שונות.\nפתרון מקיף, מעוגל ונוח לפרויקט שלך.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 27251,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Parker Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Parker Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/parker-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Parker Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Parker Sofa/12.png",
      "../upload_images/Domkapa/Sofas/Parker Sofa/13.png",
      "../upload_images/Domkapa/Sofas/Parker Sofa/14.png"
    ],
    "description": "התוספת החדשה ביותר לאוסף הספות של Domkapa, ספת Parker משדרת אסתטיקה פשוטה המשלבת פרופורציות נדיבות ומזמינות. נחה על רגליים דקות מעץ או מתכת, משענת היד הרחבה מספקת נוחות מירבית בשילוב עם הכריות הכפולות המרופדות במלואן בגב. לגב ולמושב של הספה הזו יש מכנה משותף אחד: קווים אנכיים גיאומטריים ואלגנטיים שמאריכים את העיצוב ליצירת פריט עכשווי.\n\nמתאימה לפרויקטים למגורים ולחוזים, ספת Parker יכולה להתאים לצרכים של סגנונות ודרישות רבות.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 18086,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Shinto Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Shinto Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/shinto-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Shinto Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/17.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/16.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/15.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/14.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/13.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/12.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/11.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/10.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/18.png",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/19.png",
      "../upload_images/Domkapa/Sofas/Shinto Sofa/20.png"
    ],
    "description": "שינטו היא מערכת ספה מודולרית מהממת שתשנה את פרויקט העיצוב שלך. אתם יכולים לבחור את השילוב שאתם רוצים מתוך שלושה עיצובים מודולריים שונים: כורסה, כורסה עם שאז לונג, ופוף. בגב כל מודול, שתי מוטות פלדה שחורות במרקם מחליקות לתחתית הספה, עם פרטי נירוסטה מוזהבים עדינים.\nתפרים חלקים זורמים על פני הספה הזו ומשלימים עיצוב אקסקלוסיבי עם שימושיות גבוהה ונוחות מירבית.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 16177,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Stella Sofa": {
    "image_url": "../upload_images/Domkapa/Sofas/Stella Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/stella-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Sofas/Stella Sofa/main.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/9.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/8.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/7.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/6.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/5.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/4.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/3.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/2.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/1.jpg",
      "../upload_images/Domkapa/Sofas/Stella Sofa/10.png"
    ],
    "description": "עיצוב בלעדי לעיטורים הייחודיים ביותר! ספת Stella היא ספה מעוקלת עם גב קעור עמוק. מתנשאת על בסיס עץ, חתיכה זו מציגה צנרת עדינה מלמעלה ועד לתחתית הגב ליצירת אשליה מוגברת. עיצוב זה מאפשר לכם לארח את האורחים שלכם גם אם יש לכם מקום קטן.\nקווים עוטפים ופרופורציות נדיבות מאפיינים את ספת Stella מבלי לוותר על הפונקציה הארגונומית.",
    "company_name": "Domkapa",
    "original_category": "Sofas",
    "price": 27955,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Anna Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Anna Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/anna-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Anna Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/20.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/19.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/18.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/17.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/16.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/15.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/14.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/13.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/12.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/11.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/10.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Anna Chair/21.png",
      "../upload_images/Domkapa/Chairs/Anna Chair/22.png",
      "../upload_images/Domkapa/Chairs/Anna Chair/23.png",
      "../upload_images/Domkapa/Chairs/Anna Chair/24.png"
    ],
    "description": "חברה: דומקאפה, מוצר: כיסא אנה. תיאור המוצר: עיצוב הכיסא האלגנטי הזה הוא תוצאה של תהליך בגרות ומודעות שנלווה בהשראת רעיונות וחוויות שונים. הכיסא זמין בארבע גרסאות שונות, וכולל שתי אפשרויות להתאמה אישית של משענות הידיים (עם או בלי משענת יד) וכן שתי אפשרויות התאמה אישית של הבסיס (ארבע רגליים או בסיס סגדוך). בהתייחס לבסיס, ניתן לבחור בין גימור עץ לגימור מתכתי. במקביל, ניתן להתאים אישית גם את המושב והמשענת המרופדים עם בדים מנוגדים.\nכיסא אנה הוא מגרש משחקים למקצוענים, המאפשר אינספור אפשרויות התאמה אישית לתוצאות בלתי מוגבלות.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 15975,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Carter Bar & Counter Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/main.jpg",
    "product_url": "https://domkapa.com/en/bar-counter-chairs/carter-bar-counter-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/10.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/11.png",
      "../upload_images/Domkapa/Chairs/Carter Bar & Counter Chair/12.png"
    ],
    "description": "כיסא בר ודלפק קרטר מבטא תכונה אמיתית של עיצוב עכשווי, המשולבת עם מהות הקווים המסורתיים, אשר יחדיו יבטיחו אלגנטיות ומתוחכמות. כיסא מרופד זה כולל תפר כפול המפצל את גבו למראה על-זמני בעוד שמבנה העץ המלא שלו מעניק תחושה יוקרתית, מושלמת לחללים מגורים או מסחריים.\nזמין בגרסת כיסא, קרטר הוא פריט מובחן להופעה קלאסית ורב-שימושית.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 28212,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Carter Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Carter Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/carter-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Carter Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Carter Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Carter Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Carter Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Carter Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Carter Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Carter Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Carter Chair/1.jpg"
    ],
    "description": "כיסא Carter הוא השילוב המושלם בין קווים מסורתיים ועכשוויים, עובי ועדינות. כיסא זה מתאפיין בכרית מושב מוצקה ונוחה שמתפרשת על מבנה עץ מלא. לאורך כל הכיסא המרופד תפירה כפולה המפרידה את גב הכיסא למראה על-זמני.\nכיסא אוכל רב תפקודי עם קווים ותפירה ייחודיים, אידיאלי לבתים וקהילות.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 12421,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Eva Bar & Counter Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/main.jpg",
    "product_url": "https://domkapa.com/en/bar-counter-chairs/eva-bar-counter-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/11.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/10.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/12.png",
      "../upload_images/Domkapa/Chairs/Eva Bar & Counter Chair/13.png"
    ],
    "description": "בנוי להחזיק זמן רב, המבנה מעץ מלא של כסאות הבר והדלפק Eva הוא תערובת מושלמת של עיצוב עכשווי וניחוח וינטג'. טכניקת האריגה המפורטת על הגב מבטיחה לבלוט בכל חדר כפי שהיא ייחודית. המושב המרופד מבטיח חווית ישיבה נוחה בעוד הקווים העדינים והרכים מבטיחים שעיצוב זה יתאים לכל סביבה.\nEva זמינה גם ככיסא כך שניתן להוסיף את הטוויסט המיוחד שלה למקומות נוספים בבית.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 26474,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Eva Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Eva Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/eva-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Eva Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/12.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/11.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/10.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Eva Chair/13.png",
      "../upload_images/Domkapa/Chairs/Eva Chair/14.png"
    ],
    "description": "Eva היא השילוב המושלם בין עיצוב עכשווי לטכניקות יצור עתיקות, חרוטה על גבה וצדדיה של היצירה. זהו כיסא רב-תכליתי שיכול לבלוט בכל חדר בזכות קווים רכים וחוויית ישיבה נוחה המסופקת על ידי טקסטיל פרימיום היישומים. זהו עיצוב ייחודי אך פשוט שיעניק אופי מיוחד לכל חדר.\nEva זמינה גם עם משענת יד וכן ככיסא בר ודלפק וככיסא עם משענות ידיים, המציעה אפשרויות רבות לשלב בפרויקט העיצוב שלך.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 11943,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Frank Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Frank Chair/main.jpg",
    "product_url": "https://domkapa.com/en/product/frank-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Frank Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Frank Chair/9.png"
    ],
    "description": "מותאם בצורה מושלמת לפרויקטים מסחריים ובתחום האירוח, כיסא Frank הוא עיצוב פשוט וקל שמעצים את הפרויקט העיצובי שלכם. בשורות ישרות, היצירה הזו מציגה פרטי תפירה מוצלבים דיסקרטיים אך אלגנטיים על גב המושב, שמקשטים ומעשירים לא רק את היצירה אלא גם את כל האווירה שהיא מוכנסת לתוכה.\nבנוסף לכל, רגלי העץ המלאות והמסגרת מספקות את הרצינות הנדרשת.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 20014,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Gram Bar & Counter Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/main.jpg",
    "product_url": "https://domkapa.com/en/counter-bar-chairs/gram-counter-bar-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/10.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/11.png",
      "../upload_images/Domkapa/Chairs/Gram Bar & Counter Chair/12.png"
    ],
    "description": "הצורות הגאומטריות והבלתי צפויות של Gram הן האפשרות המושכת את העין המושלמת עבור כל פרויקט מתוחכם. כיסאות הבר והדלפק מספקים חוויה מאופקת ונוחה במיוחד, שכן המבנה המתכתי המותאם עם הגב והמושב המרופד יבטיח שהצורות הגאומטריות יתאימו לכל סביבה.\n\nאותו עיצוב מושך ניתן למצוא גם בגרסת כסא כך שכל חדר יכול לקבל נגיעה מיוחדת.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 18426,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Gram Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Gram Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/gram-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Gram Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Gram Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Gram Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Gram Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Gram Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Gram Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Gram Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Gram Chair/7.png"
    ],
    "description": "כיסא בולט לעין המאופיין בצורות גיאומטריות שנוצרו מחומרים וגימורים מעולים. הכיסא Gram מציג מבנה מתכת שמעניק יציבות ונוחות. כדי להבטיח חוויית ישיבה נעימה, משענת גב ומושב מרופדים קיימים, והם ניתנים להתאמה אישית בחומרים וגימורים שיתאימו לפרויקט מגורים או עסקי שלכם. \nאותו עיצוב מושך של כיסא Gram זמין גם בגרסאות כיסא בר ודלפק, כך שתוכלו לשלב אותם יחד.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 25063,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Jermain Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Jermain Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/jermain-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Jermain Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/13.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/12.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/11.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/10.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Jermain Chair/14.png",
      "../upload_images/Domkapa/Chairs/Jermain Chair/15.png"
    ],
    "description": "ג'רמין הוא הכיסא האולטימטיבי רב-השימושים. ניתן להתאים את הבסיס לשתי אפשרויות נפרדות: בסיס מעץ או בסיס מתכתי. הבסיס מעץ מציג ארבע רגליים עם חיתוך זוויתי לעיצוב אדריכלי. האפשרות המתכתית כוללת ארבע רגליות מתכתיות בצורת כוכב עם מערכת סיבוב, מה שהופך אותה למושלמת לאווירת משרד. לג'רמין גב קמור שמתארך למשענת יד דיסקרטית עם כיפוף קל לפתיחה לנוחות מרבית. כמו כן, פתיחה אלגנטית בגב מוסיפה נופך של סגנון עכשווי.\nיצירה זו היא עיצוב יוצא דופן ועל-זמני, תוצאה של תהליך ייצור מפורט.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 21084,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Louise Bar & Counter Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/main.jpg",
    "product_url": "https://domkapa.com/en/bar-counter-chairs/louise-bar-counter-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/11.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/10.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/12.png",
      "../upload_images/Domkapa/Chairs/Louise Bar & Counter Chair/13.png"
    ],
    "description": "העיצוב החסון של כיסא Louise משרה ביטחון ואופי, משולב עם קווים פשוטים אך מצהיר באומץ על נוחות. המשענת והמושב מרופדים במלואם לחוויה מרגיעה בעוד שרגלי העץ משלימות את תחכום העיצוב. המשענת המעוגלת קלות תבטיח חוויה נעימה עם עיצוב נועז הכולל נעצים מוזהבים.\nהקווים הפשוטים אך המתוחכמים שלו מתאימים לכל עיצוב ומשדרגים את החלל.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 28394,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Louise Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Louise Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/louise-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Louise Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Louise Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Louise Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Louise Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Louise Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Louise Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Louise Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Louise Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Louise Chair/8.png"
    ],
    "description": "כיסא לואיז ןשל חברת Domkapa בעל עיצוב חסון המקרין ביטחון ואופיין יחד עם קווים פשוטים אך מספק הצהרה חזקה של נוחות. המשענת והכיסא מרופדים לגמרי כדי לספק חווית ישיבה מרגיעה בזמן שרגלי העץ משלימים את האקסקלוסיביות של העיצוב. הגב המעוקל במעט יבטיח חווית ישיבה נעימה עם עיצוב נועז הכולל ציפורני זהב.\nקווים פשוטים אך מתוחכמים אלו מתאימים לכל עיצוב פנים ומעצימים את החדר.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 22002,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Norah Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Norah Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/norah-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Norah Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Norah Chair/10.png"
    ],
    "description": "כיסא Norah הוא עיצוב נוסף של חברת Domkapa שיעלה את רמת האזור שלכם בחדר האוכל. הכיסא כולל מסגרת עץ מוצקה עם ארבע רגליים, כמו גם פרט קלאסי מעץ ופרט עדין של קפלים אנכיים במשענת הגב. פריט זה מעודד שימוש בבדים מנוגדים למושב ולמשענת הגב, מה שמאפשר לכם לשחק עם סוגים שונים של חומרים, כגון קטיפה ועור טבעי.\nכיסא Norah מציג פרופורציה וצורה פשוטות אך מאוזנות, עם נוחות מירבית.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 10425,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Ruth Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Ruth Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/ruth-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Ruth Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Ruth Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Ruth Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Ruth Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Ruth Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Ruth Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Ruth Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Ruth Chair/1.jpg"
    ],
    "description": "בהשראת מושגי החן, הנוחות והתחכום, כיסא רות מתאפיין בצורות רכות ועיצוב אלגנטי. מסגרת העץ והקווים הנקיים משתלבים עם משענת הגב הארגונומית והקמורה, שמכוסה בבדים או עור מהאוסף הרחב של Domkapa. בחלק הפנימי של הגב, שני תפרים מתחברים בצורה מעודנת לכרית המושב, המדמים את הצללית היפהפייה של גוף האדם.  \nרות הוא דוגמה מושלמת ל\"פחות זה יותר\", תוך שימת דגש לפרטים ויצירת קלאסיקה נצחית.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 18385,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Vianna Chair": {
    "image_url": "../upload_images/Domkapa/Chairs/Vianna Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/vianna-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Chairs/Vianna Chair/main.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/9.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/8.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/7.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/6.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/5.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/4.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/3.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/2.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/1.jpg",
      "../upload_images/Domkapa/Chairs/Vianna Chair/10.png",
      "../upload_images/Domkapa/Chairs/Vianna Chair/11.png"
    ],
    "description": "מופת של נוחות, התיאור הטוב ביותר לכיסא Vianna. נתמך על ידי ארבע רגלי עץ, מושב וכרית גב מרופדים יוצרים את האביזר המושלם הן לבתים והן למקומות ציבוריים. זמין בשתי גרסאות, עם או בלי משענות ידיים, החלק העליון של משענת הגב מתעקל החוצה לנוחות מרבית. לאורך הקצוות, גימור עדין ומרשים מוסיף נגיעה על-זמנית לעיצוב.  \nכיסא Vianna הוא עיצוב קלאסי עם טוויסט מודרני, מה שהופך אותו לבחירה מצוינת לכל פרויקט עיצוב.",
    "company_name": "Domkapa",
    "original_category": "Chairs",
    "price": 13857,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Amanda Bed": {
    "image_url": "../upload_images/Domkapa/Beds/Amanda Bed/main.jpg",
    "product_url": "https://domkapa.com/en/beds/amanda-bed/",
    "image_urls": [
      "../upload_images/Domkapa/Beds/Amanda Bed/main.jpg",
      "../upload_images/Domkapa/Beds/Amanda Bed/6.jpg",
      "../upload_images/Domkapa/Beds/Amanda Bed/5.jpg",
      "../upload_images/Domkapa/Beds/Amanda Bed/4.jpg",
      "../upload_images/Domkapa/Beds/Amanda Bed/3.jpg",
      "../upload_images/Domkapa/Beds/Amanda Bed/2.jpg",
      "../upload_images/Domkapa/Beds/Amanda Bed/1.jpg",
      "../upload_images/Domkapa/Beds/Amanda Bed/7.png",
      "../upload_images/Domkapa/Beds/Amanda Bed/8.png",
      "../upload_images/Domkapa/Beds/Amanda Bed/9.png",
      "../upload_images/Domkapa/Beds/Amanda Bed/10.png",
      "../upload_images/Domkapa/Beds/Amanda Bed/11.png"
    ],
    "description": "עיצוב יוצא דופן בהשראת עיצוב עכשווי שאנו כולנו אוהבים. מיטת אמנדה מוגבהת מהרצפה ומתאפיינת בראש מיטה מרופד ורחב עם תפירה כפולה אנכית ושולחנות צד מעץ משולבים בשני הצדדים. ראש המיטה ניתן לריפוד בשני בדים שונים, מה שמעניק ליחידה זו אישיות ייחודית לחדרי שינה מהמשובחים ביותר.\nזמינה במגוון גדלים וניתנת להתאמה אישית בכל חומר, מיטת אמנדה היא העיצוב המיוחד שהפרויקט שלכם צריך.",
    "company_name": "Domkapa",
    "original_category": "Beds",
    "price": 20655,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Echo Bed": {
    "image_url": "../upload_images/Domkapa/Beds/Echo Bed/main.jpg",
    "product_url": "https://domkapa.com/en/beds/echo-bed/",
    "image_urls": [
      "../upload_images/Domkapa/Beds/Echo Bed/main.jpg",
      "../upload_images/Domkapa/Beds/Echo Bed/7.jpg",
      "../upload_images/Domkapa/Beds/Echo Bed/6.jpg",
      "../upload_images/Domkapa/Beds/Echo Bed/5.jpg",
      "../upload_images/Domkapa/Beds/Echo Bed/4.jpg",
      "../upload_images/Domkapa/Beds/Echo Bed/3.jpg",
      "../upload_images/Domkapa/Beds/Echo Bed/2.jpg",
      "../upload_images/Domkapa/Beds/Echo Bed/1.jpg",
      "../upload_images/Domkapa/Beds/Echo Bed/8.png",
      "../upload_images/Domkapa/Beds/Echo Bed/9.png",
      "../upload_images/Domkapa/Beds/Echo Bed/10.png",
      "../upload_images/Domkapa/Beds/Echo Bed/11.png",
      "../upload_images/Domkapa/Beds/Echo Bed/12.png"
    ],
    "description": "\n\nEcho היא המיטה האידאלית אם אתם מחפשים נוחות בשילוב עם תכונות ופרטים מרהיבים. ראש המיטה של Echo הוא אלגנטי ומרשים, מלא בקווים עוטפים המשדרים אסתטיקה מדהימה ותפירה עדינה. הוא כולל גם ראש מיטה ייחודי המקיף את המיטה, עם כנפיים אלגנטיות לרגעים של אינטימיות ומחסה. פרט נוסף שניתן למצוא הוא פסי הצנרת העדינים המקשטים את הריפוד.\n\nמיטת Echo זמינה במידות וחומרים שונים המבטיחים תחושות ייחודיות.",
    "company_name": "Domkapa",
    "original_category": "Beds",
    "price": 27067,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Kelsi Bed": {
    "image_url": "../upload_images/Domkapa/Beds/Kelsi Bed/main.jpg",
    "product_url": "https://domkapa.com/en/beds/kelsi-bed/",
    "image_urls": [
      "../upload_images/Domkapa/Beds/Kelsi Bed/main.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/8.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/7.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/6.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/5.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/4.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/3.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/2.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/1.jpg",
      "../upload_images/Domkapa/Beds/Kelsi Bed/9.png",
      "../upload_images/Domkapa/Beds/Kelsi Bed/10.png",
      "../upload_images/Domkapa/Beds/Kelsi Bed/11.png",
      "../upload_images/Domkapa/Beds/Kelsi Bed/12.png",
      "../upload_images/Domkapa/Beds/Kelsi Bed/13.png"
    ],
    "description": "קֶלסִי היא יצירה יוצאת דופן של עיצוב ועבודת יד, המשלבת טכניקות ייצור ייחודיות וחומרים עדינים ליצירת פריט נדיר. מִשׁעֶנֶת הַכְּנָפַיִם היא מוקד המיטה הזאת, עשירה בפרטים. היא כוללת שני כריות מרופדות גדולות לנוחות מקסימלית, הנתמכות על ידי שני צינורות מתכת מפוארים. יחד עם המבנה, תוכלו למצוא פרטים קטנים נוספים, תוצאה של אומנות בלעדית.\nמיטת קֶלסִי זמינה בשלושה גדלים שונים, וניתן להתאים אותה אישית בצורתה, בחומר ובגימור שלה כדי להשיג את התוצאה המושלמת לפרויקט העיצוב שלכם.",
    "company_name": "Domkapa",
    "original_category": "Beds",
    "price": 11665,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Margot Bed": {
    "image_url": "../upload_images/Domkapa/Beds/Margot Bed/main.jpg",
    "product_url": "https://domkapa.com/en/beds/margot-bed/",
    "image_urls": [
      "../upload_images/Domkapa/Beds/Margot Bed/main.jpg",
      "../upload_images/Domkapa/Beds/Margot Bed/7.jpg",
      "../upload_images/Domkapa/Beds/Margot Bed/6.jpg",
      "../upload_images/Domkapa/Beds/Margot Bed/5.jpg",
      "../upload_images/Domkapa/Beds/Margot Bed/4.jpg",
      "../upload_images/Domkapa/Beds/Margot Bed/3.jpg",
      "../upload_images/Domkapa/Beds/Margot Bed/2.jpg",
      "../upload_images/Domkapa/Beds/Margot Bed/1.jpg",
      "../upload_images/Domkapa/Beds/Margot Bed/8.png",
      "../upload_images/Domkapa/Beds/Margot Bed/9.png",
      "../upload_images/Domkapa/Beds/Margot Bed/10.png",
      "../upload_images/Domkapa/Beds/Margot Bed/11.png",
      "../upload_images/Domkapa/Beds/Margot Bed/12.png"
    ],
    "description": "מיטת מרגו היא פתרון חדשני במיוחד לחדר השינה, המקשר בין צורות פונקציונליות וחיוניות ויוצר רהיט מרופד ייחודי. הגב המיטה הרחב והמכיל, עם הקווים הרכים והפרטים האיכותיים, מחולק לשתי קבוצות מרופדות כדי לספק רגעי מנוחה הן בסביבות ביתיות והן במקומות ציבוריים. הצנרת המתכתית והרהיטים המרשימים משדרגים את יופיו של פריט זה מתוך קולקציית 2022 של Domkapa.  \nעם סגנון מינימלי ובולט, מיטת מרגו מבטיחה לחבק כל פרט בפרויקט שלכם ולהעצים אותם לעיצוב המושלם.",
    "company_name": "Domkapa",
    "original_category": "Beds",
    "price": 27835,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Shelby Bed": {
    "image_url": "../upload_images/Domkapa/Beds/Shelby Bed/main.jpg",
    "product_url": "https://domkapa.com/en/beds/shelby-bed/",
    "image_urls": [
      "../upload_images/Domkapa/Beds/Shelby Bed/main.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/8.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/7.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/6.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/5.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/4.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/3.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/2.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/1.jpg",
      "../upload_images/Domkapa/Beds/Shelby Bed/9.png",
      "../upload_images/Domkapa/Beds/Shelby Bed/10.png",
      "../upload_images/Domkapa/Beds/Shelby Bed/11.png",
      "../upload_images/Domkapa/Beds/Shelby Bed/12.png",
      "../upload_images/Domkapa/Beds/Shelby Bed/13.png"
    ],
    "description": "מיטת ה-Shelby הייחודית היא מיטה מתוחכמת בהשראת קווים גיאומטריים, זוויות וצורות שאנו כולנו אוהבים. המסגרת המרותקת וקוויה הנקיים משלימים את המבנה המרופד וקוויו, ומבטיחים יצירה נוחה ומתוחכמת. עם ראש המיטה שצר מעט בחלקו העליון, מיטה זו עוזרת ליצור אשליית מימד, מה שגורם לחדר שלכם להיראות גדול יותר.\nפריט פונקציונלי מאוד שמבטיח נוחות מושלמת תוך שמירה על פרויקט חדר השינה שלכם בהרמוניה ובסטייל.",
    "company_name": "Domkapa",
    "original_category": "Beds",
    "price": 22237,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Yumi Bed": {
    "image_url": "../upload_images/Domkapa/Beds/Yumi Bed/main.jpg",
    "product_url": "https://domkapa.com/en/beds/yumi-bed/",
    "image_urls": [
      "../upload_images/Domkapa/Beds/Yumi Bed/main.jpg",
      "../upload_images/Domkapa/Beds/Yumi Bed/7.jpg",
      "../upload_images/Domkapa/Beds/Yumi Bed/6.jpg",
      "../upload_images/Domkapa/Beds/Yumi Bed/5.jpg",
      "../upload_images/Domkapa/Beds/Yumi Bed/4.jpg",
      "../upload_images/Domkapa/Beds/Yumi Bed/3.jpg",
      "../upload_images/Domkapa/Beds/Yumi Bed/2.jpg",
      "../upload_images/Domkapa/Beds/Yumi Bed/1.jpg",
      "../upload_images/Domkapa/Beds/Yumi Bed/8.png",
      "../upload_images/Domkapa/Beds/Yumi Bed/9.png",
      "../upload_images/Domkapa/Beds/Yumi Bed/10.png",
      "../upload_images/Domkapa/Beds/Yumi Bed/11.png",
      "../upload_images/Domkapa/Beds/Yumi Bed/12.png"
    ],
    "description": "עיצוב מינימליסטי אך אלגנטי, עם צורה ופרופורציות קלאסיות, המעוטרות בקווים אופקיים שנתפרו על כל ראש המיטה המרופד. מוגבהת על ידי ארבע רגליים מעץ, מיטת Yumi מקבלת השראה מקונספט של אלגנטיות, נוחות וקווים מאוזנים. זמינה במגוון גדלים וניתנת להתאמה אישית בכל רכיב, היא מושלמת לרגעי מנוחה.\nעיצוב זה מתאים גם לפרויקטים של מגורים וגם לפרויקטים של בתי מלון, והוא בחירה מצוינת לכל סגנון עיצוב, בהתאם לחומרים שתבחרו.",
    "company_name": "Domkapa",
    "original_category": "Beds",
    "price": 26445,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Adley Pouf": {
    "image_url": "../upload_images/Domkapa/Poufs/Adley Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/adley-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Poufs/Adley Pouf/main.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/14.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/13.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/12.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/11.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/10.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/9.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/8.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/7.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/6.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/5.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/4.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/3.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/2.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/1.jpg",
      "../upload_images/Domkapa/Poufs/Adley Pouf/15.png",
      "../upload_images/Domkapa/Poufs/Adley Pouf/16.png"
    ],
    "description": "עם פרשנות מודרנית לצורות ודגמים מסורתיים מההיסטוריה, אדלי פותח את הדלת לעולם מלא משמעות, כמקום אחסון או אפילו כמושב נוסף. מערכת פתיחה קלה לתפעול משתלטת על השדה המודרני ומעניקה לו השפעה נוספת, ומאפשרת אחסון המתאים לכל סוג של מגורים.  \nהעיצוב הרב-תכליתי של אדלי זמין בשני גדלים ויביא פונקציונליות לכל סוג של חלל פנים.",
    "company_name": "Domkapa",
    "original_category": "Poufs",
    "price": 22800,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Angles Pouf": {
    "image_url": "../upload_images/Domkapa/Poufs/Angles Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/angles-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Poufs/Angles Pouf/main.jpg",
      "../upload_images/Domkapa/Poufs/Angles Pouf/6.jpg",
      "../upload_images/Domkapa/Poufs/Angles Pouf/5.jpg",
      "../upload_images/Domkapa/Poufs/Angles Pouf/4.jpg",
      "../upload_images/Domkapa/Poufs/Angles Pouf/3.jpg",
      "../upload_images/Domkapa/Poufs/Angles Pouf/2.jpg",
      "../upload_images/Domkapa/Poufs/Angles Pouf/1.jpg",
      "../upload_images/Domkapa/Poufs/Angles Pouf/7.png"
    ],
    "description": "שרפרף הזויות והצורה המיוחדת שלו הם הפריט הבולט שכל פרויקט חייב לכלול. העיצוב המרופד כולו והקפלים הייחודיים הם האופי של פריט מפואר זה שמבטיח להיות שובה עין וכיף לשלב אותו עם צורות אחרות. הפרטים יוצרים הצהרה באותה מידה כמו שרפרף זויות שמגלם יחד נוחות ונועזות בפריט אחד.\n\nהצורה המשעשעת של שרפרף זויות יכולה להשתלב עם כל פריט מרופד אחר.",
    "company_name": "Domkapa",
    "original_category": "Poufs",
    "price": 13902,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Avery Pouf": {
    "image_url": "../upload_images/Domkapa/Poufs/Avery Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/avery-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Poufs/Avery Pouf/main.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/8.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/7.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/6.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/5.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/4.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/3.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/2.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/1.jpg",
      "../upload_images/Domkapa/Poufs/Avery Pouf/9.png"
    ],
    "description": "הדום אייברי מתאפיין ברוח חמימה בזכות המרקמים הרכים והצורה העגולה שלו. עם מבנה מעט מוטה, החלק הבולט הזה משקף משחק של ניגודים בין מטרה לעיצוב, לחוויה מעודנת. בחלק העליון ניתן למצוא משטח חזק ומלוטש לשימוש כשולחן צד בשילוב עם מרחב אחסון, מה שמשלב פונקציונליות עם עיצוב פשוט וברור.\nהאייברי מעניק רוח לאווירה ייחודית, מזמין אתכם לשחק עם הפונקציות.",
    "company_name": "Domkapa",
    "original_category": "Poufs",
    "price": 13423,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Grant Pouf": {
    "image_url": "../upload_images/Domkapa/Poufs/Grant Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/grant-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Poufs/Grant Pouf/main.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/12.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/11.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/10.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/9.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/8.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/7.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/6.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/5.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/4.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/3.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/2.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/1.jpg",
      "../upload_images/Domkapa/Poufs/Grant Pouf/13.png",
      "../upload_images/Domkapa/Poufs/Grant Pouf/14.png",
      "../upload_images/Domkapa/Poufs/Grant Pouf/15.png"
    ],
    "description": "המבנה של פוף Grant משלב בכישרון אסתטיקה וארגונומיה במטרה ליצור את הפתרון המוביל לכל פרויקט עיצובי. מיועד לשימושים מגוונים, פוף Grant זמין בשלושה גדלים שונים כדי להשלים את המראה הסופי שתמיד חלמת עליו. הפוף מאופיין בפייפינג אלגנטי בכל פינה, המשתלב בחן עם שני פסי הקונטרסט המעדינים שמחליקים באלגנטיות סביב כל הפוף.\nפוף Grant הוא צורה קלאסית ואלגנטית מבלי לוותר על נוחות ארגונומית.",
    "company_name": "Domkapa",
    "original_category": "Poufs",
    "price": 14638,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Kate Pouf": {
    "image_url": "../upload_images/Domkapa/Poufs/Kate Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/kate-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Poufs/Kate Pouf/main.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/10.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/9.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/8.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/7.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/6.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/5.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/4.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/3.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/2.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/1.jpg",
      "../upload_images/Domkapa/Poufs/Kate Pouf/11.png",
      "../upload_images/Domkapa/Poufs/Kate Pouf/12.png"
    ],
    "description": "קייט הדום מרופד במלואו, ומספק חוויית נוחות אולטימטיבית שניתן להוסיף לכל פרויקט. מגיע בשני גדלים, כך שהלקוח חופשי לבחור באפשרות המתאימה ביותר לצרכיו. בזכות הקווים הפשוטים שלו, קייט הוא פריט רב-תכליתי שיכול להשתלב כחלק משלים בכל חדר ולרופפו בכל בד. ניתן להתאים את קייט לכל אחד מהספות המפוארות שלנו, והקווים הפשוטים שלו ישתלבו בקלות בכל סגנון.",
    "company_name": "Domkapa",
    "original_category": "Poufs",
    "price": 11680,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Low Pouf": {
    "image_url": "../upload_images/Domkapa/Poufs/Low Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/low-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Poufs/Low Pouf/main.jpg",
      "../upload_images/Domkapa/Poufs/Low Pouf/5.jpg",
      "../upload_images/Domkapa/Poufs/Low Pouf/4.jpg",
      "../upload_images/Domkapa/Poufs/Low Pouf/3.jpg",
      "../upload_images/Domkapa/Poufs/Low Pouf/2.jpg",
      "../upload_images/Domkapa/Poufs/Low Pouf/1.jpg",
      "../upload_images/Domkapa/Poufs/Low Pouf/6.png"
    ],
    "description": "הפוף הנמוך מאמץ עיצוב קלאסי עם צורות עדינות. הצורה העגולה מצופה כולו בבד עם בסיס עץ המבטיח שמדובר בפריט נצחי. הקפלים העדינים בצדדים מבטיחים להוסיף אלגנטיות נוספת לעיצוב שניתן להתאים בקלות לכל סוג של פרויקט.  \nהפוף הנמוך יכול להשתלב עם כל פריט הצהרה אחר.",
    "company_name": "Domkapa",
    "original_category": "Poufs",
    "price": 18420,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Rachel Pouf": {
    "image_url": "../upload_images/Domkapa/Poufs/Rachel Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/rachel-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Poufs/Rachel Pouf/main.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/9.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/8.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/7.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/6.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/5.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/4.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/3.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/2.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/1.jpg",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/10.png",
      "../upload_images/Domkapa/Poufs/Rachel Pouf/11.png"
    ],
    "description": "פוף רייצ'ל ועיצובו העדין והעגול הוא פריט שנועד להביא נוחות נוספת לפרויקט. הפריט משלב חומרים מפוארים כמו בד רך ובסיס עץ. העיצוב כולל קפלים בצדדים שמעניקים לפריט אופי ייחודי. פוף רייצ'ל מגיע בשני גדלים לאפשרויות נוספות עבור הרצונות התובעניים ביותר, שכן הגמישות של העיצוב מאפשרת להשתמש בו כמושב נוסף או כהדום לרגליים. \nשלבו אותו עם רהיט מרופד או מעץ, ורייצ'ל מבטיחה להקסים.",
    "company_name": "Domkapa",
    "original_category": "Poufs",
    "price": 10177,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Zigzag Pouf": {
    "image_url": "../upload_images/Domkapa/Poufs/Zigzag Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/zigzag-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Poufs/Zigzag Pouf/main.jpg",
      "../upload_images/Domkapa/Poufs/Zigzag Pouf/6.jpg",
      "../upload_images/Domkapa/Poufs/Zigzag Pouf/5.jpg",
      "../upload_images/Domkapa/Poufs/Zigzag Pouf/4.jpg",
      "../upload_images/Domkapa/Poufs/Zigzag Pouf/3.jpg",
      "../upload_images/Domkapa/Poufs/Zigzag Pouf/2.jpg",
      "../upload_images/Domkapa/Poufs/Zigzag Pouf/1.jpg",
      "../upload_images/Domkapa/Poufs/Zigzag Pouf/7.png"
    ],
    "description": "פוף זיגזג וצורתו הלא שגרתית מעניקים אופי לפריט העדין הזה. הפוף מרופד כולו ומשובץ בקפלים רוחביים ואנכיים שנותנים לו טוויסט מהנה ואווירה מיוחדת. הצורה הייחודית החצי-מעגלית של פוף זיגזג ניתנת להתאמה לכל סביבה ומשתלבת עם כל סגנון.  \nפוף זיגזג ניתן לשילוב עם עיצובים אחרים הכוללים קפלים משחקיים.  \n",
    "company_name": "Domkapa",
    "original_category": "Poufs",
    "price": 24293,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Colbert Bench": {
    "image_url": "../upload_images/Domkapa/Benches/Colbert Bench/main.jpg",
    "product_url": "https://domkapa.com/en/benches/colbert-bench/",
    "image_urls": [
      "../upload_images/Domkapa/Benches/Colbert Bench/main.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/10.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/9.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/8.png",
      "../upload_images/Domkapa/Benches/Colbert Bench/7.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/6.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/5.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/4.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/3.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/2.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/1.jpg",
      "../upload_images/Domkapa/Benches/Colbert Bench/11.png",
      "../upload_images/Domkapa/Benches/Colbert Bench/12.png"
    ],
    "description": "קולברט הוא ספסל עדין ואלגנטי, מושלם לסביבה עכשווית. עם מושב מרופד לחלוטין, הוא כולל תפרים עדינים ולוקסוס בביצוע התפרים הבודדים והכפולים. קולברט מתאפיין גם בבסיס מתכת מורכב בצורת T עם ארבע רגליים מתכתיות. הצורה האובלית המוארכת של המושב יוצרת ניגוד יפה עם חומרי הגלם והקווים של המבנה.\nפיסת השלמה מעודנת זו משתלבת היטב לבד או עם כל מיטה, ומציעה שילוב של פונקציונליות וסגנון.",
    "company_name": "Domkapa",
    "original_category": "Benches",
    "price": 14220,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Henry Bench": {
    "image_url": "../upload_images/Domkapa/Benches/Henry Bench/main.jpg",
    "product_url": "https://domkapa.com/en/benches/henry-bench/",
    "image_urls": [
      "../upload_images/Domkapa/Benches/Henry Bench/main.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/13.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/12.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/11.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/10.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/9.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/8.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/7.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/6.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/5.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/4.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/3.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/2.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/1.jpg",
      "../upload_images/Domkapa/Benches/Henry Bench/14.png",
      "../upload_images/Domkapa/Benches/Henry Bench/15.png"
    ],
    "description": "ספסל הנרי מבית Domkapa מביע הרמוניה באמצעות הפרטים המיוחדים שלו. עם כרית קטנה שיכולה להיות מותאמת ואפילו מוסרת, העיצוב של מושב זה משלב באופן מושלם בין הרגליים המיוצרות בקפידה בעבודת יד לבין המושב הרך אך עוטף. קלאסי ואלגנטי, ספסל הנרי הוא יצירה ייחודית בהשראת העיצוב העכשווי שכולנו אוהבים.\nפתרון קלאסי זה, הזמין בשני גדלים, מחובר לצורה פונקציונלית שמתאימה באופן מושלם לחומרים המעודנים שלו.",
    "company_name": "Domkapa",
    "original_category": "Benches",
    "price": 25169,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Vincent Bench": {
    "image_url": "../upload_images/Domkapa/Benches/Vincent Bench/main.jpg",
    "product_url": "https://domkapa.com/en/benches/vincent-bench/",
    "image_urls": [
      "../upload_images/Domkapa/Benches/Vincent Bench/main.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/13.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/12.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/11.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/10.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/9.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/8.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/7.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/6.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/5.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/4.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/3.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/2.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/1.jpg",
      "../upload_images/Domkapa/Benches/Vincent Bench/14.png",
      "../upload_images/Domkapa/Benches/Vincent Bench/15.png"
    ],
    "description": "ספסל Vincent מצדיע למסורת המלאכה הידנית המובעת על ידי ניגודים מדוקדקים בין המבנה העצי למושב המרופד. עיצוב זה, המוצע בשני גדלים, אינו רק נעים לעין אלא גם למגע, ומאפשר לפנים הבית שלכם לשלב את האלגנטיות והאותנטיות שלו לכל החיים. מובחן במראהו, Vincent מאופיין בסגנון מסורתי שמעניק ביטוי מוצק לעולם המודרני של ימינו.  \nכל פרט ב-Vincent מבטא אופי עם חומרי הגלם המכובדים והאיכותיים שלו.",
    "company_name": "Domkapa",
    "original_category": "Benches",
    "price": 18898,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },


  "Cleo Mirror": {
    "image_url": "../upload_images/Domkapa/Accessories/Cleo Mirror/main.jpg",
    "product_url": "https://domkapa.com/en/mirrors/cleo-mirror/",
    "image_urls": [
      "../upload_images/Domkapa/Accessories/Cleo Mirror/main.jpg",
      "../upload_images/Domkapa/Accessories/Cleo Mirror/5.jpg",
      "../upload_images/Domkapa/Accessories/Cleo Mirror/4.jpg",
      "../upload_images/Domkapa/Accessories/Cleo Mirror/3.jpg",
      "../upload_images/Domkapa/Accessories/Cleo Mirror/2.jpg",
      "../upload_images/Domkapa/Accessories/Cleo Mirror/1.jpg",
      "../upload_images/Domkapa/Accessories/Cleo Mirror/6.png",
      "../upload_images/Domkapa/Accessories/Cleo Mirror/7.png"
    ],
    "description": "מתעגלת, מינימלית ובעלת מראה ייחודי, מראה Cleo היא עיצוב מראה מפואר שישדרג את פרויקט העיצוב שלכם. צורת האליפסה של המראה היא רק אחת מהתכונות הרבות שכאשר משולבות יחד, יוצרות אביזר ייחודי שמעצים את היופי של הפרויקט. מסגרת המראה מרופדת בבד לבחירתכם ובאמצע החלק נמצא מדף עץ לתמיכה נוספת. \nמראת Cleo היא משהו שלא ראיתם לפני כן ותהיה התוספת המושלמת לפרויקט שלכם.",
    "company_name": "Domkapa",
    "original_category": "Accessories",
    "price": 25210,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Ralph Hanger": {
    "image_url": "../upload_images/Domkapa/Accessories/Ralph Hanger/main.jpg",
    "product_url": "https://domkapa.com/en/hangers/ralph-hanger/",
    "image_urls": [
      "../upload_images/Domkapa/Accessories/Ralph Hanger/main.jpg",
      "../upload_images/Domkapa/Accessories/Ralph Hanger/5.jpg",
      "../upload_images/Domkapa/Accessories/Ralph Hanger/4.jpg",
      "../upload_images/Domkapa/Accessories/Ralph Hanger/3.jpg",
      "../upload_images/Domkapa/Accessories/Ralph Hanger/2.jpg",
      "../upload_images/Domkapa/Accessories/Ralph Hanger/1.jpg",
      "../upload_images/Domkapa/Accessories/Ralph Hanger/6.png"
    ],
    "description": "Ralph הוא קולב מינימליסטי עם נגיעה תעשייתית, המתאפיין בשלוש צינורות אנכיים גבוהים. שלושת הצינורות האלו מחוברים באמצעות צינור מתכתי בצורת T בחלק העליון והתחתון של הפריט ליציבות מדהימה. נקודת העיקר של עיצוב מהמם זה היא המגש בסגנון וינטג' עם פרט עור המסתובב ב-360º. תכונה זו מאפשרת מקום אחסון למפתחות תוך כדי השלמת הקולב ושיפור הסגנון של הפרויקט שלכם. \nקולב מתכתי לחלוטין עם סגנון ועיצוב מתוחכם, מבלי לאבד את הצד הפונקציונלי הנדרש מפריט ריהוט.",
    "company_name": "Domkapa",
    "original_category": "Accessories",
    "price": 10288,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Bondi Pouf": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/product/bondi-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Pouf/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Pouf/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Pouf/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Pouf/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Pouf/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Pouf/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Pouf/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Pouf/7.png"
    ],
    "description": "הדום בונדי הוא פריט מרופד אלגנטי בגודל נוח ומרווח נעים לנוח בו. התאימו את הדום בונדי עם ספת בונדי כדי להתרווח באמת.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 10851,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Bondi Side Table": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Side Table/main.jpg",
    "product_url": "https://domkapa.com/en/side-tables/bondi-side-table/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Side Table/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Side Table/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Side Table/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Side Table/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Side Table/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Side Table/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Side Table/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Side Table/7.png"
    ],
    "description": "הגיע הזמן לאבזר את החוץ ושולחן הצד Bondi הוא התחלה מצוינת. הוסיפו פרטים מיוחדים עם האביזרים האלה והפכו את שטח החוץ שלכם לאישי יותר.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 19219,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Copacabana Pouf": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Pouf/main.jpg",
    "product_url": "https://domkapa.com/en/poufs/copacabana-pouf/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/10.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/9.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/8.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/7.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/6.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/5.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Pouf/11.png"
    ],
    "description": "פוף Copacabana יתפוס מקום מיוחד בפרויקטים חיצוניים. מעוצב להיות נוח במיוחד, חתיכה זו מאופיינת בגוונים יפים.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 21960,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Copacabana Side Table": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Side Table/main.jpg",
    "product_url": "https://domkapa.com/en/side-tables/copacabana-side-table/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Side Table/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Side Table/5.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Side Table/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Side Table/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Side Table/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Side Table/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Side Table/6.png"
    ],
    "description": "לפעמים, פחות זה יותר. שולחן צד Copacabana ממחיש זאת בצורה מושלמת עם עיצוב המינימליסטי שלו הכובש את כל תשומת הלב.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 12172,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },


  "Gilbert Table Set": {
    "image_url": "../upload_images/Domkapa/Accessories/Gilbert Table Set/main.jpg",
    "product_url": "https://domkapa.com/en/accessories/gilbert-table-set/",
    "image_urls": [
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/main.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/19.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/18.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/17.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/16.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/15.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/14.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/13.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/12.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/11.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/10.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/9.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/8.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/7.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/6.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/5.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/4.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/3.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/2.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/1.jpg",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/20.png",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/21.png",
      "../upload_images/Domkapa/Accessories/Gilbert Table Set/22.png"
    ],
    "description": "בעיצוב מינימליסטי, Gilbert הוא סט שולחנות הכולל שלושה שולחנות בגדלים שונים שיכולים לשמש כשולחנות צד או שולחנות קפה. דגם שולחן הקפה כולל בסיס מעץ בצורת H בעוד ששולחנות הצד כוללים בסיס בצורת T. לשולחנות Gilbert יש פינות מעוגלות שניתן להתאים אישית בלכה, פורניר עץ, ואפילו עור סינתטי בחלקם העליון.\nהחלק הטוב ביותר של סט שולחנות Gilbert הוא שניתן להשתמש בהם בנפרד או לשלב אותם יחד ליצירת מערכת אחת, שמשלבת את הצורות והגבהים הייחודיים שלהם.",
    "company_name": "Domkapa",
    "original_category": "Accessories",
    "price": 19361,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Inside Table Set": {
    "image_url": "../upload_images/Domkapa/Accessories/Inside Table Set/main.jpg",
    "product_url": "https://domkapa.com/en/tables/inside-table/",
    "image_urls": [
      "../upload_images/Domkapa/Accessories/Inside Table Set/main.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/13.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/12.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/11.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/10.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/9.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/8.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/7.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/6.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/5.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/4.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/3.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/2.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/1.jpg",
      "../upload_images/Domkapa/Accessories/Inside Table Set/14.png",
      "../upload_images/Domkapa/Accessories/Inside Table Set/15.png",
      "../upload_images/Domkapa/Accessories/Inside Table Set/16.png"
    ],
    "description": "סט שולחנות Inside כולל גרסאות שונות כדי למלא את כל צרכי הפרויקט שלכם: שולחנות קפה, שולחנות צד נמוכים וגבוהים. דבר אחד משותף לכל שלוש הגרסאות הוא הרגליים מפלדה טקסטורה עם בסיס בצורת X שיוצרות אשליה אופטית. השולחן זמין בעץ ופלדת אל-חלד, מה שמבטיח מראה ייחודי בכל גימור שתבחרו.\nעיצוב עכשווי עם נופך תעשייתי לתרחישים התובעניים ביותר.",
    "company_name": "Domkapa",
    "original_category": "Accessories",
    "price": 16771,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Mano Table Set": {
    "image_url": "../upload_images/Domkapa/Accessories/Mano Table Set/main.jpg",
    "product_url": "https://domkapa.com/en/tables/mano-table/",
    "image_urls": [
      "../upload_images/Domkapa/Accessories/Mano Table Set/main.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/9.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/8.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/7.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/6.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/5.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/4.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/3.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/2.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/1.jpg",
      "../upload_images/Domkapa/Accessories/Mano Table Set/10.png",
      "../upload_images/Domkapa/Accessories/Mano Table Set/11.png"
    ],
    "description": "יצירה יוצאת דופן עם איזון אסתטי מרהיב ופונקציונליות, הממוזגת בעיצוב מלאכת יד הרמונית. המבנה העגול מרופד לגמרי בעור טבעי בעוד שהחלק העליון כולל לוח עץ. מסגרת העור כוללת ארבעה פאנלים שמתכנסים יחד ליצירת עיצוב מרהיב ומיומנויות ייצור ברמה גבוהה.\nMano זמין בגרסת שולחן קפה ושולחן צד, לזיהוי ייחודי ונצחי.",
    "company_name": "Domkapa",
    "original_category": "Accessories",
    "price": 24194,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Panton Table Set": {
    "image_url": "../upload_images/Domkapa/Accessories/Panton Table Set/main.jpg",
    "product_url": "https://domkapa.com/en/tables/panton-table-set/",
    "image_urls": [
      "../upload_images/Domkapa/Accessories/Panton Table Set/main.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/9.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/8.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/7.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/6.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/5.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/4.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/3.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/2.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/1.jpg",
      "../upload_images/Domkapa/Accessories/Panton Table Set/10.png",
      "../upload_images/Domkapa/Accessories/Panton Table Set/11.png"
    ],
    "description": "פנטון הוא שולחן מצוין עם סגנון נעים, צורות נדיבות ועיצוב קווי. המשטח העליון העגול מזכוכית מולחם לבסיס מעץ בצורת חרוט, המאפשר שימושים שונים הן בסביבות ביתיות והן במקומות ציבוריים. לאורך החלק תוכלו למצוא פרטי נירוסטה עדינים שיכולים לייפות אותו ולהקנות לו רמה אחרת.\nזמין במידות של שולחן קפה ושולחן צד, זהו פריט רב-תכליתי שניתן להתאים אישית את מרכיביו.",
    "company_name": "Domkapa",
    "original_category": "Accessories",
    "price": 18360,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Bondi Coffee Table": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/main.jpg",
    "product_url": "https://domkapa.com/en/coffee-tables/bondi-coffee-table/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Coffee Table/8.png"
    ],
    "description": "שולחן קפה בונדי יוצר אווירה חמימה לקיצים בלתי נשכחים. פריט פשוט עם מרקם בלתי נשכח שמעניק לחללים החיצוניים את האופי שמגיע להם.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 29175,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Copacabana Coffee Table": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Coffee Table/main.jpg",
    "product_url": "https://domkapa.com/en/coffee-tables/copacabana-coffee-table/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Coffee Table/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Coffee Table/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Coffee Table/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Coffee Table/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Coffee Table/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Coffee Table/5.png"
    ],
    "description": "חברה: Domkapa, מוצר: שולחן קפה קופקבנה. תאור: שולחן קפה קופקבנה מספק נוחות למשפחה דרך עיצוב ומרקמים מחודשים. ניתן לשלב אותו עם שולחן צד קופקבנה.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 25440,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },


  "Mano Dining Table": {
    "image_url": "../upload_images/Domkapa/Accessories/Mano Dining Table/main.jpg",
    "product_url": "https://domkapa.com/en/dining-tables/mano-dining-table/",
    "image_urls": [
      "../upload_images/Domkapa/Accessories/Mano Dining Table/main.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/9.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/8.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/7.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/6.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/5.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/4.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/3.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/2.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/1.jpg",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/10.png",
      "../upload_images/Domkapa/Accessories/Mano Dining Table/11.png"
    ],
    "description": "עם חומרים קלאסיים וצורה יוצאת דופן, שולחן אוכל Mano מעורר השראה בהרמוניה ובעיצוב מלאכת יד. הוא מרופד כולו בעור טבעי בניגוד לחלק העליון מזכוכית, מה שמקנה תחושת אותנטיות ומאפשר לעיצוב שלכם להחזיק מעמד לאורך זמן.\nשולחן Mano זמין גם בגרסאות של שולחן קפה ושולחן צד לעיצוב ייחודי.",
    "company_name": "Domkapa",
    "original_category": "Accessories",
    "price": 11364,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Panton Dining Table": {
    "image_url": "../upload_images/Domkapa/Accessories/Panton Dining Table/main.jpg",
    "product_url": "https://domkapa.com/en/dining-tables/panton-dining-table/",
    "image_urls": [
      "../upload_images/Domkapa/Accessories/Panton Dining Table/main.jpg",
      "../upload_images/Domkapa/Accessories/Panton Dining Table/7.jpg",
      "../upload_images/Domkapa/Accessories/Panton Dining Table/6.jpg",
      "../upload_images/Domkapa/Accessories/Panton Dining Table/5.jpg",
      "../upload_images/Domkapa/Accessories/Panton Dining Table/4.jpg",
      "../upload_images/Domkapa/Accessories/Panton Dining Table/3.jpg",
      "../upload_images/Domkapa/Accessories/Panton Dining Table/2.jpg",
      "../upload_images/Domkapa/Accessories/Panton Dining Table/1.jpg",
      "../upload_images/Domkapa/Accessories/Panton Dining Table/8.png"
    ],
    "description": "עם עיצוב מעוגל וצורות נדיבות, Panton הוא שולחן אוכל שניתן לשלב במקומות מגורים ומסחריים. משטח זכוכית עגול מחובר לבסיס עץ חרוטי, וממלא את החלל שלכם בכמות המתאימה של אלגנטיות ומתוחכמות. עבור אווירה חיננית, פרטים מנירוסטה כלולים כדי לקחת את העיצובים שלכם לרמה אחרת.\nPanton ניתן להתאמה אישית וזמין בממדי שולחן קפה ושולחן צד.",
    "company_name": "Domkapa",
    "original_category": "Accessories",
    "price": 16780,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Bondi Dining Table": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Dining Table/main.jpg",
    "product_url": "https://domkapa.com/en/dining-tables/bondi-dining-table/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/9.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/8.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/10.png",
      "../upload_images/Domkapa/Outdoor/Bondi Dining Table/11.png"
    ],
    "description": "כנסו את חבריכם ומשפחותיכם וחגגו את הקיץ בנוחות ובסטייל עם שולחן האוכל Bondi. העיצוב המינימליסטי עם מבנה פלדה שחורה בעלת מרקם מסוגל להיראות מהמם בכל סגנון ובכל חוץ.\nשולחן האוכל Bondi המתוכנן, זמין בשני גדלים להתאים לטעמכם הטוב, ומביא פונקציונליות לגינתכם.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 23736,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Copacabana Dining Table": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/main.jpg",
    "product_url": "https://domkapa.com/en/dining-tables/copacabana-dining-table/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/6.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/5.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Dining Table/7.png"
    ],
    "description": "אוכל בחוץ מעולם לא היה כל כך קל. עם שולחן האוכל קופקבנה, תוכלו כעת לספק את הפונקציונליות שהעיצוב החיצוני שלכם זקוק לה, תוך שילוב המידה הנכונה של סגנון וורסטיליות. פרקטי ומתוחכם, שולחן אוכל מהמם זה יבטיח לכם רגעי שמחה.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 28189,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },


  "Bondi 1 Seater": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/bondi-1-seater/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/8.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi 1 Seater/9.png"
    ],
    "description": "כיסא בונדי הוא תוספת רכה ונוחה שניתן לשלב עם פריטי חוץ נוספים מהאוסף של Domkapa. הזמנה להירגע ולשקוע בנוחות.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 14811,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Bondi Armchair": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/bondi-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/17.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/16.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/15.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/14.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/13.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/12.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/11.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/10.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/9.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/8.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Armchair/18.png"
    ],
    "description": "התרווחו על כורסת Bondi והנאה מאוויר הפתוח עם נוחות מרבית. התכרבלו וחגגו את ההרמוניה עם הטבע. רהיט ייחודי, רחוק מלהיות משעמם, להופעה חיצונית נעימה.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 14678,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Bondi Chaise Longue": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/main.jpg",
    "product_url": "https://domkapa.com/en/chaise-longues/bondi-chaise-longue/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/11.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/10.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/9.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/8.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chaise Longue/12.png"
    ],
    "description": "כיסא נוח Bondi הוא פריט מודרני שמעורר קריאת כיוון למעריצי השמש להתרווח. ניתן להתאים אישית את הממדים, החומרים כמו גם את גודל מסעד היד כדי לוודא שתקבלו את התוצאה שהפרויקט שלכם דורש.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 21646,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Bondi Corner Chair": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/bondi-corner-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Corner Chair/8.png"
    ],
    "description": "העיצוב הגמיש במיוחד של כיסא הפינה Bondi מזמין אותך לשלב את רהיט זה עם מודולים נוספים, כולל ספת אמצע Bondi ופוף Bondi.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 21215,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Copacabana Armchair": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Armchair/main.jpg",
    "product_url": "https://domkapa.com/en/armchairs/copacabana-armchair/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/10.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/9.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/8.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/7.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/6.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/5.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Armchair/11.png"
    ],
    "description": "מבנה הפלדה לא יתחמצן, הצבעים עמידים בפני השמש והאסתטיקה חזקה בדיוק כפי שהיצירתיות מאפשרת. אלו הם המאפיינים של כורסאת Copacabana: רהיט מהפנט בזכות אישיותו.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 11143,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Copacabana Chaise Longue": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/main.jpg",
    "product_url": "https://domkapa.com/en/chaise-longues/copacabana-chaise-longue/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/11.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/10.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/9.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/8.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/7.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/6.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/5.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chaise Longue/12.png"
    ],
    "description": "לשֵׁז לוֹנג קוֹפָּקָבָּנָה יש את הכוח הייחודי להשפיע על מצב רוחכם. בזכות השקט והנוחות שלו, זהו פריט חובה לקייצים שמחים יותר. זמין עם תמיכת גב וידית ימינית או שמאלית, תוכלו להתאים את הפריט הזה לכל מקום שתרצו.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 12360,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },


  "Bondi Chair": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/bondi-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Chair/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/11.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/10.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/9.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/8.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/12.png",
      "../upload_images/Domkapa/Outdoor/Bondi Chair/13.png"
    ],
    "description": "כיסא Bondi משקף אוסף סגנון חיים מיוחד המאופיין בצורות אורגניות ואלמנטים תחושתיים. מבנהו עשוי מפלדה שחורה במרקם מחוספס המספקת את כל התמיכה הנחוצה בעוד המושב מספק חוויה ייחודית של נוחות.  \nזמין בשתי גרסאות, עם או בלי משענות יד, ניתן לשלב אותו עם שולחן האוכל Bondi ועם פריטים נוספים מאוסף הריהוט החיצוני של Domkapa.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 18579,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Copacabana Chair": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Chair/main.jpg",
    "product_url": "https://domkapa.com/en/chairs/copacabana-chair/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/10.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/9.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/8.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/7.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/6.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/5.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/11.png",
      "../upload_images/Domkapa/Outdoor/Copacabana Chair/12.png"
    ],
    "description": "כיסא קופקבנה של דומקפה כאן כדי לחולל מהפכה במשמעות של נוחות המתאימה לכל המשפחה. עם עיצוב מחודש וצורה מינימליסטית, הוא יספק לכם רגעי נוחות שאתם זקוקים להם במרחב החיצוני שלכם.\nהוא זמין בשתי גרסאות, עם משענות יד וללא, כך שתוכלו לשלב אותו עם שולחן אוכל קופקבנה לרגעי שלווה ושמחה.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 21181,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },


  "Bondi Lounger": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Lounger/main.jpg",
    "product_url": "https://domkapa.com/en/loungers/bondi-lounger/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Lounger/8.png"
    ],
    "description": "תהנו מהמרחב החיצוני שלכם עם Bondi Lounger והקיצים שלכם לעולם לא יהיו אותו הדבר. עם מבנה עמיד וצורה אורגנית, Bondi יביא נוחות נוספת לאזור המנוחה שלכם. המבנה הזה של פלדה שחורה במרקם מוודא שתקבלו את כל התמיכה שאתם צריכים בעוד שהשילוב של מרקמים וחומרים מעצים את הנוחות המושלמת.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 16856,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Copacabana Lounger": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Lounger/main.jpg",
    "product_url": "https://domkapa.com/en/loungers/copacabana-lounger/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/7.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/6.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/5.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Lounger/8.png"
    ],
    "description": "הגינה שלך תעניק לך רגעי נוחות בעזרת עיצוב מינימליסטי ושלווה עם כסא נוח קופקבנה. עיצוב זה חיוני לרגעי רווחה בזמן שאתה נהנה מהאוויר הפתוח, בעוד המושב הנוח מתמזג עם חומרים איכותיים.\n\nעם מבנה פלדה שאינו מחליד, כסא נוח קופקבנה הוא חלק מושלם לכל אזור חיצוני, משפר את איכות חייך ואת עיצובך.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 27110,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },


  "Bondi Sofa": {
    "image_url": "../upload_images/Domkapa/Outdoor/Bondi Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/bondi-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/main.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/11.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/10.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/9.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/8.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/7.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/6.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/5.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/4.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/3.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/2.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/1.jpg",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/12.png",
      "../upload_images/Domkapa/Outdoor/Bondi Sofa/13.png"
    ],
    "description": "האסתטיקה הנקייה מקנה צורה אורגנית ועיצוב נעים לספת Bondi עם או בלי משענת ליד. מבנה הפלדה הצבועה מעניק מגע עכשווי לפריט עמיד זה.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 14115,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Copacabana Sofa": {
    "image_url": "../upload_images/Domkapa/Outdoor/Copacabana Sofa/main.jpg",
    "product_url": "https://domkapa.com/en/sofas/copacabana-sofa/",
    "image_urls": [
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/main.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/11.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/10.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/9.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/8.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/7.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/6.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/5.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/4.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/3.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/2.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/1.jpg",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/12.png",
      "../upload_images/Domkapa/Outdoor/Copacabana Sofa/13.png"
    ],
    "description": "ספת Copacabana עם או בלי משענת יד היא פריט ייחודי לאלו שאוהבים לבלות זמן איכות עם חברים בחוץ.",
    "company_name": "Domkapa",
    "original_category": "Outdoor",
    "price": 22923,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "AMBRA": {
    "image_url": "../upload_images/franco_ferri/Design/AMBRA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=ambra&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/AMBRA/main.jpg",
      "../upload_images/franco_ferri/Design/AMBRA/1.jpg",
      "../upload_images/franco_ferri/Design/AMBRA/2.jpg",
      "../upload_images/franco_ferri/Design/AMBRA/3.jpg"
    ],
    "description": "אמברָה היא הספה שמציעה איזון מושלם בין אלגנטיות לנוחות. המושב המרופד שלה מבטיח חוויית רגיעה עוטפת, בעוד המשענות הניתנות לכוונון ידני מאפשרות למצוא את התנוחה הנוחה ביותר. הכריות התומכות המותניות הנשלפות מציעות פרקטיות וגמישות, ומותאמות להעדפות שלך. מוחזקת מעל הרצפה בזכות רגלי המתכת שלה, אמברָה מעניקה מגע מודרני ומתוחכם לסביבתך.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 14769,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "SPIGA": {
    "image_url": "../upload_images/franco_ferri/Design/SPIGA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=spiga&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/SPIGA/main.jpg",
      "../upload_images/franco_ferri/Design/SPIGA/1.jpg",
      "../upload_images/franco_ferri/Design/SPIGA/2.jpg",
      "../upload_images/franco_ferri/Design/SPIGA/3.jpg"
    ],
    "description": "עיצוב המתמקד בקווים אלגנטיים עבור הספה דגם Spiga, עם פרט ייחודי של רגלי מתכת מוטות. מתאפיין בטקסטורות עמוקות במושב ובמשענת הגב, כולל משענת גב מתכווננת ומשענות יד מוטות שמגבירות את הנוחות. זמין גם בגרסה עם משענת גב קבועה ועומק מופחת, עם ריפוד מעור או מבד, ומציע מגוון רחב של תצורות בקו ישר ועם שזלונג.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 19790,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "ABBRACCI": {
    "image_url": "../upload_images/franco_ferri/Design/ABBRACCI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=abbracci&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/ABBRACCI/main.jpg",
      "../upload_images/franco_ferri/Design/ABBRACCI/1.jpg",
      "../upload_images/franco_ferri/Design/ABBRACCI/2.jpg",
      "../upload_images/franco_ferri/Design/ABBRACCI/3.jpg",
      "../upload_images/franco_ferri/Design/ABBRACCI/4.jpg"
    ],
    "description": "קווים רכים לספת המודולרית \"Abbracci\", אשר מבטאת את כל הידע והמיומנות של אומנות מלאכה מיומנת בתפירת הגיאומטריה הנדיבה שעוקבת אחר צורת המושב. גב המשענת המרופד המחבק, בפרופורציות נדיבות, יוצר יחידה סגנונית יחד עם משענות הידיים. עם אסתטיקה עכשווית שבה הנפחים מגדירים רעיון מדויק ומזמין של נוחות.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 17065,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "CARRERA": {
    "image_url": "../upload_images/franco_ferri/Design/CARRERA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=carrera&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/CARRERA/main.jpg",
      "../upload_images/franco_ferri/Design/CARRERA/1.jpg",
      "../upload_images/franco_ferri/Design/CARRERA/2.jpg",
      "../upload_images/franco_ferri/Design/CARRERA/3.jpg"
    ],
    "description": "פשוט, מודרני וקווים דקים לספה מודולרית שמציעה חופש מרבי ליצירת הפתרון המתאים ביותר לאזור המגורים. עם אפשרות לריפוד בד ובחירה בין תצורות מודולריות או פינתיות, קאררה מתאימה לחללים גדולים כמו גם לחללים קטנים. מעוצבת להבטיח נוחות מרבית בזכות ריפוד נוצות בכריות המושב והגב, ועם אפשרות לכוון ידנית הן את נטיית משענת הגב והן את זו של משענות הידיים.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 13415,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "TENCO": {
    "image_url": "../upload_images/franco_ferri/Design/TENCO/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=tenco&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/TENCO/main.jpg",
      "../upload_images/franco_ferri/Design/TENCO/1.jpg",
      "../upload_images/franco_ferri/Design/TENCO/2.jpg",
      "../upload_images/franco_ferri/Design/TENCO/3.jpg",
      "../upload_images/franco_ferri/Design/TENCO/4.jpg"
    ],
    "description": "גמישות ודינמיות מאפיינות את Tenco, ספת מודולרית על בסיס מונח עם משענות יד ניתנות לכוונון ידני המעוטרות בתפירה אופקית. ספה זו זמינה בעור ובבד, ומציעה כריות גב כפולות ותמיכה נוחה לגב התחתון. כאביזר אופציונלי, ניתן להוסיף שולחן משולב פרקטי ופונקציונלי המסתיים עם משטח זכוכית או עץ.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 14533,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "JORDAN": {
    "image_url": "../upload_images/franco_ferri/Design/JORDAN/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=jordan&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/JORDAN/main.jpg",
      "../upload_images/franco_ferri/Design/JORDAN/1.jpg",
      "../upload_images/franco_ferri/Design/JORDAN/2.jpg",
      "../upload_images/franco_ferri/Design/JORDAN/3.jpg"
    ],
    "description": "עיצוב אקלקטי וגמיש זה, עם גב מעוצב המתעגל ומחבק, מוקל על ידי בסיס עץ או מתכת לבחירתכם. הקונספט החדש והעכשווי של שילוב אלמנטים שונים מקבל את הצורה של סט סלון או פינת ישיבה, עם הדום כרכיב שובב. ניתן ליהנות מנוחות נוספת הודות לכריות קצף זיכרון. גימור רוז גולד יקרות על רגל המתכת מוסיף נופך ייחודי.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 29532,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "SACAI": {
    "image_url": "../upload_images/franco_ferri/Design/SACAI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=sacai&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/SACAI/main.jpg",
      "../upload_images/franco_ferri/Design/SACAI/1.jpg",
      "../upload_images/franco_ferri/Design/SACAI/2.jpg",
      "../upload_images/franco_ferri/Design/SACAI/3.jpg",
      "../upload_images/franco_ferri/Design/SACAI/4.jpg",
      "../upload_images/franco_ferri/Design/SACAI/5.jpg"
    ],
    "description": "רצף הריתמוס של עיצוב פופ גאומטרי זה של הטלאים הוא שמאפיין את הספה המודולרית הדינמית הזו. המודולרית המשובצת של סאקאי מאפשרת דרגות שונות של תצורות מגוונות, ומתאימה לחללים שונים בבית. היא זמינה עם בסיס מתכת וכן בסיס מרופד, והמושבים שלה, הן מפוליאוריתן והן מקצף זיכרון, מבטיחים נוחות מרבית.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 25322,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "ROCK": {
    "image_url": "../upload_images/franco_ferri/Design/ROCK/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=rock&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/ROCK/main.jpg",
      "../upload_images/franco_ferri/Design/ROCK/1.jpg",
      "../upload_images/franco_ferri/Design/ROCK/2.jpg",
      "../upload_images/franco_ferri/Design/ROCK/3.jpg"
    ],
    "description": "צעיר, דינמי ומלא אישיות, השילוב הזה של ריפוד עור ובד יוצר תערובת נעימה של מגע רך וניגודיות מרשימה של צבעים מעודנים. קוויו המעוגלים מועצמים על ידי התפרים המתקדמים והמוקפדים על הכריות. מורם מהרצפה בבסיס מתכת צינורי שחור שמקל על המראה האסתטי, רוק זמין גם כחלק מסט מודולרי לפינת החדר.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 20924,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BROSS": {
    "image_url": "../upload_images/franco_ferri/Design/BROSS/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=bross&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/BROSS/main.jpg",
      "../upload_images/franco_ferri/Design/BROSS/1.jpg",
      "../upload_images/franco_ferri/Design/BROSS/2.jpg",
      "../upload_images/franco_ferri/Design/BROSS/3.jpg",
      "../upload_images/franco_ferri/Design/BROSS/4.jpg",
      "../upload_images/franco_ferri/Design/BROSS/5.jpg",
      "../upload_images/franco_ferri/Design/BROSS/6.jpg"
    ],
    "description": "בעל קווים סדירים ומאוזנים, דגם זה צובר תאוצה הודות לקלות הרגל מעץ בצורת קשת התומכת בבסיס העץ. לוחות מתכת המצופים בעור תומכים בכריות הגב, ומבטיחים נוחות מקסימלית ויציבה נכונה. זמין גם בשילוב בד ועור, ניתן לשלב את רכיביו המודולריים עם שזלונג והדומים עומדים בנפרד.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 10728,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "HYBRID": {
    "image_url": "../upload_images/franco_ferri/Design/HYBRID/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=hybrid&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/HYBRID/main.jpg",
      "../upload_images/franco_ferri/Design/HYBRID/1.jpg",
      "../upload_images/franco_ferri/Design/HYBRID/2.jpg",
      "../upload_images/franco_ferri/Design/HYBRID/3.jpg"
    ],
    "description": "תודה למושב הכריות מנוחת הזיכרון המשולבות והנוחות שלו, ולמשענות היד המתכווננות באופן ידני, הדגם הפונקציונלי הזה זמין עם תיפורים מנוגדים בעור וגם בבד. הדף הטכני שלו כולל מגוון רחב של שילובים מודולריים, ספות פינתיות, עם פינות שזלונג ופופים.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 14652,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "COLE": {
    "image_url": "../upload_images/franco_ferri/Design/COLE/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=cole&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/COLE/main.jpg",
      "../upload_images/franco_ferri/Design/COLE/1.jpg",
      "../upload_images/franco_ferri/Design/COLE/2.jpg",
      "../upload_images/franco_ferri/Design/COLE/3.jpg"
    ],
    "description": "לקול יש סגנון חיוני ומודרני בהחלט. עם תוספות המתכת על מוט משענת הגב, באותו גימור כמו הרגליים, אלמנטים שהופכים מפונקציונליים לביטויים, הם מוסיפים אופי ועוצמה לעיצוב הכללי. הנוחות שלו מועצמת על ידי פרטי התפירה הכפולה לאורך משענת היד וכריות הזיכרון הזמינות הן בגרסת בד והן בגרסת עור.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 15895,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "ASTOR": {
    "image_url": "../upload_images/franco_ferri/Design/ASTOR/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=astor&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/ASTOR/main.jpg",
      "../upload_images/franco_ferri/Design/ASTOR/1.jpg",
      "../upload_images/franco_ferri/Design/ASTOR/2.jpg",
      "../upload_images/franco_ferri/Design/ASTOR/3.jpg"
    ],
    "description": "צורות מעוצבות היטב, עם קווי מתאר רכים לספה שעושה מודולריות וגמישות לליבה שלה. אסטור, עם ריפוד בד, מציעה מגוון רחב של פתרונות אפשריים שניתן להתאים לכל הקשר; והיא גם משלבת תשומת לב קפדנית לפרטים, עם איכות החומרים שבהם נעשה שימוש.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 21396,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "ELISA": {
    "image_url": "../upload_images/franco_ferri/Design/ELISA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=elisa&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/ELISA/main.jpg",
      "../upload_images/franco_ferri/Design/ELISA/1.jpg",
      "../upload_images/franco_ferri/Design/ELISA/2.jpg",
      "../upload_images/franco_ferri/Design/ELISA/3.jpg",
      "../upload_images/franco_ferri/Design/ELISA/4.jpg",
      "../upload_images/franco_ferri/Design/ELISA/5.jpg",
      "../upload_images/franco_ferri/Design/ELISA/6.jpg",
      "../upload_images/franco_ferri/Design/ELISA/7.jpg",
      "../upload_images/franco_ferri/Design/ELISA/8.jpg"
    ],
    "description": "עם הקימורים של אליסה זו אהבה ממבט ראשון. היא מבטיחה נוחות מרבית בזכות הצורה המודולרית של כרית המושב המשתלבת עם משענת הגב. מתאימה גם לחללים קטנים, וזמינה גם בעור וגם בבד.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 28289,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "CAPITOLO": {
    "image_url": "../upload_images/franco_ferri/Design/CAPITOLO/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=capitolo&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/CAPITOLO/main.jpg",
      "../upload_images/franco_ferri/Design/CAPITOLO/1.jpg",
      "../upload_images/franco_ferri/Design/CAPITOLO/2.jpg"
    ],
    "description": "הדגם הרך והדק הזה, המורכב מכריות מעטפות אך מובנות, מושלם להירגעות בזכות התמיכה המותנית והמנגנון הידני המאפשר זוויות שונות הן של משענת היד והן של משענת הגב הגבוהה. קפיטולו זמין במודולי פינה מבד ועור, שזלונג ופוף, הנתמכים ברגלי מתכת המעוטרות בתפירת קונטור שטוחה לאורך כל הכריות.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 14092,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "SANTORINI": {
    "image_url": "../upload_images/franco_ferri/Design/SANTORINI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=santorini&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/SANTORINI/main.jpg",
      "../upload_images/franco_ferri/Design/SANTORINI/1.jpg",
      "../upload_images/franco_ferri/Design/SANTORINI/2.jpg"
    ],
    "description": "קווים ישרים, עם ריפוד נוצות על כל משענת הגב, סנטוריני מציע נוחות נוספת הודות לכריות מושב עם קצף זיכרון ומשענת יד מתקפלת עם מנגנון ידני. הגב נתמך על ידי רצועות מתכת, בגימור זהה לזה של הרגליים, מה שמוסיף לדגם זה חוזק ואופי. סט הספות הזה זמין בבד או בעור, עם מודולים המאפשרים מגוון רחב של פתרונות, כולל סט פינת עם שזלונג או עם חצי אי סופי.",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 28919,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "AGI": {
    "image_url": "../upload_images/franco_ferri/Design/AGI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=agi&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Design/AGI/main.jpg",
      "../upload_images/franco_ferri/Design/AGI/1.jpg",
      "../upload_images/franco_ferri/Design/AGI/2.jpg",
      "../upload_images/franco_ferri/Design/AGI/3.jpg",
      "../upload_images/franco_ferri/Design/AGI/4.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Design",
    "price": 19838,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "GENESI": {
    "image_url": "../upload_images/franco_ferri/Relax/GENESI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=genesi&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/GENESI/main.jpg",
      "../upload_images/franco_ferri/Relax/GENESI/1.jpg",
      "../upload_images/franco_ferri/Relax/GENESI/2.jpg",
      "../upload_images/franco_ferri/Relax/GENESI/3.jpg"
    ],
    "description": "ג'נסי עוטף אותך כמו חיבוק רך. מודגש על ידי התפרים הקצביים המנוגדים, הוא מעוטר בפרט של רגל המתכת שהופכת להוספה אלגנטית במשענת היד. \nפרויקט כורסה, הוא מצויד במערכת עם מנוע חשמלי כפול עבור המושב ועבור משענת הראש.",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 18032,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BORG": {
    "image_url": "../upload_images/franco_ferri/Relax/BORG/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=borg&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/BORG/main.jpg",
      "../upload_images/franco_ferri/Relax/BORG/1.jpg",
      "../upload_images/franco_ferri/Relax/BORG/2.jpg",
      "../upload_images/franco_ferri/Relax/BORG/3.jpg"
    ],
    "description": "דגם אייקוני עכשווי, בורג הוא איזון מושלם בין צורה ותפקוד, בין אלגנטיות לפרקטיות. הנוחות מודגשת על ידי תפירת הגיאומטרית יחד עם פונקציות הרגיעה שלו: מושבים עם מנגנון הישענות חשמלי, בשילוב עם משענות ראש הנעות אנכית, כמו גם כוונון ידני להטיית משענת הראש או היד.",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 17680,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BLAKE": {
    "image_url": "../upload_images/franco_ferri/Relax/BLAKE/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=blake&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/BLAKE/main.jpg",
      "../upload_images/franco_ferri/Relax/BLAKE/1.jpg",
      "../upload_images/franco_ferri/Relax/BLAKE/2.jpg",
      "../upload_images/franco_ferri/Relax/BLAKE/3.jpg"
    ],
    "description": "עיצוב נקי ואלגנטי עם קווים מאוזנים היטב ורגלי מתכת התומכות ומקלילות את בסיס המבנה העשוי עץ. בלייק זמין בבד או בעור, וכולל משענת ראש חשמלית אנכית שניתן גם לכוון ידנית קדימה. בנוסף, יש לו לוח רגליים שניתן לכוון חשמלית כדי להבטיח את רמת הנוחות הגבוהה ביותר.",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 22145,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "VITTI": {
    "image_url": "../upload_images/franco_ferri/Relax/VITTI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=vitti&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/VITTI/main.jpg",
      "../upload_images/franco_ferri/Relax/VITTI/1.jpg",
      "../upload_images/franco_ferri/Relax/VITTI/2.jpg",
      "../upload_images/franco_ferri/Relax/VITTI/3.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 23028,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BERTÈ": {
    "image_url": "../upload_images/franco_ferri/Relax/BERTÈ/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=berte&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/BERTÈ/main.jpg",
      "../upload_images/franco_ferri/Relax/BERTÈ/1.jpg",
      "../upload_images/franco_ferri/Relax/BERTÈ/2.jpg",
      "../upload_images/franco_ferri/Relax/BERTÈ/3.jpg"
    ],
    "description": "דגם עשיר מלא בפרטים מעודנים כמו התפירה הצולבת על משענת הראש ומשענת היד והתפירה הצדדית הכפולה שמתווה את הפרופיל שלו. 'ברטה' זמין בגרסה מבד או מעור עם רגליים ממתכת ופונקציית תנועה, הודות לכיסא המיטה הכפול המתכוונן ומשענת הראש שניתן להתאים גם אנכית וגם בכיפוף קדימה באופן ידני.",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 17436,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "DAUNIA": {
    "image_url": "../upload_images/franco_ferri/Relax/DAUNIA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=daunia&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/DAUNIA/main.jpg",
      "../upload_images/franco_ferri/Relax/DAUNIA/1.jpg",
      "../upload_images/franco_ferri/Relax/DAUNIA/2.jpg",
      "../upload_images/franco_ferri/Relax/DAUNIA/3.jpg"
    ],
    "description": "הספה הזו בעיצוב מודרני ובקווים ישרים וסולידיים כוללת את הפרט של רצועת מתכת הממסגרת את משענות היד, אשר מוגדרת על ידי תפרים נתפרים מנוגדים, מה שמוסיף חוזק ואופי לכלל המערכת. דאוניה, הזמינה בעור או בבד, היא גם נוחה במיוחד הודות לפונקציות ההטיה שלה, עם מושב מתכוונן עם שני מנועים ומשענת ראש אנכית שניתן גם להטות קדימה ידנית.",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 19073,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "DENISE": {
    "image_url": "../upload_images/franco_ferri/Relax/DENISE/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=denise&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/DENISE/main.jpg",
      "../upload_images/franco_ferri/Relax/DENISE/1.jpg",
      "../upload_images/franco_ferri/Relax/DENISE/2.jpg",
      "../upload_images/franco_ferri/Relax/DENISE/3.jpg"
    ],
    "description": "עיצוב חדשני לחוויית ספה רגועה יותר הודות למשענת גב ניידת המאפשרת לשנות את עומק המושב ולשיפור בפרטי ריפוד כרית המושב בזיכרון, המוסתר על ידי כרית מרופדת. עם גרסת עור וגרסת בד על רגלי מתכת, דניז זמינה בתצורה מודולרית לערכות פינה דינמיות.",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 26763,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "STING": {
    "image_url": "../upload_images/franco_ferri/Relax/STING/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=sting&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/STING/main.jpg",
      "../upload_images/franco_ferri/Relax/STING/1.jpg",
      "../upload_images/franco_ferri/Relax/STING/2.jpg",
      "../upload_images/franco_ferri/Relax/STING/3.jpg"
    ],
    "description": "מורם מהקרקע על ידי רגליים מתכתיות אלגנטיות, Sting מייצג פרויקט דינמי שניתן ליהנות ממנו בהתאם לצרכים שונים בזכות מסעד היד המעודן שיכול לזוז כלפי חוץ ומשענת הגב הנוטה לשנות את עומק המושב. מנגנון נוסף בתוך משענת הגב מגביר את הנוחות שלה בזכות הנטייה של אזור משענת הראש. בין אם בריפוד בד או עור, Sting מציע מגוון רחב של מודולים הזמינים גם עם שזלונג וגם עם פינת סיום.",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 17547,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "VANONI": {
    "image_url": "../upload_images/franco_ferri/Relax/VANONI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=vanoni&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Relax/VANONI/main.jpg",
      "../upload_images/franco_ferri/Relax/VANONI/1.jpg",
      "../upload_images/franco_ferri/Relax/VANONI/2.jpg"
    ],
    "description": "האלגנטיות העדינה של קווי המתאר שלו, הפרטים המעודנים והפונקציונליות המרבית. משענת יד מרובעת ובולטת משלימה את המושב, עם גימור ריפוד גיאומטרי בעבודת יד ותפרים מוצלבים כפולים. וָנוֹנִי, עם ריפוד עור או בד על רגלי מתכת, מהווה קריאה אמיתית להירגעות בזכות הכריות המותניות ומשענת הגב הזזה, המווסתת את עומק הישיבה.",
    "company_name": "franco_ferri",
    "original_category": "Relax",
    "price": 21923,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "FORMOSA": {
    "image_url": "../upload_images/franco_ferri/Modular/FORMOSA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=formosa&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/FORMOSA/main.jpg",
      "../upload_images/franco_ferri/Modular/FORMOSA/1.jpg",
      "../upload_images/franco_ferri/Modular/FORMOSA/2.jpg",
      "../upload_images/franco_ferri/Modular/FORMOSA/3.jpg"
    ],
    "description": "סט ספות מודולרי חדשני, מודרני ומקיף. מרופד בבד, התפרים והצנרת שלו מדגישים את הרכות בקווים המעוגלים של המושבים וגם של משענת הגב. פורמוסה מעוצבת להבטיח תצורות רבות הודות למודולים שלה הכוללים אלמנטים ישרים כמו גם מעוגלים, פופים, שזלונג, והמגוון הרחב של בדים.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 29450,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "DESEO": {
    "image_url": "../upload_images/franco_ferri/Modular/DESEO/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=deseo&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/DESEO/main.jpg",
      "../upload_images/franco_ferri/Modular/DESEO/1.jpg",
      "../upload_images/franco_ferri/Modular/DESEO/2.jpg",
      "../upload_images/franco_ferri/Modular/DESEO/3.jpg"
    ],
    "description": "ספה צעירה, עכשווית ואיקונית עם עיצוב מוצק ומרתק המתאימה לכל סוגי המרחבים. מאופיינת בתפרים עמוקים המדגישים את קווי העקומה שלה ומבליטים את נוחותה, \"דסאו\" מעוצבת באמצעות צנרת מתאר לאורך הסילואטה של צדדיה. ריפוד בבד לפי בחירתך, סט הספה המודולרי הזה מורכב מפריטים מעוגלים וכן שזלונג היכולים ליצור פתרונות שונים עבור חלל המגורים שלך.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 19612,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BELLA BORA": {
    "image_url": "../upload_images/franco_ferri/Modular/BELLA BORA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=bella-bora&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/BELLA BORA/main.jpg",
      "../upload_images/franco_ferri/Modular/BELLA BORA/1.jpg",
      "../upload_images/franco_ferri/Modular/BELLA BORA/2.jpg",
      "../upload_images/franco_ferri/Modular/BELLA BORA/3.jpg"
    ],
    "description": "תפירה א-ריתמית ואלגנטית באיכות אומנותית על משענת הגב והמושב הרציף יוצרת דפוס גיאומטרי שהופך את בלה בורה לספת מודולרית עם ריפוד בד, אופי וסטייל. בשילוב עם מודולים של פוף ושזלונג, יש לה מושב רך ומכני המתכוונן לנוחות מרבית.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 10605,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "TWIN": {
    "image_url": "../upload_images/franco_ferri/Modular/TWIN/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=twin&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/TWIN/main.jpg",
      "../upload_images/franco_ferri/Modular/TWIN/1.jpg",
      "../upload_images/franco_ferri/Modular/TWIN/2.jpg"
    ],
    "description": "טווין הוא ספת מודולרית עם אסתטיקה הרמונית ודגש רב על פונקציונליות. הוא מלא בכריות רכות ונעימות ומעוטר בתפרים עדינים על המשענת והמושב, והוא זמין גם בכיסוי עור וגם בבד. ארגונומיה ונוחות מודגשים באמצעות מושביו הרכים עם ריקליינר חשמלי.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 11945,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "TOLO": {
    "image_url": "../upload_images/franco_ferri/Modular/TOLO/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=tolo&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/TOLO/main.jpg",
      "../upload_images/franco_ferri/Modular/TOLO/1.jpg",
      "../upload_images/franco_ferri/Modular/TOLO/2.jpg",
      "../upload_images/franco_ferri/Modular/TOLO/3.jpg"
    ],
    "description": "חופש, רוגע ויצירתיות: אלו הם חלק מהדרכים הרבות לחוות את הספה הזו, המוגדרת על ידי ריפוד רגיל במשענת הראש ובכרית הישיבה. האפשרות להשתמש במשענת הראש האנכית המתכווננת חשמלית ובמושב המתכוונן מציעה יכולת רגיעה מרבית, בעוד שהמודולריות והריפוד מאפשרים ליצור הרכבים שונים מרשימים הניתנים להתאמה קלה לכל חלל.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 15436,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "MARVEL": {
    "image_url": "../upload_images/franco_ferri/Modular/MARVEL/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=marvel&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/MARVEL/main.jpg",
      "../upload_images/franco_ferri/Modular/MARVEL/1.jpg",
      "../upload_images/franco_ferri/Modular/MARVEL/2.jpg",
      "../upload_images/franco_ferri/Modular/MARVEL/3.jpg"
    ],
    "description": "הבסיס הוא הגיבור של פרויקט החדשני והמודרני של מארוול: \"סומר\" רך, עם תפירה גדולה שנמתחת לאורך שולי בסיס הישיבה הפתוח הנתמך על ידי רגליים מתכתיות. זמין גם בעור וגם בבד, ניתן לארגן אותו בהרכבות מודולריות בצורות ובגדלים שונים, עם כריות גב תפורות המפוזרות כאן ושם.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 13105,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "STOR": {
    "image_url": "../upload_images/franco_ferri/Modular/STOR/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=stor&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/STOR/main.jpg",
      "../upload_images/franco_ferri/Modular/STOR/1.jpg",
      "../upload_images/franco_ferri/Modular/STOR/2.jpg",
      "../upload_images/franco_ferri/Modular/STOR/3.jpg"
    ],
    "description": "האבולוציה המודרנית של הסומייר, Stor, מתוכננת לשימוש מעשי וגמיש בכל הקשר, סגנון ופונקציה. הבסיס, על רגל מתכתית בסגנון מזחלת, מאופיין בתפירה אלגנטית וצפופה בעבודת יד (גם כן זמינה בגרסה חלקה). תוכנן בקפידה בצורות ובפרטים תפורים, כמו השימוש בכריות גב כפולות שניתן למקם בחופשיות ויכולות לעקוב אחר תבנית ישרה, נטויה או מעוגלת.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 27823,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "CESTONE": {
    "image_url": "../upload_images/franco_ferri/Smart/CESTONE/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=cestone&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Smart/CESTONE/main.jpg",
      "../upload_images/franco_ferri/Smart/CESTONE/1.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Smart",
    "price": 11279,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "FABI": {
    "image_url": "../upload_images/franco_ferri/Smart/FABI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=fabi&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Smart/FABI/main.jpg",
      "../upload_images/franco_ferri/Smart/FABI/1.jpg",
      "../upload_images/franco_ferri/Smart/FABI/2.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Smart",
    "price": 28099,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BALTIK": {
    "image_url": "../upload_images/franco_ferri/Smart/BALTIK/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=baltik&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Smart/BALTIK/main.jpg",
      "../upload_images/franco_ferri/Smart/BALTIK/1.jpg",
      "../upload_images/franco_ferri/Smart/BALTIK/2.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Smart",
    "price": 24560,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "MIMÌ": {
    "image_url": "../upload_images/franco_ferri/Smart/MIMÌ/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=mimi&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Smart/MIMÌ/main.jpg",
      "../upload_images/franco_ferri/Smart/MIMÌ/1.jpg",
      "../upload_images/franco_ferri/Smart/MIMÌ/2.jpg",
      "../upload_images/franco_ferri/Smart/MIMÌ/3.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Smart",
    "price": 28331,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "BOE": {
    "image_url": "../upload_images/franco_ferri/Smart/BOE/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=boe&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Smart/BOE/main.jpg",
      "../upload_images/franco_ferri/Smart/BOE/1.jpg",
      "../upload_images/franco_ferri/Smart/BOE/2.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Smart",
    "price": 17045,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },

  "JILL": {
    "image_url": "../upload_images/franco_ferri/Modular/JILL/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=jill&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/JILL/main.jpg",
      "../upload_images/franco_ferri/Modular/JILL/1.jpg",
      "../upload_images/franco_ferri/Modular/JILL/2.jpg",
      "../upload_images/franco_ferri/Modular/JILL/3.jpg",
      "../upload_images/franco_ferri/Modular/JILL/4.jpg"
    ],
    "description": "כורסאת ג'יל מתבלטת בזכות השילוב המשובח של דיוק ואלגנטיות הודות לצורת הקונכייה המחבקת שלה, המעניקה תמיכה ארגונומית. יציבותה מובטחת על ידי רגליה המתכתיות הדקות, שמשלימות את מראה הכורסא הייחודי. כורסאת ג'יל מציגה את עצמה כאייקון של סגנון ונוחות מודרניים, מושלמת להעשיר כל סביבה בנגיעה של קלאס ותחכום.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 29822,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "LAURO": {
    "image_url": "../upload_images/franco_ferri/Modular/LAURO/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=lauro&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/LAURO/main.jpg",
      "../upload_images/franco_ferri/Modular/LAURO/1.jpg",
      "../upload_images/franco_ferri/Modular/LAURO/2.jpg",
      "../upload_images/franco_ferri/Modular/LAURO/3.jpg",
      "../upload_images/franco_ferri/Modular/LAURO/4.jpg"
    ],
    "description": "עם קווים על-זמניים, כורסת לאורו נתמכת על ידי מבנה מעץ ומתכת שממסגר את הכריות עם מוטיב קפיטונֶה אלגנטי במשענת הגב ותפרים עדינים בכרית הישיבה.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 25333,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "BENATI": {
    "image_url": "../upload_images/franco_ferri/Modular/BENATI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=benati&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/BENATI/main.jpg",
      "../upload_images/franco_ferri/Modular/BENATI/1.jpg",
      "../upload_images/franco_ferri/Modular/BENATI/2.jpg",
      "../upload_images/franco_ferri/Modular/BENATI/3.jpg",
      "../upload_images/franco_ferri/Modular/BENATI/4.jpg"
    ],
    "description": "אלגנטיות מחפשת ופרופורציות קומפקטיות לכורסה בנאטי, שמשלבת ערך אסתטי עם נוחות גבוהה. עם קווים עוטפים וצורת מעטפת, כריות מושב ומשענת רכות, הכורסה זמינה בציפויים מעור או בד. נתמכת ברגל ממתכת, התפרים והתיפורים התפורים עוקבים אחרי הקווים ומדגישים את העיצוב המודרני.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 24302,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "ALICUDI": {
    "image_url": "../upload_images/franco_ferri/Modular/ALICUDI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=alicudi&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/ALICUDI/main.jpg",
      "../upload_images/franco_ferri/Modular/ALICUDI/1.jpg",
      "../upload_images/franco_ferri/Modular/ALICUDI/2.jpg",
      "../upload_images/franco_ferri/Modular/ALICUDI/3.jpg",
      "../upload_images/franco_ferri/Modular/ALICUDI/4.jpg"
    ],
    "description": "כורסה בעיצוב עכשווי זה, עם הפרופורציות המושלמות והקווים הארגונומיים שלה, מתאימה לכל סגנון בכל סביבה. דגם אליקודי זמין בשלוש גרסאות שונות וכיסויים מבד או עור: רגלי מתכת, גרסת סיבוב, או בסיס עץ עם הדום תואם.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 17312,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "FRACCO": {
    "image_url": "../upload_images/franco_ferri/Modular/FRACCO/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=fracco&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/FRACCO/main.jpg",
      "../upload_images/franco_ferri/Modular/FRACCO/1.jpg",
      "../upload_images/franco_ferri/Modular/FRACCO/2.jpg",
      "../upload_images/franco_ferri/Modular/FRACCO/3.jpg",
      "../upload_images/franco_ferri/Modular/FRACCO/4.jpg"
    ],
    "description": "ביטוי של רעיון של רוגע מאוזן, עם נפחים וקווים מעוצבים ומוגדרים היטב, לכורסה מודרנית וקומפקטית. הכורסה פרקו מציגה גב מעוגל, עוטף ורציף שיוצר יחידה אחת עם המשענות וכוללת קו מתרחב מאפיין מתחת לכרית הישיבה, אלגנטית וארגונומית. על בסיס מתכתי עגול, היא זמינה גם בגרסה עם ריפוד טקסטיל וגם בעור.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 17551,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "FILICUDI": {
    "image_url": "../upload_images/franco_ferri/Modular/FILICUDI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=filicudi&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/FILICUDI/main.jpg",
      "../upload_images/franco_ferri/Modular/FILICUDI/1.jpg",
      "../upload_images/franco_ferri/Modular/FILICUDI/2.jpg",
      "../upload_images/franco_ferri/Modular/FILICUDI/3.jpg",
      "../upload_images/franco_ferri/Modular/FILICUDI/4.jpg"
    ],
    "description": "אלגנטיות עכשווית ניתנת לפיליקודי ולגופו המוצק, המעצב ועוקב אחר קווי המתאר של הכורסה. היא מועשרת בכריות רכות על משענת הגב והמושב, עם מתאר מעוגל. פיליקודי זמין בשלוש גרסאות שונות וכיסויי בד או עור: גרסה עם רגלי מתכת, מסתובבת, או בסיס עץ עם פוף תואם.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 25694,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "LIPARI": {
    "image_url": "../upload_images/franco_ferri/Modular/LIPARI/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=lipari&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/LIPARI/main.jpg",
      "../upload_images/franco_ferri/Modular/LIPARI/1.jpg",
      "../upload_images/franco_ferri/Modular/LIPARI/2.jpg",
      "../upload_images/franco_ferri/Modular/LIPARI/3.jpg"
    ],
    "description": "ליפארי, המקום שבו הנוחות פוגשת את העיצוב; צללית אלגנטית, נקייה ונצחית שהופכת אותה למתאימה בכל הקשר. עם מושב רחב ומשענת גב מועשרת בפרט הקווילטי המרכזי, ליפארי זמינה בשלוש גרסאות שונות וכיסויים מבד או עור: רגלי מתכת, גרסת סיבוב, או בסיס מעץ עם פוף תואם משלה.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 17616,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "GERARD": {
    "image_url": "../upload_images/franco_ferri/Modular/GERARD/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=gerard&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/GERARD/main.jpg",
      "../upload_images/franco_ferri/Modular/GERARD/1.jpg",
      "../upload_images/franco_ferri/Modular/GERARD/2.jpg"
    ],
    "description": "סגנון קלאסי עם קסם ואלגנטיות, כורסה של ג'רארד, זמינה בכיסוי עור או בד, מועשרת ברגלי המתכת המלוטשות שלה ובמשענת הגב המעוטרת בתפירת כריות עשירה ומעוצבת.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 25136,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "ALFA": {
    "image_url": "../upload_images/franco_ferri/Modular/ALFA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=alfa&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Modular/ALFA/main.jpg",
      "../upload_images/franco_ferri/Modular/ALFA/1.jpg",
      "../upload_images/franco_ferri/Modular/ALFA/2.jpg"
    ],
    "description": "יציב בקוויו המרובעים ונוח בישיבתו, אלפא, עם משענת גב משופעת, נתמך על ידי רגלי מתכת. פרטים בהתאמה אישית כמו כריות מושב מרופדות ותפרים מנוגדים מעשירים את כורסה עדינה והכרחית זו, הזמינה בכיסוי עור או בד.",
    "company_name": "franco_ferri",
    "original_category": "Modular",
    "price": 16077,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "AGON": {
    "image_url": "../upload_images/franco_ferri/Smart/AGON/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=agon&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Smart/AGON/main.jpg",
      "../upload_images/franco_ferri/Smart/AGON/1.jpg",
      "../upload_images/franco_ferri/Smart/AGON/2.jpg",
      "../upload_images/franco_ferri/Smart/AGON/3.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Smart",
    "price": 25095,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "ALASIA": {
    "image_url": "../upload_images/franco_ferri/Smart/ALASIA/main.jpg",
    "product_url": "https://francoferri.it/?portfolio=alasia&lang=en",
    "image_urls": [
      "../upload_images/franco_ferri/Smart/ALASIA/main.jpg",
      "../upload_images/franco_ferri/Smart/ALASIA/1.jpg",
      "../upload_images/franco_ferri/Smart/ALASIA/2.jpg",
      "../upload_images/franco_ferri/Smart/ALASIA/3.jpg"
    ],
    "description": "",
    "company_name": "franco_ferri",
    "original_category": "Smart",
    "price": 11232,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Darwin Suspension Lamp": {
    "image_url": "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/darwin-suspension-lamp_p84502.html?id=728&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/1.jpg",
      "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/2.jpg",
      "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/3.jpg",
      "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/4.jpg",
      "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/5.jpg",
      "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/6.jpg",
      "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/7.jpg",
      "../upload_images/laskasas/Ceiling Lights/Darwin Suspension Lamp/8.jpg"
    ],
    "description": "מנורת התלייה דארווין היא פריט תאורה מעוצב להפליא עם שלושה נורות תליות היוצרות זוהר חם וקורן, המשפר את האפקט הכולל של החלל.",
    "company_name": "Laskasas",
    "original_category": "Ceiling Lights",
    "price": 18566,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Andy suspension lamp": {
    "image_url": "../upload_images/laskasas/Ceiling Lights/Andy suspension lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/andy-suspension-lamp_p5594.html?id=728&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ceiling Lights/Andy suspension lamp/1.jpg",
      "../upload_images/laskasas/Ceiling Lights/Andy suspension lamp/2.jpg",
      "../upload_images/laskasas/Ceiling Lights/Andy suspension lamp/3.jpg",
      "../upload_images/laskasas/Ceiling Lights/Andy suspension lamp/4.jpg",
      "../upload_images/laskasas/Ceiling Lights/Andy suspension lamp/5.jpg",
      "../upload_images/laskasas/Ceiling Lights/Andy suspension lamp/6.jpg"
    ],
    "description": "מנורת התלייה אנדי מתאפיינת בקווים מתעגלים שמייצרים אלמנט תאורה מרשים לסלונים רומנטיים. המנורה מתהדרת במבנה מתכתי ובעיצוב פשוט, עם מסך עגול שמדגיש את היופי של כל עיצוב ותפיסת דקורציה.",
    "company_name": "Laskasas",
    "original_category": "Ceiling Lights",
    "price": 20994,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Janis suspension lamp": {
    "image_url": "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/janis-suspension-lamp_p5567.html?id=728&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/1.jpg",
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/2.jpg",
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/3.jpg",
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/4.jpg",
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/5.jpg",
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/6.jpg",
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/7.jpg",
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/8.jpg",
      "../upload_images/laskasas/Ceiling Lights/Janis suspension lamp/9.jpg"
    ],
    "description": "מנורת התליה Janis כוללת תמיכת תקרה מפלדת אל-חלד ומעוצבת בהשראת יופיין של הבועות. המנורה כוללת שתי נורות לבנות עגולות המצביעות לכיוונים שונים, מה שהופך אותה לתליון ייחודי ולא קונבנציונלי לעיצוב מודרני מתקופת אמצע המאה.",
    "company_name": "Laskasas",
    "original_category": "Ceiling Lights",
    "price": 27905,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Jazz Suspension Lamp": {
    "image_url": "../upload_images/laskasas/Ceiling Lights/Jazz Suspension Lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/jazz-suspension-lamp_p5569.html?id=728&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ceiling Lights/Jazz Suspension Lamp/1.jpg",
      "../upload_images/laskasas/Ceiling Lights/Jazz Suspension Lamp/2.jpg",
      "../upload_images/laskasas/Ceiling Lights/Jazz Suspension Lamp/3.jpg",
      "../upload_images/laskasas/Ceiling Lights/Jazz Suspension Lamp/4.jpg",
      "../upload_images/laskasas/Ceiling Lights/Jazz Suspension Lamp/5.jpg",
      "../upload_images/laskasas/Ceiling Lights/Jazz Suspension Lamp/6.jpg"
    ],
    "description": "מנורת התלייה ג'אז היא יצירה בעבודת יד המלאה בפרטים יוקרתיים. היא כוללת עשר צינורות נופלים בגימורים שונים, התלויים על חוטים עדינים, מה שהופך אותה לתוספת המושלמת לחדרים עם תקרות גבוהות.",
    "company_name": "Laskasas",
    "original_category": "Ceiling Lights",
    "price": 23742,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Meredith Chandelier": {
    "image_url": "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/meredith-chandelier_p5571.html?id=728&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/1.jpg",
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/2.jpg",
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/3.jpg",
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/4.jpg",
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/5.jpg",
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/6.jpg",
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/7.jpg",
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/8.jpg",
      "../upload_images/laskasas/Ceiling Lights/Meredith Chandelier/9.jpg"
    ],
    "description": "נברשת מרדית' היא יצירה יוקרתית בעבודת יד בעלת מבנה מתכתי ופרטים מיוחדים. היא כוללת שני מפלסי תאורה, בכל מפלס שני נורות המצביעות בכיוונים שונים, המספקות אור שופע לחדר האוכל שלך.",
    "company_name": "Laskasas",
    "original_category": "Ceiling Lights",
    "price": 12299,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Randolph suspension lamp": {
    "image_url": "../upload_images/laskasas/Ceiling Lights/Randolph suspension lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/randolph-suspension-lamp_p5555.html?id=728&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ceiling Lights/Randolph suspension lamp/1.jpg",
      "../upload_images/laskasas/Ceiling Lights/Randolph suspension lamp/2.jpg",
      "../upload_images/laskasas/Ceiling Lights/Randolph suspension lamp/3.jpg",
      "../upload_images/laskasas/Ceiling Lights/Randolph suspension lamp/4.jpg",
      "../upload_images/laskasas/Ceiling Lights/Randolph suspension lamp/5.jpg",
      "../upload_images/laskasas/Ceiling Lights/Randolph suspension lamp/6.jpg"
    ],
    "description": "מנורת התליה רנדולף היא גישה חדשה לעיצוב מודרני. המנורה כוללת שני אהילים המצביעים בכיוונים מנוגדים, מה שהופך אותה למושלמת למשרדים ביתיים מודרניים או לחדרי שינה ראשיים עכשוויים.",
    "company_name": "Laskasas",
    "original_category": "Ceiling Lights",
    "price": 11300,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Robert chandelier": {
    "image_url": "../upload_images/laskasas/Ceiling Lights/Robert chandelier/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/robert-chandelier_p5588.html?id=728&cat=513&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/1.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/2.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/3.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/4.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/5.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/6.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/7.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/8.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/9.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/10.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/11.jpg",
      "../upload_images/laskasas/Ceiling Lights/Robert chandelier/12.jpg"
    ],
    "description": "נברשת רוברט היא אפשרות תאורה מודרנית משנות האמצע שמשלבת את התשוקה של לאסקאס לחומרים וצורות שונים. מוגדרת על ידי קווים עדינים, היא יכולה להתאים לכל סגנון או סוג של קישוט ומהווה יצירת אמנות יוצאת דופן לעיצוב כל חדר.",
    "company_name": "Laskasas",
    "original_category": "Ceiling Lights",
    "price": 16205,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Clarke floor lamp": {
    "image_url": "../upload_images/laskasas/Floor Lights/Clarke floor lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/clarke-floor-lamp_p4800.html?id=731&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Floor Lights/Clarke floor lamp/1.jpg",
      "../upload_images/laskasas/Floor Lights/Clarke floor lamp/2.jpg",
      "../upload_images/laskasas/Floor Lights/Clarke floor lamp/3.jpg",
      "../upload_images/laskasas/Floor Lights/Clarke floor lamp/4.jpg"
    ],
    "description": "המנורה העומדת \"קלארק\" מתהדרת במראה ייחודי ומרשים עם אהיל זכוכית כדורי גדול ובסיס שיש מוצק. זוהי מנורה אופנתית ביותר שתמשוך תשומת לב בכל חדר בפרויקט עיצוב הפנים שלך.",
    "company_name": "Laskasas",
    "original_category": "Floor Lights",
    "price": 19553,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Evans floor lamp": {
    "image_url": "../upload_images/laskasas/Floor Lights/Evans floor lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/evans-floor-lamp_p4803.html?id=731&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Floor Lights/Evans floor lamp/1.jpg",
      "../upload_images/laskasas/Floor Lights/Evans floor lamp/2.jpg",
      "../upload_images/laskasas/Floor Lights/Evans floor lamp/3.jpg",
      "../upload_images/laskasas/Floor Lights/Evans floor lamp/4.jpg",
      "../upload_images/laskasas/Floor Lights/Evans floor lamp/5.jpg",
      "../upload_images/laskasas/Floor Lights/Evans floor lamp/6.jpg"
    ],
    "description": "מנורת הרצפה אוונס היא תוספת מינימליסטית וסטייליסטית לחדר מגורים, חדר שינה או מסדרון בעיצוב עכשווי. היא כוללת עיצוב נקי עם בסיס שיש נמוך ומבנה מברזל או פלדה, מה שהופך אותה לתוספת תאורה נהדרת לפרויקט העיצוב שלך.",
    "company_name": "Laskasas",
    "original_category": "Floor Lights",
    "price": 10800,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Jones Floor Lamp": {
    "image_url": "../upload_images/laskasas/Floor Lights/Jones Floor Lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/jones-floor-lamp_p4918.html?id=731&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Floor Lights/Jones Floor Lamp/1.jpg",
      "../upload_images/laskasas/Floor Lights/Jones Floor Lamp/2.jpg",
      "../upload_images/laskasas/Floor Lights/Jones Floor Lamp/3.jpg"
    ],
    "description": "מנורת הרצפה ג'ונס היא פריט בעבודת יד מאומני Laskasas, הכוללת מבנה מתכת ומייצגת את הקסם של הפשטות. הקווים הישרים שלה מחזיקים את כדור המנורה והופכים אותה לפריט מרשים עבור כל חדר או פרויקט עיצוב פנים.",
    "company_name": "Laskasas",
    "original_category": "Floor Lights",
    "price": 27815,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Randolph floor lamp": {
    "image_url": "../upload_images/laskasas/Floor Lights/Randolph floor lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/randolph-floor-lamp_p5578.html?id=731&cat=513&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/1.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/2.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/3.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/4.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/5.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/6.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/7.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/8.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/9.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/10.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/11.jpg",
      "../upload_images/laskasas/Floor Lights/Randolph floor lamp/12.jpg"
    ],
    "description": "מנורת הרצפה רנדולף, ממשפחת רנדולף, מוסיפה אפילו יותר סטייל לכל עיצוב. היא כוללת רגליים ומבנה מברזל, ומתאימה לתאורה סביבתית עם נקודת אור אחת בלבד. היא מציגה את אומנות הייצור האיכותית שלשמה ידועה Laskasas.",
    "company_name": "Laskasas",
    "original_category": "Floor Lights",
    "price": 13936,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Marcel Table Lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Marcel Table Lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/marcel-table-lamp_p5549.html?id=732&cat=513&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/6.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/7.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/8.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/9.jpg",
      "../upload_images/laskasas/Table Lights/Marcel Table Lamp/10.jpg"
    ],
    "description": "מנורת שולחן מרסל היא עיצוב אייקוני בעבודת יד ממרבל הכולל פרטים מתכתיים לתוספת של זוהר. מנורות שולחן הן יותר מאשר מקורות תאורה בלבד; הן פריטי אמנות שימושיים ומרהיבים שמעניקים לחללי המגורים שלכם אווירה של תחכום וקסם.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 15724,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Franklin table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Franklin table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/franklin-table-lamp_p6391.html?id=732&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Franklin table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Franklin table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Franklin table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Franklin table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Franklin table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Franklin table lamp/6.jpg"
    ],
    "description": "מנורת שולחן פרנקלין היא עיצוב מתוחכם עם קווים מעוגלים וחומרים אצילים, מושלמת כנקודת מוקד לא צפויה בסלון, באולמות כניסה וכמנורת שולחן ליד המיטה.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 11550,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Jones table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Jones table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/jones-table-lamp_p4662.html?id=732&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Jones table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Jones table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Jones table lamp/3.jpg"
    ],
    "description": "מנורת השולחן ג'ונס היא פריט רב-תכליתי עם מבנה ברזל מינימליסטי ייחודי בצורת ריבוע שיוצר זוויות חדשות לתאורת אווירה, בעוד הנורה העגולה מזכוכית שקופה מוסיפה ניגודיות. בין אם אתם מעדיפים נופך מסורתי או הצהרה מודרנית, מנורות השולחן שלנו לסלון מציעות מגוון בחירות שתואמות את האסתטיקה שלכם.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 10583,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Clarke table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Clarke table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/clarke-table-lamp_p4799.html?id=732&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Clarke table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Clarke table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Clarke table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Clarke table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Clarke table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Clarke table lamp/6.jpg"
    ],
    "description": "",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 15653,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Walker table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Walker table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/walker-table-lamp_p4801.html?id=732&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Walker table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Walker table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Walker table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Walker table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Walker table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Walker table lamp/6.jpg"
    ],
    "description": "מנורת השולחן ווקר היא עיצוב קלאסי שבולט בכל סביבה ומתאימה כפריט דקורטיבי לכל שולחן.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 16296,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Wright table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Wright table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/wright-table-lamp_p4802.html?id=732&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Wright table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Wright table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Wright table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Wright table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Wright table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Wright table lamp/6.jpg"
    ],
    "description": "מנורת השולחן רייט מוסיפה נופך של תחכום לכל חלל עם אפשרויות בסיס מתכת מותאמות אישית. העיצוב המלוטש שלה הופך אותה לתוספת מושלמת לכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 29533,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Little Jack table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Little Jack table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/little-jack-table-lamp_p5553.html?id=732&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/6.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/7.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/8.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/9.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/10.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/11.jpg",
      "../upload_images/laskasas/Table Lights/Little Jack table lamp/12.jpg"
    ],
    "description": "הוסף נגיעה של אלגנטיות לסלון או לחדר השינה שלך עם מנורות השולחן הייחודיות שלנו. בין אם אתה מעדיף את הקסם הנצחי של מנורת שולחן מוזהבת או את הסופיסטיקציה המודרנית של מנורת שולחן שחורה, האוסף שלנו מציע מגוון מנורות שולחן לסלונים ולחדרי שינה, המאפשרות לך להאיר את המרחב שלך בסטייל.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 12894,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Jack Table Lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Jack Table Lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/jack-table-lamp_p5559.html?id=732&cat=513&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/6.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/7.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/8.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/9.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/10.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/11.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/12.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/13.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/14.jpg",
      "../upload_images/laskasas/Table Lights/Jack Table Lamp/15.jpg"
    ],
    "description": "מנורת שולחן מפוארת בעבודת יד עשויה משיש ובעלת פרטים מטאליים, אידיאלית לחדרי שינה, אולמות כניסה וחדרי מגורים. כשמדובר בשיפור האסתטיקה והפונקציונליות של חדר שינה, מנורת השולחן הנכונה יכולה לעשות את כל ההבדל.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 25360,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Quentin table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Quentin table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/quentin-table-lamp_p5600.html?id=732&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Quentin table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/6.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/7.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/8.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/9.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/10.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/11.jpg",
      "../upload_images/laskasas/Table Lights/Quentin table lamp/12.jpg"
    ],
    "description": "מנורת השולחן קוונטין היא מנורת שולחן עשויה שיש בעבודת יד, עם פרטים מתכתיים ובסיס מרובע עם אהיל עגול ליצירת ניגוד גיאומטרי מעניין, מושלמת לאולמות כניסה.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 27754,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Martin table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Martin table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/martin-table-lamp_p5564.html?id=732&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Martin table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Martin table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Martin table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Martin table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Martin table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Martin table lamp/6.jpg",
      "../upload_images/laskasas/Table Lights/Martin table lamp/7.jpg",
      "../upload_images/laskasas/Table Lights/Martin table lamp/8.jpg"
    ],
    "description": "מנורת השולחן מרטין היא מנורה קלאסית גבוהה עם מבנה שיש גלילי ופרטים מתכתיים, ניתנת להתאמה אישית ומושלמת לפרויקטים בעיצוב פנים מודרני ועכשווי.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 14397,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Jude table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Jude table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/jude-table-lamp_p4663.html?id=732&cat=513&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Jude table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Jude table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Jude table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Jude table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Jude table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Jude table lamp/6.jpg"
    ],
    "description": "מנורת השולחן ג'וד היא פריט דקורטיבי המשלב את האלגנטיות של עיצוב קלאסי עם האומנות של Laskasas. עשויה ביד משיש ועץ, ומסתיימת עם פרטים מתכתיים וצבעים חמימים, זו התוספת המושלמת לכל משרד ביתי מודרני. הצורה הקונית של הבסיס מוסיפה ממד ועניין לפריט.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 26659,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Sharon Table Lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Sharon Table Lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/sharon-table-lamp_p5576.html?id=732&cat=513&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/6.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/7.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/8.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/9.jpg",
      "../upload_images/laskasas/Table Lights/Sharon Table Lamp/10.jpg"
    ],
    "description": "מנורת השולחן שרון מקרינה יוקרה עם בסיס השיש המתוחכם שלה ופרטי הנירוסטה. הצורה העגולה של המנורה יוצרת אווירה מפוארת בכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 19144,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Smith table lamp": {
    "image_url": "../upload_images/laskasas/Table Lights/Smith table lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/smith-table-lamp_p5603.html?id=732&cat=513&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Table Lights/Smith table lamp/1.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/2.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/3.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/4.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/5.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/6.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/7.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/8.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/9.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/10.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/11.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/12.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/13.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/14.jpg",
      "../upload_images/laskasas/Table Lights/Smith table lamp/15.jpg"
    ],
    "description": "מנורת השולחן סמית היא יצירת אמנות שמתכתבת עם הקלאסיקות וכוללת שכבות אינסופיות של גימורים וחומרים, מה שהופך אותה לגוף תאורה אידיאלי עבור אולמות כניסה, חדרי שינה ראשיים או חדרי אוכל.",
    "company_name": "Laskasas",
    "original_category": "Table Lights",
    "price": 17139,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Dave wall lamp": {
    "image_url": "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/dave-wall-lamp_p5592.html?id=733&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/1.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/2.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/3.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/4.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/5.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/6.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/7.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Dave wall lamp/8.jpg"
    ],
    "description": "מנורת קיר דייב היא מנורת קיר מודרנית היוצרת אור אווירה רך תוך הענקת מימד למרחב, ומתאפיינת בעיצוב מינימליסטי עשוי שיש ומתכת.",
    "company_name": "Laskasas",
    "original_category": "Wall and Surface Lights",
    "price": 20315,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Jackson's wall lamp": {
    "image_url": "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/jacksons-wall-lamp_p5583.html?id=733&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/1.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/2.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/3.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/4.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/5.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/6.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/7.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Jackson's wall lamp/8.jpg"
    ],
    "description": "מנורת הקיר של ג'קסון היא גופי התאורה המושלמים להציג בלובי של מלון יוקרתי או באולם כניסה מקסים.",
    "company_name": "Laskasas",
    "original_category": "Wall and Surface Lights",
    "price": 22693,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Lord Wall Lamp": {
    "image_url": "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/1.jpg",
    "product_url": "https://www.laskasas.com/en/lighting/lord-wall-lamp_p5581.html?id=733&cat=513&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/1.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/2.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/3.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/4.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/5.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/6.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/7.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/8.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/9.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/10.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/11.jpg",
      "../upload_images/laskasas/Wall and Surface Lights/Lord Wall Lamp/12.jpg"
    ],
    "description": "מנורת הקיר לורד משקפת את התשוקה של Laskasas לפרש מחדש את העבר באמצעות אלמנטים ופרספקטיבות מודרניות.",
    "company_name": "Laskasas",
    "original_category": "Wall and Surface Lights",
    "price": 21595,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Tadeas Armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Tadeas Armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/tadeas-armchair_p9726.html?id=735&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Tadeas Armchair/16.jpg"
    ],
    "description": "כורסאת טדיאס עם משענת גב מעור מוסיפה אלמנט מלוטש ומעודן לעיצוב הפנים שלך. העיצוב הרב-תכליתי והמבחר הצבעים שלה מאפשרים לה להשתלב בצורה חלקה בכל תכנית עיצוב, ממודרנית ועד מסורתית. משענת הגב מעור מוסיפה נגיעה של אלגנטיות ומרקם לחדר.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 25299,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Veera Armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Veera Armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/veera-armchair_p84296.html?id=735&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Veera Armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Veera Armchair/16.jpg"
    ],
    "description": "וירה היא כורסה עם אווירת ארט-דקו סופר מגניבה עם ניגוד נחמד של חומרים. הסגנון הייחודי שלה יוסיף נופך של תחכום לכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 13661,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Sophia Armchair with Ottoman": {
    "image_url": "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/sophia-armchair-with-ottoman_p5416.html?id=735&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/1.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/2.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/3.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/4.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/5.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/6.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/7.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/8.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/9.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/10.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/11.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/12.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/13.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/14.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/15.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/16.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/17.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/18.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/19.jpg",
      "../upload_images/laskasas/Armchairs/Sophia Armchair with Ottoman/20.jpg"
    ],
    "description": "כורסה עם גב מעוגל מרופדת בקטיפה עם בסיס מתכת. אלגנטית, מודרנית ונוחה מאוד. היא תשנה לחלוטין את עיצוב הסלון שלך.\n\n*התמונות, הצבעים והגימורים המוצגים הם בתלת-ממד. ייתכנו הבדלים במציאות.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 16313,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Keros Armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Keros Armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/keros-armchair_p8100.html?id=735&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Keros Armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Keros Armchair/16.jpg"
    ],
    "description": "כיסא הידיים קיירוס הוא כיסא מודרני עם רגליים ומושב דקים. העיצוב המינימליסטי נוח ואלגנטי, מה שהופך אותו לתוספת מושלמת לכל חדר בביתך.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 22437,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Amalfi Armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Amalfi Armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/amalfi-armchair_p5411.html?id=735&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Amalfi Armchair/16.jpg"
    ],
    "description": "עמאלפי הוא כורסה נוחה ויפה שהיא ה\"פופ\" בכל חלל. כל מי שנכנס בדלת יצטרך לשבת בה.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 16688,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Ambrose armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Ambrose armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/ambrose-armchair_p5404.html?id=735&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Ambrose armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Ambrose armchair/16.jpg"
    ],
    "description": "אמברוז הוא כורסה אהובה שתמיד בשיא הפופולריות, עם בד יוקרתי העוטף את הגב, הידיים והמושב הארגונומיים לכורסה מתוחכמת ונוחה.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 10099,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Hector armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Hector armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/hector-armchair_p4539.html?id=735&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Hector armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Hector armchair/16.jpg"
    ],
    "description": "הקטור הוא פריט הצהרה עם מראה טוב ונוחות המשתלבים יחד. העיצוב הנועז שלו הופך אותו למוקד בכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 24529,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Xangai Armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Xangai Armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/xangai-armchair_p4546.html?id=735&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Xangai Armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Xangai Armchair/16.jpg"
    ],
    "description": "שנחאי הוא כיסא מודרני שהוא גם מובנה וגם נוח. הוא משתלב היטב עם כמעט כל סגנון.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 15696,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Nelly armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Nelly armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/nelly-armchair_p5429.html?id=735&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Nelly armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Nelly armchair/16.jpg"
    ],
    "description": "נלי היא כורסה יציבה, עמידה ונוחה שמתאימה היטב לכל סוגי החללים. הקווים הנקיים שלה הופכים אותה לפריט על-זמני.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 24703,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Cosy armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Cosy armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/cosy-armchair_p5421.html?id=735&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Cosy armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/16.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/17.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/18.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/19.jpg",
      "../upload_images/laskasas/Armchairs/Cosy armchair/20.jpg"
    ],
    "description": "כורסה היא כורסת פסל שמביאה תחכום לכל חלל. זוהי יצירת המופת האולטימטיבית של Laskasas לנוחות.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 27362,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Harold armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Harold armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/harold-armchair_p5426.html?id=735&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Harold armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/16.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/17.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/18.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/19.jpg",
      "../upload_images/laskasas/Armchairs/Harold armchair/20.jpg"
    ],
    "description": "הרולד הוא כורסה מעודנת עם מראה פשוט אך נוחות רבה. יש לה קווים מעוגלים והיא מושלמת למגורים יוקרתיים.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 12187,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Joe armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Joe armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/joe-armchair_p5399.html?id=735&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Joe armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/16.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/17.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/18.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/19.jpg",
      "../upload_images/laskasas/Armchairs/Joe armchair/20.jpg"
    ],
    "description": "ג'ו הוא כורסה רב-תכליתית שמושכת תשומת לב בכל חלל וניתנת לשימוש בסביבה לא פורמלית וגם אלגנטית. הרב-תכליתיות שלה הופכת אותה להוספה נהדרת לכל בית.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 20790,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Marlow armchair": {
    "image_url": "../upload_images/laskasas/Armchairs/Marlow armchair/1.jpg",
    "product_url": "https://www.laskasas.com/en/armchairs/marlow-armchair_p5440.html?id=735&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Armchairs/Marlow armchair/1.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/2.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/3.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/4.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/5.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/6.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/7.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/8.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/9.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/10.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/11.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/12.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/13.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/14.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/15.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/16.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/17.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/18.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/19.jpg",
      "../upload_images/laskasas/Armchairs/Marlow armchair/20.jpg"
    ],
    "description": "מרלו הוא כורסה מזמינה שנראית כאילו היא מרחפת מעל בסיס מתכת דק. הוא מוסיף אלגנטיות לכל חדר ומתאים מאוד לסיבובים.",
    "company_name": "Laskasas",
    "original_category": "Armchairs",
    "price": 29653,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Jayne Bar Stool": {
    "image_url": "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-and-counter-stools/jayne-bar-stool_p84472.html?id=736&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/1.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/2.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/3.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/4.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/5.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/6.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/7.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/8.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/9.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/10.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/11.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/12.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/13.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/14.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/15.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/16.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/17.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/18.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/19.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Jayne Bar Stool/20.jpg"
    ],
    "description": "ג'יין היא ההגדרה של תחכום בכיסא בר. עם מושב רך ומפנק ומשענת גב מעוצבת לנוחות מרבית, אלו הם כיסאות הבר המושלמים לאי במטבח או לכל מיקום בר ביתי.",
    "company_name": "Laskasas",
    "original_category": "Bar & Counter Stools",
    "price": 28502,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Peter Bar Stool": {
    "image_url": "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-and-counter-stools/peter-bar-stool_p6243.html?id=736&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/1.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/2.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/3.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/4.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/5.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/6.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/7.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Peter Bar Stool/8.jpg"
    ],
    "description": "הכיסא בר פיטר הוא עיצוב קלאסי הכולל גב מלבני ושלד בעל ארבע רגליים, מה שהופך אותו למתאים במיוחד עבור ברים בהשראת וינטג' או אזורי טרקלין בבתים מעוצבים.",
    "company_name": "Laskasas",
    "original_category": "Bar & Counter Stools",
    "price": 25686,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Estoril Bar Stool": {
    "image_url": "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-and-counter-stools/estoril-bar-stool_p6246.html?id=736&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/1.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/2.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/3.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/4.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/5.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/6.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/7.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/8.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/9.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/10.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/11.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/12.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/13.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/14.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/15.jpg",
      "../upload_images/laskasas/Bar & Counter Stools/Estoril Bar Stool/16.jpg"
    ],
    "description": "שרפרף הבר אשטוריל הוא פריט אופנתי שמשלב עיצוב אמצע המאה עם טוויסט מודרני, מה שהופך אותו לתוספת מצוינת לכל בר ביתי.",
    "company_name": "Laskasas",
    "original_category": "Bar & Counter Stools",
    "price": 16938,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Bruny Bed": {
    "image_url": "../upload_images/laskasas/Beds/Bruny Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/bruny-bed_p8111.html?id=737&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/Bruny Bed/1.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/2.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/3.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/4.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/5.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/6.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/7.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/8.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/9.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/10.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/11.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/12.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/13.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/14.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/15.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/16.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/17.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/18.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/19.jpg",
      "../upload_images/laskasas/Beds/Bruny Bed/20.jpg"
    ],
    "description": "המיטה ברוני היא מיטה אלגנטית ומינימליסטית. העיצוב הייחודי של מיטה זו הופך אותה לתוספת נהדרת לכל פרויקט חדר שינה שדורש נוחות, סגנון ופונקציונליות.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 23313,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Dangar Bed": {
    "image_url": "../upload_images/laskasas/Beds/Dangar Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/dangar-bed_p8107.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Dangar Bed/1.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/2.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/3.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/4.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/5.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/6.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/7.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/8.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/9.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/10.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/11.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/12.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/13.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/14.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/15.jpg",
      "../upload_images/laskasas/Beds/Dangar Bed/16.jpg"
    ],
    "description": "מיטת דנגר מציעה מראה מינימליסטי, ראש מיטה נוח ובנייה חזקה שתימשך לשנים רבות.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 10750,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Gray Bed": {
    "image_url": "../upload_images/laskasas/Beds/Gray Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/gray-bed_p84477.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Gray Bed/1.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/2.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/3.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/4.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/5.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/6.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/7.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/8.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/9.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/10.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/11.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/12.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/13.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/14.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/15.jpg",
      "../upload_images/laskasas/Beds/Gray Bed/16.jpg"
    ],
    "description": "אפור הוא מיטה חלומית שמגלמת נוחות ואלגנטיות. עם המראה המינימליסטי שלה וראש המיטה המרופד ללא רבב, היא מציעה קסם אינסופי שהופך כל חדר שינה למקלט.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 26589,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Jody Bed": {
    "image_url": "../upload_images/laskasas/Beds/Jody Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/jody-bed_p9545.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Jody Bed/1.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/2.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/3.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/4.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/5.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/6.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/7.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/8.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/9.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/10.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/11.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/12.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/13.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/14.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/15.jpg",
      "../upload_images/laskasas/Beds/Jody Bed/16.jpg"
    ],
    "description": "המיטה של ג'ודי היא רהיט מרהיב שמשדר יוקרה ואלגנטיות. המיטה מעוצבת בקו מלוטש ומודרני, עם מסגרת נמוכה ומשענת ראש נוחה.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 25141,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Teri Bed": {
    "image_url": "../upload_images/laskasas/Beds/Teri Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/teri-bed_p9549.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Teri Bed/1.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/2.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/3.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/4.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/5.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/6.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/7.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/8.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/9.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/10.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/11.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/12.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/13.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/14.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/15.jpg",
      "../upload_images/laskasas/Beds/Teri Bed/16.jpg"
    ],
    "description": "תרי הוא רהיט מוצק עם בנייה, התאמה וגימור שאין להם אח ורע. זהו פריט השולט בחדר ש יזכה לשאלות רבות ולהרבה התפעלות.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 11426,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Bonnie bed": {
    "image_url": "../upload_images/laskasas/Beds/Bonnie bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/bonnie-bed_p6201.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Bonnie bed/1.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/2.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/3.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/4.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/5.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/6.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/7.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/8.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/9.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/10.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/11.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/12.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/13.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/14.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/15.jpg",
      "../upload_images/laskasas/Beds/Bonnie bed/16.jpg"
    ],
    "description": "בוני היא מיטה אופנתית ובעלת השפעה חזקה, שמוסיפה אמירה יפה לרהיטים. המיטה תוכננה מתוך מחשבה על נוחות ופונקציונליות, וכוללת מטען לטלפון המובנה בשידות הלילה.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 25309,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Brooke bed": {
    "image_url": "../upload_images/laskasas/Beds/Brooke bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/brooke-bed_p4812.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Brooke bed/1.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/2.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/3.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/4.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/5.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/6.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/7.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/8.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/9.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/10.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/11.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/12.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/13.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/14.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/15.jpg",
      "../upload_images/laskasas/Beds/Brooke bed/16.jpg"
    ],
    "description": "ברוק הוא מיטה שמושכת תשומת לב ומתוכננת להיות מרשימה במיוחד. למיטה בסיס מעץ ומסעד ראש מרופד, המושלם למי שאוהב להישען אחורה ולקרוא או לצפות בטלוויזיה במיטה. כדי להמשיך את המראה המודרני, התאימו את ברוק עם שידות לילה מבסיס עץ מלא או מתכת.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 22964,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Harry bed": {
    "image_url": "../upload_images/laskasas/Beds/Harry bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/harry-bed_p4551.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Harry bed/1.jpg",
      "../upload_images/laskasas/Beds/Harry bed/2.jpg",
      "../upload_images/laskasas/Beds/Harry bed/3.jpg",
      "../upload_images/laskasas/Beds/Harry bed/4.jpg",
      "../upload_images/laskasas/Beds/Harry bed/5.jpg",
      "../upload_images/laskasas/Beds/Harry bed/6.jpg",
      "../upload_images/laskasas/Beds/Harry bed/7.jpg",
      "../upload_images/laskasas/Beds/Harry bed/8.jpg",
      "../upload_images/laskasas/Beds/Harry bed/9.jpg",
      "../upload_images/laskasas/Beds/Harry bed/10.jpg",
      "../upload_images/laskasas/Beds/Harry bed/11.jpg",
      "../upload_images/laskasas/Beds/Harry bed/12.jpg",
      "../upload_images/laskasas/Beds/Harry bed/13.jpg",
      "../upload_images/laskasas/Beds/Harry bed/14.jpg",
      "../upload_images/laskasas/Beds/Harry bed/15.jpg",
      "../upload_images/laskasas/Beds/Harry bed/16.jpg"
    ],
    "description": "הארי הוא מיטה יפה שתזכה לתגובות מצד אנשים שמבקרים בבית שלך. היא מקבלת חמישה כוכבים מבחינת מראה ומציעה מגוון אפשרויות צבע ומרקם.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 26450,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Lauren Bed": {
    "image_url": "../upload_images/laskasas/Beds/Lauren Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/lauren-bed_p6226.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Lauren Bed/1.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/2.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/3.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/4.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/5.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/6.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/7.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/8.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/9.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/10.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/11.jpg",
      "../upload_images/laskasas/Beds/Lauren Bed/12.jpg"
    ],
    "description": "לורן היא מיטה פשוטה ואלגנטית שמשקפת אישיות ונוחות. זו בחירה נהדרת אם זה מה שחיפשת.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 11276,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Anny bed": {
    "image_url": "../upload_images/laskasas/Beds/Anny bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/anny-bed_p6241.html?id=737&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Beds/Anny bed/1.jpg",
      "../upload_images/laskasas/Beds/Anny bed/2.jpg",
      "../upload_images/laskasas/Beds/Anny bed/3.jpg",
      "../upload_images/laskasas/Beds/Anny bed/4.jpg",
      "../upload_images/laskasas/Beds/Anny bed/5.jpg",
      "../upload_images/laskasas/Beds/Anny bed/6.jpg",
      "../upload_images/laskasas/Beds/Anny bed/7.jpg",
      "../upload_images/laskasas/Beds/Anny bed/8.jpg",
      "../upload_images/laskasas/Beds/Anny bed/9.jpg",
      "../upload_images/laskasas/Beds/Anny bed/10.jpg",
      "../upload_images/laskasas/Beds/Anny bed/11.jpg",
      "../upload_images/laskasas/Beds/Anny bed/12.jpg",
      "../upload_images/laskasas/Beds/Anny bed/13.jpg",
      "../upload_images/laskasas/Beds/Anny bed/14.jpg",
      "../upload_images/laskasas/Beds/Anny bed/15.jpg",
      "../upload_images/laskasas/Beds/Anny bed/16.jpg"
    ],
    "description": "אנני היא מיטה ייחודית ומוגבהת שאנחנו פשוט אוהבים. הבד רך להישען עליו, הוא נראה עדין מאוד והוא בהחלט ישפר את איכות השינה שלך.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 21538,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Cantao Bed": {
    "image_url": "../upload_images/laskasas/Beds/Cantao Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/cantao-bed_p4737.html?id=737&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/Cantao Bed/1.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/2.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/3.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/4.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/5.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/6.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/7.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/8.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/9.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/10.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/11.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/12.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/13.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/14.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/15.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/16.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/17.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/18.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/19.jpg",
      "../upload_images/laskasas/Beds/Cantao Bed/20.jpg"
    ],
    "description": "מיטה קנטאו, המתאפיינת במבנה חזק, ראש מיטה רך ועיצוב מותאם ללילות שלווים, היא המקום המושלם להרגעות ולהרגיש את ההשפעה החיובית של נוחות מתמשכת.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 26941,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Corin Bed": {
    "image_url": "../upload_images/laskasas/Beds/Corin Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/corin-bed_p6211.html?id=737&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/Corin Bed/1.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/2.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/3.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/4.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/5.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/6.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/7.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/8.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/9.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/10.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/11.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/12.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/13.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/14.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/15.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/16.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/17.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/18.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/19.jpg",
      "../upload_images/laskasas/Beds/Corin Bed/20.jpg"
    ],
    "description": "קורין היא מיטה נוחה ומעוצבת היטב, בגובה המושלם. היא תשמח אותך במשך שנים רבות.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 25102,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Duane bed": {
    "image_url": "../upload_images/laskasas/Beds/Duane bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/duane-bed_p6218.html?id=737&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/Duane bed/1.jpg",
      "../upload_images/laskasas/Beds/Duane bed/2.jpg",
      "../upload_images/laskasas/Beds/Duane bed/3.jpg",
      "../upload_images/laskasas/Beds/Duane bed/4.jpg",
      "../upload_images/laskasas/Beds/Duane bed/5.jpg",
      "../upload_images/laskasas/Beds/Duane bed/6.jpg",
      "../upload_images/laskasas/Beds/Duane bed/7.jpg",
      "../upload_images/laskasas/Beds/Duane bed/8.jpg",
      "../upload_images/laskasas/Beds/Duane bed/9.jpg",
      "../upload_images/laskasas/Beds/Duane bed/10.jpg",
      "../upload_images/laskasas/Beds/Duane bed/11.jpg",
      "../upload_images/laskasas/Beds/Duane bed/12.jpg",
      "../upload_images/laskasas/Beds/Duane bed/13.jpg",
      "../upload_images/laskasas/Beds/Duane bed/14.jpg",
      "../upload_images/laskasas/Beds/Duane bed/15.jpg",
      "../upload_images/laskasas/Beds/Duane bed/16.jpg",
      "../upload_images/laskasas/Beds/Duane bed/17.jpg",
      "../upload_images/laskasas/Beds/Duane bed/18.jpg",
      "../upload_images/laskasas/Beds/Duane bed/19.jpg",
      "../upload_images/laskasas/Beds/Duane bed/20.jpg"
    ],
    "description": "דווין הוא מיטה המוגדרת על ידי יופי, קווים נקיים ומינימליזם חמים. זהו האלמנט המושלם ליצירת חדרי שינה עם וייבים חיוביים.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 23684,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Jackson Bed": {
    "image_url": "../upload_images/laskasas/Beds/Jackson Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/jackson-bed_p6233.html?id=737&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/Jackson Bed/1.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/2.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/3.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/4.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/5.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/6.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/7.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/8.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/9.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/10.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/11.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/12.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/13.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/14.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/15.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/16.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/17.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/18.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/19.jpg",
      "../upload_images/laskasas/Beds/Jackson Bed/20.jpg"
    ],
    "description": "התכונה הבולטת ביותר של ג'קסון היא ראש המיטה הגיאומטרי שלו. עם סטייל נהדר, המיטה הזו מעניקה אופי לכל חדר שינה.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 28978,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Maia Bed": {
    "image_url": "../upload_images/laskasas/Beds/Maia Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/maia-bed_p4713.html?id=737&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/Maia Bed/1.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/2.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/3.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/4.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/5.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/6.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/7.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/8.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/9.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/10.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/11.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/12.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/13.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/14.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/15.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/16.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/17.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/18.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/19.jpg",
      "../upload_images/laskasas/Beds/Maia Bed/20.jpg"
    ],
    "description": "מאיה היא מיטה מינימליסטית ופונקציונלית שהיא אחת מהאהובות עלינו בזכות העיצוב המלוטש והגימור שלה. היא מתאימה באופן מושלם לסגנון עיצוב מודרני מהמאה האמצעית וקלה לשילוב עם חלקים אחרים.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 17778,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Marlin Bed": {
    "image_url": "../upload_images/laskasas/Beds/Marlin Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/marlin-bed_p6232.html?id=737&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/Marlin Bed/1.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/2.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/3.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/4.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/5.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/6.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/7.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/8.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/9.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/10.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/11.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/12.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/13.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/14.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/15.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/16.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/17.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/18.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/19.jpg",
      "../upload_images/laskasas/Beds/Marlin Bed/20.jpg"
    ],
    "description": "מרלין הוא מיטה נוחה להפליא בהשראת הפשטות האלגנטית של עיצוב עכשווי. היא תהווה תוספת נהדרת למראה חדר השינה שלך.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 11012,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Norma bed": {
    "image_url": "../upload_images/laskasas/Beds/Norma bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/norma-bed_p4556.html?id=737&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/Norma bed/1.jpg",
      "../upload_images/laskasas/Beds/Norma bed/2.jpg",
      "../upload_images/laskasas/Beds/Norma bed/3.jpg",
      "../upload_images/laskasas/Beds/Norma bed/4.jpg",
      "../upload_images/laskasas/Beds/Norma bed/5.jpg",
      "../upload_images/laskasas/Beds/Norma bed/6.jpg",
      "../upload_images/laskasas/Beds/Norma bed/7.jpg",
      "../upload_images/laskasas/Beds/Norma bed/8.jpg",
      "../upload_images/laskasas/Beds/Norma bed/9.jpg",
      "../upload_images/laskasas/Beds/Norma bed/10.jpg",
      "../upload_images/laskasas/Beds/Norma bed/11.jpg",
      "../upload_images/laskasas/Beds/Norma bed/12.jpg",
      "../upload_images/laskasas/Beds/Norma bed/13.jpg",
      "../upload_images/laskasas/Beds/Norma bed/14.jpg",
      "../upload_images/laskasas/Beds/Norma bed/15.jpg",
      "../upload_images/laskasas/Beds/Norma bed/16.jpg",
      "../upload_images/laskasas/Beds/Norma bed/17.jpg",
      "../upload_images/laskasas/Beds/Norma bed/18.jpg",
      "../upload_images/laskasas/Beds/Norma bed/19.jpg",
      "../upload_images/laskasas/Beds/Norma bed/20.jpg"
    ],
    "description": "נורמה מוגדרת על ידי האיכות היפה והמלאכה שלה. היא בעלת פרופיל נמוך מאוד, אך תעלה על הציפיות שלך.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 10094,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "USO Bed": {
    "image_url": "../upload_images/laskasas/Beds/USO Bed/1.jpg",
    "product_url": "https://www.laskasas.com/en/beds/uso-bed_p6213.html?id=737&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Beds/USO Bed/1.jpg",
      "../upload_images/laskasas/Beds/USO Bed/2.jpg",
      "../upload_images/laskasas/Beds/USO Bed/3.jpg",
      "../upload_images/laskasas/Beds/USO Bed/4.jpg",
      "../upload_images/laskasas/Beds/USO Bed/5.jpg",
      "../upload_images/laskasas/Beds/USO Bed/6.jpg",
      "../upload_images/laskasas/Beds/USO Bed/7.jpg",
      "../upload_images/laskasas/Beds/USO Bed/8.jpg",
      "../upload_images/laskasas/Beds/USO Bed/9.jpg",
      "../upload_images/laskasas/Beds/USO Bed/10.jpg",
      "../upload_images/laskasas/Beds/USO Bed/11.jpg",
      "../upload_images/laskasas/Beds/USO Bed/12.jpg",
      "../upload_images/laskasas/Beds/USO Bed/13.jpg",
      "../upload_images/laskasas/Beds/USO Bed/14.jpg",
      "../upload_images/laskasas/Beds/USO Bed/15.jpg",
      "../upload_images/laskasas/Beds/USO Bed/16.jpg",
      "../upload_images/laskasas/Beds/USO Bed/17.jpg",
      "../upload_images/laskasas/Beds/USO Bed/18.jpg",
      "../upload_images/laskasas/Beds/USO Bed/19.jpg",
      "../upload_images/laskasas/Beds/USO Bed/20.jpg"
    ],
    "description": "אוסו הוא מיטה סופר מודרנית מבלי לנסות יותר מדי. מומלץ לכל מי שמחפש מיטה מודרנית אך אלגנטית.",
    "company_name": "Laskasas",
    "original_category": "Beds",
    "price": 29957,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Amy bench": {
    "image_url": "../upload_images/laskasas/Benches/Amy bench/1.jpg",
    "product_url": "https://www.laskasas.com/en/benches/amy-bench_p4509.html?id=738&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Benches/Amy bench/1.jpg",
      "../upload_images/laskasas/Benches/Amy bench/2.jpg",
      "../upload_images/laskasas/Benches/Amy bench/3.jpg",
      "../upload_images/laskasas/Benches/Amy bench/4.jpg",
      "../upload_images/laskasas/Benches/Amy bench/5.jpg",
      "../upload_images/laskasas/Benches/Amy bench/6.jpg",
      "../upload_images/laskasas/Benches/Amy bench/7.jpg",
      "../upload_images/laskasas/Benches/Amy bench/8.jpg",
      "../upload_images/laskasas/Benches/Amy bench/9.jpg",
      "../upload_images/laskasas/Benches/Amy bench/10.jpg",
      "../upload_images/laskasas/Benches/Amy bench/11.jpg",
      "../upload_images/laskasas/Benches/Amy bench/12.jpg",
      "../upload_images/laskasas/Benches/Amy bench/13.jpg",
      "../upload_images/laskasas/Benches/Amy bench/14.jpg",
      "../upload_images/laskasas/Benches/Amy bench/15.jpg"
    ],
    "description": "הספסל איימי הוא פריט אלגנטי ונצחי שיכול לשמש כעוגן ויזואלי בכל עיצוב, בין אם ממוקם בקצה המיטה או ליד חלון בחדר המגורים.",
    "company_name": "Laskasas",
    "original_category": "Benches",
    "price": 19692,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Benner bench": {
    "image_url": "../upload_images/laskasas/Benches/Benner bench/1.jpg",
    "product_url": "https://www.laskasas.com/en/benches/benner-bench_p4784.html?id=738&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Benches/Benner bench/1.jpg",
      "../upload_images/laskasas/Benches/Benner bench/2.jpg",
      "../upload_images/laskasas/Benches/Benner bench/3.jpg",
      "../upload_images/laskasas/Benches/Benner bench/4.jpg",
      "../upload_images/laskasas/Benches/Benner bench/5.jpg",
      "../upload_images/laskasas/Benches/Benner bench/6.jpg",
      "../upload_images/laskasas/Benches/Benner bench/7.jpg",
      "../upload_images/laskasas/Benches/Benner bench/8.jpg",
      "../upload_images/laskasas/Benches/Benner bench/9.jpg",
      "../upload_images/laskasas/Benches/Benner bench/10.jpg",
      "../upload_images/laskasas/Benches/Benner bench/11.jpg",
      "../upload_images/laskasas/Benches/Benner bench/12.jpg"
    ],
    "description": "הספסל בנר הוא תוספת אופנתית ושיקית לכל חדר, מושלם לסלון, מבואה או חדר שינה. הוא יוסיף נופך של אלגנטיות לחלל שלכם וירשים במשך שנים רבות.",
    "company_name": "Laskasas",
    "original_category": "Benches",
    "price": 10277,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Charlie bench": {
    "image_url": "../upload_images/laskasas/Benches/Charlie bench/1.jpg",
    "product_url": "https://www.laskasas.com/en/benches/charlie-bench_p5394.html?id=738&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Benches/Charlie bench/1.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/2.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/3.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/4.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/5.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/6.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/7.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/8.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/9.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/10.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/11.jpg",
      "../upload_images/laskasas/Benches/Charlie bench/12.jpg"
    ],
    "description": "הספסל צ'ארלי הוא פריט בולט שישדרג כל בית. הוא נוח ורב-גוני, וניתן למקם אותו בסלון ליד חלון או בקצה המיטה.",
    "company_name": "Laskasas",
    "original_category": "Benches",
    "price": 28486,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Devon Bench": {
    "image_url": "../upload_images/laskasas/Benches/Devon Bench/1.jpg",
    "product_url": "https://www.laskasas.com/en/benches/devon-bench_p8136.html?id=738&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Benches/Devon Bench/1.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/2.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/3.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/4.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/5.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/6.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/7.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/8.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/9.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/10.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/11.jpg",
      "../upload_images/laskasas/Benches/Devon Bench/12.jpg"
    ],
    "description": "הספסל דבון הוא ספסל עכשווי עם עיצוב מינימליסטי, שיתרום סגנון לכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Benches",
    "price": 12669,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Karin Chaise Longue": {
    "image_url": "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/1.jpg",
    "product_url": "https://www.laskasas.com/en/chaise-longues/karin-chaise-longue_p5446.html?id=739&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/1.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/2.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/3.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/4.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/5.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/6.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/7.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/8.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/9.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/10.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/11.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/12.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/13.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/14.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/15.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/16.jpg",
      "../upload_images/laskasas/Chaise Longues/Karin Chaise Longue/17.jpg"
    ],
    "description": "כורסאת הקאזה לונג קרין היא הפריט המושלם להתרווח איתו עם ספר טוב בידיכם. כורסא זו רב-שימושית וכוללת משענת יד ומשענת גב, מה שמספק נוחות מרבית.",
    "company_name": "Laskasas",
    "original_category": "Chaise Longues",
    "price": 11441,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Mull Chair with arms": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/mull-chair-with-arms_p8052.html?id=740&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair with arms/20.jpg"
    ],
    "description": "מול הוא כיסא מעודן עם ידיות, המציג עיצוב מינימליסטי המדגיש גמישות ונוחות. הפרופיל החלק שלו הופך אותו לאידיאלי הן עבור אזורי אוכל קטנים והן עבור אזורים מרווחים יותר, והוא משתלב בצורה חלקה עם סגנונות פנים שונים.\n\n*הרגליים עשויות עץ מַנְגָּן במראה הדומה לכל סוג עץ מקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 27897,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Achiles Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/achiles-chair_p11478.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Achiles Chair/8.jpg"
    ],
    "description": "גלה את השילוב המושלם של נוחות ועמידות עם כיסא אכילס, כיסא פינת אוכל עם מסגרת מתכת המעוצב להחזיק שנים רבות. המסגרת המתכתית החזקה שלו מספקת יציבות, בעוד הריפוד הרך ומשענת הגב התומכת מציעים נוחות יוצאת דופן. אידיאלי לחדרי אוכל מודרניים וקלאסיים כאחד, כיסא זה הוא בחירה מצטיינת עבור מעצבי פנים.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 11545,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Clyde Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/clyde-chair_p8060.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Chair/16.jpg"
    ],
    "description": "קלייד הוא כיסא אוכל נוח שמשלב אסתטיקה מודרנית עם עיצוב מינימליסטי. עם מושב מבד רך, הכיסא הזה מבטיח חווית אוכל נוחה תוך שהוא משפר בצורה חלקה את הסגנון הכללי של אזור האוכל.\n\n*הרגליים עשויות מעץ מילה ומוכתמות לחקות כל סוג עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 27225,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Jayne Chair with Arms": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/jayne-chair-with-arms_p84462.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair with Arms/16.jpg"
    ],
    "description": "כיסא האוכל ג'יין משלב בצורה חלקה נוחות ועמידות. העיצוב המזמין והמבנה המוצק שלו מבטיחים נוחות וסגנון לאורך זמן, מה שהופך אותו לבחירה אידיאלית הן למגורים והן למקומות מסחריים.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 13958,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Mull Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/mull-chair_p8056.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Mull Chair/16.jpg"
    ],
    "description": "בוול הוא כיסא מעודן ללא ידיות, המציג עיצוב מינימליסטי שמדגיש רבגוניות ונוחות. הפרופיל האלגנטי שלו הופך אותו לאידיאלי הן לאזורי אוכל קטנים והן לנדיבים יותר, והוא משתלב בהרמוניה עם סגנונות עיצוב פנים שונים.\n\n*הרגליים עשויות מעץ מילה ומוכתמות כדי לדמות כל סוג עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 12136,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Clyde Office Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/clyde-office-chair_p8141.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Clyde Office Chair/16.jpg"
    ],
    "description": "כיסא המשרד הביתי קלייד הוא בעיצוב עכשווי שמושלם למרחבים קטנים. קווים נקיים ומודרניים מאפשרים לו להשתלב בכל משרד ביתי.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 11422,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Haia II Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/haia-ii-chair_p9540.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Haia II Chair/16.jpg"
    ],
    "description": "כיסא חאיה II הוא כיסא משרד מעוצב עם קווים אלגנטיים, מושלם למשרדים ביתיים. פשוט, מעוקל ואייקוני, הוא מוסיף נגיעת סגנון שאין לעמוד בפניה לכל חלל, מה שהופך אותו לבחירה אידיאלית עבור מעצבי פנים המחפשים גם עיצוב וגם פונקציונליות.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 13084,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Jayne Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/jayne-chair_p84466.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Jayne Chair/16.jpg"
    ],
    "description": "כיסא האוכל ג'יין משלב בצורה מושלמת נוחות ועמידות. העיצוב המזמין והמבנה החזק שלו מבטיחים נוחות וסטייל לאורך זמן, מה שהופך אותו לבחירה אידיאלית גם לסביבות מגורים וגם לסביבות מסחריות.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 29003,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Dale chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Dale chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/dale-chair_p6157.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dale chair/16.jpg"
    ],
    "description": "דייל הוא כיסא אוכל יציב המשלב חומרים מנוגדים וצורות גיאומטריות לעיצוב נועז ופונקציונלי. עם גב ומשענת זרוע קמורים, מבנה מתכת ורגליים, ומושב ומשענת גב מבד חלק, הוא מושלם לחדרי אוכל נועזים או חללים פתוחים אחרים.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 29848,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Amour Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/amour-chair_p6124.html?id=740&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Amour Chair/16.jpg"
    ],
    "description": "הכיסא אמור הוא כיסא אוכל יפהפה עם גב פתוח שמשדר רומנטיקה וזוהר. הגב הפתוח והמעוגל שלו מנוגד באופן אלגנטי לפשטות המושב, מה שהופך אותו למושלם לכל חדר.\n\n*הרגליים עשויות מעץ מילה וצבועות לחקות כל עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 18868,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Nelly Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/nelly-chair_p4915.html?id=740&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Nelly Chair/20.jpg"
    ],
    "description": "כחלק מאוסף נלי, כיסא זה בהשראה וינטג' בעל משענת גב מעוגלת וארבע רגליים מעץ מלא. מרופד בשני בדים שונים, נלי מקרין קסם ייחודי, מה שהופך אותו להוספה אידיאלית לחדרי אוכל אלגנטיים.\n\n*הרגליים עשויות מעץ אש ומוכתמות כדי להידמות לכל עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 16541,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Ambrose Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/ambrose-chair_p4520.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ambrose Chair/20.jpg"
    ],
    "description": "האמברוז הוא כיסא אוכל ארגונומי הכולל גב קמור ומלוטש הנתמך על ידי מסגרת מרופדת עם מושב נוח. הכיסא פותח מתוך מחשבה על סגנון ונוחות, והוא מושלם ליצירת מרחבי אוכל מזמינים שבהם האסתטיקה והפונקציונליות הם בראש סדר העדיפויות.\n\n*הרגליים עשויות מעץ אפר וצבועות כדי להידמות לכל עץ מקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 23735,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Lili Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/lili-chair_p6130.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili Chair/20.jpg"
    ],
    "description": "כיסא לילי הוא כיסא אוכל אלגנטי המשלב עיצוב מלוטש עם נוחות. עם גב מעוגל בצורה יפה, הוא משדרג את המראה של כל עיצוב חדר עם קוויו החינניים. העיקול האורגני מוסיף נופך של סגנון ומעודן, והופך אותו לבחירה אידיאלית ליצירת חללי אוכל אופנתיים ומזמינים.\n\nהרגליים עשויות מעץ מילה וצבועות לחיקוי כל עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 18904,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Ferrara Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/ferrara-chair_p4712.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Ferrara Chair/20.jpg"
    ],
    "description": "פֶרָרָה היא כיסא אוכל קלאסי שמוסיף נופך של תחכום לכל חלל אוכל. היצירה האלגנטית הזו כוללת גב חלק, מושבים מרופדים במילוי קצף ורגליים מתכתיות בהתאמה אישית, מה שמבטיח נוחות וסגנון. כיסא פֶרָרָה זמין במגוון צבעי בדים, ניתן להתאמה אישית כדי להתאים לכל עיצוב, מה שהופך אותו לבחירה אידיאלית עבור מעצבי פנים המבקשים ליצור אזורי אוכל מעודנים ואלגנטיים.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 18682,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Bali Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/bali-chair_p6140.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Bali Chair/20.jpg"
    ],
    "description": "כיסא באלי, כיסא אוכל עור מרהיב, הוא סינתזה ייחודית של קווים ישרים, צורות רכות וקצוות מודגשים לחוויית אוכל נוחה וסטייליסטית. בעוד שעור הוא אפשרות אחת, כיסא זה מציע אפשרויות התאמה רבות, כולל מגוון רחב של בדים, שיתאימו לטעמים ופנים שונים.\n\n*הרגליים מיוצרות מעץ אש ומוכתמות לחקות כל עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 12094,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Robson chair with arms": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/robson-chair-with-arms_p6127.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Robson chair with arms/20.jpg"
    ],
    "description": "כיסא רובסון הוא כיסא אוכל אלגנטי עם ידיות, מושלם לחדרי אוכל מודרניים ותוססים. עם משענות יד נוחות ומבנה מתכת מוצק, הוא אידיאלי למעצבי פנים המחפשים להוסיף פונקציונליות ואלגנטיות עכשווית לחללים שלהם.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 18571,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Capri Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/capri-chair_p6192.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Capri Chair/20.jpg"
    ],
    "description": "כיסא הקאפרי הוא כיסא אוכל אלגנטי וקל משקל, המשלים פונקציונליות עם עיצוב פשוט אך מתוחכם. עם קווים ישרים ואסתטיקה מינימליסטית, הוא משתלב ללא מאמץ בכל סגנון חדר אוכל, ומוסיף נגיעה של עידון מאופק לחלל.\n\n*הרגליים עשויות מעץ מילה ומוכתמות לחקות כל סוג עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 22365,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Lili home office chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/lili-home-office-chair_p4793.html?id=740&cat=512&pc=2&f=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Lili home office chair/20.jpg"
    ],
    "description": "כיסא המשרד \"לילי\" הוא כיסא עור רב-שימושי עם משענות, המעוצב לנוחות בזמן ישיבה ארוכה. הוא מתאפיין בגב גבוה ומשענות יציבות, וזמין במגוון בדי ריפוד, עם אופציות לעור או אפשרויות אחרות. מושלם עבור חללי עבודה ביתיים מודרניים, עיצובו הגמיש משתלב עם סגנונות שולחן שונים, ומוסיף נוחות ואלגנטיות לכל סביבה מקצועית.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 11877,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Denver Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/denver-chair_p6144.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Denver Chair/20.jpg"
    ],
    "description": "גלה את דנוור: כיסא פינת אוכל עם גב גבוה המשדר תחכום ואלגנטיות. העיצוב של משענת הגב מספק תמיכה יוצאת דופן, בעוד הריפוד מבד רך מוסיף חמימות ונוחות לכל אזור אוכל.\n\n*הרגליים עשויות מעץ מילה וצבועות כדי לחקות כל סוג עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 15172,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Loren home office chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/loren-home-office-chair_p4794.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren home office chair/20.jpg"
    ],
    "description": "כיסא המשרד לורן הוא כיסא משרד מרהיב בעיצובו, המיועד להשתלב בצורה חלקה בכל סביבה. עם קוויו המרשימים והמושב המרופד הנוח שלו, הוא מהווה תוספת מושלמת לכל סביבת עבודה ביתית.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 16584,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Dublin Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/dublin-chair_p4747.html?id=740&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Dublin Chair/20.jpg"
    ],
    "description": "הכיסא דבלין הוא כיסא אוכל מתוחכם שמשלב בין חן לנוחות. העיצוב המעורר חזותית שלו עם קימורים אלגנטיים מוסיף נופך של עידון ורכות לחללי האוכל.\n\n*הרגליים עשויות מעץ מילה ומוכתמות כדי לדמות כל עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 28565,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Estoril Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/estoril-chair_p6180.html?id=740&cat=512&pc=3",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Estoril Chair/20.jpg"
    ],
    "description": "אסטריל הוא כיסא פינתיות רב-תכליתי עם עיצוב קווי ועשיר. מושלם כשולחן אוכל, כיסא פינה או כיסא לאונג', הוא מכיל בתוכו זוהר קלאסי בעולם העכשווי, תוך שימוש בחומרים המשובחים ביותר לתוספת אלגנטיות לכל סביבה.\n\n*הרגליים עשויות מעץ אַש וצבועות לחיקוי כל עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 25146,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Gordon Chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/gordon-chair_p6170.html?id=740&cat=512&pc=3",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Gordon Chair/20.jpg"
    ],
    "description": "כיסא גורדון בעל נוכחות מרשימה המתאזנת עם הניגוד היפה שיוצרות הפסיפסים בגב הכיסא. מרופד על ידי אומני לאסקאסאס, הוא מתאפיין בארבע רגליים נוצצות לתמיכה מלאה. גורדון משלב גדוּלה ויופי כדי ליצור הצהרה בכל חדר אוכל.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 24606,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Loren chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Loren chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/loren-chair_p6160.html?id=740&cat=512&pc=3",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Loren chair/20.jpg"
    ],
    "description": "כיסא לורן אידיאלי ליצירת אווירה נעימה באזורים אינטימיים לסעודה. הזמין במבחר של בדים, כיסא נוח זה כולל בסיס חלק וקווים מודרניים שמוסיפים סטייל ונוחות לכל חדר אוכל.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 27384,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Prestige chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/prestige-chair_p4531.html?id=740&cat=512&pc=3",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Prestige chair/16.jpg"
    ],
    "description": "פרסטיז' היא כיסא אלגנטי עם רגלי עץ: תוספת מגוונת לכל חלל. עם עיצוב קווי ועשיר, הכיסא מתפקד בצורה יפהפייה ככיסא לפינת אוכל, פינה או שקע. הכיסא מיוצר מהחומרים המשובחים ביותר ומכניס זוהר קלאסי לכל סביבה עכשווית.\n\n*הרגליים מיוצרות מעץ מילה ומוכתמות לחיקוי כל עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 24886,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Simone chair": {
    "image_url": "../upload_images/laskasas/Dining & Office Chairs/Simone chair/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-and-office-chairs/simone-chair_p4532.html?id=740&cat=512&pc=3",
    "image_urls": [
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/1.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/2.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/3.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/4.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/5.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/6.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/7.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/8.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/9.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/10.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/11.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/12.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/13.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/14.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/15.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/16.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/17.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/18.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/19.jpg",
      "../upload_images/laskasas/Dining & Office Chairs/Simone chair/20.jpg"
    ],
    "description": "הכירו את סימון: כיסא אוכל חזק שמשלב עיצוב עכשווי עם עמידות יוצאת דופן. השלדה המוצקה שלו תומכת במושב ובמשענת מרופדים בנוחות, מה שהופך אותו לסטיילי ומעשי עבור כל חדר אוכל.\n\n*הרגליים עשויות מעץ מֵלוּחרף ומוכתמות כך שידמו לכל סוג עץ מהקטלוג שלנו.",
    "company_name": "Laskasas",
    "original_category": "Dining & Office Chairs",
    "price": 20801,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Fraser Pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/fraser-pouf_p8132.html?id=741&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/10.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/11.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/12.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/13.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/14.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Fraser Pouf/15.jpg"
    ],
    "description": "הוסף נופך של סגנון עכשווי לסלון שלך עם הפוף של פרייזר. בין אם אתה נרגע או מארח, העיצוב המינימליסטי של הפריט הזה יגרום לו להיראות נהדר בכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 14031,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Charlie Pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/charlie-pouf_p11556.html?id=741&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Charlie Pouf/9.jpg"
    ],
    "description": "הפוף צ'סטר מתהדר בעיצוב חלק ומודרני עם בדים רכים וקווים נקיים, מושלם לחלל מגורים מינימליסטי.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 15834,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Chester Pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/chester-pouf_p11561.html?id=741&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/10.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/11.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Chester Pouf/12.jpg"
    ],
    "description": "הפוף צ'סטר מתהדר בעיצוב מודרני ואלגנטי עם בדים רכים וקווים נקיים, מושלם לחלל מגורים מינימליסטי.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 10121,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Grey Pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/grey-pouf_p9719.html?id=741&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/10.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/11.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Grey Pouf/12.jpg"
    ],
    "description": "שדרגו את עיצוב הבית שלכם עם הפוף האפור. אפשרות ישיבה רב-תכליתית ונוחה זו מושלמת לכל חדר בביתכם. העיצוב המינימליסטי והמרקם הרך שלו יספקו את השילוב המושלם בין סגנון לנוחות.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 16099,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Eddy pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/eddy-pouf_p5474.html?id=741&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Eddy pouf/8.jpg"
    ],
    "description": "הפוף אדי הוא אביזר בית רב-תכליתי, המשלב חומרים המדגישים את המרקם והצבע של הבד.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 17763,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Bur Small Pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/bur-small-pouf_p6251.html?id=741&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Bur Small Pouf/8.jpg"
    ],
    "description": "הפוף הקטן Bur מעורר יופי עם רכות בלתי מוסברת. עשוי בעבודת יד בטכניקת הריפוד עם כפתורים, הפריט הזה הוא מֶזֶה של סגנון. סגנון החיים, הגישה וההיסטוריה של פריז חיים בכל פרט של הפוף הזה, אידיאלי לפרויקטים של חדרי שינה רומנטיים או מבואות כניסה מקסימות באווירה של ראוותנות.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 21411,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Benner pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/benner-pouf_p5486.html?id=741&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/10.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/11.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Benner pouf/12.jpg"
    ],
    "description": "הפוף בנר מוסיף אווירה מעודנת לכל חדר, מושלם לסלונים, מבואות או חדרי שינה עם המראה השיקי והמרשים שלו.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 26932,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Jason big pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/jason-big-pouf_p4807.html?id=741&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Jason big pouf/10.jpg"
    ],
    "description": "הפוף ג'ייסון הוא רהיט מפואר, מושלם למקומות חברתיים קטנים שבהם יש לעיתים אורחים נוספים. ניתן להשתמש בו כשולחן להנחת מגזינים או להרים את הרגליים אחרי יום ארוך.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 25137,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Stewart pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/stewart-pouf_p5488.html?id=741&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Stewart pouf/9.jpg"
    ],
    "description": "הפוף סטיוארט הוא רהיט עדין מרופד לחדר השינה הראשי או לסלון, עם מבנה מתכתי ואסתטיקה נקייה. זהו פריט משלים לכל עיצוב.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 26466,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Round Bur Pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/round-bur-pouf_p4633.html?id=741&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Round Bur Pouf/8.jpg"
    ],
    "description": "הפוף \"בור\" מעורר יופי עם הרכות הבלתי מוסברת שלו, מיוצר בעבודת יד בטכניקת ריפוד עם כפתורים, והוא הפריט המושלם לחדרי שינה רומנטיים או לפרוזדורים שובי לב עם תחושת יוקרה עדינה.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 13888,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Square Bur Pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Square Bur Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/square-bur-pouf_p4911.html?id=741&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Square Bur Pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Square Bur Pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Square Bur Pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Square Bur Pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Square Bur Pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Square Bur Pouf/6.jpg"
    ],
    "description": "פוף מרובע זה מעורר יופי עם רכות שאין להסבירה. מיוצר בעבודת יד בטכניקת ריפוד מכופתר, יצירה זו היא מילה נרדפת לסגנון. סגנון החיים בפריז, גישה והיסטוריה חיים בכל פרט של פוף זה, אידיאלי לחדרי שינה רומנטיים או לאולמות כניסה מקסימים עם הילה של זוהר.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 28563,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Isaac pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/isaac-pouf_p5468.html?id=741&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Isaac pouf/10.jpg"
    ],
    "description": "הפוף יצחק הוא פריט פשוט ואלגנטי, בעל צורה גלילית ומושב מרופד, מושלם לאולמות כניסה וחדרי מגורים עם קסם נצחי.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 19753,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Mike pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/mike-pouf_p5460.html?id=741&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/10.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/11.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/12.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/13.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/14.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Mike pouf/15.jpg"
    ],
    "description": "הפוף מייק הוא שרפרף נמוך עם בסיס מתכתי, המספק אביזר קטן אך מסוגנן שמעצים את היופי של הבד שנוצר על ידי אומנים.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 13715,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Moore pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/moore-pouf_p5482.html?id=741&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/10.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/11.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/12.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/13.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/14.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Moore pouf/15.jpg"
    ],
    "description": "הפוף של מור תוכנן עם נוחות בראש, וזמין במגוון בדים שמתאימים לכל עיצוב. הרכות השופעת שלו הופכת אותו לנוח מספיק כדי לשמש כמושב נוסף או כמקום להניח את הרגליים.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 13932,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Sebastian pouf": {
    "image_url": "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/ottomans-and-pouffes/sebastian-pouf_p5452.html?id=741&cat=512&pc=2&f=-1",
    "image_urls": [
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/1.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/2.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/3.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/4.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/5.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/6.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/7.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/8.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/9.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/10.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/11.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/12.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/13.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/14.jpg",
      "../upload_images/laskasas/Ottomans & Pouffes/Sebastian pouf/15.jpg"
    ],
    "description": "השרפרף סבסטיאן הוא הדום מרופד לגמרי עם עיצוב עליז, מושלם לכל חדר בבית, הכולל בד חלק ומרקם רך.",
    "company_name": "Laskasas",
    "original_category": "Ottomans & Pouffes",
    "price": 17609,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Fletcher Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Fletcher Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/fletcher-sofa_p4817.html?id=742&cat=512&pc=1&f=5",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Fletcher Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Fletcher Sofa/15.jpg"
    ],
    "description": "הספה המודולרית Fletcher היא שילוב מאוזן בקפידה של נוחות, פתרונות אחסון אלגנטיים ועיצוב רב־תכליתי. עם אלמנטים צדדיים, פינתיים, מרכזיים ושזלונג זמינים, ניתן להתאים את גודלה וצורתה כך שיתאימו לכל סלון, ספריה או משרד ביתי.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 18917,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Cosy Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Cosy Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/cosy-sofa_p11483.html?id=742&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Cosy Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/16.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/17.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/18.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/19.jpg",
      "../upload_images/laskasas/Sofas/Cosy Sofa/20.jpg"
    ],
    "description": "שקעו בנוחות עם ספת הקוזי. העיצוב הרך והמזמין שלה יגרום לכם לרצות להתכרבל ולהשתחרר, בעוד מגוון הצבעים והחומרים מאפשרים לכם לבחור את המושלם שמתאים לסגנון ולהעדפות שלכם.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 22492,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Foster Sofa Modular with Chaise": {
    "image_url": "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/foster-sofa-modular-with-chaise_p84437.html?id=742&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/1.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/2.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/3.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/4.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/5.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/6.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/7.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/8.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/9.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/10.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/11.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/12.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/13.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/14.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/15.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/16.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/17.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/18.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/19.jpg",
      "../upload_images/laskasas/Sofas/Foster Sofa Modular with Chaise/20.jpg"
    ],
    "description": "הספה פוסטר היא הזמנה לנוחות שאין לה מתחרים. ספה מודולרית מקסימה זו, המעוטרת בכיסי עור קטנים לצורך פונקציונליות נוספת, מעלה את הרגיעה לרמה חדשה. עם האלגנטיות הנצחית שלה, ספה זו מהווה תוספת אופנתית לכל סלון, ומשלבת יופי ומטרה לאווירה מתוחכמת באמת.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 10608,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Hidra Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Hidra Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/hidra-sofa_p8152.html?id=742&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Hidra Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Hidra Sofa/16.jpg"
    ],
    "description": "ספת הידרה מעוצבת עבור חלל מגורים עכשווי. העיצוב המינימליסטי הזה מאפשר לך להתאים אישית את הספה בבחירת הבד, הצבע והגימור שלך.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 24758,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Decker Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Decker Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/decker-sofa_p9564.html?id=742&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Decker Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Decker Sofa/15.jpg"
    ],
    "description": "הספה דקר מאפשרת התאמה אישית מוחלטת עם חלקים מודולריים, זמינה במגוון בדים וצבעים.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 24480,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Casablanca Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Casablanca Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/casablanca-sofa_p4818.html?id=742&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Casablanca Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Casablanca Sofa/15.jpg"
    ],
    "description": "הספה המודולרית קזבלנקה מציעה גמישות רבה, ומאפשרת התאמה אישית של רכיבים כך שיתאימו לגודל, לצורה ולצרכים של כל סלון. היא משלבת פרופורציות אלגנטיות וגאומטריות עם נוחות שמזמינה מאוד.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 21172,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Montreal Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Montreal Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/montreal-sofa_p4819.html?id=742&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Montreal Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Montreal Sofa/15.jpg"
    ],
    "description": "הספה המודולרית ממונטריאול משלבת קווים חדים ועיקולים רכים ליצירת הצהרה יוקרתית ומזמינה בכל חדר מגורים.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 14059,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Stewart sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Stewart sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/stewart-sofa_p5501.html?id=742&cat=512&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Stewart sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/16.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/17.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/18.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/19.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/20.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/21.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/22.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/23.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/24.jpg",
      "../upload_images/laskasas/Sofas/Stewart sofa/25.jpg"
    ],
    "description": "הספה סטיוארט היא תוספת מושלמת לסלונים מודרניים, מספקת קו מתאר קלאסי ומגע רך, מעולה לשילוב עם גוונים נייטרליים או כנקודת מוקד מרוסנת בחללים נועזים יותר.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 23030,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Harry Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Harry Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/harry-sofa_p4816.html?id=742&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Harry Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Harry Sofa/10.jpg"
    ],
    "description": "הספה הארי היא רהיט ישיבה מרשים, מעוצבת באיכות גבוהה וזמינה בהרכבים שונים להוספה נוחה ומזמינה לכל בית או פרויקט אירוח.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 22090,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Wellington sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Wellington sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/wellington-sofa_p5547.html?id=742&cat=512&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Wellington sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/16.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/17.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/18.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/19.jpg",
      "../upload_images/laskasas/Sofas/Wellington sofa/20.jpg"
    ],
    "description": "הספה וולינגטון היא פריט מודרני עם נגיעה וינטג', הכוללת בסיס עץ וקצוות קמורים להוספה נוחה וסטייליסטית לכל חלל מגורים פתוח.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 22153,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Charlie sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Charlie sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/charlie-sofa_p5517.html?id=742&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Charlie sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/16.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/17.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/18.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/19.jpg",
      "../upload_images/laskasas/Sofas/Charlie sofa/20.jpg"
    ],
    "description": "הספה \"צ'רלי\" היא פריט עכשווי ונוח המיועד לחדרי מגורים שלווים, הכוללת בסיס מתכת חלק וזרועות רחבות. הספה זמינה עם שזלונג ובאפשרויות לשני או שלושה מושבים.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 28819,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Chester Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Chester Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/chester-sofa_p4647.html?id=742&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Chester Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/16.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/17.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/18.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/19.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/20.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/21.jpg",
      "../upload_images/laskasas/Sofas/Chester Sofa/22.jpg"
    ],
    "description": "הספה צ'סטר היא סמל של תחכום וסגנון על-זמני, מושלמת לסלונים יוקרתיים. ידועה כזיקית בעולם עיצוב הפנים, היא יכולה להשתלב בכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 29841,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Gold Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Gold Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/gold-sofa_p5529.html?id=742&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Gold Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Gold Sofa/16.jpg"
    ],
    "description": "הספה הזהובה מתאפיינת בעיצוב ייחודי ומושב נוח, ומאפשרת לך ליצור חוויית רגיעה מושלמת. זמינה במגוון אפשרויות בד.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 19152,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Grey Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Grey Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/grey-sofa_p5495.html?id=742&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Grey Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/16.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/17.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/18.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/19.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/20.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/21.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/22.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/23.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/24.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa/25.jpg"
    ],
    "description": "הספה האפורה היא פריט נוח ועל-זמני שישדרג כל פרויקט עיצוב פנים, וייצור אווירה מזמינה בכל סלון.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 11379,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Grey Sofa with Chaise Longue": {
    "image_url": "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/grey-sofa-with-chaise-longue_p5491.html?id=742&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/1.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/2.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/3.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/4.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/5.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/6.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/7.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/8.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/9.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/10.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/11.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/12.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/13.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/14.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/15.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/16.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/17.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/18.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/19.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/20.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/21.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/22.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/23.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/24.jpg",
      "../upload_images/laskasas/Sofas/Grey Sofa with Chaise Longue/25.jpg"
    ],
    "description": "ספת אפור עם שזלונג תנצח בכל פרויקט עיצוב פנים. הרהיט הזה, הניתן להתאמה אישית בצבעים רבים, יוצר עיצוב מדהים ומזמין של הסלון. בהחלט, ספה בת שלושה מושבים המתאימה לאזורים פתוחים ולסגנון על-זמני.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 20604,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Jean Sofa small": {
    "image_url": "../upload_images/laskasas/Sofas/Jean Sofa small/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/jean-sofa-small_p5510.html?id=742&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Jean Sofa small/1.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/2.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/3.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/4.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/5.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/6.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/7.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/8.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/9.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/10.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/11.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/12.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/13.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/14.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/15.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/16.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/17.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/18.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/19.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa small/20.jpg"
    ],
    "description": "באמצעות הגב הייחודי שלה, שעוצב בטכניקת כפתור עמוק, ספה קטנה של ג'ין היא יצירה מרשימה לסלונים נחשקים. ספה מרופדת זו היא תוספת מושלמת למקומות מפנקים ומרחבים פתוחים ומזמינים. ג'ין מנצלת את המירב מחדר מגורים שמשמש גם כחדר אוכל. זהו רהיט ישיבה רב-שימושי עם פרטים מעץ ובסיס מתכתי.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 18685,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Jean Sofa": {
    "image_url": "../upload_images/laskasas/Sofas/Jean Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/jean-sofa_p5506.html?id=742&cat=512&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sofas/Jean Sofa/1.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/2.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/3.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/4.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/5.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/6.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/7.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/8.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/9.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/10.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/11.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/12.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/13.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/14.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/15.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/16.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/17.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/18.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/19.jpg",
      "../upload_images/laskasas/Sofas/Jean Sofa/20.jpg"
    ],
    "description": "הספה ז'אן היא פריט מרשים עבור חדרי מגורים יוקרתיים, הכוללת גב ייחודי עם עבודת כפתור עמוקה, מושלמת לפינות נעימות ולחללים פתוחים ומזמינים.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 25769,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "London Sofa with Chaise Longue": {
    "image_url": "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/1.jpg",
    "product_url": "https://www.laskasas.com/en/sofas/london-sofa-with-chaise-longue_p5498.html?id=742&cat=512&pc=2&f=-1",
    "image_urls": [
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/1.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/2.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/3.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/4.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/5.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/6.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/7.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/8.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/9.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/10.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/11.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/12.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/13.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/14.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/15.jpg",
      "../upload_images/laskasas/Sofas/London Sofa with Chaise Longue/16.jpg"
    ],
    "description": "הספה הלונדונית היא רהיט עם קווים נקיים שמתאים היטב לרוב הפנים, ומציעה נוחות נוספת במושביה ותחושה רשמית בידיותיה. ניתן להפוך אותה לספת שייז לונג, מה שמוסיף יותר נוחות ומקום ישיבה לעיצוב הפנים.",
    "company_name": "Laskasas",
    "original_category": "Sofas",
    "price": 18407,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Ben coat rack": {
    "image_url": "../upload_images/laskasas/Coat Hangers/Ben coat rack/1.jpg",
    "product_url": "https://www.laskasas.com/en/coat-hangers/ben-coat-rack_p5332.html?id=726&cat=514&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/1.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/2.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/3.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/4.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/5.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/6.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/7.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/8.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/9.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/10.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/11.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/12.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/13.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/14.jpg",
      "../upload_images/laskasas/Coat Hangers/Ben coat rack/15.jpg"
    ],
    "description": "מתלה המעילים בן עשוי ממתכת ובסיס שיש, מעוצב בסגנון מודרני וכולל שני שלבי תלייה ואחסון מטריות משולב.",
    "company_name": "Laskasas",
    "original_category": "Coat Hangers",
    "price": 26042,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Gozo Coat Hanger": {
    "image_url": "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/1.jpg",
    "product_url": "https://www.laskasas.com/en/coat-hangers/gozo-coat-hanger_p8042.html?id=726&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/1.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/2.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/3.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/4.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/5.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/6.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/7.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/8.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/9.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/10.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/11.jpg",
      "../upload_images/laskasas/Coat Hangers/Gozo Coat Hanger/12.jpg"
    ],
    "description": "מתלה המעילים גוזו הוא הדרך המושלמת לארגן את החלל שלך. עיצוב מינימליסטי נראה נהדר בכל חדר, עם שטח רחב לתליית מעילים, ז'קטים ותיקים.",
    "company_name": "Laskasas",
    "original_category": "Coat Hangers",
    "price": 20564,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Matt coat rack": {
    "image_url": "../upload_images/laskasas/Coat Hangers/Matt coat rack/1.jpg",
    "product_url": "https://www.laskasas.com/en/coat-hangers/matt-coat-rack_p5335.html?id=726&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/1.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/2.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/3.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/4.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/5.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/6.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/7.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/8.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/9.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/10.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/11.jpg",
      "../upload_images/laskasas/Coat Hangers/Matt coat rack/12.jpg"
    ],
    "description": "מתלה המעילים מאט עשוי ממתכת בעיצוב מסוגנן ומודרני הכולל ארבעה ענפים לאחסון קל.",
    "company_name": "Laskasas",
    "original_category": "Coat Hangers",
    "price": 22459,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Twisted coat rack": {
    "image_url": "../upload_images/laskasas/Coat Hangers/Twisted coat rack/1.jpg",
    "product_url": "https://www.laskasas.com/en/coat-hangers/twisted-coat-rack_p5330.html?id=726&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/1.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/2.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/3.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/4.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/5.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/6.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/7.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/8.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/9.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/10.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/11.jpg",
      "../upload_images/laskasas/Coat Hangers/Twisted coat rack/12.jpg"
    ],
    "description": "המתלה המעוצב הוא מעמד גבוה ודקורטיבי עם ארבע רגליים צולבות גבוהות לתמיכה מרבית ועיצוב מעניין.",
    "company_name": "Laskasas",
    "original_category": "Coat Hangers",
    "price": 10108,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Airon Coat Rack ": {
    "image_url": "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /1.jpg",
    "product_url": "https://www.laskasas.com/en/coat-hangers/airon-coat-rack_p93131.html?id=726&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /1.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /2.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /3.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /4.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /5.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /6.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /7.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /8.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /9.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /10.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /11.jpg",
      "../upload_images/laskasas/Coat Hangers/Airon Coat Rack /12.jpg"
    ],
    "description": "כולל מבנה חלקלק ומודרני עם בסיס עליון מעוגל, ארון מספק גם מקום לתלייה וגם משטח נוח להנחת פריטים קטנים. מתלה המעילים עם המדף הזה הוא פריט רב-תכליתי שמשלב פונקציונליות ואלגנטיות על-זמנית, מה שהופך אותו לתוספת אידיאלית לכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Coat Hangers",
    "price": 25842,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Tyler Coat Rack": {
    "image_url": "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/1.jpg",
    "product_url": "https://www.laskasas.com/en/coat-hangers/tyler-coat-rack_p93126.html?id=726&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/1.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/2.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/3.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/4.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/5.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/6.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/7.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/8.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/9.jpg",
      "../upload_images/laskasas/Coat Hangers/Tyler Coat Rack/10.jpg"
    ],
    "description": "מתלה המעילים טיילר מעוצב בפשטות ואלגנטיות כדי לספק תמיכה יציבה למעילים ואביזרים, מה שהופך אותו לבחירה אידיאלית עבור חללים מסוגננים ופונקציונליים. מושלם לחדרי שינה או אולמות כניסה, מתלה המעילים המודרני הזה משלב נוחות עם אלגנטיות עכשווית.",
    "company_name": "Laskasas",
    "original_category": "Coat Hangers",
    "price": 29132,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Ted Coat Rack": {
    "image_url": "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/1.jpg",
    "product_url": "https://www.laskasas.com/en/coat-hangers/ted-coat-rack_p93134.html?id=726&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/1.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/2.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/3.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/4.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/5.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/6.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/7.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/8.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/9.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/10.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/11.jpg",
      "../upload_images/laskasas/Coat Hangers/Ted Coat Rack/12.jpg"
    ],
    "description": "טד, המתלה הרב תכליתי, הוא מבנה רב שימושי המשמש הן כמתלה למעילים עם אחסון והן כמחזיק למגבות. עיצובו המינימליסטי משתלב בכל סגנון, ומספק פתרון מתוחכם ומכוון למטרות עבור הפרויקטים שלכם.",
    "company_name": "Laskasas",
    "original_category": "Coat Hangers",
    "price": 18825,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Pitt tea cart": {
    "image_url": "../upload_images/laskasas/Decorative Elements/Pitt tea cart/1.jpg",
    "product_url": "https://www.laskasas.com/en/decorative-elements/pitt-tea-cart_p4786.html?id=915&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/1.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/2.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/3.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/4.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/5.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/6.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/7.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/8.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/9.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/10.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/11.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/12.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/13.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/14.jpg",
      "../upload_images/laskasas/Decorative Elements/Pitt tea cart/15.jpg"
    ],
    "description": "עגלת התה של פיט היא פריט רב-תכליתי, מושלם לפרויקטים בתחום האירוח או לאירוח אורחים בבית. המדפים המעוצבים מברזל והמסגרת המתכתית החזקה מגיעים בגימור בהתאמה אישית, בעוד שהמגש עשוי מאבן שיש טבעית להוספת אלגנטיות.",
    "company_name": "Laskasas",
    "original_category": "Decorative Elements",
    "price": 15136,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Tim tray": {
    "image_url": "../upload_images/laskasas/Decorative Elements/Tim tray/1.jpg",
    "product_url": "https://www.laskasas.com/en/trays/tim-tray_p4791.html?id=915&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Decorative Elements/Tim tray/1.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/2.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/3.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/4.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/5.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/6.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/7.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/8.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/9.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/10.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/11.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/12.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/13.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/14.jpg",
      "../upload_images/laskasas/Decorative Elements/Tim tray/15.jpg"
    ],
    "description": "מגש טים הוא תוספת רב-שימושית ואלגנטית לכל פרויקט עיצוב פנים. השתמשו בו להגשת קוקטיילים ייחודיים, לאחסון כלי בר בבר, מוצרי טיפוח בחדר האמבטיה, או אפילו כמגש לאיפור ותכשיטים בחדר השינה לתוספת של תחכום.",
    "company_name": "Laskasas",
    "original_category": "Decorative Elements",
    "price": 18534,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Poppy flower pot": {
    "image_url": "../upload_images/laskasas/Flower Pots/Poppy flower pot/1.jpg",
    "product_url": "https://www.laskasas.com/en/flowers-pots/poppy-flower-pot_p4696.html?id=727&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Flower Pots/Poppy flower pot/1.jpg",
      "../upload_images/laskasas/Flower Pots/Poppy flower pot/2.jpg",
      "../upload_images/laskasas/Flower Pots/Poppy flower pot/3.jpg",
      "../upload_images/laskasas/Flower Pots/Poppy flower pot/4.jpg",
      "../upload_images/laskasas/Flower Pots/Poppy flower pot/5.jpg",
      "../upload_images/laskasas/Flower Pots/Poppy flower pot/6.jpg",
      "../upload_images/laskasas/Flower Pots/Poppy flower pot/7.jpg",
      "../upload_images/laskasas/Flower Pots/Poppy flower pot/8.jpg"
    ],
    "description": "עציץ פרח הפרג הוא עציץ תוסס וצבעוני, מושלם להצגת הצמחים האהובים עליך.",
    "company_name": "Laskasas",
    "original_category": "Flower Pots",
    "price": 17174,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Gold tall flower pot": {
    "image_url": "../upload_images/laskasas/Flower Pots/Gold tall flower pot/1.jpg",
    "product_url": "https://www.laskasas.com/en/flowers-pots/gold-tall-flower-pot_p5375.html?id=727&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/1.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/2.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/3.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/4.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/5.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/6.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/7.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/8.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/9.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/10.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/11.jpg",
      "../upload_images/laskasas/Flower Pots/Gold tall flower pot/12.jpg"
    ],
    "description": "עציץ זהב הוא מבנה עץ יפהפה המשלב בסיס פלדה כדי להאיר את הפטיו או הדק שלך.",
    "company_name": "Laskasas",
    "original_category": "Flower Pots",
    "price": 29978,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Gold little flower pot": {
    "image_url": "../upload_images/laskasas/Flower Pots/Gold little flower pot/1.jpg",
    "product_url": "https://www.laskasas.com/en/flowers-pots/gold-little-flower-pot_p4805.html?id=727&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/1.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/2.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/3.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/4.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/5.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/6.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/7.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/8.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/9.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/10.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/11.jpg",
      "../upload_images/laskasas/Flower Pots/Gold little flower pot/12.jpg"
    ],
    "description": "המעמד לפרחים מזהב הוא מבנה עץ יפהפה שמשולב עם בסיס פלדה כדי להאיר את הפטיו או הדק שלכם.",
    "company_name": "Laskasas",
    "original_category": "Flower Pots",
    "price": 16285,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Rosie flower pot": {
    "image_url": "../upload_images/laskasas/Flower Pots/Rosie flower pot/1.jpg",
    "product_url": "https://www.laskasas.com/en/flowers-pots/rosie-flower-pot_p5384.html?id=727&cat=514&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/1.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/2.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/3.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/4.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/5.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/6.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/7.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/8.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/9.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/10.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/11.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/12.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/13.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/14.jpg",
      "../upload_images/laskasas/Flower Pots/Rosie flower pot/15.jpg"
    ],
    "description": "",
    "company_name": "Laskasas",
    "original_category": "Flower Pots",
    "price": 25629,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Lanie flower pot": {
    "image_url": "../upload_images/laskasas/Flower Pots/Lanie flower pot/1.jpg",
    "product_url": "https://www.laskasas.com/en/flowers-pots/lanie-flower-pot_p5381.html?id=727&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/1.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/2.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/3.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/4.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/5.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/6.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/7.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/8.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/9.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/10.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/11.jpg",
      "../upload_images/laskasas/Flower Pots/Lanie flower pot/12.jpg"
    ],
    "description": "עציץ לאני הוא מקום יפה לפרחים ולצמחים שלך, מושלם למרחבים סגורים שבהם לאם הטבע יש גישה קשה.",
    "company_name": "Laskasas",
    "original_category": "Flower Pots",
    "price": 26870,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Herbert Mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Herbert Mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/coat-hangers/herbert-mirror_p93121.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Herbert Mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/8.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/9.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/10.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/11.jpg",
      "../upload_images/laskasas/Mirrors/Herbert Mirror/12.jpg"
    ],
    "description": "תוכנן להיות פונקציונלי, הרברט הוא מראת עמידה בגובה מלא הכוללת מתלה בגדים קטן בצד שמאל ושלושה מדפים מרובעים בצד ימין, המספקים אחסון נוח לאביזרים ופריטים חיוניים. הקווים הנקיים והאסתטיקה המודרנית שלו הופכים אותו לבחירה רב-גונית עבור מעצבי פנים המחפשים להוסיף גם צורה וגם פונקציה לפרויקטים שלהם.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 16752,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Forth Mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Forth Mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/forth-mirror_p8048.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Forth Mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Forth Mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Forth Mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Forth Mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Forth Mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Forth Mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Forth Mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Forth Mirror/8.jpg"
    ],
    "description": "המראה פורט לוכדת את המיטב של עיצוב מינימליסטי, עם מסגרת עכשווית שבטוח תעשה רושם בכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 12820,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Frank Mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Frank Mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/frank-mirror_p84418.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Frank Mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Frank Mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Frank Mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Frank Mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Frank Mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Frank Mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Frank Mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Frank Mirror/8.jpg"
    ],
    "description": "מראה פרנק, המיוצרת מזכוכית המראה המשובחת ביותר, משלבת עיצוב עגול עם מסגרת עץ קלאסית להוספת סגנון ואופי לחללים מודרניים. עם האסתטיקה האלגנטית שלה, מראה זו תוסיף באופן מושלם לכל חלל: מבואה, סלון או חדר שינה ראשי.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 17869,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Scilly Mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Scilly Mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/scilly-mirror_p9688.html?id=724&cat=514&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Scilly Mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/8.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/9.jpg",
      "../upload_images/laskasas/Mirrors/Scilly Mirror/10.jpg"
    ],
    "description": "המראה מסילי היא הדרך המושלמת להוסיף נקודת מוקד עכשווית ומושכת עין לכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 27120,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Tanny mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Tanny mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/tanny-mirror_p5363.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Tanny mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Tanny mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Tanny mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Tanny mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Tanny mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Tanny mirror/6.jpg"
    ],
    "description": "מראה טאני היא מראה עגולה גדולה שמוסיפה סגנון ופונקציונליות לכל חדר. עשויה ממתכת, חלק זה מושלם לחדרי שינה מודרניים או למשרדים ביתיים ואפילו לאולמות כניסה בעלי עיצוב עתידני.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 29983,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Rosane mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Rosane mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/rosane-mirror_p5344.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Rosane mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Rosane mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Rosane mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Rosane mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Rosane mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Rosane mirror/6.jpg"
    ],
    "description": "מראת רוזאן היא מראת קיר ייחודית שמאתגרת את העיצוב המסורתי ויוצרת חלל יפה. הצורה המעגלית של המראה הזו עשויה מתערובת של חומרים, כולל שיש ומתכת, ומציגה קו מתכת דק להוספת תחכום.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 11650,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Rod mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Rod mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/rod-mirror_p5349.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Rod mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Rod mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Rod mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Rod mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Rod mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Rod mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Rod mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Rod mirror/8.jpg"
    ],
    "description": "מראת מוט היא מראת קיר מודרנית עם מסגרת אלגנטית שמוסיפה תחושת יוקרה לכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 15034,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Phill mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Phill mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/phill-mirror_p4682.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Phill mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Phill mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Phill mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Phill mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Phill mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Phill mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Phill mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Phill mirror/8.jpg"
    ],
    "description": "פיל מראה הוא פריט דקורטיבי בסגנון מודרני. עם מסגרת נירוסטה, הוא מוסיף נופך של יוקרה לכל פרויקט עיצוב פנים.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 15871,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "James mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/James mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/james-mirror_p5340.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/James mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/James mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/James mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/James mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/James mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/James mirror/6.jpg"
    ],
    "description": "המראה של ג'יימס היא מראה עגולה גדולה ורב-תכליתית שיכולה לשמש במגוון סביבות. עם מסגרת לא בולטת, היא מושלמת לחדרי שינה עם תקרות גבוהות.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 15290,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Rayne mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Rayne mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/rayne-mirror_p5359.html?id=724&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Rayne mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Rayne mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Rayne mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Rayne mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Rayne mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Rayne mirror/6.jpg"
    ],
    "description": "המראה ריין היא פריט מרהיב המורכב ממראה ועלי מתכת. בעלת טקסטורה חזקה מבחינה ויזואלית, היא מראה שתופסת את העין ומהווה פריט נוי מעניין לקירות בחללים רכים.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 16425,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Lima Mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Lima Mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/lima-mirror_p4760.html?id=724&cat=514&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Lima Mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Lima Mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Lima Mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Lima Mirror/4.jpg"
    ],
    "description": "מראת לימה היא מראה עגולה ללא מסגרת עם עיצוב רומנטי ומעודן. אלמנט דקורטיבי שישדרג את המראה של כל חדר.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 20558,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Texas mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Texas mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/texas-mirror_p4689.html?id=724&cat=514&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Texas mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/8.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/9.jpg",
      "../upload_images/laskasas/Mirrors/Texas mirror/10.jpg"
    ],
    "description": "מראת טקסס היא פריט שחובה בכל חלל עכשווי עם עיצוב איטלקי. עם מסגרת פשוטה, המראה העומדת בעיצוב מלבני משדרגת את היופי של כל פרויקט עיצוב פנים.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 25119,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Iris mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Iris mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/iris-mirror_p5338.html?id=724&cat=514&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Iris mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Iris mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Iris mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Iris mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Iris mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Iris mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Iris mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Iris mirror/8.jpg"
    ],
    "description": "",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 22126,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Rio mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Rio mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/rio-mirror_p5366.html?id=724&cat=514&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Rio mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Rio mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Rio mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Rio mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Rio mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Rio mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Rio mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Rio mirror/8.jpg"
    ],
    "description": "המראה ריו היא מראת רצפה בעיצוב מודרני ופשוט שיכולה לשמש גם כמראת קיר. פריט פונקציונלי להחזרת אור ומרחב.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 17207,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Opium Mirror": {
    "image_url": "../upload_images/laskasas/Mirrors/Opium Mirror/1.jpg",
    "product_url": "https://www.laskasas.com/en/mirrors/opium-mirror_p4681.html?id=724&cat=514&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Mirrors/Opium Mirror/1.jpg",
      "../upload_images/laskasas/Mirrors/Opium Mirror/2.jpg",
      "../upload_images/laskasas/Mirrors/Opium Mirror/3.jpg",
      "../upload_images/laskasas/Mirrors/Opium Mirror/4.jpg",
      "../upload_images/laskasas/Mirrors/Opium Mirror/5.jpg",
      "../upload_images/laskasas/Mirrors/Opium Mirror/6.jpg",
      "../upload_images/laskasas/Mirrors/Opium Mirror/7.jpg",
      "../upload_images/laskasas/Mirrors/Opium Mirror/8.jpg"
    ],
    "description": "מראת אופיום היא מראת קיר גבוהה בעלת עיצוב מינימליסטי שמוסיפה אור ותחכום לכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Mirrors",
    "price": 17295,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Field Rug": {
    "image_url": "../upload_images/laskasas/Rugs/Field Rug/1.jpg",
    "product_url": "https://www.laskasas.com/en/rugs/field-rug_p9690.html?id=1151&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Rugs/Field Rug/1.jpg",
      "../upload_images/laskasas/Rugs/Field Rug/2.jpg",
      "../upload_images/laskasas/Rugs/Field Rug/3.jpg",
      "../upload_images/laskasas/Rugs/Field Rug/4.jpg",
      "../upload_images/laskasas/Rugs/Field Rug/5.jpg",
      "../upload_images/laskasas/Rugs/Field Rug/6.jpg"
    ],
    "description": "שטיח \"Field\" הוא שטיח רך ונעים שמביא את יופייה של הטבע אל תוך ביתך עם עיצובו בהשראת טבע.",
    "company_name": "Laskasas",
    "original_category": "Rugs",
    "price": 22029,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Net Rug": {
    "image_url": "../upload_images/laskasas/Rugs/Net Rug/1.jpg",
    "product_url": "https://www.laskasas.com/en/rugs/net-rug_p9698.html?id=1151&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Rugs/Net Rug/1.jpg",
      "../upload_images/laskasas/Rugs/Net Rug/2.jpg",
      "../upload_images/laskasas/Rugs/Net Rug/3.jpg",
      "../upload_images/laskasas/Rugs/Net Rug/4.jpg",
      "../upload_images/laskasas/Rugs/Net Rug/5.jpg",
      "../upload_images/laskasas/Rugs/Net Rug/6.jpg"
    ],
    "description": "שטיח נט הוא שטיח מודרני המתאפיין בדוגמת רשת ייחודית, המוסיף נגיעה של סגנון עכשווי לביתך.",
    "company_name": "Laskasas",
    "original_category": "Rugs",
    "price": 10453,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Path Rug": {
    "image_url": "../upload_images/laskasas/Rugs/Path Rug/1.jpg",
    "product_url": "https://www.laskasas.com/en/rugs/path-rug_p9704.html?id=1151&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Rugs/Path Rug/1.jpg",
      "../upload_images/laskasas/Rugs/Path Rug/2.jpg",
      "../upload_images/laskasas/Rugs/Path Rug/3.jpg",
      "../upload_images/laskasas/Rugs/Path Rug/4.jpg",
      "../upload_images/laskasas/Rugs/Path Rug/5.jpg",
      "../upload_images/laskasas/Rugs/Path Rug/6.jpg"
    ],
    "description": "שטיח פַּת הוא שטיח נועז ובולט שיוצר אמירה בכל חדר עם דוגמאותיו וצבעיו הניגודיים.",
    "company_name": "Laskasas",
    "original_category": "Rugs",
    "price": 19962,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Sash Rug": {
    "image_url": "../upload_images/laskasas/Rugs/Sash Rug/1.jpg",
    "product_url": "https://www.laskasas.com/en/rugs/sash-rug_p9695.html?id=1151&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Rugs/Sash Rug/1.jpg",
      "../upload_images/laskasas/Rugs/Sash Rug/2.jpg",
      "../upload_images/laskasas/Rugs/Sash Rug/3.jpg",
      "../upload_images/laskasas/Rugs/Sash Rug/4.jpg",
      "../upload_images/laskasas/Rugs/Sash Rug/5.jpg",
      "../upload_images/laskasas/Rugs/Sash Rug/6.jpg"
    ],
    "description": "שטיח סאש הוא שטיח שמוסיף נגיעה של אלגנטיות לכל חדר עם העיצוב העדין שלו, הדומה לסאש.",
    "company_name": "Laskasas",
    "original_category": "Rugs",
    "price": 10365,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Sidewalk Rug": {
    "image_url": "../upload_images/laskasas/Rugs/Sidewalk Rug/1.jpg",
    "product_url": "https://www.laskasas.com/en/rugs/sidewalk-rug_p9556.html?id=1151&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Rugs/Sidewalk Rug/1.jpg",
      "../upload_images/laskasas/Rugs/Sidewalk Rug/2.jpg",
      "../upload_images/laskasas/Rugs/Sidewalk Rug/3.jpg",
      "../upload_images/laskasas/Rugs/Sidewalk Rug/4.jpg",
      "../upload_images/laskasas/Rugs/Sidewalk Rug/5.jpg",
      "../upload_images/laskasas/Rugs/Sidewalk Rug/6.jpg"
    ],
    "description": "שטיח מדרכה הוא שטיח שמעורר את התחושה של מדרכה עירונית עם העיצוב בהשראת עיר.",
    "company_name": "Laskasas",
    "original_category": "Rugs",
    "price": 29702,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Vertical Rug": {
    "image_url": "../upload_images/laskasas/Rugs/Vertical Rug/1.jpg",
    "product_url": "https://www.laskasas.com/en/rugs/vertical-rug_p9560.html?id=1151&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Rugs/Vertical Rug/1.jpg",
      "../upload_images/laskasas/Rugs/Vertical Rug/2.jpg",
      "../upload_images/laskasas/Rugs/Vertical Rug/3.jpg",
      "../upload_images/laskasas/Rugs/Vertical Rug/4.jpg",
      "../upload_images/laskasas/Rugs/Vertical Rug/5.jpg",
      "../upload_images/laskasas/Rugs/Vertical Rug/6.jpg"
    ],
    "description": "שָׁטִיחַ אֲנָכִי הוא שָׁטִיחַ שמביע אמירה עם העיצוב האנכי הייחודי שלו ופלטת הגוונים הניטרלית.",
    "company_name": "Laskasas",
    "original_category": "Rugs",
    "price": 25655,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Wire Rug": {
    "image_url": "../upload_images/laskasas/Rugs/Wire Rug/1.jpg",
    "product_url": "https://www.laskasas.com/en/rugs/wire-rug_p9701.html?id=1151&cat=514&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Rugs/Wire Rug/1.jpg",
      "../upload_images/laskasas/Rugs/Wire Rug/2.jpg",
      "../upload_images/laskasas/Rugs/Wire Rug/3.jpg",
      "../upload_images/laskasas/Rugs/Wire Rug/4.jpg",
      "../upload_images/laskasas/Rugs/Wire Rug/5.jpg",
      "../upload_images/laskasas/Rugs/Wire Rug/6.jpg"
    ],
    "description": "שטיח חוט הוא שטיח עם עיצוב נקי ומינימליסטי שמוסיף נופך של תחכום לכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Rugs",
    "price": 14249,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Badi Outdoor Armchair ": {
    "image_url": "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /1.jpg",
    "product_url": "https://www.laskasas.com/en/outside/badi-outdoor-armchair_p84325.html?id=1357&cat=1196&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /1.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /2.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /3.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /4.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /5.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /6.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /7.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /8.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /9.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /10.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /11.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /12.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /13.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /14.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /15.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Armchair /16.jpg"
    ],
    "description": "רב-גוני ומסוגנן, כורסת החוץ \"בדי\" יכולה לעמוד לבד כפריט ייחודי או להשתלב עם ספות ופופים מסדרת \"בדי\" ליצירת אזורי נוחות מזמינים בחוץ. עם מסגרת ברזל שחורה ומרקמת וריפוד בד, כורסה זו מבטיחה נוחות וסגנון ארוך-טווח שישדרגו כל חלל חיצוני.",
    "company_name": "Laskasas",
    "original_category": "Outdoor Collection",
    "price": 19810,
    "filter_category": "",
    "placement": "Indoor"
  },
  "Salim Outdoor Sun Lounger": {
    "image_url": "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/1.jpg",
    "product_url": "https://www.laskasas.com/en/outside/salim-outdoor-sun-lounger_p84343.html?id=1357&cat=1196&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/1.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/2.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/3.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/4.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/5.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/6.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/7.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/8.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/9.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/10.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/11.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/12.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/13.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/14.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/15.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/16.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/17.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/18.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/19.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sun Lounger/20.jpg"
    ],
    "description": "לנוחות וסגנון אולטימטיבי בחוץ, מיטת שיזוף מודרנית זו מתאפיינת במסגרת ברזל שחור עם מרקם ותוספות עץ קמבאלה כהות. מיטת שיזוף זו מוצבת על גלגלים להובלה קלה, ומאפשרת הרפיה והנאה מהחוץ עם אלגנטיות ונוחות שאין דומה להן.",
    "company_name": "Laskasas",
    "original_category": "Outdoor Collection",
    "price": 27192,
    "filter_category": "",
    "placement": "Indoor"
  },
  "Badi Outdoor Coffee Table": {
    "image_url": "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/outside/badi-outdoor-coffee-table_p84323.html?id=1357&cat=1196&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Coffee Table/1.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Coffee Table/2.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Coffee Table/3.jpg"
    ],
    "description": "המזנון החיצוני של בדי, המיוצר בעץ קמבאלה כהה בעל גוון ייחודי ועשיר, מוסיף אווירה של תחכום לכל חלל חיצוני. מיוצר במטרה לשמור על עמידות, הוא מבטיח יופי ופונקציונליות גם יחד, מה שהופך אותו לתוספת המושלמת לספות ולכורסאות בדי.",
    "company_name": "Laskasas",
    "original_category": "Outdoor Collection",
    "price": 13980,
    "filter_category": "",
    "placement": "Indoor"
  },
  "Salim Outdoor Coffee Table": {
    "image_url": "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/outside/salim-outdoor-coffee-table_p84344.html?id=1357&cat=1196&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Coffee Table/1.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Coffee Table/2.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Coffee Table/3.jpg"
    ],
    "description": "בשילוב קווים נקיים ואישיות תוססת, שולחן הקפה החיצוני הזה משנה בקלות כל חלל חיצוני. המשטח העץ המרהיב מחזק את החמימות והנוחות של עץ הקמבאלה הכהה, בעוד שעיצובו הרב-שימושי מציע נוחות ונוחות.",
    "company_name": "Laskasas",
    "original_category": "Outdoor Collection",
    "price": 17636,
    "filter_category": "",
    "placement": "Indoor"
  },
  "Badi Outdoor Pouf": {
    "image_url": "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/outside/badi-outdoor-pouf_p84331.html?id=1357&cat=1196&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/1.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/2.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/3.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/4.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/5.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/6.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/7.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/8.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/9.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/10.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/11.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/12.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/13.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/14.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/15.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Pouf/16.jpg"
    ],
    "description": "הפוף באדי הזה הוא התוספת המושלמת ליצירת חללי חוץ פונקציונליים ומזמינים. עם העיצוב הנעים והמפנק שלו, הפוף הזה לחוץ מוסיף בנוחות ובחינניות לכל חלל חיצוני, והופך אותו לנווה מדבר עליז ואלגנטי.",
    "company_name": "Laskasas",
    "original_category": "Outdoor Collection",
    "price": 29490,
    "filter_category": "",
    "placement": "Indoor"
  },
  "Salim Outdoor Pouf": {
    "image_url": "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/1.jpg",
    "product_url": "https://www.laskasas.com/en/outside/salim-outdoor-pouf_p84346.html?id=1357&cat=1196&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/1.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/2.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/3.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/4.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/5.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/6.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/7.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/8.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/9.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/10.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/11.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Pouf/12.jpg"
    ],
    "description": "עם קווים חלקים ועיצוב מעוגל, הפוף החיצוני סליים הוא התוספת המושלמת לספת סליים, והוא אידיאלי ליצירת מרחבים חיצוניים נוחים ומזמינים שהם גם אופנתיים וגם פונקציונליים.",
    "company_name": "Laskasas",
    "original_category": "Outdoor Collection",
    "price": 22986,
    "filter_category": "",
    "placement": "Indoor"
  },
  "Badi Outdoor Sofa": {
    "image_url": "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/outside/badi-outdoor-sofa_p84337.html?id=1357&cat=1196&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/1.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/2.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/3.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/4.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/5.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/6.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/7.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/8.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/9.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/10.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/11.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/12.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/13.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/14.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/15.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/16.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/17.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/18.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/19.jpg",
      "../upload_images/laskasas/Outdoor Collection/Badi Outdoor Sofa/20.jpg"
    ],
    "description": "ספת החוץ המודרנית באדי היא ההגדרה לאלגנטיות, עם עיצוב חלק ואיכות עבודת אומן עמידה. עם מסגרת ברזל שחורה ומרקמת עטופה בבד ספות חוץ מרופד, ספת החוץ הזו משתלבת בצורה מושלמת בין פנים לחוץ, מה שהופך אותה לפריט הצהרתי המושלם לכל חלל חיצוני. כיסוי עמיד למים לספת חוץ זמין.",
    "company_name": "Laskasas",
    "original_category": "Outdoor Collection",
    "price": 27930,
    "filter_category": "",
    "placement": "Indoor"
  },
  "Salim Outdoor Sofa": {
    "image_url": "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/1.jpg",
    "product_url": "https://www.laskasas.com/en/outside/salim-outdoor-sofa_p84356.html?id=1357&cat=1196&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/1.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/2.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/3.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/4.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/5.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/6.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/7.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/8.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/9.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/10.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/11.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/12.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/13.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/14.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/15.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/16.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/17.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/18.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/19.jpg",
      "../upload_images/laskasas/Outdoor Collection/Salim Outdoor Sofa/20.jpg"
    ],
    "description": "הספה החיצונית \"סלים\" משלבת פשטות עם עמידות. ספה זו נתמכת על ידי מבנה ברזל שחור בעל טקסטורה יציבה ומרופדת בחומרים פרימיום. סט הספות החיצוניות מדגים את מחויבות \"Laskasas\" לאלגנטיות על-זמנית ונוחות. יחד עם שולחן חיצוני תואם, הספה החיצונית המודרנית יוצרת מערכת קוהרנטית ומזמינה לכל חלל, ומציעה גם סגנון וגם עמידות בפני פגעי מזג האוויר. כיסוי עמיד למים לספה חיצונית זמין.",
    "company_name": "Laskasas",
    "original_category": "Outdoor Collection",
    "price": 24585,
    "filter_category": "",
    "placement": "Indoor"
  },
  "Morrison Bar Cabinet": {
    "image_url": "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-cabinets-and-cupboards/morrison-bar-cabinet_p84443.html?id=1393&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/1.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/2.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/3.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/4.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/5.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/6.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/7.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/8.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/9.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/10.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/11.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/12.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/13.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/14.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/15.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/16.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/17.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/18.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/19.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/20.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/21.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/22.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/23.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/24.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/25.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/26.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/27.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/28.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/29.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Morrison Bar Cabinet/30.jpg"
    ],
    "description": "ארון הבר מוריסון הוא התגלמות התחכום והתפקודיות. עם אחסון שופע, כולל שני מגירות ומדף זכוכית ברונזה, הוא מאזנים באופן מושלם בין צורה לתפקוד. הפריט האלגנטי הזה לא רק משפר את הפנים אלא גם מציע נוחות, מה שהופך אותו להוספה מעוצבת ומעשית לכל אזור אוכל.",
    "company_name": "Laskasas",
    "original_category": "Bar Cabinets & Cupboards",
    "price": 11537,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Boris Cupboard": {
    "image_url": "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-cabinets-and-cupboards/boris-cupboard_p5878.html?id=1393&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/1.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/2.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/3.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/4.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/5.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/6.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/7.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/8.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/9.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/10.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/11.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/12.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/13.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/14.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/15.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Boris Cupboard/16.jpg"
    ],
    "description": "הארון בוריס הוא ארון מפתה בעבודת יד מעץ, המתאפיין בשילוב גימורים שמעניקים מגע זוהר לכל חלל. זהו פתרון פשוט לחדרי אוכל פונקציונליים.",
    "company_name": "Laskasas",
    "original_category": "Bar Cabinets & Cupboards",
    "price": 17428,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Cannes bar cabinet": {
    "image_url": "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-cabinets-and-cupboards/cannes-bar-cabinet_p5865.html?id=1393&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/1.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/2.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/3.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/4.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/5.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/6.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/7.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/8.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/9.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/10.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/11.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/12.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/13.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/14.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/15.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cannes bar cabinet/16.jpg"
    ],
    "description": "ארון הבר קאן הוא פריט מרשים וזוהר. הוא מושלם לפינת בר ביתית או לסלון של מועדון כפרי פרטי. הוא כולל מגירות מעשיות ומקום אחסון לקוקטיילים.",
    "company_name": "Laskasas",
    "original_category": "Bar Cabinets & Cupboards",
    "price": 18280,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Cuba Bar Cabinet": {
    "image_url": "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-cabinets-and-cupboards/cuba-bar-cabinet_p4757.html?id=1393&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/1.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/2.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/3.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/4.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/5.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/6.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/7.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/8.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/9.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/10.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/11.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/12.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/13.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/14.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/15.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Cuba Bar Cabinet/16.jpg"
    ],
    "description": "קבינט הבר קובה ישדרג כל עמדת בר בבית, עם עיצובו היפה שייראה נהדר בחדר אוכל או בסלון.",
    "company_name": "Laskasas",
    "original_category": "Bar Cabinets & Cupboards",
    "price": 28490,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Lewis cupboard": {
    "image_url": "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-cabinets-and-cupboards/lewis-cupboard_p5870.html?id=1393&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/1.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/2.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/3.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/4.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/5.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/6.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/7.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/8.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/9.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/10.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/11.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/12.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/13.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/14.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/15.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Lewis cupboard/16.jpg"
    ],
    "description": "המזנון של לואיס הוא פריט עכשווי עם קווים ישרים, עשוי בעבודת יד מעץ וניתן להתאמה אישית בחומרים, בגימורים ובמידות שונות. בתחום עיצוב הבית המתוחכם, ארונות בר הפכו לפריט חובה עבור אלה שמעריכים את הדברים המיוחדים בחיים.",
    "company_name": "Laskasas",
    "original_category": "Bar Cabinets & Cupboards",
    "price": 26881,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Ralph Bar Cabinet": {
    "image_url": "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-cabinets-and-cupboards/ralph-bar-cabinet_p9538.html?id=1393&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/1.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/2.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/3.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/4.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/5.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/6.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/7.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/8.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/9.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/10.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/11.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/12.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/13.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/14.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/15.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/16.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/17.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/18.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/19.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Ralph Bar Cabinet/20.jpg"
    ],
    "description": "ארון הבר ראלף הוא תוספת מושלמת לכל חלל מגורים מודרני. השילוב של החומרים יוצר מראה ייחודי ואלגנטי שבטוח להרשים.",
    "company_name": "Laskasas",
    "original_category": "Bar Cabinets & Cupboards",
    "price": 15400,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Alvar Bar Cabinet": {
    "image_url": "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/bar-cabinets-and-cupboards/alvar-bar-cabinet_p9534.html?id=1393&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/1.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/2.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/3.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/4.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/5.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/6.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/7.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/8.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/9.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/10.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/11.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/12.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/13.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/14.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/15.jpg",
      "../upload_images/laskasas/Bar Cabinets & Cupboards/Alvar Bar Cabinet/16.jpg"
    ],
    "description": "ארון הבר אלוואר הוא רהיט מודרני שמביא נגיעה עכשווית לאזור הבר הביתי. עם הקווים הנקיים והעיצוב המינימלי שלו, ארון הבר הזה מושלם עבור אלו שמעריכים פשטות ופונקציונליות.",
    "company_name": "Laskasas",
    "original_category": "Bar Cabinets & Cupboards",
    "price": 18018,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Amber bedside table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Amber bedside table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/amber-bedside-table_p5970.html?id=1394&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Amber bedside table/20.jpg"
    ],
    "description": "אמבר הוא שולחן צד אלגנטי לחדר השינה עם רגליים שמביא סגנון ואחסון מרווח לכל חדר שינה. הפרופיל הנקי שלו משתלב בצורה מושלמת עם עיצוב מודרני, דבר שהופך אותו לבחירה אידיאלית עבור מעצבים המחפשים שילוב של פונקציונליות ואלגנטיות עכשווית.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 23187,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Bowen bedside table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Bowen bedside table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/bowen-bedside-table_p8114.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Bowen bedside table/16.jpg"
    ],
    "description": "שולחן הצד בואן הוא יצירת מופת עכשווית שממחישה עבודת יד, חומרים מעודנים ועיצוב מודרני. הוא משלב חומרים מנוגדים ליצירת מראה רענן ומעברי שיכול להשלים כל עיצוב פנים.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 20902,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Cairo Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/cairo-bedside-table_p5934.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Cairo Bedside Table/16.jpg"
    ],
    "description": "שדרגו את עיצובי הפנים שלכם עם שולחן הלילה קהיר, שולחן לילה אלגנטי שמשתלב עם כל מיטה וסגנון עיצוב. העיצוב הפשוט אך המעודן שלו מוסיף נופך של תחכום על-זמני, מה שהופך אותו לתוספת רב-תכליתית ופונקציונלית לכל חדר שינה.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 13001,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Connor bedside table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Connor bedside table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/connor-bedside-table_p4594.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Connor bedside table/16.jpg"
    ],
    "description": "קונור הוא שולחן לילה קומפקטי המעוצב לשימוש יומיומי וגמישות. עם עיצוב חלק ללא ידיות ושתי מגירות מרווחות, הוא מציע שטח אחסון רב תוך שמירה על אסתטיקה מינימליסטית.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 13152,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Dakar Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/dakar-bedside-table_p5960.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakar Bedside Table/16.jpg"
    ],
    "description": "מבקשת לתרגם את הטקסט הבא לעברית: \"דקר הוא שולחן לילה עכשווי שמשלב סגנון ופונקציונליות. עם עיצוב מודרני ואלגנטי, הוא מושלם לחללי פנים אופנתיים, מציע שטח אחסון רב ומשדרג את המראה הכללי של כל עיצוב חדר שינה.\"",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 10267,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Dakota Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/dakota-bedside-table_p5963.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Dakota Bedside Table/16.jpg"
    ],
    "description": "נראה מסוגנן, אלגנטי וייחודי, שולחן הלילה דקוטה יפתור את כל צרכי האחסון שלך בלי להתאמץ. מושלם לשמור ספרים, מטענים ופריטים קטנים נוספים בחדר השינה מוסתרים בצורה מסודרת בשידת לילה קטנה ומועילה זו, שתשלים את המראה של עיצוב חדר השינה שלך.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 20563,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Duane bedside table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Duane bedside table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/duane-bedside-table_p5964.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Duane bedside table/16.jpg"
    ],
    "description": "שולחן ליד המיטה דוויין הוא שולחן ליד המיטה מעץ ומתכת, שעוצב כדי להציע אלגנטיות וסגנון לכל חדר שינה. הוא כולל שתי מגירות רכות-סגירה ללא ידיות ופרטי מתכת מנוגדים, ומטרתו לשדרג את האווירה הכללית של כל סט חדר שינה.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 22930,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Emily Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/emily-bedside-table_p5945.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Emily Bedside Table/16.jpg"
    ],
    "description": "גלה את שידת הלילה אמילי, שידת לילה מעוצבת שמשלבת פונקציונליות ועיצוב מלוטש. עם שטח אחסון מרווח לבגדים, מצעים או פריטים חיוניים, היא בחירה אידיאלית למעצבי פנים המחפשים גם פונקציה וגם אלגנטיות מודרנית.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 19755,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Endy bedside table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Endy bedside table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/endy-bedside-table_p5928.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Endy bedside table/17.jpg"
    ],
    "description": "שידת הלילה העשויה עץ מעודן עם מגירות מציגה אומנות מודרנית ואיכות נצחית. עם עיצוב קומפקטי ומינימליסטי ושתי מגירות ללא ידיות, שידת הלילה אנדי מושלמת לאחסון פריטים יומיומיים ומוסיפה נגיעה איטלקית מיוחדת לכל חדר שינה.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 23945,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Ester Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/ester-bedside-table_p4597.html?id=1394&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Ester Bedside Table/16.jpg"
    ],
    "description": "הכירו את אסתר, שולחן צד קטן לצד המיטה המיוצר בדיוק ותשוקה. ניחן בקסם על-זמני ומציע גמישות שאין שנייה לה, רהיט עץ זה הוא בחירה אידיאלית לאלה המחפשים לשדרג חללים קומפקטיים עם אחסון אלגנטי ופונקציונלי.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 28494,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Rowling Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/rowling-bedside-table_p84482.html?id=1394&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Rowling Bedside Table/20.jpg"
    ],
    "description": "שולחן הלילה רולינג, עם מגירה מרווחת ומדף פתוח, מספק אחסון לכל הדברים החיוניים תוך הוספת נגיעה של אלגנטיות עכשווית לחדר השינה.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 14519,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Hilary Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/hilary-bedside-table_p5930.html?id=1394&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Hilary Bedside Table/20.jpg"
    ],
    "description": "זהו שולחן הלילה \"הילרי\", שולחן עץ מודרני המיועד לנוחות ואלגנטיות. העיצוב הרך והמינימליסטי שלו הופך אותו לתוספת המושלמת לחדר שינה עכשווי, ומציע משיכה אסתטית ופונקציונליות לחלל מגורים רגוע.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 17261,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Kira Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/kira-bedside-table_p5942.html?id=1394&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Kira Bedside Table/20.jpg"
    ],
    "description": "שולחן הלילה קירה הוא שולחן לילה אלגנטי עם שתי מגירות, המיועד לעיצובים מתוחכמים. עם מגירות נסגרות ברכות ובסיס מתכתי מרשים, פריט זה משלב יופי עם פונקציונליות, מה שהופך אותו למושלם ליצירת חדרי שינה מתוחכמים ועל זמניים.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 29213,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Lady bedside table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Lady bedside table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/lady-bedside-table_p5956.html?id=1394&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Lady bedside table/20.jpg"
    ],
    "description": "שידת הלילה ליידי: בחירה מתוחכמת לחללים קלאסיים. שידת לילה מעץ זו כוללת שתי מגירות עם סגירה רכה ובסיס מתכתי מנוגד, ומשלבת בין אומנות עץ על-זמנית לפונקציונליות אלגנטית.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 30000,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Male Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Male Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/male-bedside-table_p5973.html?id=1394&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/20.jpg",
      "../upload_images/laskasas/Bedside Tables/Male Bedside Table/21.jpg"
    ],
    "description": "גלה את מאלאה, שולחן צד בעל מגירה אחת שמיועד להוסיף מראה נקי ורענן לכל חדר. העיצוב המינימליסטי שלו ותא האחסון היחיד משלבים פונקציונליות עם תחכום, מה שהופך אותו לבחירה אידיאלית לחללים מודרניים.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 29897,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Mucala Bedside Table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/mucala-bedside-table_p4741.html?id=1394&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Mucala Bedside Table/20.jpg"
    ],
    "description": "מוצלה היא שידת לילה רחבה שמתאפיינת בפשטות ובקווים נקיים. עם שני מגירות מרווחות לאחסון ואפשרות להתאמה אישית במגוון רחב של חומרים, היא מושלמת למעצבי פנים שמחפשים פתרונות גמישים ואלגנטיים לעיצוב חדרי שינה מודרניים.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 22627,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Rosie bedside table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Rosie bedside table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/rosie-bedside-table_p5953.html?id=1394&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Rosie bedside table/20.jpg"
    ],
    "description": "נתפס כשמשל משויף של אלגנטיות, רוזי היא שידת לילה עם מגירות שתפאר כל חדר שינה בנוכחותה המעודנת. יש לה שתי מגירות לאחסון פרקטי. מוצר זה זמין בשני גדלים סטנדרטיים, כאשר ניתן לקבל מידות מותאמות אישית, מה שמציע גמישות להתאים לדרישות שונות של חלל.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 14378,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Uso bedside table": {
    "image_url": "../upload_images/laskasas/Bedside Tables/Uso bedside table/1.jpg",
    "product_url": "https://www.laskasas.com/en/bedside-tables/uso-bedside-table_p4702.html?id=1394&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/1.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/2.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/3.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/4.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/5.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/6.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/7.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/8.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/9.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/10.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/11.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/12.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/13.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/14.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/15.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/16.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/17.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/18.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/19.jpg",
      "../upload_images/laskasas/Bedside Tables/Uso bedside table/20.jpg"
    ],
    "description": "שולחן הלילה \"אוסו\" הוא שולחן מעץ מעוצב ומלוטש המתאים לחללים פנים מתוחכמים. פריט קומפקטי וחלק זה כולל שני מדפים אלגנטיים, המוסיפים נופך יוקרתי לחלל ומשלבים פתרון אחסון פרקטי.",
    "company_name": "Laskasas",
    "original_category": "Bedside Tables",
    "price": 11637,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Biel bookshelf": {
    "image_url": "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/1.jpg",
    "product_url": "https://www.laskasas.com/en/bookcases-and-bookshelves/biel-bookshelf_p4792.html?id=1392&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/1.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/2.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/3.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/4.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/5.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/6.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/7.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/8.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/9.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/10.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/11.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/12.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/13.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/14.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/15.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/16.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/17.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/18.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/19.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Biel bookshelf/20.jpg"
    ],
    "description": "גלה את מדף הספרים ביאל, מדף ספרים אלגנטי עם מגירות המעוצב עבור חללים פנימיים מודרניים. עם קווים נקיים, עיצוב מינימליסטי וחומרים באיכות גבוהה, זהו פתרון אחסון חכם להוסיף פונקציונליות מסוגננת לכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Bookcases & Bookshelves",
    "price": 29390,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Bylot Bookshelf": {
    "image_url": "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/1.jpg",
    "product_url": "https://www.laskasas.com/en/bookcases-and-bookshelves/bylot-bookshelf_p8147.html?id=1392&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/1.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/2.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/3.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/4.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/5.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/6.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/7.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/8.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/9.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/10.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/11.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Bylot Bookshelf/12.jpg"
    ],
    "description": "השלימו את הסלון שלכם עם כוננית הספרים ביילוט. עיצוב המסגרת הייחודי שלה בוודאי יוסיף אופי לחלל שהוא אחרת מסורתי.",
    "company_name": "Laskasas",
    "original_category": "Bookcases & Bookshelves",
    "price": 26843,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "D'ARC Bookshelf": {
    "image_url": "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/1.jpg",
    "product_url": "https://www.laskasas.com/en/bookcases-and-bookshelves/darc-bookshelf_p5800.html?id=1392&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/1.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/2.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/3.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/4.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/5.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/6.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/7.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/8.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/9.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/10.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/11.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'ARC Bookshelf/12.jpg"
    ],
    "description": "הכירו את מדף הספרים D'Arc: מדף ספרים עכשווי שמשלב באופן מושלם בין אלגנטיות קלאסית לעיצוב מודרני. ההיבט האסתטי הפשוט אך המושך שלו, בשילוב עם אחסון יעיל, הופכים אותו לתוספת אידיאלית לכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Bookcases & Bookshelves",
    "price": 28246,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Ives Bookshelf": {
    "image_url": "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/1.jpg",
    "product_url": "https://www.laskasas.com/en/bookcases-and-bookshelves/ives-bookshelf_p93153.html?id=1392&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/1.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/2.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/3.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/4.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/5.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/6.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/7.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/8.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/9.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/10.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/11.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Ives Bookshelf/12.jpg"
    ],
    "description": "עם ממדיו המרווחים וריבוי התאים הקטנים והפתוחים הממוקמים בצורה מסודרת, מספק כוננית הספרים הגדולה הזו שפע מקום לאחסון ולהצגה, מה שהופך את הסידור והאבזור לפשוטים. מעוצבת בברזל שחור עם טקסטורה ובפלדת אל-חלד, אייבס מתאפיין במשיכה עכשווית תוך שהוספה של טאץ' עידון לכל משרד או סלון.",
    "company_name": "Laskasas",
    "original_category": "Bookcases & Bookshelves",
    "price": 15514,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Taylor bookshelf": {
    "image_url": "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/1.jpg",
    "product_url": "https://www.laskasas.com/en/bookcases-and-bookshelves/taylor-bookshelf_p4690.html?id=1392&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/1.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/2.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/3.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/4.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/5.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/6.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/7.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/8.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/9.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/10.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/11.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/12.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/13.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/14.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/15.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Taylor bookshelf/16.jpg"
    ],
    "description": "טיילור הוא כוננית ספרים גדולה המציעה פתרונות אחסון עכשוויים. מושלם עבור ספרים, פריטים דקורטיביים ועוד, העיצוב הייחודי והמבנה האיכותי שלו הופכים אותו לבחירה אידיאלית למי שמחפש להוסיף פונקציונליות וסטייל לכל סביבה.",
    "company_name": "Laskasas",
    "original_category": "Bookcases & Bookshelves",
    "price": 10337,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "D'Arc bookcase": {
    "image_url": "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/1.jpg",
    "product_url": "https://www.laskasas.com/en/bookcases-and-bookshelves/darc-bookcase_p4660.html?id=1392&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/1.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/2.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/3.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/4.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/5.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/6.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/7.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/8.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/9.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/10.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/11.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/12.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/13.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/14.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/15.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/D'Arc bookcase/16.jpg"
    ],
    "description": "שידת ראלף היא פריט אלגנטי עם ארון בעל 4 דלתות המשדר תחושה טבעית ורטרו. מושלם לשמירת חפצים חיוניים בקרבת מקום, שידה זו עם רגלי מתכת יכולה להשתלב בכל פרויקט עיצוב פנים, ולהוסיף הן פונקציונליות והן סגנון לכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Bookcases & Bookshelves",
    "price": 24315,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Emy Bookshelf": {
    "image_url": "../upload_images/laskasas/Bookcases & Bookshelves/Emy Bookshelf/1.jpg",
    "product_url": "https://www.laskasas.com/en/bookcases-and-bookshelves/emy-bookshelf_p4820.html?id=1392&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Bookcases & Bookshelves/Emy Bookshelf/1.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Emy Bookshelf/2.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Emy Bookshelf/3.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Emy Bookshelf/4.jpg",
      "../upload_images/laskasas/Bookcases & Bookshelves/Emy Bookshelf/5.jpg"
    ],
    "description": "יחידת המדפים של אמי היא מדף רב-תכליתי עם חמש קומות, מתאים בצורה מושלמת למשרד, חדר לימוד, ספריה או פינת קריאה. העיצוב האלגנטי שלה מציע גם סגנון וגם פרקטיות, מה שהופך אותה לפתרון חוסך מקום אידיאלי עבור מעצבי פנים השואפים למקסם אחסון ומשיכה אסתטית.",
    "company_name": "Laskasas",
    "original_category": "Bookcases & Bookshelves",
    "price": 26257,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Endy Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/endy-chest-of-drawers_p5714.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Endy Chest of Drawers/12.jpg"
    ],
    "description": "שידת מגירות אנדי היא שילוב מושלם של סגנון ופונקציונליות. היא מתאפיינת בעיצוב מינימליסטי ויש לה שטח אחסון רב במגירות.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 18441,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Bowen Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/bowen-chest-of-drawers_p8119.html?id=1395&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/16.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/17.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/18.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/19.jpg",
      "../upload_images/laskasas/Chest of Drawers/Bowen Chest of Drawers/20.jpg"
    ],
    "description": "השידה של בואן היא תוספת עכשווית לכל חדר שינה. הקווים החלקים מעניקים לשידה מראה אלגנטי, בעוד שהמקום האחסון הרחב יכיל את כל המצעים והבגדים שלך.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 23435,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Rowling Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/rowling-chest-of-drawers_p84490.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rowling Chest of Drawers/16.jpg"
    ],
    "description": "שידת המגירות רולינג היא רהיט פונקציונלי שיוסיף נופך מעודן לעיצוב הפנים. עם משטח זכוכית מלוטש ושלוש מגירות מרווחות, היא מציעה שילוב של סגנון ותפקוד.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 20627,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "CONNOR Chest of Drawres": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/connor-chest-of-drawres_p4567.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/CONNOR Chest of Drawres/12.jpg"
    ],
    "description": "בשל עיצובו הייחודי והבנייה האיכותית שלו, ארון המגירות \"קונור\" מושלם לאחסון בגדים, מצעים או פריטים אחרים. הוא זמין בגימורים וצבעים שונים כדי להתאים לסגנון שלך.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 28702,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "DUANE Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/duane-chest-of-drawers_p4568.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/DUANE Chest of Drawers/16.jpg"
    ],
    "description": "שידת המגירות דוויין מושלמת לכל עיצוב מודרני, היא מתאפיינת בעיצוב מלוטש ומספקת שטח אחסון מרווח במגירות.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 13486,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "EMILY Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/emily-chest-of-drawers_p4569.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/EMILY Chest of Drawers/16.jpg"
    ],
    "description": "שידת המגירות הקטנה הזו מציעה פרקטיות מבלי להתפשר על סגנון. מושלמת לארגון והוספת נגיעה של תחכום לכל חלל פנים. שדרגו כל חלל עם שידת המגירות מעץ באיכות הגבוהה ביותר שלנו, הניתנת להתאמה אישית מלאה כדי להתאים לצרכי הפרויקט שלכם.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 28148,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Ester Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/ester-chest-of-drawers_p9721.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Ester Chest of Drawers/16.jpg"
    ],
    "description": "שידת המגירות אסתר היא שילוב מושלם של אלגנטיות ופונקציונליות. היא כוללת שישה מגירות מרווחות המספקות שטח אחסון נרחב לשמור על חפציכם מסודרים ונגישים בקלות. המגירות עמוקות ורחבות מספיק כדי להכיל את חפציכם, והמנגנון החלק לפתיחתן וסגירתן הופך את השימוש בהן לנוח.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 15972,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "HILARY Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/hilary-chest-of-drawers_p4570.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/HILARY Chest of Drawers/16.jpg"
    ],
    "description": "שידת המגירות הילרי היא תוספת מסוגננת לכל חדר בביתכם. היא מתאפיינת בעיצוב מינימליסטי ובשטח אחסון נרחב במגירות.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 20294,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Mucala Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/mucala-chest-of-drawers_p4743.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Mucala Chest of Drawers/16.jpg"
    ],
    "description": "שידת מגירות מוכלרה היא פתרון אחסון אלגנטי ומודרני לכל חדר בפרויקט שלך. היא מאופיינת בקווים נקיים ועיצוב מינימליסטי שישתלב בכל עיצוב מודרני.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 10410,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Kira Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/kira-chest-of-drawers_p4921.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Kira Chest of Drawers/16.jpg"
    ],
    "description": "עיצוב החזה של קירה והמומחיות ביצוע הופכים אותו לתוספת מושלמת לכל בית. ארון המגירות ניתן למיקום כנגד קיר, מה שהופך אותו לפתרון אחסון פרקטי וסטייליסטי. שדרגו את הפרויקט שלכם עם העיצוב הייחודי והאיכות המעולה של ארון המגירות של קירה.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 25090,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "LADY Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/lady-chest-of-drawers_p4572.html?id=1395&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/LADY Chest of Drawers/16.jpg"
    ],
    "description": "שידת מגירות לאשה היא תוספת אופנתית לכל חדר שינה, ומציעה מרחב אחסון נרחב ומראה מודרני. המגירות נעות בצורה חלקה ומצויידות במנגנוני סגירה רכה לנוחות.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 28963,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Rosie chest of drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/rosie-chest-of-drawers_p4573.html?id=1395&cat=1382&pc=2&f=2",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/16.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/17.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/18.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/19.jpg",
      "../upload_images/laskasas/Chest of Drawers/Rosie chest of drawers/20.jpg"
    ],
    "description": "השידה המודרנית של רוזי היא פתרון אחסון חלק ומודרני לכל חדר בביתך, עם עיצוב מינימליסטי ושפע מקום אחסון במגירות.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 20946,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Male Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/male-chest-of-drawers_p5745.html?id=1395&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/16.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/17.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/18.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/19.jpg",
      "../upload_images/laskasas/Chest of Drawers/Male Chest of Drawers/20.jpg"
    ],
    "description": "שידת מגירות מאלי היא פתרון אחסון אופנתי ומעשי לכל חדר, המתאפיין בעיצוב חלק ובמרחב אחסון גדול במגירות.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 21352,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Cairo Chest of Drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/cairo-chest-of-drawers_p5722.html?id=1395&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/16.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/17.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/18.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/19.jpg",
      "../upload_images/laskasas/Chest of Drawers/Cairo Chest of Drawers/20.jpg"
    ],
    "description": "יחידת מגירות קהיר היא השילוב המושלם בין סגנון לפונקציונליות, והיא כוללת עיצוב אלגנטי ושפע של מקום אחסון במגירות לכל חפציך.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 26180,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Uso chest of drawers": {
    "image_url": "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/1.jpg",
    "product_url": "https://www.laskasas.com/en/chests-of-drawers/uso-chest-of-drawers_p4700.html?id=1395&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/1.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/2.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/3.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/4.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/5.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/6.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/7.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/8.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/9.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/10.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/11.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/12.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/13.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/14.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/15.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/16.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/17.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/18.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/19.jpg",
      "../upload_images/laskasas/Chest of Drawers/Uso chest of drawers/20.jpg"
    ],
    "description": "שידת מגירות \"Uso\" היא פתרון אחסון מודרני ומעוצב לכל חדר בביתכם. היא מתאפיינת בעיצוב מינימליסטי ובשפע של מקום אחסון.",
    "company_name": "Laskasas",
    "original_category": "Chest of Drawers",
    "price": 17358,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Crawford Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Crawford Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/crawford-coffee-table_p84430.html?id=1389&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Crawford Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Crawford Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Crawford Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Crawford Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Crawford Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Crawford Coffee Table/6.jpg"
    ],
    "description": "שולחן הקפה קרופורד, עם משטח זכוכית חלק ושלושה פופים אלגנטיים, מציע פונקציונליות ונוחות. עם שפע של מקום לפריטים דקורטיביים, שולחן הקפה עם הפופים הזה משפר את הנוחות בכל חדר ומשלב בצורה חלקה סגנון ונוחות.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 15953,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Alair Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/alair-coffee-table_p93117.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Alair Coffee Table/12.jpg"
    ],
    "description": "שולחן הקפה אלאיר הוא תוספת אלגנטית ומינימליסטית לכל חלל מגורים עכשווי. עם עיצובו הנקי, שולחן הקפה המרובע הזה מציע גמישות ואלגנטיות מעודנת, המספקים פתרון פרקטי ומסוגנן לצרכים היומיומיים המודרניים.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 15267,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Anthony coffee table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Anthony coffee table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/anthony-coffee-table_p5905.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Anthony coffee table/12.jpg"
    ],
    "description": "בבקשה לשדרג את חלל המגורים שלכם עם האוסף המרהיב שלנו של שולחנות קפה עגולים וסטים של שולחנות קפה עכשווים. שולחן הקפה אנטוני, יצירה מפוארת לאוהבי עיצוב, משלב עץ ומתכת ליצירת חדר מזמין עם נשמה יוקרתית.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 24392,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Williams Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/williams-coffee-table_p84431.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Williams Coffee Table/12.jpg"
    ],
    "description": "ויליאמס הוא שולחן קפה עגול נצחי המשדר אלגנטיות וגמישות. עם שלושת עמודי הבסיס הא-סימטריים שתומכים במשטח שולחן עץ רך, שולחן הקפה הזה יספק בסיס יוקרתי להוספת תחכום וקסם לכל סביבה.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 23703,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Dili Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/dili-coffee-table_p4764.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Dili Coffee Table/12.jpg"
    ],
    "description": "שולחן הקפה דילי הוא תוספת אופנתית לכל חדר מגורים עם משטח השולחן העגול והדק שלו ושלוש הרגליים הדקות.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 23642,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Chios Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/chios-coffee-table_p8082.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Chios Coffee Table/12.jpg"
    ],
    "description": "שולחן הקפה קיוס הוא רהיט עכשווי עם מראה נקי ומודרני שמוסיף סגנון מיידי לסלון שלך. משטח השולחן מאפשר לך להציג את החפצים האהובים עליך בצורה ייחודית, בעוד שרגלי השולחן המותאמות אישית מספקות בסיס יציב.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 16824,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Clea coffee table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Clea coffee table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/clea-coffee-table_p5913.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Clea coffee table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Clea coffee table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Clea coffee table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Clea coffee table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Clea coffee table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Clea coffee table/6.jpg"
    ],
    "description": "שולחן הקפה קליאה הוא מוקד מרשים לכל סלון מודרני. הוא מציע שילוב של גימורים בלתי צפויים עם טכניקות עיצוב מסורתיות בתהליך יצירתי קפדני.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 12864,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "D'Arc Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/darc-coffee-table_p4604.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/D'Arc Coffee Table/12.jpg"
    ],
    "description": "שולחן הקפה ד'ארק מציג שילוב יפהפה של חומרים, היוצר ניגוד מרהיב ותוספת מושלמת לכל מסעדה, ביסטרו, בית קפה, מלון או סלון.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 18020,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Gold coffee table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Gold coffee table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/gold-coffee-table_p5918.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Gold coffee table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Gold coffee table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Gold coffee table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Gold coffee table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Gold coffee table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Gold coffee table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Gold coffee table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Gold coffee table/8.jpg"
    ],
    "description": "שולחנות הקפה המוזהבים כוללים משטח שיש וגוף עץ להוספת סגנון מודרני. השולחן שלנו, המעוצב בעבודת יד מוקפדת, מפיץ אלגנטיות מכל זווית. המשטח החלק והמלוטש מספק את המרכז המושלם לחלל המגורים שלכם, ומהווה פלטפורמה להצגת עיצוב, הגשת כיבוד, או פשוט להירגעות עם ספר טוב.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 29213,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Lyssa coffee table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/lyssa-coffee-table_p5840.html?id=1389&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Lyssa coffee table/12.jpg"
    ],
    "description": "היצירה האלגנטית הזו מחבקת את הקסם הנצחי של שולחנות קפה עגולים תוך הכנסת נגיעה של זוהר. עם משטח השיש המוצק שלה, היצירה יוצאת הדופן הזו מושלמת לאוהבי הטעם המיוחד ביצירות פונקציונליות ומסוגננות.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 17855,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Megan coffee table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Megan coffee table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/megan-coffee-table_p5892.html?id=1389&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/12.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/13.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/14.jpg",
      "../upload_images/laskasas/Coffee Tables/Megan coffee table/15.jpg"
    ],
    "description": "שדרגו את חלל המגורים שלכם עם הקסם הנצחי של שולחן הקפה המודרני מעץ מדגם מייגן שלנו. בעיצוב שמחבר בצורה חלקה בין משטח עץ ומבנה מתכתי עם מדף נמוך לאחסון. עם הקווים הנקיים והעיצוב המינימליסטי שלו, שולחן הקפה מייגן משקף את מהות המודרניות. הגימור העץ החם והעשיר מכניס נגיעה של טבע לתוך הבית ומשלים מגוון רחב של סגנונות עיצוביים.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 25714,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Mercy Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/mercy-coffee-table_p5903.html?id=1389&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/12.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/13.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/14.jpg",
      "../upload_images/laskasas/Coffee Tables/Mercy Coffee Table/15.jpg"
    ],
    "description": "שולחן הקפה מרסי יוצר רושם חזק בכל חדר מגורים עם שילוב החומרים שלו, ויוצר נוכחות מרשימה בזכות המבנה הגאומטרי המדהים שלו.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 14095,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Nilo Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/nilo-coffee-table_p5881.html?id=1389&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/12.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/13.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/14.jpg",
      "../upload_images/laskasas/Coffee Tables/Nilo Coffee Table/15.jpg"
    ],
    "description": "שולחן הקפה נילו הוא תוספת מודרנית לכל חלל, עם משטח שיש טבעי ומסיבי ופנים עשוי עץ או לכה. יש קסם בלתי ניתן להכחשה בשולחנות קפה מלבניים. הקצוות החלקים שלהם מקדמים זרימה קלה באזור המגורים, מה שהופך אותם למתאימים לחללים קטנים יותר.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 27549,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Raw Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/raw-coffee-table_p5917.html?id=1389&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/12.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/13.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/14.jpg",
      "../upload_images/laskasas/Coffee Tables/Raw Coffee Table/15.jpg"
    ],
    "description": "שדרגו את עיצוב הפנים שלכם עם מבחר שולחנות הקפה המדהימים שלנו, שעוצבו בקפדנות כדי ללכוד את מהות החיים המודרניים. מהקסם המרתק של שולחנות קפה עגולים ועד התחכום האלגנטי של שולחנות קפה מלבניים מעץ, אנו מציעים מגוון רחב שיתאים לטעם המוער שלכם.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 26566,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Riga Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/riga-coffee-table_p5924.html?id=1389&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/12.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/13.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/14.jpg",
      "../upload_images/laskasas/Coffee Tables/Riga Coffee Table/15.jpg"
    ],
    "description": "שולחן קפה עגול ריגה הוא תוספת מסוגננת ורב-גונית לכל סלון או חלל אירוח. הצורה העגולה והעיצוב המינימלי שלו הופכים אותו למושלם לחללים קטנים או להשלמת רהיטים גדולים יותר.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 27496,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Sila Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/sila-coffee-table_p5895.html?id=1389&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/12.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/13.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/14.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/15.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/16.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/17.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/18.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/19.jpg",
      "../upload_images/laskasas/Coffee Tables/Sila Coffee Table/20.jpg"
    ],
    "description": "שולחן הקפה סילה הוא התוספת המושלמת לסלון בהשראת עיצוב איטלקי, עם ארבעה מקומות אחסון בפתיחתו המחולקת.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 29118,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Still coffee table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Still coffee table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/still-coffee-table_p5908.html?id=1389&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Still coffee table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Still coffee table/10.jpg"
    ],
    "description": "שולחן הקפה \"The Still\" הוא תוספת יוקרתית ומעודנת לכל סלון נועז או פינת מושב במסעדה מתוחכמת. העיצוב העגול והאלגנטי שלו והבסיס מנירוסטה מוסיפים נופך של זוהר לכל פנים.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 25847,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "S. Paulo Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/s.-paulo-coffee-table_p4610.html?id=1389&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/12.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/13.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/14.jpg",
      "../upload_images/laskasas/Coffee Tables/S. Paulo Coffee Table/15.jpg"
    ],
    "description": "יצירת מופת זו משלבת בקלות עיצוב על-זמני עם טוויסט עכשווי, מה שהופך אותה לתוספת מושלמת לכל עיצוב פנים. העיצוב המלוטש והמינימליסטי שלה מציג את היופי של עץ טבעי, ומלכד את מהות התחכום. השימוש בחומרים מובחרים מבטיח לא רק את האטרקטיביות הוויזואלית שלה אלא גם את עמידותה לאורך זמן.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 18537,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Tasos Coffee Table": {
    "image_url": "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/coffee-tables/tasos-coffee-table_p8078.html?id=1389&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/1.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/2.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/3.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/4.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/5.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/6.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/7.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/8.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/9.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/10.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/11.jpg",
      "../upload_images/laskasas/Coffee Tables/Tasos Coffee Table/12.jpg"
    ],
    "description": "כאשר מדובר בעיצוב, שולחן הקפה של טאסוס הוא משהו מיוחד. צורתו המודרנית והמינימליסטית הופכת אותו לפריט רב תכליתי שניתן להשתמש בו בדרכים שונות ומגוונות.",
    "company_name": "Laskasas",
    "original_category": "Coffee Tables",
    "price": 24637,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Kahlo Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Kahlo Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/kahlo-console-table_p84422.html?id=1391&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Kahlo Console Table/15.jpg"
    ],
    "description": "שולחן הקונסולה מקלהו משיש הוא שילוב מהמם של יופי טבעי ועיצוב עכשווי. עם שילוב מושלם של שיש ועץ, פריט הצהרה זה יוסיף אלגנטיות ומתוחכמות לכל אולם כניסה.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 23351,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Agot Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Agot Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/agot-console-table_p9730.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Agot Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Agot Console Table/15.jpg"
    ],
    "description": "מציגים את הקונסולה אגוט: שולחן קונסולה דק עם משטח עץ ומבנה מתכתי שמשדר עיצוב מעודן. מושלם לשיפור אזור הכניסה, משטח העץ מחפה רק חלק מרוחב השולחן, ומדגיש את המבנה המתכתי המרהיב. מודרני ומתוחכם, הפריט הזה ישאיר רושם מתמשך על האורחים, מה שהופך אותו לתוספת אידיאלית לכל חלל פנים מסוגנן.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 23121,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Anthony Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Anthony Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/anthony-console-table_p5790.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Anthony Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Anthony Console Table/12.jpg"
    ],
    "description": "אנתוני מציג שולחן קונסולה עם חלק עליון עשוי שיש מרהיב, מה שהופך אותו לרהיט מרשים עבור כל סלון או מסדרון כניסה. הניגוד הנועז בין החלק העליון של השיש לבסיס המלבני והעדין יוצר הצהרה ייחודית. למעצבי פנים המחפשים להוסיף נופך של אלגנטיות ומתוחכמות לפרויקטים שלהם, שולחן הקונסולה אנתוני זמין גם עם אפשרויות חלק עליון נוספות, כגון לַכָּה או פורניר עץ, מציע התאמה אישית מגוונת.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 22134,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Ceuta Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Ceuta Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/ceuta-console-table_p5784.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/15.jpg",
      "../upload_images/laskasas/Console Tables/Ceuta Console Table/16.jpg"
    ],
    "description": "קונסולת סאוטה היא שולחן קונסולה מינימליסטי עם מגירה אחת, הכולל רגליים מלבניות חזקות המיושרות באופן מדויק עם החלק העליון. עיצוב זה מעניק תחושת עניין אדריכלי ובאותו זמן מאפשר לציפוי העץ היפה להיות במרכז הבמה, מה שהופך אותו לתוספת אלגנטית לכל פנים מעודן.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 20655,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Avignon Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Avignon Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/avignon-console-table_p5765.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Avignon Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Avignon Console Table/12.jpg"
    ],
    "description": "קונסולת אביניון היא שולחן קונסולה מעץ שמבטא עיצוב מינימליסטי עם קווים אלגנטיים. רהיט זה מתוכנן להיות מושך עין בכל חדר או פרויקט עיצוב פנים, עם מגוון צבעים, מרקמים, גדלים וגימורים כדי להתאים להעדפות אסתטיות שונות.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 17568,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Samos Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Samos Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/samos-console-table_p8036.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Samos Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/15.jpg",
      "../upload_images/laskasas/Console Tables/Samos Console Table/16.jpg"
    ],
    "description": "בחירה מפתה לעיצובים עכשוויים, שולחן הקפה סאמוס מתאפיין במסגרת אלגנטית. הוא מוסיף נגיעה של קלילות לחלל שלכם.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 13986,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Chios Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Chios Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/chios-console-table_p8039.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Chios Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Chios Console Table/12.jpg"
    ],
    "description": "קונסולת כיוס היא פריט עכשווי שמתאים לעיצוב אולם כניסה. העיצוב המלוטש והמינימליסטי שלה והגימור החלק הופכים אותו לתוספת המושלמת לכל בית מודרני.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 12440,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Evelyn Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Evelyn Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/evelyn-console-table_p4576.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/15.jpg",
      "../upload_images/laskasas/Console Tables/Evelyn Console Table/16.jpg"
    ],
    "description": "קונסולת אוולין, שולחן קונסולה מדהים עם מגירות, מגדיר מחדש את האלגנטיות המודרנית בעזרת עיצובו החדשני. החלק העליון שלו כולל שתי מגירות, שמשתלבות בצורה מושלמת עם מסגרת מתכתית המוסיפה נגיעה של תחכום עכשווי לכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 27260,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Ives Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Ives Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/ives-console-table_p93141.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Ives Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Ives Console Table/12.jpg"
    ],
    "description": "בתרגום חופשי לעברית: עם פרטים מרשימים במתכת שחורה ונירוסטה, שולחן הקונסולות Ives הוא ארוך וצר, מה שמקנה תחושת אלגנטיות מעודנת, והופך אותו לתוספת המושלמת לאולמות כניסה. העיצוב האלגנטי והחומרים העמידים לאורך זמן מעניקים סגנון, בעוד הפונקציונליות הרב-תכליתית שלו מציעה מקום רב לאחסון ולהצגה.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 29735,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Jill Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Jill Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/jill-console-table_p5762.html?id=1391&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Jill Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Jill Console Table/12.jpg"
    ],
    "description": "הכירו את שולחן הקונסולה ג'יל, שולחן קונסולה שיש מרהיב שתוכנן במיוחד עבור אולמות כניסה מרשימים. מבנה שיש של יחידה אחת זו משדר תחכום עכשווי ומציע אפשרויות התאמה אישית מגוונות, המשלבות אלמנטים של שיש ומתכת כדי להעצים את האלגנטיות של כל פנים יוקרתי.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 21493,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Lyssa Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Lyssa Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/lyssa-console-table_p5780.html?id=1391&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Lyssa Console Table/15.jpg"
    ],
    "description": "ליסה היא שולחן קונסולה מברזל המשלב את האלגנטיות של חומרים מעודנים בטוויסט עכשווי. המבנה הברזל שלה משתלב בצורה יפה עם משטח עץ או שיש, ויוצר מראה מתוחכם ללא מאמץ. מושלם לאולמות כניסה מלאי קסם, שולחן הקונסולה ליסה מוסיף אלגנטיות ומודרניות לכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 12151,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Niels Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Niels Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/niels-console-table_p4579.html?id=1391&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Niels Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/15.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/16.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/17.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/18.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/19.jpg",
      "../upload_images/laskasas/Console Tables/Niels Console Table/20.jpg"
    ],
    "description": "נילס היא קונסולה מודרנית שעשויה פורניר עץ עם פרטי נירוסטה מרשימים. היא מושלמת לקישוט חללים פתוחים, עם רגליים זוויתיות היוצרות אסתטיקה וינטג' ייחודית ושני מגירות המספקות שטח אחסון נרחב.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 14437,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Pearl Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Pearl Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/pearl-console-table_p4775.html?id=1391&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Pearl Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Pearl Console Table/15.jpg"
    ],
    "description": "קונסולת הפנינה היא שולחן קונסולה קלאסי המושלם לחובב העיצוב. עם הפרטים המבניים המעודנים והחומרים והגימורים האלגנטיים שלה, היא הצהרה של אלגנטיות ויופי, מושלמת לשדרוג כל חלל פנים מתוחכם.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 10131,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Rory Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Rory Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/rory-console-table_p5767.html?id=1391&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Rory Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Rory Console Table/15.jpg"
    ],
    "description": "רורי הוא שולחן קונסולה מינימליסטי, אופנתי ופונקציונלי, מושלם לכל מבואת כניסה. הוא בנוי משילוב של חומרים חזקים ומציג עיצוב גיאומטרי ייחודי שמוסיף נגיעה של אלגנטיות מודרנית לכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 19753,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Dallas Console Table": {
    "image_url": "../upload_images/laskasas/Console Tables/Dallas Console Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/consoles/dallas-console-table_p4756.html?id=1391&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Console Tables/Dallas Console Table/1.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/2.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/3.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/4.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/5.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/6.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/7.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/8.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/9.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/10.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/11.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/12.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/13.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/14.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/15.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/16.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/17.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/18.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/19.jpg",
      "../upload_images/laskasas/Console Tables/Dallas Console Table/20.jpg"
    ],
    "description": "שולחן הקונסולה דאלאס למעברים צרים משלב בין מראה מוכר לסילואט רענן ומינימליסטי, מה שהופך אותו לבחירה מצוינת עבור מעצבי פנים. עיצובו הרב-תכליתי פונה הן למסורתיים והן למודרניים, ומספק פתרון מסוגנן למיטוב החלל בכניסות צרות.",
    "company_name": "Laskasas",
    "original_category": "Console Tables",
    "price": 10438,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Gatsby Desk": {
    "image_url": "../upload_images/laskasas/Desks/Gatsby Desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/gatsby-desk_p84498.html?id=1398&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Desks/Gatsby Desk/1.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/2.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/3.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/4.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/5.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/6.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/7.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/8.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/9.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/10.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/11.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/12.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/13.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/14.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/15.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/16.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/17.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/18.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/19.jpg",
      "../upload_images/laskasas/Desks/Gatsby Desk/20.jpg"
    ],
    "description": "מִשְׁרוֹן גטסבי מציג תחושת אלגנטיות ותכלית למרחב העבודה. המשׁרון מעוצב בקווים נקיים ופשוטים והמשטח העליון מתאפיין במכסה מתרומם המכוסה בעור סיאול או סאדל, המוסיף מרקם ומשיכה לסביבת העבודה. המסגרת והרגליים זמינות בכל סוגי העץ והגימורים מהאוסף, כמו גם המדפים הפנימיים. רק המדרך זמין בברזל שחור בעל מרקם.\n\nבכל הנוגע להתאמה אישית, כל הגוף דורש גימור אחיד, אם כי ניתן לבחור צבע שונה למגשים הפנימיים. המשׁרון מציע גם שלוש אפשרויות לשקע: ללא שקע, עם שקע בצד ימין או עם שקע בצד שמאל.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 29354,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Dara desk": {
    "image_url": "../upload_images/laskasas/Desks/Dara desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/dara-desk_p4692.html?id=1398&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Desks/Dara desk/1.jpg",
      "../upload_images/laskasas/Desks/Dara desk/2.jpg",
      "../upload_images/laskasas/Desks/Dara desk/3.jpg",
      "../upload_images/laskasas/Desks/Dara desk/4.jpg",
      "../upload_images/laskasas/Desks/Dara desk/5.jpg",
      "../upload_images/laskasas/Desks/Dara desk/6.jpg",
      "../upload_images/laskasas/Desks/Dara desk/7.jpg",
      "../upload_images/laskasas/Desks/Dara desk/8.jpg",
      "../upload_images/laskasas/Desks/Dara desk/9.jpg",
      "../upload_images/laskasas/Desks/Dara desk/10.jpg",
      "../upload_images/laskasas/Desks/Dara desk/11.jpg",
      "../upload_images/laskasas/Desks/Dara desk/12.jpg",
      "../upload_images/laskasas/Desks/Dara desk/13.jpg",
      "../upload_images/laskasas/Desks/Dara desk/14.jpg",
      "../upload_images/laskasas/Desks/Dara desk/15.jpg",
      "../upload_images/laskasas/Desks/Dara desk/16.jpg"
    ],
    "description": "דארה היא שולחן עבודה מינימליסטי מלוטש ומתפקד, שמתאים באופן מושלם לכל משרד ביתי. עם קווים נקיים ונגיעת יוקרה של חומרים משובחים, פריט זה יעניק לכל חדר תחושה מודרנית, ויצור הצהרה של סגנון ופרקטיות גם יחד.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 14670,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Rosie Desk": {
    "image_url": "../upload_images/laskasas/Desks/Rosie Desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/rosie-desk_p4644.html?id=1398&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Desks/Rosie Desk/1.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/2.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/3.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/4.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/5.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/6.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/7.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/8.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/9.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/10.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/11.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/12.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/13.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/14.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/15.jpg",
      "../upload_images/laskasas/Desks/Rosie Desk/16.jpg"
    ],
    "description": "בעיצובו העכשווי ובמבנה המתכתי שלו, שולחן העבודה \"רוזי\" הוא בחירה מעוצבת ופונקציונלית לכל משרד ביתי. זמין עם משטח שיש או עץ, שולחן עכשווי זה מושלם לכל סביבת עבודה ומשלב פונקציה עם אסתטיקה שיקית.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 12948,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Cape Desk": {
    "image_url": "../upload_images/laskasas/Desks/Cape Desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/cape-desk_p8139.html?id=1398&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Desks/Cape Desk/1.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/2.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/3.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/4.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/5.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/6.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/7.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/8.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/9.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/10.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/11.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/12.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/13.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/14.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/15.jpg",
      "../upload_images/laskasas/Desks/Cape Desk/16.jpg"
    ],
    "description": "שולחן קייפ הוא עיצוב מינימליסטי שיוצר אמירה נועזת. עם המראה הקר והעכשווי שלו, ניתן להתאים את השולחן הזה לצרכים שלך.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 25913,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Belgrado Desk": {
    "image_url": "../upload_images/laskasas/Desks/Belgrado Desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/belgrado-desk_p6094.html?id=1398&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Desks/Belgrado Desk/1.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/2.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/3.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/4.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/5.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/6.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/7.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/8.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/9.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/10.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/11.jpg",
      "../upload_images/laskasas/Desks/Belgrado Desk/12.jpg"
    ],
    "description": "בלגרדו הוא שולחן עבודה דק עם תשומת לב שווה לצורה ולפונקציה, מושלם למקסום המרחב תוך שמירה על מראה מלוטש. הוא משלב עיצוב פרקטי עם משיכה אסתטית לשיפור חוויית העבודה היומיומית.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 18536,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Bonham desk": {
    "image_url": "../upload_images/laskasas/Desks/Bonham desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/bonham-desk_p6109.html?id=1398&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Desks/Bonham desk/1.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/2.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/3.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/4.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/5.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/6.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/7.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/8.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/9.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/10.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/11.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/12.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/13.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/14.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/15.jpg",
      "../upload_images/laskasas/Desks/Bonham desk/16.jpg"
    ],
    "description": "שולחן בונהאם, עם המגירה שמתחת לשולחן, הוא בחירה בולטת לכל משרד ביתי. עם חומרים עמידים וניתנים להתאמה, הוא משלב קסם כפרי עם נגיעות מתכת ליצירת סגנון עכשווי ומינימליסטי.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 12292,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Allie Desk": {
    "image_url": "../upload_images/laskasas/Desks/Allie Desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/allie-desk_p4779.html?id=1398&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Desks/Allie Desk/1.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/2.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/3.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/4.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/5.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/6.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/7.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/8.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/9.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/10.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/11.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/12.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/13.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/14.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/15.jpg",
      "../upload_images/laskasas/Desks/Allie Desk/16.jpg"
    ],
    "description": "שולחן הכתיבה Allie, שולחן אמיתי מהמאה האמצעית, משלב קסם קלאסי עם טוויסט מודרני, ומציע פתרון מסוגנן ומעשי לשיפור מרחבי העבודה. עם אפשרויות האחסון החכמות שלו והעיצוב המתוחכם, שולחן ה-Allie ישפר את הסביבה הכוללת תוך הוספת נגיעה של זוהר לחלל.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 19179,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Larson desk": {
    "image_url": "../upload_images/laskasas/Desks/Larson desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/larson-desk_p6100.html?id=1398&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Desks/Larson desk/1.jpg",
      "../upload_images/laskasas/Desks/Larson desk/2.jpg",
      "../upload_images/laskasas/Desks/Larson desk/3.jpg",
      "../upload_images/laskasas/Desks/Larson desk/4.jpg",
      "../upload_images/laskasas/Desks/Larson desk/5.jpg",
      "../upload_images/laskasas/Desks/Larson desk/6.jpg",
      "../upload_images/laskasas/Desks/Larson desk/7.jpg",
      "../upload_images/laskasas/Desks/Larson desk/8.jpg",
      "../upload_images/laskasas/Desks/Larson desk/9.jpg",
      "../upload_images/laskasas/Desks/Larson desk/10.jpg",
      "../upload_images/laskasas/Desks/Larson desk/11.jpg",
      "../upload_images/laskasas/Desks/Larson desk/12.jpg",
      "../upload_images/laskasas/Desks/Larson desk/13.jpg",
      "../upload_images/laskasas/Desks/Larson desk/14.jpg",
      "../upload_images/laskasas/Desks/Larson desk/15.jpg",
      "../upload_images/laskasas/Desks/Larson desk/16.jpg",
      "../upload_images/laskasas/Desks/Larson desk/17.jpg",
      "../upload_images/laskasas/Desks/Larson desk/18.jpg",
      "../upload_images/laskasas/Desks/Larson desk/19.jpg",
      "../upload_images/laskasas/Desks/Larson desk/20.jpg"
    ],
    "description": "",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 14395,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Miami desk": {
    "image_url": "../upload_images/laskasas/Desks/Miami desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/miami-desk_p4693.html?id=1398&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Desks/Miami desk/1.jpg",
      "../upload_images/laskasas/Desks/Miami desk/2.jpg",
      "../upload_images/laskasas/Desks/Miami desk/3.jpg",
      "../upload_images/laskasas/Desks/Miami desk/4.jpg",
      "../upload_images/laskasas/Desks/Miami desk/5.jpg",
      "../upload_images/laskasas/Desks/Miami desk/6.jpg",
      "../upload_images/laskasas/Desks/Miami desk/7.jpg",
      "../upload_images/laskasas/Desks/Miami desk/8.jpg",
      "../upload_images/laskasas/Desks/Miami desk/9.jpg",
      "../upload_images/laskasas/Desks/Miami desk/10.jpg",
      "../upload_images/laskasas/Desks/Miami desk/11.jpg",
      "../upload_images/laskasas/Desks/Miami desk/12.jpg",
      "../upload_images/laskasas/Desks/Miami desk/13.jpg",
      "../upload_images/laskasas/Desks/Miami desk/14.jpg",
      "../upload_images/laskasas/Desks/Miami desk/15.jpg",
      "../upload_images/laskasas/Desks/Miami desk/16.jpg"
    ],
    "description": "מיאמי היא שולחן עבודה מודרני המתאים לכל חלל עבודה מרשים. עם עיצוב נקי ופתרונות אחסון חכמים, היא תוספת מצוינת לכל משרד ביתי עכשווי, גדול או קטן, ומספקת שטח עבודה מרווח ומשתלבת עם סגנונות עיצוב פנים רבים.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 22908,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Kampala Desk": {
    "image_url": "../upload_images/laskasas/Desks/Kampala Desk/1.jpg",
    "product_url": "https://www.laskasas.com/en/desks/kampala-desk_p6097.html?id=1398&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Desks/Kampala Desk/1.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/2.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/3.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/4.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/5.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/6.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/7.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/8.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/9.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/10.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/11.jpg",
      "../upload_images/laskasas/Desks/Kampala Desk/12.jpg"
    ],
    "description": "קמפאלה הוא שולחן עם רגליים מתכתיות שעיצובו המינימליסטי מציע נגיעה מודרנית מבלי להתפשר על פרקטיות. רגלי המתכת שלו מספקות תמיכה יציבה תוך שהן מנוגדות בצורה אלגנטית למשטח העליון, ובכך יוצרות בחירה אופנתית ובלתי מחייבת לסביבות משרדיות.",
    "company_name": "Laskasas",
    "original_category": "Desks",
    "price": 10516,
    "filter_category": "שולחנות משרד",
    "placement": "Indoor"
  },
  "Marilyn dining table": {
    "image_url": "../upload_images/laskasas/Dining tables/Marilyn dining table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/marilyn-dining-table_p6023.html?id=1387&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Marilyn dining table/1.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/2.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/3.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/4.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/5.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/6.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/7.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/8.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/9.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/10.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/11.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/12.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/13.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/14.jpg",
      "../upload_images/laskasas/Dining tables/Marilyn dining table/15.jpg"
    ],
    "description": "מרילין היא שולחן אוכל עגול מרהיב עם בוצ'ר מסתובב, שתוכנן להיות מרכז העיצוב של כל חדר אוכל יוקרתי. עם רגל מרכזית ייחודית, החלק העליון שלו זמין בחומרים שונים, כגון שיש או עץ, ומציע שפע של אפשרויות התאמה אישית. פריט רב-תכליתי זה מספק למעצבי פנים שילוב מושלם של אלגנטיות ופונקציונליות לפרויקטים שלהם.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 11658,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Kelly Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Kelly Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/kelly-dining-table_p5980.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Kelly Dining Table/12.jpg"
    ],
    "description": "שולחן האוכל קלי הוא יצירה מרשימה ובולטת, מושלם לאזורי אוכל ייחודיים. עם פלטה אובלית ייחודית המונחת על עמוד מוצק, השולחן הזה משלב באופן מושלם תפקוד ועיצוב ליצירת אלמנט ייחודי בחדרי אוכל מתוחכמים.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 10848,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Jeane dining table": {
    "image_url": "../upload_images/laskasas/Dining tables/Jeane dining table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/jeane-dining-table_p5989.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Jeane dining table/1.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/2.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/3.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/4.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/5.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/6.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/7.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/8.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/9.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/10.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/11.jpg",
      "../upload_images/laskasas/Dining tables/Jeane dining table/12.jpg"
    ],
    "description": "ז'אן מתהדר בעיצוב שולחן אוכל מודרני שמשדר סגנון ואלגנטיות נצחית. עשוי מחומרים איכותיים, הוא כולל אלמנטים מתכתיים חלקים, מה שהופך אותו לתוספת אידיאלית לחדרי אוכל מתוחכמים. מושלם עבור מעצבי פנים המחפשים לשדרג את האווירה בנגיעת תחכום עכשווית.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 14512,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Ponza Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Ponza Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/ponza-dining-table_p8063.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Ponza Dining Table/12.jpg"
    ],
    "description": "שולחן האוכל פונזה הוא תוספת מודרנית מושלמת לסלון שלך, כיוון שהוא מוסיף נופך של סגנון ואלגנטיות לכל חלל.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 15809,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Alison Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Alison Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/alison-dining-table_p4613.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Alison Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Alison Dining Table/12.jpg"
    ],
    "description": "אליסון הוא שולחן אוכל גדול ומזוהה, מושלם לחדרי אוכל מלאי זוהר נצחי. עם משטח עליון עשוי מעץ טבעי ופרטים מתכתיים, שולחן זה הוא תוספת מרשימה לכל עיצוב פנים. הגודל המרשים והעיצוב האלגנטי שלו הופכים אותו למוקד אידיאלי עבור חדרי אוכל מתוחכמים.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 15082,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Ann Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Ann Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/ann-dining-table_p6388.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Ann Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Ann Dining Table/12.jpg"
    ],
    "description": "לאלו המחפשים שולחן אוכל אובלי, אן מציעה אפשרות לא שגרתית לרענון פרויקטים של חדרי אוכל. הפריט המרשים הזה כולל בסיס גלילי ומשטח עץ או קרמיקה אובלי כדי ליצור תחושת נצחיות בכל חלל עכשווי.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 28062,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Baiona Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Baiona Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/baiona-dining-table_p4761.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Baiona Dining Table/12.jpg"
    ],
    "description": "בהעונה הוא שולחן אוכל נפתח שמשלב עמידות ויופי. שולחן זה מתוכנן לתחזוקה קלה ומציג מבנה מודרני הניתן להתאמה אישית, המגלם אומנות, מה שעושה אותו לתוספת מעשית ואלגנטית לכל חדר אוכל.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 12896,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Brenda Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Brenda Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/brenda-dining-table_p4615.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Brenda Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Brenda Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Brenda Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Brenda Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Brenda Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Brenda Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Brenda Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Brenda Dining Table/8.jpg"
    ],
    "description": "הכירו את ברנדה: שולחן אוכל עגול לארבעה אנשים עם משטח מדהים מזכוכית, שיש או עץ ומבנה גלילי מרשים. עשוי בעבודת יד מהחומרים האיכותיים ביותר, הוא לוכד את תמצית היופי הטבעי תוך שהוא מאמץ עיצוב מלוטש ומודרני. למרות שהשולחן הזה מושלם למפגשים אינטימיים של ארבעה אנשים, ניתן גם לבצע התאמות אישיות נוספות שיתאימו לכל חלל אוכל.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 27806,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Buda Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Buda Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/buda-dining-table_p4765.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Buda Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Buda Dining Table/12.jpg"
    ],
    "description": "בודה הוא שולחן אוכל מינימליסטי שמעוצב עבור אלה שמעריכים אלגנטיות מעודנת. הקווים הנקיים והפרטים המעודנים שלו הופכים אותו לבחירה מושלמת ליצירת חלל אוכל מתוחכם ומסודר.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 18423,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Cheryl Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Cheryl Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/cheryl-dining-table_p4616.html?id=1387&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl Dining Table/9.jpg"
    ],
    "description": "שריל היא שולחן אוכל עגול ומודרני מרהיב, בהשראת עיצוב עכשווי. עם בסיס בסגנון כלוב ציפורים, השולחן הייחודי והאלגנטי הזה מוסיף נגיעה אלגנטית לכל בית. המבנה המתוחכם שלו הופך אותו ליצירה המרכזית המושלמת עבור חללי אוכל שמחבקים את היצירתיות והמודרניות.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 17069,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Cheryl dining table": {
    "image_url": "../upload_images/laskasas/Dining tables/Cheryl dining table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/cheryl-dining-table_p6437.html?id=1387&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Cheryl dining table/1.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/2.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/3.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/4.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/5.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/6.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/7.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/8.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/9.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/10.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/11.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/12.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/13.jpg",
      "../upload_images/laskasas/Dining tables/Cheryl dining table/14.jpg"
    ],
    "description": "שולחן האוכל שריל הוא פריט מרשים, בהשראת סגנון מודרני. הבסיס בסגנון כלוב הציפורים הופך את השולחן הזה לתוספת ייחודית ושיקית לכל בית מודרני.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 27228,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Cres Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Cres Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/cres-dining-table_p8068.html?id=1387&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Cres Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/12.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/13.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/14.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/15.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/16.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/17.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/18.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/19.jpg",
      "../upload_images/laskasas/Dining tables/Cres Dining Table/20.jpg"
    ],
    "description": "שולחן האוכל קרס בעל הצורה המינימליסטית יתאים באופן מושלם לסביבות אסתטיות רבות ויוסיף נופך אלגנטי לעיצוב שלך.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 28529,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "D'Arc Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/D'Arc Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/darc-dining-table_p5994.html?id=1387&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/12.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/13.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/14.jpg",
      "../upload_images/laskasas/Dining tables/D'Arc Dining Table/15.jpg"
    ],
    "description": "שולחן האוכל דארק הוא שולחן אוכל מלבני ואלגנטי שמשדרג כל חדר אוכל. השולחן כולל משטח עץ עכשווי ומבנה מתכתי ייחודי, ומשלב בין פונקציונליות לעיצוב מודרני. זהו בחירה אידיאלית לחללי אוכל אופנתיים ופונקציונליים.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 18165,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Isis Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Isis Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/isis-dining-table_p5985.html?id=1387&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Isis Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/12.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/13.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/14.jpg",
      "../upload_images/laskasas/Dining tables/Isis Dining Table/15.jpg"
    ],
    "description": "איסיס הוא שולחן אוכל מחוספס המשלב עמידות עם פונקציונליות. עיצובו הניתן להרחבה והחומרים האיכותיים מהם הוא עשוי מבטיחים כי יוכל לעמוד בשימוש היומיומי תוך הוספת תחושת קסם לכל חדר אוכל.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 21707,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Egg Oval Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/egg-oval-dining-table_p11494.html?id=1387&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/12.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/13.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/14.jpg",
      "../upload_images/laskasas/Dining tables/Egg Oval Dining Table/15.jpg"
    ],
    "description": "שולחן האוכל הסגלגל \"הביצה\" הוא באמת יצירת עיצוב. עם החלק העליון הסגלגל והבסיס המחוברים על ידי קטע זורם, שולחן זה יוצר אפקט עיצוב אלגנטי וייחודי שמבטיח להרשים.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 24502,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Prestige Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Prestige Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/prestige-dining-table_p4624.html?id=1387&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/12.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/13.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/14.jpg",
      "../upload_images/laskasas/Dining tables/Prestige Dining Table/15.jpg"
    ],
    "description": "שולחן האוכל פרסטיז' הוא רהיט מודרני עם קיבולת לשישה אנשים. עם יכולת בעלת עוצמה, שולחן נפתח זה הוא ההרמוניה המושלמת בין חומרים שונים, גימורים וצורות. הוסף נופך מעודן עוד יותר לחדר האוכל שלך עם שולחן האוכל פרסטיז'.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 25440,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Susan Dining Table": {
    "image_url": "../upload_images/laskasas/Dining tables/Susan Dining Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dining-tables/susan-dining-table_p5991.html?id=1387&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Dining tables/Susan Dining Table/1.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/2.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/3.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/4.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/5.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/6.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/7.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/8.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/9.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/10.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/11.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/12.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/13.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/14.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/15.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/16.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/17.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/18.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/19.jpg",
      "../upload_images/laskasas/Dining tables/Susan Dining Table/20.jpg"
    ],
    "description": "סוזן היא שולחן אוכל מעץ בעיצוב עכשווי שימשוך תשומת לב בכל חדר אוכל. צורתו המלבנית והקווים הנקיים שלו הופכים אותו למאפיין בולט, שבו פשטות פוגשת אלגנטיות מודרנית.",
    "company_name": "Laskasas",
    "original_category": "Dining tables",
    "price": 26794,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Hamlet Dressing Table": {
    "image_url": "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dressing-tables/hamlet-dressing-table_p84479.html?id=1397&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/1.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/2.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/3.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/4.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/5.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/6.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/7.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/8.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/9.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/10.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/11.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/12.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/13.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/14.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/15.jpg",
      "../upload_images/laskasas/Dressing Tables/Hamlet Dressing Table/16.jpg"
    ],
    "description": "המלט הוא שולחן איפור שיקי עם מראה, שתוכנן בקפידה לשלב יופי ופונקציונליות. עם מגירות אחסון מרווחות ומראה עגולה, המלט מספק סדר למוצרי יופי, אביזרי שיער ותכשיטים, מה שהופך אותו לתוספת חיונית לכל ארון או חדר שינה.",
    "company_name": "Laskasas",
    "original_category": "Dressing Tables",
    "price": 27196,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Amy Dressing Table": {
    "image_url": "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dressing-tables/amy-dressing-table_p4657.html?id=1397&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/1.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/2.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/3.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/4.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/5.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/6.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/7.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/8.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/9.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/10.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/11.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/12.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/13.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/14.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/15.jpg",
      "../upload_images/laskasas/Dressing Tables/Amy Dressing Table/16.jpg"
    ],
    "description": "אמילי היא שידת איפור פונקציונלית ואלגנטית עם מראה מתקפלת ומגירות. הגימור העץ החלק והשטח המרווח שלה משלבים בין סגנון ושימושיות, מה שהופך אותה לתוספת אידיאלית לכל פנים מודרני או קלאסי.",
    "company_name": "Laskasas",
    "original_category": "Dressing Tables",
    "price": 22890,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Moreton Dressing Table": {
    "image_url": "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dressing-tables/moreton-dressing-table_p8128.html?id=1397&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/1.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/2.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/3.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/4.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/5.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/6.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/7.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/8.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/9.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/10.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/11.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/12.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/13.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/14.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/15.jpg",
      "../upload_images/laskasas/Dressing Tables/Moreton Dressing Table/16.jpg"
    ],
    "description": "שולחן האיפור מורטון שלנו הוא רהיט מודרני בעל עיצוב מינימליסטי וניתן להתאמה אישית ברמה גבוהה.",
    "company_name": "Laskasas",
    "original_category": "Dressing Tables",
    "price": 29218,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Ester dressing table": {
    "image_url": "../upload_images/laskasas/Dressing Tables/Ester dressing table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dressing-tables/ester-dressing-table_p6123.html?id=1397&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/1.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/2.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/3.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/4.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/5.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/6.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/7.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/8.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/9.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/10.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/11.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/12.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/13.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/14.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/15.jpg",
      "../upload_images/laskasas/Dressing Tables/Ester dressing table/16.jpg"
    ],
    "description": "שידת האיפור אסתר היא פריט אופנתי וקלאסי עבור מעצבי פנים המחפשים גמישות בפרויקטים שלהם. שידת האיפור ללא מראה מציעה אפשרויות רבות לציפוי עץ, שני מגירות, ומשטח רחב, המספק מספיק מקום לכל מוצרי היופי תוך השתלבות חלקה בעיצוב כל חדר שינה.",
    "company_name": "Laskasas",
    "original_category": "Dressing Tables",
    "price": 24075,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "D'Arc Dressing Table": {
    "image_url": "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dressing-tables/darc-dressing-table_p4658.html?id=1397&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/1.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/2.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/3.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/4.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/5.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/6.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/7.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/8.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/9.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/10.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/11.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/12.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/13.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/14.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/15.jpg",
      "../upload_images/laskasas/Dressing Tables/D'Arc Dressing Table/16.jpg"
    ],
    "description": "מָעֳצָב לְהִישָּׂר הָרְמִיָּה וְהַפָּרְטִקְיוּלוּת, ד'ארק הִיא שֻׁלְחַן אִפּוּר עִם מַרְאָה עֲגֻלָּה, חֲמִשָּׁה מְגֵרוֹת וּשְׁטַח פָּנִים גָּדוֹל. מְיֻצָּר מֵעֵצִים וּמַתָּכוֹת מַרְשִׁימוֹת, הוּא מָשְׁלָם לִיצִירַת אֶסְתֵּטִיקָה מְעֻדֶּנֶת וְנָשִׁית בְּחֶדֶר הַשֵּׁנָה.",
    "company_name": "Laskasas",
    "original_category": "Dressing Tables",
    "price": 13495,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Rosie dressing table": {
    "image_url": "../upload_images/laskasas/Dressing Tables/Rosie dressing table/1.jpg",
    "product_url": "https://www.laskasas.com/en/dressing-tables/rosie-dressing-table_p6112.html?id=1397&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/1.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/2.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/3.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/4.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/5.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/6.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/7.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/8.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/9.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/10.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/11.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/12.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/13.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/14.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/15.jpg",
      "../upload_images/laskasas/Dressing Tables/Rosie dressing table/16.jpg"
    ],
    "description": "רוזי היא שידת איפור אלגנטית שמשלבת סגנון עכשווי עם קווים שובים לב. המבנה הפשוט מברזל תומך בשלוש מגירות, בעוד מראה עם מסגרת מתכת מוסיפה נגיעה של זוהר, מה שהופך אותה לפריט המושלם לסביבה מתוחכמת.",
    "company_name": "Laskasas",
    "original_category": "Dressing Tables",
    "price": 28384,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "LYSSA Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/LYSSA Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/lyssa-side-table_p6426.html?id=1390&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/LYSSA Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/LYSSA Side Table/15.jpg"
    ],
    "description": "כשולחן צד רב-שימושי עם רגלי מתכת, ליסה מציעה אפשרויות כמו שיש מלוטש או גימור אגוז לחלק העליון, דבר שמאפשר לכם להפוך את הפרויקטים שלכם למרחב מסוגנן ומאורגן מאוד.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 25158,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Riga Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Riga Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/riga-side-table_p4754.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Riga Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Riga Side Table/12.jpg"
    ],
    "description": "שולחן הצד ריגה הוא תוספת מסוגננת ופונקציונלית לכל סלון. שולחן הצד העגול הזה מוסיף נופך של אלגנטיות לעיצוב הפנים בזכות העיצוב המלוטש שלו, מה שהופך אותו לבחירה מעשית ואסתטית עבור פנים מודרניים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 19048,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Riley Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Riley Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/riley-side-table_p93145.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Riley Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Riley Side Table/12.jpg"
    ],
    "description": "מעוצב עם תשומת לב לפרטים, ריילי הוא שולחן צד עם גלגלים הכולל עיטורים מתוחכמים מברזל שחור ופלדת אל-חלד. המאפיין הבולט שלו הוא הגלגלים, המאפשרים ניידות קלה ותמיכה רב-תכליתית בכל מקום בו נדרש.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 12200,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Gold side table": {
    "image_url": "../upload_images/laskasas/Side tables/Gold side table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/gold-side-table_p4587.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Gold side table/1.jpg",
      "../upload_images/laskasas/Side tables/Gold side table/2.jpg",
      "../upload_images/laskasas/Side tables/Gold side table/3.jpg",
      "../upload_images/laskasas/Side tables/Gold side table/4.jpg",
      "../upload_images/laskasas/Side tables/Gold side table/5.jpg",
      "../upload_images/laskasas/Side tables/Gold side table/6.jpg",
      "../upload_images/laskasas/Side tables/Gold side table/7.jpg",
      "../upload_images/laskasas/Side tables/Gold side table/8.jpg"
    ],
    "description": "שולחן הצד הזהב הוא פריט על-זמני הכולל עיצוב עגול של שולחן קפה מעץ עם קימורים אלגנטיים וחומרים יוקרתיים. אחת האופציות האייקוניות ביותר עבור שולחן רב-שימושי זה היא האופציה עם משטח שיש, מה שהופך אותו למושלם להוספת נופך של תחכום לסלונים קלאסיים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 24833,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Hidra Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Hidra Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/hidra-side-table_p8076.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Hidra Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Hidra Side Table/12.jpg"
    ],
    "description": "הידרה היא שולחן צד מודרני שיחזק את המשיכה האסתטית של כל חלל מגורים. השולחן מתאפיין בעיצוב עץ עם מגוון גימורים, והחלק הזה, המאופיין באלגנטיות, מספק את האיזון המושלם בין סגנון לפונקציונליות. העיצוב הייחודי שלו עושה אותו לתוספת שמושכת את העין לכל חדר, והוא אידאלי עבור מעצבי פנים המעוניינים לשדרג את הפרויקטים שלהם.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 24971,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Megan side table": {
    "image_url": "../upload_images/laskasas/Side tables/Megan side table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/megan-side-table_p4588.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Megan side table/1.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/2.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/3.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/4.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/5.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/6.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/7.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/8.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/9.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/10.jpg",
      "../upload_images/laskasas/Side tables/Megan side table/11.jpg"
    ],
    "description": "מייגן היא שולחן צד מרובע גדול עם משטח עץ קלאסי ומבנה מתכת. החלק הזה, שהוא על זמני, מוסיף אלגנטיות ותפקוד לכל חלל מגורים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 18289,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Mercy side table": {
    "image_url": "../upload_images/laskasas/Side tables/Mercy side table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/mercy-side-table_p5827.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Mercy side table/1.jpg",
      "../upload_images/laskasas/Side tables/Mercy side table/2.jpg",
      "../upload_images/laskasas/Side tables/Mercy side table/3.jpg",
      "../upload_images/laskasas/Side tables/Mercy side table/4.jpg",
      "../upload_images/laskasas/Side tables/Mercy side table/5.jpg",
      "../upload_images/laskasas/Side tables/Mercy side table/6.jpg",
      "../upload_images/laskasas/Side tables/Mercy side table/7.jpg",
      "../upload_images/laskasas/Side tables/Mercy side table/8.jpg"
    ],
    "description": "מרסי היא שולחן צד גאומטרי עם משטח עגול ומבנה מתכתי אסימטרי. העיצוב הנועז והצורה המרשימה שלו הופכים אותו לפריט בולט בכל חלל מגורים עכשווי.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 18362,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Lee Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Lee Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/lee-side-table_p84451.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Lee Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Lee Side Table/12.jpg"
    ],
    "description": "שולחן צד לי מתהדר בעיצוב עכשווי בקווים ישרים, המשדרג כל פנים עם נגיעה אלגנטית. העיצוב המינימליסטי שלו משפר את הפן האסתטי של אזורי המגורים ומשמש כמקום מושלם להצגת פריטים דקורטיביים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 29253,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Ary Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Ary Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/ary-side-table_p93149.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Ary Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Ary Side Table/12.jpg"
    ],
    "description": "שולחן הצד Ary הוא חידוש לעומת העיצוב המסורתי עם קווים ישרים מרשימים ותכונות ייחודיות. עם ברזל שחור מרקם ואלמנטים מנירוסטה, שולחן הצד הזה עם מתלה למגזינים מוסיף נופך של תחכום מודרני לכל חלל. הוא מתבלט בזכות תמיכת העור הלא מובנית שלו, המציעה פתרון אחסון פונקציונלי למגזינים וספרים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 29123,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Still side table": {
    "image_url": "../upload_images/laskasas/Side tables/Still side table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/still-side-table_p5814.html?id=1390&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Still side table/1.jpg",
      "../upload_images/laskasas/Side tables/Still side table/2.jpg",
      "../upload_images/laskasas/Side tables/Still side table/3.jpg",
      "../upload_images/laskasas/Side tables/Still side table/4.jpg",
      "../upload_images/laskasas/Side tables/Still side table/5.jpg",
      "../upload_images/laskasas/Side tables/Still side table/6.jpg",
      "../upload_images/laskasas/Side tables/Still side table/7.jpg",
      "../upload_images/laskasas/Side tables/Still side table/8.jpg"
    ],
    "description": "שולחן הצד Still הוא שולחן אלגנטי עם מבנה מתכת מעודן וחלק עליון הזמין במגוון חומרים, כולל שיש, זכוכית או פורניר עץ. הניגוד הוויזואלי הבולט שלו הופך אותו לאידיאלי להצבה ליד ספות או כורסאות, ומספק גישה נוחה לפריטים חיוניים תוך שיפור האסתטיקה הכללית של החדר.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 12350,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Tasos Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Tasos Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/tasos-side-table_p8094.html?id=1390&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Tasos Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/Tasos Side Table/15.jpg"
    ],
    "description": "שולחן צד טאסוס הוא מועדף עכשווי. עם עיצוב פשוט, הוא יכול להשתלב בכל סידור ישיבה או לשמש כפריט בפני עצמו בפרויקט הסלון שלך.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 25549,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Sally Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Sally Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/sally-side-table_p5811.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Sally Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/Sally Side Table/15.jpg"
    ],
    "description": "סאלי היא שולחן צד מעץ ומתכת המתאים באופן מושלם לחללים מודרניים או מסורתיים. בעבודת יד על ידי אומנים מיומנים, היצירה הזו משלבת פונקציונליות עם עיצוב על-זמני, ומוסיפה נופך של אלגנטיות לכל פנים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 20094,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Cap side table": {
    "image_url": "../upload_images/laskasas/Side tables/Cap side table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/cap-side-table_p5810.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Cap side table/1.jpg",
      "../upload_images/laskasas/Side tables/Cap side table/2.jpg",
      "../upload_images/laskasas/Side tables/Cap side table/3.jpg",
      "../upload_images/laskasas/Side tables/Cap side table/4.jpg",
      "../upload_images/laskasas/Side tables/Cap side table/5.jpg",
      "../upload_images/laskasas/Side tables/Cap side table/6.jpg",
      "../upload_images/laskasas/Side tables/Cap side table/7.jpg",
      "../upload_images/laskasas/Side tables/Cap side table/8.jpg"
    ],
    "description": "קאפ הוא שולחן צד בסגנון מודרניסטי עם עיצוב בצורת פעמון, שבו הצללית הייחודית מוסיפה נופך ייחודי לכל עיצוב סלון: אקסנט שבאמת מושך את העין.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 12890,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Chios Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Chios Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/chios-side-table_p8086.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Chios Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/Chios Side Table/15.jpg"
    ],
    "description": "עיצוב הריבועי והקווים הנקיים של שולחן הצד צ'יוס מעניקים לו מראה מודרני שמתאים בקלות הן לחדרי מגורים קטנים והן לחללים פתוחים גדולים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 25237,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Cheryl side table": {
    "image_url": "../upload_images/laskasas/Side tables/Cheryl side table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/cheryl-side-table_p5818.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Cheryl side table/1.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/2.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/3.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/4.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/5.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/6.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/7.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/8.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/9.jpg",
      "../upload_images/laskasas/Side tables/Cheryl side table/10.jpg"
    ],
    "description": "צ'ריל, עם העיצוב האלגנטי שלה והחומרים המנוגדים, היא תוספת מסוגננת לכל חלל. שולחן צד זה עם רגלי כרום מוסיף מראה מפואר, ומשלב באופן מושלם פונקציונליות ואלגנטיות.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 12842,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Nottingham Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Nottingham Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/nottingham-side-table_p4590.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Nottingham Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/Nottingham Side Table/15.jpg"
    ],
    "description": "נוטינגהם הוא שולחן צד מודרני עם מבנה מקסים ועיצוב רב תכליתי. הקווים הנקיים והחומרים האיכותיים שלו הופכים אותו לתוספת מושלמת לכל חלל מגורים עכשווי.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 11081,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Nilo Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Nilo Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/nilo-side-table_p5860.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Nilo Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/Nilo Side Table/15.jpg"
    ],
    "description": "נילו הוא שולחן צד מלבני שמתבלט בזכות המשטח העליון שלו, העשוי משיש מוצק או ציפוי עץ, ומשלים אותו פנים עץ. פריט ייחודי ומודרני זה מושלם לחדרי מגורים ושינה, ומציע שילוב של אסתטיקה ופונקציונליות החיוני לכל פרויקט עיצוב פנים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 20174,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Aura side table": {
    "image_url": "../upload_images/laskasas/Side tables/Aura side table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/aura-side-table_p5841.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Aura side table/1.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/2.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/3.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/4.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/5.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/6.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/7.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/8.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/9.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/10.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/11.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/12.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/13.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/14.jpg",
      "../upload_images/laskasas/Side tables/Aura side table/15.jpg"
    ],
    "description": "שולחן צד אורורה הוא אביזר בית אלגנטי בעל צורה מרובעת בולטת וגימור עץ טבעי. שולחן צד מרובע זה מתאים לכל סגנון עיצוב פנים ומוסיף נוחות למרחב המגורים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 15656,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Brenda side table": {
    "image_url": "../upload_images/laskasas/Side tables/Brenda side table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/brenda-side-table_p5825.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Brenda side table/1.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/2.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/3.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/4.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/5.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/6.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/7.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/8.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/9.jpg",
      "../upload_images/laskasas/Side tables/Brenda side table/10.jpg"
    ],
    "description": "ברנדה היא שולחן צד קטן ועגול שמשלב בצורה יפהפייה אלגנטיות ומודרניות. השולחן מיוצר משילוב הרמוני של עץ ומתכת, ומהווה פריט אידיאלי לשיפור האסתטיקה של חללי מגורים. העיצוב המלוטש שלו משתלב בכל פנים, מה שהופך אותו למושלם ליצירת חללים מתוחכמים ואלגנטיים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 24804,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Poppi Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Poppi Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/poppi-side-table_p4755.html?id=1390&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Poppi Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/Poppi Side Table/15.jpg"
    ],
    "description": "פופי היא תוספת ייחודית ומודרנית לכל אזור ישיבה. עם העיצוב המלוטש שלה, שולחן צד מינימליסטי זה משתלב בכל חלל מגורים מודרני, ומציע פונקציונליות וסטייל.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 20246,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Dili Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Dili Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/dili-side-table_p4718.html?id=1390&cat=1382&pc=2&f=2",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Dili Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/Dili Side Table/15.jpg"
    ],
    "description": "דיליי הוא שולחן צד אלגנטי שמשלב עיצוב מודרני עם פונקציונליות. עם רגליים מתכתיות ישרות ובחירה בין פלטת עץ או שיש, פריט רב-תכליתי זה מעלה את המשיכה של כל חדר.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 26204,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Simi Side Table": {
    "image_url": "../upload_images/laskasas/Side tables/Simi Side Table/1.jpg",
    "product_url": "https://www.laskasas.com/en/side-tables/simi-side-table_p8091.html?id=1390&cat=1382&pc=3",
    "image_urls": [
      "../upload_images/laskasas/Side tables/Simi Side Table/1.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/2.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/3.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/4.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/5.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/6.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/7.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/8.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/9.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/10.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/11.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/12.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/13.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/14.jpg",
      "../upload_images/laskasas/Side tables/Simi Side Table/15.jpg"
    ],
    "description": "שדרג את העיצוב שלך עם שולחן הצד סימי, בסגנון עכשווי עם גימור מודרני וגולש. באפשרותך להתאים אותו אישית מתוך מבחר רחב של חומרים וגימורים.",
    "company_name": "Laskasas",
    "original_category": "Side tables",
    "price": 11053,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Austen Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Austen Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/austen-sideboard_p84455.html?id=1388&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Austen Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/16.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/17.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/18.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/19.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/20.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/21.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/22.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/23.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/24.jpg",
      "../upload_images/laskasas/Sideboards/Austen Sideboard/25.jpg"
    ],
    "description": "השידה אוסטן היא שידה מרהיבה עם דלתות זכוכית שמספקת שפע של מקום תוך כדי שהיא משמשת כאלמנט מושך עין במרחבי מגורים מודרניים. בנוסף לכך שהיא מציעה פתרון אחסון פרקטי, העיצוב העכשווי שלה ישדרג את המראה הכללי של המרחב.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 25881,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Brown Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Brown Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/brown-sideboard_p4497.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Brown Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Brown Sideboard/16.jpg"
    ],
    "description": "בראון הוא מזנון מעוצב בעיקול עם משטח עץ, עיטורים מתכתיים מדויקים ומשטח עליון משיש בעבודת יד. אידיאלי לחדרי אוכל מרשימים, הפריט המעוצב בקפידה הזה מציע מראה עכשווי שיחמיא לכל פנים עם האלגנטיות המעודנת שלו.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 12433,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Cuba Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Cuba Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/cuba-sideboard_p4763.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Cuba Sideboard/16.jpg"
    ],
    "description": "Meet Cuba: a contemporary sideboard featuring four doors with push-latch hardware and one inner drawer. This sleek piece combines modern design with practical functionality, making it an ideal addition to any stylish living or dining space.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 11646,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Dean sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Dean sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/dean-sideboard_p5652.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Dean sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Dean sideboard/16.jpg"
    ],
    "description": "מזנון זה עם מגירות מספק שטח אחסון נדיב, מה שהופך אותו למושלם לארגון ואחסון חפצים באופן מסוגנן. בעיצוב עכשווי, דין הוא תוספת מצוינת לכל פנים מודרני.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 24625,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Duane Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Duane Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/duane-sideboard_p4501.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Duane Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Duane Sideboard/16.jpg"
    ],
    "description": "דווין הוא מזנון גדול שמשלב קסם וינטג' עם אלמנטים עיצוביים אלגנטיים, ומציג חומרים קלאסיים וגימורים לא שגרתיים. הפריט המרשים הזה מושלם להעלאת האלגנטיות של כל חדר אוכל, והוא מציע גם סגנון וגם שטח אחסון רחב.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 12196,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Isis sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Isis sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/isis-sideboard_p4502.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Isis sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Isis sideboard/16.jpg"
    ],
    "description": "גלה את איסיס: מזנון מן התקופה האמצעית עם טוויסט עכשווי. המסגרת המנצנצת שלו והעיצוב החלק מביאים נגיעה של אֵלֵגוֹנְסְיוּת מודרנית לכל חדר אוכל, ומציעים הן סגנון והן פונקציונליות. מושלם עבור מי שמחפש לשלב קסם של אמצע המאה עם אסתטיקה עכשווית.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 18061,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "D'Arc Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/D'Arc Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/darc-sideboard_p4499.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/D'Arc Sideboard/16.jpg"
    ],
    "description": "מזנון D'Arc מעוצב לבלוט בכל חדר אוכל או סלון, ומציג עיצוב נקי על מבנה מעץ עם פרטים מתכתיים. מזנון עץ זה הוא הפתרון המושלם לחדרים הזקוקים לשפע של שטח אחסון, ומשלב פונקציונליות עם אסתטיקה מתוחכמת.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 15750,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Boris Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Boris Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/boris-sideboard_p4496.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Boris Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Boris Sideboard/16.jpg"
    ],
    "description": "המזנון בוריס הוא איזון בין פשטות לפונקציונליות, מעשה ידי אמנים מוכשרים מעץ הנתמך על ידי רגליים מתכתיות. הוא מושלם לחדרי אוכל יוקרתיים.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 11272,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Lagos Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Lagos Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/lagos-sideboard_p4768.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Lagos Sideboard/16.jpg"
    ],
    "description": "מזנון הצד הצר של לאגוס הוא פתרון אחסון שמשדר פינוק מעודן. עם רגלי מתכת חלקות ועיצוב אלגנטי, הוא משתלב באופן מושלם בפנים מודרני, ומציע סגנון ופרקטיות.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 18606,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Lewis Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Lewis Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/lewis-sideboard_p5627.html?id=1388&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Lewis Sideboard/16.jpg"
    ],
    "description": "המזנון המודרני לואיס הוא פריט עכשווי המאופיין בקווים נקיים וישרים. בנוי בעבודת יד וניתן להתאמה אישית מלאה, הוא יכול להיות מותאם במגוון חומרים, גימורים ומידות כדי להתאים לכל פרויקט עיצוב פנים, ולהשתלב באופן מושלם בחללים מודרניים.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 29175,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Milos Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Milos Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/milos-sideboard_p8072.html?id=1388&cat=1382&pc=1&f=2",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Milos Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/16.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/17.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/18.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/19.jpg",
      "../upload_images/laskasas/Sideboards/Milos Sideboard/20.jpg"
    ],
    "description": "מזנון \"מילוס\" הוא מזנון עכשווי ומעוצב הכולל שתי דלתות, שלוש מגירות ומדפים פתוחים. אידיאלי לאחסון בכל חדר בבית.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 12426,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Ralph sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Ralph sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/ralph-sideboard_p4782.html?id=1388&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Ralph sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/16.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/17.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/18.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/19.jpg",
      "../upload_images/laskasas/Sideboards/Ralph sideboard/20.jpg"
    ],
    "description": "שידת ראלף היא פריט אלגנטי עם ארון בעל 4 דלתות שמקרין תחושה טבעית ורטרו. מושלם לשמירה על הדברים החיוניים בקרבת מקום, שידה זו עם רגלי מתכת יכולה להתאים לכל פרויקט עיצוב פנים, ולהוסיף הן פונקציונליות והן סגנון לכל חדר.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 10856,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "RICK Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/RICK Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/rick-sideboard_p5641.html?id=1388&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/RICK Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/16.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/17.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/18.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/19.jpg",
      "../upload_images/laskasas/Sideboards/RICK Sideboard/20.jpg"
    ],
    "description": "ריק הוא פריט הצהרה שיגדיר כל קונספט של חדר אוכל. המזנון מעץ ושיש כולל ארבע דלתות, ויוצר מרחב מושלם לאירוח ובידור. הערה: המוצרים שלנו מיוצרים מעץ וניר איכותי, ומבטיחים גם עמידות וגם אלגנטיות.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 12241,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Macau Sideboard": {
    "image_url": "../upload_images/laskasas/Sideboards/Macau Sideboard/1.jpg",
    "product_url": "https://www.laskasas.com/en/sideboards/macau-sideboard_p4766.html?id=1388&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Sideboards/Macau Sideboard/1.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/2.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/3.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/4.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/5.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/6.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/7.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/8.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/9.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/10.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/11.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/12.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/13.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/14.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/15.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/16.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/17.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/18.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/19.jpg",
      "../upload_images/laskasas/Sideboards/Macau Sideboard/20.jpg"
    ],
    "description": "מזנון ה-3 מגירות של מקאו משלב פורניר עץ ומתכת, ומציג את האלגנטיות של חומרים טבעיים. המגירות המעוצבות בקפידה מספקות שטח אחסון נרחב תוך הוספת מגע ייחודי לכל פרויקט עיצוב פנים. למרות שיחידת ה-3 מגירות היא אפשרות סטנדרטית, ניתן להתאים אותה לצרכים הספציפיים וההעדפות העיצוביות של הפרויקט שלך.",
    "company_name": "Laskasas",
    "original_category": "Sideboards",
    "price": 24682,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Amber tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Amber tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/amber-tallboy_p4814.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Amber tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Amber tallboy/16.jpg"
    ],
    "description": "עם הקווים הנקיים והצורה המלבנית שלו, הארונית Amber Tallboy מוסיפה מראה קו אחיד לכל חדר שינה. הגימור הנייטרלי, הדגשים הפלדה והמבנה העץ משתלבים יחד ליצירת פריט מגוון ודקורטיבי שמשדרג מגוון סגנונות עיצוב פנים.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 14409,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Bowen Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Bowen Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/bowen-tallboy_p8123.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Bowen Tallboy/16.jpg"
    ],
    "description": "טאלבוי בואן הוא טאלבוי בסגנון עכשווי ותוספת מושלמת לכל פרויקט חדר שינה. ניתן להתאמה אישית במגוון חומרים, יש לו תחושה חמה וטבעית שתשלים כל עיצוב בית.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 11493,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Cairo Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Cairo Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/cairo-tallboy_p5687.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Cairo Tallboy/16.jpg"
    ],
    "description": "ארון המגירות קהיר מציג עיצוב פשוט אך אלגנטי, מה שהופך אותו לתוספת רב-תכליתית לכל חדר שינה. הקווים הנקיים והקסם המעודן שלו מאפשרים לו להשתלב בהרמוניה עם מגוון סגנונות, ולהעשיר את החללים בתחכום חסר מאמץ.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 12309,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Connor tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Connor tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/connor-tallboy_p4558.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Connor tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Connor tallboy/12.jpg"
    ],
    "description": "הקונור טאלבוי מתאפיין בעיצוב פשוט וקומפקטי, מה שהופך אותו לבחירה אידיאלית להוספת אחסון נוסף לכל עיצוב חדר שינה ראשי. הפרופיל המלוטש שלו ממקסם את הפונקציונליות תוך שמירה על אסתטיקה נקייה, ומבטיח שהוא ישתלב באופן מושלם במרחב שלך.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 21280,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Dakar Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Dakar Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/dakar-tallboy_p5690.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Dakar Tallboy/16.jpg"
    ],
    "description": "דקר טולבוי הוא פריט עכשווי ומינימליסטי שנועד לשדרג כל חלל מגורים. הוא עשוי מחומרים עמידים ומציע אפשרויות התאמה אישית בגימורים שונים כדי להתאים לסגנון הייחודי של הלקוח שלך. העיצוב המלוטש שלו משלב באופן מושלם פונקציונליות עם אסתטיקה מודרנית.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 18054,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Emily Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Emily Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/emily-tallboy_p4559.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Emily Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Emily Tallboy/12.jpg"
    ],
    "description": "אימילי טולבוי היא תוספת על-זמנית לכל חדר שינה פונקציונלי. עם גוף מעץ ומסגרת מתכת יציבה, היא כוללת מגירות מרווחות, שכל אחת מהן מעוטרת בידיות מתכת חלקות, מה שמבטיח סגנון ונוחות.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 21941,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Endy Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Endy Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/endy-tallboy_p5672.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Endy Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Endy Tallboy/16.jpg"
    ],
    "description": "הטולבוי של אנדי מעוצב למקסם את השטח המנוצל תוך כדי הצעת מגירות גדולות וחלקות ללא ידיות למראה מלוטש. פריט זה מספק אחסון נרחב ומשדרג את יופיו של כל חדר שינה עם האלגנטיות העכשווית שלו.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 10640,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Ester Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Ester Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/ester-tallboy_p4560.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Ester Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Ester Tallboy/16.jpg"
    ],
    "description": "אסתר טולבוי היא תוספת רומנטית לחדרי שינה על-זמניים. עם המגירות המעוצבות שלה הנתמכות בצורה אלגנטית על ידי מבנה מתכתי בולט, הפריט הזה מביא איזון ונגיעה מחודדת לחלל שלכם, ומשפר את הקסם הכללי של החדר.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 12523,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Hilary Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Hilary Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/hilary-tallboy_p4561.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Hilary Tallboy/16.jpg"
    ],
    "description": "הילארי טולבוי הוא תוספת מודרנית לחדרי שינה מעודנים, ומשלב בין פרטים מעץ עבודת יד לפרטים מתכתיים. הרהיט הסטיילי הזה משדרג את עיצוב הפנים הכללי ומספק פונקציונליות ואלגנטיות.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 20224,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Kira Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Kira Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/kira-tallboy_p5708.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Kira Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Kira Tallboy/16.jpg"
    ],
    "description": "קירה טולבוי הוא פריט קלאסי עם עיצוב מודרני, המציע יופי ופונקציונליות. קווים הנקיים והגימור האלגנטי שלו הופכים אותו לתוספת אידיאלית לכל פרויקט חדר שינה, ומשדרגים את החלל בנגיעה של תחכום עכשווי.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 29240,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Lady Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Lady Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/lady-tallboy_p4562.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Lady Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Lady Tallboy/16.jpg"
    ],
    "description": "גבירת טולבוי היא שידת מגירות אידיאלית לחדרי שינה קלאסיים, עם מגירות חלקות ועיצוב שמשדר אלגנטיות נצחית. האסתטיקה המעודנת שלה הופכת אותה להשלמה בולטת לכל עיצוב מסורתי.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 17893,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Male Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Male Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/male-tallboy_p4715.html?id=1396&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Male Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Male Tallboy/16.jpg"
    ],
    "description": "טאלבוי מליי מציע מראה נקי ומרענן לכל חדר, עם עיצוב חלק המשתלב עם ארבעה תאי אחסון. פריט זה משיג איזון מושלם בין פרקטיות לסגנון, מה שהופך אותו לבחירה אידיאלית עבור עיצובים מודרניים.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 16381,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Mucala Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Mucala Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/mucala-tallboy_p4742.html?id=1396&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/16.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/17.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/18.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/19.jpg",
      "../upload_images/laskasas/Tallboys/Mucala Tallboy/20.jpg"
    ],
    "description": "הגבוהה של מובולה טולבוי מגלמת אלגנטיות מתוחכמת ומעודנת, עם מגירות מעוצבות היטב לאחסון רב-תכליתי. ניתן להתאים אותה אישית לצורכי הלקוח הספציפיים, והיא משתלבת בצורה חלקה בכל חדר שינה, ומציעה סגנון ופונקציונליות.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 21816,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Rosie Tallboy ": {
    "image_url": "../upload_images/laskasas/Tallboys/Rosie Tallboy /1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/rosie-tallboy_p4563.html?id=1396&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /1.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /2.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /3.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /4.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /5.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /6.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /7.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /8.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /9.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /10.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /11.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /12.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /13.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /14.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /15.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /16.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /17.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /18.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /19.jpg",
      "../upload_images/laskasas/Tallboys/Rosie Tallboy /20.jpg"
    ],
    "description": "ה\"רוזי טולבוי\" הוא יצירת מופת מהאמצע המאה, עם עיצוב אנכי הכולל מספר מגירות המספקות אחסון מקסימלי תוך תפיסת שטח מינימלי. הצללית האלגנטית שלו מוסיפה נגיעה שיקית לכל חדר שינה, ומשלבת בצורה חלקה בין פונקציונליות למשיכה אסתטית.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 21940,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Rowling Tallboy": {
    "image_url": "../upload_images/laskasas/Tallboys/Rowling Tallboy/1.jpg",
    "product_url": "https://www.laskasas.com/en/tallboys/rowling-tallboy_p84494.html?id=1396&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/1.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/2.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/3.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/4.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/5.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/6.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/7.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/8.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/9.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/10.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/11.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/12.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/13.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/14.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/15.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/16.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/17.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/18.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/19.jpg",
      "../upload_images/laskasas/Tallboys/Rowling Tallboy/20.jpg"
    ],
    "description": "בעיצובו המינימליסטי ושלושת המגירות המרווחות שלו, הארונית הגבוהה של רולינג היא תוספת פונקציונלית לחדרי שינה וארונות.",
    "company_name": "Laskasas",
    "original_category": "Tallboys",
    "price": 23604,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Austen TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/austen-tv-cabinet_p84426.html?id=1410&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/20.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/21.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/22.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/23.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/24.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Austen TV Cabinet/25.jpg"
    ],
    "description": "אוסטן הוא מזנון טלוויזיה מרשים במיוחד, המתפקד בצורה גבוהה מבחינה פרקטית וויזואלית. הוא כולל ארבע דלתות זכוכית אלגנטיות המאפשרות אפשרויות אחסון מרובות. המזנון תוכנן כתצוגה שיקית לאביזרי בידור ביתי, והמשטח הרחב שלו עונה על הצרכים הפרקטיים של חללי מגורים מודרניים עם סגנון ותחכום.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 18714,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Boris TV cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/boris-tv-cabinet_p4511.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Boris TV cabinet/16.jpg"
    ],
    "description": "ארונית הטלוויזיה בוריס, מתוך קולקציית בוריס, היא יצירה מרהיבה לעיצוב נועז, עשויה מעץ ומושלמת לאחסון פריטי כסף לאספנים. היא מהווה תוספת אלגנטית לכל חדר קלאסי עם פסיפס מדהים.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 28111,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Brown TV cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/brown-tv-cabinet_p6045.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Brown TV cabinet/16.jpg"
    ],
    "description": "ארון הטלוויזיה החום הוא רהיט אחסון בהשראת עיצוב משנות ה-20, המיוצר מעץ ומשלב באופן מושלם בין סגנונות קלאסיים ועכשוויים. עבור אלו שמעריכים את הנוסטלגיה של העיצוב מהמחצית המאה, האוסף שלנו מציע את הפתרון המושלם. שידת הטלוויזיה בעיצוב מודרני מהמחצית המאה משלבת את הקסם הנצחי של העבר עם הטכנולוגיה של ההווה.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 14128,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Cuba TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/cuba-tv-cabinet_p4748.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Cuba TV Cabinet/14.jpg"
    ],
    "description": "ארונית הטלוויזיה של קובה אינה רק מעמד לטלוויזיה, אלא גם מספקת שפע של מקום אחסון, והופכת לפריט מרכזי שימשוך את תשומת הלב של כל מי שיראה אותו.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 19621,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Antoine TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/antoine-tv-cabinet_p6042.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Antoine TV Cabinet/16.jpg"
    ],
    "description": "ארונית הטלוויזיה אנטואן היא יצירה מינימליסטית שמאמצת את פילוסופיית העיצוב של סגנון הריהוט האיטלקי, עם פרטים במתכת המנוגדים לפשטות של הדלתות והמגירות.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 19323,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Dean TV cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/dean-tv-cabinet_p6068.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dean TV cabinet/16.jpg"
    ],
    "description": "ארון הטלוויזיה דין הוא רהיט מתקופת אמצע המאה, מלא קסם, עם משטח שיש מהמם הנתמך על ידי מבנה עץ ופרטים מתכתיים למגע יוקרתי.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 25341,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Dener TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/dener-tv-cabinet_p4809.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Dener TV Cabinet/16.jpg"
    ],
    "description": "ארון הטלוויזיה דנר הוא פריט אלגנטי ופשוט שישדרג כל סלון. הוא מאופיין בקווים חדים וברגשות נועזים, ועונה על כל הדרישות של הסלון.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 11929,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Milos TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/milos-tv-cabinet_p8103.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Milos TV Cabinet/16.jpg"
    ],
    "description": "ארונית הטלוויזיה מילו היא תוספת מקסימה לכל חלל מגורים, עם הקווים הברורים והנקיים שלה. הארונית כוללת שלוש מגירות ומדפים פתוחים, ומציעה אפשרויות אחסון מרובות לכל צרכי הבית שלכם.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 18143,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Duane TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/duane-tv-cabinet_p6076.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Duane TV Cabinet/16.jpg"
    ],
    "description": "ארון הטלוויזיה דוויין הוא פריט אחסון קלאסי שמשלב עץ ומסגרת מתכת כדי להעניק נגיעה של יוקרה לחללים פונקציונליים עם נשמה מקסימה.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 11111,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "D'Arc TV cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/darc-tv-cabinet_p4513.html?id=1410&cat=1382&pc=1",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/D'Arc TV cabinet/16.jpg"
    ],
    "description": "ארון הטלוויזיה D'Arc הוא דוגמה איקונית לטעם טוב מתוך אוסף D'Arc, ובו שני מודולים של מגירות ושתי דלתות מרכזיות, עם גוף עץ וכמות מושלמת של פרטים לשדרוג כל עיצוב בית.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 13564,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Lagos TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/lagos-tv-cabinet_p4745.html?id=1410&cat=1382&pc=1&f=3",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lagos TV Cabinet/20.jpg"
    ],
    "description": "ארון הטלוויזיה לאגוס הוא פריט עכשווי שחוגג עיצוב בכל פרט, מושלם לכל סלון.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 18175,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Lewis TV cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/lewis-tv-cabinet_p6048.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lewis TV cabinet/20.jpg"
    ],
    "description": "ארון הטלוויזיה לואיס הוא פריט עליז עם דוגמת עץ, מודגש על ידי גוף עץ ופלטת שיש. הוא כולל שתי דלתות וארבע מגירות, ומספק מגע יוקרתי לכל פרויקט עיצוב. עוררו את הנוסטלגיה של אסתטיקת אמצע המאה עם אוסף מעמד הטלוויזיה המודרני שלנו.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 25646,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Lora TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/lora-tv-cabinet_p6081.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lora TV Cabinet/20.jpg"
    ],
    "description": "ארון הטלוויזיה לורה הוא פריט נקי ופונקציונלי, מושלם לאחסון מדיה. הוא כולל מדפים פתוחים בתא השמאלי לגישה נוחה לרכיבי מדיה, וניתן להתאמה אישית עם אפשרויות שונות של פלדה ועץ.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 12089,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Macau TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/macau-tv-cabinet_p4749.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Macau TV Cabinet/20.jpg"
    ],
    "description": "ארון הטלוויזיה של מקאו הוא פריט מינימליסטי שמאחסן את כל האלקטרוניקה בצורה חלקה, ומאפשר מרחב מחיה נקי ומסודר.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 20425,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Rick TV cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/rick-tv-cabinet_p6051.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rick TV cabinet/20.jpg"
    ],
    "description": "ארון הטלוויזיה ריק הוא איזון בין פונקציונליות ליופי, כולל ארבע דלתות ופרטים מתכתיים שניתן להתאים אישית עם מבנה מעץ או שיש. זהו רהיט רב-גוני המתאים לסלונים עכשוויים או לחדרי שינה עיקריים.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 23287,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Norman TV cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/norman-tv-cabinet_p11718.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Norman TV cabinet/20.jpg"
    ],
    "description": "ארון הטלוויזיה נורמן מביא ניחוח רטרו לאזורי המגורים עם הצללית האלגנטית והמינימליסטית שלו. הוא מתאים באופן מושלם לסביבות מסורתיות ולסגנון שנות ה-50, והמשטח העליון הניתן להתאמה אישית יכול לשאת טלוויזיה, רמקולים ואפילו סאונד-באר.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 26038,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Pam TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/pam-tv-cabinet_p4810.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Pam TV Cabinet/20.jpg"
    ],
    "description": "ארון הטלוויזיה פאם מאופיין במבנה עץ ובעיצוב בעל קווים נקיים, שמביא תחכום לכל אזור בידור. הוא משתלב בצורה מושלמת הן בחללים מונוכרומטיים והן בחללים עשירי צבע, וצורתו המלבנית אידיאלית לכל חלל בלתי פורמלי.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 20183,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Isis Tv Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/isis-tv-cabinet_p6056.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Isis Tv Cabinet/19.jpg"
    ],
    "description": "מזנון הטלוויזיה איסיס הוא רהיט מודרני בהשראת מגמות עיצוב עכשוויות, עבודת יד של אומני לסקסאס, והוא מתאפיין בפרופיל אלגנטי עם שלוש דלתות בגימור פורניר אגוז ומדף עם פרטים מוזהבים.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 21014,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Rodney TV Cabinet": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/1.jpg",
    "product_url": "https://www.laskasas.com/en/tv-cabinets/rodney-tv-cabinet_p93136.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Rodney TV Cabinet/10.jpg"
    ],
    "description": "בעיצובו המושלם ובתאי האחסון הפתוחים והנדיבים שלו, רודני מאזן בין תכלית לאלגנטיות. אידיאלי למרחבי מגורים עכשוויים, ארון הטלוויזיה עם אחסון זה מציע מרחב נדיב תוך שמירה על אסתטיקה נקייה ומינימליסטית.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 13695,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Lyon storage unit": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/1.jpg",
    "product_url": "https://www.laskasas.com/en/storage-units/lyon-storage-unit_p4626.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/15.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/16.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/17.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/18.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/19.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Lyon storage unit/20.jpg"
    ],
    "description": "יחידת האחסון ליון היא פתרון חכם לקונספטים קלאסיים, ניתנת להתאמה אישית מלאה ומושלמת לעיצוב פנים בגוונים ניטרליים.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 16436,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Will storage unit": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/1.jpg",
    "product_url": "https://www.laskasas.com/en/storage-units/will-storage-unit_p5664.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Will storage unit/15.jpg"
    ],
    "description": "יחידת האחסון וויל היא פריט רב-תכליתי, עשויה מחומרים עמידים כמו עץ ושיש, ומתאימה לשימוש בסלונים, חדרי אוכל, מסדרונות, חדרי שינה, ואף במסעדות או מלונות.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 15634,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Ryan storage unit": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/1.jpg",
    "product_url": "https://www.laskasas.com/en/storage-units/ryan-storage-unit_p4795.html?id=1410&cat=1382&pc=2",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Ryan storage unit/15.jpg"
    ],
    "description": "יחידת האחסון ריאן היא פריט דקורטיבי שמשלב יופי ופונקציונליות, עשוי בעבודת יד מחומרים איכותיים כמו עץ ומתכת, מושלם להצגת מגזינים.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 17988,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Daisy storage unit": {
    "image_url": "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/1.jpg",
    "product_url": "https://www.laskasas.com/en/storage-units/daisy-storage-unit_p4699.html?id=1410&cat=1382&pc=3",
    "image_urls": [
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/1.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/2.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/3.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/4.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/5.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/6.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/7.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/8.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/9.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/10.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/11.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/12.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/13.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/14.jpg",
      "../upload_images/laskasas/TV Cabinets & Storage Units/Daisy storage unit/15.jpg"
    ],
    "description": "יחידת האחסון דייזי היא פריט עיצוב מינימליסטי עשוי עץ, בהשראה עיצובית סקנדינבית ומושלם להצבה מאחורי ספה או מול מיטה.",
    "company_name": "Laskasas",
    "original_category": "TV Cabinets & Storage Units",
    "price": 18848,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Bloom HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/387346-bloom",
    "image_url": "../upload_images/naturedesign/Tables/Bloom HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Bloom HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Bloom HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Bloom HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Bloom HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Bloom HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nשולחן עם משטח משיש ערבסקאטו רוסו אורוביקו ובסיס מתכת בצבע טיטניום לוקסור",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 12926,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Blow HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/681-blow",
    "image_url": "../upload_images/naturedesign/Tables/Blow HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Blow HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Blow HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Blow HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Blow HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Blow HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/Blow HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Tables/Blow HOME COLLECTION/7.jpg"
    ],
    "description": "עיצוב ג'ינו קארולו  \nהאפקט הוויזואלי של תנועת קלות הנוצר על ידי הקווים של שולחן ה-Blow מוגבר על ידי משחקי אור וצל שנותנים לשולחן נוכחות סצנתית חזקה שמתאימה באופן מושלם לכל סוג של סביבה, עם הגימורים המתכתיים והמשטח העליון מעץ, שיש או קרמיקה.  \nשולחן עם משטח עליון עשוי שיש פטגוניה ובסיס עשוי מתכת ברונזה לוקסור.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 14571,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Blur HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/50655-blur",
    "image_url": "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/7.jpg",
      "../upload_images/naturedesign/Tables/Blur HOME COLLECTION/8.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nהקווים העדינים והמעוגלים של שולחן ה-Blur יוצרים תחושת זרימה ומשרים אפקטים של אור מרומזים הודות לזכוכית בעלת הטקסטורה, המאפשרת לאור לחדור ולהחיות את הסביבה. הבסיס והמשטח העליון מזכוכית יצוקה בטקסטורה זמינים בצבעים שונים, ויוצרים תמהיל הרמוני של אור וצבעים.  \nשולחן עם משטח ובסיס מזכוכית יצוקה בצבע ענבר.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 12770,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Bridge ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/387605-bridge",
    "image_url": "../upload_images/naturedesign/Tables/Bridge ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Bridge ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Bridge ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Bridge ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Bridge ORIGIN COLLECTION/4.jpg"
    ],
    "description": "שולחן גשר עם חלק עליון וקורה מזכוכית שקופה ובסיס מעץ סקולרה טבעי.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 24586,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Cocoon ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/740-cocoon",
    "image_url": "../upload_images/naturedesign/Tables/Cocoon ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Cocoon ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Cocoon ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Cocoon ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Cocoon ORIGIN COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Cocoon ORIGIN COLLECTION/5.jpg"
    ],
    "description": "שולחן Cocoon עם משטח עליון עשוי עץ Secolare טבעי ובסיס מתכת בצבע חום. מימין: בסיס מתכת בצבע ברונזה Luxor.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 25544,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Fontana ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/388468-fontana",
    "image_url": "../upload_images/naturedesign/Tables/Fontana ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Fontana ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Fontana ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Fontana ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Fontana ORIGIN COLLECTION/4.jpg"
    ],
    "description": "שולחן פונטנה עם משטח עץ סקולרה טבעי ובסיס זכוכית יצוקה אקסטרה-שקופה.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 29897,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Gate ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/568364-gate",
    "image_url": "../upload_images/naturedesign/Tables/Gate ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Gate ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Gate ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Gate ORIGIN COLLECTION/3.jpg"
    ],
    "description": "עיצוב ND Lab שולחן גשר עם משטח וקורה זכוכית שקופה ובסיס מעץ Secolare טבעי.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 28443,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Harvest Metal ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/759-harvest-metal",
    "image_url": "../upload_images/naturedesign/Tables/Harvest Metal ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Harvest Metal ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Harvest Metal ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Harvest Metal ORIGIN COLLECTION/3.jpg"
    ],
    "description": "שולחן מתכת Harvest עם משטח עץ Secolare טבעי ובסיס מתכת בצבע ברונזה לוקסור.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 28684,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Harvest Murano ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/1553-harvest-murano",
    "image_url": "../upload_images/naturedesign/Tables/Harvest Murano ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Harvest Murano ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Harvest Murano ORIGIN COLLECTION/2.jpg"
    ],
    "description": "שולחן הרווסט מורנו עם משטח מעץ סקולארה טבעי ובסיס מזכוכית מורנו אקסטרה-קלייר.  \nTavolo Harvest Murano con top in legno frassino nero assoluto e base in vetro di Murano grigio fumo.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 13381,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "ILL Metal ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/901-ill-metal",
    "image_url": "../upload_images/naturedesign/Tables/ILL Metal ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/ILL Metal ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/ILL Metal ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/ILL Metal ORIGIN COLLECTION/3.jpg"
    ],
    "description": "שולחן מתכת מסוגנן עם משטח עץ סכולארה טבעי ובסיס מתכת ברונזה לוקסור.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 28178,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "ILL Murano ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/931-ill-murano",
    "image_url": "../upload_images/naturedesign/Tables/ILL Murano ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/ILL Murano ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/ILL Murano ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/ILL Murano ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/ILL Murano ORIGIN COLLECTION/4.jpg"
    ],
    "description": "שולחן מורנו מדגם איל עם משטח עץ טבעי מסוג ססולאר ובסיס זכוכית מורנו בהירה במיוחד.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 20837,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Lymph HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/1055-lymph",
    "image_url": "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/7.jpg",
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/8.jpg",
      "../upload_images/naturedesign/Tables/Lymph HOME COLLECTION/9.jpg"
    ],
    "description": "סטודיו עיצוב 28  \nהצורות האמורפיות והאורגניות של שולחן ה-Lymph מעוררות דימוי של אלמנטים טבעיים ומעניקות תחושה של זרימה טהורה, ומוסיפות נגיעה של טבעיות לסביבה שמסביב.  \nהגימורים, עם משטחי שיש, עץ או קרמיקה, מדגישים את ההיבט האמנותי/דקורטיבי של שולחן זה, שבו המשחק בעיצוב בין הבסיסים למשטח המותאם אישית הופך כל גרסה למפרשת אייקונית של בית העיצוב.  \nשולחן עם משטח ובסיסים מעץ אשוח מוקה.  \n",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 15541,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Lymph Big HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/388649-lymph-big",
    "image_url": "../upload_images/naturedesign/Tables/Lymph Big HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Lymph Big HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Lymph Big HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Lymph Big HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Lymph Big HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Lymph Big HOME COLLECTION/5.jpg"
    ],
    "description": "סטודיו לעיצוב 28\nבהשראת אלמנטים טבעיים ודגמים ביומורפיים, הקווים הזורמים והאמורפיים של שולחן ה-Lymph Big מעניקים לחלל נגיעה של טבע, ויוצרים מקום אינטימי ומחבק להרהור. השולחן מתאפיין בצורות רכות וזורמות, שבתוך עירוב הסגנונות בין הבסיס והחלק העליון, הופכות כל גרסה למפרש איקוני של בית העיצוב.\n\nהגימורים הזמינים — בסיס עץ או שיש וחלק עליון מעץ, שיש או קרמיקה — מדגישים את האופי האמנותי/דקורטיבי של השולחן ומעניקים לו נוכחות חזותית משמעותית בתוך הסביבה הקרובה.\n\nשולחן עם חלק עליון ובסיסים מעץ אשור שחור מוחלט ושיש נרו אנטיקו.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 10942,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Monolith HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/1116-monolith",
    "image_url": "../upload_images/naturedesign/Tables/Monolith HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Monolith HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Monolith HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Monolith HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Monolith HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Monolith HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/Monolith HOME COLLECTION/6.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nשולחן המונולית הוא פרשנות מינימליסטית ואלגנטית של שולחן, עם סגנון מפוסל המאופיין בקווים ונפחים המונחים זה לצד זה במקביל ומאונך זה לזה. השונות הזו, יחד עם השילוב של החומרים, הופכים כל שולחן ליצירה ייחודית, בדיוק כמו הסביבה שבה הוא נמצא.  \nשולחן עם משטח ובסיסים מעץ אפר שחור מוחלט",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 23496,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Sail HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/1149-sail",
    "image_url": "../upload_images/naturedesign/Tables/Sail HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Sail HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Sail HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Sail HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Sail HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Sail HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/Sail HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Tables/Sail HOME COLLECTION/7.jpg"
    ],
    "description": "סטודיו לעיצוב 28  \nשולחן ה־Sail מתחיל מבנייה אסתטית שמזכירה מפרשים פרושים. הבסיס הדק והקליל של השולחן מדגיש את המשטח העליון, שנראה מרחף, ומנוגד לשילוב של קימורים וזוויות בסגנון מובהק ומהפכני. הבסיס המתכתי המטופל והמשטח העליון שעשוי מעץ, קרמיקה או שיש מעניקים נפח וחוזק לצורה.  \nשולחן עם משטח עליון מעץ אֵלֶה בגוון קרמל ובסיס מתכת ברונזה לוקסור",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 16226,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Sequoia ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/568409-sequoia",
    "image_url": "../upload_images/naturedesign/Tables/Sequoia ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Sequoia ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Sequoia ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Sequoia ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Sequoia ORIGIN COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Sequoia ORIGIN COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/Sequoia ORIGIN COLLECTION/6.jpg",
      "../upload_images/naturedesign/Tables/Sequoia ORIGIN COLLECTION/7.jpg"
    ],
    "description": "עיצוב מעבדת ND  \nשולחן קוקון עם משטח עץ סקלורה טבעי ובסיס מתכת חום. מימין: בסיס מתכת בצבע ברונזה לוקסור.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 27359,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Tide HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/388613-tide",
    "image_url": "../upload_images/naturedesign/Tables/Tide HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Tide HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Tide HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Tide HOME COLLECTION/3.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nהבסיס העשוי עץ של שולחן Tide ניתן להעריך מזוויות שונות, יוצר אפקט ויזואלי של אחדות ולכידות, ותומך בחלק העליון עם גרסאות רבות זמינות בעץ, שיש, קרמיקה וזכוכית. המשחק של אורות וצללים שנוצר על ידי הבסיס מוסיף אפקטים תלת-ממדיים אלגנטיים לאסתטיקה הכללית.  \nשולחן עם חלק עליון ובסיס מעץ מוקה אפר",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 28316,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Tide HOME COLLECTION|": {
    "product_url": "https://naturedesign.com/en/products/tables/568572-tide",
    "image_url": "../upload_images/naturedesign/Tables/Tide HOME COLLECTION|/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Tide HOME COLLECTION|/1.jpg",
      "../upload_images/naturedesign/Tables/Tide HOME COLLECTION|/2.jpg",
      "../upload_images/naturedesign/Tables/Tide HOME COLLECTION|/3.jpg",
      "../upload_images/naturedesign/Tables/Tide HOME COLLECTION|/4.jpg"
    ],
    "description": "עיצוב: ג'ינו קארולו  \nבסיס העץ של שולחן הטייד ניתן להערכה מזוויות שונות, ויוצר אפקט חזותי של אחדות ולכידות, תומך במשטח העליון ממנו ישנן גרסאות רבות ומגוונות הכוללות עץ, שיש, קרמיקה וזכוכית. המשחק של אורות וצללים הנוצר על ידי הבסיס מוסיף אפקטים תלת-ממדיים אלגנטיים לאסתטיקה הכוללת.  \nשולחן עם בסיס מעץ אגוז אמריקאי ומשטח עליון משיש קמופלאז'.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 17808,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Tide Glass HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/388539-tide-glass",
    "image_url": "../upload_images/naturedesign/Tables/Tide Glass HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Tide Glass HOME COLLECTION/1.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו שולחן עם משטח זכוכית מעושנת ובסיס בטיטניום לוקסור",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 26520,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Tribe HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/50670-tribe",
    "image_url": "../upload_images/naturedesign/Tables/Tribe HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Tribe HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Tribe HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Tribe HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Tribe HOME COLLECTION/4.jpg"
    ],
    "description": "סטודיו לעיצוב 28  \nהקווים הרכים והמעוצבים של שולחן ה-Tribe מזכירים אומנות ותרבות שבטית, ומעוררים תחושת חוסן ודינמיות השייכת לעולם עתיק ומסתורי. פריט ריהוט ייחודי, עם בסיס עץ המנוגד למשטח עליון מזכוכית, שיש או קרמיקה, מסוגל לחלוטין לשנות כל סביבה.  \nשולחן עם משטח עליון מזכוכית מעושנת ובסיס מעץ מילה שחור מוחלט.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 15257,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Tribe Stone HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/388511-tribe-stone",
    "image_url": "../upload_images/naturedesign/Tables/Tribe Stone HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Tribe Stone HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Tribe Stone HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Tribe Stone HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Tribe Stone HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Tribe Stone HOME COLLECTION/5.jpg"
    ],
    "description": "סטודיו עיצוב 28  \nהקווים הרכים והמעוצבים של שולחן Tribe Stone, המועצמים באמצעות הבסיס השיש, מזכירים אמנות ותרבות שבטית ומעוררים תחושת חוסן בניגוד לקלילות של משטח הזכוכית או זכוכית במרקם טקסטורה. הדינמיקה של פריט ריהוט ייחודי זה לוקחת את מחשבתנו לעולם קדום ומסתורי.  \nשולחן עם משטח זכוכית בטקסטורת ברונזה ובסיס שיש טראוורטין",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 22714,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Unique ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/387640-unique",
    "image_url": "../upload_images/naturedesign/Tables/Unique ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Unique ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Unique ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Unique ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Unique ORIGIN COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Unique ORIGIN COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/Unique ORIGIN COLLECTION/6.jpg"
    ],
    "description": "הטקסט מתאר שולחן ייחודי המשלב את החוסן של קורת עץ מאותית עם בסיס ומשטח עליון מזכוכית שקופה במיוחד. העיצוב מתפתח מאחת הלוחות המאותיים המצויים בסטודיו של נייצ'רדיזיין, שכל אחד מהם ייחודי וחד-פעמי. לוחות שנאספו ממבנים אדריכליים עתיקים, שוחזרו במיומנות כדי לשמר ולהעצים את הקסם שהן צברו עם הזמן.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 13766,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Waterfall HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/1171-waterfall",
    "image_url": "../upload_images/naturedesign/Tables/Waterfall HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Waterfall HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Waterfall HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Waterfall HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Waterfall HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/Waterfall HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/Waterfall HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Tables/Waterfall HOME COLLECTION/7.jpg"
    ],
    "description": "עיצוב: ג'ינו קארולו  \nעשוי כולו מזכוכית יצוקה, שולחן ה-Waterfall מגלם אלגנטיות ומראה מודרני עם קווי מתאר לינאריים מוגדרים היטב, בעוד שהאפקטים של האור שהוא יוצר מזכירים מים זורמים: מפל מרהיב.  \nשולחן מזכוכית יצוקה בגוון ענבר מעושן.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 19995,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Wave ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/1333-wave",
    "image_url": "../upload_images/naturedesign/Tables/Wave ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/Wave ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/Wave ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/Wave ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/Wave ORIGIN COLLECTION/4.jpg"
    ],
    "description": "שולחן Wave עם משטח זכוכית אקסטרה-צלולה, בסיס מתכת חום וקורת עץ Secolare טבעית.  \nשולחן Wave עם משטח קרמיקה Calacatta Gold, בסיס מתכת מושחר וקורת עץ מוקה אפר.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 21604,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "X ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/tables/1363-x",
    "image_url": "../upload_images/naturedesign/Tables/X ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Tables/X ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Tables/X ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Tables/X ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Tables/X ORIGIN COLLECTION/4.jpg",
      "../upload_images/naturedesign/Tables/X ORIGIN COLLECTION/5.jpg",
      "../upload_images/naturedesign/Tables/X ORIGIN COLLECTION/6.jpg"
    ],
    "description": "שולחן X עם משטח זכוכית שקופה במיוחד, בסיס מתכת בצבע חום ובסיס עץ סוקולרה טבעי.",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 17565,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Lake HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/2054-lake",
    "image_url": "../upload_images/naturedesign/Complements/Lake HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Lake HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Lake HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Lake HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Lake HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Complements/Lake HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nשולחן הקצה Lake מאזן באופן מיומן בין צורות אורגניות וגיאומטריות, ומשופר ביופיים של חומרים טבעיים. שולחן הקצה משתלב בהרמוניה עם הסביבה עם בסיס עץ המעוטר בגימורים מעודנים המשמשים לחלק העליון, בהשראת הטבע. התוצאה היא השפעה אסתטית חזקה שאינה מזניחה את הפונקציונליות של משטח מרווח עשוי זכוכית, קרמיקה או שיש.  \nשולחן עם חלק עליון מזכוכית וכתות בסיס מעץ אשוח שחור מוחלט",
    "company_name": "naturedesign",
    "original_category": "Tables",
    "price": 24239,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Bay HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/seatings/976-bay",
    "image_url": "../upload_images/naturedesign/Seatings/Bay HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Seatings/Bay HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Seatings/Bay HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Seatings/Bay HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Seatings/Bay HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Seatings/Bay HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Seatings/Bay HOME COLLECTION/6.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nהשילוב ההרמוני של צורות הכוללות את מבנה המתכת הקליל הופך את כיסא Bay לדוגמה לעיצוב על-זמני. כמחווה לעיצוב אורגני, הגב בגרסת העץ בולט בעיצובו הגלי וההכרחי, מה שהופך את הכיסא למזמין וארגונומי, בעוד שהמבנה הרציף מדגיש את החום והאיתן של עץ מלא. כיסא זה, הזמין בבד, עור או נובוק, תמיד מעודכן ורב-תכליתי, יוצר אווירה אלגנטית ומסבירת פנים.  \nמבנה במתכת שחורה מאט ובד בוקלה B10.",
    "company_name": "naturedesign",
    "original_category": "Seatings",
    "price": 28609,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Bay Armchair HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/seatings/947-bay-armchair",
    "image_url": "../upload_images/naturedesign/Seatings/Bay Armchair HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Seatings/Bay Armchair HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Seatings/Bay Armchair HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Seatings/Bay Armchair HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Seatings/Bay Armchair HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Seatings/Bay Armchair HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו\n\nהשילוב ההרמוני של צורות מקיפות עם המבנה המתכתי הקליל הופך את כורסת Bay לדוגמה של עיצוב על-זמני. כמחווה לעיצוב אורגני, הגב בגרסת העץ בולט בעיצובו העקמומי והחיוני, מה שהופך את הכיסא למזמין וארגונומי, בעוד המבנה הרציף מדגיש את החמימות והחוזק של עץ מלא. כיסא זה, הזמין בבד, עור או נובוק, הוא תמיד עדכני ורב-תכליתי, יוצר אווירה אלגנטית ומזמינה.\n\nכיסא עם בסיס ממתכת ברונזה לוקסור ובד בוקלה B01",
    "company_name": "naturedesign",
    "original_category": "Seatings",
    "price": 21159,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Manta HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/seatings/1036-manta",
    "image_url": "../upload_images/naturedesign/Seatings/Manta HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Seatings/Manta HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Seatings/Manta HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Seatings/Manta HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Seatings/Manta HOME COLLECTION/4.jpg"
    ],
    "description": "סטודיו עיצוב 28  \nהביטוי המעולה של כיסא המנטה משלב את הטוהר הלינארי של בסיס העץ עם התחושה החזותית של המושב המכוסה בעור, והופך אובייקט יומיומי לדמות חיונית ומעוצבת שמעצימה את ערכו של השולחן הנלווה.  \nמושב עם בסיס מעץ מילה שחור מוחלט ועור בצבע בז'",
    "company_name": "naturedesign",
    "original_category": "Seatings",
    "price": 19737,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Manta Low HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/seatings/388933-manta-low",
    "image_url": "../upload_images/naturedesign/Seatings/Manta Low HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Seatings/Manta Low HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Seatings/Manta Low HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Seatings/Manta Low HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Seatings/Manta Low HOME COLLECTION/4.jpg"
    ],
    "description": "סטודיו עיצוב 28  \nההבעה המרשימה של כיסא ה-Manta Low משלבת את הקווים הטהורים של בסיס העץ עם המראה המורם של המושב המכוסה עור, והופכת חפץ יומיומי לדמות מהותית ומפוסלת שמעלה את ערכו של השולחן הנלווה.  \nמושב עם בסיס מעץ מילה קרמל ועור קוניאק.",
    "company_name": "naturedesign",
    "original_category": "Seatings",
    "price": 19758,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Nest HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/seatings/388903-nest",
    "image_url": "../upload_images/naturedesign/Seatings/Nest HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Seatings/Nest HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Seatings/Nest HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Seatings/Nest HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Seatings/Nest HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nהצורה הרכה של הכיסא, שעוטפת בעדינות את הגוף ויוצרת תחושה של הגנה, מזכירה קן. הבסיס האיקוני של כיסא Next משקף יציבות תוך הוספת נגיעה של סגנון עכשווי. המבנה מורכב מסדרה של צורות שונות המשתלבות בהרמוניה עם הריפוד המלא בבד, בנובוק או בעור, ומוסיפות נפח וחוזק לצורה.  \nמושב בבד בוקלה B01",
    "company_name": "naturedesign",
    "original_category": "Seatings",
    "price": 17152,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Origin HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/seatings/1198-origin",
    "image_url": "../upload_images/naturedesign/Seatings/Origin HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Seatings/Origin HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Seatings/Origin HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Seatings/Origin HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Seatings/Origin HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nהקווים הנקיים והפשוטים של כיסא ה-Origin מחזירים אותנו לארכיטיפ של מושב. השימוש בחומר אחד — בד, עור או נובוק — מאפשר השתלבות מושלמת בכל סביבה.  \nמושב בבד בוקלה B02",
    "company_name": "naturedesign",
    "original_category": "Seatings",
    "price": 17591,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Pebble HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/seatings/1082-pebble",
    "image_url": "../upload_images/naturedesign/Seatings/Pebble HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Seatings/Pebble HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Seatings/Pebble HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Seatings/Pebble HOME COLLECTION/3.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו\nכיסא ה-Pebble משלב נוחות עם הצורות העקלקלות של הטבע. ישיבה על אחד מהם היא חוויה מחבקת ומרגיעה שבה הגוף מתקבל בצורה נוחה וטבעית. המבנה מעץ ומגוון הבדים, העור והנובוק המתוחכם הופכים אותו למושלם עבור כל סביבה.\nריפוד בבד בוקלה B01 ובסיס מעץ אפר לכה מוקָה",
    "company_name": "naturedesign",
    "original_category": "Seatings",
    "price": 15325,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Twig HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/seatings/388769-twig",
    "image_url": "../upload_images/naturedesign/Seatings/Twig HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Seatings/Twig HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Seatings/Twig HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Seatings/Twig HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Seatings/Twig HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Seatings/Twig HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nהצורה המתפתלת והמעוררת של בסיס העץ של כיסא Twig מזכירה את הקונספט הטבעי של שורשים. הגב והמושב המרופד המכוסים בבד, עור או נובוק נובעים מאיחוד של צורות מעוקלות טהורות היוצרות אווירה אלגנטית ומזמינה.  \nהמושב עם מבנה מעץ אפר מוחלט בצבע שחור ובד בּוּקְלֶה B10.",
    "company_name": "naturedesign",
    "original_category": "Seatings",
    "price": 28365,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Dolmen HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/50710-dolmen",
    "image_url": "../upload_images/naturedesign/Sideboards/Dolmen HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Dolmen HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Dolmen HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sideboards/Dolmen HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sideboards/Dolmen HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Sideboards/Dolmen HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Sideboards/Dolmen HOME COLLECTION/6.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו\n\nמזנון ה-Dolmen מתבלט בנפחים המינימליסטיים שלו, המודגשים על ידי עיצוב הבסיס מעץ מלא. הקווים הפרופיליים העגולים של דלתות העץ מעניקים לו אופי מובהק ועוצמה מעוררת רושם. החלופה בין הקווים הישרים והמעוגלים של הדלתות יוצרת קצב משתנה, המעמיק את העומק והגוונים. המשטח העליון, הזמין בשיש, עץ או קרמיקה, מאפשר למזנון זה להשתלב בקלות בכל סביבה ביתית.\n\nמזנון עם מבנה מעץ אפר כהה ומשטח עליון משיש טרוורטין.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 13469,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Duefacce ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/567797-duefacce",
    "image_url": "../upload_images/naturedesign/Sideboards/Duefacce ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Duefacce ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Duefacce ORIGIN COLLECTION/2.jpg"
    ],
    "description": "עיצוב ND Lab\nשידה Duefacce עם מבנה ודלת מעץ אפר מוחלט שחור, דלת קרמית בסגנון Sahara Noir ובסיס מתכת שחור מט.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 24838,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Dusk HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/1221-dusk",
    "image_url": "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/7.jpg",
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/8.jpg",
      "../upload_images/naturedesign/Sideboards/Dusk HOME COLLECTION/9.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nהפרט של הבסיס נראה כאילו הוא מתמשך לדלתות האופייניות של המזנון דסק, ומוסיף נגיעה של מקוריות ויצירתיות לקירות שעליהם הוא נשען. בכך הוא שובר את הקווים ויוצר אשליה של המשכיות וזרימה במבנה הכולל שלו, ובהתאם לכך מוסיף תפקיד אסתטי טהור לתפקודו המהותי כמזנון. הדלתות והמבנה של המזנון הזה עשויים מעץ, מה שיוצר מראה אלגנטי, בעוד שהחלק העליון עשוי שיש, עץ או קרמיקה.  \nמזנון מעץ מוקה אפר.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 11492,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Flow HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/389062-flow",
    "image_url": "../upload_images/naturedesign/Sideboards/Flow HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Flow HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Flow HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sideboards/Flow HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sideboards/Flow HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Sideboards/Flow HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Sideboards/Flow HOME COLLECTION/6.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nהמרכיב המרכזי של ארון הצד Flow הוא הבסיס מעץ, שעוצב ליצירת אפקט זורם ודינמי המנוגד לנועזות הפיסולית של מיכל העץ. ברהיט זה, החיפוש אחר איכות דקורטיבית משתלב עם טוהר נפחי, מה שמאפשר את שילובו בחללים מגוונים ביותר. בחירה סגנונית זו מועצמת על ידי הגימורים, הזמינים בשיש, עץ או קרמיקה.  \nמַדִיָה עם מבנה ובסיס מעץ אפר שחור מוחלט ומשטח עליון משיש נרו עתיק",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 28880,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Gea ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/567828-gea",
    "image_url": "../upload_images/naturedesign/Sideboards/Gea ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Gea ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Gea ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sideboards/Gea ORIGIN COLLECTION/3.jpg"
    ],
    "description": "עיצוב ג'ינו קארולו  \nמזנון Gea עם מבנה מעץ אש שחור מוחלט, דלתות מעץ Secolare טבעי ובסיס מתכת שחור מט.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 27584,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Geode ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/1242-geode",
    "image_url": "../upload_images/naturedesign/Sideboards/Geode ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Geode ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Geode ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sideboards/Geode ORIGIN COLLECTION/3.jpg"
    ],
    "description": "ג'ינו קרולו עיצוב  \nמזנון גיאוד עם דלתות וצדדים מעץ סקולארה טבעי, פלטת שיש קלקטה גולד ובסיס מתכת חום.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 19054,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Pod HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/389041-pod",
    "image_url": "../upload_images/naturedesign/Sideboards/Pod HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Pod HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Pod HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sideboards/Pod HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sideboards/Pod HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Sideboards/Pod HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nהנפחים הפשוטים והפורמליים של מזנון הפוד מוסיפים נגיעה של אלגנטיות נצחית לאזור המגורים. עם עיצובו החיוני, הפוד הוא דיסקרטי ומעודן, עם בסיס מתכת ומבנה עץ. החלק העליון, השקוע קלות כדי להעצים את החמימות והיוקרה של העץ, עשוי משלושה חומרים שונים: עץ, שיש או קרמיקה, היוצרים ניגוד אלגנטי עם המבנה.  \nמזנון עם מבנה מעץ פרסימון מוקה, חלק עליון משיש קמופלאג' ובסיס ממתכת בצבע חום כהה.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 21710,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "River ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/50739-river",
    "image_url": "../upload_images/naturedesign/Sideboards/River ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/River ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/River ORIGIN COLLECTION/2.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו\nשידת נהר עם מבנה מעץ סקלולארי טבעי, דלתות וצדדים מזכוכית יצוקה אולטרה-שקופה ומגירה עם חזית מצופת עור.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 13153,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Shell HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/1797-shell",
    "image_url": "../upload_images/naturedesign/Sideboards/Shell HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Shell HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Shell HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sideboards/Shell HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sideboards/Shell HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Sideboards/Shell HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב: ג'ינו קארולו\n\nמזנון Shell מתאפיין באלגנטיות מינימליסטית של המבנה העצי ובבסיס המתכתי שכמעט ואינו נראה, אשר מעניק תחושה של ריחוף. זהו קליפה ייחודית עם קווים פשוטים ומחמירים לאחסון חפצים. אלמנט ייחודי נוסף של פריט ריהוט זה הוא השיש, העץ, או החלק העליון הקרמי.\n\nמזנון עשוי עץ מוקה אפר, חלק עליון מקרמיקה פטגוניה ובסיס מתכת בגוון חום.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 18946,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Shell ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/569081-shell",
    "image_url": "../upload_images/naturedesign/Sideboards/Shell ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Shell ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Shell ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sideboards/Shell ORIGIN COLLECTION/3.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nשידת Shell מתבלטת באלגנטיות המינימליסטית של המבנה מעץ ובסיס המתכת שכמעט ולא נראה, מה שמעניק תחושת ריחוף. מדובר במעטפת ייחודית עם קווים פשוטים וקפדניים לאחסון חפצים. אלמנט ייחודי נוסף של פריט הריהוט הזה הוא החלק העליון שמגיע משיש, עץ או קרמיקה.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 14685,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Slice ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sideboards/1830-slice",
    "image_url": "../upload_images/naturedesign/Sideboards/Slice ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sideboards/Slice ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sideboards/Slice ORIGIN COLLECTION/2.jpg"
    ],
    "description": "עיצוב ND Lab\nשידת סלייס עם מבנה מעץ מוקה אש, תוספת עץ טבעי Secolare ובסיס מתכת חום.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 13611,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Line Box ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/568029-line-box",
    "image_url": "../upload_images/naturedesign/Complements/Line Box ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Line Box ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Line Box ORIGIN COLLECTION/2.jpg"
    ],
    "description": "ליין בוקס עם מבנה מעץ סקלארי טבעי ובסיס ממתכת מושחרת.",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 24642,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Living Plain ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/2018-living-plain",
    "image_url": "../upload_images/naturedesign/Complements/Living Plain ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Living Plain ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Living Plain ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Living Plain ORIGIN COLLECTION/3.jpg"
    ],
    "description": "מעבדת עיצוב ND",
    "company_name": "naturedesign",
    "original_category": "Sideboards",
    "price": 20015,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Frost ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/bookcases/567912-frost",
    "image_url": "../upload_images/naturedesign/Bookcases/Frost ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Bookcases/Frost ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Bookcases/Frost ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Bookcases/Frost ORIGIN COLLECTION/3.jpg"
    ],
    "description": "עיצוב ND Lab ספריית פרוסט עם מבנה זכוכית שקופה ומדפי עץ סקלולה טבעיים.",
    "company_name": "naturedesign",
    "original_category": "Bookcases",
    "price": 18900,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Gemini ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/bookcases/1268-gemini",
    "image_url": "../upload_images/naturedesign/Bookcases/Gemini ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Bookcases/Gemini ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Bookcases/Gemini ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Bookcases/Gemini ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Bookcases/Gemini ORIGIN COLLECTION/4.jpg"
    ],
    "description": "עיצוב אנדראה לוקטלו  \nמדף ג'מיני מעץ סקולרה טבעי וממתכת ברונזה לקסור.  \nספריית ג'מיני מעץ סקולרה שחור ומתכת שחורה מט.",
    "company_name": "naturedesign",
    "original_category": "Bookcases",
    "price": 10038,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Graft Glass ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/bookcases/1278-graft-glass",
    "image_url": "../upload_images/naturedesign/Bookcases/Graft Glass ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Bookcases/Graft Glass ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Bookcases/Graft Glass ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Bookcases/Graft Glass ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Bookcases/Graft Glass ORIGIN COLLECTION/4.jpg",
      "../upload_images/naturedesign/Bookcases/Graft Glass ORIGIN COLLECTION/5.jpg",
      "../upload_images/naturedesign/Bookcases/Graft Glass ORIGIN COLLECTION/6.jpg",
      "../upload_images/naturedesign/Bookcases/Graft Glass ORIGIN COLLECTION/7.jpg"
    ],
    "description": "כוורת זכוכית מסוג גראפט עם מבנה זכוכית שקופה במיוחד ומדפים מעץ סקולרי טבעי.",
    "company_name": "naturedesign",
    "original_category": "Bookcases",
    "price": 22522,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Graft Metal ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/bookcases/1298-graft-metal",
    "image_url": "../upload_images/naturedesign/Bookcases/Graft Metal ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Bookcases/Graft Metal ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Bookcases/Graft Metal ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Bookcases/Graft Metal ORIGIN COLLECTION/3.jpg"
    ],
    "description": "כוננית ספרים גרפט מתכת עם מבנה מתכת ברונזה לוקסור ומדפי עץ סכולרי טבעי.  \nכוננית ספרים גרפט מתכת עם מבנה מתכת שחור מט ומדפי עץ סכולרי שחור.",
    "company_name": "naturedesign",
    "original_category": "Bookcases",
    "price": 14759,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Nook HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/bookcases/50773-nook",
    "image_url": "../upload_images/naturedesign/Bookcases/Nook HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Bookcases/Nook HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Bookcases/Nook HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Bookcases/Nook HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Bookcases/Nook HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו\nספרייה מעץ מוקה אַשְׁחֵרָד",
    "company_name": "naturedesign",
    "original_category": "Bookcases",
    "price": 23216,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Random ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/bookcases/568055-random",
    "image_url": "../upload_images/naturedesign/Bookcases/Random ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Bookcases/Random ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Bookcases/Random ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Bookcases/Random ORIGIN COLLECTION/3.jpg"
    ],
    "description": "מדף ספרים אקראי עם מדפי עץ שחור מוחלט מסוג אש ומתכת בזהב לזור.",
    "company_name": "naturedesign",
    "original_category": "Bookcases",
    "price": 23373,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Random Kitchen ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/bookcases/567999-random-kitchen",
    "image_url": "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/4.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/5.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/6.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/7.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/8.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/9.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/10.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/11.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/12.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/13.jpg",
      "../upload_images/naturedesign/Bookcases/Random Kitchen ORIGIN COLLECTION/14.jpg"
    ],
    "description": "מטבח רנדום עם מדפי עץ טבעיים מסוג Secolare ומבנה מתכת בצבע ארד לוקסור.",
    "company_name": "naturedesign",
    "original_category": "Bookcases",
    "price": 25710,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Stem HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/bookcases/389247-stem",
    "image_url": "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/7.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/8.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/9.jpg",
      "../upload_images/naturedesign/Bookcases/Stem HOME COLLECTION/10.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nספריית סטם עושה שימוש באלמנטים ורסטיליים, אסתטיים ופונקציונליים המרחיבים את טווח הקומפוזיציה שלה, עם משקופים מעץ היוצרים חללים לחוות בחופש מוחלט. ניתן להשתמש בה כנגד קיר או במרכז החדר בגרסה הליניארית או המעוגלת שלה, ולתחום בעדינות את הסביבה באלגנטיות ובתחכום. מדפי זכוכית או עץ ומיכלים מעץ מעצימים את הקומפוזיציות, ומובילים לפתרונות אחסון נוספים ומקנים לספרייה פונקציונליות מרובה.  \nספרייה עם מבנה מעץ אפר מוקה ומתכת בגוון שמפניה ומדפים בזכוכית בצבע ברונזה.",
    "company_name": "naturedesign",
    "original_category": "Bookcases",
    "price": 16634,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Big flat ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/568244-living-plain",
    "image_url": "../upload_images/naturedesign/Complements/Big flat ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Big flat ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Big flat ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Big flat ORIGIN COLLECTION/3.jpg"
    ],
    "description": "עיצוב ND Lab דירה גדולה מעץ סכולרה טבעי.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 25509,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Cloud HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/389371-cloud",
    "image_url": "../upload_images/naturedesign/Complements/Cloud HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Cloud HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Cloud HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Cloud HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Cloud HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Complements/Cloud HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nעם הסגנון האדריכלי שלו, המבנה מעץ של מסך \"קלאוד\" מגדיר את החלל, מעניק לו חמימות וטבעיות, בעוד הצורה המעוגלת והרכה מוסיפה תחושת הרמוניה וזרימה. אובייקט זה, עם הסגנון המהותי שלו, עשוי ממבנה עץ ואינסרט קליעה ראטן, נותן לו נגיעה של אלגנטיות ופונקציונליות כמחיצת חלל.  \nמחיצה עם מבנה מעץ מילה שחור ואינסרט מקש וינה שחור.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 22106,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Dew HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/1998-dew",
    "image_url": "../upload_images/naturedesign/Complements/Dew HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Dew HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Dew HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Dew HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Dew HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nהצורות האמורפיות האורגניות של מראות ה-Dew שואבות השראה מהטבע, ומעניקות תחושת זרימה והרמוניה לחדרים שבהם הן ממוקמות. הן כוללות קצה מתכתי שמגדיר את האופי ומעניק להן נגיעה אמנותית מינימליסטית.  \nרכיב עם מראה ומסגרת ממתכת זהב לוקסור.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 24571,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Eclipse HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/50804-eclipse",
    "image_url": "../upload_images/naturedesign/Complements/Eclipse HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Eclipse HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Eclipse HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Eclipse HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Eclipse HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Complements/Eclipse HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Complements/Eclipse HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Complements/Eclipse HOME COLLECTION/7.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nהצורה הבסיסית והקווית של מראת ה-Eclipse מוקפת ומעוטרת בזכוכית טקסטורה אופיינית. אורות ה-LED מסביב להיקף יוצרים משחק קסום של אור והשתקפויות שמוסיפים אלגנטיות לסביבה ויוצרים אווירה ייחודית ומסתורית. מראה זו לא רק פונקציונלית, אלא גם אלמנט עיצובי שתופס את תשומת הלב ומשנה את החלל שבו היא ממוקמת.  \nמשלים עם מראה וזכוכית מבושלת בצבע ענבר.  \n",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 28833,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Lagoon HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/389331-lagoon",
    "image_url": "../upload_images/naturedesign/Complements/Lagoon HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Lagoon HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Lagoon HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Lagoon HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Lagoon HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Complements/Lagoon HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Complements/Lagoon HOME COLLECTION/6.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו שכבות המראות והזכוכית עם הטקסטורה שהולכות ומשתלבות הופכים את מראת הלגון לאובייקט דקורטיבי במיוחד. הלגון מורכבת משלושה חלקים: הראשון הוא מראה, השני הוא מראה ברונזה או מראה מעושנת, והשלישי הוא צורה מרכזית רכה חופפת עשויה מזכוכית עם טקסטורה, הזמינה בצבעים שונים. משלים עם מראה כסף, מראה ברונזה וזכוכית אפויה ברונזה.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 26814,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Line Living ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/1989-line-living",
    "image_url": "../upload_images/naturedesign/Complements/Line Living ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Line Living ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Line Living ORIGIN COLLECTION/2.jpg"
    ],
    "description": "Of course! Please provide the text you would like translated to Hebrew.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 22861,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Ovoo HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/50852-ovoo",
    "image_url": "../upload_images/naturedesign/Complements/Ovoo HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Ovoo HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Ovoo HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Ovoo HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Ovoo HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nשולחן הקפה הקרמי הזה מבדיל את עצמו במראה הייחודי שלו: הצורה הגלית והמפוסלת מועשרת בגימורים חומריים, מה שמעניק נגיעה יצירתית לחדר מגורים מודרני בעיצוב מינימליסטי. עם צורתו, הוא יכול להיות ממוקם ליד כיסא או לקשט פינת קריאה או כניסה, או שהוא יכול לשמש גם כהדום אלגנטי.  \nשולחן/שרפרף בצבע בז' חומרי",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 24119,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Pangea HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/389315-pangea",
    "image_url": "../upload_images/naturedesign/Complements/Pangea HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Pangea HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Pangea HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Pangea HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Pangea HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nהמראה של פנגיאה בעלת נפח רך שקולט ומשקף את הסביבה שמסביב, ומעניק לה נגיעה של טבע ותחכום. הקולקציה מכילה שני צורות בגדלים שונים, שכאשר משלבים אותן נוצר שלם מרתק ומשלים. זהו התוספת המושלמת לשיפור כל חלל בסגנון ואלגנטיות.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 10026,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Snack top ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/568148-snack-top",
    "image_url": "../upload_images/naturedesign/Complements/Snack top ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Snack top ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Snack top ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Snack top ORIGIN COLLECTION/3.jpg"
    ],
    "description": "מזנון טופ למדידה מעץ טבעי סקולארה.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 15008,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Soil HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/52192-soil",
    "image_url": "../upload_images/naturedesign/Complements/Soil HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Soil HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Soil HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Soil HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Soil HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב: ג'ינו קארולו  \nSoil, קומפוזיציה פיסולית של מיכלים המחוברים לקיר, משתלבת עם מאסטריות עיצובית ופונקציונליות. המיכלים, עשויים עץ, משרים חמימות טבעית ותחושת אותנטיות, ומוסיפים אלגנטיות אורגנית לחלל שמסביב. נוכחותם משדרת תחושת איזון והרמוניה, ויוצרת סביבה מזמינה ומעודנת.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 15011,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Sommelier ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/568120-sommelier",
    "image_url": "../upload_images/naturedesign/Complements/Sommelier ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Sommelier ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Sommelier ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Sommelier ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Sommelier ORIGIN COLLECTION/4.jpg"
    ],
    "description": "מעבדת עיצוב ND\nכוננית יין לקיר מדגם סומלייה מעץ סקלר טבעי.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 13328,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Willow ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/568188-willow",
    "image_url": "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/4.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/5.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/6.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/7.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/8.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/9.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/10.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/11.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/12.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/13.jpg",
      "../upload_images/naturedesign/Complements/Willow ORIGIN COLLECTION/14.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו\nשרפרף ווילואו עם בסיס מתכת חום ומושב מעץ סקולארה טבעי.",
    "company_name": "naturedesign",
    "original_category": "Complements",
    "price": 13723,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Dune HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sofas-and-armchairs/389185-dune",
    "image_url": "../upload_images/naturedesign/Sofas and armchairs/Dune HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sofas and armchairs/Dune HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nהספה המודולרית Dune מעוצבת כחיבוק רך ומזמין שאפשר להתרווח בתוכו בכל שעה של היום. היא מתבלטת בצורותיה המעוגלות והרכות שמעניקות לה מראה יפה והרמוני בהשראת הטבע עצמו. ניתן להתאים את הספה אישית על ידי שילוב סוגים שונים של מודולים בהתאם לצורך הספציפי בנוחות ובמרחב. הבסיס המעוקל מעץ מוסיף יציבות וחמימות, בעוד הכריות יכולות להיות מרופדות בבד, עור או נובוק.  \nספה בבד בוקלה B01",
    "company_name": "naturedesign",
    "original_category": "Sofas",
    "price": 17560,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Dune wood HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sofas-and-armchairs/389152-dune-wood",
    "image_url": "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/6.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/7.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/8.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/9.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Dune wood HOME COLLECTION/10.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nהספה המודולרית Dune תוכננה כחיבוק רך ומזמין שכיף לנוח בו בכל שעה של היום. היא בולטת בצורותיה הרכות והמעוגלות, המעניקות לה אווירה יפה והרמונית בהשראת הטבע עצמו. ניתן להתאים את הספה על ידי שילוב סוגים שונים של מודולים בהתאם לצורך הספציפי בנוחות ובמרחב. הבסיס העשוי עץ מעניק לה יציבות וחמימות, בעוד הכריות ניתנות לריפוד בבד, עור או נובוק.  \nספה בבד בוקלה B10, בסיס ושולחן בעץ אפר שחור מוחלט ופלטה משיש נרו אנטיקו.",
    "company_name": "naturedesign",
    "original_category": "Sofas",
    "price": 25643,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Pebble Lounge HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sofas-and-armchairs/1095-pebble-lounge",
    "image_url": "../upload_images/naturedesign/Sofas and armchairs/Pebble Lounge HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sofas and armchairs/Pebble Lounge HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Pebble Lounge HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Pebble Lounge HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Pebble Lounge HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו\nכורסאת Pebble משחקת עם האיזון בפרופורציות ובצורותיה. האלמנטים המרופדים בבד, עור או נובוק רכים ושופעים, מוכנים לקבל ולחבק, בעוד שהבסיס מעץ הופך אותה למתאימה להקשרים שונים ולרגעים שונים ביום, באזורי המגורים והחדרי השינה כאחד.\nבהשראת צורתו של אבן חלקה ששטפה מים, ה-Pebble Big Pouf מוסיף נגיעה של מקוריות ואישיות לאזור המגורים. הבסיס מעץ מחזיק כרית רכה מרופדת בבד, עור או נובוק.\nכורסה בבד בוקלה B01 ובסיס מעץ אגוז אמריקאי.",
    "company_name": "naturedesign",
    "original_category": "Armchairs",
    "price": 16174,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Pebble Pouf HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sofas-and-armchairs/1183-pebble-pouf",
    "image_url": "../upload_images/naturedesign/Sofas and armchairs/Pebble Pouf HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sofas and armchairs/Pebble Pouf HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Pebble Pouf HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Pebble Pouf HOME COLLECTION/3.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו\nפוף מבד בוקלה B01 ובסיס מעץ אגוז אמריקאי",
    "company_name": "naturedesign",
    "original_category": "Armchairs",
    "price": 27920,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Twig Lounge HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sofas-and-armchairs/388846-twig-lounge",
    "image_url": "../upload_images/naturedesign/Sofas and armchairs/Twig Lounge HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sofas and armchairs/Twig Lounge HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Twig Lounge HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Twig Lounge HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Twig Lounge HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Twig Lounge HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nכיסא הטוויג משלב קווים מעוגלים, עדינות וצורות מזמינות עם רגע של שלווה מוחלטת. מצטרף לאוסף כיסאות נוחים אך מתוחכמים בעלי אישיות חזקה וגימורים בהתאמה אישית מבד, עור או נובוק, הוא יכול להשתלב בצורה מושלמת בכל סביבה. עם בסיס העץ, הכורסה הקלאסית הופכת לאובייקט מרגיע של פנאי.  \nכורסה עם בסיס מעץ אפר בגוון אגוז ובד בוקלה B02",
    "company_name": "naturedesign",
    "original_category": "Armchairs",
    "price": 24095,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Twig Rocking Chair HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/sofas-and-armchairs/388825-twig-rocking-chair",
    "image_url": "../upload_images/naturedesign/Sofas and armchairs/Twig Rocking Chair HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Sofas and armchairs/Twig Rocking Chair HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Twig Rocking Chair HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Twig Rocking Chair HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Sofas and armchairs/Twig Rocking Chair HOME COLLECTION/4.jpg"
    ],
    "description": "עיצוב: ג'ינו קארולו הכיסא המתנדנד Twig מבטא את ערכי המסורת תוך שהוא לבוש במפתח מקורי ועכשווי. בסיס העץ המוצק, אלמנט ייחודי המשדר עמידות וקרקוע, משתלב עם הקווים הרכים של המושב והגב בבד, עור או נובוק, ומקבל את פני האורחים עם קווים מרגיעים. כורסה עם בסיס מעץ מילה בגוון אגוז ובד בוקלה B09.",
    "company_name": "naturedesign",
    "original_category": "Armchairs",
    "price": 28890,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Lily HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/beds/390561-lily",
    "image_url": "../upload_images/naturedesign/Beds/Lily HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Beds/Lily HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Beds/Lily HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Beds/Lily HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Beds/Lily HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Beds/Lily HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב: ג'ינו קרולו  \nהקווים הרכים והנוחים של מיטת לילי מעניקים לכל חדר שינה חמימות ואינטימיות. הצורה הרכה של בסיס העץ והקוים המתפתלים של משענת הראש המרופדת הופכים אותה לא רק לרהיט, אלא גם לחוויה חושית הלוכדת את הדמיון ומזמינה לרווחה. הריפוד זמין בעור, נובוק או בד.  \nמיטה מבד בוקלה B01 ומבנה מעץ מילה בגימור אגוז.",
    "company_name": "naturedesign",
    "original_category": "Beds",
    "price": 20866,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Archi-lamp ORIGIN COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/568290-archi-lamp",
    "image_url": "../upload_images/naturedesign/Complements/Archi-lamp ORIGIN COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Archi-lamp ORIGIN COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Archi-lamp ORIGIN COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Archi-lamp ORIGIN COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Archi-lamp ORIGIN COLLECTION/4.jpg"
    ],
    "description": "עיצוב ND Lab\nמנורת Archi בעץ Secolare טבעי ובסיס מתכת חום.",
    "company_name": "naturedesign",
    "original_category": "Lightning",
    "price": 14598,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Blur coffee table HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/389442-blur-coffee-table",
    "image_url": "../upload_images/naturedesign/Complements/Blur coffee table HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Blur coffee table HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Blur coffee table HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Blur coffee table HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Blur coffee table HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Complements/Blur coffee table HOME COLLECTION/5.jpg",
      "../upload_images/naturedesign/Complements/Blur coffee table HOME COLLECTION/6.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nהעדינות של הקימורים והצורות הרכות של שולחן בלר הופכת לרהיטים חדשים לסביבת המגורים. עם הזכוכית במרקם המיוחדת שמסננת אור, שולחנות הקצה בלר הופכים לחפצים דקורטיביים של ממש.  \nשולחנות צד מזכוכית בצבע ענבר.",
    "company_name": "naturedesign",
    "original_category": "Coffee Tables",
    "price": 14573,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Drop HOME COLLECTION": {
    "product_url": "https://naturedesign.com/en/products/complements/2031-drop",
    "image_url": "../upload_images/naturedesign/Complements/Drop HOME COLLECTION/main.jpg",
    "image_urls": [
      "../upload_images/naturedesign/Complements/Drop HOME COLLECTION/1.jpg",
      "../upload_images/naturedesign/Complements/Drop HOME COLLECTION/2.jpg",
      "../upload_images/naturedesign/Complements/Drop HOME COLLECTION/3.jpg",
      "../upload_images/naturedesign/Complements/Drop HOME COLLECTION/4.jpg",
      "../upload_images/naturedesign/Complements/Drop HOME COLLECTION/5.jpg"
    ],
    "description": "עיצוב ג'ינו קרולו  \nקווים חיוניים מעניקים לשולחן הצד דרופ אלגנטיות נצחית, בעוד שהצורה האמורפית של החלק העליון מוסיפה נופך של דינמיקה ותנועה. הבסיס עשוי מתכת והמבנה עשוי עץ, בעוד שהחלק העליון מגיע בזכוכית, קרמיקה או שיש. השילוב הזה של חומרים טבעיים וצורות אורגניות יוצר ניגוד מרתק שתופס את תשומת הלב.  \nשולחן עם משטח עליון משיש נרו אנטיקו, מבנה מעץ אפר שחור מוחלט ובסיס ממתכת בטיטניום לוקסור.",
    "company_name": "naturedesign",
    "original_category": "Coffee Tables",
    "price": 16771,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Ama Grand Pouf": {
    "description": "אמא גרנד פוף, תחושה מאוד נוחה הניתנת על ידי הריפוד הנדיב והפרטים המעודנים שמרככים את הגיאומטריות. בעקבות ההצלחה של הספה, משפחת אמא מקבלת גם מושבים מרופדים אחרים כמו הברגרה, הגרנד פוף, העות'מאני וגרסה מודולרית עם מודולים מעוגלים לספה באותו שם. אוסף מושבי אמא מתאפיין באסימטריות הנוצרות על ידי הגבהים והעומקים השונים של הרכיבים, החדר אכן מופעל על ידי דינמיות לא מצופה ודרמטית.\n\nחומרים:\nמבנה: עץ\nריפוד: בדים פנימיים\n\nגימורים:\nריפוד: בדים קטגוריה עליונה, דלוקס, ידידותיים לסביבה\nעור TOP, עור בקר, נובוק\nמידות: אורך 140×140; גובה 37 ס\"מ\nגלה את כל משפחת אמא: ספת אמא, מודולרית אמא, כורסת אמא, עות'מאני אמא, ברגרה אמא",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Ama Grand Pouf/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Ama Grand Pouf/1.png",
      "../upload_images/PaoloCasteli/Sofas/Ama Grand Pouf/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Grand Pouf/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/ama-grand-pouf/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 15902,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Ama Modular Sofa": {
    "description": "אמה מודולרי, תחושה נוחה מאוד שנוצרת על ידי הריפודים הנדיבים והפרטים המתוחכמים שמרככים את הגיאומטריות. בעקבות הצלחת הספה, משפחת אמה מקבלת בברכה מושבים מרופדים נוספים כגון הביז'רה, הגרנד פוף, העות'מאני, והגרסה המודולרית גם עם מודולים מעוקלים של הספה הנושאת אותו שם. אוסף הישיבה אמה מאופיין באסימטריות שנוצרות על ידי גבהים ועומקים שונים של האלמנטים הקומפוזיציוניים, החדר מתמלא בדינמיקה בלתי צפויה ובעלת תפאורה מרהיבה.\n\nחומרים:\nמבנה: עץ\nריפוד: חומרים פנימיים\n\nגימורים:\nעור: עור אנלין, נובוק\n\nבדים:\nסופר: לוק שניל, ביר שניל, פשתן מעורב, שיפלנד\nדה-לוקס: שניל, צמר בוקלה\nמידות: אורך 114 ס\"מ, רוחב 241 ס\"מ; גובה 73/40 ס\"מ\n\nגלו את כל משפחת אמה: ספת אמה, ביז'רה אמה, כורסא אמה, עות'מאני אמה, גרנד פוף אמה.",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/8.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/9.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Modular Sofa/10.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/ama-modular/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 11969,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Ama Sofa": {
    "description": "אמה היא קולקציית ישיבה מרופדת הכוללת ספות וכורסאות רכות ומציפות עם מראה דקו. הצורה היא באמת מקורית, מאחר שהיא מתאפיינת באסימטריות קומפוזיציונית הנובעת מהגובה השונה של האלמנטים הקומפוזיציוניים. המראה הכולל הוא מאוד סצינאי ונוצץ, ומספק אפילו את הקהל הצעיר ביותר, מבלי לאבד את האלגנטיות שמאפיינת את הקולקציה שהיא חלק ממנה.\nהספות והכורסה כוללות שלדת עץ מלא מחוזקת בשכבות מרובות וריפוד פוליאוריתן עשיר עם כיסוי סיבי פוליאסטר וביטנה מכותנה. הרגליים, שהן מעט נראות, עשויות מעץ אש כהה מוכתם.\nמידות:\nספת תלת מושבית: רוחב 280 ס\"מ x עומק 95 ס\"מ x גובה 75/40 ס\"מ\nקומפוזיציה של ספה עם שזלונג: רוחב 391 ס\"מ x עומק 104/65 ס\"מ x גובה 75/40 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Ama Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/8.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/9.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/10.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Sofa/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/ama/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 22435,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Coral Sofa": {
    "description": "ספת קורל, צורות נדיבות ושופעות לסדרה של פריטי ריהוט מרופדים עם עיצוב שנראה כמו ענן נוח. המבנה המונוליטי נעים לעין, בזכות החלוקה הלא שגרתית של האלמנטים הבודדים שמרכיבים את השלם: משענת גב, משענות ידיים ומושב, שנראים כמו אלמנטים טבעיים שעוצבו על ידי הזמן. ספה תלת-מושבית עם ריפוד עשוי פוליאוריתן ביולוגי המכוסה במילוי טבעי ורשת יוטה. כיסוי שאינו ניתן להסרה. בסיס עץ מעץ מילה בגימור אצטיקי.\nמידות:\nרוחב 275 x עומק 106 x גובה 75/40 ס\"מ\nגלו את משפחת קורל: כורסא קורל",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Coral Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Coral Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Coral Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Coral Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Coral Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Coral Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Coral Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Coral Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Coral Sofa/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/coral-sofa/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 28497,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Elegance Soft Sofa": {
    "description": "ספת ה-Elegance Soft מחדשת את צורותיה, ומציגה עצמה כבמה עכשווית חדשה המוקדשת לקונביוויאליות טהורה. ספה הניצבת על הרצפה, נוחה ורכה המציגה צורות מפוסלות, המוגדרות על ידי סגנון לינארי ורפוי. הפרופורציות המאוזנות והגיאומטריה המחמירה של המבנה המרופד מקדמות כריות ישיבה נדיבות, גב נמוך ומשענות יד לאורך מלא, מרופדות בפוליאוריתן בצפיפות שונה עטוף בכדוריות מיקרופייבר, המציעות את הנוחות של מערכת ישיבה עם צורות רכות, פשוטות ומאוד מזמינות. הבסיס שלה עשוי עץ מכוסה בעור למינציה ברונזה, בניגוד לרגליים העשויות מבוק מוכתם בשחור מט. עם גודל, פרופורציות ועומק ישיבה חדשים להשגת תוצאה קלאסית יותר, ספה זו מסוגלת להציע פתרונות ריהוט מגוונים המתאימים לצרכים המשתנים של עולם המגורים.\nממדים:\nאורך: 275; גובה: 85; עומק: 110; גובה מושב: 44 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Elegance Soft Sofa/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/elegance-soft-sofa/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 27312,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Fenpei Modular Outdoor Sofa": {
    "description": "אסתטיקה משתלבת עם פונקציונליות, וכך נוצרת השילוב המושלם בין צורה וטבע דרך סינתזה הרמונית של \"פנים\" ו\"חוץ\". פנסי מספקת גם ריהוט לחללים חיצוניים בעבודת אומן עדינה ותעוזה של מערכת גמישה המורכבת ממודולים שהופכים לאיים רכים ונעימים של יוקרה. כל מודול מוגדר על ידי תפר שאינו במרכז, מה שמביא להפרדת המושב ומשענות הגב לשני חלקים עם צבעים מנוגדים, ויוצר משחק צבעים עם השפעה גרפית חזקה. המושבים ומשענות הגב מתמזגים יחד לפתרון מודולרי קל להרכבה המורכב מאלמנטים רכים, מרופדים בפוליאוריתן בצפיפות משתנה עטוף בנוצת מיקרופייבר ומכוסה בבד דוחה מים, אשר מתחלפים בין ארבעה מושבים ושתי משענות גב זמינות. משענות הגב המאוזנות ניתנות למיקום חופשי או לעיגון למושבים בזכות צפרדע במבוק פונקציונלית ומעודנת שמציבה את ארבעת משענות הגב על ידי חיבור תחרת עור הממוקמת על המושב. הבסיס המתכתי, עם גימור אפוקסי ברונזה מט, תומך בנפח הכללי, ומדגיש שוב את תחושת הקלות המדהימה. איזון שמבטיח נוחות מירבית ומתאים לכל סביבה, בין אם קלאסית או עכשווית, בתוך הבית או מחוצה לו.\n\nמידות:\nפוף: ר: 106; ג: 43; ע: 106 ס\"מ\nשזלונג: ר: 106; ג: 43; ע: 171 ס\"מ\nטרפז: ר: 106; ג: 43; ע: 102 ס\"מ\nפוף קטן: ר: 106; ג: 43; ע: 65 ס\"מ\nמשענת גב לינארית: ר: 102; ג: 32; ע: 30 ס\"מ\nמשענת גב זוויתית: ר: 102; ג: 32; ע: 102 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Outdoor Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Outdoor Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Outdoor Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Outdoor Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Outdoor Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Outdoor Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Outdoor Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Outdoor Sofa/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/fenpei-modular-outdoor/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 11496,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Fenpei Modular Sofa": {
    "description": "דרך חדשה לחוות קוניביאליות שמשקפת את הפירושים הדינמיים ביותר של החלל, במודעות מלאה להתפתחויות המתמשכות שמתרחשות בעולם הריהוט. \"פנפיי\" מרהטת חדרים עם עבודות יד משובחות ותעוזה של מערכת גמישה המורכבת ממודולים שהופכים לאיים רכים ומזמינים של יוקרה. כל מודול מוגדר לפי תפר לא מרכזי שמביא לחלוקת המושב ואת גב המושב לשני חלקים בצבעים מנוגדים, כך שנוצרת משחק צבעים בעל השפעה גרפית חזקה. המושבים וגב המושבים מתמזגים לפתרון מודולרי קליל המורכב ממרכיבים רכים ומרופדים מפוליאוריתן בצפיפות משתנה שעוטפים במיקרופייבר מסיבים במילוי פלאמטים שמתחלפים בין ארבעת אפשרויות המושב ושני אפשרויות הגב הזמינות. גב המושבים הנגדיים יכולים להיות ממוקמים בחופשיות או מעוגנים למושבים הודות לצפרדע במבוק פונקציונלית ומעוצבת שמחברת את ארבעת גב המושבים באמצעות שרוך עור הממוקם על המושב. הבסיס המתכתי, הכולל גימור אפוקסי ברונזה מט, תומך בנפח הכללי ובכך מדגיש שוב את תחושת הקלילות המרשימה. איזון שמבטיח נוחות מקסימלית ומתאים לכל סביבה, בין אם קלאסית או עכשווית.\n\nמימדים:\nפוּף: ר': 106; ג': 43; ע': 106 ס\"מ\nצ'ס לונג: ר': 106; ג': 43; ע': 171 ס\"מ\nטרפז: ר': 106; ג': 43; ע': 102 ס\"מ\nפוּף קטן: ר': 106; ג': 43; ע': 65 ס\"מ\nגב מושב ישר: ר': 102; ג': 32; ע': 30 ס\"מ\nגב מושב זוויתי: ר': 102; ג': 32; ע': 102 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/8.jpg",
      "../upload_images/PaoloCasteli/Sofas/Fenpei Modular Sofa/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/fenpei-modular/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 15084,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor"
  },
  "Imane Sofa": {
    "description": "כורסאות איאן – קו חוץ\nIMANE היא הקולקציה החדשה של מושבים מרופדים ושולחנות קפה לשימוש חיצוני, שעוצבו על ידי תיירי למאיר, הוברט דה מאלרב ופאולו קסטלי. עשויה מחומרים טבעיים ובאומנות ידנית לפרטים הקטנים ביותר, IMANE היא חלק מפרויקט GREENKISS הרחב יותר, הכולל את האוספים של החברה בעלי נשמה ירוקה.\n\nהכורסאות והספה של Imane מאופיינות במבנה לינארי מעץ איארו מוצק מוברש ומוכתם בשמן טבעי, עם מראה מעודן ואקזוטי. טבעה העמיד במיוחד של עץ איארו, שמתעצם לאחר תהליך היישון, עושה את העץ הזה מתאים במיוחד לתנאי חוץ.\n\nמבנה:\nעץ איארו מוצק, מוברש ומוכתם בשמן טבעי.\n\nכריות מושב:\nפוליאוריתן מעוצב בצפיפות משתנה.\n\nכריות גב:\nכריות גב מחומר פוליאסטר עם תוספת של פרספקס.\n\nהכריות מכוסות בבד סיבי פוליאסטר דוחה מים במגוון מרקמים וצבעים, כל אלה מיועדים לשימוש חוץ.\n\nספה תלת מושבית:\nמידות: רוחב - 285 ס\"מ; עומק - 65 ס\"מ; גובה - 40/78 ס\"מ.\n\nספה דו מושבית:\nמידות: רוחב - 196 ס\"מ; עומק - 65 ס\"מ; גובה - 40/78 ס\"מ.\n\nגלה את כל משפחת Imane: כורסאת Imane, מיטת יום Imane, כיסא Imane, שולחן Imane, שולחן קפה Imane.",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Imane Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Imane Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Imane Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Imane Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Imane Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Imane Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Imane Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Imane Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Imane Sofa/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/imane-sofa/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 26400,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ipanema Sofa": {
    "description": "ספת איפנמה מפרשת, דרך קווים מדויקים אך עדינים ולעולם לא נוקשים, את הנוחות המקסימלית. המבנה - עשוי ממסגרת מתכת בגימור ניקל סאטן שחור מט וזהב מבריק לרגליים - מכיל כריות מלאות ומושבים רכים עשויים מסיב פוליאסטר עם תוספת בחומר שאינו מתעוות בצפיפויות שונות. כריות הגב והמושבים עשויים מפוליאוריתן עם כיסוי סיב פוליאסטר כדי להבטיח תמיכה מיטבית ולהיות רכים ומזמינים באותה מידה. לנוחות נוספת, הכריות מכילות גם מילוי נוסף מנוצות אווז מעוקרות. כל הכריות והמושבים נשלפים.\n\nמידות:\nספת איפנמה 3 מושבים: אורך 275 ס\"מ; עומק 100 ס\"מ; גובה 38 / 75 ס\"מ\nספת איפנמה 2 מושבים: אורך 209 ס\"מ; עומק 100 ס\"מ; גובה 38 / 75 ס\"מ\n",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/8.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/9.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/10.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/11.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/12.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/13.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/14.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/15.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ipanema Sofa/16.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/ipanema-sofa/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 19924,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Lemma Sofa": {
    "description": "הכתובית המעוצבת מעץ כוללת מערכת מתלית של רצועות אלסטיות, עם מילוי פוליאוריתן מורחב בצפיפות שונה. הבסיס שלה עשוי מעץ המכוסה באותם חומרים. הכיסוי הלא-ניתן להסרה יכול להיות מותאם אישית עם בד קטיפה רך וכריות דקורטיביות. הגב יכול להיות מרופד בצבע מנוגד ואפילו עם בדים דקורטיביים. הריפוד נעשה עם צינור תואם שמקשט ומשדרג את קו הספה.\nמידות:\nרוחב: 280 ס\"מ\nעומק: 187 ס\"מ\nגובה: 82/42 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Lemma Sofa/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/lemma-sofa/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 10926,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Soft Ratio Sofa": {
    "description": "יחס רך הוא מערכת ישיבה מודולרית עם 11 אלמנטים ליניאריים, פינתיים או חצי אי שמשתלבים כדי ליצור מגוון קומבינציות. מושבי הגב וכריות הגב אינם ניתנים להסרה, ועשויים מקצף פוליאוריטן בצפיפויות שונות. במודול השזלונג עם שולחן קפה משולב, המשטח העליון עשוי מטרוורטין.\nמידות:\n\nSoft Ratio Modular M | L : צרו קשר עם המותג לבקשת אפשרויות תצורה",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/8.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/9.png",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/10.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/11.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/12.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/13.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/14.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/15.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/16.jpg",
      "../upload_images/PaoloCasteli/Sofas/Soft Ratio Sofa/17.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/soft-ratio-sofa/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 12657,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Vao 250 Sofa": {
    "description": "ספת Vao 250, ספה עם קווים מעוגלים היטב הנתמכת על ידי מבנה עם רגליים עשויות אש מוצק ידידותי לסביבה שנתזבוז עם גימור אצטתי, אשר הליקויים שלו מעניקים לו מראה אסתטי מובהק. במידת הבקשה המבנה כולל תוסף בד דקורטיבי עשוי מסיב עלה בננה.\nהריפוד עשוי מפוליאוריתן ביולוגי, ריפוד פנימי עשוי מריפוד טבעי ורצועות עשויות מיוטה. מרופדת בצמר בוקלה טבעי, בד מעורבב עם פשתן או פשתן. כיסוי לא נשלף.\nמידות:\nרוחב 250 x עומק 109/65 x גובה 74/40 ס\"מ\nגלה את משפחת Vao: מיטת Vao, ספת Vao 380, כורסה זוגית Vao 150, כיסא Vao, פוף Vao",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/8.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/9.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/10.png",
      "../upload_images/PaoloCasteli/Sofas/Vao 250 Sofa/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/vao-sofa-250/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 20718,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Vao 380 Sofa": {
    "description": "ספת ואו 380, ספה בת שלושה מושבים עם צורה מתעקלת ומידות גדולות, נתמכת על ידי מבנה עם רגליים עשויות מאש מוצק שנזרק וידידותי לסביבה עם גימור אצטטי, אשר גווניו מעניקים לה מראה אסתטי מרשים. ריפוד עשוי מפוליאוריתן ביולוגי, מילוי עשוי מצמר טבעי ורצועות עשויות מיוטה. כיסוי לא ניתן להסרה.\nמידות:\nרוחב. 380 ס\"מ x עומק. 187 ס\"מ x גובה. 80/40 ס\"מ\nגלו את משפחת ואו: מיטת ואו, ספת ואו 250, כורסת אהבה ואו 150, כורסת ואו, פוף ואו.",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/7.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/8.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/9.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/10.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/11.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/12.png",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/13.png",
      "../upload_images/PaoloCasteli/Sofas/Vao 380 Sofa/14.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/vao-380-sofa/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 29451,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Vao Love Seat 150": {
    "description": "כיסא אוהבים Vao 150, ספה עם קווים מעוגלים הנתמכת על ידי מבנה עם רגליים עשויות מעץ אש מוצק עם גימור אצטטי, שלו הפגמים מעניקים לו מראה אסתטי מרשים. לפי בקשה ניתן להוסיף למבנה תוספת דקורטיבית מבד סיבי עלי בננה.\n\nהריפוד נעשה מפוליאוריתן ביולוגי, המילוי עשוי מצמר טבעי, והרצועות עשויות מיוטה. מרופדת בצמר בוקלה טבעי, בד מעורב עם פשתן או פשתן. אין כיסוי ניתן להסרה.\n\nמידות:\nאורך: 150 ס\"מ x עומק: 81 ס\"מ x גובה: 73/40 ס\"מ\n\nגלה את משפחת Vao: מיטת Vao, ספת Vao 380, ספת Vao 250, כיסא Vao, פוף Vao",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Vao Love Seat 150/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Vao Love Seat 150/1.png",
      "../upload_images/PaoloCasteli/Sofas/Vao Love Seat 150/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao Love Seat 150/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao Love Seat 150/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao Love Seat 150/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao Love Seat 150/6.jpeg",
      "../upload_images/PaoloCasteli/Sofas/Vao Love Seat 150/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/vao-love-seat-150/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 28390,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Vao Pouf": {
    "description": "ואו פוף, פוף עם קווים מעוגלים היטב, עם רגליים עשויות מאפר מוצק וידידותי לסביבה עם גימור אצטטי, שפגמיו מעניקים לו מראה אסתטי מרשים. הריפוד עשוי גומי ידידותי לסביבה וכבה מאליו, המילוי עשוי מצמר טבעי, והרתמות עשויות מג'וט. כיסוי לא ניתן להסרה. \nמידות:\nקוטר 100 x גובה 40 ס\"מ\nגלה את משפחת Vao: מיטת Vao, ספת Vao 380, ספת Vao 250, כורסת אהבה Vao 150, כורסת Vao",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Vao Pouf/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Vao Pouf/1.png",
      "../upload_images/PaoloCasteli/Sofas/Vao Pouf/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao Pouf/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao Pouf/4.png",
      "../upload_images/PaoloCasteli/Sofas/Vao Pouf/5.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao Pouf/6.jpg",
      "../upload_images/PaoloCasteli/Sofas/Vao Pouf/7.jpeg",
      "../upload_images/PaoloCasteli/Sofas/Vao Pouf/8.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/vao-pouf/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 24151,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Venice Sofa": {
    "description": "ספת ונציה היא ספה קטנה ומרופדת עם עיצוב רך שמקנה לה מראה אידיאלי לכל חלל מגורים עכשווי.\nהמבנה שלה עשוי מעץ רב-שכבתי מעוקם המורופד בפוליאוריתן בצפיפות שונה. הכיסוי שלה, שאינו ניתן להסרה, ניתן להתאמה אישית במגוון רחב של בדים אלגנטיים, עור עדין ונובוק. בסיס הספה עשוי מעץ בז' מצופה בצבע מתכת פנינה Ral 1035.\nמידות: ר 150 x ע 66 x ג 70/40 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Venice Sofa/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Venice Sofa/1.png",
      "../upload_images/PaoloCasteli/Sofas/Venice Sofa/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Venice Sofa/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Venice Sofa/4.jpg",
      "../upload_images/PaoloCasteli/Sofas/Venice Sofa/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/venice-sofa/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 19378,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Ama Dormeuse": {
    "description": "אמה דורמוזה  \nאמה היא קולקציית ישיבה מרופדת המורכבת מספות וכורסאות רכות ועוטפות עם מראה דקו. הצורה היא ייחודית באמת, שכן היא מאופיינת באסימטריות קומפוזיציונית הנובעת מהבדלי הגובה של האלמנטים המרכיבים. המראה הכללי הוא מרהיב ונוצץ, מה שמספק גם את הקהל הצעיר ביותר, מבלי לאבד את האלגנטיות שמאפיינת את הקולקציה אליה היא שייכת. לספות ולכורסה יש מסגרת עץ קשיח רב-שכבתית מחוזקת וריפוד פוליאוריתן מלא עם כיסוי סיבי פוליאסטר ובטנת כותנה. הרגליים הנראות מעט עשויות מעץ אש כהה.\nמידות:\nאורך 264 ס\"מ x עומק 95/65 ס\"מ x גובה 75/56/40 ס\"מ\nגלה את כל משפחת אמה: ספת אמה, ספת אמה מודולרית, כורסת אמה, אמה ברג'רה, הדום אמה, אמה פאף גדול.",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Ama Dormeuse/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Ama Dormeuse/1.png",
      "../upload_images/PaoloCasteli/Sofas/Ama Dormeuse/2.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Dormeuse/3.jpg",
      "../upload_images/PaoloCasteli/Sofas/Ama Dormeuse/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/ama-dormeuse/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 20480,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Ama Daybed Large": {
    "description": "אמא דייבד גדול\nאמא היא אוסף ישיבה מרופד הכולל ספות וכורסאות רכות ומחבקות עם מראה דקו. הצורה באמת מקורית, שכן היא מאופיינת בא-סימטריות קומפוזיציונית הנובעת מגבהים שונים של האלמנטים המרכיבים. הכלל הינו בימתי ומרהיב ביותר, ומספק גם לקהל הצעיר יותר, מבלי לאבד מהאלגנטיות שמייחדת את האוסף בו הוא חלק.\nלספות ולכורסאות יש מסגרת עץ מלא רב-שכבתית מחוזקת וריפוד פוליאוריתן מלא עם כיסוי סיבים פוליאסטר ובטנה כותנה. הרגליים, הנראות מעט, עשויות מעץ לבוד צבוע כהה.\nמידות:\nאורך 264 ס\"מ x עומק 95/65 ס\"מ x גובה 75/56/40 ס\"מ\nגלה את כל משפחת אמא: אמא ספה, אמא ספה מודולרית, אמא כורסה, אמא ברגר, אמאּ הדום, אמא פוף גדול, אמא דורסי.",
    "image_url": "../upload_images/PaoloCasteli/Sofas/Ama Daybed Large/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Sofas/Ama Daybed Large/1.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/sofas/ama-daybed-large/",
    "company_name": "Paolo Casteli",
    "original_category": "Sofas",
    "price": 22976,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Audrey Chair": {
    "description": "כיסא אודרי, קווים רכים וזורמים הם המאפיינים הבולטים של כיסא זה, שעוצב להביא אלגנטיות לאזור האוכל תוך מתן נוחות מקסימלית בו זמנית. לכיסא מבנה מעץ אשור, מרופד בפוליאוריטן מוקצף בצפיפויות שונות, ומכוסה מבפנים ב-100% כותנה ופוליאסטר. הריפוד ניתן להתאמה אישית בבחירת בד אלגנטי, עור משובח או נובוק; הרגליים עשויות מעץ אשור וצבועות בזהב מט. כיסוי שאינו ניתן להסרה.\n\nמידות: ר' 51 ס\"מ x ע' 61 ס\"מ x ג' 90 ס\"מ\nמידות עם ידיות: ר' 54 ס\"מ x ע' 61 ס\"מ x ג' 90 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Audrey Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/7.png",
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/8.jpg",
      "../upload_images/PaoloCasteli/Seating/Audrey Chair/9.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/audrey/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 17964,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Echo Barstool": {
    "description": "כסא ברסטול גבוה ונמוך Echo, הצהרת אהבה לבולוניה, משפחה של כיסאות בעלי נשמה רומנטית המאפיינת את משענות הגב המקושתות שלהן כמחווה לארקדות המפורסמות של העיר. Echo הוא אוסף עם פרופורציות מדודות שמובלט על ידי הניגוד בין המבנה המינימליסטי בעץ מכופף ובין הצורות הנדיבות של האלמנטים המרופדים. הכיסא, המוצע בשני גבהים שונים, מהווה תוספת מעניינת לקטלוג, פתרון אידיאלי עם השפעה ויזואלית רבה המסוגל לרהט גם חללים פרטיים וגם חללים יוקרתיים ומסחריים.\n\nחומרים:\nמבנה: עץ\nריפוד: בדים פנימיים\n\nגימורים:\nמבנה: עץ אש שחור\nריפוד: בדי קטגוריה מעולה, יוקרתיים, ידידותיים לסביבה. עור TOP, עור בקר, נובוק\n\nמידות:\nEcho גבוה L. 49X53; H.105 ס\"מ; Echo נמוך L. 49X53; H.95 ס\"מ\n\nגלו את כל משפחת Echo: כסא Echo",
    "image_url": "../upload_images/PaoloCasteli/Seating/Echo Barstool/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Echo Barstool/1.png",
      "../upload_images/PaoloCasteli/Seating/Echo Barstool/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Echo Barstool/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Echo Barstool/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/echo-barstool/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 18397,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Echo Chair": {
    "description": "כיסא קלאסי בגודל נוח עם צורות זורמות שמזמינות שיחות נעימות. מסגרת מעץ לבוד מעוקלת עם רגליים מחודדות באשור מוכתם כהה, מרופדת בפוליאוריתן מורחב בצפיפות שונה. משענת הגב, מרופדת בתבנית קשתות, מזכירה את הפרספקטיבה המרתקת של אכסדרות בולוניה. הכיסויים זמינים בבד אלגנטי, בעורות משובחים או בנאבוק. הכיסוי אינו ניתן להסרה.\nמידות:\nאורך 51 x רוחב 61 x גובה 90 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Echo Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Echo Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Echo Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Echo Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Echo Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Echo Chair/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/echo/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 20670,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Enso Chair": {
    "description": "כיסא Enso, חזרה למהות העיצוב, מושב שמחדש רהיט קלאסי הודות לשילוב של צורות גאומטריות פשוטות המשופרות בבחירות צבעים וטקסטורות מנוגדות.\nמורכב ממסגרת עץ גלויה, הכיסא Enso משתמש בחפיפת עיגולים מכויילת, שממנה נובע שמו, כמשענת גב, מה שהופך אותו להצעה מרתקת לחללים מגורים ומסחריים עם טעם מעודן. הכיסא Enso הוא מושב בעיצוב מחבק המבטא את תשומת הלב של החברה לכל פרט קטן.\nחומרים\nמבנה: עץ\nריפוד: בדים פנימיים\nגימורים\nמבנה: עץ מוכה אגוז\nריפוד: בדים קטגוריה עליונה, Deluxe, Eco-Friendly\nעור TOP, עור בקר, נובוק\n\nמידות: L. 56×62; H. 67/82/49 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Enso Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Enso Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/7.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/8.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/9.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/10.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/11.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/12.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/13.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/14.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/15.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/16.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/17.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/18.jpg",
      "../upload_images/PaoloCasteli/Seating/Enso Chair/19.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/enso-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 18816,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Giano Chair": {
    "description": "ג'יאנו, דואליות ונוחות\nכיסא המשלב נוחות וארגונומיה עם משחק גראפי של קווים דינמיים, המחדש בצורות ובפרטים זעירים רהיט שמסוגל להעשיר סביבות המוגדרות באסתטיקה נצחית. בהשראת המיתוס העתיק של האל בעל שתי הפנים, ג'יאנו מפרש בקלילות מושב קלאסי עם מסגרת עץ, המוגדר על ידי הפגישה הנראית של שתי הרגליים האחוריות בחלק האמצעי, המתארכות לכיוון המשענת כדי לקבוע את החלוקה המושלמת שלה לשני אלמנטים תאומים. בנוסף לעיצוב המיוחד של המשענת, הדואליות של ג'יאנו מתגלה בשתי הגרסאות הזמינות, עם מסגרות מעץ אש מוכתּם אגוז או מוכתּם שחור. המושב והמשענת מרופדים ויכולים להיות מכוסים בבחירה רחבה של בדים פנימיים מתוך הקטלוג.\nמידות:\nרוחב: 54 ס\"מ; גובה: 80 ס\"מ; עומק: 53 ס\"מ; גובה מושב: 46 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Giano Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Giano Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/7.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/8.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/9.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/10.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/11.jpg",
      "../upload_images/PaoloCasteli/Seating/Giano Chair/12.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/giano-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 25344,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Gio Chair": {
    "description": "כיסא ג'יו, כיסא אוכל עשוי כולו מעץ מילה מלא וידידותי לסביבה, זמין בשלוש אפשרויות: מילה טבעי עם גימור אצטטי, בגרסה הלבנה או בגרסה מוכתמת אגוז עם גימור נקבובית פתוחה. בתהליך זה, הנקבוביות של העץ נשארות פתוחות בכוונה, מה שמאפשר לעץ לשמור על המראה הטבעי שלו.\nמידות:\nרוחב 38 ס\"מ x עומק 51 ס\"מ x גובה 87/46 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Gio Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Gio Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/6.png",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/7.png",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/8.jpg",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/9.jpg",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/10.jpg",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/11.jpg",
      "../upload_images/PaoloCasteli/Seating/Gio Chair/12.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/gio-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 17025,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Imane Chair": {
    "description": "אימאן כסא – קו חוץ\nIMANE היא קולקציה חדשה של כיסאות מרופדים ושולחנות קפה לשימוש חיצוני, שתוכננו על ידי טיירי למייר, הוברט דה מאלרב ופאולו קסטלי. עשויה מחומרים טבעיים ומעוצבת בעבודת יד עד לפרטים הקטנים ביותר, היא חלק מפרויקט GREENKISS הרחב, הכולל את הקולקציות הירוקות של החברה.\nהספות וכיסא האימאן מאופיינים במבנה לינארי מעץ איפאה מלא מוברש ומוכתם בשמן טבעי, עם מראה מעודן ומהותי.\nמבנה:\nעץ איפאה מלא, מוברש ומוכתם בשמן טבעי\nריפוד:\nכריות פוליאוריתן מעוצבות בצפיפויות שונות\nכריות גב מסיבי פוליאסטר עם תוספת פרספקס\nכיסוי כריות מסיבי פוליאסטר דוחי מים\nכיסא אימאן\nמידות: אורך 61X60 ס\"מ גובה 83/50 ס\"מ\nגלה את כל משפחת האימאן: כיסא אימאן, ספת אימאן, מיטה יומית אימאן, שולחן אימאן, שולחן קפה אימאן",
    "image_url": "../upload_images/PaoloCasteli/Seating/Imane Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Imane Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Imane Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Imane Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Imane Chair/4.png",
      "../upload_images/PaoloCasteli/Seating/Imane Chair/5.png",
      "../upload_images/PaoloCasteli/Seating/Imane Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Imane Chair/7.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/imane-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 12985,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "N°5 High Chair": {
    "description": "שורות מעטפות ונוזלות עבור אוסף זה של כיסאות מרופדים בעלי נוחות אופטימלית ועידון מירבי. זמינים בשתי גרסאות: עם משענת גב נמוכה וגבוהה. \n\nמבנה עץ אש כהה, משענת גב מושב עץ אש כהה, מושב ומשענת גב מרופדים בפוליאוריתן מוקצף בדחיסות שונה, מרופדים בבד או עור לדוגמא. העיצוב מועשר בידית דקורטיבית באיכות גבוהה מברזל מט ועור הממוקמת בחלק האחורי של הגב. לא ניתן להסרה.\n\nמידות: רוחב 60 x עומק 64 x גובה 92 ס\"מ\n",
    "image_url": "../upload_images/PaoloCasteli/Seating/N°5 High Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/N°5 High Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/N°5 High Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/N°5 High Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/N°5 High Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/N°5 High Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/N°5 High Chair/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/n5-high-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 28729,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "N°5 Low Chair": {
    "description": "קווים זורמים ועוטפים לקולקציה זו של כיסאות מרופדים בעלי נוחות גבוהה ועדינות אופטימלית. זמינים בשתי גרסאות: עם גב נמוך וגב גבוה.\nרגליים עשויות מעץ אש כהה, מושב וגב מרופדים בפוליאוריתן מוקצף בצפיפויות שונות, מרופדים בבד או בעור לדוגמה. לא ניתן להסרה.\nמידות: רוחב 60 ס\"מ x עומק 63 ס\"מ x גובה 79 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Seating/N°5 Low Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/N°5 Low Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/N°5 Low Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/N°5 Low Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/N°5 Low Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/N°5 Low Chair/5.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/n5-high-and-low-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 23469,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Ottomana Chair": {
    "description": "פשטות ברורה מאפיינת את \"Ottomana\", שרפרף מעודן שמתאים לחללים בקלות ומשמש גם כשולחן קפה או כאובייקט דקורטיבי. העיצוב הקומפקטי עדין לעין בזכות צורת המושב המינימליסטית והעוטפת שהופכת את הרהיט לאיקוני.\nקיים במספר גרסאות: קרמיקה מזוגגת ביד וקרמיקה מרוססת בצבע עם מתכת אמיתית — אבץ או פליז.\n\nחומרים\nבסיס ומושב:\nקרמיקה מונולית איפרגרס (פורצלן אבן חד-שרפי)\nגימורים\nבסיס ומושב:\nקרמיקה מזוגגת בצבע מרווה (Sage), אדמה אדומה (Terracotta), אוקיינוס (Ocean) \nקרמיקה מרוססת בצבע עם מתכת אמיתית — אבץ או פליז\n\nמידות: אורך 59 ס\"מ על 48 ס\"מ; גובה 54/46 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Ottomana Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/7.jpg",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/8.jpg",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/9.jpg",
      "../upload_images/PaoloCasteli/Seating/Ottomana Chair/10.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/ottomana-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 18650,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Sari Chair": {
    "description": "כיסא סרי, יופי אסתטי וארגונומיה מתמזגים יחד במושב עם צללית נועזת בכל פרט. \nהכיסא מיוצר ממבנה פנימי ממתכת, והוא מתאפיין בריפוד קצף פוליאוריתן, העוטף את המושב, הגב והרגליים, וכך מגדיר את התכונה הייחודית של הרהיט. \nכמו שהסרי עוטף את הגוף הנשי, מחזק את קוויו המתפתלים, כך קשת העץ ממולחמה מלכת אגוז מוצק, הנראה כתומך בשניהם, חוגגת את הדינמיות על-ידי יצירת תנועה מעגלית.\nהמוצר ממציא מחדש את מושג הנוחות עם עיצובו האקלקטי והמראה הנעים והרך של רכיביו.\nחומרים:\nמבנה: ברזל, עץ\nריפוד: בדים פנימיים\nגימורים:\nמבנה: עץ אפר אגוז\nריפוד: Byr Chenille, פשתן מעורבב, צמר Bouclè, עור אנילין, Nubuk.\nמידות: אורך 68X65 ס\"מ; גובה 82/49 ס\"מ\nגלו את כל משפחת סרי: כיסא טרקלין סרי\n",
    "image_url": "../upload_images/PaoloCasteli/Seating/Sari Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Sari Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Sari Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Sari Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Sari Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Sari Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Sari Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Sari Chair/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/sari-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 12999,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Scranno": {
    "description": "פאולו קסטלי מעצב את אוסף הקפסולה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב. \nשרפרף שחוגג אמנות ועיצוב, הפתרון האידיאלי לאלה המחפשים מיזוג הרמוני של פונקציונליות וסגנון נצחי. Scranno מוגדר על ידי מבנה מתקפל יציב מעץ אשוח מוכתם באגוז, מעוטר באלגנטיות בפרטים מתכתיים בגימור ברונזה/פליז מט. המושב, המכוסה בעור בצבע חול עם תפרים בגוון תואם, מעורר את לוחות הצבעים הנייטרליים החמים של ציורי מורנדי, ומשלב בין נוחות לסגנון נצחי. מותאם לסביבות שונות, זמין לפי בקשה בגרסה חיצונית, ומבטיח סגנון ופונקציונליות בכל סביבה.\nמידות:\nגובה 45 x קוטר 47 x אורך 56 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Scranno/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Scranno/1.png",
      "../upload_images/PaoloCasteli/Seating/Scranno/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/7.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/8.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/9.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/10.jpg",
      "../upload_images/PaoloCasteli/Seating/Scranno/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/scranno-stool/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 14104,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Selima Chair": {
    "description": "כיסא סלימה, כיסא אוכל עשוי כולו מעץ אש ידידותי לסביבה שנזרק, זמין בשלושה אפשרויות: אש טבעי עם גימור אצטני, גרסה מלבינה או בגימור אגוז פתוח נקבוביות. בתהליך זה נקבוביות העץ נשארות פתוחות בכוונה, ובכך מאפשרות לווניר לשמור על מראהו הטבעי. גב ומושב מרופדים בכיסוי שאינו ניתן להסרה. פרטי המסגרת עשויים ממתכת בצבע שמפניה, בגימור מלוטש.\nממדים:\nרוחב: 49 ס\"מ x עומק: 51 ס\"מ x גובה: 85/46 ס\"מ\n\nגלה את משפחת סלימה: קונסולת סלימה, שולחן צד סלימה",
    "image_url": "../upload_images/PaoloCasteli/Seating/Selima Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Selima Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/7.png",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/8.png",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/9.png",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/10.png",
      "../upload_images/PaoloCasteli/Seating/Selima Chair/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/selima-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 22050,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Sofia Chair": {
    "description": "סופיה היא כיסא מתוחכם ונוח, בעל צורה המעלה זיכרונות מהעיצוב של שנות ה-30, ומתאים לכל סוג של חלל מגורים או מרחב ציבורי עם משיכה ויזואלית רבה.\nהמבנה שלה עשוי מעץ רב-שכבתי מכופף, מרופד בפוליאוריתן מוקצף בצפיפות שונה, בעוד הרגליים עשויות מעץ אשור ומרופדות באותו ריפוד כמו הכיסא. רגלי הגב כוללות תוספת מתכת מפולשת בבראס מבריק. סופיה יכולה להיות מרופדת לחלוטין בקטיפות אלגנטיות שאינן נשלפות, עור איכותי או נבוק. סופיה זמינה גם ללא וגם עם משענות יד.\nריפוד לא ניתן להסרה.\nמימדים.\nספה: רוחב 49 x עומק 60 גובה 91 ס\"מ\nסופיה עם משענות יד: רוחב 56 x עומק 60 גובה 91 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Sofia Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/7.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/8.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/9.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/10.jpg",
      "../upload_images/PaoloCasteli/Seating/Sofia Chair/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/sofia/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 19878,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "U Chair": {
    "description": "כיסא מעודן בעל צורה מפתה, עם עומק מודגש וחזית מעט משופעת. המבנה מחבק את הגוף בצורה אלגנטית ומגיע במתכת עם ציפוי שחור מט או ברונזה מט, עם ריפוד עור ותפירות גלויות. המושב משתלב בפשטות במשענת האחורית ונכנס למשענות היד, מה שמקנה לו מראה תלוי, כאילו הוא מרחף.\nצבעי העור הזמינים: שחור, טבעי, חול, חום כהה.\nמידות: אורך: 54 ס\"מ; עומק: 56 ס\"מ; גובה: 83 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Seating/U Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/U Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/U Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/U Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/U Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/U Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/U Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/U Chair/7.jpg",
      "../upload_images/PaoloCasteli/Seating/U Chair/8.png",
      "../upload_images/PaoloCasteli/Seating/U Chair/9.png",
      "../upload_images/PaoloCasteli/Seating/U Chair/10.png",
      "../upload_images/PaoloCasteli/Seating/U Chair/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/u-chair/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 23749,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "U Outdoor Chair": {
    "description": "כיסא ה-U כובש שלבים חדשים בכך שהוא מציג את עצמו כתמיכה אידיאלית להרפיה מורכבת ואפילו בחוץ. הנוחות שלו מוגדרת על ידי מושב עם עומק מדגיש ושיפוע קל, בזכות שפה פשוטה אך מתוחכמת. המבנה שלו, קל לעין אך מוצק בתפקודו מעשוי פלדה צבועה עם גימורים לחוץ, תומך במושב ובמשענת גב בעור סינתטי EVA הזמין בשני צבעים, חום לבֵנים ושמנת. הסינתזה ההרמונית של ה-U Outdoor מציעה גמישות רחבה בשימוש, ומאפשרת לשנות כל סוג של מרחב בצורה עכשווית.\nמידות:\nאורך: 54 ס\"מ; גובה: 83 ס\"מ; עומק: 57 ס\"מ; גובה מושב: 46 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/1.png",
      "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/2.jpg",
      "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/3.jpg",
      "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/4.jpg",
      "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/5.jpg",
      "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/6.jpg",
      "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/7.jpg",
      "../upload_images/PaoloCasteli/Seating/U Outdoor Chair/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/u-chair-outdoor/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 17664,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Venice Stool": {
    "description": "כסא בר עם קווים עוטפים ומשענת גב גבוהה המרחיבה את קולקציית ונציה.\nמתאים לסלון כמו לאזור הלילה, מאופיין במבנה פנימי מעץ מעוקל עם ריפוד מפוליאוריתן בצפיפות משתנה. יש לו כיסוי בלתי ניתן להסרה הניתן להתאמה אישית עם בדים יוקרתיים, עור מלא ואיכותי וגימור נובוק. המושב נשען על מסגרת עץ בוק מצופה לכה שחורה מט, תומך רגליים ממתכת – בגימור ניקל מט עם תוספת פליז מלוטש.\nמידות:\nכסא בר H72: רוחב 55 x עומק 55 גובה 93 ס\"מ\nכסא בר H85: רוחב 55 x עומק 55 גובה 106 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Seating/Venice Stool/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Seating/Venice Stool/1.png",
      "../upload_images/PaoloCasteli/Seating/Venice Stool/2.jpg",
      "../upload_images/PaoloCasteli/Seating/Venice Stool/3.jpg",
      "../upload_images/PaoloCasteli/Seating/Venice Stool/4.jpg",
      "../upload_images/PaoloCasteli/Seating/Venice Stool/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/seating/venice-barstool/",
    "company_name": "Paolo Casteli",
    "original_category": "Seating",
    "price": 29379,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Indoor"
  },
  "Odissea Bed": {
    "description": "המשענת הקבועה, המכוסה כולה בבד סאטן, רכה במיוחד בשל הריפוד שמעניק לה מראה מזמין ונוח. התוספות העשויות עץ עם גימור מוזהב מאירות את חלומותינו בהשתקפויות ענבר. לבקשה ניתן להוסיף שקעים חשמליים על לוחות הצד של המשענת.\n\nמידות:\nL. 323/188 x D. 216 x H. 181/40 ס\"מ\nהמזרן וקפיצי המיטה אינם כלולים.\nגודל המזרן: 180 x 200 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Beds/Odissea Bed/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Beds/Odissea Bed/1.png",
      "../upload_images/PaoloCasteli/Beds/Odissea Bed/2.jpg",
      "../upload_images/PaoloCasteli/Beds/Odissea Bed/3.jpg",
      "../upload_images/PaoloCasteli/Beds/Odissea Bed/4.jpg",
      "../upload_images/PaoloCasteli/Beds/Odissea Bed/5.jpg",
      "../upload_images/PaoloCasteli/Beds/Odissea Bed/6.png",
      "../upload_images/PaoloCasteli/Beds/Odissea Bed/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/beds/odissea-bed/",
    "company_name": "Paolo Casteli",
    "original_category": "Beds",
    "price": 25684,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Vao Bed": {
    "description": "מיטת Vao, המיטה המרופדת החדשה נוספה עם קווים מתעגלים וממדים נדיבים ובהרמוניה עם האווירה של הקולקציה. למיטה מבנה ורגליים מעץ מַעֲצָתִי בר-קיימא, בעוד שהראש המרופד ומִסְגֶרֶת המיטה עשויים מגומי אורגני וריפוד טבעי. אפילו כיסוי הצמר בוקלה בעל נשמה טבעית ואקולוגית. מיטת Vao קיימת גם בגרסה מחבקת יותר המצוידת בשני \"כנפיים\" צדדיות ניתנות להזזה שמחבקות את השידות הלילה.\nהמזרן והבסיס לא כלולים.\nגודל המזרון: 180 x 200 ס\"מ\nממדים:\nללא כנפיים: ר. 207 x עמ. 242 x ג. 94/35 ס\"מ\nעם כנפיים: ר. 338 x עמ. 242 x ג. 94/35 ס\"מ\nגלה את משפחת Vao: ספה Vao 380, ספה Vao 250, כורסת Vao Love Seat 150, כורסת Vao, פוף Vao.",
    "image_url": "../upload_images/PaoloCasteli/Beds/Vao Bed/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Beds/Vao Bed/1.png",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/2.jpg",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/3.jpg",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/4.jpg",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/5.jpg",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/6.jpg",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/7.jpg",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/8.jpg",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/9.jpg",
      "../upload_images/PaoloCasteli/Beds/Vao Bed/10.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/beds/vao-bed/",
    "company_name": "Paolo Casteli",
    "original_category": "Beds",
    "price": 20962,
    "filter_category": "מיטות לחדרי שינה",
    "placement": "Indoor"
  },
  "Ama Armchair": {
    "description": "אמה היא גם כורסה, חלק ממערכת ספות וכורסאות לסלון, אוסף חדש של פאולו קסטלי. אמה היא מושב מרופד עם דימוי דקו. הצורה שלה היא באמת מקורית, שכן היא מאופיינת בא-סימטריות קומפוזיציונית הנובעת מגבהים שונים של האלמנטים המרכיבים. השלם הוא סצני ונוצץ מאוד, מספק גם את הקהל הצעיר ביותר, מבלי לאבד את האלגנטיות שמאפיינת את האוסף שאליו היא שייכת. לכורסה יש מסגרת עץ מלא רב-שיכבתית מחוזקת וריפוד פוליאוריתן מלא המכוסה בסיב פוליאסטר ובטנת כותנה.\nממדים: אורך 98 ס\"מ x עומק 84 ס\"מ x גובה 75/40 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/9.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/10.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/11.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Armchair/12.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/ama-armchair/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 28296,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Ama Bergere": {
    "description": "אמה ברז'רה, תחושה נוחה מאוד שניתנת על ידי הריפוד הנדיב והפרטים המורכבים שמרככים את הגיאומטריות. לאחר ההצלחה של הספה, משפחת אמה מקבלת בברכה מקומות ישיבה מרופדים נוספים כגון הברז'רה, הפוף הגדול, הכתף, והגרסה המודולרית גם עם המודולים המעוגלים של הספה באותו השם. אוסף מושבי אמה מתאפיין באסימטריות שנוצרים על ידי הגבהים והעומקים השונים של האלמנטים המרכיבים, החדר מונפש בצורה בלתי צפויה ודינמית ברמה גבוהה.  \nחומרים:\nמבנה: עץ\nריפוד: בדים פנימיים\nגימורים:\nריפוד: בדים קט. עליון, דלוקס, ידידותי לסביבה\nעור TOP, עור בקר, נובוק\nמידות:\nאורך 99×86; גובה 98/40 ס\"מ\nגלה את כל משפחת אמה: ספת אמה, אמה מודולרי, כיסא אמה, כתף אמה, פוף גדול אמה",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Ama Bergere/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Ama Bergere/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Ama Bergere/2.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/ama-bergere/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 11053,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Ama Ottoman": {
    "description": "עמא עות'מאן, תחושה חמימה מאוד בזכות הריפוד השופע והפרטים המורכבים שמרככים את הגיאומטריות. בעקבות הצלחת הספה, משפחת עמא מקבלת בברכה מושבים מרופדים נוספים כגון הברגר, הגרנד פוף, העות'מאן, והגרסה המודולרית גם עם מודולים מעוגלים של הספה באותו שם. אוסף המושבים של עמא מתאפיין באסימטריות שנוצרות על ידי גבהים ועומקים שונים של האלמנטים המרכביים, מה שמכניס לחדר דינמיות בלתי צפויה ומרהיבה.\nחומרים\nמבנה: עץ\nריפוד: בדים לשימוש פנימי\nגמרים\nריפוד: בדים קטגוריה עליונה, דלוקס, ידידותי לסביבה\nעור TOP, עור בקר, נובוק\nמידות: אורך 60X46; גובה 40 ס\"מ\nגלה את כל משפחת עמא: ספת עמא, עמא מודולרי, כורסת עמא, עמא ברגר, עמא גרנד פוף",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Ama Ottoman/main.jpg",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Ama Ottoman/1.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ama Ottoman/2.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/ama-ottoman/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 22928,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Babou Lounge": {
    "description": "הלאונג' באבו מאופיין בעיצוב המבנה שלו, סימן גרפי אלגנטי המגדיר את משענת הגב התומכת בריפוד, בהשראת אמנותו של הצייר הסוריאליסטי סלבדור דאלי. משפחת הישיבה באבו משלבת בין הלוגי והאִרְרַצְיוֹנָלִי במשחק של ניגודים בין מינימליזם לעושר צורני. הלאונג' כולל משענת גב מצינור פלדה מכוסה בעור חיצוני. המושב כולל מבנה מעץ רב שכבתי ימי, מרופד כולו בפוליאוריתן אקולוגי עם פליטות CO2 נמוכות. הכסא עצמו מכוסה לשימוש חיצוני בבדי פיבר פוליאסטר דוחי מים הזמינים בצבעים שונים, אך גם לשימוש פנימי בבדים ועור אנילין.\n\nהקולקציה כוללת גם מערכת מודולרית, שבה, בזכות מערכת נעילה פשוטה, ניתן לחבר כיסאות לאונג' ושרפרפים כדי ליצור קומפוזיציה חדשה בשם באבו מודולרי. מדובר במערכת מודולרית שמתאימה לכל הדרישות האסתטיות והמרחביות.\n\nחומרים:\nמבנה: פלדת אל-חלד\nריפוד: בדים קטגוריית חוץ, בדים לפנים\n\nגימורים:\nמבנה: מסגרת פלדת אל-חלד בצבע פוליאסטר צבע שמפניה, מכוסה בעור חיצוני\nריפוד: קטגוריית בדים חוץ, מעולים, דלוקס, עור ידידותי לסביבה TOP, עור בקר, נובוק\n\nמידות הלאונג' באבו: אורך: 81X81; גובה: 78/40 ס\"מ\nמידות הבאבוי מודולרי: אורך: 242X89; גובה: 78/40 ס\"מ // מחבר: אורך: 40 ס\"מ\n\nגלה את כל משפחת באבו: פוף באבו",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/9.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/10.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/11.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/12.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/13.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Babou Lounge/14.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/babou/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 20052,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Babou Pouf": {
    "description": "פוף בבו, בעל אופי דקורטיבי חזק ולעיתים גם משחקי, הוא הפתרון המושלם למרחבים פרטיים וציבוריים כאחד, שמעוניינים לחשוף את אופיים בפרטים הקטנים. בהשראת האמנות של הצייר הסוריאליסטי סלבדור דאלי, משפחת הישיבה בבו משלבת את ההגיוני והלא הגיוני במשחק של ניגודים בין מינימליזם לתוספות פיגורטיביות. הקולקציה כוללת גם כורסה ומערכת מודולרית. בבו זמין גם בגרסה פנימית, בזכות המגוון הרחב של כיסויים וצבעים זמינים. הרבגוניות המולדת של הרהיט מתגלה בגרסה ללא גב, כעות'מאן שניתן לצרפו בקלות לכורסה בבו, ליצור הרכב חדש, מערכת מודולרית שמתאימה לכל דרישות אסתטיות ומרחב.\n\nחומרים\nמבנה: פלדת אל-חלד\nריפוד: בדים קטגוריה חוץ, בדים פנימיים\n\nגימורים\nמבנה: מסגרת פלדת אל-חלד, צביעה פוליאסטר בצבע שמפניה, מצופה עור חוץ\nריפוד: בדים קטגוריה חוץ, עליון, דלוקס, עור ידידותי לסביבה, עור בוביין, נובוק\n\nמידות: אורך: 81X82; גובה 40 ס\"מ\n\nגלו את כל משפחת בבו: כורסה בבו",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Babou Pouf/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Babou Pouf/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Babou Pouf/2.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/babou-pouf/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 28253,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Coral Armchair": {
    "description": "כורסאת קורל, צורות נדיבות ושופעות עבור סדרת רהיטים מרופדים בעיצוב שמזכיר רכות עננית. המבנה המונוליתי רחוק מלהיות כבד לעין, הודות לחלוקה הבלתי רגילה של האלמנטים הבודדים המרכיבים את השלם: משענת גב, משענות יד ומושב, שנראים כאילו הם משתלבים יחד כמו אלמנטים טבעיים שעוצבו על ידי הזמן.\n\nכורסאת קורל היא כורסא קומפקטית עם ריפוד עשוי גומי אקולוגי הנתמך על ידי קפיצים יווניים המופרדים על ידי בד יוטה. כיסוי שאינו ניתן להסרה. בסיס עץ עשוי מעץ אש עם גימור אצטטי.\n\nמידות:\nרוחב 110 ס\"מ x עומק 95/65 ס\"מ x גובה 70/40 ס\"מ\n\nגלה את משפחת קורל: ספת קורל\n",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/9.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Coral Armchair/10.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/coral-armchair/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 27264,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Crudelia Armchair": {
    "description": "כיסא עם עיצוב שנון ופרובוקטיבי בכל פרט ופרט. קרודליה מטביעה את עצמה בזירה הביתית בנועזות צורותיה ובאירוניה שהיא מבטאת במהותה. כיסא עכשווי עבור אלה שמבקשים להשגיח על המקדש הקדוש של ביתם ממקום מועדף. כיסא שמורכב ממספר אלמנטים פשוטים. חרוט עולה מתפתח מלמטה, כולל את כרית המושב הרכה ואת המשענת. שתי הרגליים הקדמיות בצורת גליל עשויות עץ אפר מוצק, צבוע בשחור עם נקבוביות פתוחות, בעוד שהקצוות שלהן כוללות גימור עם חצי כדוריות של פליז חרוט בלייזר. הן המושב והן המשענת מרופדים בבדים פנימיים. לא קונפורמיסטי ומשחרר, קרודליה הוא כיסא עכשווי שמפזר אנרגיה בכל חלל שבו הוא מוצב.\nמידות:\nאורך: 153 ס\"מ; גובה: 85 ס\"מ; עומק: 69 ס\"מ; גובה מושב: 49 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Crudelia Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Crudelia Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Crudelia Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Crudelia Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Crudelia Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Crudelia Armchair/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/crudelia-armchair/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 24244,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Imane Armchair": {
    "description": "כורסה אימאן – קו חיצוני\nאימאן היא הקולקציה החדשה של כיסאות עם ריפוד ושולחנות קפה לשימוש חיצוני, שעוצבה על ידי תיירי למייר, הוברט דה מאלרב ופאולו קסטלי. עשויה מחומרים טבעיים ובעבודת יד עד לפרטים הקטנים ביותר, אימאן היא חלק מפרויקט GREENKISS הרחב יותר, הכולל את הקולקציות הירוקות של החברה.\nהספות והכורסה של אימאן מאופיינות במבנה לינארי מעץ אירוקו מסיבי מוברש וצבוע בשמן טבעי, עם מראה מעודן ומהותי.\nמבנה:\nעץ אירוקו מסיבי, מוברש וצבוע בשמן טבעי\nריפוד:\nכריות פוליאוריתן מעוצבות בצפיפות משתנה\nכריות גב מסיבי פוליאסטר עם תוספת פרספקס\nכיסוי כריות מסיבי פוליאסטר דוחה מים\nמידות: אורך 105 X 105; גובה 40/78 ס\"מ\nגלה את כל משפחת אימאן: ספת אימאן, מיטת יום אימאן, כיסא אימאן, שולחן אימאן, שולחן קפה אימאן.\n",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Imane Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Imane Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Imane Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Imane Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Imane Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Imane Armchair/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/imane-armchair/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 12792,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Ipanema Armchair": {
    "description": "כורסאת איפנמה מתורגמת, באמצעות קווים קפדניים אך עדינים ולעולם לא נוקשים, לנוחות באופן מרבי. המבנה - עשוי ממסגרת מתכת בגימור ניקוי סאטן שחור מט וזהב מבריק לרגליים - מכיל כריות מלאות וכיסאות רכים עשויים מסיבי פוליאסטר עם תוספת בחומר בלתי ניתן לעיוות בצפיפויות שונות. כריות הגב והמשענות עשויות מפוליאוריתן עם כיסוי סיבי פוליאסטר כדי להבטיח תמיכה מיטבית ולהיות רכות ומקבלות תמיד. לנוחות נוספת, הכריות מכילות גם מילוי נוספות מפוך אווז מעוקר. כל הכריות ומשענות הגב ניתנות להסרה.\n \nמידות:\nרוחב 120 ס\"מ x עומק 100 ס\"מ x גובה 75/38 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Ipanema Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Ipanema Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Ipanema Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ipanema Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ipanema Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Ipanema Armchair/5.png",
      "../upload_images/PaoloCasteli/Armchairs/Ipanema Armchair/6.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/ipanema-armchair/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 18600,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Luna Swing Armchair": {
    "description": "כורסא נדנדה לונה, כורסא מקסימה עם צורה עכשווית ומתוחכמת. המבנה עשוי מעץ אש שנזרק אך ידידותי לסביבה, עם ריפוד עשוי מפוליאוריתן ביולוגי ומכוסה בריפוד טבעי ובאריגה יוטה. משענת הגב המרופדת עוטפת את המושב כמו עלי כותרת. הריפוד אינו ניתן להסרה. המבנה נשען על בסיס מסתובב המצופה בבוקלה צמר ולוחית מתכת בצבע שמפניה עם גימור סטאן אורביטלי.\nמידות:\nרוחב 84 x עומק 84/56 x גובה 80/40 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Luna Swing Armchair/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/luna-swing-armchair/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 21435,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Parabolica Armchair": {
    "description": "כורסא פרבוליקה היא מושב יוקרתי בגודל עדין, מתאים לאזורי מנוחה והמתנה, כניסות וחללי מגורים, אידיאלי לשיחה.\nהיא מתבלטת בצורת המושב שיש לו אפקט של פרבולה, שממנו קיבלה את שמה.\nהכורסא מוגדרת על ידי מבנה מתכת מתוחכם עם גימור זהב מלוטש, והיא מרופדת בפוליאוריטן מוקצף בצפיפויות שונות. המשענות וכרית הנוצות הקטנה מכוסים בעור בקר בצבע בז'.\nהכיסוי הלא ניתן להסרה ניתן להתאמה אישית עם בדים אלגנטיים, עור יוקרתי ונובוק.\nמידות:\nרוחב 73 x עומק 80 x גובה 73/42 ס\"מ\n",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/9.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/10.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/11.png",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/12.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/13.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/14.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Armchair/15.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/parabolica/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 10393,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Parabolica Ottoman": {
    "description": "ה\"פוף פארבוליקה\" מוגדר על ידי מבנה מתכת מתוחכם בגימור זהב מבריק, וריפוד עם פוליאוריתן מוקצף בצפיפות משתנה.\nהכיסוי שאינו ניתן להסרה ניתן להתאמה אישית עם בדים אלגנטיים, עור משובח ונובוק.\nמידות:\nרוחב 73 ס\"מ x עומק 42 ס\"מ x גובה 45 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Parabolica Ottoman/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Ottoman/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Ottoman/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Parabolica Ottoman/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/parabolica-ottoman/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 19394,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Sari Lounge": {
    "description": "סארי לאונג', משלב בין אסתטיקה וארגונומיה בכסא עם סילואטה נועזת בכל פרט.\nעם מבנה פנימי ממתכת, סארי מובדל על ידי הריפוד מפוליאוריתן, אשר עוטף את המושב, משענת הרגליים ומהווה את התכונה המיוחדת של הריהוט. כמו שהסארי עוטף את הגוף הנשי, ומדגיש את הקווים העגלגלים שלו, כך הקשת עשויה מעץ אש מעובד במחוזות אגוז, שנראית כמחזיקה את הכסא והכיסא בצורה דינמית אשר יוצרת תנועה קעורה.\nסארי ממציא מחדש את רעיון הנוחות בעיצוב אקלקטי והמראה הנעים והרך של רכיביו.\nחומרים\nמבנה: ברזל, עץ\nריפוד: בדים פנימיים\nגימורים\nמבנה: עץ אש מוכתם באגוז\nריפוד: Byr Chenille, Blended Linen, Bouclè Wool, Aniline Leather, Nubuk\nמידות: אורך. 79X77; גובה. 75/42 ס\"מ\nגלו את כל משפחת סארי: כסא סארי",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/9.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/10.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/11.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/12.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/13.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/14.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/15.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Sari Lounge/16.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/sari-lounge/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 16509,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "U Lounge": {
    "description": "הכיסא המעודן הזה מתאפיין בנוחות ובאופי יוצאי דופן, המיועדים ליצור פתרונות אסתטיים ומבניים בעלי השפעה גבוהה. הצורה המפתה מוגדרת על ידי עומק מדגיש וחזית מעט מוטה. המבנה מחבק את הגוף באלגנטיות ומגיע במתכת מלוטשת, גימורי ניקל שחור וזהב, עם ריפוד עור בצבע חול הכולל תפרים גלויים (זמין גם בעור שחור או טבעי). המושב נראה \"מרחף\" באוויר, כשהוא פשוט משתלב במשענת הגב ונכנס לתוך משענות הידיים. זמין בעור עם משענות יד תואמות.\nמידות:\nרוחב 65 x עומק 65 x גובה 76/42 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/U Lounge/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/1.png",
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/U Lounge/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/u-lounge/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 18999,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Vao Armchair": {
    "description": "כורסא ואו, כורסא עם קווים מעוגלים להפליא, בעלת רגליים עשויות מעץ אש מוצק ידידותי לסביבה עם גימור אצטטי, שחסרונותיו מעניקים לו מראה אסתטי מדהים.\nריפוד עשוי מפוליאוריתן ביולוגי, מרופד בריפוד טבעי ורצועות עשויות מג'וט. כיסוי לא ניתן להסרה.\nמידות:\nרוחב: 75 ס\"מ, עומק: 77/55 ס\"מ, גובה: 75/40 ס\"מ\nגלה את משפחת ואו: מיטת ואו, ספת ואו 380, ספת ואו 250, כורסת אהבה ואו 150, פוף ואו",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/9.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/10.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/11.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/12.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Vao Armchair/13.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/vao-armchair/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 21672,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Venice Armchair": {
    "description": "כיסא הוונציה הוא כיסא קטן מרופד בצורתו הרכה, שמתאים לכל חלל מגורים עכשווי.\nהמסגרת שלו עשויה מעץ רב-שכבתי מעוגל מרופד בפוליאוריתן בצפיפות שונה. הכיסוי, שאינו ניתן להסרה, ניתן להתאמה אישית במגוון רחב של בדים אלגנטיים, עור עדין ונובוק.\nבסיס הכיסא עשוי מעץ אשור צבוע בגימור מתכתי בצבע פנינה-בז'. RAL 1035.\nמידות: רוחב 66 x עומק 66 x גובה 70/40 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Armchair/8.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/venice-armchair/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 11843,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Venice Bergere": {
    "description": "כורסה עם קווים עוטפים עם משענת גב גבוהה המרחיבה את קולקציית ונציה. מתאימה הן לסלון והן לחלל לילה, ומתאפיינת במבנה פנימי מעץ מכופף עם ריפוד מפוליאוריתן מוקצף בדרגות צפיפות שונות. יש לה כיסוי בלתי ניתן להסרה הניתן להתאמה אישית עם בדים מעודנים, עור דגנים מלא עידון וגימור נובוק. המושב נשען על מסגרת עץ אשור בגימור מט כהה.\nמידות:\nרוחב 71 x עומק 71 x גובה 95 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/3.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/4.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/5.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/9.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/10.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/11.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Bergere/12.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/venice-bergere/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 24596,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Venice Office": {
    "description": "כורסה עם קווים מעטפת ומשענת גב גבוהה המיועדת לחללי משרדים. תוספת זו לאוסף ונציה מאופיינת במבנה פנימי מעץ לבוד מעוצב עם ריפוד פוליאוריתן בצפיפות משתנה וכיסוי בלתי נשלף בהתאמה אישית, זמין בבדים מעודנים, עור פרה מלא מעודן ועור נובוק. המושב מותקן על בסיס מתכת בניקל שחור מבריק.\nמידות:\nרוחב 71 ס״מ x עומק 71 ס״מ x גובה 95 ס״מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Venice Office/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/2.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/3.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/4.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/5.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/6.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/7.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/8.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/9.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/10.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Office/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/venice-office/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 13323,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Venice Swing Armchair": {
    "description": "כורסה עם קווים עוטפים ומשענת גב גבוהה. תוספת זו לאוסף ונציה מתאימה גם לסלון וגם לחדר השינה וכוללת מבנה פנימי מעץ לבוד מעוצב עם ריפוד פוליאוריתן בצפיפות משתנה וכיסוי שאינו ניתן להסרה בהתאמה אישית, הזמין בבדים משובחים, עור בקר מלא מעודן ועור נובוק. המושב מותקן על בסיס מסתובב מצופה למינציה מתכת בגימור סאטן מט עם מנגנון חזרה.\nמידות:\nרוחב 68 x עומק 72 x גובה 71/42 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/1.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/2.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/3.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/4.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/5.png",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/6.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/7.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/8.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/9.jpg",
      "../upload_images/PaoloCasteli/Armchairs/Venice Swing Armchair/10.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/armchairs/venice-swing/",
    "company_name": "Paolo Casteli",
    "original_category": "Armchairs",
    "price": 22207,
    "filter_category": "כורסאות",
    "placement": "Indoor"
  },
  "Petra Bookcase": {
    "description": "מימדים:\nארון ספרים:\nגובה מקסימלי 345 ס\"מ, עומק 33 ס\"מ, רוחב 60 או 90 ס\"מ\nמדפים:\n830: עומק 83 x רוחב 30 ס\"מ\n530: עומק 53 x רוחב 30 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Bookcases/Petra Bookcase/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Bookcases/Petra Bookcase/1.png",
      "../upload_images/PaoloCasteli/Bookcases/Petra Bookcase/2.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Petra Bookcase/3.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Petra Bookcase/4.png",
      "../upload_images/PaoloCasteli/Bookcases/Petra Bookcase/5.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Petra Bookcase/6.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Petra Bookcase/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/bookcases/petra-day-system/",
    "company_name": "Paolo Casteli",
    "original_category": "Bookcases",
    "price": 23322,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Socrate Bookcase": {
    "description": "ארון הספרים סוקרטס עשוי ממבנה מתכת המורכב מצינורות ומקטע מרובע מחוטי מתכת. הגרסה עם השיש כוללת מסגרת עם גימור זהב מט, מדפים מזכוכית בצבע הוואנה ושיש רוזה אגאו. לגרסת העץ יש מדפי זכוכית בצבע הוואנה ועץ אלם, מסגרת מתכת בגימור מט ברונזה. הארון זמין בשני גדלים: דגם סוקרטס 35 ודגם סוקרטס 130.\nמידות:\nסוקרטס 35: רוחב 38 x עומק 35 x גובה 222 ס\"מ\nסוקרטס 130: רוחב 130 x עומק 35 x גובה 222 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/1.png",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/2.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/3.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/4.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/5.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/6.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/7.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/8.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/9.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/10.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/11.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/12.png",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/13.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Socrate Bookcase/14.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/bookcases/socrate/",
    "company_name": "Paolo Casteli",
    "original_category": "Bookcases",
    "price": 13012,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Uffizio Bookcase": {
    "description": "כוננית ספרים מוארת תלויה על הקיר הכוללת מבנה מתכת בגימור מט צבע ברונזה צללית, מדפי זכוכית שקופים בצבע אבלנה וגב זכוכית אפורה עם גימור מט מחומם עם מערכת LED מובנית, כוללת מתקן קיר. זמינה בשתי אפשרויות: 4 מדפים או 3 מדפים לאחסון חפצים גבוהים יותר. טמפרטורת צבע הלד היא 2700°K.  \nבמהלך שנת 2020 כוננית הספרים Uffizio זכתה בשני פרסים יוקרתיים: פרס Archiproducts Design Awards ו-פרס IDA Design Award  \nמידות:  \nרוחב 46 ס\"מ, עומק 22 ס\"מ, גובה 195 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/1.png",
      "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/2.png",
      "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/3.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/4.jpg",
      "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/5.png",
      "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/6.png",
      "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/7.png",
      "../upload_images/PaoloCasteli/Bookcases/Uffizio Bookcase/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/bookcases/uffizio-bookcase/",
    "company_name": "Paolo Casteli",
    "original_category": "Bookcases",
    "price": 17411,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Elegance Bench": {
    "description": "ספסל אלגנטי הוא כיסא מרופד בעיצוב אלגנטי. מתאים במיוחד בכניסות, מרחבי מגורים, אזורי ארונות בגדים וחדרי שינה. \nהמבנה עשוי מעץ רב שכבתי עם ריפוד מפוליאוריתן מורחב, מרופד בסיב פוליאסטר. הוא מקושט בכרית גלילית ורגלי המתכת בעלות גימור זהב מט.\nהמוצר ניתן להתאמה אישית במגוון רחב של בדים אלגנטיים, עור משובח ונובוק. \nמידות: רוחב 150 ס\"מ, עומק 50 ס\"מ, גובה 55/42 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Bench/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Bench/1.png",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Bench/2.jpg",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Bench/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/chaise-longue-benches/elegance-bench/",
    "company_name": "Paolo Casteli",
    "original_category": "Chaise Longue and Benches",
    "price": 25713,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Elegance Chaise Longue": {
    "description": "כורסה אלגנטית \"Elegance Chaise Lounge\" היא כיסא מרופד בעיצוב אלגנטי. אידיאלי לכניסות, חללי מגורים, אזורי ארונות וחדרי שינה.\nהמסגרת עשויה מעץ שכבות רב עם ריפוד פוליאוריתן מורחב, מרופדת בסיבי פוליאסטר. הכורסה מעוטרת בכרית גלילית והרגליים המתכתיות מצופות בגימור זהוב מט. המוצר ניתן להתאמה אישית במגוון רחב של בדים אלגנטיים, עור עדין ונובוק.\nמידות:\nרוחב 182 × עומק 74 × גובה 54/39 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Chaise Longue/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Chaise Longue/1.png",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Chaise Longue/2.jpg",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Chaise Longue/3.jpg",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Chaise Longue/4.jpg",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Elegance Chaise Longue/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/chaise-longue-benches/elegance-chaise-longue/",
    "company_name": "Paolo Casteli",
    "original_category": "Chaise Longue and Benches",
    "price": 28742,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Tugurium Cot": {
    "description": "פאולו קסטלי מעצב את קולקציית הקפסולה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב.\nספסל מתקפל המותאם בקלות לפתרונות מחיה שונים, Tugurium מאופיין במבנה מתקפל חזק עשוי מעץ מכתים אגוז, מעוטרת באלגנטיות בפרטי מתכת בגימור ברונזה/פליז מט. המושב, מכוסה בעור בצבע חול עם תפרים בגוון דומה, מעורר את לוחות הצבעים החמים והניטרליים בציורי מורנדי, ומשלב נוחות עם סגנון על-זמני. ניתן להתאים אותו להקשרים שונים, והוא זמין לפי בקשה בגרסה חיצונית, תוך הבטחת סגנון ופונקציונליות בכל סביבה.\nמידות:\nרוחב 196 x עומק 56 x גובה 45 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Chaise Longue and Benches/Tugurium Cot/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Tugurium Cot/1.png",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Tugurium Cot/2.jpg",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Tugurium Cot/3.jpg",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Tugurium Cot/4.jpg",
      "../upload_images/PaoloCasteli/Chaise Longue and Benches/Tugurium Cot/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/chaise-longue-benches/tugurium/",
    "company_name": "Paolo Casteli",
    "original_category": "Chaise Longue and Benches",
    "price": 15840,
    "filter_category": "הדומים וספסלים",
    "placement": "Indoor"
  },
  "Arche Coffee Table": {
    "description": "שולחן קפה Arche, שולחנות קפה המתאפיינים בגיאומטריות מדויקות וברורות, שבהן הקשת הופכת למבנה נושא אופייני לאדריכלות רציונליסטית. המבנה המתכתי בנוי בסידור קשת בצורת צלב חתוך בלייזר, המוצג בצבע שמפניה עם גימור סאטן מסלול.\nהמשטח עשוי מאבן ויצ'נצה צבע אפור בהיר שחוט או בצבע שנהב מלוטש – עובי 3 ס\"מ. שולחן קפה Arche זמין גם עם משטח עשוי מחתיכות אבן בעלות גרגר גס או פחמן טבעי עשוי משבבי פליז ממוחזרים (בשתי האופציות יש משטח בעובי 2 ס\"מ).\nתוספות מתכת בצבע שמפניה מט מקשטות את המשטח עם אפקט ניגוד מקסים בין החומרים.\nמידות:\nØ 90 ס\"מ x גובה. 40 ס\"מ\nגלו את משפחת Arche: שולחן אוכל Arche, שולחן צד Arche",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Arche Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Coffee Table/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/arche-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 21473,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Arche Side Table": {
    "description": "שולחן צד ארכה מאופיין בגיאומטריות מדויקות וחדות, בהן הקשת הופכת למבנה נושא טיפוסי לארכיטקטורה רציונליסטית. המבנה המתכתי בנוי בסידור קשתות בצורת צלב, חתוך בלייזר, ומוצג בצבע שמפניה עם גימור סאטן מסלולי. השטח העליון עשוי מאבן ויצ'נזה - חולפה בצבע אפור בהיר או מלוטשת בצבע שנהב - בעובי של 3 ס\"מ.\n\nשולחן הצד ארכה זמין גם עם השטח העליון עשוי מאבן מגורענת ממוחזרת או פחמן טבעי שמוחזר עם חסימות פליז ממוחזרות (שתי האפשרויות בעלות שטח עליון בעובי של 2 ס\"מ). תוספות מתכת בצבע שמפניה מט מקשטות את השטח העליון עם אפקט ניגוד מענג בין החומרים.\n\nמידות:\nØ45 – רוחב 45 x גובה 50 ס\"מ\nØ50 – רוחב 50 x גובה 45 ס\"מ\n\nגלה את משפחת ארכה: שולחן אוכל ארכה, שולחן קפה ארכה\n",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/6.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/7.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/8.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Arche Side Table/9.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/arche-side-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 10333,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Claude Coffee Table": {
    "description": "ההשראה נובעת מציורי ה\"שושנות המים\" המפורסמות של הצייר האימפרסיוניסט קלוד מונה. זה היה מקור ההשראה לסדרת אלמנטים לשירות המורכבת משלושה וריאנטים לשימוש כמשטחי חיכוך במגוון מצבים. רכות ונוקשות, שילוב של חומרים מנוגדים. אלו הפרטים שיוצרים תנועות בלתי נצפות בהתקדמות הצורות.\nהבסיסים המתכתיים בגימור מבריק מוזהב תומכים במבטי אגמים משתנים משיש ירוק בוטני שמתחדדים בעדינות בחלקם התחתון, מחליקים את הגיאומטריה שלהם; צורות רכות, מכוילות בדיוק גבוה, פרטים מוקפדים.\nחומרים\nבסיס: מתכת\nחלק עליון: שיש\nגימורים\nבסיס: זהב מבריק, פליז ברונזה מאט\nחלק עליון: ירוק בוטני, פנדת לבן וקלצאטה\nמידות\nA. ר' 57 × ע' 46 × ג' 36 ס\"מ\nB. ר' 111 × ע' 120 × ג' 30 ס\"מ\nC. ר' 50 × ע' 63 × ג' 42 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/6.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/7.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Claude Coffee Table/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/claude-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 12954,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Dione Coffee Table": {
    "description": "א' – הוא מורכב מבסיס קרמי בצורה דקה וחלק עליון מתכתי בגימור זהב מט, בעובי של 3 מ\"מ. הבסיס התחתון הוא מתכת בגימור זהב מט.\nב' – יש לו בסיס מוצק שעליו מונחת משטח רחב של שיש קלקטה עם קצוות בזווית של 45° ובעובי 20 מ\"מ. במרכז נמצאת לוחית מתכת בגימור זהב מט. הבסיס התחתון הוא מתכת בגימור זהב מט. זמין גם עם חלק עליון משיש ב-גימור משי לבן מט.\nג' – הוא מורכב מבסיס קרמי וחלק עליון משיש קלקטה עם קצוות בזווית של 45° ובעובי 20 מ\"מ. הוא כולל תוספת מתכת בצורת טבעת בגימור זהב מט. הבסיס התחתון הוא מתכת בגימור זהב מט. זמין גם עם חלק עליון משיש ב-גימור משי לבן מט.\nמידות:\nא': חלק עליון Ø 38 ס\"מ, בסיס Ø 27 ס\"מ, גובה 50 ס\"מ\nב': חלק עליון Ø 90 ס\"מ, בסיס Ø 44 ס\"מ, גובה 28 ס\"מ\nג': חלק עליון Ø 60 ס\"מ, בסיס Ø 27 ס\"מ, גובה 40 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/6.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/7.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/8.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/9.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/10.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/11.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/12.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Coffee Table/13.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/dione-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 10801,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Dione Dark Coffee Table": {
    "description": "משפחת דיון לובשת גימורים חדשים שמעניקים אלגנטיות ועכשוויות למבנה המונוליטי שלה, כך שהיא מערבבת את הטוהר הפסלי של גרניט וקרמיקה בסימפוניה של צורות וחומרים המועצמת על ידי הביטוי האוניברסלי של המראה החשוך-המלא. דיון דארק היא הצעה חסרת תקדים המורכבת משולחן ראשי ושולחנות קטנים המורכבים בסיס קרמיקה מעוצב בצורת פעמון עם גימור מבריק בצבע פחם אפור ומצופה, אפקט הנוגד את המשטח העגול העליון העשוי שיש סהרה ברונזה מלוטש, המעוטר בעבודת מידת פליז מרכזית. דיון דארק מציעה חוויה חזותית ומגעית המעשירה כל חדר בכך שהיא מתמקדת בצורה נועזת בקסם הנצחי של צבע השחור, בקווי המתאר הפיסוליים שלה ובהפגנת ניגודים חדים בין גימורים מבריקים ומאטים.\n\nמידות:\nשולחן קפה א: קוטר: 38; גובה: 50 ס\"מ\nשולחן קפה ב: קוטר: 90; גובה: 28 ס\"מ\nשולחן קפה ג: קוטר: 60; גובה: 48 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Dione Dark Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Dark Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Dark Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Dark Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Dark Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Dione Dark Coffee Table/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/dione-dark-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 26470,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Ellipse Coffee Table": {
    "description": "שולחנות הקפה, המעוצבים בשני גדלים ושני גבהים, עשויים ממתכת. החלק העליון העגול הוא לוח מתכת בגימור סאטן רדיאלי מברונזה מט. הבסיס הוא צורת מפרש מעוקלת ממתכת מדורגת, עם גימור שחור מט פנימי וגימור ברונזה מט חיצוני. מושלמים כפי שהם, בודדים או בזוגות, הם מעניקים נופך אקספרסיבי ופיסולי לכל חלל, למרות הפשטות המעודנת שלהם.\n\nממדים:\nקוטר 40 ס\"מ; גובה 49 ס\"מ; עומק 18 ס\"מ\nקוטר 60 ס\"מ; גובה 39 ס\"מ; עומק 27 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Ellipse Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Ellipse Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Ellipse Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ellipse Coffee Table/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/ellipse-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 13501,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Fenpei Coffee Table": {
    "description": "משפחת פן-פיי כוללת שולחנות קפה מלבניים, חפצים דקורטיביים ורב-תכליתיים המציעים חלופה אסימטרית של צורות חיוניות. נפחים מלאים וריקים הנתמכים באותה בסיס מתכת כמו הספה עם גימור ברונזה מט צל. השולחנות עשויים מדיקט אש בעיבוד יד בצבעי זית כהה או זית בהיר, נועדו להדגיש הרמוניה גאומטרית של ניגודים מאוזנים באופן מושלם. מוצעים בשני גדלים, הם מוכיחים עצמם כריהוט רב-תכליתי ופונקציונלי שתוכנן עבור פילוסופיית חיים שמחבקת במלואה את המורכבות של האינטראקציות היומיומיות.\nמידות:\nשולחן קפה 102: אורך: 102 ס\"מ; גובה: 27 ס\"מ; עומק: 102 ס\"מ\nשולחן קפה 60: אורך: 60 ס\"מ; גובה: 27 ס\"מ; עומק: 27 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Fenpei Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Fenpei Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Fenpei Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Fenpei Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Fenpei Coffee Table/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/fenpei-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 23504,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "For Hall Coffee Table": {
    "description": "א | ב | ג\nשולחן הקפה For Hall הם סדרה של שולחנות נמוכים מקוריים ואלגנטיים, אידיאליים לריהוט חללי מגורים גם בשילוב עם גורמים אחרים. החלק העליון עשוי שיש והבסיס כולל רגליים ממתכת בגימור זהב מט.\nד\nהחלק העליון עשוי שיש והבסיס כולל רגליים ממתכת בגימור זהב מט. דגם ה זמין גם עם חלק עליון מזכוכית.\nמידות:\nא. רוחב 39 x גובה 39 ס\"מ\nב. רוחב 60 x גובה 27 ס\"מ\nג. רוחב 39 x גובה 49 ס\"מ\nד. רוחב 100 x גובה 50 ס\"מ\n",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/6.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/7.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/8.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/9.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/10.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/11.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/12.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/For Hall Coffee Table/13.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/for-hall-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 13882,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Hyperbole Coffee Table": {
    "description": "שולחן קפה Hyperbole\nØ32 – שולחן קפה עם משטח עשוי אבן טבעית ורגלי מתכת עם גימור סאטן אורביטלי בצבע שמפניה.\nØ40 – שולחן קפה עם משטח עשוי אבן טבעית ורגלי מתכת עם גימור סאטן אורביטלי בצבע שמפניה.\nØ80 – שולחן קפה עם משטח גרניט עתיק שחור עם פסים, מעוטר עם מוסיף מתכת מט בצבע שמפניה. רגלי מתכת עם גימור סאטן אורביטלי בצבע שמפניה.\nממדים:\nØ32: קוטר 31 x גובה 52 ס\"מ\nØ40: קוטר 40 x גובה 45 ס\"מ\nØ80: קוטר 80 x גובה 35 ס\"מ\n\nגלה את משפחת Hyperbole: מנורת Hyperbole",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Hyperbole Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Hyperbole Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Hyperbole Coffee Table/2.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Hyperbole Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Hyperbole Coffee Table/4.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Hyperbole Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Hyperbole Coffee Table/6.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Hyperbole Coffee Table/7.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/hyperbole-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 20142,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Imane Coffee Table": {
    "description": "שולחן קפה אימאן – קו חוץ\nIMANE היא האוסף החדש של כיסאות מרופדים ושולחנות קפה לשימוש חיצוני, שעוצבו על ידי תיירי למר, הוברט דה מאלרב ופאולו קסטלי. עשוי מחומרים טבעיים ובעבודת יד עד לפרטים הקטנים ביותר, IMANE הוא חלק מפרויקט GREENKISS הרחב יותר, הכולל את האוספים של החברה עם נשמה ירוקה.\nשולחן הקפה IMANE מצויד במבנה ליניארי מעץ איארו מוצק ומוברש, צבוע בשמן טבעי, עם קווים רכים וביטוייים המאזכרים את הפשטות של הריהוט היפני. החלק העליון, עשוי מטרוורטין עם טיפול הדוחה מים ושמן, יושב על המבנה ומעניק לכלל השולחן אפקט טבעי ולא צפוי.\nמבנה:\nעץ איארו מוצק, מוברש וצבוע בשמן טבעי\nחלק עליון מטרוורטין עם טיפול הדוחה מים ושמן\nמידות: אורך 100 ס”מ; רוחב 100 ס”מ\nגלה את כל משפחת אימאן: כורסת אימאן, ספת אימאן, מיטת יום אימאן, כיסא אימאן, שולחן אימאן.",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Imane Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Imane Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Imane Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imane Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imane Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imane Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imane Coffee Table/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/imane-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 13180,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Imperfect Coffee Table": {
    "description": "צד – שולחן קפה עשוי משלושה חומרים שונים. זכוכית שקופה בצבע הוואנה, רגל אחת משיש רוזה איגאו והרגל השנייה זהב מלוטש.\nזכוכית – שולחן קפה עשוי מזכוכית שקופה בצבע הוואנה.\nשיש – שולחן קפה משיש עם מסגרת עץ מצופה בלוחות שיש רוזה איגאו. בסיס מוסתר עשוי עץ מצופה צבע כהה.\nמתכת – שולחן קפה עשוי משלוש לוחות מתכת משולבות, בזהב מלוטש.\n\nמידות:\nצד: רוחב 46 ס\"מ x עומק 75 ס\"מ x גובה 51 ס\"מ\nזכוכית: רוחב 96 ס\"מ x עומק 95 ס\"מ x גובה 27 ס\"מ\nשיש: רוחב 107 ס\"מ x עומק 64 ס\"מ x גובה 25 ס\"מ\nמתכת זהב מבריק: רוחב 46 ס\"מ x עומק 75 ס\"מ x גובה 30 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/6.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/7.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Imperfect Coffee Table/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/imperfect-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 25525,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Ipanema Coffee Table": {
    "description": "שולחן קפה איפנמה, עם הנוכחות החיונית שלהם, משלימים את האלגנטיות הנצחית של הכיסאות. כמו כל קולקציית איפנמה, הם זמינים עם מבנה מתכת בגימור ניקל שחור מט התומך ומאבטח את המשטח השיש המלבני היקר בעובי 10 ס\"מ. השולחנות קפה זמינים בגימור שיש גרנד אנטיק, חומר איכותי, ובעץ פרקה מוצק ומבריק.\nמידות:\nאורך: 140 ס\"מ; עומק: 125 ס\"מ; גובה: 30 ס\"מ\nאורך: 101 ס\"מ; עומק: 104 ס\"מ; גובה: 35 ס\"מ\nגלה את קולקציית איפנמה: כורסה | ספה\n",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/2.gif",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/6.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/7.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/8.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/9.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/10.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/11.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/12.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Ipanema Coffee Table/13.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/ipanema-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 14156,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Kenya Coffee Table": {
    "description": "שולחן קפה קניה, גרגרי עץ פוגשים עורקי שיש, ויוצרים שבילים חדשים. מרקם לא ישר מתווה על המשטחים, מעורר נופים טבעיים ולא פגומים. קניה היא משפחת ריהוט בעלת אופי אדריכלי חזק, הצעה שלמה לאזור המגורים והאוכל הכוללת שולחן, קונסולה ושולחן קפה. הנפחים החסרים שאפיינו את המבנה של כל אלמנט משתלבים עם משטח השולחן המלבני, ומעניקים לאוסף מראה יוצא דופן שמביא כבוד לאסימטריה. המפגש החומרי בין רגלי העץ לבין משטח השיש מאפיין כל אלמנט, ומחייה את הפרופיל המינימלי עם פרטים מתוחכמים.\nחומרים\nבסיס: עץ\nמשטח: קוורציט, עץ\nגימורים\nבסיס: אפר מצופה אגוז\nמשטח: קוורציט בלו רומא, שיש משי לבן, אפר מצופה אגוז\n\nממדים CT 90: אורך 90×94: גובה 36 ס\"מ\nממדים CT 45: אורך 49X45; גובה 45 ס\"מ\n\nגלה את כל משפחת קניה: קונסולה קניה, שולחן מלבני קניה",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table/6.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/kenya-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 19199,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Kenya Coffee Table Outdoor": {
    "description": "משפחת הרהיטים של קניה מציגה שלב חדש לשיתוף בחוץ. הצעה המורכבת משולחן ראשי, שולחנות צד וקונסולה המצטיינת באופי אדריכלי חזק, היא מייצגת פתרון שלם וגמיש שמרפד באופי חללי מגורים ואוכל תחת כיפת השמיים. הנפחים המופחתים שמגדירים את המבנה של כל רכיב משתלבים עם משטח השולחן המלבני, וכך נותנים לאוסף מראה לא שגרתי שמכבד את הא-סימטריה. המפגש הטקסטורלי בין רגלי הפוליאוריטן בצפיפות גבוהה המוקפות בפלדת אל-חלד צבועה באפוקסי ומכוסה בתערובת של טרוורטין, לבין המשטח העליון העשוי מטרוורטין לבן או אדום, מאפיין כל רכיב דרך היופי הלא מושלם של אבן טבעית. משטחים בעלי מרקם לא סדיר מגדירים את הפתרון הדינמי הזה, ובכך מעוררים נוף טבעי ופרימיטיבי בתכלית.\n\nמידות:\nשולחן קפה 90: אורך: 94; גובה: 36; עומק: 90 ס\"מ\nשולחן קפה 45: אורך: 45; גובה: 46; עומק: 49 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table Outdoor/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table Outdoor/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table Outdoor/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table Outdoor/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table Outdoor/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table Outdoor/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Kenya Coffee Table Outdoor/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/kenya-coffe-table-outdoor/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 10092,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Lens Coffee Table": {
    "description": "שולחנות קפה עם בסיס מאבן ויצ'נזה בצבע שנהב, המורכב משלושה לוחות אנכיים המחוברים לדיסק מרכזי. המשטח העליון עשוי מזכוכית מורנו מנופחת בפה, עם אפקט גלי פנימי שמוסיף ליופיו של האובייקט. תחתית קמורה מאפשרת השתלבות של המשטח העליון מזכוכית בתוך מבנה הבסיס.\nמימדים:\nקוטר 45 ס\"מ; גובה 45 ס\"מ\nקוטר 60 ס\"מ; גובה 32 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/5.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/6.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/7.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/8.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Lens Coffee Table/9.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/lens-coffee-tables/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 25484,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Nettuno Coffee Table": {
    "description": "אוסף שולחנות קפה עם פשטות מתוחכמת של קווים, המוצעים עם בחירת חומרים איכותיים המציעה דרך שונה לתפוס חלל מגורים. משטח עליון מזכוכית מוזהבת עם צד אחד חלקית מראה (זמין גם משטח עליון מזכוכית צבועה מאחור), בסיס ממתכת מקופלת עם גימור מבריק, ברונזה כהה או זהב.\nמידות:\n\nרוחב 105 x עומק 105 x גובה 35 ס\"מ\nרוחב 120 x עומק 120 x גובה 25 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Nettuno Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Nettuno Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Nettuno Coffee Table/2.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/nettuno-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 15203,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Soft Ratio Coffee Table": {
    "description": "שולחן קפה אלגנטי שמשלים את ההצעה לסלון ומשתלב היטב עם קו המיכלים והספות Soft Ratio. הבסיס המתכתי בגימור שחור מאט עם רגלי מתכת כפולות בגימור ברונזה מבריקה, מדגיש את הקלות הכללית של הפרויקט, תומך במשטח העליון מזכוכית אקסטרה-קליר ובמשטח התחתון מטרוורטין. כמו כן זמין גם בזכוכית שקופה בגוון חום כהה למשטח העליון.\nמידות:\nאורך 122 ס\"מ x רוחב 122 ס\"מ x גובה 35 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/1.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/2.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/3.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/4.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/5.png",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/6.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/7.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/8.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/9.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/10.jpg",
      "../upload_images/PaoloCasteli/Coffee Tables/Soft Ratio Coffee Table/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/soft-ratio-coffee-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Coffee Tables",
    "price": 12946,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Indoor"
  },
  "Tray": {
    "description": "פאולו קסטלי עיצב את אוסף הקפסולות \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב.\nהצעה רב-תפקודית שמשלבת בין שימושיות ואסתטיקה, tray מורכב ממגש מעץ המצופה בעור אלגנטי בצבע חול שניתן להציב בנוחות על בסיס מתקפל חזק עשוי עץ אש ברגישות של אגוז. המגש ניתן לרכישה בנפרד.\nמידות:\nמגש Ø 75 x גובה 4 ס\"מ\nמגש עם מחזיק מגש Ø 75 x גובה 49 ס\"מ\nמדף למזוודות אורך 56, רוחב 57, גובה 45 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Complements/Tray/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Tray/1.png",
      "../upload_images/PaoloCasteli/Complements/Tray/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Tray/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Tray/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Tray/5.jpg",
      "../upload_images/PaoloCasteli/Complements/Tray/6.jpg",
      "../upload_images/PaoloCasteli/Complements/Tray/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/coffee-tables/tray/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 10050,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Accra Cache-Pot": {
    "description": "קופסאות שתילה מרשימות זמינות בשני גדלים. המבנה במתכת ברונזה אטומה בגוון צל קודר, מצופה בעור נובוק מודפס קלועה בגוון בז' (מק\"ט 15) ותומך בכד מאבן לצ'ה.\nמידות:\nאקרה דגם A קוטר 61 x גובה 93 ס\"מ\nאקרה דגם B קוטר 61 x גובה 121 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Complements/Accra Cache-Pot/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Accra Cache-Pot/1.png",
      "../upload_images/PaoloCasteli/Complements/Accra Cache-Pot/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Accra Cache-Pot/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/accra-cahepot/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 13732,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Best World": {
    "description": "אוסף Best World פותח את מגוון המראות המוארות, הזמינות בצורות ומידות שונות, שיכולות להתאים למספר חללים שונים, כגון חדרי שינה עיקריים אלגנטיים, כניסות וחללים נוספים בבית. Best World כולל מראה גדולה עם מסגרת מתכת מרהיבה, המעוצבת בגימור זהב מט אלגנטי. כל יצירה מהאוסף מצוידת, לאורך הקצה, במערכת תאורת LED מודרנית שמסבה את המראה למנורה, יוצרת אווירה ומפחיתה מקורות תאורה אחרים בחדר.\n\nהאוסף זמין בשלוש גרסאות: מתומנת, מלבנית, מרובעת.\n\nמידות:\nBest World מתומנת – רוחב 145 x עומק 6 x גובה 145 ס\"מ\nBest World מלבנית – רוחב 90 x עומק 15 x גובה 195 ס\"מ\nBest World מרובעת – רוחב 194 x עומק 15 x גובה 194 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Complements/Best World/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Best World/1.png",
      "../upload_images/PaoloCasteli/Complements/Best World/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/5.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/6.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/7.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/8.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/9.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/10.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/11.jpg",
      "../upload_images/PaoloCasteli/Complements/Best World/12.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/best-world/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 28953,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Coat Rack": {
    "description": "פאולו קסטלי מעצב את הקולקציה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב.\nמתלה מעילים נוח שנולד כפרשנות מחדש לצורות הגזוזטרה המסורתיות של ציירים, חפץ חיוני בחיי היומיום של האמן ג'ורג'יו מורנדי. המבנה החזק שמיוצר מעץ דשא בצבע אגוז, מקושט בפרטי מתכת ברונזה מט מספק אופי אמנותי וייחודי לחפץ. עם קיבולת משקל מקסימלית של 8 ק\"ג, מתלה מעילים זה הוא לא רק חפץ פרקטי אלא גם יצירת אמנות פונקציונלית שמעשירה את החלל.\nמידות:\nרוחב 62 x עומק 53 x גובה 165 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Complements/Coat Rack/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Coat Rack/1.png",
      "../upload_images/PaoloCasteli/Complements/Coat Rack/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Coat Rack/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Coat Rack/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Coat Rack/5.jpg",
      "../upload_images/PaoloCasteli/Complements/Coat Rack/6.jpg",
      "../upload_images/PaoloCasteli/Complements/Coat Rack/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/appendiabito/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 16976,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Convivier Bar Trolley": {
    "description": "עגלת ההגשה Convivier היא רהיט רב-תכליתי עם עיצוב אלגנטי ומעודן, מושלם לשדרוג חללים המוקדשים לחברותיות טהורה. זהו רהיט עם זהות חזקה, עכשווית ונצחית. לעגלת ההגשה הניידת הזו יש מסגרת מפלדה מצופה לכה ושני מדפי זכוכית זמינים בשתי גימורים שונים. הידית והגלגלים מכוסים בתבנית בד נבוק ארוגה. בזכות הממדים הקומפקטיים שלה, Convivier מתאים בצורה מושלמת לחללים בעלי זהות חזקה, ומציע משטח רחב לפריטים שלכם.\nממדים:\nרוחב 56 x עומק 97 x גובה 75 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/1.png",
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/2.png",
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/5.jpg",
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/6.jpg",
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/7.jpg",
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/8.jpg",
      "../upload_images/PaoloCasteli/Complements/Convivier Bar Trolley/9.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/convivier/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 27122,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Flare Screen": {
    "description": "מסך פסל מתוחכם ואלגנטי. פלייר הוא רהיט רב-תכליתי שיכול ליצור אשליות אופטיות מדהימות. יש לו מבנה מתכת מוזהב אטום ומשי הנושא משקל וגוף מרכזי דקורטיבי עשוי צינורות רדיאליים מאלומיניום מושחר. ניתן להתאים את גובה המסך ולהניח את האלמנט הדקורטיבי בשלושה שיפועים שונים. יצירה ייחודית של עיצוב שראוי להתגלות מחדש ביופיה העדין ובקסמה הנצחי.\nמידות:\nרוחב 136 x עומק 24 x גובה 186 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Complements/Flare Screen/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Flare Screen/1.png",
      "../upload_images/PaoloCasteli/Complements/Flare Screen/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Flare Screen/3.png",
      "../upload_images/PaoloCasteli/Complements/Flare Screen/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Flare Screen/5.jpg",
      "../upload_images/PaoloCasteli/Complements/Flare Screen/6.png",
      "../upload_images/PaoloCasteli/Complements/Flare Screen/7.jpg",
      "../upload_images/PaoloCasteli/Complements/Flare Screen/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/flare-screen/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 27541,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Frank Rug": {
    "description": "פרנק רוג, עיבוד גיאומטרי של הצורות מעניק חיים למוטיבים דקורטיביים מופשטים ואדריכליים, מה שהופך את השטיח לאביזר מעניין בשלב עם הזמנים אך מושרש בזיכרון. רמזים מזרמים אמנותיים של המאה ה-20 ממריצים את השטיחים החדשים של 2023, חלק מאוסף 'אללה סרה'. כל שטיח יוצר בהודו באמצעות טכניקת יד טופטינג. תערובת הצמר והוויסקוזה שבה השתמשו היא איכות חוטים חדשנית וביצועית גבוהה המאפשרת לשטיחים להתאים הן לחללים פרטיים והן לחללים מסחריים. מרק, וסילי, פאול, פיט, תיאו, פרנק, ג'קסון, ברידג'ט: כל שטיח מתאפיין באיזון של ניגודים בהתאם למחקר מעמיק של צבע וחומר שנערך על ידי החברה.\nמידות: 296 x 296 ס\"מ | 116 9/16″ x 116 9/16″",
    "image_url": "../upload_images/PaoloCasteli/Complements/Frank Rug/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Frank Rug/1.png",
      "../upload_images/PaoloCasteli/Complements/Frank Rug/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Frank Rug/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Frank Rug/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/frank-rug/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 19449,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Gong Decorative Object": {
    "description": "אובייקט קיר דקורטיבי מלכותי בקוטר של 2 מטרים. עם גונג, ההשפעה הוויזואלית של חומר קריסטלי וריגור פורמלי מתמזגות יחד באובייקט בעל משיכה מגנטית. פרבולה עשויה זכוכית מצופה כסף עם אפקט מחוספס שחוגגת את הנוזליות והקשר בין אור לחומר דרך התלתלים המושתלים על פני השטח. אובייקט נוזלי עם נשמה מסתורית שנוצרה באש, זמין בצבע ברונזה.\n\nמידות:\nקוטר: 200 ס\"מ, עומק: 18 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/1.png",
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/5.jpg",
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/6.jpg",
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/7.jpg",
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/8.jpg",
      "../upload_images/PaoloCasteli/Complements/Gong Decorative Object/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/gong/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 19555,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Head Bookend": {
    "description": "פאולו קסטלי מעצב את האוסף המיוחד \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב.\n\"Testa,\" תומך לספרים בצורת מקורית מעץ מלא ומוברש בגוון אגוז חם. פסל דיסקרטי שממזג מלאכת יד עם השראה הנובעת מהקומפוזיציות המינימליסטיות המעודנות של ג'ורג'יו מורנדי. חפץ של אלגנטיות מטאפיזית, שגולף על פניו השטוחות בלוח מתכת מעוצב בגימור ברונזה מט עם גוון פליז. השילוב של החומרים והצבעים יוצר משחק של ניגודים עדינים שמזכירים את הפשטות המתוחכמת הנמצאת ביצירותיו של המאסטר.\nמידות:\n17 x 16 x H 29 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Objects/Head Bookend/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Head Bookend/1.png",
      "../upload_images/PaoloCasteli/Objects/Head Bookend/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Head Bookend/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Head Bookend/4.jpg",
      "../upload_images/PaoloCasteli/Objects/Head Bookend/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/head-bookend/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 15065,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Infinity Mirror": {
    "description": "מראת אינסוף, מראה בעלת קווי מתאר מעוגלים עם תאורת רקע היוצרת השתקפויות עיצוב ייחודיות. אינסוף ממציאה מחדש את קונספט המראה במפתח עכשווי, והופכת אותו מאובייקט פשוט ופונקציונלי לפיסת ריהוט דקורטיבית. הפרופילים הכהים בגימור ניקל משתחררים ממגבלות המסגרת, ויוצרים משחק פרספקטיבה שבו נראה כי המראה נמשכת אל האינסוף, מאירה ומעטרת את הקיר שבו היא ממוקמת.\nחומרים:\nמבנה: מתכת\nגוף מרכזי: מראה\nגימורים:\nמבנה: ניקל שחור\nמקור אור: LED\nהספק כולל: 69W / מתח: 220-240 V / שטף אור נמדד: 2277 ל\"מ / טמפרטורת צבע: 3000°K / אינדקס עיבוד צבע: CRI 90 סטנדרטי / פונקציית עמעום: כן\nמידות:\nרוחב 102 ס\"מ, גובה 102/4 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Complements/Infinity Mirror/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Infinity Mirror/1.png",
      "../upload_images/PaoloCasteli/Complements/Infinity Mirror/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Infinity Mirror/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Infinity Mirror/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Infinity Mirror/5.jpg",
      "../upload_images/PaoloCasteli/Complements/Infinity Mirror/6.jpg",
      "../upload_images/PaoloCasteli/Complements/Infinity Mirror/7.jpg",
      "../upload_images/PaoloCasteli/Complements/Infinity Mirror/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/infinity-mirror/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 15948,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Jackson Rug": {
    "description": "ג'קסון שטיח, עיבוד גאומטרי של הצורות נותן חיים למוטיבים דקורטיביים מופשטים ואדריכליים, מה שהופך את השטיח לאביזר מעניין ועכשווי אך מושרש בזיכרון. השראות מהזרמים האמנותיים של המאה ה-20 מפיחות חיים בשטיחי 2023 החדשים, חלק מאוסף 'אלה סרה'. כל שטיח מיוצר בהודו באמצעות טכניקת הטפטוף ביד. התערובת של צמר וויסקוזה בשימוש היא איכות חוט חדשנית וגבוהת ביצועים שמאפשרת לשטיחים להתאים לחללים פרטיים וציבוריים כאחד. מארק, ואסיליי, פול, פיט, תיאו, פרנק, ג'קסון, ברידג'ט: כל שטיח מתאפיין באיזון של ניגודים בהתאם למחקר המעמיק של צבע וחומר שנערך על ידי החברה.\nמידות: 400 x 400 ס\"מ | 157 1/2\" x 157 1/2\"",
    "image_url": "../upload_images/PaoloCasteli/Complements/Jackson Rug/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Jackson Rug/1.png",
      "../upload_images/PaoloCasteli/Complements/Jackson Rug/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Jackson Rug/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Jackson Rug/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/jackson-rug/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 29926,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Maputo Cache-Pot": {
    "description": "הכוח של אבן גיר טבעית (בצבע לבן עבור מצב A ו-B, וצבע אפור-יונה עבור דגם C) מדגיש את הירוק של העלווה בסדרת אגרטלים זו עם מבנה מתכת שחודדו בגימור ברונזה אטומה.\nמידות:\nדגם מפוטו A: קוטר 47 x גובה 60 ס\"מ\nדגם מפוטו B: קוטר 47 x גובה 75 ס\"מ\nדגם מפוטו C: קוטר 56 x גובה 100 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Complements/Maputo Cache-Pot/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Maputo Cache-Pot/1.png",
      "../upload_images/PaoloCasteli/Complements/Maputo Cache-Pot/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Maputo Cache-Pot/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Maputo Cache-Pot/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Maputo Cache-Pot/5.jpg",
      "../upload_images/PaoloCasteli/Complements/Maputo Cache-Pot/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/maputo-cachepot/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 10300,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor & Outdoor"
  },
  "Mark Rug": {
    "description": "שטיח מארק, עיבוד מחדש גיאומטרי של הצורות מעניק חיים למוטיבים דקורטיביים מופשטים ואדריכליים, מה שהופך את השטיח לאביזר מעניין בעידן הנוכחי אך מושרש בזיכרון. השראות מזרמי האמנות של המאה ה-20 מחיות את השטיחים החדשים של שנת 2023, שהם חלק מאוסף 'אלה סרה'. כל שטיח ושטיח יוצר בהודו בטכניקת אריגת יד. תערובת הצמר והויסקוזה שבה נעשה שימוש היא איכות חוט חדשנית ובעלת ביצועים גבוהים, המאפשרת לשטיחים להתאים גם לחללים פרטיים וגם לחללים תעשייתיים. מארק, ואסילי, פול, פייט, תיאו, פרנק, ג'קסון, ברידג'ט: כל שטיח מאופיין באיזון של ניגודים בהתאמה למחקר מעמיק של צבע וחומר שנעשה על ידי החברה.\nממדים: 300 x 415 ס\"מ | 118 1/8″ x 163 3/8″",
    "image_url": "../upload_images/PaoloCasteli/Complements/Mark Rug/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Mark Rug/1.png",
      "../upload_images/PaoloCasteli/Complements/Mark Rug/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Mark Rug/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Mark Rug/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/mark-rug/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 24705,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Paul Rug": {
    "description": "פול רוג, עיבוד גיאומטרי מחדש של הצורות מעניק חיים למוטיבים דקורטיביים מופשטים וארכיטקטוניים, מה שהופך את השטיח לאביזר מעניין שמתקדם עם הזמן אך מושרש בזיכרון. הצעות מהזרמים האמנותיים של המאה ה-20 מעניקים חיים לשטיחים החדשים של 2023, שהם חלק מאוסף 'אללה סרה'.\nכל שטיח ושטיח יוצר בהודו באמצעות טכניקת טפטינג ידנית. תערובת השנייה של צמר ויסקוזה היא איכות חוטים חדשנית ובעלת ביצועים גבוהים המאפשרת לשטיחים להתאים גם לחללים פרטיים וגם לחללים מסחריים. מארק, וסיליי, פול, פיט, תיאו, פרנק, ג'קסון, ברידג'ט: כל שטיח נבדל באיזון של ניגודים בהתאם לחקר הצבע והחומרים המעמיק שביצעה החברה.\nמידות: 300 x 300 ס\"מ | 118 1/8″ x 118 1/8″",
    "image_url": "../upload_images/PaoloCasteli/Complements/Paul Rug/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Paul Rug/1.png",
      "../upload_images/PaoloCasteli/Complements/Paul Rug/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Paul Rug/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Paul Rug/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Paul Rug/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/paul-rug/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 11663,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Piatti D’autore": {
    "description": "פאולו קסטלי מעצב את קולקציית הקפסולה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדו שיח פתוח בין אמנות, היסטוריה ועיצוב. \nPiatti d'Autore הוא סט של צלחות קרמיקה מוייטרי, מזוגגות וצבועות ביד בצבעים שמקורם בפלטת הצבעים המעודנת של יצירותיו של ג'ורג'ו מורנדי. כל צלחת, ייחודית ובלתי ניתנת לשחזור בעיצובה, מחקה את פלטת המאסטר, עם גוונים חמים המנוגדים למשטח החלק של הקרמיקה. הזמנה לכל מי שמבחין בהן לשקוע ביופי הפשטות. Piatti d'Autore הופכות כל ארוחה לחוויה אסתטית, ויוצרות מיזוג הרמוני בין אמנות לשולחן האוכל.\nמידות:\nצלחת מנה עיקרית Ø 25 ס\"מ\nצלחת מרק Ø 18 ס\"מ\nקערית קטנה Ø 14 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Objects/Piatti D’autore/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/1.png",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/4.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/5.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/6.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/7.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/8.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/9.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/10.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/11.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/12.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/13.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/14.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/15.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/16.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/17.jpg",
      "../upload_images/PaoloCasteli/Objects/Piatti D’autore/18.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/artistic-serving-plates/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 20609,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Piet Rug": {
    "description": "שטיח פייט, עיבוד גיאומטרי מחדש של הצורות מעניק חיים למוטיבים דקורטיביים מופשטים ואדריכליים, מה שהופך את השטיח לאביזר מעניין שמשתלב עם זמננו אך מושרש בזיכרון. שטיח פייט, הצעות מזרמי האמנות של המאה ה-20 מחיות את השטיחים החדשים של שנת 2023, כחלק מאוסף \"אללה סרה\". כל שטיח ושטיח יוצר בהודו בטכניקת טפטינג ידנית. השילוב של צמר ווויסקוזה שמשתמשים בו הוא באיכות חוט חדשנית וביצועית גבוהה שמאפשרת לשטיחים להתאים הן לחללים פרטיים והן לחללי חוזים. מרק, וסילי, פול, פייט, תיאו, פרנק, ג'קסון, ברידג'ט: כל שטיח מתאפיין באיזון בין ניגודים בהתאם למחקר מעמיק בצבע וחומר שביצעה החברה.\nמידות: 400 x 400 ס\"מ | 157 1/2\" x 157 1/2\"",
    "image_url": "../upload_images/PaoloCasteli/Complements/Piet Rug/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Piet Rug/1.png",
      "../upload_images/PaoloCasteli/Complements/Piet Rug/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Piet Rug/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Piet Rug/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/piet-rug/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 29026,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Theo Rug": {
    "description": "תיאו רוג, עיבוד גיאומטרי של הצורות נותן חיים למוטיבים דקורטיביים אבסטרקטיים ואדריכליים, והופך את השטיח לאביזר מעניין ועכשווי המושרש בזיכרון. ההשראה מהזרמים האמנותיים של המאה ה-20 מעוררת את השטיחים החדשים של 2023, חלק מאוסף 'אללה סרה'. כל שטיח מיוצר בהודו בטכניקת טפטוף ידני. תערובת של צמר וויסקוזה היוצרת איכות חוטים חדשנית וביצועית, המאפשרת לשטיחים להשתלב הן במרחבים פרטיים והן במרחבים מסחריים. מארק, ואסילי, פול, פיט, תיאו, פרנק, ג'קסון, ברידג'יט: כל שטיח מאופיין באיזון של ניגודים, בהתאם למחקר מעמיק בצבע ובחומר שערכה החברה.\nמימדים: 400 x 400 ס\"מ | 157 1/2″ x 157 1/2″",
    "image_url": "../upload_images/PaoloCasteli/Complements/Theo Rug/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Theo Rug/1.png",
      "../upload_images/PaoloCasteli/Complements/Theo Rug/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Theo Rug/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/theo-rug/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 25679,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Vasilij Rug": {
    "description": "שטיח ואסילי, עיבוד גאומטרי של הצורות מעניק חיים למוטיבים דקורטיביים מופשטים ואדריכליים, מה שהופך את השטיח לאביזר מעניין שמתאים לזמננו אך מושרש בזיכרון. רמיזות מהזרמים האומנותיים של המאה ה-20 מחיות את השטיחים החדשים לשנת 2023, שהם חלק מאוסף \"אלה סרה\". כל שטיח יוצר בהודו באמצעות טכניקת הלולאה הידנית. התערובת של צמר וצמיג היוצאת דופן היא באיכות חוטים חדשנית ובעלת ביצועים גבוהים, המאפשרת לשטיחים להיכנס הן לחללים פרטיים והן לחללים ציבוריים. מאק, ואסילי, פול, פיט, תיאו, פרנק, ג'קסון, ברידג'ט: כל שטיח ייחודי במאזן הניגודים שלו, בהתאם למחקר העמוק על צבע וחומרים שנערך על ידי החברה.\nמימדים: 300 x 400 ס\"מ | 118 1/8″ x 157 1/2″",
    "image_url": "../upload_images/PaoloCasteli/Complements/Vasilij Rug/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Complements/Vasilij Rug/1.png",
      "../upload_images/PaoloCasteli/Complements/Vasilij Rug/2.jpg",
      "../upload_images/PaoloCasteli/Complements/Vasilij Rug/3.jpg",
      "../upload_images/PaoloCasteli/Complements/Vasilij Rug/4.jpg",
      "../upload_images/PaoloCasteli/Complements/Vasilij Rug/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/complements/vasilij-rug/",
    "company_name": "Paolo Casteli",
    "original_category": "Complements",
    "price": 11947,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Alba Console": {
    "description": "קונסולת אלבה, בחירה מתוחכמת לאזור מגורים המותאם אישית בכל פרט ופרט, אוסף שמוביל את המינימליזם לקישוט. זמין עם משטחים עגולים ומלבניים, שולחן אלבה וקונסולת אלבה הם תוצאה של שילוב בין גימורים וצורות שונות שמעניקים למשפחת הרהיטים זהות ברורה שבה הכוח הביטוי של החומרים מעצים את העבודה האישית. למעשה, אוסף אלבה מוצא את סימן ההיכר שלו במפגש בין המעגל והגליל שיוצרים את החיבור בין הבסיס והמשטח, פרט אסתטי טכני אלגנטי שמרומם את כל הצורה.\n\nחומרים:\nמבנה: מתכת\nמשטח: אבן\nבסיס: אבן\n\nגימורים:\nמבנה: גימור מט צלליות ברונזה\nמשטח: אבן ויצ'נצה מבריק בצבע שנהב\nבסיס: אבן ויצ'נצה מבריק בצבע שנהב\n\nמימדים:\nאורך: 150 ס\"מ רוחב: 43 ס\"מ גובה: 75 ס\"מ\n\nגלה את כל משפחת אלבה: שולחן אלבה, שולחן אלבה ביסטרו",
    "image_url": "../upload_images/PaoloCasteli/Console/Alba Console/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Console/Alba Console/1.png",
      "../upload_images/PaoloCasteli/Console/Alba Console/2.jpg",
      "../upload_images/PaoloCasteli/Console/Alba Console/3.jpg",
      "../upload_images/PaoloCasteli/Console/Alba Console/4.jpg",
      "../upload_images/PaoloCasteli/Console/Alba Console/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/console/alba-console/",
    "company_name": "Paolo Casteli",
    "original_category": "Console",
    "price": 11690,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "For Hall Console": {
    "description": "הוא מורכב ממשטח אובלי עם פינות מעוגלות משיש יקר. הבסיס כולל 7 רגלי מתכת בציפוי זהב מט, המסודרות בזוויות שונות ומרותכות לדיסק מתכת שמקובע למשטח השולחן עם ברגי מתכת. עובי המשטח 2 ס\"מ.\nמידות:\nאורך: 150 ס\"מ; עומק: 45 ס\"מ; גובה: 74 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Console/For Hall Console/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Console/For Hall Console/1.png",
      "../upload_images/PaoloCasteli/Console/For Hall Console/2.jpg",
      "../upload_images/PaoloCasteli/Console/For Hall Console/3.jpg",
      "../upload_images/PaoloCasteli/Console/For Hall Console/4.jpg",
      "../upload_images/PaoloCasteli/Console/For Hall Console/5.jpg",
      "../upload_images/PaoloCasteli/Console/For Hall Console/6.jpg",
      "../upload_images/PaoloCasteli/Console/For Hall Console/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/console/for-hall-console/",
    "company_name": "Paolo Casteli",
    "original_category": "Console",
    "price": 17505,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Kenya Console": {
    "description": "קונסולה קניה, גרגרי העץ נפגשים עם עורקי השיש, משרטטים דרכים חדשות. מרקם לא סדיר מתוחם על פני השטח, מעורר נופים טבעיים ולא מקולקלים. \"קניה\" היא משפחת רהיטים בעלת אופי אדריכלי חזק, הצעה כוללת לאזור המגורים והאוכל הכוללת שולחן, קונסולה ושולחן קפה. הנפחים המופחתים שמאפיינים את המבנה של כל אלמנט משתלבים עם השולחן המלבני, ויוצרים מראה לא שגרתי שמכבד את האסימטריה. המפגש החומרי בין רגלי העץ והמשטח העליון משיש מאפיין כל אלמנט, ומוסיף לפרופיל המינימלי פרטים מתוחכמים.\n\nחומרים:\nבסיס: עץ\nמשטח עליון: קוורציט, עץ\n\nגימורים:\nבסיס: עץ אדר צבוע כאגוז\nמשטח עליון: קוורציט Blue Roma, שיש White Silk, אדר צבוע כאגוז\n\nמידות: אורך 153X39; גובה 60 ס\"מ\nגלו את כל משפחת קניה: שולחן מלבני קניה, שולחן קפה קניה",
    "image_url": "../upload_images/PaoloCasteli/Console/Kenya Console/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Console/Kenya Console/1.png",
      "../upload_images/PaoloCasteli/Console/Kenya Console/2.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/3.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/4.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/5.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/6.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/7.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/8.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/9.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/10.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/11.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/12.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/13.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/14.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Console/15.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/console/kenya-console/",
    "company_name": "Paolo Casteli",
    "original_category": "Console",
    "price": 19830,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Kenya Outdoor Console": {
    "description": "משפחת הרהיטים של קניה מציגה שלב חדש לשיתוף מחוץ לבית. הצעה שמורכבת משולחן מרכזי, שולחנות צד וקונסולה בעלת אופי ארכיטקטוני חזק, המייצגת פתרון שלם ורב-תכליתי שמרוה באופי מרחבי מגורים ואכילה תחת כיפת השמיים. הנפחים החסרים המגדירים את מבנה כל אלמנט משתלבים עם השולחן המלבני, מה שמעניק לאוסף מראה יוצא דופן שמכבד את חוסר הסימטריה. המפגש המרקמי בין רגלי הפוליאוריתן בצפיפות גבוהה שמוסגרו בנירוסטה צבועה באפוקסי ומכוסות בתערובת טראוורטין, ובין המשטח שלו עשוי טראוורטין לבן או אדום, מאפיין כל אלמנט באמצעות היופי הבלתי מושלם של האבן הטבעית. משטחים במרקם לא סדיר מגדירים את הפתרון הדינמי הזה, מה שמעלה מיד בנו נופים טבעיים וטהורים.\n\nמידות:\nקונסולה: אורך: 155; גובה: 60; עומק: 40 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Console/Kenya Outdoor Console/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Console/Kenya Outdoor Console/1.png",
      "../upload_images/PaoloCasteli/Console/Kenya Outdoor Console/2.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Outdoor Console/3.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Outdoor Console/4.jpg",
      "../upload_images/PaoloCasteli/Console/Kenya Outdoor Console/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/console/kenya-console-outdoor/",
    "company_name": "Paolo Casteli",
    "original_category": "Console",
    "price": 29759,
    "filter_category": "קונסולות וארונות",
    "placement": "Outdoor"
  },
  "Nucleo Console": {
    "description": "נוקלאו חוגגת את הטבעיות הטהורה של צורות וחומרים, ובכך מציעה פתרונות המעדיפים אופנות ביומורפיות, מושלמות באי-שלמותן. השולחן הראשי, שולחן הטרקלין והקונסולה, שנעשו במיומנות על ידי ידי אומן מומחה באיזון אסתטי של נפחים מאוזנים, מוגברים על ידי צורות דינמיות וחומרים בעלי אופי חזק. השולחן הראשי והקונסולה מוגדרים על ידי צללית פיסולית שנוצרה באמצעות השימוש הדקורטיבי והמבני בדולומיה, אבן טבעית מקומית המהווה סמל זהות של הרי איטליה. הברק הגירי של המינרל משלים את המבנה התומך בגימור מתכת מט קלמין או ברונז שאדו, הנראה דרך החתכים המתאפיינים במחקר האסתטי של רגלי השולחן, התומכות במשטח בסגנון אסימטרי ובלתי צפוי.\n\nבשולחן הטרקלין, עץ ומתכת משלימים זה את זה, ויוצרים שלמות הרמונית בעלת זהות חזקה. התוצאה היא תזכורת לפשטות המורכבת שמלווה באופן הרמוני את החברות, הפעולות והיחסים שמתוכננים סביב השולחן.\n\nמידות:\nקונסולה: אורך: 158 ס\"מ; גובה: 73 ס\"מ; עומק: 46 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Console/Nucleo Console/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Console/Nucleo Console/1.png",
      "../upload_images/PaoloCasteli/Console/Nucleo Console/2.jpg",
      "../upload_images/PaoloCasteli/Console/Nucleo Console/3.jpg",
      "../upload_images/PaoloCasteli/Console/Nucleo Console/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/console/nucleo-console/",
    "company_name": "Paolo Casteli",
    "original_category": "Console",
    "price": 27972,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Selima Console": {
    "description": "קונסולה עשויה מעץ מילה מוצק ידידותי לסביבה, זמינה בשלוש אפשרויות: מילה טבעית עם גימור חומצי, גרסה מולבנת או מוכתמת אגוז עם גימור נקבובית פתוחה. בתהליך זה הנקבוביות של העץ נשארות פתוחות במכוון, ובכך מאפשרות לשכבה העליונה לשמור על המראה הטבעי שלה. מסגרות הקונסולה מעוטרות בתוספות עור למינציה בגוון שמפניה מט.\nמידות:\nרוחב 160 ס\"מ, עומק 38 ס\"מ, גובה 80 ס\"מ\nגילוי משפחת סלימה: כיסא סלימה, ארונית טלוויזיה סלימה, שולחן צד סלימה\n\n",
    "image_url": "../upload_images/PaoloCasteli/Console/Selima Console/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Console/Selima Console/1.png",
      "../upload_images/PaoloCasteli/Console/Selima Console/2.jpg",
      "../upload_images/PaoloCasteli/Console/Selima Console/3.jpg",
      "../upload_images/PaoloCasteli/Console/Selima Console/4.jpg",
      "../upload_images/PaoloCasteli/Console/Selima Console/5.jpg",
      "../upload_images/PaoloCasteli/Console/Selima Console/6.jpg",
      "../upload_images/PaoloCasteli/Console/Selima Console/7.png",
      "../upload_images/PaoloCasteli/Console/Selima Console/8.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/console/selima-console/",
    "company_name": "Paolo Casteli",
    "original_category": "Console",
    "price": 11766,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Anodine Floor": {
    "description": "מנורת הרצפה אנודיין היא מנורת רצפה עומדת הממירה אור לפסל המעורר את הקונספט של \"צורה ללא צורה\" של האור, ומוסיפה נגיעה אמנותית לאווירה. היא כוללת 13 גבעולים מבריקים מנחושת הצמודים לבסיס מתכת מרובע בגימור ״זהב מט״, חלקם מעוטרים בעלי מתכת, כולם א-סימטריים ועשויים בעבודת יד על ידי אומנים מומחים, בגימור זהב מט. מושלמת כזוג ליצירת סימטריה נכונה בחדר. הודות לטכניקות ייצור ועבודת יד, כל חלק בקולקציה הוא ייחודי.\nמידות:\nרוחב 36 x עומק 25 x גובה 184 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Lighting/Anodine Floor/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/1.png",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/2.jpg",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/3.png",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/4.jpg",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/5.jpg",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/6.jpg",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/7.jpg",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/8.jpg",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/9.jpg",
      "../upload_images/PaoloCasteli/Lighting/Anodine Floor/10.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/floor-lamps/anodine-floor-2/",
    "company_name": "Paolo Casteli",
    "original_category": "Lighting",
    "price": 10170,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Comet Floor": {
    "description": "בשמחה! הנה התרגום לעברית:\n\n\"הכוכב השביט\" הוא מנורת רצפה עם בסיס מעץ אגוז קנלטו משומן או מעץ בעל גימור אבץ למתכת חומצני, מעוטרת בתוספת פליז בגימור מט סאטן.  \nאהיל בצורת טבעת עשוי מבד טבעי בצבע שנהב.\nמידות:\nרוחב: 75 ס\"מ, עומק: 14 ס\"מ, גובה: 139 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Lighting/Comet Floor/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Lighting/Comet Floor/1.png",
      "../upload_images/PaoloCasteli/Lighting/Comet Floor/2.png",
      "../upload_images/PaoloCasteli/Lighting/Comet Floor/3.jpg",
      "../upload_images/PaoloCasteli/Lighting/Comet Floor/4.png",
      "../upload_images/PaoloCasteli/Lighting/Comet Floor/5.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/floor-lamps/comet-floor/",
    "company_name": "Paolo Casteli",
    "original_category": "Lighting",
    "price": 18640,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Fanus Floor": {
    "description": "פאנוס פלור, מנורה שנועדה להאיר חלל ולספק אינטימיות של צל. מופעלת על ידי מקור אור לד, פאנוס מפרש מחדש את מושג הפנס, שמתאפיין בגוף תאורה מרכזי עשוי זכוכית שקופה משומרת ואהיל זמין בבד או בזכוכית מוראנו. פרטים מעור כויאטו טבעי מעטרים את המוצר כולו, והופכים את פאנוס לעיצוב עכשווי ביותר, זמין בגרסת תלויה, רצפה ושולחן עם כבל וסוללה.\n\nחומרים:\nמבנה: מתכת\nבסיס: אבן\nאהיל: זכוכית, בד\nגוף תאורה: זכוכית\n\nגימורים:\nמבנה: עור בצבע טבעי, מתכת מגולוונת בצבע מט שחור RAL 9004, פליז טבעי\nבסיס: טרוורטין\nאהיל: זכוכית מוראנו צבע ענבר או בד צבע שנהב טבעי\nגוף תאורה: זכוכית מוראנו שקופה מנופחת עם פסים\n\nמקור אור: Illuminatore CC LED\nהספק כולל: 16.6W / מתח כניסה (נהג): 220-240V /\nשטף אור: 1800 lm / טמפרטורת צבע: 3000°K /\nמדד רינדור צבע: 80 / פונקציית דימר: לא\n\nמידות: אורך 40/196/27; גובה 240/44/40 ס\"מ\nגלו את כל משפחת פאנוס: פאנוס שולחן, פאנוס תלוי",
    "image_url": "../upload_images/PaoloCasteli/Lighting/Fanus Floor/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Lighting/Fanus Floor/1.png",
      "../upload_images/PaoloCasteli/Lighting/Fanus Floor/2.jpg",
      "../upload_images/PaoloCasteli/Lighting/Fanus Floor/3.jpg",
      "../upload_images/PaoloCasteli/Lighting/Fanus Floor/4.jpg",
      "../upload_images/PaoloCasteli/Lighting/Fanus Floor/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/floor-lamps/fanus-floor/",
    "company_name": "Paolo Casteli",
    "original_category": "Lighting",
    "price": 19020,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Icone Luminose": {
    "description": "פאולו קסטלי מעצב את קולקציית הקפסולה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב. מנורות רצפה דמויות טוטם, מעוצבות בקפידה בשיטת ניפוח הזכוכית המסורתית של מוראנו. סדרת Luminous Icons כוללת ארבעה דגמים היכולים להקרין אור משלהם, כל אחד מהם מוגדר במבנה מתכתי בגימור זהב מט, המקושט בשילוב של ארבעה אלמנטים מזכוכית בערימה אחד מעל השני, המובחנים בגאומטריות וצבעים שונים. הצעה חיונית, אינטנסיבית ומוארת, המסוגלת להביא אנרגיה כרומטית בלתי צפויה לחללים פנימיים.\nממדים:\nØ 24 x 123 ס\"מ\nØ 24 x 94 ס\"מ\nØ 24 x 132 ס\"מ\nØ 24 x 126 ס\"מ\nגלו את משפחת Icone: מנורת שולחן Icone Luminose, Icone Sileziose",
    "image_url": "../upload_images/PaoloCasteli/Lighting/Icone Luminose/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/1.png",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/2.jpg",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/3.jpg",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/4.jpg",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/5.png",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/6.png",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/7.png",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/8.png",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/9.png",
      "../upload_images/PaoloCasteli/Lighting/Icone Luminose/10.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/floor-lamps/icone-luminose/",
    "company_name": "Paolo Casteli",
    "original_category": "Lighting",
    "price": 19981,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Manta Floor": {
    "description": "רצפת מנטה, כיפוף חומר לאמנות, מנורה שדומה לעלה שמסתובב בעדינות בחדר. משפחת מנורות מנטה כוללת גרסאות רצפה ושולחן, ומרחיבה את מגוון מערכות התאורה המאופיינות בקלות אתראלית ובאלגנטיות פשוטה. מקור האור לד, עלה זכוכית מעודן בצבע פומה או ענבר, מעוצב ביד על ידי אומני זכוכית מוכשרים במוראנו, מאיר את החדר בחום טבעי ויוצר אווירה עוטפת של הרמוניה מוחלטת.\nחומרים\nגוף התאורה: זכוכית\nמבנה: פליז\nגימורים\nזכוכית: צבע פומה ענבר\nפליז: טבעי\nמקור אור: לד\nהספק כולל: 10W / מתח: 220-240 V / שטף אור נומינלי: 800 ל\"מ / טמפרטורת צבע: 3000°K / מדד רנדור צבעים: סטנדרטי CRI>80 / פונקציית דימר: אין\n\nמידות: אורך 35 ס\"מ; גובה 163 ס\"מ\n\nגלה את כל משפחת מנטה: מנטה תלייה, מנטה שולחן",
    "image_url": "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/1.png",
      "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/2.jpg",
      "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/3.jpg",
      "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/4.jpg",
      "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/5.jpg",
      "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/6.jpg",
      "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/7.jpg",
      "../upload_images/PaoloCasteli/Floor Lamps/Manta Floor/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/floor-lamps/manta-floor/",
    "company_name": "Paolo Casteli",
    "original_category": "Floor Lamps",
    "price": 16661,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "My Lamp Floor": {
    "description": "מנורת הרצפה שלי היא מנורה עומדת, המתהדרת בצורה אלגנטית שמביאה אור ואווירה חמימה לכל חלל. בין אם בודדת או בזוג, ליצירת סימטריה מושלמת, היא מעשירה ומוסיפה אופי לכל חדר. המנורה כוללת בסיס מתכתי ומבנה עם גימור גלווני זהב מט וצינורות גליליים פתוחים המיוצרים מזכוכית בורוסיליקט ונציאנית.\nמידות:\nקוטר 37 x גובה 211 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Lighting/My Lamp Floor/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Lighting/My Lamp Floor/1.png",
      "../upload_images/PaoloCasteli/Lighting/My Lamp Floor/2.jpg",
      "../upload_images/PaoloCasteli/Lighting/My Lamp Floor/3.jpg",
      "../upload_images/PaoloCasteli/Lighting/My Lamp Floor/4.jpg",
      "../upload_images/PaoloCasteli/Lighting/My Lamp Floor/5.jpg",
      "../upload_images/PaoloCasteli/Lighting/My Lamp Floor/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/floor-lamps/my-lamp-floor/",
    "company_name": "Paolo Casteli",
    "original_category": "Lighting",
    "price": 23181,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Soreluna": {
    "description": "מנורה מעוגנת לתקרה הכוללת כבל מוט מרכזי ומשקולת קרקע עשויה מתכת – בגימור שחור מט. כבל המתיחה המרכזי נושא שלוש מנורות קוניות עשויות מתכת, עם גימור זהב מט ופליטת אור עם לוחות LED מעגליים. הבסיס התקרתי תמיד בצורה קונית, עשוי מתכת עם גימור זהב מט. לפי בקשה ניתן להוסיף תושבת קיר אופציונלית.\nזמין גם בגרסה לתלייה על הקיר.\nמידות:\nקוטר: 8 ס\"מ, עומק: 11 ס\"מ, גובה מקסימלי: 420 ס\"מ\n(תושבת קיר אופציונלית: רוחב: 19 ס\"מ, עומק: 3 ס\"מ, גובה: 11 ס\"מ)",
    "image_url": "../upload_images/PaoloCasteli/Lighting/Soreluna/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Lighting/Soreluna/1.png",
      "../upload_images/PaoloCasteli/Lighting/Soreluna/2.png",
      "../upload_images/PaoloCasteli/Lighting/Soreluna/3.jpg",
      "../upload_images/PaoloCasteli/Lighting/Soreluna/4.jpg",
      "../upload_images/PaoloCasteli/Lighting/Soreluna/5.jpg",
      "../upload_images/PaoloCasteli/Lighting/Soreluna/6.jpg",
      "../upload_images/PaoloCasteli/Lighting/Soreluna/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/lighting/soreluna/",
    "company_name": "Paolo Casteli",
    "original_category": "Lighting",
    "price": 17042,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Allure Supension": {
    "description": "האולר היא מנורה עדינה ומרשימה, עשויה כולה בעבודת יד על פי טכניקות המסורתיות של מוראנו. טיפות הצבע מקריסטל ונציאני (22 טיפות ו-6 נקודות לגרסה האובלית ו-23 טיפות ו-5 נקודות לגרסה העגולה), הממוקמות בגבהים שונים, עשויות זכוכית מוראנו מוצקה המכילה עלה זהב יקר 24 קראט. בגימור הזהב, החלק העליון עשוי מפליז וכולל תמיכה לתאורת LED מודרנית. הפלטה העליונה מחוברת לפלטת פלדה צבועה לבן מט RAL 9016, שחור RAL 9005, זהב. היא זמינה ב-3 גרסאות: אובלי עם שישה מוקדי תאורה משולבים, עגול עם חמישה מוקדי תאורה משולבים וצידי.\nמידות:\nאובלי: ר. 140 x ע. 46 x ג. 200 ס\"מ\nעגול: קוטר 86 x ג. 200 ס\"מ\nצידי: קוטר 30 x ג. 200 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/3.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/7.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/8.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/9.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/10.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/11.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Allure Supension/12.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/allure-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 17576,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Ambra Table": {
    "description": "אמברה היא מנורה שולחן אידיאלית ליצירת נקודות תאורה חמות ואלגנטיות בסלונים, חדרי שינה ראשיים וחדרי אירוח אלגנטיים. היא כוללת מוט פליז עם גימור פליז מוברש בגוון ברונזה מאט, ועליו דיסקיות לוסיט מתחלפות עם מתכת, שיוצרות שקיפות מתוחכמת והחזר אור. לאמברה יש אהיל בדיקת ויסקוזה בגוון קרם, עם קצה מועשר בצמה יוקרתית תואמת.\nמידות:\nקוטר 40 x גובה 65 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Ambra Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Ambra Table/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Ambra Table/2.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Ambra Table/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Ambra Table/4.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Ambra Table/5.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Ambra Table/6.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Ambra Table/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/ambra-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 15227,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Anodine Circle Light": {
    "description": "במהלך היום, Anodine Circle Light הוא פסל שמשקף את הדינמיקה של האור הטבעי. מנורה עם אישיות אמנותית חזקה שמתאימה לחללים עם אופי מוגדר. היא כוללת אלמנטים מתכתיים עם גימור צביעה אומנותית מט מוזהב אלגנטי, המחוברים יחד עם חוט פלדה, אשר מרחפים סביב המבנה המרכזי עשוי מתכת מלוטשת במראה עם גימור זהב מלוטש.\nמידות:\nקוטר 100 x עומק 8 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Anodine Circle Light/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Circle Light/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Circle Light/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Circle Light/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Circle Light/4.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Circle Light/5.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Circle Light/6.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Circle Light/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/anodine-cirle-light/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 25654,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Anodine Table & Mini": {
    "description": "מנורת שולחן אנודין היא מנורת שולחן יפה. בזכות טכניקות ייצור בעבודת יד, כל פריט באוסף הוא ייחודי.\n\nמנורת שולחן אנודין: היא כוללת 26 גזעים מבריקים עשויים פליז המקובעים לבסיס מתכתי עם גימור מאט של זהב סאטן בצביעה אמנותית, מעוטרת בעלי מתכת, כולם אסימטריים ועשויים בעבודת יד על ידי אומנים מומחים, עם גימור של זהב מאט.\n\nמנורת אנודין מיני: היא כוללת 3 גזעים מבריקים עשויים פליז המקובעים לבסיס מתכתי עם גימור מאט של זהב סאטן, מעוטרת בעלי מתכת, כולם אסימטריים ועשויים בעבודת יד על ידי אומנים מומחים, עם גימור זהב מאט בצביעה אמנותית.\n\nמידות:\nמיני: רוחב 26 ס\"מ, עומק 20 ס\"מ, גובה 58 ס\"מ\nשולחן: רוחב 100 ס\"מ, עומק 24 ס\"מ, גובה 68 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Anodine Table & Mini/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Anodine Table & Mini/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Anodine Table & Mini/2.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Anodine Table & Mini/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Anodine Table & Mini/4.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Anodine Table & Mini/5.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Anodine Table & Mini/6.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Anodine Table & Mini/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/anodine-mini-and-anodine-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 19549,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Anodine Wall": {
    "description": "קיר אנודין הוא מנורת קיר עדינה ההופכת את האור לציור המעורר את הקונספט של \"צורה לא צורה\" של האור, מה שמוסיף נופך אמנותי לאווירה. המנורה מורכבת מ-11 עלים מבריקים ממתכת, כולם א-סימטריים ועבודת יד של אומנים מומחים, עם גימור מוזהב מט. במודול הקבוע בעל שמונת האלמנטים, שלושה עלים מוארים על ידי נורות LED של 2W כל אחד. ההרכב מושלם על ידי 3 אלמנטים בודדים, להתקנה לפי בחירה כדי ליצור אינסוף שילובים. בזכות טכניקות הייצור בעבודת יד, כל חלק באוסף הוא ייחודי.\nממדים:\nרוחב: 50, עומק: 5, גובה: 53 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/4.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/5.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/6.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/7.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/8.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Anodine Wall/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/anodine-wall/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 19215,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Circle Lamp": {
    "description": "מנורת המעגל מסמלת חופש, אחדות ודואליות, בדומה לבלט הקוסמי בין השמש לירח כאשר הם נפגשים בליקוי חמה. מנורת קיר דקורטיבית זו מציגה נוכחות סצינתית חזקה, המורכבת משני אלמנטים עיקריים. דיסקית מתכת גדולה קעורה, שנחצבה בעבודת יד על ידי אומנים מיומנים ברוח הייחודיות, ולאחר מכן נאמיילה לגימור מראה. במרכז הדיסקית, חצי כדור ממתכת מראה עם גימור זהב מבריק מסתיר את מקור האור ומשקף את זוהרו על פני שטח הדיסקית הגדולה, ובכך יוצר פרופיל תאור עדין ואחיד סביב היקף הכדור. חתיכה זו מיועדת להביא אווירה חמימה ונינוחה לפרויקטי עיצוב פנים יוצאי דופן.\n\nמידות:\nקוטר 100 x עומק 7 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/4.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/5.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/6.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/7.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/8.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Lamp/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/circle-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 23370,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Circle Outdoor Lamp": {
    "description": "מנורת העיגול יוצאת אל החוץ. העיצוב האיקוני של הגרסה הפנימית מאיר גם לילות קיץ חמימים, ומשתלב במאמץ קל בשיווי המשקל הטבעי הסביבתי. מנורת העיגול החיצונית מסמלת חופש, איחוד ודואליות, בדומה לבאלט הקוסמי בין השמש והירח כשהם נפגשים בליקוי חמה. מנורת הקיר דקורטיבית זו מתאפיינת בנוכחות בימתית חזקה ומורכבת משני אלמנטים ראשיים: דיסק קעור גדול מצופה בטראבטרין מעובד בצבעי שנהב או חום שרוף. במרכז הדיסק, חצי כדור ממתכת מבריקה בגימור מט טיטניום מסתיר את מקור האור ומשקף את הזוהר שלו על פני המשטח של הדיסק הגדול, ויוצר פרופיל אור עדין ואחיד מסביב להיקף הספירה. יצירה זו נועדה להכניס אווירה חמימה ורגועה למרחבים חיצוניים יוקרתיים.\nמידות:\nקוטר 100 ס\"מ, עומק 7 ס\"מ\n\n",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Circle Outdoor Lamp/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Outdoor Lamp/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Outdoor Lamp/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Circle Outdoor Lamp/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/circle-outdoor-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 10179,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Colette & Hugo Table": {
    "description": "תודה לווירטואוזיות של בעלי המלאכה של זכוכית מוראנו, זוג מקסים של מנורות שולחן הופיע.\nהסט הזה מדגיש את השלמות בצורה ובסגנון שיכולה להיות מוערכת גם בנפרדותם כדי להעניק נגיעה מתוחכמת לכל סוג של מערך.\nהבסיס בצורת טיפה עשוי מזכוכית קריסטל עופרת הכוללת עלה זהב 24 קרט, אהיל המנורה עשוי בד בעבודת יד.\nהוגו, קומפקטי יותר, יש לו צורה מלאה ורכה ואהיל גלילי; ואילו, קולט רזה וקצת גבוהה יותר עם אהיל מחודד.\nמידות:\nקולט: קוטר 35 x גובה 71 ס\"מ\nהוגו: קוטר 40.5 x גובה 58 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Colette & Hugo Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Colette & Hugo Table/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Colette & Hugo Table/2.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Colette & Hugo Table/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Colette & Hugo Table/4.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Colette & Hugo Table/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/colette-hugo-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 17838,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Comet Table": {
    "description": "כוכב שביט הוא מנורת שולחן עם בסיס מעץ אגוז קנלטו משומן או מעץ מטאלי בגימור אבץ מושרש בחומצה, מעוטרת בתוספת מפליז מאט סאטן.‎\nאהיל בצורת טבעת עשוי מבד טבעי בצבע שנהב.\nמימדים:\nר.46 x ע.10 x ג.54 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Comet Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Comet Table/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Comet Table/2.png",
      "../upload_images/PaoloCasteli/Table Lamps/Comet Table/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Comet Table/4.png",
      "../upload_images/PaoloCasteli/Table Lamps/Comet Table/5.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/comet-table-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 11989,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Fair Light": {
    "description": "פייר לייט הוא גוף תאורה לקיר שמורכב ממסלול כפול עשוי אלמנטים טובולריים ממתכת בגימור ניקל שחור מט עם מפזר פוליקרבונט אופל. המבנה שמעגן אותו לקיר כולל את הדרייבר ומורכב ממתכת בצבע זהב עם גימור מבריק.\nניתן להתקין את התאורה גם במצב אנכי וגם במצב אופקי, מה שמבטיח למקור האור הליניארי עוצמת ביטוי מרבית, המעניקה אנרגיה ואופי לחדר.\nמימדים:\nL 60: ר. 60 x ע. 10 x ג. 9 ס\"מ\nL 110: ר. 110 x ע. 10 x ג. 9 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Fair Light/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Fair Light/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Fair Light/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Fair Light/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Fair Light/4.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Fair Light/5.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Fair Light/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/fair-light/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 16430,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Fanus Suspension": {
    "description": "\tמנורת תליה Fanus, מנורה שתוכננה להאיר את המרחב ולספק את האינטימיות של הצל. מופעלת על ידי מקור אור לד, מנורת Fanus מתפרשת מחדש את מושג הפנס, מתאפיינת בגוף מאיר מרכזי עשוי זכוכית משומרת שקופה ובאהבאזרים זמינים בבד או זכוכית מוראנו. פרטי עור טבעי משדרגים את כל הצורה, והופכים את Fanus לעיצוב עכשווי ביותר, זמין בגרסאות תליה, רצפה ושולחן עם כבל וסוללה.\nחומרים\nמבנה: מתכת\nאהיל: זכוכית, בד\nגוף המאיר: זכוכית\n\nגימורים\nמבנה: גימור צבוע שחור מט\nאהיל: זכוכית מוראנו בצבע ענבר\nגוף המאיר: זכוכית מוראנו נושבת מחורצת ושקופה\nמקור אור: Illuminatore CC LED\nהספק כולל: 16,6W / מתח כניסה (דרייבר): 220-240V /\nשטף אור: 1800 ל\"מ / טמפרטורת צבע: 3000°K / מדד עיבוד צבע: 80 / פונקציית עמעם: אין\n\nמידות: אורך: 23 ס\"מ; גובה: 78/44/4 ס\"מ\n\nגלה את כל משפחת Fanus: Fanus Table, Fanus Floor\n",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Fanus Suspension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Fanus Suspension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Fanus Suspension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Fanus Suspension/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Fanus Suspension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Fanus Suspension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Fanus Suspension/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/fanus-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 10797,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Galaxy": {
    "description": "גלקסי הוא מנורת קיר עם צורות והשתקפויות שכמעט הופכות אותה לפסל. היא כוללת מספר אלמנטים קמורים ממתכת בגימור זהב מבריק המשקפים גוונים שונים של אור בשילוב עם דיסקי מתכת בגימור מט ברונזה. המשטחים החלקים והקמורים מביאים דינמיות לחלל.\nמידות:\nרוחב 193 × עומק 10 × גובה 84 ס\"מ\n",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Galaxy/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Galaxy/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Galaxy/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Galaxy/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Galaxy/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/galaxy/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 14405,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Golden Cloud Suspension": {
    "description": "נברשת מעודנת שעשויה כולה בעבודת יד לפי המסורת העתיקה ביותר של מוראנו.\nגוף מנורה זה כולל 22 \"עננים\" (גרסה סגלגלה, עם 6 ספוטים מובנים) ו-23 \"עננים\" (גרסה עגולה, עם 5 ספוטים מובנים), המסודרים בגבהים מדורגים. הוא עשוי זכוכית מוראנו עם שלוש שכבות של עלה זהב ונוצר בעבודת יד בתבנית מעוצבת.\n\"ענן\" הזכוכית מחובר לגוף מתכת בגימור זהב סאטן ובתוכו יש התקנת LED מודרנית. גוף המתכת מעוגן ללוח פלדה, צבוע בלבן, שחור או זהב.\nזמין בשתי גרסאות: סגלגל ועגול.\nנברשת \"ענן זהב\" זכתה בפרס IDA Design Awards היוקרתי לשנת 2020. לקריאת הכתבה.\nמידות:\nסגלגל:  W 140 x D 46 x H 200 ס\"מ\nעגול:  קוטר 86 x גובה 200 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/7.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/8.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/9.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/10.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/11.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/12.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/13.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/14.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/15.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Cloud Suspension/16.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/golden-cloud-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 10734,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Golden Cloud Wall": {
    "description": "קיר ענן זהב הוא מנורת קיר יקרת ערך, בעבודת יד מלאה לפי המסורות העתיקות ביותר של מורנו.\nהאלמנט, עשוי זכוכית מורנו עם שלוש שכבות עלי זהב 24 קראט, תלוי על גוף מתכת בגימור זהב סאטן שמכיל את מקור ה-LED והדרייבר שלו בפנים.\nמידות:\nר. 16 x ע. 8 x ג. 17 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Golden Cloud Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Cloud Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Cloud Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Cloud Wall/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/golden-cloud-wall-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 13731,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Golden Disc Supension": {
    "description": "דיסק האור הוא סמל עתיק, אוניברסלי ומקור השראה בלתי נגמר. הגיאומטריה המושלמת והקלה שלו, בשילוב עם עלי זהב 24 קראט, משפרת את המלאכת המידור המתקדמת שלו. דיסק הזהב הוא מנורת תקרה שנוצרה עם אלמנט תאורה בעבודת יד מזכוכית מוראנו, מצופה בשלוש שכבות של עלי זהב. הזכוכית, אשר מחזרת את האור ומשדרת אותו סביב החדר, מוכנסת לדיסק מתכתי עם גימור זהב מט ומוחזקת על ידי תמיכה מתכתית מרופדת בעור בצבע חול. כל אלמנט מגיע עם ורד עשוי מתכת בגימור זהב מט וכבל תמיכה חשמלי עם אורך מקסימאלי של 2 מטר. דיסק הזהב זוכה בפרס היוקרתי IDA Design Awards לשנת 2020. קראו את החדשות\nמידות:\nרוחב 34 ס\"מ x עומק 5 ס\"מ x גובה 46 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Golden Disc Supension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Disc Supension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Disc Supension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Disc Supension/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Disc Supension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Disc Supension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Golden Disc Supension/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/golden-disc-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 27735,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Golden Disc Wall": {
    "description": "מנורת קיר יוקרתית בעבודת יד מלאה לפי המסורות העתיקות ביותר של מורנו. האלמנט, עשוי זכוכית מורנו עם מעבר משולש של עלי זהב 24 קראט, תלוי על גוף מתכת בגימור זהב מט שמכיל את מקור ה-LED ואת הדרייבר בתוך המנורה.\nמידות:\nקוטר 34 x עומק 8 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Golden Disc Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Disc Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Disc Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Disc Wall/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Disc Wall/4.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Disc Wall/5.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Golden Disc Wall/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/golden-disc-wall/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 10592,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Haibu Suspension": {
    "description": "טכנולוגיה חדישה וחומרים בטעמים טבעיים הם המרכיבים המרכזיים המגדירים את Haibu, פרויקט חדשני הכולל תאורה, הדפסת תלת ממד וורסטיליות פונקציונלית של כלי אבן. לראשונה בשימוש בתחום הריהוט היוקרתי במידה זו, כלי האבן מעוצבים בתהליך הדפסת תלת ממד חדשני, וכתוצאה מכך נוצרים פנסים חיצוניים המספקים אור חם ומרגיע. כאשר החומר מודפס ומתייבש, הוא נופל באופן ספונטני על עצמו, ובכך יוצר דפוס של חריצים המאפשרים לבריחות אור עדין. העיצוב המעודן מתמזג עם התכונות האינטרינזיות של החומר במערכת תאורה עמידה המזמינה לחוות רגעים של רוגע באוויר הפתוח. מנורת ההשעיה זמינה בשתי גרסאות, אחת יותר מוארכת ובצורת התחדדות ואחרת נמוכה ורחבה יותר.\nמידות:\nקטן: קוטר: 40 ס\"מ; גובה: 42 ס\"מ; חבל: 200 ס\"מ\nגדול: קוטר: 65 ס\"מ; גובה: 35 ס\"מ; חבל: 200 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Haibu Suspension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Haibu Suspension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Haibu Suspension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Haibu Suspension/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Haibu Suspension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Haibu Suspension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Haibu Suspension/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Haibu Suspension/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/haibu-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 20450,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Icone Luminose Table Lamp": {
    "description": "פאולו קסטלי מעצב את קולקציית הקפסולה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב.\n\nסדרת המנורות של קולקציית Morandi כוללת שני דגמים שולחניים, חפצים המפיצים אור באלגנטיות. גוף המנורות עשוי מאגרטל בצורת בקבוק שנוצר מפריטי זכוכית מנופחים על ידי אמני הזכוכית של מוראנו, שקיימים בשני גדלים וצבעים, Fumé ו-Amber. אהיל המנורה הינו מחומר קנבס טבעי, שנתפר בקפידה ביד.\nמידות:\nקוטר בסיס 13 ס\"מ\nקוטר אהיל 35 ס\"מ X גובה 53 ס\"מ (צבע Fumé) ו-66 ס\"מ (צבע Amber)\n\nגלה את משפחת Icone: Icone Luminose, Icone Sileziose\n",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/2.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/4.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/5.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/6.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/7.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Icone Luminose Table Lamp/8.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/lighting/icone-luminose-table-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 18353,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Illusio Suspension": {
    "description": "אילוסיו מעורר תחושת מסתורין וקסם על ידי שינוי מלא בתפיסת המרחב. מערכת תאורה מודולרית, בין אם תלויה או מנורת קיר, המורכבת משבעה ענפי פליז, חמישה מהם מכילים את מקור האור LED, וכך יוצרים קן אור מרגיע המסוגל להאיר חללים פנימיים עם משחק קצבי של קווים מוארים. משפחה של אלמנטים בעלי אופי חזק, שמסוגלים לשרטט נופים דינמיים של אור, מונפשים על ידי משחקי צללים בלתי צפויים ומעוררי דמיון.\nמידות:\nתלוי: אורך: 53; גובה: 80; עומק: 25; אורך כבל: 200 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Illusio Suspension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Illusio Suspension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Illusio Suspension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Illusio Suspension/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Illusio Suspension/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/illusio-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 16368,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Illusio Wall": {
    "description": "אילוזיו מעורר תחושת מסתורין וקסם על ידי שינוי התפיסה של המרחב. מדובר במערכת תאורה מודולרית, בין אם תלויה או מנורת קיר, המורכבת משבעה ענפי פליז, מתוכם חמישה כוללים את מקור האור LED, וכך יוצרים קן אור מרגיע המסוגל להאיר חללים פנימיים במשחק ריתמי של קווי אור. משפחה של אלמנטים בעלי אופי חזק, המסוגלים ליצור נופים דינמיים של אור, המונפשים על ידי משחקי צללים בלתי צפויים ומרמזים.\nמידות:\nקיר: אורך: 53 ס\"מ; גובה: 80 ס\"מ; עומק: 28 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Illusio Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Illusio Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Illusio Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Illusio Wall/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/lighting/illusio-wall/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 10456,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Joy Suspension": {
    "description": "נברשת ג'וי נוצרה כדי לתת צורה לאור. המנורה מורכבת משלושה טבעות מפליז בגובה משתנה, וכדורים מזכוכית סאטן לבנה (הכדור הגדול) ועם מראה אדום שקוף (הכדור הקטן) התלויים בצורה קסומה בתוך מבנה מתכת דק. המשחק של מסות עגולות ומסלולים יוצר עיצוב מאוזן של דינמיקה גרביטציונית.\n\nהאור מהכדור מופץ לחלל שמסביב ומאיר את המסגרת. ההשתקפויות של הפליז מעניקות לשדה האור נראות על ידי ההילה שלו.\n\nזמין ב-2 גרסאות: טבעת אחת, שלוש טבעות.\n\nמידות:\nטבעת אחת: א. 52 x ע. 17 x ר. 61 ס\"מ\nשלוש טבעות: א.51 x ע. 64 x ר.118 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/2.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/7.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Joy Suspension/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/joy-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 22472,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Joy Wall": {
    "description": "ג'וי וול נולדה מתוך הרעיון של מתן צורה לאור. המנורה מורכבת מטבעת פליז וכדורים מזכוכית סאטן לבנה מנופחת ביד (הכדור הגדול) וזכוכית שקופה אדומה (הכדור הקטן) המושעים באופן קסום בתוך מבנה מתכתי דק. המשחק של מסות מעגליות ונתיבים יוצר עיצוב מאוזן של דינמיקה גרביטציונית.\nהאור מהכדור מופץ למרחב הסובב, מאיר את המסגרת. ההשתקפויות של הפליז מראות את השדה המואר באמצעות ההילה שלו.\nממדים:\nרוחב: 52 ס\"מ, עומק: 16 ס\"מ, גובה: 52 ס\"מ\n",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Joy Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Joy Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Joy Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Joy Wall/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Joy Wall/4.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Joy Wall/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/joy-wall/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 14951,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Kaala Lamp": {
    "description": "מנורת קאלה, מנורה עם מבנה ממתכת בצבע שמפניה מט, מצופה בקרמיקה של וייטרי בעבודת יד בצבע לבן או צהוב מבריק. השילוב של שני החומרים יוצר גימור מתכתי אלגנטי.\nאהיל טבעי ב 100% עשוי סיבי קנבוס נפאליים, בירוק או לבן. מקור התאורה הוא נורת E27.\nמידות:\nקוטר 36 ס\"מ, גובה 80 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/2.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/3.png",
      "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/4.png",
      "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/5.png",
      "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/6.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/7.png",
      "../upload_images/PaoloCasteli/Table Lamps/Kaala Lamp/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/kaala-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 25650,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Kalì Supension": {
    "description": "נברשת מפוארת ומאיימת, יוצרת גיאומטריות אור חלומיות בין ידיה הנושאות נרות זהב. נברשת Kalì היא תוצאה של מלאכת יד אומנותית שנעשית כולה באי מוראנו. עשויה מפליז, ידיה המתכתיות - בצורת משושה - מחזיקות אלמנטים מזכוכית הכוללים חלקיקים של עלה זהב 24 קראט. מתחת לטבעת התחתונה ישנם זרקורים. הגימור הסופי הוא זהב מט. תאורת LED. דגם של 3 טבעות הוא נברשת בגודל מלכותי מושלמת לקישוט אולמות חשובים עם נפחים גדולים.\nשתי גרסאות זמינות.\nמידות:\nKalì 2 טבעות: קוטר 111 x גובה 151 ס\"מ\nKalì 3 טבעות: קוטר 164 x גובה 226 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/3.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/7.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/8.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Kalì Supension/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/kali-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 26453,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Kalì Wall": {
    "description": "קאלי היא התוצאה של עבודת יד אומנותית לגמרי המיוצרת באי מוראנו. גרסת הקיר של נברשת קאלי היא גם חלק מאוסף זה. הנברשת עשויה מתכת עם גימור זהב מט הנושא שני אלמנטים של זכוכית מוראנו המכילים עלה זהב 24 קראט. \nמידות: \nקאלי קיר: אורך 28 ס\"מ x עומק 13 ס\"מ x גובה 79 ס\"מ \nקאלי קיר יחיד: אורך 12 ס\"מ x עומק 14 ס\"מ x גובה 59 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Kalì Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Kalì Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Kalì Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Kalì Wall/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Kalì Wall/4.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Kalì Wall/5.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Kalì Wall/6.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Kalì Wall/7.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/kali-wall/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 14055,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Labilis Composition": {
    "description": "אלפבית גרפי חדש המורכב מיסודות גאומטריים חיוניים היוצרים צורות אור עכשוויות במרחב. שלושה טבעות בקטרים שונים שניתן להתקין בנפרד או כהרכב (4, 7, 10 טבעות). הטבעת המתכתית מגיעה בגימור שחור סאטן, עם מפזר אור מפוליקרבונט לבן בצבע אופל לאורך ההיקף. כל טבעת נושאת נקודת LED בגימור ברונזה מט. לכל טבעת שלושה כבלי תלייה, אחד מהם הוא כבל אספקת כוח. כבלי החשמל הם באורך שני מטרים. אופציות נוספות קיימות על פי בקשה: טבעות עם אפשרות לעמעום; ורדים מתכתיים גליליים לאחזקת מנהלי התקן מקומיים, המתאימים להתקנה בתקרה.\n\nמידות הטבעות:\nØ27 x גובה 3 ס\"מ\nØ43 x גובה 3 ס\"מ\nØ70 x גובה 3 ס\"מ\n\nמידות הרכבים:\nהרכב של 4 טבעות (1 Ø27 + 3 טבעות Ø43): רוחב 77 x עומק 72 x גובה 42 ס\"מ\nהרכב של 7 טבעות (1 טבעת Ø27 + 3 טבעות Ø43 + 3 טבעות Ø70): רוחב 122 x עומק 115 x גובה 66 ס\"מ\nהרכב של 10 טבעות (5 טבעות Ø27 + 2 טבעות Ø43 + 3 טבעות Ø70): רוחב 130 x עומק 114 x גובה 82 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/7.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/8.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/9.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/10.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/11.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/12.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/13.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/14.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/15.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/16.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/17.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Composition/18.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/labilis-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 15020,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Labilis Mega Ring": {
    "description": "אלפבית גרפי חדש העשוי מאלמנטים גיאומטריים חיוניים המשרטטים צורות עכשוויות של אור בחלל. משפחת Labilis מקדמת בברכה את Labilis Mega Ring - מערכת תאורה תלויה המתאפיינת בממדים נדיבים ביותר בניגוד הרמוני לפרופיל המינימליסטי שלה. הטבעת המתכתית הראשית, עם גימור שחור מט ומפזר אור LED מפוליקרבונט אטום לבן בהיקף, מעוטרת בארבע נקודות פליז בגימור פליז ברונזה מט.\nמידות:\nקוטר: 200 ס\"מ; גובה: 18 ס\"מ; אורך כבל: 200 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Mega Ring/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Mega Ring/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Mega Ring/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Mega Ring/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Mega Ring/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Mega Ring/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Labilis Mega Ring/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/labilis-mega-ring/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 18859,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Labilis Wall": {
    "description": "שלושה טבעות בקטרים שונים שניתן להתקין על הקיר בנפרד או בהרכב אקראי. הטבעת המתכתית כוללת גימור שחור מאט עם מפזר אור לד עשה מאופל פוליקרבונט לבן מסביב לפרימטר. כל טבעת מקובעת לקיר על ידי גליל מתכתי בגימור ברונזה מאט ונחושת ושני מרווחים מתכתיים בגימור שחור מאט. אספקת חשמל מרחוק. לפי בקשה אפשריים: טבעות עמעום.\n\nמידות טבעות:\nØ27 x גובה 3 ס\"מ\nØ43 x גובה 3 ס\"מ\nØ70 x גובה 3 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Labilis Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Labilis Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Labilis Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Labilis Wall/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Labilis Wall/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/labilis-wall-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 29107,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Manta Suspension": {
    "description": "מנורת תלייה מאנטה היא מנורת תלייה סצנוגרפית, ששליקותה האתֶרִית מזכירה את הפסל האייקוני \"מובייל\" של אלכסנדר קלדר. עלה זכוכית בצבע ענבר, המיוצר בעבודת יד במורנו, encapsulated בתוך מבנה ברונזה מוברשת המכיל את מקור האור LED. יש לה צורה עדינה וגלית והיא נראית כמעופפת באוויר, תלויה מכבלים תלייה חשמליים דקים מאוד. לפי בקשה, כל תליון יכול להיות מסופק עם רוזטה מתכתית המכילה דרייבר מתאים להתקנה בתקרה.\nמידות:\nקומפוזיציה: Ø23 x ר. 130 x ג. 127 ס\"מ\nאלמנט אחד: ר. 23 x ג. 10 ס\"מ\nאופציה לתלייה מאנטה: רוזטה לתקרה, ר. 22 x ע. 5 x ג. 4 ס\"מ\nגלה את כל משפחת מאנטה: מאנטה רצפה, מאנטה שולחן",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/7.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/8.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/9.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Manta Suspension/10.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/manta-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 15128,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "My Lamp Ceiling": {
    "description": "המנורה שלי מהתקרה היא מנורה עגולה עם השפעה ויזואלית מרשימה, שמוסיפה נגיעה דינמית ואלגנטית בזכות הגובה המשתנה של אלמנטים מזכוכית מוארת. היא מורכבת מ\"זר\" משמעותי של צינורות זכוכית בורוסיליקט וונציאניים הקשורים יחד על ידי רצועת מתכת מעוקלת בגימור זהב מט. המבנה התומך הפנימי הוא בגימור מתכת ניקל.\nמידות:\nתקרה 100 קוטר 100 x גובה 32 ס\"מ\nתקרה 140 קוטר 140 x גובה 32 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Ceiling/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Ceiling/1.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/lighting/my-lamp-ceiling/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 29022,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "My Lamp Suspension": {
    "description": "מנורה שלי אידיאלית בטרקלינים אלגנטיים וחדרי אוכל הרוצים ליצור אווירה מתוחכמת אך בלתי שגרתית. היא מורכבת מ\"זר\" משמעותי של צינורות זכוכית בורוסיליקט ונציאניות, התלויים מגבהים שונים, ומחוברים יחד על ידי רצועת מתכת מעוקלת עם גימור מט זהב ייחודי. המסגרת הפנימית התומכת עשויה ממתכת מצופה ניקל. פלטת נגד אטומה להפצת האור.\n4 גרסאות זמינות: מלבנית, ריבועית, עגולה 50, עגולה 100.\nמידות:\nתלייה עגולה 50: קוטר 52 ס\"מ x גובה 50 ס\"מ\nתלייה עגולה 100: קוטר 100 ס\"מ x גובה 50 ס\"מ\nתלייה מלבנית: רוחב 139 ס\"מ x עומק 72 ס\"מ x גובה 50 ס\"מ\nתלייה ריבועית: רוחב 100 ס\"מ x עומק 100 ס\"מ x גובה 50 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/7.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/8.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/9.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/10.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/11.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/12.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/My Lamp Suspension/13.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/my-lamp-suspension/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 17466,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "My Lamp Table": {
    "description": "מנורת השולחן שלי היא מנורת שולחן אלגנטית ונעימה לעין, אידיאלית לסטודיו, סלונים וחדרי שינה. היא מכילה מבנה מתכת עם גימור זהב מט התומך ב\"זר\" של צינורות העשויים מזכוכית בורוסיליקט ונציאנית.\nמידות:\nרוחב 22 ס\"מ, עומק 23 ס\"מ, גובה 46 ס\"מ.",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/My Lamp Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/My Lamp Table/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/My Lamp Table/2.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/My Lamp Table/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/My Lamp Table/4.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/My Lamp Table/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/my-lamp-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 12634,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "My Lamp Wall": {
    "description": "מנורת הקיר שלי היא מנורת קיר אופנתית ואלגנטית שמשלימה את קולקציית המנורות שלי.\nהיא כוללת \"זר\" משמעותי של צינורות זכוכית בורוסיליקט ונציאניים המוחזקים יחד על ידי רצועת מתכת בגימור ייחודי של זהב מט.\nמידות:\nמנורת הקיר שלי קטנה: ר.20 x ע.13 x ג.32 ס\"מ\nמנורת הקיר שלי גדולה: ר.29 x ע.32 x ג.137 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/4.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/5.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/6.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/7.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/8.png",
      "../upload_images/PaoloCasteli/Wall Lamps/My Lamp Wall/9.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/my-lamp-wall-2/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 17691,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Nettuno Table Lamp": {
    "description": "זוג מנורות שולחן המשלימות את קו נטונו (שולחן, שולחן כתיבה ושולחן קפה). הגוף עשוי זכוכית חרוטה בעבודת יד בצורת מקבילית, ומגיע בצבעים ובגוֹבהים שונים. הגוף הדק יותר הוא בצבע ורוד עתיק, בעוד הגוף הקומפקטי יותר הוא בצבע קש; לשני הגופים יש בית מנורה לשתי נורות E27. אהיל הבד המהודר בצבע שנהב, החוט למשיכת השרשרת וכבל אספקת החשמל בצבע זהב תורמים ליצירת צללית חמה ומתוחכמת. שתי המנורות יכולות להיות עשויות מזכוכית בצבע ורוד עתיק או בצבע קש. המנורות זמינות בשני גדלים.\n\nמידות:\nקטן: קוטר 40 x גובה 54 ס\"מ\nגדול: קוטר 40 x גובה 64 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Nettuno Table Lamp/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Nettuno Table Lamp/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Nettuno Table Lamp/2.png",
      "../upload_images/PaoloCasteli/Table Lamps/Nettuno Table Lamp/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Nettuno Table Lamp/4.png",
      "../upload_images/PaoloCasteli/Table Lamps/Nettuno Table Lamp/5.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Nettuno Table Lamp/6.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/nettuno-table-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 25833,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Oscar Lamp": {
    "description": "מנורת אוסקר, מנורה עם בסיס עשוי קרמיקה פאנזה לבנה בעבודת יד עם גימור מט. אהיל 100% טבעי עשוי מסיבי כותנה נפאליים. מקור תאורה הוא נורת E27.\n\nמידות:\nגובה 110 ס\"מ, קוטר 61 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Oscar Lamp/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Oscar Lamp/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Oscar Lamp/2.png",
      "../upload_images/PaoloCasteli/Table Lamps/Oscar Lamp/3.png",
      "../upload_images/PaoloCasteli/Table Lamps/Oscar Lamp/4.png",
      "../upload_images/PaoloCasteli/Table Lamps/Oscar Lamp/5.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/oscar-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 21069,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Stellantis": {
    "description": "סטלנטיס היא פסל תאורה תלויה, שנועדה לשמש כנקודת המוקד של החדר.\nמעוררת רגש ומשורית, היא מורכבת משישה חרוטי זכוכית בגוון ברונזה מטאלי – מיוצרים בעבודת יד על ידי אמני זכוכית מורנו – מחוברים למוט פליז אנכי.\nמוארת על ידי מקור לד, אלמנטים הזכוכית מפזרים השתקפויות בוהקות לחדר באפקט אקספרסיבי וסצנוגרפי. גם ניתנת לעמעום.\nמידות:\nרוחב 96 ס\"מ x עומק 14 ס\"מ x גובה 201 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/6.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/7.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/8.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/9.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/10.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/11.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/12.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/13.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/14.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Stellantis/15.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/suspension-lamps/stellantis/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 13594,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Terminal": {
    "description": "מנורת חוץ בגרסה תלויה ובגרסת אפליק. למנורת הטרמינל יש צורה עדינה וקלילה המזכירה את המבודדים המסורתיים. המפזר מורכב מאלמנטים חופפים מקרמיקה סיציליאנית מזוגגת ידנית. במרכז, גוף צינורי מפלדה מנוקבת בגימור צבע שמפניה מגן על מקור ה-LED בתקן IP67, עמיד בפני מים וסוכנים חיצוניים.\nמידות:\nתלייה: קוטר 15 X גובה 31 ס\"מ\nקיר: אורך 15 X עומק 25 ס\"מ גובה 33 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Suspension Lamps/Terminal/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Suspension Lamps/Terminal/1.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Terminal/2.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Terminal/3.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Terminal/4.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Terminal/5.jpg",
      "../upload_images/PaoloCasteli/Suspension Lamps/Terminal/6.png",
      "../upload_images/PaoloCasteli/Suspension Lamps/Terminal/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/lighting/terminal-lamp/",
    "company_name": "Paolo Casteli",
    "original_category": "Suspension Lamps",
    "price": 12965,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Bicchieri d’Autore": {
    "description": "פאולו קסטלי מעצב את קולקציית הקפסולה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בשיח פתוח בין אמנות, היסטוריה ועיצוב.\n\nסט של כוסות מים או יין עשויות מזכוכית בורוסיליקט, מיוצרות במיומנות ביד ובמפוח, ליצירת שלושה דגמים ייחודיים בהשראת האמנות של ג'ורג'יו מורנדי. הצעה חווייתית המשלבת עבודת יד ויצירתיות כדי להוציא לאור חפצי אמנות ייחודיים עם השפעה חזותית חזקה. הכוסות מועשרות בהתפרצויות צבע מקריות וקישוטים מרתקים המדמים את מגע המברשת, ובכך מזכירים את פלטת הצבעים הייחודית של מורנדי. כל סט, המורכב משש כוסות, כולל שני פריטים לכל מוטיב קישוטי. ניתן לשטוף במדיח כלים ומתאים לשימוש במיקרוגל.",
    "image_url": "../upload_images/PaoloCasteli/Objects/Bicchieri d’Autore/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Bicchieri d’Autore/1.png",
      "../upload_images/PaoloCasteli/Objects/Bicchieri d’Autore/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Bicchieri d’Autore/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Bicchieri d’Autore/4.jpg",
      "../upload_images/PaoloCasteli/Objects/Bicchieri d’Autore/5.png",
      "../upload_images/PaoloCasteli/Objects/Bicchieri d’Autore/6.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/bicchieri-d-autore/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 23389,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Candele d’Autore": {
    "description": "פאולו קסטלי מעצב את קולקציית הקפסולה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב. סט נרות ה-Candele d'Autore הוא מחווה לצורות האייקוניות שנמצאות בציורי הטבע הדומם של ג'ורג'ו מורנדי. בעבודת יד ממוקפדת בשעווה, נרות אלו נוצקים כדי לשחזר את הצלליות הייחודיות של בקבוקי מורנדי. המלאכה המעודנת מתמזגת ללא רבב עם הרגישות האסתטית של האומן, והופכת כל נר ליצירת אמנות.\nמידות:\nC01 – Ø10 x גובה 20 ס\"מ\nC02 – Ø10 x גובה 32 ס\"מ\nC03 – 10 x 10 x גובה 16 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Objects/Candele d’Autore/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Candele d’Autore/1.png",
      "../upload_images/PaoloCasteli/Objects/Candele d’Autore/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Candele d’Autore/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Candele d’Autore/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/candele-d-autore/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 13707,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Icone Silenziose Vases": {
    "description": "פאולו קסטלי מעצב את אוסף הקפסולה \"Oggetti d'autore: Omaggio a Morandi\" עבור Istituzione Bologna Musei. רהיטים, אביזרים וחפצים בדיאלוג פתוח בין אמנות, היסטוריה ועיצוב. \nIcone Silenziose, אגרטלים דקורטיביים אלגנטיים המושרים מחיי דומם של מורנדי, עשויים בכישרון רב מזכוכית מנופחת ביד על ידי אמני זכוכית במורנו. יצירת כל אגרטל מזכירה את הקומפוזיציות המינימליסטיות והמעודנות של האמן, שלעתים קרובות מורכבות מחפצים יומיומיים כמו אגרטלים, בקבוקים וקופסאות. חמישה הדגמים, זמינים בצבעי ענבר, מעושן, כחול ופטרול, מאופיינים בצבעים רכים המשפרים עם השתקפויות של אור, מה שמקנה גאומטריות זוהרות המעשרות את הסביבה.\nממדים:\nדגם 01 Ø13 גובה. 48 ס\"מ\nדגם 02 Ø13 גובה. 37 ס\"מ\nדגם 03 Ø12 גובה. 48 ס\"מ\nדגם 04 Ø13 גובה. 41 ס\"מ\nדגם 05 אורך. 11 x רוחב. 11 x גובה 18 ס\"מ\nגלה את משפחת Icone: מנורת שולחן Icone Luminose, Icone Luminose.",
    "image_url": "../upload_images/PaoloCasteli/Objects/Icone Silenziose Vases/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Icone Silenziose Vases/1.png",
      "../upload_images/PaoloCasteli/Objects/Icone Silenziose Vases/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Icone Silenziose Vases/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Icone Silenziose Vases/4.png",
      "../upload_images/PaoloCasteli/Objects/Icone Silenziose Vases/5.jpg",
      "../upload_images/PaoloCasteli/Objects/Icone Silenziose Vases/6.jpg",
      "../upload_images/PaoloCasteli/Objects/Icone Silenziose Vases/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/icone-silenziose/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 26084,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Murano Vases – Battuto Collection": {
    "description": "קשת של אגרטלים דקורטיביים חדשים המשקפים במלואם את היצירתיות של אומנות הזכוכית במורנו, המובעת כיצירת אמנות.\nהתוצאה הנוכחית של שיתוף הפעולה היקר הזה, שתמיד מכוונת לשילוב ידע עתיק ואסתטיקה עכשווית, היא ניסוי חסר תקדים בצבעי פסטל, זכוכית שקופה וזכוכית חלבית וצורות.\nשלוש טכניקות ייצור שונות משלימות מחקר זה: גימור בטוטו, גימור מצלעות ובועות אוויר וכדורים מראות האופייניים.\nמידות.\nאגרטל קטן קוטר 17 x גובה 43 ס\"מ\nאגרטל גדול קוטר 21 x גובה 54 ס\"מ\nכוס קטנה קוטר 27 x גובה 17 ס\"מ\nכוס גדולה קוטר 32 x גובה 20 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/1.png",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/4.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/5.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/6.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/7.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/8.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/9.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Battuto Collection/10.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/murano-vases-battuto-collection/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 17154,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Murano Vases – Bolle Collection": {
    "description": "קשת של אגרטלים דקורטיביים חדשים שמשקפים באופן מופלא את היצירתיות של מלאכת המוראנו המובעת כיצירת אמנות.\nהתוצאה הנוכחית של שיתוף הפעולה המוערך הזה, שתמיד מכוון לחיבור בין ידע עתיק לאסתטיקה עכשווית, היא ניסוי ללא תקדים בצבעים ובצורות של זכוכית פסטלית, שקופה וחלבית.\nשלוש טכניקות ייצור שונות משלימות את המחקר הזה: גימור בָּטוּטוֹ, מצולעת ובועות אוויר מאפיינות וכדורים משתקפים.\nמידות:\nאגרטל קטן קוטר 20 x גובה 39 ס\"מ\nאגרטל גדול קוטר 18 x גובה 45 ס\"מ\nספל קטן קוטר 24 x גובה 16 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/1.png",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/4.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/5.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/6.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/7.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/8.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Bolle Collection/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/murano-vases-bolle-collection/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 17361,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Murano Vases – Coste Collection": {
    "description": "קשת של אגרטלים דקורטיביים חדשים שמשקפים בצורה מופתית את היצירתיות של אומנות הזכוכית של מורנו, מתבטאים כעבודת אמנות.\nהתוצאה הנוכחית של שיתוף פעולה יקר ערך זה, שתמיד מכוון לשילוב ידע עתיק ואסתטיקה עכשווית, היא ניסוי חסר תקדים בצבעים וצורות של זכוכית פסטל, שקופה וחלבית.\nשלוש טכניקות ייצור שונות משלימות מחקר זה: גימור בטוטו, מצולע והבועות האוויר הכרות והכדורים המראות.\nמידות.\nאגרטל קטן קוטר 17 x גובה 40 סמ\nאגרטל גדול קוטר 21 סמ\nגביע קטן קוטר 27 x גובה 20 סמ\nגביע גדול קוטר 32 x גובה 23 סמ",
    "image_url": "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/1.png",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/4.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/5.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/6.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/7.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/8.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Coste Collection/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/murano-vases-coste-collection/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 20454,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Murano Vases – Spheres Collection": {
    "description": "קשת של אגרטלים דקורטיביים חדשים המשקפים באופן מושלם את היצירתיות של אמנות Murano המתבטאת כיצירת אמנות. התוצאה הנוכחית של שיתוף הפעולה היקר הזה, שתמיד מכוון לשילוב ידע עתיק ואסתטיקה עכשווית, היא ניסוי חסר תקדים בצבעים וצורות של פסטל, שקוף וזכוכית חלבית. שלוש טכניקות ייצור שונות משלימות את המחקר הזה: גימור battuto, מצולע, והבועות האוויר והכדורים המראות האופייניים.",
    "image_url": "../upload_images/PaoloCasteli/Objects/Murano Vases – Spheres Collection/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Spheres Collection/1.png",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Spheres Collection/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Spheres Collection/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases – Spheres Collection/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/murano-vases-spheres-collection/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 12525,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Murano Vases-Incalmo Collection": {
    "description": "סט של אגרטלים בעבודת יד, הצעה רב-ממדית החוקרת צורות ומעצימה את הפוטנציאל של הזכוכית. הסט Incalmo מורכב משמונה אגרטלים דקורטיביים עם צורות וגוונים שונים שיכולים להשתלב בהרמוניה תודות לפשטותם. אלגנטיות מחבקת צבע, ונותנת חיים ליצירות ייחודיות העשויות מזכוכית מוראנו.",
    "image_url": "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/1.png",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/2.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/3.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/4.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/5.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/6.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/7.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/8.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/9.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/10.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/11.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/12.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/13.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/14.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/15.jpg",
      "../upload_images/PaoloCasteli/Objects/Murano Vases-Incalmo Collection/16.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/objects/murano-vases-incalmo-collection/",
    "company_name": "Paolo Casteli",
    "original_category": "Objects",
    "price": 14689,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Indoor"
  },
  "Abstract High Cabinet": {
    "description": "מזנון גבוה אבסטרקט, אינטראקציה מנוגדת בין עיצוב מינימליסטי לבין דקורציות אבסטרקטיות דינמיות. יחידות אחסון יום אבסטרקטיות מעץ אפר מוכתם באגוז מתאפיינות בדלתות מכוסות בלוחות פליז מעוטרים בעבודת יד ענקית. הייחודיות נשענת על שני טיפולים שונים של החומר היוצרים עומק באמצעות תנועות התבניות המתפתלות, אלמנט המשתקף גם בפרטי הרגליים הדקות והמעוקלות התומכות בבסיס. עם זכוכית מלוטשת לאחור, זמינה במספר גרסאות, היא מציעה פתרון עיצובי רב גווני ואטרקטיבי לפרויקטים פנימיים שאפתנים.\nחומרים\nמבנה: עץ בלוקבורד\nציפוי: פליז\nבסיס: מתכת\nגימורים\nמבנה: אפר מוכתם אגוז\nציפוי: פליז עתיק\n \nמידות: אורך 130; גובה 171/55 ס\"מ\n \nגלה את משפחת אבסטרקט: מזנון נמוך אבסטרקט",
    "image_url": "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/1.png",
      "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/2.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/3.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/4.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/5.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/6.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/7.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract High Cabinet/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/storage/abstract-high-cabinet/",
    "company_name": "Paolo Casteli",
    "original_category": "Storage",
    "price": 22524,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Abstract Low Cabinet": {
    "description": "ארון נמוך אבסטרקטי, אינטראקציה סותרת בין עיצוב מינימליסטי לעיטורים אבסטרקטיים דינמיים. יחידות אחסון יומיומיות עשויות עץ אש אלון מוכתם באגוז מובחנות בדלתות מכוסות בלוחות פליז מקושטות בעבודת יד. הייחודיות טמונה בשתי עבודה שונות של החומר, היוצרות עומק באמצעות התנועות המתפתלות של הצורות, אלמנט המשתקף גם בפרטים של הרגליים הדקות והמעוקלות התומכות בבסיס. עם משטח זכוכית לכה בצבע אחורי, המוצר זמין בכמה גרסאות, המייצגות פתרון עיצובי ורסטילי ואטרקטיבי לפרויקטים שאפתניים בעיצוב פנים.\n\nחומרים:\nמבנה: עץ בלוקבורד\nכיסוי: פליז\nבסיס: מתכת\n\nגימורים:\nמבנה: אש מוכתם באגוז\nכיסוי: פליז עתיק\n\nמידות: אורך 192 ס\"מ; גובה 73/55 ס\"מ\nגלה את משפחת אבסטרקט: ארון גבוה אבסטרקטי",
    "image_url": "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/1.png",
      "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/2.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/3.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/4.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/5.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/6.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/7.jpg",
      "../upload_images/PaoloCasteli/Storage/Abstract Low Cabinet/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/storage/abstract-low-cabinet/",
    "company_name": "Paolo Casteli",
    "original_category": "Storage",
    "price": 28898,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Dea Night Storage": {
    "description": "מערכת האחסון ללילה Dea מאופיינת בצורות רכות, שנוצרות מהאלטרנטיביות ההרמונית של קווים קמורים מלפנים ומאחור וקווים קעורים בצדדים.\nהמכלים עשויים מעץ אקליפטוס מסולסל מיוחדת מאוד: פני השטח של העץ נגלה באופן טבעי עקב פעולת משבי הרוח על העצים לאורך הזמן. החלק העליון עשוי ממראה ברונזה בגימור סאטן בעוד שהצדדים מכוסים בעורות עדינים עם סגירת קצה ממתכת זהב בגימור מט סאטן (למעלה ולמטה).\n\nמידות:\nשידת לילה עם 3 מגירות: ר' 54 x ע' 45 x ג' 50 ס\"מ\nשידת 3 מגירות: ר' 140 x ע' 45 x ג' 72 ס\"מ\nשידת 7 מגירות: ר' 54 x ע' 45 x ג' 125 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Storage/Dea Night Storage/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/1.png",
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/2.jpg",
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/3.png",
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/4.png",
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/5.png",
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/6.png",
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/7.png",
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/8.jpg",
      "../upload_images/PaoloCasteli/Storage/Dea Night Storage/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/storage/dea/",
    "company_name": "Paolo Casteli",
    "original_category": "Storage",
    "price": 13160,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Fine Collection Night": {
    "description": "ליל אוסף משובח הוא אוסף ארונות אלגנטי, אידיאלי בכל חדר שינה ובחדר ארונות.\nעשוי מ-MDF בגימור לכה מבריק 100, עם כיסוי חזיתי מעור באותו צבע, עם קצוות מלוקקים מבריקים. הידיות המתכתיות גמורות בזהב מט.\nהמרתפים, MDF מלוקים מט, בעלי תחתית מרופדת קלות, מכוסים במיקרופייבר אלגנטי בגוון טאופה. הרגליים גם הן MDF בגימור לכה מבריק 100 ויש בהן תוספות מתכת המתאימות לגימור הגלווני של הידיות, או בסיס ממתכת מצופה זהב.\nהאוסף כולל שידת 7 מגירות מהאוסף המשובח, שידת 3 מגירות מהאוסף המשובח, ארון 180 A מהאוסף המשובח, ושידת לילה מהאוסף המשובח.\nמידות:\nאוסף משובח 180A: רוחב 180 x עומק 52 x גובה 73 ס\"מ\nשידת אוסף משובח עם 3 מגירות: רוחב 120 x עומק 52 x גובה 73 ס\"מ\nשידת אוסף משובח עם 7 מגירות: רוחב 50 x עומק 52 x גובה 116 ס\"מ\nשידת לילה מהאוסף המשובח עם 2 מגירות: רוחב 50 x עומק 47 x גובה 37 ס\"מ\nשידת לילה מהאוסף המשובח עם 3 מגירות: רוחב 50 x עומק 47 x גובה 52 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Storage/Fine Collection Night/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/1.png",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/2.png",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/3.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/4.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/5.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/6.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/7.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/8.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/9.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/10.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/11.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/12.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/13.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/14.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/15.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/16.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/17.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/18.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/19.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/20.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/21.jpg",
      "../upload_images/PaoloCasteli/Storage/Fine Collection Night/22.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/storage/fine-collection-night/",
    "company_name": "Paolo Casteli",
    "original_category": "Storage",
    "price": 28489,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "For Living Showcase": {
    "description": "מארז ייחודי שסוקר מפרספקטיבה אמנותית בזכות הגימור היקר שלו שמזכיר נגיעה מזרחית עתיקה. המבנה ושתי הידיות התכשיטים שלו עשויים מפליז מט עם לכה שקופה להגנה, בעוד שהבסיס גמור בפליז מוברש במראה מחומצן והזכוכית היא מחוסמת בהירותית. הכיסוי העליון היוקרתי עשוי פאנל תאורת LED שמפאר את הצורות והאובייקטים המוצגים בו.\nממדים:\nרוחב 90 ס\"מ x עומק 46 ס\"מ x גובה 166 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Storage/For Living Showcase/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Storage/For Living Showcase/1.png",
      "../upload_images/PaoloCasteli/Storage/For Living Showcase/2.png",
      "../upload_images/PaoloCasteli/Storage/For Living Showcase/3.jpg",
      "../upload_images/PaoloCasteli/Storage/For Living Showcase/4.jpg",
      "../upload_images/PaoloCasteli/Storage/For Living Showcase/5.jpg",
      "../upload_images/PaoloCasteli/Storage/For Living Showcase/6.jpg",
      "../upload_images/PaoloCasteli/Storage/For Living Showcase/7.png",
      "../upload_images/PaoloCasteli/Storage/For Living Showcase/8.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/storage/for-living-showcase/",
    "company_name": "Paolo Casteli",
    "original_category": "Storage",
    "price": 20503,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Selima Bedside Table": {
    "description": "שידת לילה סלימה, שידת לילה עם מגירה אחת וקצוות מעוגלים, עשויה מעץ אש מלא ידידותי לסביבה, זמינה בשלוש גרסאות: עם גימור חומצי, מולבן או מוכתם אגוז פתוח נקבוביות. תהליך זה משאיר בכוונה את הנקבוביות של העץ פתוחות, מה שמאפשר לו לשמור על המראה הטבעי שלו. תוספת מתכת בגימור מט צבע שמפניה על החלק העליון. למגירה יש ידית חריץ אלגנטית.\n\nשידת לילה סלימה זמינה עם רגליים עשויות ממתכת דקה מעוצבת בגימור צבע שמפניה, או עם רגלי עץ תואמות למבנה, עם תוספת מתכת בגימור מט צבע שמפניה.\n\nמידות:\nאורך 60 ס\"מ x רוחב 40 ס\"מ x גובה 50 ס\"מ\n\nגלה את משפחת סלימה: כיסא סלימה, קונסולת סלימה",
    "image_url": "../upload_images/PaoloCasteli/Storage/Selima Bedside Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Storage/Selima Bedside Table/1.png",
      "../upload_images/PaoloCasteli/Storage/Selima Bedside Table/2.jpg",
      "../upload_images/PaoloCasteli/Storage/Selima Bedside Table/3.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/storage/selima-bedside-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Storage",
    "price": 25195,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Soft Ratio Cabinet": {
    "description": "ארונות עם בסיס מתכת בגימור מט שחור עם רגליים כפולות ממתכת בגימור פליז ברונזה מט. הדגמים זמינים עם מבנה עץ בציפוי לכה מט או מכוסים בעור (דלתות וחזית) עם דוגמה גיאומטרית המזכירה את המבנה. ארון נמוך מצויד במדף זכוכית שקוף נוסף בפנים, כאשר החלק האחורי עשוי מזכוכית ברונזה מראה. החלק העליון עשוי זכוכית צבועה בגב (באותו צבע). הדלתות נפתחות באמצעות מערכת פתיחה בלחיצה-מגע. המודל הגבוה זמין בפנים עם 3 מדפים מזכוכית שקופה נוספת או עם מדף אחד מזכוכית שקופה נוספת ו-2 מגירות עם ריפוד פנימי מכוסה במיקרופייבר, באותו צבע. תאורת LED וחלק אחורי מזכוכית ברונזה מראה.\nארון נמוך: ר 193 x ע 59 x ג 74 ס\"מ\nארון גבוה: ר 122 x ע x ג 170 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Storage/Soft Ratio Cabinet/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Storage/Soft Ratio Cabinet/1.png",
      "../upload_images/PaoloCasteli/Storage/Soft Ratio Cabinet/2.gif",
      "../upload_images/PaoloCasteli/Storage/Soft Ratio Cabinet/3.jpg",
      "../upload_images/PaoloCasteli/Storage/Soft Ratio Cabinet/4.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/storage/soft-ratio-highlow-cabinet/",
    "company_name": "Paolo Casteli",
    "original_category": "Storage",
    "price": 11664,
    "filter_category": "קונסולות וארונות",
    "placement": "Indoor"
  },
  "Fanus Table": {
    "description": "פאנוס טייבל, מנורה המיועדת להאיר חללים ולספק את האינטימיות של הצל. מופעלת על ידי מקור אור לד, פאנוס טייבל מפרשת מחדש את הרעיון של הפנס, ומתאפיינת בגוף מאיר מרכזי העשוי זכוכית מצולעת שקופה ואהיל הזמין בבד או בזכוכית מוראנו. פרטי עור קואיטו טבעי מעטרים את הדמות כולה, מה שהופך את פאנוס לעיצוב עכשווי ביותר, הזמין בגרסה תלויה, רצפתית ושולחנית עם כבל וסוללה.\n\nחומרים\nמבנה: מתכת\nאהיל: זכוכית, בד\nגוף מאיר: זכוכית\n\nגימורים\nמבנה: גימור צבוע שחור מט\nאהיל: זכוכית מוראנו בצבע אמבר\nגוף מאיר: זכוכית מוראנו מצולעת שקופה\nמקור אור: Illuminatore CC LED\nהספק כולל: 2.1W / מתח: סוללה 3.7V – 2600mAh\nשטף אור: 300 lm / טמפרטורת צבע: 3000°K / אינדקס רינדור צבע: 84 / פונקציית עמעם: מגע לעמעום\n\nמידות: אורך 27 ס\"מ; גובה 44 ס\"מ\nגלה את כל משפחת פאנוס: פאנוס רצפה, פאנוס תלייה",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/2.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/4.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/5.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/6.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/7.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Fanus Table/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/fanus-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 14489,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Manta Table": {
    "description": "שולחן מנטרה, מכופף את החומר לאמנות, מנורה הנראית כעלה שמסתובב קלות בחדר. משפחת מנורות מנטרה מקבלת בברכה גרסאות רצפה ושולחן, ומרחיבה את טווח מערכות התאורה המאופיינות בקלות אתרים ובאלגנטיות מעודנת. מקור האור לד, עלה זכוכית מעודן בצבע פיום או ענבר שמחושל ביד על ידי אמני זכוכית במוראנו, מאיר את החדר בחמימות רבה ובטבעיות, ויוצר אווירה עוטפת של הרמוניה מוחלטת.\nחומרים:\nגוף תאורה: זכוכית\nמבנה: פליז\nגימורים:\nזכוכית: ענבר פיום\nפליז: טבעי\nמקור אור: לד\nהספק כולל: 10W / מתח: 220-240 וולט / שטף אור נמדד: 800 לומן / טמפרטורת צבע: 3000°K / מדד הצגת צבע: CRI תקני> 80 / פונקציית עמעום: לא\nמידות: אורך 40X31; גובה 43/19 ס\"מ\nגלה את כל משפחת מנטרה: מנטרה תלוי, מנטרה רצפה.",
    "image_url": "../upload_images/PaoloCasteli/Table Lamps/Manta Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Table Lamps/Manta Table/1.png",
      "../upload_images/PaoloCasteli/Table Lamps/Manta Table/2.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Manta Table/3.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Manta Table/4.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Manta Table/5.jpg",
      "../upload_images/PaoloCasteli/Table Lamps/Manta Table/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/table-lamps/manta-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Table Lamps",
    "price": 23691,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Alba Bistrot Table": {
    "description": "שולחן אלבה ביסטרו הוא בחירה מתוחכמת לאזור מגורים המותאם בקפידה בפרטים, אוסף שמוביל את המינימליזם לכיוון הקישוט. זמין עם פלטות עגולות ומלבניות, שולחן אלבה ביסטרו והקונסולה הם תוצאה של שילוב גימורים וצורות שונים שיוצרים זהות ברורה למשפחת הרהיטים, שבה הכוח הביטויי של החומרים מעצים את העבודות האישיות. למעשה, האוסף של אלבה מוצא את סימן ההיכר שלו במפגש בין המעגל והגליל שמרכיבים את החיבור בין הבסיס לפלטה, פרט אסתטי טכני אלגנטי שמעלה את כל הדמות.\n\nחומרים:\nמבנה: מתכת\nפלטה: אבן\nבסיס: אבן\n\nגימורים:\nמבנה: גימור מט ברונזה צל\nפלטה: אבן ויצ'נזה מלוטשת בצבע שנהב\nבסיס: אבן ויצ'נזה מלוטשת בצבע שנהב\n\nמידות:\nאורך: 100X100 – 120 ס\"מ; גובה: 75/45 -54 ס\"מ\n\nגלה את כל משפחת אלבה: שולחן אלבה, קונסולת אלבה",
    "image_url": "../upload_images/PaoloCasteli/Tables/Alba Bistrot Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Alba Bistrot Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Alba Bistrot Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Bistrot Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Bistrot Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Bistrot Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Bistrot Table/6.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Bistrot Table/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/alba-table-bistrot/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 21626,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Alba Table": {
    "description": "שולחן אלבה הוא שילוב של חומרים טבעיים ותעשייתיים, אבן ויצ'נצה מלוטשת בגוון שנהב וברונזה בגימור מט, שמתחברים יחד ליצירת מוצר ייחודי עם צורות גיאומטריות ורציונליות. עיגול וגליל, שמתחברים ליצירת אלמנט בודד המתאפיין באישיות יוצאת דופן ובסימן גרפי חזק, שבו הכוח הביטויי של החומרים מדגיש את תהליכי הייצור האישיים.\n\nבמרכז השולחן ישנה דקורציה מעוגלת בחריטת בָס-רָלִיף, סמל למיומנות של בעלי המקצוע שמייצרים את הגימורים היפים ביותר. החיבור בין הבסיס והראש של השולחן מופלא ביותר, מייצר פרט שאסתטית וטכנית הוא מרשים באופן אלגנטי.\n\nזמין גם דגם עם בסיס מעץ מצופה בעור, בגוון 634 אואזיס. לפי בקשה, ניתן להזמין מרכז השולחן עם דקורציה מעוגלת בחריטת בָס-רָלִיף, סמל למיומנות של בעלי המקצוע שמייצרים את הגימורים היפים ביותר.\n\nמידות גרסה עגולה:\nØ160 – ר 44 x ג 75 ס\"מ\nØ180 – ר 44 x ג 75 ס\"מ\nמידות גרסה מלבנית:\nר 270 x ע 120 x ג 75 ס\"מ\nגלו את כל משפחת אלבה: קונסולת אלבה | שולחן אלבה ביסטרו",
    "image_url": "../upload_images/PaoloCasteli/Tables/Alba Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Alba Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Alba Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Alba Table/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/alba-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 23318,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Dione Bistrot Table": {
    "description": "שולחן ביסטרו דיאונה, איזון עדין של קומפוזיציות חומריות, הצעה שמסוגלת לתקשר עם סגנונות ריהוט שונים, ולהוסיף נגיעה של אלגנטיות לחדרים. קולקציית דיאונה מתאפיינת בצורות הפיסוליות של המשטח העליון הזמין בשיש קלקטה ומשי לבן מט שמתקשרים עם הבסיס הפסלי העשוי קרמיקה. משפחת דיאונה, שמורכבת מסדרת שולחנות קפה בגדלים שונים, מקבלת גרסה חדשה של שולחן ביסטרו דיאונה עם משטח עגול אף מרווח יותר בקוטר של 100 ס\"מ. זמין גם בגרסה כהה עם בסיס מצלעות מזוגגות בצבע גרפיט, ומשטח עליון משיש סהרה בראון מבריק.\nחומרים:\nמבנה: מתכת\nמשטח עליון: שיש\nבסיס: קרמיקה\nגימורים:\nמבנה: גימור מט בצבע זהב\nמשטח עליון: קלקטה, משי לבן, סהרה בראון מבריק\nבסיס: קרמיקה תלת ממדית, קרמיקה תלת ממדית, מצלעות מזוגגות בצבע גרפיט\n\nממדים:\nר. 100X100 – 120; ג. 75/45 – 54 ס\"מ\n\nגלה את כל משפחת דיאונה: שולחן דיאונה, שולחן קפה דיאונה, דיאונה Lazy Susan, דיאונה Lazy Susan 220.",
    "image_url": "../upload_images/PaoloCasteli/Tables/Dione Bistrot Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Dione Bistrot Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Dione Bistrot Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Bistrot Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Bistrot Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Bistrot Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Bistrot Table/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/dione-bistrot-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 20475,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Dione Dark Table": {
    "description": "משפחת דיונה עוטה גימורים חדשים המעניקים אלגנטיות ומודרניות למבנה המונוליתי שלה, ומשלבת בכך את הטוהר הפיסולי של גרניט וקרמיקה בסימפוניה של צורות וחומרים המועשרים על ידי האקספרסיביות האוניברסלית של מראה הטוטאל-דארק. דיונה דארק היא הצעה חסרת תקדים המורכבת משולחן עיקרי ושולחנות קטנים המורכבים מבסיס פעמון קרמי בעבודת יד המצופה בגלזורה מבריקה בגוון פחם אפור עם גימור מצולע, אפקט המנוגד לחלקו העליון העגול העשוי משיש סהרה מלוטש ומעוטר בעבודת אינליי פליז מרכזית. דיונה דארק מציעה חוויה ויזואלית ומישושית המעשירה כל חדר על ידי התמקדות נועזת במשיכה הנצחית של צבע שחור, הצללית הפיסולית שלו, והמשחק של ניגודים חדים בין גימורים מבריקים למאט.\nמידות:\nשולחן: קוטר: 180; גובה: 75 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Tables/Dione Dark Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Dione Dark Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Dione Dark Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Dark Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Dark Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Dark Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Dark Table/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/dione-dark-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 19794,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Dione Lazy Susan": {
    "description": "דיונה לייזי סוזן היא שולחן מונוליתי שמדגיש את הטוהר הפסלי של משטחי שיש וחרסינה מעובדים בעדינות, התמונה הסצנית שלו. מיוצרת בויאטרי – אחד מעריסות ההיסטוריות של ייצור החרס באיטליה – לשולחן דיונה יש צורה עגולה וממדים פסליים. \nהבסיס בצורת פעמון עשוי מחרס ריבודי בעבודת יד מויאטרי, גימור אמייל לבן, נח על פלטת מתכת עגולה בגימור מט זהב. הקצה העליון עשוי משיש יוקרתי מסוג קלקטה או משי לבן מט עם קצוות מורמים, דיסק מרכזי ופירוטים מברונזה בגימור מט.\nמידות:\nØ 160 – lazy susan Ø 80 ס\"מ – בסיס L 80 x גובה 74\nØ 180 – lazy susan Ø 80 ס\"מ – בסיס L 80 x גובה 74\nגלה את כל משפחת דיונה: שולחן דיונה, שולחן ביסטרו דיונה, שולחן קפה דיונה, דיונה לייזי סוזן 220",
    "image_url": "../upload_images/PaoloCasteli/Tables/Dione Lazy Susan/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Dione Lazy Susan/1.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/dione-lazy-susan-2/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 26072,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Dione Lazy Susan 220": {
    "description": "דיונה לייזי סוזן 220 הוא שולחן מונוליתי שמבליט את הטוהר הפסלי של שיש וקרמיקה מעובדים לדקויות, ואת הדימוי הראוותני שלו. מיוצר בוייטרי – אחד העריסות ההיסטוריות של ייצור הקרמיקה האיטלקית – לייזי סוזן 220 של דיונה בעל צורה עגולה וממדים פסליים.\nבסיס בצורת פעמון עשוי קרמיקה מצולעת בעבודת יד מווייטרי, עם גימור אמייל לבן, נשען על פלטת מתכת עגולה עם גימור זהב מט. החלק העליון עשוי משיש קלאקטה יקר ערך או משי לבן מט עם קצוות מוגבהים, דיסק מרכזי ופרטים בגימור זהב מט מתכתי.\nמידות: \nØ 220 – לייזי סוזן Ø 120 ס\"מ – בסיס רוחב 120 x גובה 78\nגלה את כל משפחת דיונה: שולחן דיונה, שולחן דיונה ביסטרו, שולחן קפה דיונה, לייזי סוזן דיונה",
    "image_url": "../upload_images/PaoloCasteli/Tables/Dione Lazy Susan 220/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Dione Lazy Susan 220/1.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/dione-lazy-susan-220/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 17905,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Dione Table": {
    "description": "שולחן מונוליטי שמעצים את הטוהר הפסלי של שיש וקרמיקה מעובדים בעדינות, דמותו הסצנוגרפית. מיוצר בויאטרי – אחת העריסות ההיסטוריות של ייצור הקרמיקה האיטלקית – לשולחן דיונה צורה עגולה ומידות פסליות.\n\nבסיס בצורת פעמון עשוי קרמיקה ממלאכה ויאטרית מצולעת, גימור אמייל לבן, הנשען על לוח מתכת עגול עם גימור זהב מאט. משטח עליון משיש קלקטה יקר או משטח מט משי לבן עם שוליים מוגבהים, דיסק מרכזי ופרטים בגימור סאטן פליז מט.\n\nמידות:\nØ 160 x גובה 74 | בסיס 63 ס\"מ\nØ 180 x גובה 74 | בסיס 63 ס\"מ\n\nגלה את כל משפחת דיונה: שולחן דיונה ביסטרו, שולחן דיונה עם עזר סוזן, שולחן דיונה סוזן עזר 220, שולחן קפה דיונה",
    "image_url": "../upload_images/PaoloCasteli/Tables/Dione Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Dione Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Dione Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Dione Table/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/dione-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 28341,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "For Hall Oval Table": {
    "description": "שולחן אובלי For Hall עשוי עם קצוות מכונפי-זרוע עליונים אליפטיים משיש יקר. המבנה מורכב משני בסיסים עם 8 רגליים כל אחד, עשויים ממתכת בגימור זהב מט באיכות גבוהה, מסודרים בזוויות שונות. עובי 2 ס\"מ.\nמידות:\nרוחב 250 x עומק 110 x גובה 74 ס\"מ\nגלו את כל משפחת For Hall: שולחן For Hall Circle, שולחן For Hall Squircle, שולחן קפה For Hall, קונסולה For Hall",
    "image_url": "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/1.png",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/6.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/7.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/8.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/9.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/10.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Oval Table/11.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/for-hall-table-oval/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 21615,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "For Hall Squircle Table": {
    "description": "שולחן For Hall Squircle כולל משטח עליון מרובע עם פינות מעוגלות וקצוות בצורת כנף שחף המיוצר משיש – בעובי של 2 ס\"מ. הבסיס מורכב מ-8 רגלי מתכת בגימור זהב מט, המציבות בזוויות שונות ומעוגנות למשטח השולחן עם פלטת מתכת.\nמידות:\nרוחב 140 ס\"מ x עומק 140 ס\"מ x גובה 74 ס\"מ\nגלה את כל משפחת For Hall: שולחן For Hall Circle, שולחן For Hall Oval, שולחן קפה For Hall, קונסולה For Hall",
    "image_url": "../upload_images/PaoloCasteli/Tables/For Hall Squircle Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/For Hall Squircle Table/1.png",
      "../upload_images/PaoloCasteli/Tables/For Hall Squircle Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/For Hall Squircle Table/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/for-hall-squircle-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 29850,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Grieta Table": {
    "description": "שולחן פונקציונלי עם צורות חיוניות שמגלה את הפואטיקה שלו בהתערבות האמנותית. בתרגום ספרדי של המילה 'סדק', שולחן Grieta הופך את ההפרעות ברציפות להזדמנות לצאת למסע חדש לגלות את הפוטנציאל של הקרמיקה, החומר ממנו הוא עשוי. מאופיין בבסיס בצורת פעמון עם משטח לא סדיר, הזמין בקרמיקה עם זיגוג או אבן Vicenza, שולחן Grieta מייצג במה עכשווית לשיתוף, פתרון מתוחכם שמאכלס את אזור האוכל בקלות הודות לעיצוב הנקי והחיוני של משטח השולחן.\n\nחומרים:\nבסיס: אבן פורצלן בעיבוד יחיד\nטופ: קרמיקה\nתחתי: MDF\n\nגימורים:\nבסיס: קרמיקה בצבע מרווה, טרקוטה, אוקיינוס, אפור\nטופ: בצבע מרווה, טרקוטה, אוקיינוס, אפור\nתחתי: לכה מבריקה בצבע תואם\n\nמידות:\nאורך 160X160 ס\"מ; אורך הבסיס 57 ס\"מ; גובה 75 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Tables/Grieta Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Grieta Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Grieta Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Grieta Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Grieta Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Grieta Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Grieta Table/6.jpg",
      "../upload_images/PaoloCasteli/Tables/Grieta Table/7.jpg",
      "../upload_images/PaoloCasteli/Tables/Grieta Table/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/grieta-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 24494,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Imane Table": {
    "description": "שולחן אימאן – קו חיצוני\nIMANE היא קולקציה חדשה של כיסאות מרופדים ושולחנות קפה לשימוש חיצוני, שעוצבו על ידי תיירי למאר, הוברט דה מאלרב ופאולו קסטלי. עשויה מחומרים טבעיים ומעובדת בעבודת יד לפי הפרטים הקטנים ביותר, IMANE היא חלק מפרויקט GREENKISS הרחב יותר, הכולל את הקולקציות הירוקות של החברה.\nלשולחן אימאן יש משטח עשוי מטרוורטין טבעי, אבן חזקה ורב-שימושית בצבע אלבסטרין בהיר, עם שכבת גמר אחרונה מלוטשת ומוברשת, שמתאימה באופן מושלם לסביבות חיצוניות. טרוורטין הוא סמל בלתי-מעורער לעיצוב מאוזן ונצחי. השימוש בו באדריכלות מאז העת העתיקה מקשר אותו מיד לרעיונות של אלגנטיות, חמימות ועידון. מה שמדהים באבן הזו הוא הרב-שימושיות שלה, וכך קלותה לשילוב בכל סוג של סביבה.\nמבנה:\nעץ אירוקו מלא, מוברש ומוכתם בשמן טבעי\nממדים: אורך 250 X רוחב 150 ס\"מ גובה 75 ס\"מ\nגלה את כל משפחת אימאן: כורסאת אימאן, ספת אימאן, מיטת יום אימאן, כיסא אימאן, שולחן קפה אימאן",
    "image_url": "../upload_images/PaoloCasteli/Tables/Imane Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Imane Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Imane Table/2.png",
      "../upload_images/PaoloCasteli/Tables/Imane Table/3.png",
      "../upload_images/PaoloCasteli/Tables/Imane Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Imane Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Imane Table/6.png",
      "../upload_images/PaoloCasteli/Tables/Imane Table/7.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/imane-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 17124,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Kenya Outdoor Table": {
    "description": "משפחת הרהיטים של קניה מציגה שלב חדש לשיתוף בחוץ. ההצעה מורכבת משולחן ראשי, שולחנות צד וקונסולה המתאפיינים באופי ארכיטקטוני חזק, ומייצגת פתרון שלם ורב-תכליתי לריהוט חללי מגורים ואוכל תחת כיפת השמיים. הנפחים החסרים שמגדירים את מבנה כל אלמנט משתלבים עם משטח השולחן המלבני, ובכך נותנים לאוסף מראה יוצא דופן שמחווה לאי-סימטריה. המפגש הטקסטורלי בין רגלי הפוליאוריתן הצפוף הגבוה, הממוסגרות בנירוסטה צבועת אפוקסי ומכוסות בתערובת של טרוורטין, והמשטח העליון המיוצר בטרוורטין לבן או אדום, מאפיין כל אלמנט דרך היופי הבלתי מושלם של אבן טבעית. משטחים עם מרקם לא סדיר מגדירים את הפתרון הדינמי הזה, ובכך מעוררים בנאים נופים טבעיים ופריסטיניים במיידיות.\n\nמידות:\nשולחן: אורך: 310; גובה: 75; עומק: 115 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/6.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/7.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/8.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Outdoor Table/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/kenya-table-outdoor/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 18831,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Kenya Table": {
    "description": "שולחן קניה, גרגרי העץ פוגשים את עורקי השיש ומתווים נתיבים חדשים. שולחן קניה, מרקם לא סדיר מותווה על פני השטח, מעורר נופים טבעיים ולא מקולקלים. קניה היא משפחת רהיטים בעלת אופי אדריכלי חזק, הצעה שלמה לאזור המגורים והאוכל הכוללת שולחן, קונסולה ושולחן קפה. הנפחים המופחתים שמאפיינים את מבנה כל רכיב מתחברים עם משטח השולחן המלבני, ונותנים לאוסף מראה בלתי שגרתי שמצדיע לאסימטריה. המפגש החומרי בין רגלי העץ למשטח השיש מאפיין כל רכיב, ומעיר את הפרופיל המינימליסטי בפרטים מתוחכמים.\n\nחומרים\nבסיס: עץ\nמשטח: קוורציט, עץ\n\nגימורים\nבסיס: עץ אשוח צבוע באגוז\nמשטח: קוורציט בלו רומא, שיש וייט סילק, עץ אשוח צבוע באגוז\n\nמידות:\nאורך 310×155; גובה 75 ס\"מ\nאורך 240×155; גובה 75 ס\"מ\n\nגלו את כל משפחת קניה: קונסולה קניה, שולחן קפה קניה",
    "image_url": "../upload_images/PaoloCasteli/Tables/Kenya Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Kenya Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Kenya Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Table/6.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Table/7.jpg",
      "../upload_images/PaoloCasteli/Tables/Kenya Table/8.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/kenya-rectangular-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 16512,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Mars Table": {
    "description": "שולחן מאדים הוא שולחן מרתק המוגדר על ידי החלק העליון המעוטר באבק זהב ובסיס הספירי האלגנטי בעל הדוגמה התלת-ממדית המפוספסת אשר מביאה סגנון ייחודי לכניסות חשובות ולחדרי אוכל מתוחכמים.\nהחלק העליון העגול, בעובי של 4 ס\"מ, עשוי מ-MDF בגימור לקה של 100 מבריק יקר אשר כולל אבק זהב המפוזר ביד על שכבות רבות, ויוצר אפקט תלת-ממדי שמעצים את יופיו. בסיס שולחן מאדים עשוי מכדור אלומיניום מומר המקושט בפסים תלת-ממדיים ונצבע בזהב מאט ומונח על כן עגול עשוי MDF בגימור לקה שחור 100 מבריק.\nמידות:\nØ 160/180/200 x גובה 72 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Tables/Mars Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Mars Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Mars Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Mars Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Mars Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Mars Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Mars Table/6.jpg",
      "../upload_images/PaoloCasteli/Tables/Mars Table/7.jpg",
      "../upload_images/PaoloCasteli/Tables/Mars Table/8.jpg",
      "../upload_images/PaoloCasteli/Tables/Mars Table/9.jpg",
      "../upload_images/PaoloCasteli/Tables/Mars Table/10.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/mars-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 20423,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "My Beauty Desk": {
    "description": "יופיי הוא שולחן איפור עם מבנה גשר וכנף מרכזית שמסתירה מראה מוארת ב-LED, עם תא מרכזי ושני מגירות צד מרופדות ומצופות במיקרופייבר. הוא עשוי כולו מ-MDF עם גימור לקה 100 מבריק. קופסת תכשיטים אופציונלית זמינה על פי בקשה.\nמידות:\nרוחב 135 x עומק 60 x גובה 121 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Tables/My Beauty Desk/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/1.png",
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/2.jpg",
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/3.jpg",
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/4.jpg",
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/5.jpg",
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/6.jpg",
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/7.jpg",
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/8.jpg",
      "../upload_images/PaoloCasteli/Tables/My Beauty Desk/9.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/my-beauty/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 22876,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Nettuno Desk": {
    "description": "שולחן Nettuno שולחן כתיבה הוא התאמה משרדים של שולחן Nettuno. החלק העליון מכוסה בעור גרגר מלא עם שוליים ממתכת בגווני שחור מט וגימורי ניקל סאטן מט עם פרטים מוזהבים מט. הבסיס עשוי מתכת מקופלת בגימור ניקל שחור מבריק. מגירה עצמאית מכוסה לגמרי בעור גרגר מלא, מסילות מגירה הפתיחה בלחיצה ומנעול הדלת לביטחון.\nמידות:\nרוחב 210 x עומק 90 x גובה 75 ס\"מ\nגלה את כל משפחת Nettuno: שולחן Nettuno, שולחן קפה Nettuno, מנורת שולחן Nettuno",
    "image_url": "../upload_images/PaoloCasteli/Tables/Nettuno Desk/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Nettuno Desk/1.png",
      "../upload_images/PaoloCasteli/Tables/Nettuno Desk/2.png",
      "../upload_images/PaoloCasteli/Tables/Nettuno Desk/3.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/nettuno-desk-paolo-castelli/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 26117,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Nettuno Table": {
    "description": "שולחן Nettuno הוא שולחן בעל אישיות ייחודית עם מבנה מתכת בגימור זהב מט סאטן ובסיס ממתכת שחורה בניקל cnc (בקרה מספרית). החלק העליון מעץ אקליפטוס עם גימור בשחור מט סביב השוליים.\nמידות:\nעגול: Ø180 – L 95 x A 75 ס\"מ\nמלבני: L 250 x P 110 x A 75 ס\"מ\n\nגלו את כל משפחת Nettuno: שולחן קפה Nettuno, שולחן כתיבה Nettuno, מנורת שולחן Nettuno",
    "image_url": "../upload_images/PaoloCasteli/Tables/Nettuno Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Nettuno Table/1.png"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/nettuno-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 13443,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Nucleo Lounge Table": {
    "description": "Nucleo חוגג את הטבעיות הטהורה של צורות וחומרים, ומציע פתרונות המעדיפים אופנות ביומורפיות, מושלמות בחוסר השלמות שלהן. שולחן מרכזי, שולחן סלון וקונסולה, שנעשים במיומנות על ידי ידי אומנים מומחים באיזון אסתטי של נפחים מאוזנים, מועשרים בצורות דינמיות וחומרים בעלי אופי חזק. השולחן המרכזי והקונסולה מוגדרים על ידי צללית פיסולית שנוצרת באמצעות השימוש דקורטיבי והמבני בדולומיה, אבן טבעית מקומית שמסמלת את הזהות של ההרים האיטלקיים. הברק הגירתי של המינרל נתמך על ידי מבנה תומך בגימור מתכת קלמינה או ברונזה צל אפור מט, שנראה דרך החתכים שמאפיינים את המחקר האסתטי של רגליו, תומכים במשטח באמצעות קצב אי-סימטרי ומפתיע.\n\nבשולחן הסלון עץ ומתכת משלימים זה את זה, ויוצרים שלם הרמוני בעל זהות חזקה. התוצאה היא תזכורת לפשטות המורכבת שמלווה בהרמוניה את החברותיות, הפעולות והיחסים המעצובים מסביב לשולחן.\nמידות:\nסלון: אורך: 160; גובה: 65; עומק: 160 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Tables/Nucleo Lounge Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Nucleo Lounge Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Nucleo Lounge Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Lounge Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Lounge Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Lounge Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Lounge Table/6.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/nucleo-lounge-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 18712,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Nucleo Table": {
    "description": "נוקלאו חוגג את הטבעיות הטהורה של צורות וחומרים, וכך מציע פתרונות המעדיפים אופנות ביומורפיות, מושלמות באי-שלמותן. שולחן ראשי, שולחן רביצה וקונסולה, מעוצבים בכשרון על ידי ידיים של בעלי מלאכה מומחים באיזון אסתטי של נפחים מאוזנים, מועצמים באמצעות צורות וחומרים דינמיים עם אופי חזק. השולחן הראשי והקונסולה מוגדרים על ידי סילואטה פיסולית שנוצרה באמצעות השימוש הדקורטיבי והמבני של דולומיה, אבן טבעית מקומית המהווה סמל זהות של הרי איטליה. הברק הגירני של המינרל משתלב במבנה התומך בגימור מתכת מט קלמין או ברונזה צל, הנראה דרך החתכים שמאפיינים את המחקר האסתטי של רגליו, התומכים במשטח דרך קצב אסימטרי ולא צפוי.\nמידות:\nשולחן: אורך: 287; גובה: 75; עומק: 127",
    "image_url": "../upload_images/PaoloCasteli/Tables/Nucleo Table/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Tables/Nucleo Table/1.png",
      "../upload_images/PaoloCasteli/Tables/Nucleo Table/2.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Table/3.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Table/4.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Table/5.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Table/6.jpg",
      "../upload_images/PaoloCasteli/Tables/Nucleo Table/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/tables/nucleo-table/",
    "company_name": "Paolo Casteli",
    "original_category": "Tables",
    "price": 11600,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Indoor"
  },
  "Origami Wall": {
    "description": "קיר אוריגמי, יופי מעודן, אור מלא ולעולם לא פולשני שמאיר את החדר ומעורר אווירה רחוקה. \nקיר האוריגמי מאופיין בעיצוב עכשווי וארוך-ליניארי של רכיביו הפרטיים, כל אחד מורכב משני אלמנטים: המבנה בגימור כפול, זהב מט-מוברק ושחור מט, נחצה על ידי מוט פליז המכיל את מקור האור LED.\nבשילוב, הקורות יוצרות מאוורר אור שמאנימה את החלל, מעניקה תנועה לקיר. הייחודיות של עיצובו מאפשרת לקיר האוריגמי ליצור קומפוזיציות גרפיות מרובות, חושפת את אופיו הדקורטיבי ביותר, אפילו כשהאורות מכובים.\n\nחומרים\nמבנה: מתכת, פליז\n\nגימורים\nמבנה: זהב מט מוברק וזהב מלוטש\nמקור אור: LED\nהספק כולל: 6W / מתח: 24 V / שטף אור נקוב: 600 Lm / טמפרטורת צבע: 3000°K / \nמדד רנדור צבעים: CRI 90 סטנדרטי / פונקציית עמעם: לא\n\nמידות: אורך: 10 ס\"מ, גובה: 65/5 ס\"מ",
    "image_url": "../upload_images/PaoloCasteli/Wall Lamps/Origami Wall/main.png",
    "image_urls": [
      "../upload_images/PaoloCasteli/Wall Lamps/Origami Wall/1.png",
      "../upload_images/PaoloCasteli/Wall Lamps/Origami Wall/2.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Origami Wall/3.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Origami Wall/4.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Origami Wall/5.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Origami Wall/6.jpg",
      "../upload_images/PaoloCasteli/Wall Lamps/Origami Wall/7.jpg"
    ],
    "product_url": "https://www.paolocastelli.com/en/prodotto/wall-lamps/origami-wall/",
    "company_name": "Paolo Casteli",
    "original_category": "Wall Lamps",
    "price": 20420,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Indoor"
  },
  "Adam Sofa": {
    "description": "קולקציית הספה אדם משלימה אזור רגיעה חיצוני. הודות לאלומיניום של המבנה ולבד המשמש לריפוד הכריות, המוצר עמיד לחלוטין בפני מזג האוויר, ומתאים בצורה מושלמת לעיצוב של הקולקציה.",
    "image_url": "../upload_images/Talenti/Sofa/Adam Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Adam Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Adam Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Adam Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Adam Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Adam Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Adam Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Adam Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Adam Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/adam-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 26195,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Alabama-Alu Two-seater sofa": {
    "description": "ספת החוץ הדו-מושבית Alabama Alu מתבלטת בזכות המושב הנוח שלה ובזכות גודלה הקטן המסוגל לספק כל צורך של מרחב וסגנון. עיצוב מתוחכם ומסורת אמנותית מאפיינים את ספת Alabama, שהיא תוצאה של עבודה ידנית מוקפדת ומורכבת. המבנה עשוי מאלומיניום מצופה באבקה, ורצועת עץ טיק גומרת את הצד העליון של הידיות ומשענות הגב. רצועות אלסטיות סינתטיות המיועדות במיוחד לחללים חיצוניים תומכות במושב ובמשענת הגב. הכרים עשויים מבד נשלף שקל לכבס ועמיד בפני תנאי מזג האוויר. ריפוד ספוג שמתייבש מהר.",
    "image_url": "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Alu Two-seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-alu-two-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 18886,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Alabama-Wood 2 Seater sofa": {
    "description": "ספת עץ אלבמה לשני אנשים לשימוש חיצוני בולטת בזכות מושבה הנוח והגודל הקטן שלה, המאפשר לספק כל צורך במרחב ובסגנון. העיצוב החם והמרשים הופך את ספת אלבמה למלאה ופונקציונלית. \nהכריות, מבד נשלף, נתמכות על ידי רצועות סינתטיות. הריפוד עשוי מקצף המתייבש במהירות, שיחד עם עמידות החומרים למזג האוויר, הופכים את הספה למושלמת עבור השטח החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Alabama-Wood 2 Seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-wood-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 17493,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Abel Sofa": {
    "description": "",
    "image_url": "../upload_images/Talenti/Sofa/Abel Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Abel Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Abel Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Abel Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Abel Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Abel Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Abel Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Abel Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Abel Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Abel Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/abel-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 23347,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Allure 2 Seater Sofa": {
    "description": "ספת החוץ בעלת שני המושבים מקולקציית Allure משלבת אלגנטיות ופורמליות. ייחודיות הספה היא בהתאמה האישית של משענות היד, אשר בזכות שילוב של שני הגרסאות הזמינות, מעניקה לסביבה אופי ואישיות. משענת היד המכוסה בבד, עם העיצוב הגיאומטרי שלה, מספקת חוזק ויציבות. הקו הגמיש של משענת היד מעץ ואלומיניום משרה קלילות ועידון. כריות גיאומטריות ולינאריות, מעשירות על ידי שילובים ותסריטים שונים.",
    "image_url": "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/15.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Allure 2 Seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 27228,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Allure 3 Seater Sofa": {
    "description": "ספת החוץ תלת-הישבנים Allure, מעניקה אופי ואישיות לסביבת החוץ בה היא מוצבת. היא כוללת שני סוגים של משענות יד לבחירה, אשר השילובים ביניהם יוצרים סגנונות שונים: עבה וגיאומטרי עם משענת יד מכוסה בבד, או אלגנטי וקליל עם משענת יד מעץ ואלומיניום. ההרמוניה בין השילובים השונים משפיעה על הסגנון הסופי של הספה. הצורות הקפדניות והצבעים הרכים של הכריות משלימים את העיצוב ואת האופי של הגן.",
    "image_url": "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/15.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Allure 3 Seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 11325,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu 3 seater sofa": {
    "description": "ספת ה-3 מקומות Argo Alu מאופיינת במבנה אלומיניום הכולל חגורות צד רחבות. הרצועות האלסטיות מכסות את כל היקף המושב ויוצרות משחק צבעים. הכריות העוטפות, הרכות והנוחות, מעניקות לרהיט זה קו עכשווי שמתאים לרגעי הרגיעה שלך בחוץ. הבסיס בצורת מזחלת יוצר תחושה של ריחוף קסום של הריפוד, ומאזן את הפרופורציות. הכריות, הממולאות בקצף המתייבש במהירות, כוללות כיסויים נשלפים והופכות את ה-Argo Alu לספה המושלמת למרחב המגורים הנעים בחוץ.",
    "image_url": "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Argo-Alu 3 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 12286,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood 3 seater Sofa": {
    "description": "הספה התלת מושבית ארגו מזכירה את הנושא של הקופסה מעץ, שממנה שואבת ההשראה כל הקולקציה. מאופיינת ברצועות צד גדולות המכילות את הכריות ויוצרות מושב מזמין ומפוסל, רהיט זה בעל טעם קפדני, גיאומטרי ומהודר. רגלי הבסיס דמויות המזחלת תומכות בכל המבנה ומרימות את הספה: היא נראית כאילו מרחפת במשחק של נפחים ופרופורציות. הריפוד הנשלף ומילוי הקצף המתייבש מהר הופכים ספה זו לאידיאלית לחלל חיצוני אלגנטי ומזמין.",
    "image_url": "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/15.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood 3 seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 14615,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood Sofa love seat": {
    "description": "קווים מתפתלים במשענות היד וצורות גיאומטריות במושבים מתמזגים לכדי ספת אהבה ארגו, מושלמת להנות מהרגעים הרגועים שלך בזמנך הפנוי. רגלי העץ המעוגלות, המעוגנות מבחוץ, הן האלמנט המרכזי של הספה הזו. משענות היד ומשענת הגב הרחבה, המורכבות מחבלים ארוגים בסגנון ימי, יוצרים משחק מעודן בין חומר ונפח, בהתאם לסגנון כל האוסף. ריפוד הקצף המהיר לייבוש של הכריות, יחד עם הבדים העמידים למזג האוויר, מאפשרים לך לעצב את האזור החיצוני שלך בצורה פונקציונלית.",
    "image_url": "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/main.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/13.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/12.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/11.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/10.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/9.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/8.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/7.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/6.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/5.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/4.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/3.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/2.jpg",
      "../upload_images/Talenti/Sofa/Argo-Wood Sofa love seat/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-sofa-love-seat/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 13044,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Canopy Sofa": {
    "description": "וילון אחורי מתקפל שמכסה את שטח המושב מאפיין את ספת הצללה CleoSoft Alu. ספה גיאומטרית ונוקשה זו עוצבה על ידי המעצב מרקו אצ'רביס לצד אביזרים נוספים בסגנון גמיש יותר של כורסאות הטרקלין. המבנה עשוי מאלומיניום מצופה באבקה והכריות מבד נשלף, קל לכביסה ועמיד בפני מזג האוויר. הריפוד עשוי קצף שמתייבש במהירות ווילון עשוי בד טקסטילן לבן.",
    "image_url": "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Canopy Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-canopy-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 27830,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Three-seater Sofa": {
    "description": "הספה החיצונית CleoSoft Alu בעלת 3 מושבים מסכמת את מאפייני הנפח, הצורה והאיזון של כל הקולקציה. הריפוד הנפחי של המושב והמשענת, עשוי מבד נשלף, קל לכביסה ועמיד בפני מזג האוויר, מונח על מבנה עשוי אלומיניום מצופה אבקה. הריפוד עשוי מספוג המתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Alu Three-seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-three-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 24765,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood 3 seater sofa": {
    "description": "העיצוב של קולקציית CleoSoft Wood מפצה על המסגרת העץ הנוקשה של ספת החוץ בת שלושת המושבים עם הקווים הרכים יותר של המודולים האחרים. הריפוד השופע של המושב והמשענת, עשוי מבד ניתן להסרה, קל לכביסה ועמיד בפני מזג האוויר, נשען על המסגרת העץ החזקה, סימן ההיכר של כל הקולקציה. המילוי עשוי מקצף המתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/16.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/15.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/14.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/13.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/12.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood 3 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 24602,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Divano love seat": {
    "description": "\nספת הדו-מושבית CleoSoft Wood משקפת את המהות של המודולים המאפיינים בצורות רכות. מוצעת בשילוב עם אלמנטים גאומטריים ויצירתיים יותר, היא עשויה ממסגרת עץ וכריות בד מרופדות בקצף שמתייבש במהירות. הכיסויים הנשלפים קלים לניקוי ועמידים בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/main.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/15.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/14.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/13.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/12.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/11.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/10.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/9.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/8.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/7.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/6.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/5.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/4.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/3.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/2.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Divano love seat/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-divano-love-seat/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 13656,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Swing sofa": {
    "description": "ספת הנדנדה הדו-מושבית מקו CleoSoft Wood משקפת את תחושת הרוגע, האלגנטיות והפשטות שמאפיינת את כל מרכיבי הקולקציה הזו. המושב נזכר בצורת הספה הדו-מושבית, בהתאם לסגנון המעודן שהוצע על ידי המעצב מרקו אסרביס.",
    "image_url": "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/main.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/12.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/11.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/10.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/9.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/8.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/7.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/6.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/5.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/4.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/3.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/2.jpg",
      "../upload_images/Talenti/Sofa/CleoSoft-Wood Swing sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-swing-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 17635,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Braiding Sofa": {
    "description": "המושב הרחב הוא דוגמה מושלמת לצורה הייחודית של אלמנטי קליף. קשירת החבל נמצאת באלמנטים האחרים של האוסף והופכת את האלמנט הזה להתאמה מושלמת עם רעיון המשחק והכיף שמאפיין את כל קליף.",
    "image_url": "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Cliff Braiding Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-braiding-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 13555,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Dèco Braiding Sofa": {
    "description": "בטנת הקליף דקò היא רחבה ואלגנטית. המשענת שלה, העשויה מחבל סינטטי ימי, תואמת את בד הכריות, ויוצרת ניגוד נעים. מסגרת האלומיניום מבטיחה יציבות למוצר.",
    "image_url": "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Braiding Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-deco-braiding-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 17391,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Dèco Fabric Sofa": {
    "description": "השילוב המושלם בין בד לחבל הוא האלמנט המרכזי בספת Cliff Decò. משענת הגב, העשויה מבד עמיד למזג האוויר, תואמת למבנה של משענות הידיים, המכוסים לגמרי בחבל סינתטי ימי. מאופיינת בצורה קווים ישרים, הספה מושלמת לקישוט האזורים החיצוניים שלך, ומשקפת את הסגנון של הקולקציה.",
    "image_url": "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Cliff Dèco Fabric Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-deco-fabric-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 28361,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Fabric Sofa": {
    "description": "הצורה של המושבים הרחבים בעיצוב קליף מאפיינת את הספה הזו. זהו הגרסה שבה הקליעה בחבל מוחלפת בבד שמכסה את מסגרת הפלדה הצינורית.\nהמושב הרחב הוא דוגמה מושלמת לצורה הייחודית של מרכיבי קליף.",
    "image_url": "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Cliff Fabric Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-fabric-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 23147,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral two-seater sofa": {
    "description": "ספת הקוראל לשני אנשים מתבלטת בזכות הקווים הנקיים שלה והאיכות הגבוהה של חומריה. שלדת האלומיניום מכוסה בחבל סינתטי, זמינה בצבעים שונים, משתלבת עם מושב גבוה ונוח. הכריות עם הכיסויים הנשלפים יחד עם הבדים העמידים למזג האוויר הופכים את ספת הקוראל לשני אנשים לבחירה האידיאלית להנאה מרגעי רוגע במרחב החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Sofa/Coral two-seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Coral two-seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-two-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 29911,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cottage Sofa": {
    "description": "רוח כפרית לספה של אוסף קוטג' שמזכירה את המושבים של המערב הפרוע. בספת הקוטג' האלומיניום של המסגרת וחגורות הסינתטיות של המושב והמשענת מתקיימים בהרמוניה עם חומרים מסורתיים יותר כמו החבל המונח על משענות היד.",
    "image_url": "../upload_images/Talenti/Sofa/Cottage Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cottage Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 25253,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cottage Sofa luxury 2 seater": {
    "description": "כורסאת שני מושבים יוקרתית מדגם The Cottage, המאופיינת בקווים פשוטים וגיאומטריים, מושלמת לעיצוב האזורים החיצוניים שלכם. מסגרת האלומיניום מבטיחה את יציבות המוצר יחד עם תמיכת הרצועות האלסטיות. הכריות, עם ריפוד קצף שמתייבש במהירות, מרופדות בבד נשלף ועמיד בפני מזג האוויר. חבל ימי משלים את המוצר.",
    "image_url": "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/main.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/9.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/8.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/7.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/6.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/5.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/4.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/3.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/2.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 2 seater/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-sofa-luxury-2-seater/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 22857,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cottage Sofa luxury 3 seater": {
    "description": "ספת היוקרה עם 3 מושבים מדגם הקוטג' משלבת חדשנות ופונקציונליות. היא גדולה ונוחה, וכריותיה ממולאות בקצף המתייבש במהירות. הריפוד מבד עמיד בפני תנאי מזג האוויר, אידיאלי לריהוט חוץ. הרצועות הסינטטיות האלסטיות המוצמדות למבנה האלומיניום מבטיחות את יציבות המוצר.",
    "image_url": "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/main.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/9.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/8.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/7.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/6.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/5.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/4.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/3.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/2.jpg",
      "../upload_images/Talenti/Sofa/Cottage Sofa luxury 3 seater/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-sofa-luxury-3-seater/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 23160,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-Teak 3 seater Sofa": {
    "description": "ספת שלושה מושבים של אוסף Cruise Teak מיוצרת בסגנון ימי ומעורר השראה מהטבע. המבנה כולו עשוי מעץ בעוד שהבד של הכריות, עמיד לתנאי מזג האוויר, הופך את המוצר למושלם לאזור מחייה חיצוני. השימוש בחבל סינתטי שמור למשענות הידיים ולמושב הרחב, אידיאלי לרגעי מנוחה בחוץ.",
    "image_url": "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Cruise-Teak 3 seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 10447,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu 3 seater Sofa": {
    "description": "הספה בת שלושת המושבים של Cruise Alu Collection עשויה מאלומיניום יצוק, מה שמקנה למוצר צורה לינארית, פשוטה ואלגנטית. שילובי הצבעים של המבנה, יחד עם אלו של בד הכריות ועמידותם המלאה בתנאי מזג האוויר, מאפשרים ליצור סביבה חיצונית עם אווירת רוגע אמיתית. משענת הגב והמשענות מכוסות בחבל סינתטי, בהתאם לסגנון הימי של הקולקציה.",
    "image_url": "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu 3 seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 20144,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu love seat Sofa": {
    "description": "עם הצורות הרכות והמתעגלות שלה, ספת ה-Love Seat מקולקציית Cruise Alu מושלמת לרגעים של מנוחה. יציבות המבנה מובטחת בזכות אלומיניום יצוק שמקנה את הסגנון הבלתי ניתן לערעור של הקולקציה. הכריות, עשויות מקצף מהיר ייבוש, משתלבות עם הבד, עמידות לתנאי מים, ועם החבלים הסינתטיים שעוטפים את משענת הגב והידיות.",
    "image_url": "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Cruise-alu love seat Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-love-seat-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 21155,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Love seat": {
    "description": "אלגנטי ותוסס, ספת האהבה דולצ'ה ויטה מושלמת לרגעי רגיעה בגינה. המבנה העשוי עץ מכיל מושב רחב, המעוטר בשזירה צפופה של חבלים וכרית נוחה. השזירה מגיעה לשיא ביטויה בגב, וחושפת מגע של אומנות מעודנת. רהיט זה מסוגל להעניק רעננות ואישיות לסלון החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Sofa/Dolcevita Love seat/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/main.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/13.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/12.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/11.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/10.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/9.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/8.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/7.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/6.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/5.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/4.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/3.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/2.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Love seat/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-love-seat/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 29235,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Sofa 3 seats": {
    "description": "ספת הדולצ'וויטה בת 3 מושבים היא מחווה לערבי הקיץ החמימים. כל פרט, החל מהשזירה הצפופה של החבלים שמאפיינת את דפנות הקיר ומשענות היד, ועד לגימורי עץ הטיק, תוכנן בכדי להזכיר את הקלילות של העונה המתוקה ביותר. פתרון מושלם לאזור הרפיה בגינה בעלת ניחוח רענן. הבחירה הרחבה של צבעי הפסטל מאפשרת להתאים את פריט הריהוט הזה לכל חלל פתוח.",
    "image_url": "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/main.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/15.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/14.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/13.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/12.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/11.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/10.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/9.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/8.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/7.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/6.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/5.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/4.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/3.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/2.jpg",
      "../upload_images/Talenti/Sofa/Dolcevita Sofa 3 seats/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-sofa-3-seats/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 23183,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ever 2 seater sofa": {
    "description": "ספת ה-Ever ל-2 אנשים היא ביטוי אותנטי של אלגנטיות נצחית. קווים בסיסיים וכריות רכות משתלבים יחד בהרכב מינימליסטי המאתגר טרנדים ויוצר אווירה נינוחה לחיי החוץ. היא משתלבת באופן מושלם במרחבים חיצוניים, בזכות טווח הצבעים הניטרלי, בהשראת הסביבה הטבעית. רהיט נוח ורב-תכליתי המסוגל להתאים לכל סגנון.",
    "image_url": "../upload_images/Talenti/Sofa/Ever 2 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Ever 2 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 22608,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ever 3 seater sofa": {
    "description": "הספה בת שלושה מושבים Ever עוברת את מבחן הזמן הבלתי נגמר, הודות לאלגנטיות המינימלית שלה, העיצוב המתקדם וחומריה העמידים. הקווים הרכים, העגלגלות של הכריות וההרכב החיוני, מאפשרים להשתלב בטבעיות בסביבות חוץ, ולהסתגל בכישרון לסגנונות ועידנים שונים. טווח הצבעים הנייטרליים שבו היא זמינה, מעניק לסגנון החיים החיצוני סגנון אותנטי ונצחי.",
    "image_url": "../upload_images/Talenti/Sofa/Ever 3 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Ever 3 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 18169,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Frame 2 seater sofa": {
    "description": "קווים גמישים ותחושתיים מוצאים משמעות מלאה בספת דו-מושבית, פריט ריהוט הכרחי להוספת נגיעה של אלגנטיות למרחב המגורים החיצוני שלכם. השילוב של חבל ריפוד במסגרת, היוצר משחקי אור מרתקים כשקרני השמש נוגעות בחריצים, הוא סימן ההיכר של הספה הזו. הישיבה הנוחה והנעימה מתאפיינת בנפח מוצק ופסלי המאזן עם הרכות של משענת הגב. החומרים העמידים בפני מזג האוויר, המבנה והמילוי הקצף שמתייבש במהירות מתמזגים לפריט ריהוט מושלם להוספת ערך למרחב המגורים החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Sofa/Frame 2 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Frame 2 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/frame-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 21725,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Frame 3 seater sofa": {
    "description": "ספת שלושה מושבים \"פריים\" מאופיינת באותם אלמנטים מרכזיים של כל הקולקציה: מבנה צינורות האלומיניום משלב את הפונקציונליות של החומר העמיד בפני מזג האוויר עם האלגנטיות של הצורות המתעקלות. המושב המוצק והמזמין מועשר במבחר של בדים נועזים, המשמשים גם לריפוד הכריות הרכות והנפחיות של המשענת. השילוב של החבל המרופד במשענות היד והגב הוא הפרט הבלתי ניתן לטעות של הקולקציה, המעניק נגיעה מעודנת וחושנית לרהיט זה.",
    "image_url": "../upload_images/Talenti/Sofa/Frame 3 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Frame 3 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/frame-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 15865,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "George 2 Seater sofa": {
    "description": "פירוטם של הזקופים הנירוסטה הגלויים והחגורות המרופדות הופכים את ספת ה-2 מושבים ג'ורג' לפריט ריהוט אידיאלי לבילוי רגעי רגיעה והרמוניה במרחב המגורים החיצוני שלך. כריות המושב והגב המרופדות בנדיבות והבדים הזמינים בצבעים שונים הופכים את ספת ג'ורג' לנוחה ומזמינה.",
    "image_url": "../upload_images/Talenti/Sofa/George 2 Seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/George 2 Seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 14011,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Karen Sofa": {
    "description": "ספת קארן מתאפיינת באסתטיקה שבטית המשדרת את עוצמת ויופיים של אדמות אפריקה. הצורות העוטפות והקווים המעוגלים מעניקים לספה את ההדר של כיסא מלוכה ובאותו זמן מעבירים תחושת ביטחון ושלווה, כמו בקן מגן. אריגי הבד שמשלבים בין משענות הידיים למשענת הגב, נושאים טעם עבודת יד שמעניק לסגנון החיצוני אישיות ואופי.",
    "image_url": "../upload_images/Talenti/Sofa/Karen Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Karen Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/15.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Karen Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 29230,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Key Sofa": {
    "description": "ספת קולקציית ה-Key משלבת בצורה חכמה את הקלילות של החומרים עם הקלילות של הצורות. המבנה, העשוי מאלומיניום, תומך בגוף בזכות כריות עשויות טקסטילן, הנתמכות על ידי האריגה האופיינית של החבלים הסינתטיים של הקולקציה.",
    "image_url": "../upload_images/Talenti/Sofa/Key Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Key Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Key Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/key-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 28412,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Lake 2-seater Sofa": {
    "description": "הספה הדו-מושבית \"לייק\" מעשירה את הסביבה החיצונית באלגנטיות ומקוריות, בזכות העיצוב הייחודי המזכיר את הצורות הטבעיות של צמח הבמבוק. מבנה התמיכה מורכב ממקטעי אלומיניום צינוריים, המתחברים זה לזה באמצעות קשר מעניין על יציקה, הדומה לטבעות קשיחות אך בו זמנית גמישות שמאפיינות את מקל הבמבוק.",
    "image_url": "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Lake 2-seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 29912,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Lake 3-Seater Sofa": {
    "description": "הספה התלת-מושבית מקולקציית Lake מתאפיינת בעיצוב מקורי וחדשני בהשראת האלגנטיות הטבעית של הבמבוק. המודולים הצינוריים שמרכיבים את מבנה התמיכה עשויים מאלומיניום ומתחברים דרך צומת מעניין, שמעורר את היופי הזורם של קני הבמבוק. היא מעשירה את הגן באלגנטיות ובמקוריות.",
    "image_url": "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Lake 3-Seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 25394,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf 2 seater sofa": {
    "description": "ספת שני המושבים מקולקציית Leaf תעניק לכם רגעים מרגיעים בחוץ בזכות המושב הרך והרחב שלה. הקלות של מסגרת האלומיניום בשילוב עם העמידות שלה יוצרים את הפריט המושלם לריהוט חוץ מודרני ותחושתי.",
    "image_url": "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/20.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/19.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/18.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/17.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/16.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/15.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Leaf 2 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 12173,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf 3 seater sofa": {
    "description": "הספה בת שלושה המושבים מדגם ליף (Leaf) מזכירה את הנושא של הטבע שמעניק השראה לקולקציה כולה. כמו פרח שהגבעול שלו מרחף באוויר בנופח הרוח, ספת הגן מדגם ליף משלבת רגליים דקות שפונות כלפי מעלה ויוצרות תחושת ריחוף הכריות האלגנטיות והקלות. \nמושב נוח, רך ומרווח זה לריהוט גן משתלב באופן מושלם בסביבה טבעית ובעלת עיצובים.",
    "image_url": "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/20.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/19.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/18.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/17.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/16.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/15.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Leaf 3 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 13575,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo Three-seater Sofa": {
    "description": "טעם רומנטי לספת החוץ של קולקציית מילו, שנוצרה בהשראת העבודות המוקפדות של חייטים. הספה משתלבת ללא יומרה במרחב החיצוני ומעניקה לו אלגנטיות. שלדת אלומיניום מצופה אבקה, ריפוד טקסטילן וכריות. הכריות ניתנות להסרה, קלות לכביסה ועמידות בפני פגעי מזג האוויר. ריפוד מקצף המתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Milo Three-seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-three-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 10106,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo Two-seater Sofa": {
    "description": "תשומת לב לפרטים ואלגנטיות רומנטית הנחו את מרקו אצרביס בעיצוב ספת המילו דו-מושבית. גם אם היא משתלבת במרחבים הפתוחים מבלי להפגין יהירות, מדובר בפריט בעל נשמה חזקה, עם קו גמיש אך גם נוקשה. המבנה עשוי מאלומיניום בציפוי אבקה; הריפודים והכריות עשויים מטקסטילן. הכריות, הממולאות בקצף המתייבש במהירות, ניתנות להסרה, קלות לכיבוס ועמידות בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Milo Two-seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-two-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 24027,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu Love Seat": {
    "description": "",
    "image_url": "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/main.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/13.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/12.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/11.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/10.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/9.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/8.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/7.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/6.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/5.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/4.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/3.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/2.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Love Seat/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-love-seat/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 29076,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu Two-seater Sofa": {
    "description": "הספה החיצונית לשניים \"Moon\" נולדה בהשראת הירח. למעשה, הגב שלה מחזיר את הצורה של חצי ירח. הקלילות בשזירת החבלים והפרקטיות של המבנה מאלומיניום הם התכונות של הספה הזו שעוצבה על ידי קריסטיאן ויסנטין.",
    "image_url": "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Moon-Alu Two-seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-two-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 14219,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Teak Two-seater Sofa": {
    "description": "הספה הדו-מושבית החיצונית Moon נוצרה בהשראת הירח. משענת הגב שלה, למעשה, מזכירה את צורת החצי ירח. הקלילות בשזירת החבלים והעמידות של השימוש בעץ טיק הן התכונות של הספה הזו שעוצבה על ידי כריסטיאן ויסנטין. יש לה מבנה טבעי מעץ טיק עם משענות ידיים ומשענות גב מאלומיניום בצורת צינור מכוסים בשזירה של חבלים מבד סינתטי אפור. כריות עם בד שניתן להסיר, קל לכביסה ועמיד בפני מזג האוויר. ריפוד קצף עם ייבוש מהיר.",
    "image_url": "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Moon-Teak Two-seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-two-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 13655,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Nova 2 seater Sofa": {
    "description": "",
    "image_url": "../upload_images/Talenti/Sofa/Nova 2 seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Nova 2 seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Nova 2 seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Nova 2 seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Nova 2 seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Nova 2 seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Nova 2 seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Nova 2 seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nova-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 18540,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Nunù Sofa 2 seater": {
    "description": "",
    "image_url": "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/main.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/10.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/9.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/8.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/7.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/6.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/5.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/4.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/3.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/2.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 2 seater/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nunu-sofa-2-seaters/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 14824,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Nunù Sofa 3 seater": {
    "description": "",
    "image_url": "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/main.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/10.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/9.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/8.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/7.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/6.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/5.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/4.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/3.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/2.jpg",
      "../upload_images/Talenti/Sofa/Nunù Sofa 3 seater/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nunu-sofa-3-seater/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 16950,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Oliver Sofa 3 seats": {
    "description": "הספה בעלת 3 מושבים אוליבר מבטאת קשר אמיתי עם הטבע, באמצעות המבנה העשוי מעץ מלא שמדגיש את המרקם המעודן של עץ הטיק. עיצוב רהיט זה מאופיין על ידי חילופי מוצקים וחללים, אשר משלבים את המוטות לאורך הקיר והידיות, בהרכב ייחודי. בתוך הארכיטקטורה של הצורות, מוקמו כריות רכות בצבע לבן עם גוון חם, שנותנות לחדר המגורים החיצוני אווירה יותר מזמינה. פתרון מושלם לאזור מרגיעה בגינה שמעביר תחושת נוחות וביטחון.",
    "image_url": "../upload_images/Talenti/Sofa/Oliver Sofa 3 seats/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Oliver Sofa 3 seats/main.jpg",
      "../upload_images/Talenti/Sofa/Oliver Sofa 3 seats/6.jpg",
      "../upload_images/Talenti/Sofa/Oliver Sofa 3 seats/5.jpg",
      "../upload_images/Talenti/Sofa/Oliver Sofa 3 seats/4.jpg",
      "../upload_images/Talenti/Sofa/Oliver Sofa 3 seats/3.jpg",
      "../upload_images/Talenti/Sofa/Oliver Sofa 3 seats/2.jpg",
      "../upload_images/Talenti/Sofa/Oliver Sofa 3 seats/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/oliver-sofa-3-seats/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 15707,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Panama Lounge sofa": {
    "description": "ספת הטרקלין פנמה, בהשראת הים, מזכירה את רוחות הים הקרירות המניעות את עצי הדקל. היא תוכננה כדי ליהנות מרגע מרגיע בחוץ, ומתאפיינת במושב נמוך, נוח וגדול. המבנה האלומיניום מועשר וזוכה להערכה בזכות האריגה מחבל ימי וסינתטי המכסה את המסגרת. השימוש בחומרים עמידים בפני מזג אוויר יחד עם המגוון הרחב של הצבעים המוצעים הופכים את ספת הטרקלין פנמה למוצר המושלם לעיטור בסגנון אזורי החוץ שלך.",
    "image_url": "../upload_images/Talenti/Sofa/Panama Lounge sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/16.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/15.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Panama Lounge sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-lounge-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 15489,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Panama Love Seat Sofa": {
    "description": "כורסה דו מושבית דגם פנמה מתבלטת בזכות צורותיה הרחבות והרכות המאפיינות את כל קולקציה. המושב המודרני, המיוצר מחבל סינתטי המיועד לשימוש ימי וזמין בשלל צבעים, הופך את המוצר לקל ונוח לשימוש. מושלם לריהוט חוץ, הספה אינה מוותרת על יציבות, המובטחת על ידי מבנה האלומיניום. אפילו הכריות (אופציונלי), עשויות מחבל, זמינות בגוונים שונים מבלי לוותר על הסגנון המוצע על ידי קולקציית פנמה.",
    "image_url": "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/17.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/16.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/15.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Panama Love Seat Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-love-seat-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 17172,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Prichi Sofa 2 seats": {
    "description": "ספת הפריצ'י לשני אנשים היא שילוב מתוחכם של העולם הטבעי והאלגנטיות האנגלית של רהיטי הפנים. עיצוב הרהיט הזה מתאפיין בקורת קיר ההמשכית עם משענות היד, המתפתחת סביב המושב עם אריג חבלים מתוחכם, השזור בלוחות עץ טיק של המבנה. הרשת המסובכת הזו יוצרת אפקט חמים ויוקרתי שמקרין את חוויית המגורים בחוץ ומעניק לגינה את הנוחות והיישוב הדעת של סביבה פנימית.",
    "image_url": "../upload_images/Talenti/Sofa/Prichi Sofa 2 seats/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Prichi Sofa 2 seats/main.jpg",
      "../upload_images/Talenti/Sofa/Prichi Sofa 2 seats/5.jpg",
      "../upload_images/Talenti/Sofa/Prichi Sofa 2 seats/4.jpg",
      "../upload_images/Talenti/Sofa/Prichi Sofa 2 seats/3.jpg",
      "../upload_images/Talenti/Sofa/Prichi Sofa 2 seats/2.jpg",
      "../upload_images/Talenti/Sofa/Prichi Sofa 2 seats/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/prichi-sofa-2-seats/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 15204,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Riviera 2 seater Sofa": {
    "description": "ספת ריביירה הדו-מושבית בולטת בקווים האלגנטיים והבהירים שלה המותאמים באופן מושלם לחלל המגורים החיצוני שלכם. האסתטיקה המעודנת והחומרים האיכותיים אינם פוגעים בפונקציונליות של המוצר הזה, המובטחת על ידי מסגרת האלומיניום. הריפוד מקצף המתייבש במהירות מרופד בכיסויים עמידים למזג האוויר וניתנים להסרה, הזמינים בשלושה צבעים שונים, משולבים בחוכמה עם גווני המסגרת ומשענות הזרוע מגרס.",
    "image_url": "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Riviera 2 seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 16611,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas 2-Seater Sofa": {
    "description": "\nהספה הדו-מושבית Salinas מביעה קסם על-זמני, הודות גם לשימוש הנבון בבדים. הקווים הרכים של הכריות מודגשים על ידי המגת הגוונים שמזכירה את הצבעים הטבעיים של חוף סאלינס שבאיביזה. הרצועה המרופדת הופכת לאלמנט עיצובי, באמצעות משחק של קומפוזיציות המשאיר פרטים מתכתיים יקרים גלויים. הסגנון המעודן של הספה מעניק קסם ורצף בין הפנים לגינה.",
    "image_url": "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Salinas 2-Seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 24761,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas 3-Seater Sofa": {
    "description": "ספת הסלינס התלת מושבית מבטאת את העידון האופייני של העולם הפנימי בחוץ, באמצעות היוקרה של הבדים. הטווח הכרומטי המעודן מעורר את צבעי החול והים, ומעניק לסביבה החיצונית קסם טבעי ונצחי. הקווים הרכים של הכריות מודגשים על ידי השימוש ברצועה המרופדת בגב שהופכת לאלמנט עיצובי. רהיט המציע המשכיות בין פנים לחוץ.",
    "image_url": "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Salinas 3-Seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 13216,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam 2 seater sofa": {
    "description": "הספה הדו-מושבית של Slam מתאפיינת בקווים נקיים וחומרים איכותיים. הכריות המחבקות, המרופדות בקצף ייבוש מהיר, עם כיסויים ניתנים להסרה וקלות לכביסה, משלבות פונקציונליות ונוחות כדי ליהנות מרגע מרגיע ונעים. מסגרת האלומיניום והשימוש בבדים ספציפיים שנוצרו במיוחד לריהוט חוץ הופכים את הרהיט הזה לעמיד בפני מזג האוויר וחיוני לעיצוב החיים החיצוניים שלך.",
    "image_url": "../upload_images/Talenti/Sofa/Slam 2 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Slam 2 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 21037,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam-Rope Sofa": {
    "description": "הספה מקולקציית Slam // Rope היא אלגנטית וקלילה במהותה. הקווים הנקיים של העיצוב מעניקים איזון וניקיון, מה שהופך אותה למתאימה לכל הקשר חיצוני. הסיומות מחבל סינתטי ארוג והכריות הנשלפות והניתנות לכביסה משלבים סגנון ונוחות, לסלון שאפשר לחיות בו לאורך זמן.",
    "image_url": "../upload_images/Talenti/Sofa/Slam-Rope Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Slam-Rope Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-rope-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 29161,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Step Two-seater Sofa": {
    "description": "ספת שני המושבים מקולקציית Step היא קלה מכל בחינה. המבנה הדק עמיד בזכות השימוש באלומיניום ונוח בזכות הטקסטילן, חומר שקל לשטוף ועמיד בפני מזג אוויר, שגם מכסה את משענות הידיים ומשענת הגב. המושב הארוך מקבל את הגוף ומבטיח נינוחות, לרגע מושלם שתוכלו לחוות בחלל החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Sofa/Step Two-seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Step Two-seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/step-two-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 14508,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Swipe Sofa 2 seats": {
    "description": "ספת Swipe דו-מושבית מבטאת קלילות ותנועה דרך עיצוב עם אישיות חזקה. משענת האלומיניום, המועשרת באריגה דינמית של חבל מרופד, עוטפת את הכריות המרווחת, המאופיינות בקווים רכים. רהיט זה הופך את פינת ההסבה החיצונית לנוחה ומזמינה, ומעניק רגעים בלתי נשכחים של הרפיה משותפת. זמינה במגוון רחב של צבעים, ספת Swipe היא רב-שימושית ומתאימה לכל הקשר חיצוני.",
    "image_url": "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/main.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/11.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/10.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/9.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/8.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/7.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/6.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/5.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/4.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/3.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/2.jpg",
      "../upload_images/Talenti/Sofa/Swipe Sofa 2 seats/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-sofa-2-seats/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 24973,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Touch Living Sofa": {
    "description": "שני המושבים של ספת ה-Living, העשויים מטקסטילן ואלומיניום, הם פשוטים אך לא בנאליים. בשילוב הגאומטריה המרובעת של המבנה עם העיקולים הרכים של הבד, היא משלבת את הפשטות של קולקציית ה-Touch עם השלמות שהמוצר יוצר במרחב החיצוני.",
    "image_url": "../upload_images/Talenti/Sofa/Touch Living Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Touch Living Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/14.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Touch Living Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-living-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 29368,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tressé Sofa 3 seats": {
    "description": "ספת תרסה בת 3 המקומות מסוגלת להסתגל לכל סביבה חיצונית, בזכות מבחר רחב של גוונים הנעים מאפור משי קר, דרך הצבע העמוק וההחלטי של בוץ, ועד להתבלט עם הצבע החם של אדמת סיינה. נוחה ומתוחכמת, פיסת ריהוט זו מתאפיינת בגימורים העדינים של הגב, הנתמך על ידי מבנה אלומיניום צינורי המצופה ביד, עם רצועות אקו-עור ארוגות במיומנות. פתרון עיצובי המעניק אופי לחללים חיצוניים ועונה על הצורך בנוחות.",
    "image_url": "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/main.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/12.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/11.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/10.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/9.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/8.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/7.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/6.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/5.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/4.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/3.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/2.jpg",
      "../upload_images/Talenti/Sofa/Tressé Sofa 3 seats/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-sofa-3-seats/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 10812,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tweet Sofa": {
    "description": "ספת טווויט בעלת נשמה מכובדת ומזמינה שיוצרת חוויה חדשה בעולם החוץ. הקווים המעוגלים בהם ניתן להרגיש חיבוק מאפיינים את עיצוב הספה, ומעניקים לחלל החיצוני אווירה מודרנית ומכילת פנים.",
    "image_url": "../upload_images/Talenti/Sofa/Tweet Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Tweet Sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Tweet Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tweet-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 28334,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice 2 seater sofa": {
    "description": "הספה בת שני המושבים בוונציה מבטאת את הקסם והקלילות של העיר ההומונימית. בסיסי העץ הטיק המוצק ועץ האקויה נועדו להבליט את הקווים הרכים של הכריות ואת כיסויי הבד האלגנטיים של הגב והמשענות, המזכירים את הסגנון הימי הקלאסי. המושבים הגדולים מעבירים תחושת נוחות ויוצרים מרחב חיצוני נעים. פתרון מושלם ליצירת אזור מרגוע בגינה.",
    "image_url": "../upload_images/Talenti/Sofa/Venice 2 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Venice 2 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 12714,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice 3 seater sofa": {
    "description": "ספת ה-3 מושבים ונציה היא מחווה לאלגנטיות והסגנון של העיר הלגונה בעלת אותו שם, אשר משתקפת בעיצוב הבסיסים העשויים עץ שנראים כצפים כמו כלי שיט. עליהם נמצאים מושבים גדולים עם קווים רכים. הסגנון הימי משתקף במרקמים של הבדים שמכסים את הגב והמשענות. ספת ונציה מוסיפה חן וקלילות לחדר המגורים החיצוני ולגינה שלך, ומציעה פתרון נעלה של נוחות. מבחר רחב של בדים מאפשר לך להתאים את פריט הריהוט הזה לכל מרחב פתוח.",
    "image_url": "../upload_images/Talenti/Sofa/Venice 3 seater sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/13.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/12.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Venice 3 seater sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-3-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 10771,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Love seat sofa": {
    "description": "כמו העיר הרומנטית בעלת אותו שם, הספה מסוג ונציה אידיאלית לרגעי הרפיה בגינה. מבנה מעץ מוצק תומך במושב הרחב והנוח. הכריות מאופיינות בקווים רכים ובדים בצבעים מעטיפי לב. חבל כרוך במשענת הגב, המזכיר את הסגנון הימי הקלאסי. פריט ריהוט זה מעניק קסם וקלילות לחלל החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Sofa/Venice Love seat sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/main.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/11.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/10.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/9.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/8.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/7.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/6.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/5.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/4.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/3.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/2.jpg",
      "../upload_images/Talenti/Sofa/Venice Love seat sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-love-seat-sofa/",
    "company_name": "Talenti",
    "original_category": "Sofa",
    "price": 23630,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Accessories Box": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Accessories Box/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Accessories Box/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Box/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Box/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Box/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Box/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Box/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-box/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 10378,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Accessories Cart": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Accessories Cart/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Accessories Cart/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Cart/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Cart/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Cart/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Cart/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Cart/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Cart/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Cart/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-cart/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 19319,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Accessories Fireplace": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Fireplace/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-fireplace/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 26185,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Accessories Ray big": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Accessories Ray big/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Accessories Ray big/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray big/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray big/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray big/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray big/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray big/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-ray-big/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 14950,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Accessories Ray small": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Accessories Ray small/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Accessories Ray small/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray small/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray small/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray small/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray small/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Accessories Ray small/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-ray-small/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 18203,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Jackie Basket": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Jackie Basket/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/19.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/18.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/17.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/16.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/15.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/14.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/13.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/12.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/11.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/10.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/9.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/8.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Basket/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-basket/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 15464,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Jackie Planter": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Jackie Planter/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/18.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/17.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/16.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/15.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/14.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/13.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/12.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/11.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/10.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/9.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/8.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Planter/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-planter/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 28215,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Jackie Pouf big": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/20.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/19.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/18.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/17.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/16.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/15.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/14.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/13.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/12.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/11.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/10.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/9.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/8.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf big/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-pouf-big/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 24197,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Jackie Pouf medium": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/20.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/19.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/18.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/17.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/16.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/15.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/14.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/13.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/12.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/11.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/10.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/9.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/8.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf medium/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-pouf-medium/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 23065,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Jackie Pouf small": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/20.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/19.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/18.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/17.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/16.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/15.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/14.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/13.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/12.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/11.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/10.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/9.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/8.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Jackie Pouf small/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-pouf-small/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 12654,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Kukà Planter D40": {
    "description": "המעמד לעציצים דגם D40 Kukà עם קווים מינימליים אך מדויקים עשוי מבטון אקולוגי ומורכב מגוף גלילי כפול, מה שהופך אותו לאידאלי להשלמת החלל החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D40/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/kuka-planter-d40/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 27119,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Kukà Planter D60": {
    "description": "עציץ ה-D60 Kukà הוא הגדול ביותר בקו ה-Kukà. הוא עשוי מבטון אקולוגי ומורכב מגוף גלילי כפול, מה שמאפשר לשלבו עם קולקציות אחרות של Talenti.",
    "image_url": "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Kukà Planter D60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/kuka-planter-d60/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 11862,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Path planter + handrail h100": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/path-planter-handrail-h100/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 21776,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Path planter + handrail h120": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/path-planter-handrail-h120/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 15191,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Path planter + handrail h85": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter + handrail h85/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/path-planter-handrail-h85/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 21088,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Path planter h100": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Path planter h100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Path planter h100/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h100/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h100/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h100/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h100/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h100/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h100/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/path-planter-h100/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 24147,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Path planter h120": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Path planter h120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Path planter h120/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h120/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h120/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h120/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h120/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h120/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h120/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/path-planter-h120/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 16726,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Path planter h85": {
    "description": "",
    "image_url": "../upload_images/Talenti/Accessories & decor/Path planter h85/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Path planter h85/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h85/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h85/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h85/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h85/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h85/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h85/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Path planter h85/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/path-planter-h85/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 27270,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Scacco H135 Partition": {
    "description": "אוסף Scacco H135 מציג את האפקט הגאומטרי הנעים שהיווה השראה לאוסף. חבלים סינתטיים ימיים המשמשים למבנה מכסים את מבנה האלומיניום המוצק והבטוח שמרכיב מוצר מיוחד ואלגנטי זה.",
    "image_url": "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/9.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/8.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H135 Partition/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/scacco-h135-partition/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 23721,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Scacco H200 Partition": {
    "description": "אידיאלי להתאמה אישית של ריהוט חוץ, מחיצת Scacco אוסף H200 מאופיינת בגובהה. הדוגמה הגיאומטרית, עם המוטיב המשובץ, מבוצעת מאלומיניום המכוסה בחבלים סינתטיים ימיים.",
    "image_url": "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/8.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Scacco H200 Partition/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/scacco-h200-partition/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 17753,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Showergate Shower": {
    "description": "שוארגייט (Showergate) הוא פריט ריהוט המשתלב באופן מושלם עם ריהוט החוץ מקולקציות טלנטי (Talenti). עם פריט זה, המעצב מרקו אצרביס (Marco Acerbis) שאף ליצור מוצר פונקציונלי המעביר, בו בזמן, את התחושה הנעימה של מקלחת מרעננת עם אובייקט עיצובי בעל השפעה ויזואלית מרשימה.",
    "image_url": "../upload_images/Talenti/Accessories & decor/Showergate Shower/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Showergate Shower/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Showergate Shower/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Showergate Shower/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Showergate Shower/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Showergate Shower/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-shower/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 12243,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Tikal Column Module": {
    "description": "עמוד עם מדפי מתכת נשלפים ומתכווננים. דלת נדנדה עם ידיות שקועות, פתיחה מהירה ב-125° ונעילה עם בלומושן. אפשרות להכללת מכשירים: מקרר (596x550x860) מדיח כלים (600x600x820).",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal Column Module/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal Column Module/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/12.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Column Module/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-column-module/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 26319,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Tikal Shelf module 120×190": {
    "description": "מדף עם מדפי מתכת נשלפים ומתכווננים.",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 120×190/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-shelf-module-120x190/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 19939,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Tikal Shelf module 80×190": {
    "description": "מדף עם מדפי מתכת נשלפים ומתכווננים.",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/13.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/12.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Shelf module 80×190/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-shelf-module-80x190/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 22640,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Tressé Cube": {
    "description": "הצורה הראשונית ממנה נולדת כל הקולקציה, רהיט זה פונקציונלי הן כשולחן קפה והן כשולחן בעת רגעי הרפיה. הוא משתלב בסביבות חוץ באלגנטיות, בזכות קליעת רצועות עור מתוחכמת, תוצרת יד. בזכות הווריאציות הכרומטיות בהן הוא זמין, הנעות בין אפור משי קר, דרך גוון הבוץ העמוק והנחוש, ועד להבלטתו בגוון האדמה החם של סיינה, הוא מתאים לכל אזור מגורים חיצוני.",
    "image_url": "../upload_images/Talenti/Accessories & decor/Tressé Cube/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/main.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/10.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/9.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/8.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/7.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/6.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/5.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/4.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/3.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/2.jpg",
      "../upload_images/Talenti/Accessories & decor/Tressé Cube/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-cube/",
    "company_name": "Talenti",
    "original_category": "Accessories & decor",
    "price": 12024,
    "filter_category": "אקססוריז וריהוט משלים לפנים וחוץ",
    "placement": "Outdoor"
  },
  "Accessories Fabric Carpet-Ribs": {
    "description": "",
    "image_url": "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/main.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/7.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/6.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/5.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/4.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/3.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/2.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Ribs/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-fabric-carpet-ribs/",
    "company_name": "Talenti",
    "original_category": "Carpet",
    "price": 17775,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Accessories Fabric Carpet-Square": {
    "description": "",
    "image_url": "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/main.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/7.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/6.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/5.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/4.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/3.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/2.jpg",
      "../upload_images/Talenti/Carpet/Accessories Fabric Carpet-Square/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-fabric-carpet-square/",
    "company_name": "Talenti",
    "original_category": "Carpet",
    "price": 19320,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Accessories Round fabric Carpet-Square": {
    "description": "",
    "image_url": "../upload_images/Talenti/Carpet/Accessories Round fabric Carpet-Square/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Carpet/Accessories Round fabric Carpet-Square/main.jpg",
      "../upload_images/Talenti/Carpet/Accessories Round fabric Carpet-Square/6.jpg",
      "../upload_images/Talenti/Carpet/Accessories Round fabric Carpet-Square/5.jpg",
      "../upload_images/Talenti/Carpet/Accessories Round fabric Carpet-Square/4.jpg",
      "../upload_images/Talenti/Carpet/Accessories Round fabric Carpet-Square/3.jpg",
      "../upload_images/Talenti/Carpet/Accessories Round fabric Carpet-Square/2.jpg",
      "../upload_images/Talenti/Carpet/Accessories Round fabric Carpet-Square/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/accessories-round-fabric-carpet-square/",
    "company_name": "Talenti",
    "original_category": "Carpet",
    "price": 24149,
    "filter_category": "שטיחים",
    "placement": "Outdoor"
  },
  "Abel Coffee table D70": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/main.jpg",
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/8.jpg",
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/7.jpg",
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/6.jpg",
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/5.jpg",
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/4.jpg",
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/3.jpg",
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/2.jpg",
      "../upload_images/Talenti/Coffee Table/Abel Coffee table D70/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/abel-coffee-table-d70/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 19521,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Alabama-Alu Coffee Table": {
    "description": "שולחן הקפה Alabama Alu הוא אביזר ריהוט מושלם לשילוב עם פריטי הסלון מהקולקציה הזו כדי ליצור סביבות חוץ מעודנות ומודרניות. המבנה עשוי אלומיניום מצופה באבקה והמשטח העליון עשוי מבטון סיבי.",
    "image_url": "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Alu Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-alu-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 14809,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Alabama-Wood coffee table": {
    "description": "שולחן הקפה Alabama Wood משלים את החוץ, גם הודות לשימוש בעץ איפאה, בהתאמה לקונספט שמאפיין את הקולקציה. המבנה מעץ וחלקו העליון מגרניט פורצלן מאפשרים ליצור חלל חיצוני עכשווי ומזמין.",
    "image_url": "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Alabama-Wood coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-wood-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 19530,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Allure 120×120 Coffee Table": {
    "description": "שולחן הקפה אלור מתאפיין בסגנון גיאומטרי ואלגנטי. דרך העיצוב המרובע והעידון של החומרים, הוא מבטא אישיות מודרנית ומקורית. משטח העץ המוצק נתמך על ידי 4 רגלי אלומיניום לינאריות וקלות. האיזון בין אלמנטים אלו מעניק לסביבת החוץ אופי ואישיות.",
    "image_url": "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 120×120 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-120x120-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10389,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Allure 79×140 Coffe Table": {
    "description": "שולחן הקפה מקולקציית Allure הוא הדוגמה המושלמת לעיצוב המשלב אלגנטיות ורשמיות. הסגנון הגיאומטרי מוגבר בזכות העדינות של החומרים: הקווים המרובעים של רגלי האלומיניום מדגישים את הנוכחות המסיבית של העץ שמוסיף חום למרחב החיצוני עם נגיעה מודרנית.",
    "image_url": "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 79×140 Coffe Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-79x140-coffe-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 19099,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Allure 95×140 Coffee Table": {
    "description": "שולחן הקפה אלור מתאפיין בעיצוב גיאומטרי עם טעם עכשווי. הקווים הדקים של הרגליים ומדף האלומיניום מדגישים את המשטח העליון העשוי מעץ מלא, ויוצרים קומפוזיציה מודרנית ומובחנת.",
    "image_url": "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-95x140-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 14156,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Allure 95×140 Coffee Table without shelf": {
    "description": "שולחן הקפה Allure מעוצב בגיאומטריה עם טעם מודרני. חלק העליון מעץ מוצק מונח על ארבע רגליים מאלומיניום, וכתוצאה מכך נוצרת קומפוזיציה שמעניקה איזון ואישיות לסביבה החיצונית.",
    "image_url": "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/main.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/10.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/9.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/8.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/7.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/6.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/5.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/4.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/3.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/2.jpg",
      "../upload_images/Talenti/Coffee Table/Allure 95×140 Coffee Table without shelf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-95x140-coffee-table-without-shelf/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 17367,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu 100×95 coffee table": {
    "description": "שולחן הקפה בגודל 95×100 מהקולקציה Argo Alu הוא המוצר האידיאלי ליצירת שילובים שונים של שולחנות בחלל החיצוני שלך. המוצקות של מבנה האלומיניום תומכת במשטח מקרמיקה המוצע בצבעים שונים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 100×95 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-100x95-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 21001,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu 113×80 coffee table": {
    "description": "שולחן הקפה Argo Alu במידות 113×80 מציג צורה מלבנית התואמת למסגרת אלומיניום ומשטח קרמיקה שזמין במגוון גוונים שונים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 113×80 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-113x80-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 28174,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu 157×80 coffee table": {
    "description": "שולחן הקפה במידות 157×80 הוא הגדול ביותר בקו ארגו אלו. הוא מאופיין במשטח אבן רחב, פונקציונלי ועמיד בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Alu 157×80 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-157x80-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 17124,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood 107×107 Coffee table": {
    "description": "שולחן הקפה ארגו במידות 107×107, המיוצר כולו מעץ אקויה, זמין בשני צבעים.\nבהשתקפות של הסגנון הגיאומטרי והמעודן של הקולקציה, הוא מתאפיין במשטח עליון רבוע גדול שהופך אותו לפריט אופטימלי לעיצוב הגינה שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 107×107 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-107x107-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 20471,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood 180×94 Coffee table": {
    "description": "שולחן הקפה ארגו בגודל 180×94 הוא מושלם להשתלב עם השילובים השונים של עיצוב החוץ שלך. מיוצר כולו באקויה באמצעות טיפול חדשני, שולחן הקפה הזה הוא הבחירה הטובה ביותר לקשט את אזורי החוץ שלך עם מוצר מעץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 180×94 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-180x94-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 23844,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood 95×67 Coffee table": {
    "description": "שולחן הקפה ארגו בגודל 95×67, עם גודלו הקומפקטי וטעם מרובה, עשוי כולו מעץ אקויה. מוצר פונקציונלי זה הוא רהיט מושלם לעיצוב כל סוג של חלל חיצוני.",
    "image_url": "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Argo-Wood 95×67 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-95x67-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 17660,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Breez Coffee Table": {
    "description": "שולחן הקפה מאוסף Breez בעל צורה מלבנית וקווים זורמים במיוחד. הוא עשוי מפלדה שטופלה בתהליכי ננו-קרמיקה, קתפורזיס וציפוי אבקה. Breez עמיד בתנאי מזג האוויר וזמין בשני צבעים: לבן וטאופ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Breez Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Breez Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/breez-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 20635,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Coffe table 140×70": {
    "description": "שולחן קפה קסילדה 140×70 הוא שולחן מלבני יחיד מסוגו עם מסגרת נירוסטה מצופה באבקה ומשטח עץ אירוקו משולב עם פס שיש בהתאם לצבע הבסיס.",
    "image_url": "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/main.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/14.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/13.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/12.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/11.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/10.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/9.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/8.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/7.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/6.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/5.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/4.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/3.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/2.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffe table 140×70/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-coffe-table-140x70/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 17948,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Coffee table 100×100": {
    "description": "שולחן הקפה קזילדה 100×100 עם מסגרת נירוסטה מצופה באבקה ומשטח עץ אירוקו משולב עם רצועות שיש בהתאם לצבע הבסיס.",
    "image_url": "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/main.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/13.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/12.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/11.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/10.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/9.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/8.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/7.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/6.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/5.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/4.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/3.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/2.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 100×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-coffee-table-100x100/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 22443,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Coffee table 140×140": {
    "description": "שולחן הקפה קסילדה 140×140 עם מסגרת נירוסטה מצופה באבקה ומשטח עץ איפאה משולב עם לוחות שיש בהתאם לצבע הבסיס.",
    "image_url": "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/main.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/13.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/12.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/11.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/10.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/9.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/8.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/7.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/6.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/5.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/4.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/3.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/2.jpg",
      "../upload_images/Talenti/Coffee Table/Casilda Coffee table 140×140/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-coffee-table-140x140/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 14011,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Chic Big opening Coffee Table": {
    "description": "שולחן הקפה הגדול והמקורי של אוסף Chic מאפשר שימוש חכם במרחב. התפקודיות שלו והעיצוב העלגנטי הם מדהימים. חברת Talenti גם שומרת על איכות החומרים, באמצעות מבנה מאלומיניום וזכוכית משוריינת מבריקה עם הדפסה עליונה לחלק התחתון, מה שמבטיח לא רק סגנון ואיכות, אלא גם עמידות בפני גורמים אטמוספיריים. אידיאלי להשלמת אזור המגורים החיצוני שלך, יש לו ארבעה חלקים עליונים נפתחים, כדי לחיות את החוויה החיצונית שלך מתי שתרצה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Big opening Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/chic-big-opening-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 14859,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Chic Side Table": {
    "description": "שולחן Chic הקטן, למרות צורתו הפשוטה, מפליא בעיצובו. הצורה מאפשרת שילוב עם מוצרים אחרים מאותה קולקציה, ומבטיחה המשכיות עם מוצרי הקולקציה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Chic Side Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Chic Side Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Side Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/chic-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10228,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Chic Small opening Coffee Table": {
    "description": "עם הגודל הקטן שלו, שולחן הקפה בעל הפתיחה הקטנה מאוסף Chic מכוון להשלים את החיים החיצוניים בסגנון המלא של Talenti. זמין בצבעים לבן ואפור-יונה, השולחן מכיל את כל החוכמה של העיצוב האיטלקי, תוך שילוב סגנון עם פונקציונליות. האלומיניום של המבנה והזכוכית המחוסמת המודפסת של המשטח התחתון הופכים אותו לעמיד לחלוטין בפני מזג האוויר. מערכת הפתיחה של המשטח מאפשרת שימוש מלא במוצר.",
    "image_url": "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Chic Small opening Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/chic-small-opening-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 29199,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu 100×100 Coffee Table": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 100×100 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-100x100-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10429,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu 60×100 Coffee Table": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu 60×100 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-60x100-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 22012,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu D100 Coffee Table": {
    "description": "שולחן הקפה העגול D100 מקולקציית הגן CleoSoft Alu כולל מבנה אלומיניום מצופה באבקה ומציע משטחים שונים בהתאם לצבע המבנה: אפור בהיר בגרסה הלבנה, אפור כהה בגרסה הגרפית.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D100 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-d100-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 20058,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu D50 Coffee Table": {
    "description": "שולחן הקפה D50 מקולקציית CleoSoft Alu לגינה הוא עגול, גבוה יותר מהשולחנות האחרים באותה קו ויש לו קוטר קטן יותר. יש לו מבנה מאלומיניום מצופה באבקה ומציע חלקי עליונות שונים בהתאם לצבע המבנה.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D50 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-d50-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 25451,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu D75 Coffee Table": {
    "description": "שולחן הקפה העגול מדגם D75 של קולקציית הגן CleoSoft Alu עשוי מאלומיניום מצופה באבקה ומציע משטחי שולחן שונים בהתאם לצבע המבנה.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Alu D75 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-d75-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 21729,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood 60×100 coffee table": {
    "description": "שולחן הקפה CleoSoft Wood במידות 60×100 מאופיין במבנה עץ שניתן להתאים עם משטח עשוי חרסינה או עץ. עם מידות קומפקטיות, הוא משתלב בצורה מושלמת עם סגנון האוסף.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood 60×100 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-60x100-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 16146,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood D100 coffee table": {
    "description": "שולחן הקפה העגול דגם D.100 מקולקציית CleoSoft Woood מתאפיין במבנה עץ בשילוב עם משטח עליון מגרניט פורצלן או עץ. פונקציונלי ובהתאם לסגנון הקולקציה, הוא מושלם לעיצוב שטח החוץ שלכם.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/16.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/15.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/14.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D100 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-d100-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 15293,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood D50 coffee table": {
    "description": "שולחן הקפה העגול D50 מקולקציית CleoSoft Woood בעל מבנה עץ ופלטה עליה עשויה מגרניט פורצלן או עץ. פונקציונלי ובהתאם לסגנון הקולקציה, הוא מושלם לקישוט החלל החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/16.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/15.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/14.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D50 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-d50-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 22853,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood D75 coffee table": {
    "description": "שולחן הקפה העגול מדגם D75 מתוך קולקציית CleoSoft Wood בעל מבנה עץ שניתן להתאים לפלטת חרסינה או עץ. פונקציונלי ובהתאם לסגנון הקולקציה, הוא מושלם לעיטור החלל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/16.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/15.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/14.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood D75 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-d75-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 18807,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Side table": {
    "description": "שולחן הצד CleoSoft Wood משתלב בצורה מושלמת עם הקווים של הקולקציה. עשוי מעץ, גם המבנה וגם החלק העליון עשויים מאותו חומר.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/12.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Side table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 24519,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Tavolo da caffè 100×100": {
    "description": "שולחן הקפה CleoSoft Wood 100×100 מושלם לעיטור הגן שלכם. מבנה העץ יכול להיות משולב עם ציפוי פורצלן או ציפוי עץ. המוצר מתאים באופן מושלם לסגנון הקולקציה, כשהוא נוטל השראה מהטבע.",
    "image_url": "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/main.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/11.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/10.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/9.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/8.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/7.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/6.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/5.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/4.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/3.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/2.jpg",
      "../upload_images/Talenti/Coffee Table/CleoSoft-Wood Tavolo da caffè 100×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-tavolo-da-caffe-100x100/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 24446,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Dèco Coffee Table big": {
    "description": "שולחן הקפה הגדול Cliff Decò הוא נמוך אבל רחב. הוא כולו עשוי אלומיניום, והמסגרת שלו מכוסה לחלוטין בחבל ימי סינתטי, מה שמבטיח פונקציונליות של המוצר באזורים חיצוניים. הסגנון והצורות של שולחן הקפה הזה מאפשרים לך לעשות שימוש מיטבי במרחב שלך בזכות האפשרות לשלב אותו עם שולחנות הקפה האחרים מהאוסף.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/14.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/13.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table big/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-deco-coffee-table-big/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 16227,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Dèco Coffee Table medium": {
    "description": "שולחן הקפה הבינוני Cliff Decò הוא פריט פונקציונלי המשקף בצורה מושלמת את סגנון הקולקציה. חבל הנאוטיקה הסינטטי, המכסה את מסגרת האלומיניום, יוצר משחק של צללים. המשטח הגדול מאלומיניום מבטיח את פונקציונליות המוצר, שנוצר כדי להשתלב עם שולחנות הקפה האחרים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/14.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/13.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table medium/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-deco-coffee-table-medium/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 28653,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Dèco Coffee Table small": {
    "description": "שולחן הקפה הקטן של Cliff Decò מאופיין באריגת חבל ימית אופיינית. כולו עשוי מאלומיניום, הן בחלקו העליון והן במסגרת, והוא מוצר פונקציונלי שמתאים באופן מושלם לשולחנות הקפה האחרים בקולקציה. כדי למקסם את המרחב, ניתן לשלב אותם יחד.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/14.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/13.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cliff Dèco Coffee Table small/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-deco-coffee-table-small/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 20643,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Coffe Table": {
    "description": "שולחן הקפה קורל מאופיין בצורת ריבוע עם פינות מעוגלות, מה שמקנה לו קווים נקיים ומודרניים. ניתן להשתמש בו בפני עצמו או לשלב אותו עם השולחנות האחרים מאותה קולקציה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Coral Coffe Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-coffe-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 19256,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Coffe Table 120×80": {
    "description": "שולחן הקפה במידות 120×80 משלב את מסגרת האלומיניום המודרנית עם המגע המעודן של פני האבן, ומוסיף אופי לאזור המגורים החיצוני שלכם. רגלי השולחן המעוצבות בצורת צינור מצטלבות ויוצרות עיצוב דינמי ומודרני, המשתלב בצורה מושלמת עם שאר האלמנטים של הקולקציה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/main.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/9.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/8.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/7.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/6.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/5.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/4.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/3.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/2.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffe Table 120×80/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-coffe-table-120x80/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 16146,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Coffee Table 100×100": {
    "description": "הרכיבים המרכזיים של קולקציית הקורל, אלומיניום וגריס, זורמים בהרמוניה לשולחן הקפה קורל במידות 100×100. הגודל הקומפקטי לצד התכונות הפיזיות והמכאניות של החומרים הנבחרים, הופכים את פריט הריהוט הזה לבחירה הטובה ביותר להוסיף נגיעה של יצירתיות לחלל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/main.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/9.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/8.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/7.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/6.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/5.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/4.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/3.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/2.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Coffee Table 100×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-coffee-table-100x100/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 19654,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Side Table": {
    "description": "שולחן הצד קורל הוא פריט הריהוט האופטימלי להשלמת העיצוב החיצוני של חלל מרגיע. המסגרת מאלומיניום מקלה על הטיפול וההזזה שלו. משטח הגרז מוסיף לאלגנטיות ולפונקציונליות של המוצר בזכות עמידותו לתנאי מזג האוויר וקרני UV. שזירת חבל סינתטי שעוטפת את הידית מעשירה את הגימור. עם מידות קומפקטיות, שולחן צד זה מציע מודולריות ופונקציונליות מרובות, מושלם להשלמת העיצוב החיצוני.",
    "image_url": "../upload_images/Talenti/Coffee Table/Coral Side Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Coral Side Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Coral Side Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 27567,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cottage Coffee Table 120×120": {
    "description": "שולחן הקפה בגודל 120×120 מקולקציית הקוטג' מכיל משטח מעץ אירוקו שמתאים בצורה מושלמת לסגנון בהשראת המערב הפרוע. המסגרת עשויה מאלומיניום מצופה אבקה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/14.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/13.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-coffee-table-120x120/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 24439,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cottage Coffee Table 120×60": {
    "description": "שולחן 120×60 מסדרת Cottage הוא היחיד שהוא מלבני. מסגרת האלומיניום זהה לזו של שאר האלמנטים כגון כורסאות הסלון, הספה, הפוף והכיסא השיזוף. החלק העליון עשוי מעץ אירוקו.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 120×60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-coffee-table-120x60/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 26359,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cottage Coffee Table 60×60": {
    "description": "שולחן הקפה Cottage בגודל 60×60 הוא השולחן הקטן והגבוה ביותר בקו Cottage. הוא משתלב בצורה מושלמת עם האלמנטים של הסלון מאחר שיש לו את אותו שלדת האלומיניום. החלק העליון עשוי מעץ אירוקו.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/13.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cottage Coffee Table 60×60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-coffee-table-60x60/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 24334,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-Teak 160×90 Coffee table": {
    "description": "בגודל גדול, הגודל 160×90 מתאים בצורה מושלמת לקולקציית Cruise Teak. הצורה המלבנית מאפשרת שימוש מצוין במוצר, בזכות הבסיס העץ החזק והפלטה העמידה למזג האוויר.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 160×90 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-160x90-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 13784,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-Teak 45×90 Coffee table": {
    "description": "שולחן הקפה 45×90 מקולקציית ה-Cruise Teak הוא פשוט אך ייחודי בו זמנית. המוצר גמיש מאוד וניתן להשתמש בו גם עם ספת המודולרית של ה-Cruise Teak, תוך יצירת מרווח בין היחידות בסטייל. המשטח עשוי גרֶס בעוד הבסיס עשוי עץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-Teak 45×90 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-45x90-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 18097,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu 120×120 Coffee table": {
    "description": "שולחן הקפה 120×120 מקולקציית ה-Cruise Alu מיוצר באמצעות טכניקת יציקה בלחץ, מה שמעניק למבנה האלומיניום יציבות וסגנון. החלק העליון הגדול והמרובע, כולו עשוי גרס, פונקציונלי לריהוט חוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 120×120 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-120x120-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 21930,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu 160×90 Coffee table": {
    "description": "שולחן הקפה בגודל 160×90 מקולקציית Cruise Alu משלים את ריהוט החוץ. המבנה, בדומה לשאר המוצרים מהקולקציה, עשוי כולו מאלומיניום. המשטח הרחב מפורצלן גרס (gres) הוא אלגנטי ופונקציונלי.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu 160×90 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-160x90-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 16876,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu D120 round Coffee table": {
    "description": "עם הקווים הרכים והפשוטים שלו, שולחן הקפה העגול D120 מקולקציית Cruise Alu הוא מושלם להשלמת פינת החוץ המרגיעה. המוצר גדול אך לא מסיבי, ומציע מבנה יציב מאלומיניום. המשטח המרווח והפונקציונלי עשוי כולו מגרז.",
    "image_url": "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu D120 round Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-d120-round-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 20958,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu Side table": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Cruise-alu Side table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 20331,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Coffee table D45": {
    "description": "חי ושובב, שולחן הקפה דולצ'וויטה מבטא את קלילות ערבי הקיץ. הצורות הקלות וההרמוניות מדגישות את הטיק והאלומיניום. הוא מעניק תחושת רעננות לסלון החוץ ומתאים בגמישות לסגנונות שונים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/main.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/13.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/12.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/11.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/10.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/9.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/8.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/7.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/6.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/5.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/4.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/3.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/2.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D45/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-coffee-table-d45/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 22719,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Coffee table D60": {
    "description": "נועד להעניק רעננות לחדר האורחים החיצוני, שולחן הקפה דולצ'וויטה מציג עיצוב חיוני והרמוני. משטח העץ טיק נתמך על ידי בסיס אלומיניום. האיזון המושלם בין אלו מודגש על ידי הגימורים העדינים של כל פרט.",
    "image_url": "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/main.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/13.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/12.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/11.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/10.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/9.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/8.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/7.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/6.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/5.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/4.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/3.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/2.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Coffee table D60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-coffee-table-d60/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 12962,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Side table": {
    "description": "שולחן הצד דולצ'ביטה הוא השולחן האידיאלי לרגעים של רגיעה בגינה. העיצוב הפשוט של המבנה, עם זאת תשומת הלב הקפדנית לפרטים, הופך אותו לרהיט אלגנטי וגם פונקציונלי.",
    "image_url": "../upload_images/Talenti/Coffee Table/Dolcevita Side table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Dolcevita Side table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 26752,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ever Coffee table 160×80": {
    "description": "שולחן הקפה Ever מעוצב לבטא את קסם הסגנון הנצחי. הוא משתלב בסלון החיצוני עם אלגנטיות נינוחה, הודות לפשטות צורותיו וטבעיות החומרים שממנו הוא עשוי. רהיט שמקרין את עצמו אל עתיד החיים החיצוניים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/main.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/14.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/13.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/12.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/11.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/10.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/9.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/8.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/7.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/6.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/5.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/4.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/3.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/2.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table 160×80/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-coffee-table-160x80/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 17633,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ever Coffee table D70": {
    "description": "הצורות הנקיות והמעוקלות הן סימן ההיכר של שולחן הקפה אבר. העיצוב המינימליסטי והאייקוני משתלב עם המרקמים של חומרים טבעיים, ומשחרר אלגנטיות שעומדת במבחן הזמן. רהיט רב-שימושי שמעניק לסלון החיצוני אווירה קלאסית ועתידנית.",
    "image_url": "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/main.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/14.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/13.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/12.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/11.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/10.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/9.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/8.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/7.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/6.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/5.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/4.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/3.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/2.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D70/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-coffee-table-d70/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 24771,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ever Coffee table D90": {
    "description": "שולחן הקפה \"Ever\" משלב בין קלילות הצורות לחוזק החומרים, מבלי לוותר על אלגנטיות. מאפיינים אלו הופכים אותו לאלמנט עיצובי רב תכליתי ואייקוני, שניתן להתאימו לכל סביבה חיצונית ואזור מגורים, המעוניינים להביע סגנון נצחי.",
    "image_url": "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/main.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/14.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/13.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/12.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/11.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/10.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/9.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/8.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/7.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/6.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/5.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/4.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/3.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/2.jpg",
      "../upload_images/Talenti/Coffee Table/Ever Coffee table D90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-coffee-table-d90/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 23175,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Gabri Coffee table H45": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Gabri Coffee table H45/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H45/main.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H45/6.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H45/5.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H45/4.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H45/3.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H45/2.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H45/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/gabri-coffee-table-h45/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 20868,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Gabri Coffee table H55": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Gabri Coffee table H55/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H55/main.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H55/6.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H55/5.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H55/4.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H55/3.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H55/2.jpg",
      "../upload_images/Talenti/Coffee Table/Gabri Coffee table H55/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/gabri-coffee-table-h55/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 28519,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "George 40×90 side table": {
    "description": "העיצוב החדשני שמאפיין את קולקציות טאלנטי ניתן לזהות גם בשולחן צד ג'ורג' 40×90. שולחן קטן זה יכול לשמש כמושב בעת הצורך ולהיפך. פונקציונלי ורב-שימושי, זהו האלמנט המושלם להשלמת המרחב החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/George 40×90 side table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/main.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/11.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/10.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/9.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/8.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/7.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/6.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/5.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/4.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/3.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/2.jpg",
      "../upload_images/Talenti/Coffee Table/George 40×90 side table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-40x90-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 11465,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "George Coffee table 110×60": {
    "description": "שולחן הקפה ג'ורג' בגודל 110×60 יש את המשטח הגדול ביותר בקולקציה. מסגרת הנירוסטה תוכננה עם אותם קווים כמו כורסת הסלון והאוכל, כמו גם השולחנות. המשטח זמין הן בעץ אקויה והן באבן לבה בצבעים שונים.",
    "image_url": "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/main.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/11.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/10.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/9.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/8.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/7.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/6.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/5.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/4.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/3.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/2.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 110×60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-coffee-table-110x60/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10525,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "George Coffee table 60×60": {
    "description": "שולחן הקפה בגודל 60×60 מקולקציית ג'ורג' יכול להיות משולב עם פלטות עץ אקויה או אבן לבה. הוא מאופיין במסגרת פלדת אל-חלד מוצקה וגובהו 40 ס\"מ.",
    "image_url": "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/main.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/11.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/10.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/9.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/8.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/7.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/6.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/5.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/4.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/3.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/2.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 60×60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-coffee-table-60x60/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10790,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "George Coffee table 80×80": {
    "description": "שולחן קפה בגודל מרובע ובממדים קומפקטיים הופך את שולחן הקפה George 80x80 לאידיאלי ליצירת שילובים ייחודיים עם שולחנות הקפה האחרים באוסף. המסגרת העשויה מפלדת אל-חלד מוצקה והמשטח הזמין בשתי גרסאות שונות, עץ אקויה ואבן לבה, הם סימני ההיכר של שולחן הקפה 80x80, המושלם לחלל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/main.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/11.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/10.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/9.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/8.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/7.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/6.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/5.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/4.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/3.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/2.jpg",
      "../upload_images/Talenti/Coffee Table/George Coffee table 80×80/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-coffee-table-80x80/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 27795,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "George D60 coffee table": {
    "description": "שולחן הקפה דגם D60 ג'ורג' הוא השולחן הקטן ביותר באוסף. המסגרת מנירוסטה משולבת בשני משטחים שונים: עץ אקויה ואבן לבה, זמינים בצבעים שונים.",
    "image_url": "../upload_images/Talenti/Coffee Table/George D60 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/George D60 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-d60-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 12745,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Karen D60 Coffee Table": {
    "description": "שולחן הקפה מקולקציית Karen מאופיין במלאכת יד אסתטית אופיינית לתרבות האפריקנית. גימורי העץ מודגשים על ידי הקווים הרכים של העיצוב, מה שמעניק לסביבה החיצונית סגנון ואישיות.",
    "image_url": "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D60 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-d60-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 28166,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Karen D90 Coffee Table": {
    "description": "שולחן הקפה מהאוסף של קארן מוסיף סגנון ואישיות לסביבת החוץ בזכות האסתטיקה האומנותית המושפעת מהתרבות האפריקאית. צורות העיצוב החלקות והצבע החם של העץ מבטאים את היופי האופייני של אפריקה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Karen D90 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-d90-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 12252,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Key Coffee Table H30": {
    "description": "שולחן הקפה העגול עשוי כולו מאלומיניום.",
    "image_url": "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/main.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/11.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/10.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/9.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/8.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/7.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/6.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/5.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/4.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/3.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/2.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H30/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/key-coffee-table-h30/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 22714,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Key Coffee Table H34": {
    "description": "שולחן הקפה העגול עשוי כולו מאלומיניום.",
    "image_url": "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/main.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/9.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/8.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/7.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/6.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/5.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/4.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/3.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/2.jpg",
      "../upload_images/Talenti/Coffee Table/Key Coffee Table H34/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/key-coffee-table-h34/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 29590,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Kukà Coffee Table D50": {
    "description": "שולחן הקפה דגם D50 Kukà הוא פריט ריהוט שניתן לשלב עם כל סגנון וסביבה. הבסיס עשוי מתקרילט מפזר את אור המנורה המשולבת בשולחן ותומך במשטח עליון עגול עשוי שרף.",
    "image_url": "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/main.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/8.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/7.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/6.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/5.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/4.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/3.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/2.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D50/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/kuka-coffee-table-d50/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 26792,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Kukà Coffee Table D80": {
    "description": "שולחן הקפה D80 מקולקציית Kukà הוא השולחן המושלם להשלמת חלל החוץ שלך. חדשני ועמיד בפני מזג האוויר, הוא עשוי מחומרים ידידותיים לסביבה. הבסיס עשוי מתאקרילט מפזר את האור של המנורה המשולבת בשולחן ותומך במשטח עגול עשוי שרף.",
    "image_url": "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/main.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/8.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/7.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/6.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/5.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/4.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/3.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/2.jpg",
      "../upload_images/Talenti/Coffee Table/Kukà Coffee Table D80/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/kuka-coffee-table-d80/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10348,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Lake Coffee Table 100×70": {
    "description": "שולחן הקפה לייק מצטיין בעיצוב מקורי, המוגדר על ידי מבנה המסגרת המורכב ממודולי אלומיניום צינוריים שהתמזגו בקפידה יחד. כאשר הוא ממוקם בסביבה חיצונית, הוא מעניק אלגנטיות ומודרניות.",
    "image_url": "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/main.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/8.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/7.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/6.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/5.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/4.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/3.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/2.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 100×70/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-coffee-table-100x70/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 16010,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Lake Coffee Table 70×70": {
    "description": "שולחן הקפה \"לייק\" בעל עיצוב מקורי, המתאפיין במבנה המסגרת שמורכב ממודולים של אלומיניום צינורי המולחמים בצורה מדויקת יחד. כשהוא ממוקם בסביבה החיצונית, הוא מעניק אלגנטיות ומודרניות.",
    "image_url": "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/main.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/8.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/7.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/6.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/5.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/4.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/3.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/2.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee Table 70×70/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-coffee-table-70x70/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 11290,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Lake Coffee table 50×50": {
    "description": "שולחן הקפה מאוסף \"Lake\" משתלב בסביבה החיצונית באלגנטיות ובמקוריות, הודות למבנה המסגרת: הצורות הרכות והחן וההרכב של מודולי האלומיניום הצינוריים מזכירים את היופי הטבעי של הבמבוק.",
    "image_url": "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/main.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/8.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/7.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/6.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/5.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/4.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/3.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/2.jpg",
      "../upload_images/Talenti/Coffee Table/Lake Coffee table 50×50/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-coffee-table-50x50/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 24328,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf 50×80 coffee table": {
    "description": "שולחן הקפה Leaf בגודל 50×80 הוא הקטן ביותר בקולקציה. המסגרת מאלומיניום בשילוב עם משטח ה-vitter נשאבה בהשראת הקווים הקלים והמושעים שמאפיינים את הספה, הכיסא והכורסה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/17.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/16.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/15.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 50×80 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-50x80-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 26567,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf 70×100 coffee table": {
    "description": "שולחן הקפה 70×100 מקולקציית עלה, בעל מידות קומפקטיות ועיצוב אלגנטי ופונקציונלי, מתאים לסביבה טבעית.",
    "image_url": "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/16.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/15.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 70×100 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-70x100-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 29329,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf 80×80 coffee table": {
    "description": "שולחן הקפה 80×80 מקולקציית Leaf בעל מסגרת מאלומיניום ומשטח עליון מסוג ויטר הזמין בשלושה צבעים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/16.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/15.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf 80×80 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-80x80-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 22571,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf base H32 + Vitter top": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/main.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/11.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/10.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/9.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/8.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/7.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/6.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/5.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/4.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/3.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/2.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H32 + Vitter top/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-base-top-h32/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 17321,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf base H40 + Vitter top": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/main.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/11.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/10.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/9.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/8.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/7.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/6.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/5.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/4.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/3.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/2.jpg",
      "../upload_images/Talenti/Coffee Table/Leaf base H40 + Vitter top/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-base-top-h40/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 24729,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Malè 90×90 coffee table": {
    "description": "שולחן הקפה המרובע מלֵה בגודל 90×90 מתאים באופן מושלם לסגנון האוסף. מסגרת הפוליאתילן היציבה והעמידה תומכת בראש החרסינה המרובע, המושלם להשלמת אזור המגורים החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Malè 90×90 coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/male-90x90-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 20086,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo D100 Coffee Table": {
    "description": "צורתו המקורית, משולש גמיש כמו מעגל, מאפיינת את שולחן הקפה ד100 מילו. הוא משתלב בצורה מושלמת עם קו הריהוט מילו, המעצב את הגן באלגנטיות. המבנה והמשטח העליון עשויים מאלומיניום בציפוי אבקה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D100 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-d100-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 21587,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo D50 Coffee Table": {
    "description": "שולחן הקפה D50 של מילו עשוי כולו מאלומיניום בציפוי אבקה. יחד עם שאר האלמנטים של קו המגורים, הוא יוצר ריהוט גמיש אך גם קשיח, צבעוני אך מאוזן, מודרני אך נצחי.",
    "image_url": "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D50 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-d50-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 14889,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo D70 Coffee Table": {
    "description": "שולחן הקפה דגם Milo D7 בעל צורה משולשת אך גמיש כמו עיגול. המבנה והחלק העליון עשויים מאלומיניום מצופה באבקה. למרות שיש לו אופי חזק, השולחן משתלב בפנים הבית ללא שחצנות.",
    "image_url": "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Milo D70 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-d70-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10186,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu Coffee Table": {
    "description": "שולחן הקפה של קולקציית Moon חוץ הוא בעל צורה מלבנית עם פינות מעוגלות שמעניקות לו רכות אלגנטית. המבנה עשוי מאלומיניום והחלק העליון מקרמיקה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 22571,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu Side Table": {
    "description": "שולחן הקפה של אוסף החוץ Moon הוא בצורת ריבוע עם פינות עגלגלות המעניקות לו רכות אלגנטית. המבנה עשוי מאלומיניום והמשטח העליון הוא קרמי.",
    "image_url": "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Alu Side Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 21636,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Teak Coffee Table": {
    "description": "שולחן הקפה של קולקציית החוץ Moon מעוצב בצורה מלבנית עם פינות מעוגלות שמעניקות לו רכות אלגנטית. המבנה והגבול ההיקפי עשויים טיק טבעי ויש לו חלק עליון עשוי hpl אפור.",
    "image_url": "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 11641,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Teak Coffee Table 110×60": {
    "description": "שׁוּלְחָן הַקָפֶה בְּמִדּוֹת 110×60, שֶׁעָשׂוּי כּוּלוֹ מֵעֵץ טִיק, הוּא הַרְהִיט הָאִידֵאָלִי לְהַשְׁלִים אֶת אִסּוּף Moon Teak.",
    "image_url": "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/main.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/9.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/8.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/7.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/6.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/5.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/4.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/3.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/2.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 110×60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-coffee-table-110x60/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 15520,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Teak Coffee Table 45×45": {
    "description": "שולחן הקפה בגודל 45×45 מתאים לחלוטין לקווי הקולקציה של Moon Teak. המסגרת והמשטח עשויים כולם מעץ טיק.",
    "image_url": "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/main.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/9.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/8.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/7.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/6.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/5.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/4.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/3.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/2.jpg",
      "../upload_images/Talenti/Coffee Table/Moon-Teak Coffee Table 45×45/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-coffee-table-45x45/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 24293,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Nova Coffee table": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Nova Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Nova Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Nova Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Nova Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Nova Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Nova Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Nova Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Nova Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nova-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 28781,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Nunù Coffee table": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Nunù Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nunu-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 25758,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Nunù Side table": {
    "description": "",
    "image_url": "../upload_images/Talenti/Coffee Table/Nunù Side table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Nunù Side table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Side table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Side table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Side table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Side table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Side table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Side table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Nunù Side table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nunu-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10310,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Oliver Coffee table D45": {
    "description": "העיצוב הבסיסי של שולחן הקפה אוליבר נוצר במטרה הברורה לשפר את היופי הטבעי של החלק העליון של הגניליה. המשטח המנומר על ידי תערובת נעימה של צבעים רכים, משופר על ידי גימור חלק ונעים. האסתטיקה הצנועה והמעודנת הופכת את רהיט זה למושלם להציב בגינה שלך או באזור המחייה בחוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Oliver Coffee table D45/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D45/main.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D45/6.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D45/5.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D45/4.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D45/3.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D45/2.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D45/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/oliver-coffee-table-d45/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 26567,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Oliver Coffee table D60": {
    "description": "שולחן הקפה \"אוליבר\" נועד להשתלב בצורה אורגנית בגינה ובחדר המגורים החיצוני, בזכות השימוש הכנה באלמנטים טבעיים. העיצוב הפרקטי והחיוני מדגיש את היופי הטבעי של המשטח העליון, הן בגרסתו עם החלוקות והמשטח החלק המפוספס בצבעי פסטל, והן בגרסת העץ טיק, עם הוורידים החמים והברורים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/main.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/7.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/6.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/5.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/4.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/3.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/2.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/oliver-coffee-table-d60/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 18439,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Oliver Coffee table D90": {
    "description": "שולחן הקפה אוליבר מתאפיין בפשטות העיצוב שלו ובטבעיות של גווני הנייטרליים. הנקודה החזקה היא השיש הגרני, המתאפיין בגימור חלק ונעים, שמרקמו הוא תערובת נעימה של צבעים רכים. מדובר ברהיט פונקציונלי, שממוקם בהמשכיות עם הטבע, ומשתלב באופן מושלם בגינה ובסביבות החוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Oliver Coffee table D90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D90/main.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D90/6.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D90/5.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D90/4.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D90/3.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D90/2.jpg",
      "../upload_images/Talenti/Coffee Table/Oliver Coffee table D90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/oliver-coffee-table-d90/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 13437,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Panama 50×50 Coffee table": {
    "description": "פשוט בצורתו אך עם סגנון מיוחד, שולחן קפה \"פנמה\" במידות 50×50 מזכיר את החלקות של אבנים במים. החלק העליון המרובע מקרמיקה גרס מבטיח יציבות, מבלי להתרחק מההשראה של הטבע שטלנטי מציעה עם האוסף הזה. הנתמך על ידי אלומיניום מוצק, המוצר מתגלה כלינארי ומוצק, מושלם להשלים את רהיטי החוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 50×50 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-50x50-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 19005,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Panama 70×70 Coffee table": {
    "description": "שולחן קפה Panama 70×70 בהשראת הטבע בחומריו. החלק העליון הריבועי, המותמך באלומיניום מוצק, עשוי מגרס ומבטיח יציבות ועיצוב כאחד. המוצר נראה קווי וקליל, מושלם להשלמת ריהוט חוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Panama 70×70 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-70x70-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 12435,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Plaza  Coffee table D45": {
    "description": "שולחן הקפה פלאזה הוא בסיס פרקטי ומשחקי. העיצוב שלו מאופיין בקווים רכים וגמישים, המודגשים על ידי המשטח האטום של הבטון. זמין במגוון צבעים, פריט ריהוט זה ניתן להתאמה והוא עמיד, אידיאלי לגינה או לחיים בחוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/main.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/14.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/13.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/12.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/11.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/10.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/9.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/8.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/7.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/6.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/5.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/4.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/3.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/2.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza  Coffee table D45/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/plaza-coffee-table-d45/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 11006,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Plaza Coffee table 80X65": {
    "description": "שולחן הקפה פלאזה מוגדר בקווים רכים ומתעגלים. הוא משתלב בטבעיות בגינה ומביא דינמיות לחללי החוץ. העמידות של הבטון בשילוב עם משחק הצבעים, הופכים את פריט הריהוט הזה לפתרון מעשי ובו בזמן עשיר באופי.",
    "image_url": "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/main.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/14.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/13.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/12.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/11.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/10.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/9.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/8.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/7.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/6.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/5.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/4.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/3.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/2.jpg",
      "../upload_images/Talenti/Coffee Table/Plaza Coffee table 80X65/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/plaza-coffee-table-80x65/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 29672,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Prichi Coffee table 55X80": {
    "description": "שולחן הקפה פריצ'י משלב את העיצוב המאופק והמעודן של הפנים עם הגוונים החמים של עץ הטבע שמשדר החוץ. משטח השולחן הפרקטי מתאפיין בגימורים מתוחכמים, אשר מעניקים לסביבה אפקט שיקי ומזמין. העיצוב המודרני, עם הקווים הרכים, מדגיש את תכונות הטיק, מה שהופך אותו לרהיט המושלם להצבה בגינה ובסביבות חוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Prichi Coffee table 55X80/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Prichi Coffee table 55X80/main.jpg",
      "../upload_images/Talenti/Coffee Table/Prichi Coffee table 55X80/6.jpg",
      "../upload_images/Talenti/Coffee Table/Prichi Coffee table 55X80/5.jpg",
      "../upload_images/Talenti/Coffee Table/Prichi Coffee table 55X80/4.jpg",
      "../upload_images/Talenti/Coffee Table/Prichi Coffee table 55X80/3.jpg",
      "../upload_images/Talenti/Coffee Table/Prichi Coffee table 55X80/2.jpg",
      "../upload_images/Talenti/Coffee Table/Prichi Coffee table 55X80/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/prichi-coffee-table-55x80/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 11294,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Reef D60 Coffee Table": {
    "description": "שולחן קפה ריף מאופיין בעיצוב מודרני שמעביר חום ונעימות. הקווים המעוגלים והמתפתלים שמגדירים את הפרופיל של השולחן נוצרים בתהליך היציקה הסיבובית, טכניקה שמקבלת כוח מחודש בעולם החוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Reef D60 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/reef-d60-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 16508,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Riviera 110×70 Coffee table": {
    "description": "שולחן הקפה במידות 110×70 מתאפיין באותו טעם ששולט בכל האוסף. סגנונו מזכיר את משענות היד של ספת הדו-מושבית ושל כורסת הסלון. החלק העליון העשוי גרס מעניק נופך מעודן למבנה האלומיניום הפשוט והקווי. מושלם לשימוש חיצוני, שולחן זה מציע אפשרויות עיצוב מגוונות לחלל החוץ.",
    "image_url": "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 110×70 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-110x70-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 29907,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Riviera 70×70 Coffee table": {
    "description": "עם חלק עליון מרובע וגודל קומפקטי, שולחן הקפה בגודל 70×70 הוא אידיאלי ליצירת שילובים משחקיים עם שאר שולחנות הקפה של הקולקציה. המסגרת מאלומיניום הופכת אותו לפונקציונלי ונוח לשימוש, בעוד שחלק השולחן מאבן גרנית, בזכות איכותו הפיזיות והמכניות, הופכת אותו למושלם לשימוש חיצוני.",
    "image_url": "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera 70×70 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-70x70-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 28092,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Riviera D50 round Coffee table": {
    "description": "שולחן הקפה העגול הוא האלמנט החיוני להשלמת ריהוט החוץ שלך. עם קוויהו האלגנטיים והמינימליסטיים ותודות לעיצוב הגיאומטרי של המסגרת, הוא אינו מוותר על הנגיעה המתוחכמת של ה-\"צפו די גרה\", כאן בשימוש בחלק העליון העגול.",
    "image_url": "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Riviera D50 round Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-d50-round-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 26335,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas 100×100 Coffee Table": {
    "description": "שולחן הקפה סלינס בולט בשל החומרים המעודנים שלו. מבנה המתכת מועשר בלוח דק מאבן לבה מעט מחזירת אור, שמספקת קסם לסביבה החיצונית שבה הוא מוצב.",
    "image_url": "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas 100×100 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-100x100-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 12047,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas D65 Coffee Table": {
    "description": "שולחן הקפה סלינס בעל עיצוב מתוחכם ואלגנטי שמנצל את החומר הגולמי, כדי ליצור רצף בין הפנים לבין הגינה. המוצקות של הבטון משדרת קסם טבעי לסביבה החיצונית שבה הוא ממוקם.",
    "image_url": "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D65 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-d65-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 12494,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas D80 Coffee Table": {
    "description": "שולחן הקפה מקולקציית סלינס הוא בעל קסם ועידון הודות לעיצוב המדגיש את חומר הגלם ממנו הוא עשוי. המבנה העץ מעוצב בהשראת נופים טבעיים, בכך הוא משרה אלגנטיות והמשכיות בין הסביבה החיצונית לפנימית.",
    "image_url": "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Salinas D80 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-d80-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 17006,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam 70×70 Coffee table": {
    "description": "שולחן הקפה Slam בגודל 70×70 עם הקווים הנקיים שלו, הוא חיוני בסידור צבעוני של המרחב החיצוני שלך. בזכות המסת סגסוגות האלומיניום השונות, עמידותו של רהיט זה משתלבת היטב עם אלגנטיות וסטייל, מה שהופך אותו לאטרקטיבי לעיצוב החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 70×70 Coffee table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-70x70-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 26609,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam 80×80 Coffee Table": {
    "description": "צורות גיאומטריות מאפיינות את שולחן הקפה בגודל 80×80, בהתאם לכל קולקציית Slam. מסגרת האלומיניום היא המרכיב המרכזי של רהיט עמיד בפני מזג האוויר הזה, מושלם להשלמת העיצוב החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Slam 80×80 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-80x80-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 28176,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Sofy Coffee table H45": {
    "description": "אוסף Sofy שולחן קפה H45, עם צורות ברורות אך מקוריות, משלים ומייחד אזור מנוחה חיצוני. עשוי כולו מאלומיניום, ומבטיח יציבות ועמידות בפני תנאי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/main.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/8.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/7.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/6.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/5.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/4.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/3.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/2.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H45/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/sofy-coffee-table-h45/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 12792,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Sofy Coffee table H50": {
    "description": "שולחן קפה מסדרת \"Sofy Collection H50\" בעל צורות ברורות אך מקוריות, משלים ומותאם אישית לאזור מנוחה חיצוני. מיוצר כולו מאלומיניום, הוא מבטיח יציבות ועמידות בפני תנאי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/main.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/8.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/7.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/6.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/5.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/4.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/3.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/2.jpg",
      "../upload_images/Talenti/Coffee Table/Sofy Coffee table H50/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/sofy-coffee-table-h50/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 19861,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Step Coffee Table": {
    "description": "פשוט ואלגנטי, שולחן הקפה מבית Step עשוי מאלומיניום, זמין בשלושה צבעים (לבן, אפור-יונה ומוקה), בעוד המשטח העליון הוא מזכוכית מחוסמת בהדפסה תואמת בצבע זהה. בהתאם לקונספט של הקולקציה, שולחן הקפה מוצע כאביזר מושלם להשלמת מגורים מרגיעים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Step Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Step Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/step-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 27457,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Touch Coffee Table": {
    "description": "ליניארי ובעל צורה ברורה, שולחן הקפה עשוי מאלומיניום, זמין בארבעה צבעים שונים: לבן, אפור-יונה, אפור כהה ומוקה. המשטח העליון עשוי כולו מזכוכית.",
    "image_url": "../upload_images/Talenti/Coffee Table/Touch Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Touch Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 25192,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Touch D45 Coffee Table": {
    "description": "קל לשימוש ליד הבריכה או כהשלמה לריהוט חוץ עם פשטות ואלגנטיות, שולחן הקפה D45 עשוי כולו מאלומיניום, ומבטיח את העמידות הטובה ביותר בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Touch D45 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-d45-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 15078,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Touch H60 Coffee Table": {
    "description": "שולחן הקפה H60 משלב את האלגנטיות של הקווים עם הנוחות של מבנה גבוה, המאפשר שימושיות מרבית. החומר האלומיניום זמין בארבעה גוונים: אפור כהה, לבן, אפור יונה ומוקה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/14.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/13.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/12.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/11.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/10.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Touch H60 Coffee Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-h60-coffee-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 25185,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tressé Coffee table 120X50": {
    "description": "מתוחכם ופונקציונלי, שולחן הקפה טרסה הוא אכן יצירת עיצוב. תשומת הלב לפרטים מתבטאת בבחירת החומרים: האבן הגעשית המזווגת והעבודה בידיים מומחים נכללת במיומנות במבנה האלומיניום הצינורי. שילוב מושלם שמעניק אופי לגינה או למרחב המגורים החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/main.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/23.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/22.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/21.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/20.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/19.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/18.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/17.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/16.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/15.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/14.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/13.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/12.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/11.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/10.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/9.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/8.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/7.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/6.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/5.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/4.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/3.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/2.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 120X50/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-coffee-table-120x50/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 12953,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tressé Coffee table 160X90": {
    "description": "שולחן הקפה טרסה הוא יצירת עיצוב מתוחכמת ופונקציונלית. כל פרט מטופל בדיוק רב, תוך תשומת לב מיוחדת לבחירת החומרים. האבן הוולקנית המוקרת בעבודת יד משתלבת בצורה מושלמת עם מבנה האלומיניום הצינורי, מה שהופך אותו לרהיט האידיאלי להענקת אופי לסלון החיצוני.",
    "image_url": "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/main.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/23.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/22.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/21.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/20.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/19.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/18.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/17.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/16.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/15.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/14.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/13.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/12.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/11.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/10.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/9.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/8.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/7.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/6.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/5.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/4.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/3.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/2.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Coffee table 160X90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-coffee-table-160x90/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 17322,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tressé Side table": {
    "description": "שולחן הצד Tressè הוא השולחן המושלם לרגעי מנוחה. הוא משלים את הריהוט עם אלגנטיות, הודות לשזירה המורכבת של רצועות דמויי עור, בעבודת יד, וממקסם את הנוחות והתפקודיות עם עיצוב מודולרי שמאפשר חופש אדפטציה רחב.",
    "image_url": "../upload_images/Talenti/Coffee Table/Tressé Side table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Tressé Side table/main.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/9.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/8.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/7.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/6.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/5.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/4.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/3.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/2.jpg",
      "../upload_images/Talenti/Coffee Table/Tressé Side table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-side-table/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 15004,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Coffee Table 120×120": {
    "description": "העיצוב המונוליטי של שולחן הקפה ונציה משבח את הקסם הנצחי של העיר ההומונימית. המים הנוצצים של הלגונה נזכרים באמצעות המשטח הקרמי הבוהק של אבן הלבה. מגוון הצבעים שנבחר משקף את כל גווני הים הוונציאני, מהגוונים החמים של השקיעה ועד הגוונים הקרים של הדמדומים. יצירת עיצוב זו משלימה את ריהוט הגן והחוץ באלגנטיות עילאית.",
    "image_url": "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/main.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/13.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/12.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/11.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/10.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/9.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/8.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/7.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/6.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/5.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/4.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/3.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/2.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 120×120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-coffee-table-120x120/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 10555,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Coffee Table 150×90": {
    "description": "האמנות והאלגנטיות הם סימן ההיכר של שולחן הקפה ונציה, בהשראת עיר לגונה המפורסמת ביותר. השיש הקרמי מזכיר את ההשתקפויות של המים בתעלות ונציה. טווח הצבעים הנבחר כולל את כל גווני הים, מהשקיעה החמה ועד לדמדומים הקרים. העיצוב והמבנה של פריט ריהוט זה מאופיינים בקסם מונוליטי המתנגד לקלות המובעת בעץ אקויה, ומשדרג את פינת הישיבה החיצונית באווירה רומנטית.",
    "image_url": "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/main.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/13.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/12.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/11.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/10.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/9.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/8.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/7.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/6.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/5.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/4.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/3.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/2.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee Table 150×90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-coffee-table-150x90/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 23357,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Coffee table D60": {
    "description": "שולחן הקפה ונציה מגלם את הקסם והקלילות של עיר הלגונה. משטח האבן הוולקנית האלגנטי זמין בצבעים שונים, שכל אחד מהם, הודות לגימור הקרמי המבריק, מזכיר את פני השטח המבריקים של תעלות ונציה משקיעה עד דמדומים. חפץ מונוליטי שמשלים את הסלון החיצוני ומעניק גוון רומנטי לגינה.",
    "image_url": "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/main.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/16.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/15.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/14.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/13.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/12.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/11.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/10.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/9.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/8.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/7.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/6.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/5.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/4.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/3.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/2.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D60/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-coffee-table-d60/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 15466,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Coffee table D90": {
    "description": "שולחן הקפה ונציה מוגדר על ידי עיצוב מונוליתי, שמתחבר בטבעיות לסביבה החיצונית, בזכות הקסם הפנימי של החומרים. המבנה העץ המוצק עשוי אקויה תומך במשטח האבן וולקנית, הזמין במספר צבעים שנבחרו להזכיר את הגוונים החמים בשקיעה והקרים בשקיעה של הימים הוונציאניים. האפקט מודגש יותר על ידי הגימור הקרמי המבריק של האבן, ונותן אווירה רומנטית לחיים החיצוניים.",
    "image_url": "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/main.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/15.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/14.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/13.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/12.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/11.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/10.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/9.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/8.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/7.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/6.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/5.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/4.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/3.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/2.jpg",
      "../upload_images/Talenti/Coffee Table/Venice Coffee table D90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-coffee-table-d90/",
    "company_name": "Talenti",
    "original_category": "Coffee Table",
    "price": 18289,
    "filter_category": "שולחנות קפה פנים וחוץ",
    "placement": "Outdoor"
  },
  "Abel Dining armchair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Chair/Abel Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Abel Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/abel-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 20373,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Adam Dining armchair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Chair/Adam Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Adam Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/adam-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 13092,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Alabama-Alu Dining Armchair": {
    "description": "בתרגום לעברית:\nשילוב מושלם של אלומיניום ועץ, כיסא האוכל עם משענות יד מהקולקציה AlabamaAlu הוא פשוט אבל לא רגיל. המושב הנוח עם קצף המתייבש במהירות, מכוסה בבד נשלף וכביס בקלות, נתמך ברצועות אלסטיות סינתטיות, שנוצרו במיוחד לריהוט חוץ. הכיסא קל ומשתלב, והוא המוצר האידיאלי להשלמת אזור האוכל בגינה שלך.",
    "image_url": "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Alabama-Alu Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-alu-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 22246,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Allure Dining chair": {
    "description": "כיסא האוכל \"אלור\" מתאפיין בסגנון אלגנטי ומודרני. מסגרת הפלדה היא שילוב מעודן של גאומטריות. הגימורים בעץ, משענת הגב והמושב בעור מלאכותי, משלימים את העיצוב הדק והקל של הכיסא, המשווה לחללי החוץ מראה מסוגנן.",
    "image_url": "../upload_images/Talenti/Dining Chair/Allure Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/17.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/16.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Allure Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 27699,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Argo-Alu dining armchair": {
    "description": "כיסא האוכל עם משענות הידיים מדגם ארגו אלומיניום משלב בין הרכות של צורותיו לקשיחות של מסגרת האלומיניום. כיסא זה משתלב באופן מושלם עם השולחנות ואלמנטים אחרים של האוסף. איכות החומרים הופכת את כיסא זה למושלם עבור החלל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Alu dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 28725,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Argo-Wood Dining chair": {
    "description": "כיסאות האוכל עם משענות היד מדגם ארגו מתאפיינים בנפח החובק של האריגה בחבל, העוטפת את הכריות הרכות והמזמינות ויוצרת משחק בין צורות וגדלים שממשיך את הטעם הכללי של הקולקציה. השימוש בחבלים ימיים סינתטיים קלועים סביב משענות הגב והידיים יחד עם הריפוד הנשלף של הכריות הממולאות בקצף שמתייבש במהירות, הופך את הכיסא למוצר עמיד במיוחד לתנאי מזג האוויר. האיכות הגבוהה של אריגת החבלים, בשילוב עם המרקם המתוחכם של הבדים תורמים לכך שהכיסא יהווה מוצר אופטימלי לריהוט החוץ שלך.",
    "image_url": "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Argo-Wood Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 17758,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Bridge ABS Chair": {
    "description": "קווים רכים ונוחות הם המאפיינים של כיסא הגשר ABS. המבנה עשוי מ-ABS, פולימר תרמופלסטי ואלומיניום, המבטיחים את החוזק הנדרש. הכיסא אינו מאבד את הייחודיות של האוסף ומפתיע בשונותו מהשאר, ומשתלב בצורה מושלמת עם ריהוט חוץ וגם פנים.",
    "image_url": "../upload_images/Talenti/Dining Chair/Bridge ABS Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Bridge ABS Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge ABS Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge ABS Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge ABS Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge ABS Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge ABS Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge ABS Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/bridge-abs-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 14909,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Bridge Director Chair": {
    "description": "כיסא הבמאי של Bridge מתאים בצורה מושלמת לאוסף. בהשוואת היציבות של המהגוני, שמשמש למבנה ולמשענות היד, עם הטקסטילן של המושב ומשענת הגב, ישנה ניגודיות בין רכות ליציבות.",
    "image_url": "../upload_images/Talenti/Dining Chair/Bridge Director Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Bridge Director Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/bridge-director-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 15102,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Casilda Bar Stool": {
    "description": "מסגרת כסא הבר קאסילדה, עשויה מפלדת אל חלד בציפוי אבקה, בעלת מראה מינימליסטי וקליל, התואמת באופן מושלם לגודל המרותק של המשענת והמושב. שילוב של אלמנטים אלה עם המרקם הבולט, הופך את המוצר הזה לקלאסה על-זמנית.",
    "image_url": "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/15.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/14.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/13.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/12.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/11.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/10.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/9.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/8.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/7.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Bar Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-bar-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 27455,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Casilda Dining Armchair": {
    "description": "הכורסא עם משענות הידיים של קולקציית קזילדה תואמת את שולחן האוכל של אותה סדרה. המסגרת המעודנת והקלה מדגישה את תוספות העץ והשיש של משענות הידיים, בעקבות הסגנון שרמון אסטבה מעניק לכל הקולקציה.\nהמסגרת הדקה והגיאומטרית חזקה הודות למבנה הפלדה הנירוסטה המצופה באבקה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/16.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 11538,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Casilda Dining Chair": {
    "description": "כיסא האוכל קאסילדה הוא ללא משענות יד. למרות המבנה הגיאומטרי והליניארי שלו, כמו כל האוסף, הוא מוכיח כוח ויציבות בזכות ה מסגרת הפלדה האל חלד המצופה באבקה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/16.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Casilda Dining Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 17703,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Chic Director Chair": {
    "description": "כיסא הבמאי, זמין בגרסה לבנה ובגרסת אפור-יונה, יציב ונוח.",
    "image_url": "../upload_images/Talenti/Dining Chair/Chic Director Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Chic Director Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/chic-director-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 21463,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Padded tub chair": {
    "description": "כיסא האוכל החיצוני קליאו-סופט אלאו מציע מושב גמיש ומזמין. בשילוב עם שולחן האוכל מדובר בהצעה אלגנטית ופשוטה לרגעים נעימים של רוגע באוויר הפתוח. מבנה אלומיניום בציפוי אבקה וריפוד מקצף שמתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Alu Padded tub chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-padded-tub-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 22765,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Padded tube chair": {
    "description": "מושב כיסא השפופרת המרופד מקולקציית Cleo Soft Wood מאופיין באותו העיצוב כמו כיסא הטרקלין. בזכות תכונה זו ניתן לשלבו בקלות עם כל מרכיבי הקולקציה, במיוחד עם אלה בעלי הקווים הרכים. המבנה מעץ תומך בכריות העמידות בתנאי מזג האוויר, עם כיסויים נשלפים וקלים לכיבוס. המילוי הוא קצף המתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/14.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/13.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/CleoSoft-Wood Padded tube chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-padded-tube-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 29452,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Cliff Dining Armchair": {
    "description": "סגנון הקליעה של החבלים באוסף עוטף את הכורסא, יוצר כיסא שמשלים את אוסף הקליף.",
    "image_url": "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Cliff Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 25070,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Coral Bar Stool": {
    "description": "מסגרת הדקה של כיסא הבר קורל יכולה לקשט ביעילות הקשר חיצוני אלגנטי ומתוחכם. מושב הכיסא, כמו בכיסא האוכל עם הידיות, רחב ונוח, בעוד גב הכיסא נמוך, בהתאם לצורתו של כיסא בר טיפוסי. שזירת החבלים הסינתטיים בידיות הבולטת כאלמנט המפתח של הקולקציה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Coral Bar Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/10.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/9.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/8.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/7.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Bar Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-bar-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 17364,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Coral Dining Armchair": {
    "description": "פונקציונלית ודקה, כיסא האוכל עם ידיות מדגם קוראל בהשראת הרעיון של קלילות, שנוצר הודות למבנה האלומיניום המבטיח את עמידותו בסביבה חיצונית. המושב הנוח והמזמין מתאפיין במידות קומפקטיות, בהתאם לעיצוב הקליל של הקולקציה. ריפוד הקצף המהיר לייבוש, שמכוסה בבדים עמידים למים, הניתנים לכביסה וכיסויים נשלפים, הופך את הכיסא למושלם לשימוש חיצוני.",
    "image_url": "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Coral Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-dining-harmchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 23205,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Coral dining chair": {
    "description": "הכיסא הרחב והנוח של כיסא האוכל קורל, בשילוב עם מסגרת אלומיניום מוצקית ועמידה לאורך זמן, מצופה בחבל סינתטי, עושה את הכיסא הזה למוצר האידיאלי להשלמת רהיטי החוץ בסלון שלך.",
    "image_url": "../upload_images/Talenti/Dining Chair/Coral dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Coral dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Coral dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 27136,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Cottage Dining armchair": {
    "description": "כיסא האוכל עם ידיות מדגם קוטג' בעל צורה ייחודית אך פונקציונלית. המסגרת האלומיניום, המתאפיינת בקווים גאומטריים, תומכת בכריות הממולאות בקצף מתייבש במהירות. הריפוד, עמיד בפני מזג אוויר, הופך את המוצר לאידיאלי לקישוט אזורי החוץ שלכם.",
    "image_url": "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Cottage Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 12342,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Cruise-Teak Dining chair": {
    "description": "כיסא האוכל מקולקציית השייט עשוי מעץ טיק הוא בעל קווים ישרים אך אף פעם לא שגרתי. המושב הנוח והגבוה, המיוצר מקצף מהיר ייבוש, מכוסה בבד עמיד בפני מזג האוויר. העץ של הבסיס והחבלים המשמשים לכיסוי המשענת והמשענות היד תואמים את הקונספט של הקולקציה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-Teak Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 11428,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Cruise-alu Dining armchair": {
    "description": "הצורה הרכה והמחבקת של כיסא האוכל מדגם Cruise Alu הופכת את המוצר למושלם לריהוט הגינה שלך. המבנה מאלומיניום תומך בגוף בצורה מושלמת ועוטף אותו בכריות קצף שמתייבשות במהירות. הבד, עמיד לתנאי מזג האוויר, משולב עם החבלים הסינתטיים שעוטפים את משענת הגב והידיות, מה שהופך את הכיסא לריהוט האידיאלי לשימוש חיצוני.",
    "image_url": "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Cruise-alu Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 26735,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Dolcevita Bar Stool": {
    "description": "כיסא הבר Dolcevita תוכנן כדי להעניק קלילות לרגעי הקהילתיות. המבנה הפשוט והלינארי מדגיש את יופיו של המרקם עץ הטיק. כל פרט, מהגימורים של המשענות לידיים ועד המרקם הצפוף שמאפיין את משענת הגב והמושב הרחב, תוכנן כדי להעניק נגיעה של רעננות לחלל החיצוני והסביבה הפתוחה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/17.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/16.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/15.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/14.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/13.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/12.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/11.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/10.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/9.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/8.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/7.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Bar Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-bar-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 12263,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Dolcevita Dining armchair": {
    "description": "כיסא האוכל דולצ'וויטה הוא הפתרון המושלם לשדרוג הפינה החיה בגינה שלך, תוך הענקת סגנון וקלילות. מבנה העץ הוא בעל קו פשוט ומינימליסטי המבליט את היופי הטבעי של עץ הטיק, והגמרים המוקפדים של כל פרט ופרט. הסורגים הדפניים והמושב הם המרכזיים ברהיט הזה, בזכות האריגה הצפופה של החבלים שמאפיינת את כל הקולקציה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/20.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/19.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/18.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/17.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/16.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Dolcevita Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 19050,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Ever Dining Chair": {
    "description": "חיוני בהרכבו, כיסא ה-Ever לאוכל מאופיין במבנה עץ מוצק, המתרכך על ידי הקווים הרכים של העיצוב שלו. הכריות מעניקות מראה איקוני לרהיט, ומציעות מושב נוח ומזמין. המרקמים של החומרים, בשילוב עם עיצוב מינימליסטי, הופכים אותו לרהיט המושלם למגורים חיצוניים.",
    "image_url": "../upload_images/Talenti/Dining Chair/Ever Dining Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Ever Dining Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 14666,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Frame Bar Stool": {
    "description": "מבנה מאלומיניום, שהופך לחושני בזכות הכריות הנוחות והחבל הקלוע המרופד, המסוגל ליצור משחק מרתק של אור כאשר קרני השמש מלטפות את השטח. השרפרף מקולקציית Frame משקף קסם בלתי ניתן לערעור בגינה ובסביבות החיצוניות, מעניק רגעים של רגיעה ואווירה חברתית עם נגיעת אלגנטיות.",
    "image_url": "../upload_images/Talenti/Dining Chair/Frame Bar Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Frame Bar Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Bar Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Bar Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Bar Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Bar Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Bar Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Bar Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/frame-bar-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 21190,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Frame Dining armchair": {
    "description": "כיסא אוכל עם משענות מדגם Frame הוא השילוב של כל האלמנטים המרכזיים של קולקציה זו. המבנה הדק מאלומיניום משולב עם הכריות הרכות של המשענת ועם שזירת החבל המרופד. מעודן וחושני, זוהי התוספת הדקורטיבית המושלמת לעיצוב אזור האוכל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Dining Chair/Frame Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Frame Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/frame-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 10409,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "George Dining armchair": {
    "description": "כיסא האוכל מקולקציית ג'ורג' משלב מסגרת נירוסטה עם חבלים סינתטיים שזורים במשענת הגב והמושב. בזכות משחק של חבלים משתלבים, הכיסא קל לקיפול.",
    "image_url": "../upload_images/Talenti/Dining Chair/George Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/George Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/George Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 24506,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Karen Dining Chair": {
    "description": "כיסא האוכל קארן נזכר ביופי האופייני של ארצות אפריקה. העיצוב מאופיין במשענות היד בצורת טבעת ובמשענת הגב העוטפת בחן סביב המושב, אשר מזכירה את המלכותיות של כס מלכות. השזירה של אינספור חוטי בד מגלה את המלאכה האומנותית של הכיסא, שהוא מזמין כמו מפלט, ומעשיר את הסביבה החיצונית בסגנון ובאישיות.",
    "image_url": "../upload_images/Talenti/Dining Chair/Karen Dining Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Dining Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 22613,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Karen Stool": {
    "description": "השרפרף מקולקציית קארן הוא תזכורת ליופי הטיפוסי של הארצות האפריקאיות. כל פרט, מהידיות עד לטבעות, ועד לגב שמקיף את המושב, מעורר את המלכות של כס המלכות ובו בזמן משרה תחושת חמימות של מקום מפלט נעים. רהיט זה מסוגל להעצים ולהעניק אישיות חזקה לחלל החיצוני, בזכות השזירה של אין-ספור חוטי בד שמגלה את האומנות שבה הוא נוצר.",
    "image_url": "../upload_images/Talenti/Dining Chair/Karen Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Karen Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/11.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/10.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/9.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/8.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/7.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Karen Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 15650,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Key Dining Armchair": {
    "description": "הכיסא הדק מעורר תחושת קלילות ויציבות. המשענת מתקבלת על ידי כיפוף חלקים מלבניים של צינורות אלומיניום והיא מכוסה בחבל. כרית טקסטילן.",
    "image_url": "../upload_images/Talenti/Dining Chair/Key Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Key Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/key-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 26235,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Lady Bench": {
    "description": "הספסל ליידי הוא מוצר מושלם למנוחה שלך. עם צורות פשוטות אך מקוריות, הוא משלב את איכות החומרים עם העיצוב האופייני של טלנטי, ומאפשר שימוש בו בכל אזור חיצוני. האלומיניום של המבנה מעניק יציבות, בעוד הטקסטילן של המושב מבטיח רכות ונוחות, מבלי לאבד אלגנטיות וסגנון.",
    "image_url": "../upload_images/Talenti/Dining Chair/Lady Bench/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Lady Bench/main.jpg",
      "../upload_images/Talenti/Dining Chair/Lady Bench/8.jpg",
      "../upload_images/Talenti/Dining Chair/Lady Bench/7.jpg",
      "../upload_images/Talenti/Dining Chair/Lady Bench/6.jpg",
      "../upload_images/Talenti/Dining Chair/Lady Bench/5.jpg",
      "../upload_images/Talenti/Dining Chair/Lady Bench/4.jpg",
      "../upload_images/Talenti/Dining Chair/Lady Bench/3.jpg",
      "../upload_images/Talenti/Dining Chair/Lady Bench/2.jpg",
      "../upload_images/Talenti/Dining Chair/Lady Bench/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lady-bench/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 27728,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Lake Dining chair": {
    "description": "כיסא האוכל Lake מעניק אלגנטיות ומקוריות לסביבה החיצונית. העיצוב של המסגרת מתאפיין בקשרים מכוסים בטבעות שמחברים את המודולים האלומיניום הצינוריים, ומזכירים את הצורות הטבעיות של צמח הבמבוק, מקור ההשראה לכל הקולקציה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Lake Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Lake Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 20315,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Leaf Dining chair": {
    "description": "כיסא האוכל מקולקציית Leaf מאופיין בצורות אלגנטיות וקווים דקים ועדינים. המושב הרך, המרופד בספוג מהיר ייבוש, מרופד בבד עמיד בתנאי מזג האוויר. המבנה האלומיניום יחד עם הבדים הייחודיים יוצרים מוצר המתאים לעיצוב של הקולקציה כולה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Leaf Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Leaf Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 19248,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Maiorca Armchair": {
    "description": "עם המושב והמשענת הגדולים שלו, כורסת מאיורקה היא מוצר נוח, מרגיע ופונקציונלי. אידיאלית הן באזור המגורים והן באזור האוכל של המרחב החיצוני שלכם, הכורסה מבטיחה יציבות ואלגנטיות. המבנה, זמין בשני צבעים (לבן ואפור יונה), עשוי מאלומיניום, בעוד שהמושב והמשענת, זמינים בשלושה צבעים (לבן, מוקה, אפור יונה), עשויים מטקסטילן. האפשרות לערום את המוצר הופכת אותו לנוח וחסכוני במקום, אפילו בעונות הקרות.",
    "image_url": "../upload_images/Talenti/Dining Chair/Maiorca Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/maiorca-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 25901,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Maiorca Bar Stool": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/9.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/8.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/7.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Maiorca Bar Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/maiorca-bar-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 15859,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Malè Dining chair": {
    "description": "המושב הרחב של כיסא האוכל מאלè עשוי מחומר פלסטי נתמך על-ידי מסגרת פלדה מרובעת ונוקשה, מה שהופך אותו למושלם להשלים את ריהוט הגינה שלך.",
    "image_url": "../upload_images/Talenti/Dining Chair/Malè Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Malè Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/male-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 13088,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Milo Dining Armchair": {
    "description": "אלגנטיות רומנטית ותשומת לב לפרטים הם היסודות המובחנים של כיסא החוץ מילו. מבנה מאלומיניום עם ציפוי באבקה ומושב מטקסטילן, חומר סינתטי המסוגל לעמוד בעומסי דחיסה, קריעות, גורמי מזג אוויר וקרני UV. הכיסא ניתן לערמה. כרית אופציונלית זמינה באפור בהיר או כהה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/17.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/16.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Milo Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 14935,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Minorca Chair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Chair/Minorca Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Minorca Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Minorca Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/minorca-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 10996,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Moon-Alu Dining Armchair": {
    "description": "כיסא האוכל הירח מציע מושב רחב ומזמין עם קליעת חבלים קלה היוצרת את המושב ואת משענת הגב.",
    "image_url": "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 23225,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Moon-Alu Dining Chair": {
    "description": "כיסא האוכל Moon מציע מושב רחב ומזמין עם קליעת חוטים קלה היוצרת את המושב ואת משענת הגב.",
    "image_url": "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Dining Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 23044,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Moon-Alu Stool": {
    "description": "הכיסא Moon מציע מושב רחב ומזמין עם קליעת חבלים קלה היוצרת את המושב והמשענת ומזכירה את הצורות של הכיסאות האחרים באוסף. הרגליים הדקות כוללות משענת רגל נוחה.",
    "image_url": "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/12.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/11.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/10.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/9.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/8.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/7.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Alu Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 26035,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Moon-Teak Bar Stool": {
    "description": "קווים אלגנטיים מאפיינים את שרפרף החוץ Moon Teak: המבנה, המכוסה בחבלים סינתטיים, משולב עם המשענת שמזכירה את שאר האלמנטים באוסף. מושב רחב ונוח הופך את השרפרף הזה לאלמנט המושלם להשלים את ריהוט החוץ שלכם.",
    "image_url": "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/12.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/11.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/10.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/9.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/8.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/7.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Bar Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-bar-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 27682,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Moon-Teak Dining Armchair": {
    "description": "כיסא האוכל החיצוני \"הירח\" מציע מושב רחב ומזמין עם קליעת חבל קלה שיוצרת את המושב ואת המשענת.",
    "image_url": "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 23125,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Moon-Teak Dining Chair": {
    "description": "כיסא האוכל מהקולקציה Moon Teak הוא האלמנט האידיאלי לשילוב עם השולחנות מהקולקציה. הוא משקף את הסגנון שמאפיין את הקו כולו, עם שלד עץ שמתאים לגב ולמושב העשויים מחבל קלוע מוצק ועמיד לאורך זמן.",
    "image_url": "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Moon-Teak Dining Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 25840,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Nova Dining armchair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Chair/Nova Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Nova Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Nova Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Nova Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Nova Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Nova Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Nova Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Nova Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Nova Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nova-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 25754,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Oliver Dining chair": {
    "description": "מוצק ובו זמנית קל, כיסא האוכל \"אוליבר\" בולט בשל העיצוב המורכב של מבנה העץ, שמחליף בין חללים מלאים לחללים ריקים, ומתפתח לצורה רציפה וייחודית המדגישה את המרקם המעודן של עץ הטיק. התבנית של העץ יחד עם הגוון החם של הכריות הלבנות, מעניקות אווירה חמה ומזמינה, מושלמת לחוות רגעים של רוגע וחברות בגינה ובסביבות חיצוניות.",
    "image_url": "../upload_images/Talenti/Dining Chair/Oliver Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Oliver Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Oliver Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Oliver Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Oliver Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Oliver Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Oliver Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Oliver Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/oliver-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 11161,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Panama Bar Stool": {
    "description": "מושב הבר של קולקציית פנמה נבדל ממוצרים אחרים בזכות מושבו הגבוה, המיוצר בעזרת חבלי ניילון סינתטיים, אשר מבטיח תמיכה הכרחית. הודות לאלומיניום היציב והמוצק של המבנה, המוצר אידיאלי להשלמת ריהוט חוץ משום שהוא עמיד בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Dining Chair/Panama Bar Stool/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/main.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/17.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/16.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/15.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/14.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/13.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/12.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/11.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/10.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/9.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/8.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/7.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/6.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/5.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/4.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/3.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/2.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Bar Stool/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-bar-stool/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 23809,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Panama Dining Armchair": {
    "description": "כיסא האוכל מקולקציית פנמה הוא הפתרון המושלם לארוחות צהריים וערב בחוץ. המבנה מאלומיניום קל ומעוטר בחבלי ים משולבים המביעים את כל היוקרה של הקולקציה תוך שמירה על פונקציונליות המוצר. הכריות מבדים עמידים ב-100% למזג האוויר, זמינות במגוון צבעים, ומשלימות את המוצר, מעניקות לו אופי ואלגנטיות.",
    "image_url": "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/20.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/19.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/18.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/17.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/16.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 24573,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Panama Dining Armchair hight backrest": {
    "description": "כיסא האוכל \"פנמה\" עם משענת גבוהה מכוסה בחבלים ימיים ותוכנן במטרה להעניק רגעים של רוגע מוחלט. מסגרת האלומיניום קלה ועמידה, מעוצבת עבור סביבות חוץ. הכריות עם בדים 100% לשימוש חוץ, זמינות במגוון צבעים, משלימות את הפריט ונותנות לו אישיות ואלגנטיות.",
    "image_url": "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/main.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/20.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/19.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/18.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/17.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/16.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/15.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/14.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/13.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/12.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/11.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/10.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/9.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/8.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/7.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/6.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/5.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/4.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/3.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/2.jpg",
      "../upload_images/Talenti/Dining Chair/Panama Dining Armchair hight backrest/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-dining-armchair-hight-backrest/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 25468,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Panama dining Chair": {
    "description": "מעוצב לרגע של רוגע, כיסא האוכל תואם לכל המוצרים של קולקציית פנמה. המושב הגבוה מבטיח תמיכה לגוף הודות לחבלים הימיים הסינתטיים שמרכיבים את משענת הגב. המבנה מיוצר מאלומיניום, קל ועמיד. זמין במגוון צבעים רבים, ניתן להתאים את הכיסא עם כריות (אופציונלי) כדי להשלים את המוצר.",
    "image_url": "../upload_images/Talenti/Dining Chair/Panama dining Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/17.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/16.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/15.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Panama dining Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 10566,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Prichi Armchair for dining room": {
    "description": "מוצקת ומיוחדת, כורסת האוכל פריצ'י בולטת הודות לעיצוב המיוחד של סורגי הקיר, שמוגדרים על ידי חבלים השזורים יחד עם לוחות הטיק של המבנה. משחק ההשתלבות המורכב הזה, יוצר ניגוד עם הטוהר של מרקם העץ, ויוצר אפקט נעים ומלוטש שמכניס את סגנון הסלון האנגלי לעולם החוץ. פריט הריהוט הזה מחמם את האווירה והופך את הגינה ואת המרחב החיצוני לנוחים ומזמינים יותר.",
    "image_url": "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/main.jpg",
      "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/7.jpg",
      "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/6.jpg",
      "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/5.jpg",
      "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/4.jpg",
      "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/3.jpg",
      "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/2.jpg",
      "../upload_images/Talenti/Dining Chair/Prichi Armchair for dining room/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/prichi-armchair-for-dining-room/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 26888,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Queen Folding Chair": {
    "description": "קל ונוח לשימוש, כסא הקיפול מקולקציית המלכה מפתיע בנוחותו. מתאים לכל מצב, מבריכת השחייה ועד למרפסת, ואפילו מתאים לחללים פנימיים, המוצר מתאפיין גם בקלות הצורות שלו. הקווים הרכים של המבנה, העשוי כולו מאלומיניום, משתלבים עם הגב והכסא בטקסטילן. איכות החומרים, בחתימת טלנטי, משלימה מוצר זה שהנו רב-שימושי ביותר.",
    "image_url": "../upload_images/Talenti/Dining Chair/Queen Folding Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Queen Folding Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Queen Folding Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Queen Folding Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Queen Folding Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Queen Folding Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Queen Folding Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Queen Folding Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Queen Folding Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/queen-folding-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 21399,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Riviera Director chair": {
    "description": "כיסא הבמאי ריביירה הוא הצעה עיצובית אופנתית ומעודנת להוסיף מגע של אלגנטיות לחלל האוכל החיצוני שלך. הקווים המינימליים מתאימים לתשומת הלב לפרטים במסגרת האלומיניום, ומשקפים את הטעם המעודן של כל אוסף הריביירה. גודל הכריות הקומפקטי תואם את סגנון כיסא הבמאי מבלי לפגוע בנוחות ובפונקציונליות של המוצר, המובטחות על ידי המילוי בקצף המתייבש במהירות. כיסא הבמאי הזה הוא רהיט חובה לריהוט חיצוני נצחי.",
    "image_url": "../upload_images/Talenti/Dining Chair/Riviera Director chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Riviera Director chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-director-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 22194,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Salinas Dining chair": {
    "description": "כיסא האוכל סלינס בולט הודות לעיצוב הרצועה המרופדת שעוטפת את הגב, מדגישה את הקווים הרכים של הכריות. איכות הבדים והצבעים הטבעיים של החול והים, מעוררים אווירה אלגנטית ומעודנת שמעצימה את המרחבים החיצוניים, ומקצרת את המרחק בין פנים לחוץ.",
    "image_url": "../upload_images/Talenti/Dining Chair/Salinas Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Salinas Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 12167,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Scacco Dining armchair": {
    "description": "כיסא האוכל סקאקו משלב את החוזק והאלגנטיות של האלומיניום עם דוגמת הגיאומטרית היפה של החבל המאפיינת את המשענת. הרכות והעגולות של המושב משתלבות בצורה מושלמת עם האפקטים המפתיעים והמקוריים של החבל.\nכיסא האוכל סקאקו הוא האלמנט המושלם להוסיף מגע חזק ומודרני למרחב החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Scacco Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/scacco-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 12814,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Slam Dining armchair": {
    "description": "בזכות צורותיו הרכות, כיסא האוכל עם הידיות מאזן בין פונקציונליות לבין רב-תכליתיות. החלק התחתון, שעשוי מאלומיניום, משתלב עם מושב אלגנטי, מרופד בבד נועז, קל לניקוי וניתן להסרה. הריפוד מקצף המתייבש במהירות הוא אידיאלי למוצר פונקציונלי. בזכות צורותיו ההרמוניות והמבנה הנוח שלו, הוא מתאים לכל אזור אוכל חיצוני.",
    "image_url": "../upload_images/Talenti/Dining Chair/Slam Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Slam Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 10728,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Slam-Rope Dining chair": {
    "description": "סלאם // כסא אוכל חבל משתלב באזור המגורים החיצוני באלגנטיות, ומשלב עיצוב מינימליסטי עם חומרים משובחים. משענת הגב, מכוסה באריגים אלגנטיים של חבל סינתטי, עוטפת בחן את המושב, ומכניסה איזון וקלילות לאזור המגורים.",
    "image_url": "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Slam-Rope Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-rope-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 25284,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Swipe Dining Chair": {
    "description": "כיסא האוכל Swipe מתאפיין בעיצוב דינמי המקרין נוחות וקלילות. מבנה האלומיניום מדגיש את סורגי הקיר, הודות לשזירה הזריזה של חבל מרופד, אשר יוצר דפוס גיאומטרי אלגנטי. המושב הרך והמחבק, מביא לרמה גבוהה יותר את רגעי הרגיעה והמפגשים החברתיים בסלון החוץ.",
    "image_url": "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 18874,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Swipe Dining Chair2": {
    "description": "כסא האוכל Swipe הוא הפתרון המושלם להענקת אופי לאזור המגורים שלך בגינה. מסגרת האלומיניום הקלה מפותחת סביב המושב הנוח. סורגי הקיר והמשענות יד הם יחידה אחת המודגשת על ידי הדוגמה הגאומטרית שצוירה בחבל המרופד. השזירה הדינמית הזו מעוררת תחושת תנועה וקלילות, המשתקפת בחדר המגורים החיצוני.",
    "image_url": "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/main.jpeg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/main.jpeg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/11.jpeg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/10.jpeg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/9.jpeg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/8.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/7.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/6.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/5.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/4.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/3.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/2.jpg",
      "../upload_images/Talenti/Dining Chair/Swipe Dining Chair2/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-dining-chair-2/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 10919,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Timber Dining Armchair": {
    "description": "הבנה סקרנית ושילוב חומרי נחמד, כיסא האוכל עם משענות יד של אוסף טימבר מתאים באופן מושלם לעיצוב ולחמימות של המוצרים האחרים באוסף. המבנה עשוי מאלומיניום, המושב ומשענת הגב עשויים מטקסטילן בצבע זהה והמשענות היד עשויות מעץ טיק, יוצרים ניגוד נעים בין מודרניות למסורת. הכיסא זמין בשני צבעים (לבן ואפור-יונה), והוא נוח אפילו בתקופות הקרות ביותר בזכות יכולתו להיערם שטי הופכת אותו קל לאחסון.",
    "image_url": "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Timber Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/timber-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 20795,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Touch Dining Armchair": {
    "description": "כיסא האוכל עם ידיות, נוח בזכות המושב העשוי מבד טקסטילן אך חזק בזכות המבנה מאלומיניום, מושלם להשלמת אזור האוכל החיצוני. עמידותו בפני מזג האוויר ויכולת ההערמה שלו הופכים את המוצרים לנוחים ופונקציונליים.",
    "image_url": "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/14.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/13.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Touch Dining Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 14493,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Tressé Dining armchair": {
    "description": "כיסא האוכל טרֶסֶה הוא פתרון עיצובי אלגנטי שעונה על הצורך בנוחות רבה יותר עבור סלון הבית שלך. המבנה הדקיק והצינורי של אלומיניום מציע עיצוב אלגנטי ומאוזן שמספק יציבות למושב ולמשענת, שהם מועשרים ברצועות אקו-עור וכריות רכות, זמינות בבדי המפ או גַרדֶנִיָה. שילוב של כל האלמנטים האלו הופך את הכיסא למתוחכם וגמיש לשימוש בכל סוג של סביבה חיצונית.",
    "image_url": "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Tressé Dining armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-dining-armchair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 27041,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Venice Armchair for bar": {
    "description": "כסא הבר של ונציה תוכנן לרגעי חברות נעימים, בשילוב נוחות ואלגנטיות. המושב הגבוה, הנתמך על ידי מבנה עץ טיק יציב, רך ונוח בזכות רוחבו. הגימורים העדינים, המוצגים על ידי האריגה המעודנת של החבלים, מזכירים את הסגנון הימי ואת הקסם של לגונת ונציה. אלמנט העיצוב הזה מסוגל לשדרג את הגן ואת החיים בחוץ.",
    "image_url": "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/main.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/10.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/9.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/8.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/7.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/6.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/5.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/4.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/3.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/2.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Armchair for bar/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-armchair-for-bar/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 14784,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Venice Dining chair": {
    "description": "כיסא האוכל ונציה, בהשראת עיר הלגונה המפורסמת, הוא הפתרון המושלם לשדרוג אזור המחיה שלכם בגינה. מסגרת העץ הטיק המוצק עוטפת את המושב הרחב והנוח. בד הכריות ואריג החבל שעוטף את הגב, מזכירים את הסגנון הימי הקלאסי והופכים את החלל החיצוני למעודן ואלגנטי.",
    "image_url": "../upload_images/Talenti/Dining Chair/Venice Dining chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/main.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/12.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/11.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/10.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/9.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/8.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/7.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/6.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/5.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/4.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/3.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/2.jpg",
      "../upload_images/Talenti/Dining Chair/Venice Dining chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-dining-chair/",
    "company_name": "Talenti",
    "original_category": "Dining Chair",
    "price": 24524,
    "filter_category": "כיסאות וכיסאות בר",
    "placement": "Outdoor"
  },
  "Adam extending Dining table 156x214": {
    "description": "שולחן האוכל הניתן להארכה מקולקציית אדם עשוי כולו מאלומיניום כדי להבטיח את יציבותו ועמידותו של המוצר. המשטח הניתן להארכה יכול להכיל עד 8 אנשים, מה שהופך את אזור האכילה החיצוני שלכם למושלם לכל אירוע.",
    "image_url": "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/main.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/7.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/6.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/5.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/4.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/3.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/2.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 156x214/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/adam-extending-dining-table-156-214/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 23095,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Adam extending Dining table 200x280": {
    "description": "שולחן האוכל הנפתח מקולקציית אדם מתאים לעד 10 אנשים, ומציע חלל חיצוני אלגנטי ומעוצב. המבנה, שעשוי כולו מאלומיניום, הופך את המוצר לעמיד וחזק נגד תנאי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/main.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/7.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/6.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/5.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/4.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/3.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/2.jpg",
      "../upload_images/Talenti/Dining Table/Adam extending Dining table 200x280/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/adam-extending-dining-table-200-280/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 12132,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Alabama-Alu Dining Table 160×90": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/main.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/14.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/13.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/12.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/11.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/10.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/9.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/8.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/7.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/6.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/5.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/4.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/3.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/2.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 160×90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-alu-dining-table-160x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 26795,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Alabama-Alu Dining Table 220×100": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/main.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/14.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/13.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/12.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/11.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/10.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/9.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/8.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/7.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/6.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/5.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/4.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/3.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/2.jpg",
      "../upload_images/Talenti/Dining Table/Alabama-Alu Dining Table 220×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-alu-dining-table-220x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 12763,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Allure 220×95 Dining Table": {
    "description": "שולחן האוכל מקולקציית Allure בולט בזכות העיצוב הגיאומטרי והחומרים האיכותיים שלו. המבנה הקל והמעודן מאלומיניום תומך במשטח עץ מוצק. ההרכב מעניק לשולחן טעם אלגנטי ועכשווי, מה שמעניק אופי לסביבה החיצונית.",
    "image_url": "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Allure 220×95 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-220x95-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 22944,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Allure 300×95 Dining Table": {
    "description": "שולחן האוכל אלור מעניק אלגנטיות ומודרניות לסביבה החיצונית. המבנה הקל והמעודן מאלומיניום משתלב עם יציבות המשטח העליון מעץ. העיצוב הגיאומטרי של ההרכב, בשילוב עם חומרים יוקרתיים, מבטא אופי ואישיות.",
    "image_url": "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Allure 300×95 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-300x95-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 18188,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu 157×157 dining table": {
    "description": "החלק העליון המרובע של שולחן האוכל Argo Alu בגודל 157×157 ס\"מ יכול להכיל עד 8 אנשים. המבנה החזק והיציב מאלומיניום תומך בחלק עליון מחרסית, הזמין במגוון צבעים שונים.",
    "image_url": "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/16.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/15.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/14.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 157×157 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-157x157-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 18119,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu 220×100 dining table": {
    "description": "שולחן האוכל ארגו אלומיניום בגודל 220×100 מיועד להכיל עד 8 אנשים במרחב החיצוני שלכם. מבנה האלומיניום החזק, הזמין בשלושה צבעים שונים, יחד עם העמידות של משטח האבן, הופכים את השולחן הזה למושלם למגוון מקומות חיצוניים.",
    "image_url": "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 220×100 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-220x100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25121,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu 290×100 dining table": {
    "description": "שולחן האוכל המלבני במידות 280×100 הוא הגדול ביותר בקולקציית ארגו אלומיניום. המבנה האלומיניום המוצק תומך במשטח גדול מגרניט פורצלן. השילוב המושלם עם כיסאות האוכל בעלי הידיות מאותה הקו הופך את השולחן הזה לפריט רהיטי אידיאלי לעיצוב מרחבים חיצוניים רבים.",
    "image_url": "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Alu 290×100 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-280x100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 13706,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood 165×165 Dining table": {
    "description": "השילוב בין חומרי עץ גולמיים שנבחרו בקפידה לבין עבודה עם עץ אקויה הופכת את השולחן הזה לבחירה הטובה ביותר לעיצוב חלל אוכל חיצוני אלגנטי ואיכותי. הסגנון הגאומטרי והמדויק של כל הקולקציה משתקף ברהיט זה שהופך לאלמנט המרכזי לשילוב רהיטי החוץ שלכם בסגנונות מגוונים.",
    "image_url": "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 165×165 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-165x165-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10518,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood 220×110 Dining table": {
    "description": "שולחן האוכל Argo בגודל 220×110 בהשראה נושא תיבת העץ, שמופיע בכל האוסף. הקונספט הזה מודגש על ידי הסגנון של השולחן העליון, שמורכב מלוחות עץ, והרגליים הזוויתיות. בהתאם לשילוב הצבעים הנבחר, הוא יכול להיראות מעודן או מחוספס יותר, אבל הוא תמיד מוצר מצוין לקישוט המרחב החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 220×110 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-220x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 18824,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood 280×110 Dining table": {
    "description": "שולחן האוכל ארגו בגודל 280×110, עם שטח המשטח הרחב שלו, מאפשר לארח בנוחות עד 10 אנשים באזור החיצוני שלכם. פונקציונלי ועמיד מאוד, הודות לשימוש בעץ אקויה, שולחן זה אידיאלי לעיצוב חוץ.",
    "image_url": "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 280×110 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-280x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16872,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood 95×95 Dining table": {
    "description": "שולחן האוכל ארגו בגודל 95×95 עשוי כולו מעץ אקויה, ועומד בצורה מושלמת בדרישות של מוצרים המיועדים לשימוש חיצוני, תוך כדי הבטחת עמידות גבוהה לתנאי מזג האוויר. בהשראת נושא קופסת העץ, הוא מאופיין בשפה עיצובית מאופקת עם קווים חיוניים.",
    "image_url": "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Argo-Wood 95×95 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-95x95-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16719,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Bridge Round Table 150": {
    "description": "מבנה המהגוני הופך את השולחן העגול מבית Bridge לפריט קלאסי. הרגליים החופפות, הייחודיות והמוזרות, יחד עם הקלאסיות של העץ, אפשרו לחברת Talenti ליצור מוצר ייחודי. החלק העליון החלק והעגול מעניק את האפשרות ליצור אזור חיים חיצוני, בזכות טיפול בעץ, ואזור פנימי עם אישיות ייחודית.",
    "image_url": "../upload_images/Talenti/Dining Table/Bridge Round Table 150/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Bridge Round Table 150/main.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Round Table 150/6.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Round Table 150/5.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Round Table 150/4.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Round Table 150/3.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Round Table 150/2.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Round Table 150/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/bridge-round-table-150/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 29511,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Bridge Table 220X100": {
    "description": "השולחן המלבני הגדול אך לא מגושם של הגשר משלים את הסלון והופך את המרחב החיצוני לדינמי, הודות לרגליו ומשטחו העשויים מעץ מהגוני. ייחודי אך מתאים לכל אווירה, ניתן להשתמש בשולחן כרהיט מבלי לאבד את הפונקציונליות שלו.",
    "image_url": "../upload_images/Talenti/Dining Table/Bridge Table 220X100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Bridge Table 220X100/main.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Table 220X100/6.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Table 220X100/5.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Table 220X100/4.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Table 220X100/3.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Table 220X100/2.jpg",
      "../upload_images/Talenti/Dining Table/Bridge Table 220X100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/bridge-table-220x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 12257,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Bar table 125×70": {
    "description": "שולחן הבר קסילדה משקף באופן מושלם את הטעם הנקי והעכשווי של האוסף הזה, ומציע מוצר פונקציונלי ומודרני לעיצוב חוץ אלגנטי. מסגרת הנירוסטה המצופה באבקה תומכת בקורות העץ שמרכיבות את החלק העליון. זמין בשילובי צבעים שונים, הוא מקבל מראה שונה בהתאם לבחירה, בין אם יותר אלגנטי או יותר תעשייתי, ומסתגל לסביבות חוץ שונות.",
    "image_url": "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/main.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/13.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/12.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/11.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/10.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/9.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/8.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/7.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/6.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/5.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/4.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/3.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/2.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Bar table 125×70/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-bar-table-125x70/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 15585,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Dining Table 150×150": {
    "description": "להלן תרגום הטקסט שלך לעברית: שולחן האוכל קאסילדה 260×100 עם מסגרת נירוסטה מצופת אבקה ומשטח עליון מעץ אירוקו משולב עם לוח שיש בהתאם לצבע הבסיס.",
    "image_url": "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/main.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/14.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/13.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/12.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/11.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/10.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/9.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/8.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/7.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/6.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/5.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/4.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/3.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/2.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 150×150/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-dining-table-150x150/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 23226,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Dining Table 260×100": {
    "description": "שולחן האוכל קסילדה 260×100 עם מסגרת נירוסטה מצופה אבקה ומשטח עץ אירוקו משולב בשיש בחריצים בהתאם לצבע הבסיס.",
    "image_url": "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/main.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/13.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/12.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/11.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/10.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/9.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/8.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/7.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/6.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/5.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/4.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/3.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/2.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining Table 260×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-dining-table-260x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 29606,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Dining table 200×100": {
    "description": "שולחן האוכל קסילדה 200×100 עם מסגרת מפלדת אל-חלד בצביעה בתנור ומשטח עץ אירוקו משולב עם פיסות שיש בהתאם לצבע הבסיס.",
    "image_url": "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/main.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/14.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/13.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/12.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/11.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/10.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/9.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/8.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/7.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/6.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/5.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/4.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/3.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/2.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Dining table 200×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-dining-table-200x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 19274,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Table 90×90": {
    "description": "שולחן האוכל קאסילדה בגודל 90×90 מאופיין במסגרת מרובעת מפלדת אל-חלד. השימוש בחריצי עץ אקויה או אירוקו מעניק עיצוב משעשע ונצחי עם טעם תעשייתי קל. הבחירה הקפדנית של החומרים העמידים בפני מזג האוויר, עושה את השולחן הזה למוצר אידיאלי לעיצוב החוץ שלכם.",
    "image_url": "../upload_images/Talenti/Dining Table/Casilda Table 90×90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/main.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/13.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/12.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/11.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/10.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/9.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/8.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/7.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/6.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/5.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/4.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/3.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/2.jpg",
      "../upload_images/Talenti/Dining Table/Casilda Table 90×90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-table90x90/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 29779,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu 150×150 Dining Table": {
    "description": "שולחן האוכל המרובע מתוך קולקציית החוץ CleoSoft Alu בעל מבנה אלומיניום מצופה אבקה ומשטח Vitter. השילוב עם כיסאות מרווחים ועגולים יוצר ניגודים אלגנטיים של צורות שמעוררות שלווה, אלגנטיות ופשטות. השולחן מתאים ל-8 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 150×150 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-150x150-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 17879,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu 220×100 Dining Table": {
    "description": "שולחן האוכל 220×100 של קולקציית החוץ CleoSoft Alu הוא עגול, גבוה יותר משאר השולחנות בקו זה ויש לו קוטר קטן יותר. יש לו מבנה אלומיניום בציפוי אבקה ומציע מגוון משטחים בהתאם לצבע המבנה. השילוב עם כיסאות מקבלים ומעוגלים יוצר ניגודים אלגנטיים של צורות שמעניקים תחושת רוגע, אלגנטיות ופשטות. השולחן מתאים ל-8 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Alu 220×100 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-220x100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 28674,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood 150×150 dining table": {
    "description": "עם החלק העליון המרובע הגדול שלה, שולחן האוכל CleoSoft Wood 150×150 יכול לארח עד 8 אנשים. המבנה מעץ תומך בחלק העליון מקרמיקה. חומרים שנבחרו בקפידה ועמידים בפני מזג האוויר הופכים שולחן אוכל זה לבחירה הטובה ביותר עבור סביבת המגורים החיצונית שלך.",
    "image_url": "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 150×150 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-150x150-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 27164,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood 220×100 dining table": {
    "description": "שולחן האוכל בגודל 220×100 מקולקציית CleoSoft Wood עשוי ממבנה עץ ופלטת פורצלן באבן קרמית הזמינה בשני צבעים שונים: קלקטה ואבן גיר חולית. השילוב עם כיסאות בעלי צורות רכות ועגולות יוצר ניגודי צורות אלגנטיים המשרים שלווה, אלגנטיות ופשטות. השולחן יכול להכיל עד 8 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 220×100 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-220x100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25284,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood 300×110 dining table": {
    "description": "שולחן האוכל המלבני בגודל 300×110 הוא הגדול והמרווח ביותר בקו CleoSoft Wood. תוכנן להכיל עד 10 אנשים, והוא מושלם ליהנות מרגעי חברות באזור המגורים החיצוני שלך. שולחן CleoSoft Wood זה בעל מבנה עץ ופלטת אבן זמינה בצבעים שונים.",
    "image_url": "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/CleoSoft-Wood 300×110 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-300x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16807,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff 240x300×100 Extendable Dining Table": {
    "description": "החלק העליון נתמך על ידי רגלי השולחן העשויות משזירת כבלים, סימן היכר ייחודי של הקולקציה.",
    "image_url": "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Cliff 240x300×100 Extendable Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-240-300x100-extendable-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 15770,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff D140 Dining Table": {
    "description": "הקליעה של החבל שמאפיינת את אוסף Cliff תומכת במשטח הפלדה.\nהצורה העגולה נמצאת במשטח ובבסיס, קליעת החבלים יוצרת גוונים וניחוחות שמרמזים על הדינמיות האופיינית לאוסף.",
    "image_url": "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Cliff D140 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-d140-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 19675,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Square Dining Table": {
    "description": "קליעת החבל של אוסף קליף תומכת בראש האלומיניום בצורת ריבוע. החבל שנראה כמספק תמיכה לראש, מזכיר את האור והצל שנמצאים גם בשאר הרכיבים של אוסף קליף, מסתיר את המבנה המתכתי הטובולרי.",
    "image_url": "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Cliff Square Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-square-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10769,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Bar Table 75×75": {
    "description": "שולחן הבר קורל בגודל 75×75, בשילוב עם כסא הבר, הוא השילוב המושלם ליהנות מרגע נעים ומשובח. שלדת האלומיניום הקלה בולטת בעיצובה החדשני, המשתלב עם משטח השולחן מקרמיקה. בצורה זו, המראה הוא נקי ומאוזן היטב, מה שהופך את שולחן הבר לרהיט מודולרי ועל-זמני, שמתאים לכל סוג של סביבה חיצונית.",
    "image_url": "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/main.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/10.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/9.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/8.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/7.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/6.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/5.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/4.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/3.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/2.jpg",
      "../upload_images/Talenti/Dining Table/Coral Bar Table 75×75/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-bar-table-75x75/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10171,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Dining Table 240×120": {
    "description": "עכשווי ואלגנטי, שולחן האוכל בגודל 240×120 ימלא את הצרכים שלך ברהיט חברתי ונצחי לפינת האוכל החיצונית שלך. החלק העליון הדק והמעודן מחרסינה מאזן את העיצוב הייחודי של רגלי האלומיניום הדינמיות, אלמנט הליבה של רהיט זה. החומרים האיכותיים, העמידים לתנאי מזג האוויר ולקרני UV, הופכים את השולחן הזה למוצר המושלם עבור פינת האוכל החיצונית.",
    "image_url": "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/main.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/10.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/9.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/8.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/7.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/6.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/5.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/4.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/3.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/2.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 240×120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-dining-table-240x120/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16903,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Dining Table 90×90": {
    "description": "שולחן האוכל קורל במידות 90×90 מדגיש את הטעם החיוני והעל-זמני האופייני לכל האוסף. המסגרת מאלומיניום ומשטח הפורצלן הופכים אותו למוצר פונקציונלי ועמיד בפני מזג האוויר, מושלם ליצירת מרחב חיצוני חברתי.",
    "image_url": "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/main.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/10.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/9.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/8.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/7.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/6.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/5.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/4.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/3.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/2.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table 90×90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-dining-table-90x90/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 12599,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Dining Table D120": {
    "description": "שולחן האוכל העגול קורל מדגיש את העיצוב המאוזן והנקי שמאפיין את כל הקולקציה. אבן הקרמיקה מכסה את משטח השולחן, בעוד שמסגרת האלומיניום יוצרת קומפוזיציה מהנה ומודרנית המורכבת מרגליים בצורת צינורות מוצלבים. שולחן אוכל עגול זה אידיאלי להוספת נגיעה יצירתית לעיצוב החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Dining Table/Coral Dining Table D120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/main.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/9.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/8.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/7.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/6.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/5.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/4.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/3.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/2.jpg",
      "../upload_images/Talenti/Dining Table/Coral Dining Table D120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-dining-table-d120/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 12041,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cottage Dining Table 240×110": {
    "description": "שולחן האוכל The Cottage 240×110 משלב סגנון כפרי ומינימליסטי. החלק העליון, עשוי מעץ אירוקו, נתמך על ידי מבנה אלומיניום מוצק. הצורה הליניארית של החלק העליון משולבת עם הצורה הלא סדירה של הרגליים, יוצרת שולחן גדול שיכול להכיל עד 10 אורחים.",
    "image_url": "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/main.jpg",
      "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/7.jpg",
      "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/6.jpg",
      "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/5.jpg",
      "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/4.jpg",
      "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/3.jpg",
      "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/2.jpg",
      "../upload_images/Talenti/Dining Table/Cottage Dining Table 240×110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-dining-table-240x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 13108,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-Teak 160×40 Consolle": {
    "description": "קונסולה 160×40 מקולקציית Cruise Teak אידיאלית להשלמת ריהוט חוץ. הודות לגודלה הקטן היא אינה מגושמת. המשטח הגבוה והפונקציונלי עשוי גרס נתמך על ידי מבנה עץ מלא, בהתאם לכל הקולקציה.",
    "image_url": "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/main.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/13.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/12.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/11.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/10.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/9.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/8.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/7.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/6.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/5.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/4.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/3.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/2.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 160×40 Consolle/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-160x40-consolle/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 13806,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-Teak 240×110 Dining table": {
    "description": "שולחן האוכל בגודל 240×110 מקולקציית קרוז טיק מושלם כריהוט חוץ. בגודלו הגדול, הוא נראה מרשים הודות לשימוש בעץ לבסיס. הוא מתאים במיוחד לארוחת צהריים או ערב בגינה בזכות המשטח הגדול, הפונקציונלי והעמיד בפני מזג האוויר אשר יכול להכיל עד עשרה מקומות ישיבה.",
    "image_url": "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-Teak 240×110 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-240x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 20532,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu 150×150 Dining table": {
    "description": "החלק העליון המרובע של שולחן האוכל 150×150 מקולקציית Cruise Alu, שיכול להכיל עד 8 אנשים, עשוי כולו מגרס. המבנה האיתן והיציב מאלומיניום מעניק למוצר סטייל והוא אידיאלי לריהוט חוץ.",
    "image_url": "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 150×150 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-150x150-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10095,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu 250×100 Dining table": {
    "description": "שולחן האוכל Cruise Alu 250×100, מרווח ואלגנטי, בעל מראה קליל מאוד. יחד עם הצורה הרכה והנוחה של כורסת האוכל Cruise Alu, הוא מושלם לעיצוב הגן שלך.",
    "image_url": "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu 250×100 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-250x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 19528,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu D150 round Dining table": {
    "description": "שולחן אוכל עגול D150 מתאים בצורה מושלמת לאוסף Cruise Alu. המבנה האלומיניום נעשה בטכניקת יציקה בלחץ דבר שמבטיח מוצר יציב ומעוצב. המשטח הגדול והפונקציונלי, עשוי כולו מגרס, יכול להכיל עד 8 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/14.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-alu D150 round Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-d150-round-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 22961,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-teak dining table 320×120": {
    "description": "שולחן האוכל מעץ טיק מסדרת קרוז הוא אלגנטי ומרשים. בסיס העץ הטיק המעשן והמשטח הקרמי הופכים אותו לאידיאלי לארוחת צהריים או ערב בגינה. פונקציונלי, אלגנטי ועמיד בפני מזג האוויר, הוא יכול להכיל עד 12 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/main.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/13.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/12.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/11.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/10.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/9.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/8.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/7.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/6.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/5.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/4.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/3.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/2.jpg",
      "../upload_images/Talenti/Dining Table/Cruise-teak dining table 320×120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-dining-table-320x120/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 19089,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Bar table D75": {
    "description": "שולחן הבר דולצ'וויטה אידיאלי לתת נגיעת רעננות לסלון החיצוני. בהשראת ערבי קיץ חמים, השולחן בולט בעיצובו החי והרמוני. הצורות הרכות של משטח הטיק ובסיס האלומיניום משתלבות באופן מושלם. פריט ריהוט עליז זה מתאים לסביבות חוץ בסגנונות שונים, והוא מוסיף לגינה אווירה אינטימית ומסבירת פנים.",
    "image_url": "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/main.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/14.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/13.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/12.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/11.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/10.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/9.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/8.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/7.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/6.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/5.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/4.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/3.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/2.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Bar table D75/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-bar-table-d75/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 24979,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Dining Table D140": {
    "description": "מעודן ובאותו הזמן מלא חיים, שולחן האוכל דולצ'ביטה מזכיר את הקסם של ערבי קיץ חמימים. הקווים המוארים וההרמוניים מדגישים את הגימורים המוקפדים של משטח העץ טיק. הוא מעניק לחדר המגורים החיצוני אווירה קלה ומזמינה ומתאים לכל גן הודות למגוון צבעים רב תכליתי.",
    "image_url": "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/main.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/14.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/13.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/12.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/11.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/10.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/9.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/8.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/7.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/6.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/5.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/4.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/3.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/2.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D140/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-dining-table-d140/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 18068,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Dining Table D90": {
    "description": "שולחן האוכל דולצ'ויטה הוא הצהרה של קלילות וסטייל המעניקה צבעים לסלון החיצוני עם נשימה של רעננות. בהשראת ערבי הקיץ, רהיט זה מתאפיין בעיצובו החיוני, שמשלב את משטח העץ הטיק המעובד בקפידה עם הבסיס האלומיניום הצבעוני. הוא מעניק אווירה אינטימית וחברותית לכל גינה או סביבה חיצונית.",
    "image_url": "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/main.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/16.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/15.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/14.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/13.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/12.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/11.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/10.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/9.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/8.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/7.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/6.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/5.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/4.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/3.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/2.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table D90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-dining-table-d90/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 17505,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Dolcevita Dining Table H66": {
    "description": "בהשראת ערבים קיציים חמימים, שולחן האוכל דולצ'וויטה מושלם לרגעים של קהילתיות. המבנה הפשוט מדגיש את תשומת הלב לפרטים ואת היופי הטבעי של טיק וקרמיקה. המרקמים המפתים של חומרים אלה מקרינים אווירה קלה ורעננה, שמאפיינת בסגנון את החיים בגינה ובחוץ.",
    "image_url": "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/main.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/12.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/11.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/10.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/9.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/8.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/7.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/6.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/5.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/4.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/3.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/2.jpg",
      "../upload_images/Talenti/Dining Table/Dolcevita Dining Table H66/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-dining-table-h66/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25472,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ebi Dining table 220×100": {
    "description": "שולחן האוכל מאוסף Ebi הוא מוצק ואלגנטי. הקווים הקלאסיים של המוצר הופכים אותו לאידיאלי לקישוט שטח חיצוני, וגם הודות לגודלו, הוא יכול להכיל עד 8 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/Ebi Dining table 220×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Ebi Dining table 220×100/main.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Dining table 220×100/6.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Dining table 220×100/5.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Dining table 220×100/4.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Dining table 220×100/3.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Dining table 220×100/2.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Dining table 220×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ebi-dining-table-200x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 14378,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ebi Top table 80x80x3": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Ebi Top table 80x80x3/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Ebi Top table 80x80x3/main.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Top table 80x80x3/6.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Top table 80x80x3/5.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Top table 80x80x3/4.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Top table 80x80x3/3.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Top table 80x80x3/2.jpg",
      "../upload_images/Talenti/Dining Table/Ebi Top table 80x80x3/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ebi-top-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 18635,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ever Dining table 300×100": {
    "description": "שולחן האוכל Ever הוא ביטוי של אלגנטיות פשוטה ונצחית. הסינרגיה המושלמת בין העיצוב המינימליסטי לבין הטבעיות של החומרים הטבעיים, מעניקה אופי נצחי לחללי חוץ. עמידות החומרים משתלבת עם האסתטיקה הנצחית של פריט ריהוט זה, ומשדרגת את הסלון בפרספקטיבה עתידנית.",
    "image_url": "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/main.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/15.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/14.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/13.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/12.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/11.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/10.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/9.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/8.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/7.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/6.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/5.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/4.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/3.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/2.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table 300×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-dining-table-300x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 22988,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ever Dining table H65": {
    "description": "העיצוב הפשוט והנקי של שולחן האוכל Ever מדגיש את המרקמים של החומרים הטבעיים מהם הוא עוצב. זה מאפשר לשלב ברבגוניות את רהיט בכל סביבה חיצונית, ולשדרג אותה עם אסתטיקה איקונית ועל-זמנית.",
    "image_url": "../upload_images/Talenti/Dining Table/Ever Dining table H65/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/main.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/16.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/15.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/14.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/13.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/12.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/11.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/10.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/9.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/8.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/7.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/6.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/5.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/4.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/3.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/2.jpg",
      "../upload_images/Talenti/Dining Table/Ever Dining table H65/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-dining-table-h65/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 20022,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Frame Folding table 80×80": {
    "description": "שולחן המסגרת הוא בעל נוכחות קסם בלתי מעורערת בסביבה החיצונית בזכות הנפחים הקלים והחושניים שמדגישים את עיצובו בנשמה חיונית. המשטח המתקפל והאלומיניום העמיד בפני מזג אוויר מציעים פרקטיות ותפקודיות גם בגינות בעלות מימדים מוגבלים, מה שהופך אותו לפריט ריהוט מתאים למגוון פתרונות.",
    "image_url": "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/main.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/10.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/9.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/8.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/7.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/6.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/5.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/4.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/3.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/2.jpg",
      "../upload_images/Talenti/Dining Table/Frame Folding table 80×80/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/frame-folding-table-80x80/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 21219,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "George 150×150 Dining table": {
    "description": "הקשב הקפדני לבחירת חומרי הגלם לייצור שולחן האוכל ג'ורג' 150×150 הופך אותו למושלם עבור חלל מגורים חיצוני יוקרתי. המשטח המרובע, מעץ אקויה או מאבן לבה הזמינים במגוון צבעים, נתמך על ידי מבנה מפלדת אל-חלד.",
    "image_url": "../upload_images/Talenti/Dining Table/George 150×150 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/George 150×150 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-150x150-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25160,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "George 250×100 Dining table": {
    "description": "החלק העליון הגדול של שולחן האוכל ג׳ורג׳ 250×100 יכול להכיל בנוחות עד 10 אנשים באזור המגורים החיצוני שלך. חזק, מוצק ועמיד הודות לשימוש באיכות גבוהה של חומרי הגלם כמו נירוסטה ועץ אקויה או אבן לבה לחלק העליון, שולחן האוכל ג׳ורג׳ אידיאלי לריהוט כל סוג של מרחב חיצוני.",
    "image_url": "../upload_images/Talenti/Dining Table/George 250×100 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/George 250×100 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-250x100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 19195,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "George Consolle": {
    "description": "קונסולת 45×160 היא יצירת המופת של קולקציית ג'ורג'. קונסולה מיוחדת, פרקטית ופונקציונלית שהיא קטנה ולא מגושמת. מבנה הנירוסטה משולב עם משטח עליון זמין מעץ אקויה או מאבן לבה, אשר הייצור שלהם הופך כל חלק לייחודי ושונה מהאחר.\nשולחן הקונסולה 45×160 הוא המוצר המושלם להשלמת ריהוט החוץ שלכם.",
    "image_url": "../upload_images/Talenti/Dining Table/George Consolle/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/George Consolle/main.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/11.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/10.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/9.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/8.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/7.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/6.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/5.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/4.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/3.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/2.jpg",
      "../upload_images/Talenti/Dining Table/George Consolle/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-consolle/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 14481,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "George D.155 Dining table": {
    "description": "שולחן האוכל D155 הוא השולחן העגול היחיד באוסף ג'ורג'. החלק העליון הגדול והפונקציונלי יכול להכיל בנוחות עד 6 אנשים והוא זמין בשני חומרים שונים: עץ אקויה או אבן לבה, מה שהופך אותו לייחודי במינו.\nהמסגרת מפלדת אל-חלד מתאימה לאותו סגנון של כל אוסף ג'ורג'.",
    "image_url": "../upload_images/Talenti/Dining Table/George D.155 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/George D.155 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-d-155-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 23476,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Karen 280×110 Dining Table": {
    "description": "שולחן האוכל קארן מקרין את העוצמה והיופי של ארצות אפריקה, בזכות גימורי העץ שמדגישים את הקווים הרכים של העיצוב. המלאכה של השולחן הופכת את הגן למזמין, אך מלא בסגנון ואישיות.",
    "image_url": "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Karen 280×110 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-280x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 15555,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Karen D100 Dining Table": {
    "description": "שולחן האוכל קרן בולט בזכות עיצוב עם קווים רכים, שמדגיש את מאפייני העץ. הצורות העקלתוניות מזכירות את האסתטיקה האפריקאית האומנותית הטיפוסית, ומעניקות לגינה תחושת אירוח מלאה באופי.",
    "image_url": "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Karen D100 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-d100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 24877,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Karen D160 Dining Table": {
    "description": "השולחן האוכל קארן מבטא את האומנות האסתטית האופיינית לתרבות האפריקאית. דרך הצורות המעוקלות של עיצובו וצבע העץ, הוא הופך את המראה החיצוני למזמין ומעניק לו סגנון ואישיות.",
    "image_url": "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Karen D160 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-d160-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 28278,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Lake extendible Dining Table 178x252×90": {
    "description": "שולחן האוכל הנפתח \"The Lake\" מתבלט בצורותיו הרכות והחינניות, שהופכות אותו למושא לעיון מפתה. בנוסף למילוי תפקידו דרך המגשים וההארכה החבויה, הוא מעניק אלגנטיות ומקוריות לסביבה החיצונית.",
    "image_url": "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/main.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/8.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/7.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/6.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/5.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/4.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/3.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/2.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 178x252×90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-extendible-dining-table-178-252x90/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10627,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Lake extendible Dining Table 220x337×100": {
    "description": "אובייקט של התבוננות מפתה, השולחן הנמתח לייק, בזכות צורותיו הרכות והמעוגלות, מעניק אלגנטיות ומקוריות לאזור המגורים החיצוני. דרך המגלשות ומערכת ההארכות הנסתרת הוא יכול לארח בין 6 ל-12 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/main.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/8.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/7.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/6.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/5.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/4.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/3.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/2.jpg",
      "../upload_images/Talenti/Dining Table/Lake extendible Dining Table 220x337×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-extendible-dining-table-220-337x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16867,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf 150×150 dining table": {
    "description": "שולחן האוכל 150×150 מקולקציית Leaf יכול להכיל עד 8 אנשים. מסגרת האלומיניום והמשטח העליון מוויטר שלו משקפים את האלגנטיות והעיצוב המאפיינים את כל קולקציית Leaf.",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/16.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/15.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/14.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 150×150 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-150x150-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 28437,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf 220×100 dining table": {
    "description": "שולחן האוכל 220×110 מקולקציית Leaf הוא מושלם לריהוט חוץ. השולחן עם פלטת ה-vitter, הזמינה בשלושה צבעים, נתמך על ידי מסגרת אלומיניום אלגנטית. הוא יכול להכיל בקלות עד 10 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/15.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/14.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 220×100 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-220x100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 14584,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf 300×110 dining table": {
    "description": "שולחן האוכל בגודל 300×110 הוא מרכז הקולקציה Leaf. מודרני וחדשני, הוא משלב חומרים עמידים למזג האוויר עם עיצוב אלגנטי ונצחי. המשטח הגדול שלו יכול להכיל עד 12 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/15.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/14.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/13.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/12.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf 300×110 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-300x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 18080,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf base H102 + Vitter top": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H102 + Vitter top/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-base-top-h102/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 26680,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf base H62 + Vitter top": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H62 + Vitter top/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-base-top-h62/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 12776,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf base H70 + Vitter top": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf base H70 + Vitter top/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-base-top-h70/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 15456,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf dining table H63": {
    "description": "שולחן האוכל מקולקציית Leaf מתאפיין במשטח עליון אלגנטי מחומר Vitter, הזמין בשלושה צבעים, הנתמך על ידי מבנה אלומיניום דק. הוא משתלב בצורה מושלמת בסביבה החיצונית, ומעביר את הקלילות הטמונה בטבע.",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf dining table H63/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/19.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/18.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/17.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/16.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/15.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/14.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/13.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/12.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H63/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-dining-table-h63/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10053,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf dining table H68": {
    "description": "שולחן האוכל \"Leaf\" מושפע מהטבע ומאזכר את הקלילות של עלי הכותרת של פרח. המשטח העליון העשוי מווִיטֶר, הזמין בשלושה צבעים, נשען בחן על המבנה הדקיק מאלומיניום. רהיט זה משתלב באופן מושלם עם הסביבה החיצונית ומעשיר באלגנטיות את הסלון החיצוני.",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf dining table H68/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/19.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/18.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/17.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/16.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/15.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/14.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/13.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/12.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf dining table H68/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-tavolo-da-pranzo-h68/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 18123,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf extending table 160x215×95": {
    "description": "שולחן האוכל הנפתח \"Leaf\", בעיצוב מודרני וחדשני, הוא רהיט אידיאלי להכיל 6 עד 8 אנשים, מתאים לסביבות גדולות ומרווחות כמו גנים וטרסות גדולות.\nהאלומיניום מבטיח עמידות כנגד גורמים חיצוניים ומזג אוויר גרוע. משטח הוויטר, הזמין בשלושה צבעים, מושלם כשולחן חיצוני: עמידות גבוהה מאוד בפני פגיעות ושריטות, עמיד לשימוש עם חומרי ניקוי כימיים ומתאים למגע ישיר עם מזון.",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/16.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/15.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/14.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/13.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/12.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 160x215×95/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-extending-table-160-215x95/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 22580,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf extending table 200x260×100": {
    "description": "שולחן האוכל המתקפל 'Leaf' עם עיצוב מודרני וחדשני הוא החתיכה האידיאלית של רהיט להכיל 6 עד 8 אנשים, מתאים לסביבות גדולות ומרווחות כגון גינות ומרפסות גדולות.\nהמבנה מאלומיניום מבטיח עמידות כנגד גורמים חיצוניים ומזג אוויר גרוע. חזית ה-Vitter, הזמינה בשלושה צבעים, היא החומר המושלם לשולחן חוץ: עמידות גבוהה מאוד כנגד פגיעות ושריטות, עמידות לשימוש בחומרי ניקוי כימיים ומתאים למגע ישיר עם מזון.",
    "image_url": "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/main.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/16.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/15.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/14.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/13.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/12.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/11.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/10.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/9.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/8.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/7.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/6.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/5.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/4.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/3.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/2.jpg",
      "../upload_images/Talenti/Dining Table/Leaf extending table 200x260×100/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-extending-table-200-260x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25538,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Maiorca 200x300 Extendible dining Table": {
    "description": "שולחן האוכל הגדול הניתן להארכה 200/300 של Maiorca הוא מוצר מרכזי בחוויית האוכל החיצונית שלכם. השולחן, בזכות יכולת ההארכה של 100 סנטימטרים, מאפשר שימוש מקסימלי, מבלי לאבד את העיצוב הייחודי, שחתום על ידי Talenti. המבנה הוא יציב, עשוי מאלומיניום, בעוד שהמישור העליון, הזמין בלבן או אפור-יונה, עשוי מזכוכית משי.",
    "image_url": "../upload_images/Talenti/Dining Table/Maiorca 200x300 Extendible dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Maiorca 200x300 Extendible dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca 200x300 Extendible dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca 200x300 Extendible dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca 200x300 Extendible dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca 200x300 Extendible dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca 200x300 Extendible dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/maiorca-200-300-extendible-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25385,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Maiorca Bar Table 70×70": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/main.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/7.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/6.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/5.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/4.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/3.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/2.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Bar Table 70×70/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/maiorca-bar-table-70x70/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 26805,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Maiorca Dining Table": {
    "description": "שולחן האוכל מאיורה (Maiorca) הוא אינטימי ואלגנטי. המבנה מאלומיניום והזכוכית המחוסמת המבריקה עם הדפס משי הופכים אותו לאידיאלי ליצירת פינת אוכל בחלל החיצוני שלך. בנוסף, הגודל הקטן מאפשר ורסטיליות רבה למוצר.",
    "image_url": "../upload_images/Talenti/Dining Table/Maiorca Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Maiorca Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/maiorca-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 15453,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Maiorca Table 70×70": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/main.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/8.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/7.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/6.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/5.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/4.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/3.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/2.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 70×70/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/maiorca-table-70x70/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25859,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Maiorca Table 80×80": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/main.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/7.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/6.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/5.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/4.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/3.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/2.jpg",
      "../upload_images/Talenti/Dining Table/Maiorca Table 80×80/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/maiorca-table-80x80/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 21262,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo 120×80 Dining Table": {
    "description": "שולחן האוכל 120×80 מקולקציית מילו כולל חלק עליון מלבני גדול אך חוסך מקום שיכול להכיל עד 4 אנשים. שלדת האלומיניום שתומכת בחלק עליון נשלף מחרס זמינה בצבעים שונים. השולחן יכול להשתלב בצורה מושלמת עם כיסא האוכל מהקו אותו.",
    "image_url": "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Milo 120×80 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-120x80-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 29081,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo 160×95 Dining Table": {
    "description": "שולחן האוכל מילו תוכנן באותה תשומת לב לפרטים כמו החייט כאשר הוא מכין חליפה. המבנה עשוי מאלומיניום בציפוי אבקה. השולחן יכול להתרחב עד 215 ס\"מ בזכות הארכה פנימית.",
    "image_url": "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/13.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-160x95-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 20779,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo 160×95 ceramic Dining Table": {
    "description": "השולחן הזה של מילו מתאפיין במשטח הקרמי שלו ובמבנה אלומיניום מצופה אבקה. שולחן עם נשמה חזקה, אך יחד עם זאת משתלב ללא התנשאות בריהוט החוץ. הודות להארכה הפנימית שלו, הוא יכול להתרחב עד 215 ס\"מ.",
    "image_url": "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/15.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/14.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/13.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Milo 160×95 ceramic Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-160x95-ceramic-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 11895,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo 200×100 Dining Table": {
    "description": "שולחן החוץ מאלומיניום \"מילו\" יכול להאריך עד ל-260 ס\"מ עם ההארכה הכלולה במבנה ועד ל-320 ס\"מ עם לוח אלומיניום נוסף. הוא משתלב באופן מושלם עם כיסאות האוכל \"מילו\" כדי ליצור ריהוט גמיש אך קשיח, צבעוני אך מאוזן, מודרני אך נצחי.",
    "image_url": "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/13.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-200x100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10552,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo 200×100 ceramic Dining Table": {
    "description": "מבנה אלומיניום ומשטח קרמי לשולחן האלגנטי הזה של מילו. השולחן יכול להתרחב עד 260 ס\"מ עם הרחבה מאלומיניום הכלולה במבנה, ועד 320 ס\"מ עם לוח קרמי נוסף. הוא משתלב בצורה מושלמת עם כיסאות האוכל של מילו כדי ליצור עיצוב רומנטי, מודרני אך נצחי.",
    "image_url": "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/13.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Milo 200×100 ceramic Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-200x100-ceramic-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 23085,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo Dining Table 160×90": {
    "description": "מסגרת עליונה מאלומיניום לשולחן החוץ האלגנטי הזה בסדרת Milo, שמתאים בצורה מושלמת עם כיסאות האוכל של Milo ליצירת עיצוב רומנטי, מודרני אך נצחי.",
    "image_url": "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/main.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/15.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/14.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/13.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/12.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/11.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/10.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/9.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/8.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/7.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/6.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/5.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/4.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/3.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/2.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 160×90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-dining-table-160x90/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16363,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo Dining Table 90×90": {
    "description": "שולחן מרובע מילוא, הוא תוכנן באותה תשומת לב לפרטים כמו חייט כשמכין חליפת חייטים. המסגרת עשויה מאלומיניום בציפוי אבקה.",
    "image_url": "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/main.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/17.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/16.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/15.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/14.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/13.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/12.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/11.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/10.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/9.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/8.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/7.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/6.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/5.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/4.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/3.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/2.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table 90×90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-dining-table-90x90/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25471,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Milo Dining Table D90": {
    "description": "שולחן העגול לחצר עשוי מאלומיניום. הוא משתלב באופן מושלם עם כיסאות האוכל מילו. הוא יוצר עיצוב המורכב מקווים רכים ונוקשים, צבעוני אך מאוזן, מודרני אך נצחי.",
    "image_url": "../upload_images/Talenti/Dining Table/Milo Dining Table D90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/main.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/15.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/14.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/13.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/12.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/11.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/10.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/9.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/8.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/7.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/6.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/5.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/4.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/3.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/2.jpg",
      "../upload_images/Talenti/Dining Table/Milo Dining Table D90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-dining-table-d90/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16550,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Minorca Bar Base H105": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/main.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/7.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/6.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/5.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/4.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/3.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/2.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Bar Base H105/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/minorca-bar-base-h105/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 14630,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Minorca Rectangular Base H72": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/main.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/7.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/6.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/5.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/4.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/3.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/2.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Rectangular Base H72/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/minorca-rectangular-base-h72/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 15167,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Minorca Square Base H72": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Minorca Square Base H72/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/main.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/9.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/8.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/7.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/6.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/5.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/4.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/3.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/2.jpg",
      "../upload_images/Talenti/Dining Table/Minorca Square Base H72/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/minorca-square-base-h72/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 21056,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu 160x215×95 Extendible dining Table": {
    "description": "שולחן האוכל \"Moon\" מעוצב עבור החוץ אך עם אזכורים לצבעים הטיפוסיים של הפנים. המבנה עשוי אלומיניום והחלק העליון מקרמיקה.",
    "image_url": "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 160x215×95 Extendible dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-160-215x95-extendible-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 13996,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu 200x260×100 Extendible dining Table": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 200x260×100 Extendible dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-200-260x100-extendible-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25333,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu 240x300×100 Extendible dining Table": {
    "description": "שולחן האוכל Moon מעוצב עבור חוץ אך עם אזכורים לצבעים הטיפוסיים של הפנים. המבנה עשוי מאלומיניום והמשטח העליון מקרמיקה.",
    "image_url": "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/13.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu 240x300×100 Extendible dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-240-300x100-extendible-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 12945,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu Bar Table": {
    "description": "בוּאִיקָה הנתמכת על ידי פֶּדֶסְטָל עם רֶגֶל בעלת בסיס מרובע. היא משתלבת באופן מושלם עם הכִּסְאוֹת הגבוהים של האוסף הזה. המבנה עשוי מאלומיניום והמשטח מִקֵּרָמִיקָה.",
    "image_url": "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Bar Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-bar-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 27822,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Alu Square Table": {
    "description": "עמוד הרגל היחיד תומך בשולחן המרובע. החלק העליון מתאפיין בפינות מעוגלות המתאימות לסגנון כל הקולקציה.\nהעמוד עשוי מאלומיניום והחלק העליון מקרמיקה.",
    "image_url": "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Alu Square Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-square-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 29392,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Teak 150×150 dining table": {
    "description": "\nשולחן האוכל 150×150 מקולקציית Moon Teak מתאפיין במסגרת ובמשטח שכל כולו עשוי מעץ טיק. למרות המידות הקומפקטיות שלו, השולחן מספיק מרווח בכדי להושיב עד 8 אנשים. שולחן ה-Moon Teak המרובע, בשילוב עם כסאות האוכל מאותה הקולקציה, הוא אידיאלי להשלמת המרחב החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 150×150 dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-dining-table-150x150/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 17213,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Teak 200×100 Dining table": {
    "description": "שולחן האוכל Moon Teak בגודל 200×100, אשר יכול להכיל עד 8 אנשים, כולל מסגרת ושולחן מעץ טיק, המעניקים לו מראה טבעי ומיוצר ביד. השולחן, בשילוב עם כיסא האוכל מאותה קולקציה, הוא המרכיב האידיאלי להשלמת אזור המגורים החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 200×100 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-dining-table-200x100/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 20434,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Moon-Teak 260×110 Dining table": {
    "description": "שולחן האוכל בגודל 260×110 מקולקציית Moon Teak הוא הגדול ביותר בכל הקולקציה. האלגנטיות של העץ, שהוא המרכיב המרכזי של כל הקו, מאפיינת את השולחן הזה ויכולה להכיל עד 10 אנשים.",
    "image_url": "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Moon-Teak 260×110 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-dining-table-260x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 22696,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Nova Dining table": {
    "description": "",
    "image_url": "../upload_images/Talenti/Dining Table/Nova Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Nova Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Nova Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Nova Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Nova Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Nova Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Nova Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Nova Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Nova Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nova-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 11303,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Oliver Dining table 220X110": {
    "description": "שולחן האוכל אוליבר הוא מחווה אמתית ליופייה של הטבע. העיצוב הפשוט והמינימליסטי נועד להדגיש את המרקם של העץ והגרנית. המבנה המוצק מדגיש את תכונות הטיק, עם הוורידים החמים והמוגדרים היטב שלו. עליו מונח משטח הגרנית המאפיינים במרקם נעים של צבעים רכים וגימור חלק ונעים. האותנטיות של החומרים מעניקה לסביבה אווירה חמימה ומזמינה, ומריהטה את הגן ואת מרחבי החוץ בטבעיות ובפשטות.",
    "image_url": "../upload_images/Talenti/Dining Table/Oliver Dining table 220X110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Oliver Dining table 220X110/main.jpg",
      "../upload_images/Talenti/Dining Table/Oliver Dining table 220X110/6.jpg",
      "../upload_images/Talenti/Dining Table/Oliver Dining table 220X110/5.jpg",
      "../upload_images/Talenti/Dining Table/Oliver Dining table 220X110/4.jpg",
      "../upload_images/Talenti/Dining Table/Oliver Dining table 220X110/3.jpg",
      "../upload_images/Talenti/Dining Table/Oliver Dining table 220X110/2.jpg",
      "../upload_images/Talenti/Dining Table/Oliver Dining table 220X110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/oliver-dining-table-220x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 25370,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Prichi Dining table D120": {
    "description": "שולחן האוכל Prichi  מרומם את היופי הטבעי של העץ והחצץ דרך קונספט מתוחכם ונעים של שיק. עץ הטיק, עם הטקסטורה שלו בגוונים חמים, מהווה התייחסות לעולם הטבעי, המנוגדת לעיצוב המורכב של המבנה המוצק. עליו מונח הרצפה בחצץ, המעוטר בטקסטורה נעימה של צבעי פסטל. השילוב של אלמנטים אלו יוצר בחדר המגורים החיצוני אווירה מושלמת לרגעים של חברות, יוצר נקודת מפגש בין הסגנון המודרני של העולם הפנימי לבין האותנטיות של החוץ.",
    "image_url": "../upload_images/Talenti/Dining Table/Prichi Dining table D120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Prichi Dining table D120/main.jpg",
      "../upload_images/Talenti/Dining Table/Prichi Dining table D120/6.jpg",
      "../upload_images/Talenti/Dining Table/Prichi Dining table D120/5.jpg",
      "../upload_images/Talenti/Dining Table/Prichi Dining table D120/4.jpg",
      "../upload_images/Talenti/Dining Table/Prichi Dining table D120/3.jpg",
      "../upload_images/Talenti/Dining Table/Prichi Dining table D120/2.jpg",
      "../upload_images/Talenti/Dining Table/Prichi Dining table D120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/prichi-dining-table-d120/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16699,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Queen 120×80 Folding Table": {
    "description": "בנוחות, הודות לרצפה הגדולה שלה וקל לאחסון בזכות קלילותה, שולחן הקיפול 120X80 מושלם ליצירת אזור אוכל לצד הבריכה. היציבות מובטחת על ידי האלומיניום, ממנו כל השולחן עשוי, זמין בשני צבעים: לבן ואפור חמרה.",
    "image_url": "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Queen 120×80 Folding Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/queen-120x80-folding-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 17609,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Queen 70×70 Folding Table": {
    "description": "שולחן המלכה המתקפל בגודל 70×70, כולו מאלומיניום, יכול לשמש בכל מצב. החומר, עמיד ומוצק, מאפשר להשתמש בו בכל סיטואציה חיצונית, מחדר מגורים ועד לחדר אוכל, ולהנות ממשטח שולחן נוח ולא מגושם לארוחות בוקר או ארוחות קלות בחוץ.",
    "image_url": "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Queen 70×70 Folding Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/queen-70x70-folding-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16068,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Riviera 210×100 Dining table": {
    "description": "שולחן האוכל ריביירה 210×100 מציע אפשרות לארח עד 8 אנשים באזור הפינת אוכל החיצוני שלכם. בזכות המבנה האלומיניום והמשטח גרניט פורצלן, העמידים מאוד בפני מזג האוויר וקרני UV, הוא אופטימלי למילוי הצרכים של כל סוג של מיקום חיצוני. עם הקווים הבטוניים והחיוניים שלו, שנשארים באותו הזמן אלגנטיים ומתוחכמים, שולחן זה אידיאלי ליהנות מהמרחב החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 210×100 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-210x100-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 29404,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Riviera 260×110 Dining table": {
    "description": "שולחן האוכל ריביירה 260×110 הוא המוקד של אזור המגורים החיצוני שלכם. מודרני ומעודן, הוא מאופיין בשימוש בחומרים עמידים למזג האוויר ובעיצוב אלגנטי ועל-זמני. המשטח הגדול מחרסינה אידיאלי לאירוח של עד 10 אנשים, ויוצר פריט ריהוט עם סגנון החלטי ומלוטש.",
    "image_url": "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Riviera 260×110 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-260x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 26601,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas 140×140 Dining Table": {
    "description": "שולחן האוכל סאלינס מביא את העידון האופייני לעולם הפנים אל החוץ. העיצוב המיוחד של העמודות התומכות בו מדגיש את המרקם של הבטון, ומעלה תחושת קסם טבעי של סאלינס, האזור באיביזה שהיווה השראה לכל הקולקציה.",
    "image_url": "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 140×140 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-140x140-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10442,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas 320×120 Dining Table": {
    "description": "שולחן האוכל מקולקציית סלינס מעניק קסם טבעי לסביבה החיצונית, הודות לעיצוב הייחודי שמדגיש את מאפייני העץ. הסגנון האלגנטי והמזוקק, המודגש על ידי ארבעת העמודים הקלאסיים שתומכים בו, מציע פתרון של המשכיות בין ריהוט פנים וריהוט חוץ.",
    "image_url": "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Salinas 320×120 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-320x120-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10690,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas D 165 Accoya Dining Table": {
    "description": "שולחן האוכל \"סאלינס\" מעוצב באופן מעודן שמנצל את החומר הגולמי ומדגיש את המרקם של העץ. הוא מעניק לסביבה החיצונית בה הוא משולב, קסם ואלגנטיות, ומזכיר את האווירה של סאלינס, אזור טבעי באיביזה ממנו נלקחה ההשראה. שלושת העמודים המרכזיים שתומכים בשולחן מזכירים את העולם הקלאסי.",
    "image_url": "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D 165 Accoya Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-d-165-accoya-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 11840,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas D165 Concrete Dining Table": {
    "description": "שולחן האוכל מאוסף סלינס מוסיף קסם ועידון לסביבה החיצונית בה הוא משולב. העיצוב מדגיש את החוזק של הבטון, ומעניק אלגנטיות והמשכיות בין הסביבה החיצונית לגינה. התכונה הייחודית של שולחנות הגן של סלינס היא העמודות בסגנון הקלאסי שעליהן מונח המשטח העליון.",
    "image_url": "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Salinas D165 Concrete Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-d165-concrete-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 20651,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas Dining Table 280×110": {
    "description": "שולחן האוכל Salinas מייצג את העידון הטיפוסי של עולמות הפנים בחוץ. המרקם של הבטון מודגש על ידי העיצוב האלגנטי. האיזון המושלם בין העמודים המרהיבים בסגנון קלאסי והמשטח, מעורר את הקסם הטבעי שמעורר Salinas, האזור באיביזה שהיווה השראה לכל האוסף.",
    "image_url": "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/main.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/12.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/11.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/10.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/9.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/8.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/7.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/6.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/5.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/4.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/3.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/2.jpg",
      "../upload_images/Talenti/Dining Table/Salinas Dining Table 280×110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-dining-table-280x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 12761,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam 190×90 Dining Table": {
    "description": "השילוב המיומן בין קווים נקיים ורכים ובחירת החומרים האיכותיים הופכים את שולחן האוכל בגודל 190×90 לחלק חשוב בעיצוב חוץ סטייליסטי. משטח האבן והמבנה האלומיניום המוצק מבטיחים עמידות טובה בפני מזג האוויר, מה שהופך מוצר זה למושלם לשימוש חיצוני.",
    "image_url": "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Slam 190×90 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-190x90-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16593,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam 230×110 Dining table": {
    "description": "שולחן האוכל בגודל 230×110 הוא מרכז האזור החיצוני המיועד לאירוח, המעוצב בשם ההרמוניה והפשטות, הודות להזדמנות לארח עד 10 אנשים. צורות דקות וגיאומטריות מאפיינות את החלק העליון, העשוי מאבן, ואת מסגרת האלומיניום. עמיד בפני מזג האוויר, הוא אידיאלי להוסיף נגיעה של אלגנטיות למרחב האכילה החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Slam 230×110 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-230x110-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 16142,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam D120 Dining table": {
    "description": "בהתאם לסגנון של כל הקולקציה, שולחן האוכל העגול \"סלאם\" מאופיין בגודל קומפקטי, אידיאלי לאירוח עד 6 אנשים. השילוב עם כיסאות האוכל יוצר חלל עם צורות מאווררות ונעימות, המציע הזדמנות ליהנות מרגעי רגיעה באזור החיצוני. תשומת הלב לפרטים והחומרים האיכותיים הופכים מוצר זה לרהיט עמיד בפני מזג האוויר ונצחי.",
    "image_url": "../upload_images/Talenti/Dining Table/Slam D120 Dining table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/main.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/9.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/8.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/7.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/6.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/5.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/4.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/3.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/2.jpg",
      "../upload_images/Talenti/Dining Table/Slam D120 Dining table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-d120-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 15295,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Sofy Dining table D110": {
    "description": "עשוי כולו מאלומיניום, שולחן האוכל מקולקציית Sofy הוא יציב ואלגנטי. המשטח העגול הרחב מאפשר להשלמת אזור ארוחת צהריים חיצונית גם בזכות עמידותו למזג האוויר.",
    "image_url": "../upload_images/Talenti/Dining Table/Sofy Dining table D110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Sofy Dining table D110/main.jpg",
      "../upload_images/Talenti/Dining Table/Sofy Dining table D110/7.jpg",
      "../upload_images/Talenti/Dining Table/Sofy Dining table D110/6.jpg",
      "../upload_images/Talenti/Dining Table/Sofy Dining table D110/5.jpg",
      "../upload_images/Talenti/Dining Table/Sofy Dining table D110/4.jpg",
      "../upload_images/Talenti/Dining Table/Sofy Dining table D110/3.jpg",
      "../upload_images/Talenti/Dining Table/Sofy Dining table D110/2.jpg",
      "../upload_images/Talenti/Dining Table/Sofy Dining table D110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/sofy-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 27104,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Swipe Dining table 220X110": {
    "description": "שולחן האוכל Swipe משלב קלילות וחברותיות הודות לעיצוב המשחקי של האלמנטים השונים המרכיבים אותו. בהשראת רעיון התנועה, פריט עיצוב זה מתאפיין בחלקו העליון הדק מאבן, שנראה כאילו הוא מרחף הודות למשחק זריז של שקיפויות, הניתן על ידי החבל המרופד הקלוע שמסתיר את מבנה האלומיניום המוצק. הדגם הגיאומטרי של הבסיס משקף אווירה מקסימה לגינה ולחיים החיצוניים.",
    "image_url": "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/main.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/12.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/11.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/10.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/9.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/8.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/7.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/6.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/5.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/4.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/3.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/2.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 220X110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-dining-table-220x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 17975,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Swipe Dining table 300X110": {
    "description": "שולחן האוכל Swipe הוא פתרון מושלם להנות מרגעים נהדרים של הכנסת אורחים בגן. הוא מאופיין במשטח גרניט דק שנראה כמו מרחף בזכות עיצוב הבסיס מאלומיניום, המצופה בחבל מרופד קלוע. הגיאומטריה של האריגה יוצרת משחק שקיפות המעניק אווריריות נעימה לסלון החיצוני.",
    "image_url": "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/main.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/12.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/11.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/10.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/9.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/8.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/7.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/6.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/5.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/4.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/3.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/2.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table 300X110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-dining-table-300x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 24073,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Swipe Dining table D150": {
    "description": "הדינמיות והתנועה הם המושגים שהיוו השראה לעיצוב שולחן האוכל Swipe. פריט ריהוט זה מעניק קלילות לרגעי התכנסות בגינה, הודות לקצב הגיאומטרי של המיתרים המרופדים המכסים את מבנה האלומיניום הצינורי. אלמנט משחקי זה מוסיף אופי לסלון החיצוני ומשעשע את העיניים בתחושה שהמשטח החרסינה הדק מרחף.",
    "image_url": "../upload_images/Talenti/Dining Table/Swipe Dining table D150/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/main.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/12.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/11.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/10.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/9.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/8.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/7.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/6.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/5.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/4.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/3.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/2.jpg",
      "../upload_images/Talenti/Dining Table/Swipe Dining table D150/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-dining-table-d150/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 28705,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Timber 156x214 Extendile dining Table": {
    "description": "שולחן האוכל המתרחב 156/214 מבית Timber משלב את עיצוב הצורות עם החום של החומר המשמש. המשטח, העשוי עץ טיק, נותן גוון ביתי למוצר, מה שהופך אותו למושלם ליצירת אזור אוכל חיצוני. המבנה מאלומיניום תומך במשטח המתרחב ויוצר סביבה מזמינה יותר.",
    "image_url": "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Timber 156x214 Extendile dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/timber-156-214-extendile-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 17428,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Timber 200x280 Extendible dining Table": {
    "description": "בהיותו גדול אך לא מגושם, שולחן האוכל הניתן להארכה 200/280 של Timber יכול להפוך למרכז אזור האוכל בסגנון Talenti המושלם. יציבות המוצר, הניתנת על ידי האלומיניום של המבנה, יחד עם החום של המשטח המעץ הטיק, תורמת להנאה מלאה מהמוצר. בנוסף, המשטח הניתן להארכה מאפשר ליהנות מהמוצר באופן מלא, להפיק את המירב משטח החוץ שלכם לארוחה עם חברים.",
    "image_url": "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Timber 200x280 Extendible dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/timber-200-280-extendible-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 22994,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Touch 152x225 Extentible dining Table": {
    "description": "שולחן האוכל המתרחב יכול להיפתח עד 225 סנטימטרים ולארח 8 אנשים. המשטח עשוי זכוכית והמבנה, כולו מאלומיניום, זמין בארבעה צבעים: לבן, אפור-יונה, אפור כהה ומוקה.",
    "image_url": "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/14.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/13.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Touch 152x225 Extentible dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-152-225-extentible-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 15127,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Touch 155×155 Dining Table": {
    "description": "פשוט אך פונקציונלי, שולחן האוכל משתמש בצורה מרובעת כדי להכיל עד 8 אנשים סביבו. זמין בשני צבעים (לבן ואפור-יונה), מבנה אלומיניום ולוח זכוכית.",
    "image_url": "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/13.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Touch 155×155 Dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-155x155-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 28436,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Touch 220x330 Extendible dining Table": {
    "description": "שולחן האוכל הנפתח יכול להיפתח עד לאורך של 330 סנטימטרים ולארח עד 12 אנשים סביבו. מבנה מאלומיניום ומשטח זכוכית.",
    "image_url": "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/main.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/14.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/13.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/12.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/11.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/10.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/9.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/8.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/7.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/6.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/5.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/4.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/3.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/2.jpg",
      "../upload_images/Talenti/Dining Table/Touch 220x330 Extendible dining Table/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-220-330-extendible-dining-table/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 27897,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tressé Dining table 270X110": {
    "description": "כל פרט ופרט נחקר בקפידה בשולחן האוכל הזה, שעוצב לרגעים בלתי נשכחים של חברות באוויר הפתוח. הבחירה הקפדנית של החומרים, הזמינה במגוון שילובי צבעים, משלבת בין אסתטיקה לפונקציונליות הודות לאבן הלבה העמידה, המזוגגת והמעובדת ביד, ומבנה האלומיניום הצינורי, החזק והקל בו זמנית. העיצוב המורכב של יצירת עיצוב מצוינת זו מעניק טעם מעודן לאזור המגורים החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/main.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/23.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/22.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/21.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/20.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/19.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/18.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/17.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/16.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/15.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/14.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/13.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/12.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/11.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/10.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/9.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/8.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/7.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/6.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/5.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/4.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/3.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/2.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 270X110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-dining-table-270x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 22048,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tressé Dining table 340X120": {
    "description": "שולחן האוכל Tressè מסוגל להעניק רגעים בלתי נשכחים של אנשים שחיים ביחד. גימורים משובחים ותשומת לב לפרטים, הופכים אותו ליצירת עיצוב מתוחכמת, עמידה ופונקציונלית. החלק העליון מאבן לבה מזוגגת, עשוי בעבודת יד ומשובץ בצורה מיומנת למבנה האלומיניום הצינורי. השילוב הזה של אלמנטים, משופר על ידי מגוון רחב של וריאציות צבע, מעניק אופי ואלגנטיות לחיים בחוץ ומסתגל לכל סוג של חלל חיצוני.",
    "image_url": "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/main.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/23.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/22.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/21.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/20.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/19.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/18.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/17.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/16.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/15.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/14.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/13.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/12.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/11.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/10.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/9.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/8.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/7.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/6.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/5.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/4.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/3.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/2.jpg",
      "../upload_images/Talenti/Dining Table/Tressé Dining table 340X120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-dining-table-340x120/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 28018,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Dining table 220X110": {
    "description": "בהשראת אחת הערים הרומנטיות ביותר, שולחן האוכל ונציה מושלם לרגעים של חמימות ואירוח. הקסם הנשגב של פריט עיצובי זה נובע ממשטח הקרמיקה המבריק של החלק העליון, המעורר את מימי התעלות הזוהרות של ונציה. מצבעי החמים של השקיעה ועד לגוונים הקרים של הדמדומים, מכלול הצבעים של משטח האבן הוולקנית מציג את כל גווני הים. העיצוב המונוליטי משתלב היטב עם קלילות החומרים והסינרגיה בין האלמנטים, וצובע את האווירה של הגן והסלון החיצוני בעדינות מתוחכמת.",
    "image_url": "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/main.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/14.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/13.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/12.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/11.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/10.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/9.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/8.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/7.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/6.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/5.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/4.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/3.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/2.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 220X110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-dining-table-220x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 10357,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Dining table 280X110": {
    "description": "שולחן האוכל ונציה הוא הצהרה של סגנון ועידון שמעלה את סביבת החיים החיצונית לרמת אלגנטיות חדשה. בהשראת העיר הנושאת את אותו שם, פריט העיצוב הזה מתאפיין במשטח אבן לבה, המוגמר בקרמיקה מבריקה, המזכיר את הבריכות הנוצצות של התעלות. האפקט מועצם על ידי טווח הצבעים שנבחר, המשקף את כל גווני הים, מגווני השקיעה החמימים ועד לגוונים הקרים של הדמדומים. הוא משתלב באופן טבעי בגינה ומעניק לחיים בחוץ אווירה אינטימית וחברתית.",
    "image_url": "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/main.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/14.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/13.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/12.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/11.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/10.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/9.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/8.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/7.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/6.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/5.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/4.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/3.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/2.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table 280X110/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-dining-table-280x110/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 28271,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Dining table D150": {
    "description": "אמנות ופונקציונליות מתקיימות יחד בשולחן האוכל ונציה, שמעלה בזיכרון את האווירה הרומנטית של עיר הלגונה המפורסמת ביותר. אידיאלי לריהוט הגן וחדר המגורים החיצוני, אלמנט העיצוב הזה מוגדר על ידי המשטח הקרמי המבריק של החלק העליון, שחוגג את מראות המים של תעלות ונציה. מגווני החום של השקיעה ועד לגוונים הקרים של הדמדומים, טווח הצבעים של משטח האבן הוולקנית מקיף את כל גווני הים של ונציה.",
    "image_url": "../upload_images/Talenti/Dining Table/Venice Dining table D150/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/main.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/14.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/13.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/12.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/11.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/10.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/9.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/8.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/7.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/6.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/5.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/4.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/3.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/2.jpg",
      "../upload_images/Talenti/Dining Table/Venice Dining table D150/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-dining-table-d150/",
    "company_name": "Talenti",
    "original_category": "Dining Table",
    "price": 28472,
    "filter_category": "שולחנות אוכל פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tikal Madia": {
    "description": "מבנה מפלדה מגולוונת באבץ-מגנזיום ואלומיניום (מגנזיט), שחור RAL 9004 עמיד בטמפרטורה גבוהה, צביעה במרקם. \n4 דלתות נדנדה זמינות במגנזיט או בעץ אקויה, בצבע טיק טבעי עם ידיות שקועות, פתיחה מהירה בזווית 125° ומנגנון בלומושן. חלק עליון מגרס.",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal Madia/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal Madia/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/15.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/14.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/13.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/12.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Madia/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-madia/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 10579,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Tikal Peninsula": {
    "description": "גרס תלוי זמין רק בבסיס טיקאל עם 3 מודולים.",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal Peninsula/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/13.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/12.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Peninsula/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-peninsula/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 24608,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Tikal Snack bar": {
    "description": "זמין גג מקרמיקה תלוי למטבח לבסיס טיקאל עם 2 ו-3 מודולים.",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal Snack bar/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/16.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/15.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/14.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/13.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/12.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal Snack bar/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-snack-bar/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 22914,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Tikal corner": {
    "description": "הבסיס הפינתי יכול להיות משמש כמחבר בין בסיסים עם 3 מודולים או בסיסים עם 2 מודולים. הבסיס הפינתי אינו מתאים לחצי אי או עמדת נשנושים.",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal corner/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal corner/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/14.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/13.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/12.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal corner/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-corner/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 24969,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Tikal kitchen 2 modules": {
    "description": "שילוב הבסיס של שני המודולים של טיקאל מאופיין במבנה מגנזיט צבוע בצבע ראל 9004 שחור עם צבע טקסטורה בטמפרטורה גבוהה, ספציפי לשימוש חיצוני.\nבמידות 160×60 ס\"מ, יש לו 4 דלתות נדנדה עם ידיות מוסתרות, פתיחה מהירה ב-125⁰ ומנעול בלומושן. המודולים הניתנים לשילוב הם: גריל ברביקיו, כיור, כיריים אינדוקציה ומשטח עבודה נייטרלי.\nכאופציה נוספת, ניתן להוסיף את האביזרים הבאים: משטח תלוי של 160×35 ס\"מ, מקרר יין, מכונת קרח, מקרר למיני בר וערכת תאורה.\nטיקאל לא רק תוכנן לבישול הארוחות האהובות עליך, אלא גם כדי לאפשר לך ליהנות מהשטח החיצוני שלך ולשתף רגעים ידידותיים עם יקיריך.",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/17.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/16.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/15.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/14.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/13.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/12.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 2 modules/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-kitchen-2-modules/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 24008,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Tikal kitchen 3 modules": {
    "description": "שילוב בסיס שלושת המודולים של טיקאל מאופיין במבנה מגנזיט צבוע בצבע טקסטורה עמידה בטמפרטורה גבוהה RAL 9004 שחור, ייחודי לשימוש חיצוני. \nבמידות של 240x60 ס\"מ, יש לו 6 דלתות נדנדות עם ידיות שקועות, פתיחה מהירה בזווית של 125 מעלות ונעילת בלומושן. \nהמודולים הניתנים לשילוב הם: גריל ברביקיו, כיור, כיריים אינדוקציה ומשטח עבודה ניטרלי. כאופציה נוספת ניתן להוסיף את האביזרים הבאים: משטח תלייה גרס בגובה 240×35 ס\"מ עם אופציה לכיור חצי-אי (מידות כוללות 360x95 ס\"מ), מקרר יין, מכונת קרח, מקרר מיני-בר ומערכת תאורה.\nטיקאל לא רק נועדה לבשל את המנות האהובות עליכם, אלא גם לאפשר לכם ליהנות מהמרחב החיצוני שלכם ולחלוק רגעים ידידותיים עם יקיריכם.",
    "image_url": "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/main.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/18.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/17.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/16.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/15.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/14.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/13.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/12.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/11.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/10.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/9.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/8.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/7.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/6.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/5.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/4.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/3.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/2.jpg",
      "../upload_images/Talenti/Kitchen/Tikal kitchen 3 modules/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tikal-kitchen-3-modules/",
    "company_name": "Talenti",
    "original_category": "Kitchen",
    "price": 20247,
    "filter_category": "מטבחי חוץ",
    "placement": "Outdoor"
  },
  "Casilda Lamp L": {
    "description": "מנורת קאסילדה L היא אלמנט תאורה מושלם לשילוב עם הרהיטים של האוסף הזה.\nמסגרת המתכת הגיאומטרית מצופה באבקה תואמת בסיס עץ איקרו מוצק.",
    "image_url": "../upload_images/Talenti/Lamp/Casilda Lamp L/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Casilda Lamp L/main.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/13.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/12.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/11.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/10.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/9.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/8.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/7.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/6.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/5.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/4.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/3.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/2.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp L/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-lamp-l/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 19180,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Lamp S": {
    "description": "מנורת ה-Casilda S היא אלמנט תאורה מושלם לשילוב עם הרהיטים של האוסף הזה.  \nהמסגרת הגיאומטרית מנירוסטה עם ציפוי באבקה משתלבת עם בסיס עץ אירוקו מוצק.",
    "image_url": "../upload_images/Talenti/Lamp/Casilda Lamp S/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Casilda Lamp S/main.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/13.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/12.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/11.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/10.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/9.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/8.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/7.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/6.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/5.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/4.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/3.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/2.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp S/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-lamp-s/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 17825,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Lamp XS": {
    "description": "מנורת קסילדה XS היא מרכיב תאורה שמתאים באופן מושלם לשילוב עם ריהוט מהקולקציה הזו. השלדה הגיאומטרית מנירוסטה בציפוי אבקה מתאימה לבסיס מעץ איפאה מוצק.",
    "image_url": "../upload_images/Talenti/Lamp/Casilda Lamp XS/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/main.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/12.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/11.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/10.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/9.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/8.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/7.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/6.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/5.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/4.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/3.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/2.jpg",
      "../upload_images/Talenti/Lamp/Casilda Lamp XS/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-lamp-xs/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 12647,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Arc lamp": {
    "description": "מנורת הקשת CleoSoft Alu היא מרכז הקישוט והפונקציונליות של המרחב החיצוני שלכם. מסגרת האלומיניום הדקה, היציבה ועמידה בפני גורמים אטמוספריים, קלה להזזה. המנורה אלגנטית ופונקציונלית, עם נקודת אור מרכזית גבוהה, מושלמת להוספת אור ואופי לכל סוג של מרחב חיצוני.",
    "image_url": "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/main.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/8.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/7.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/6.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/5.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/4.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/3.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/2.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Arc lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-arc-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 21624,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Lantern H120": {
    "description": "הלנתר CleoSoft Alu H120, כמו שאר הפנסים באוסף, מתאפיין באיזון בין נפח ומידות. ביום, העיצוב הנצחי שלו משדרג כל סגנון של מיקום, בעוד שבלילה האורות הרכים שלו משמחים את האווירה כדי ליהנות מרגע נינוח מחוץ לזמן.",
    "image_url": "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/main.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/8.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/7.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/6.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/5.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/4.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/3.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/2.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H120/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-lantern-h120/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 16837,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Lantern H90": {
    "description": "עששית CleoSoft Alu H.90 מכבדת במלואה את הטעם של כל הקולקציה. הקווים הגיאומטריים והמוגדרים היטב של מסגרת האלומיניום יוצרים עיצוב על-זמני המעניק נגיעה סגנונית נוספת לחלל החיצוני של המגורים שלכם.",
    "image_url": "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/main.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/8.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/7.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/6.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/5.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/4.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/3.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/2.jpg",
      "../upload_images/Talenti/Lamp/CleoSoft-Alu Lantern H90/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-lantern-h90/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 10955,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral lamp H125": {
    "description": "מנורת הקורל H125 היא רהיט מושלם לעיצוב חלל המגורים החיצוני שלכם, בשילוב עם שאר המודולים מאותה קולקציה. המסגרת מאלומיניום מכוסה בחבל ימי סינתטי, שהוא החוט המנחה של כל הקולקציה, מבטאת תחושת קלילות כלפי החלק העליון.",
    "image_url": "../upload_images/Talenti/Lamp/Coral lamp H125/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Coral lamp H125/main.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/10.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/9.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/8.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/7.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/6.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/5.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/4.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/3.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/2.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H125/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-lamp-h125/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 15145,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral lamp H45": {
    "description": "מנורת הקורל H45 היא פריט ריהוט שתוכנן להיות מותאם בצורה מושלמת עם המודולים של אותו הקו. מסגרת האלומיניום, המכוסה בחבל סינתטי, חוט המחבר של כל הקולקציה, מבטאת תחושת קלילות כללית.",
    "image_url": "../upload_images/Talenti/Lamp/Coral lamp H45/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Coral lamp H45/main.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/10.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/9.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/8.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/7.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/6.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/5.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/4.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/3.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/2.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H45/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-lamp-h45/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 13687,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral lamp H95": {
    "description": "מנורת הקורל H95 היא המוצר האידיאלי להתאמה עם המודולים של אותה קולקציה. החבל הסינתטי, החוט המשותף של כל הקולקציה, מכסה את המבנה האלומיניום ונותן תחושת קלילות כלפי מעלה.",
    "image_url": "../upload_images/Talenti/Lamp/Coral lamp H95/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Coral lamp H95/main.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/10.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/9.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/8.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/7.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/6.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/5.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/4.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/3.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/2.jpg",
      "../upload_images/Talenti/Lamp/Coral lamp H95/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-lamp-h95/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 27131,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Jackie Floor Lamp": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Jackie Floor Lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/main.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/18.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/17.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/16.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/15.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/14.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/13.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/12.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/11.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/10.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/9.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/8.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/7.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/6.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/5.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/4.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/3.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/2.jpg",
      "../upload_images/Talenti/Lamp/Jackie Floor Lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-floor-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 25379,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Jackie Lamp big": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Jackie Lamp big/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Jackie Lamp big/main.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/19.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/18.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/17.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/16.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/15.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/14.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/13.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/12.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/11.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/10.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/9.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/8.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/7.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/6.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/5.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/4.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/3.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/2.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp big/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-lamp-big/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 19671,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Jackie Lamp small": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Jackie Lamp small/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Jackie Lamp small/main.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/19.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/18.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/17.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/16.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/15.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/14.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/13.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/12.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/11.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/10.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/9.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/8.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/7.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/6.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/5.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/4.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/3.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/2.jpg",
      "../upload_images/Talenti/Lamp/Jackie Lamp small/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-lamp-small/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 12739,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Kukà Big lamp": {
    "description": "מנורת ה-Big Kukà היא רהיט עשוי מחומרים ידידותיים לסביבה ומתאפיינת בעיצוב שניתן להתאים לכל סגנון וסביבה. הבסיס ממחקרילאט של המנורה הנטענת מפזר את האור ותומך באלמנט עגול עשוי שרף.",
    "image_url": "../upload_images/Talenti/Lamp/Kukà Big lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Kukà Big lamp/main.jpg",
      "../upload_images/Talenti/Lamp/Kukà Big lamp/8.jpg",
      "../upload_images/Talenti/Lamp/Kukà Big lamp/7.jpg",
      "../upload_images/Talenti/Lamp/Kukà Big lamp/6.jpg",
      "../upload_images/Talenti/Lamp/Kukà Big lamp/5.jpg",
      "../upload_images/Talenti/Lamp/Kukà Big lamp/4.jpg",
      "../upload_images/Talenti/Lamp/Kukà Big lamp/3.jpg",
      "../upload_images/Talenti/Lamp/Kukà Big lamp/2.jpg",
      "../upload_images/Talenti/Lamp/Kukà Big lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/kuka-big-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 11663,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Kukà Medium Lamp": {
    "description": "מנורת ה-Kukà בגודל בינוני היא אביזר ריהוט עשוי מחומרים ידידותיים לסביבה ומאופיינת בעיצוב שיכול להשתלב עם כל סגנון וסביבה. בסיס המתאקרילט של המנורה הנטענת מפיץ את האור ותומך באלמנט עגול משרף.",
    "image_url": "../upload_images/Talenti/Lamp/Kukà Medium Lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/main.jpg",
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/8.jpg",
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/7.jpg",
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/6.jpg",
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/5.jpg",
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/4.jpg",
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/3.jpg",
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/2.jpg",
      "../upload_images/Talenti/Lamp/Kukà Medium Lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/kuka-medium-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 28172,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Kukà Small Lamp": {
    "description": "מנורת ה-Kukà הקטנה היא המנורה הקטנה ביותר באוסף. מדובר בפריט ריהוט העשוי מחומרים ידידותיים לסביבה ומתאפיין בעיצוב שניתן להתאים לכל סגנון וסביבה. בסיס המתאקרילט של המנורה הנטענת מפזר את האור ותומך באלמנט עגול משרף.",
    "image_url": "../upload_images/Talenti/Lamp/Kukà Small Lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/main.jpg",
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/8.jpg",
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/7.jpg",
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/6.jpg",
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/5.jpg",
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/4.jpg",
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/3.jpg",
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/2.jpg",
      "../upload_images/Talenti/Lamp/Kukà Small Lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/kuka-small-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 25870,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Malè H190 Lamp": {
    "description": "מנורת הרצפה H190 Malè כוללת מסגרת מנירוסטה מכוסה בפלסטיק שקוף שמתאים לשאר האלמנטים של האוסף.",
    "image_url": "../upload_images/Talenti/Lamp/Malè H190 Lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/main.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/10.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/9.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/8.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/7.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/6.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/5.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/4.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/3.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/2.jpg",
      "../upload_images/Talenti/Lamp/Malè H190 Lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/male-h190-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 17601,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Malè H90 lamp": {
    "description": "מנורת הרצפה Malè H90 בעלת מסגרת נירוסטה המכוסה בפלסטיק שקוף המשתלבת בצורה מושלמת עם שאר האלמנטים באוסף.",
    "image_url": "../upload_images/Talenti/Lamp/Malè H90 lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Malè H90 lamp/main.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/10.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/9.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/8.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/7.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/6.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/5.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/4.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/3.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/2.jpg",
      "../upload_images/Talenti/Lamp/Malè H90 lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/male-h90-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 23150,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tod Lamp": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Tod Lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Tod Lamp/main.jpg",
      "../upload_images/Talenti/Lamp/Tod Lamp/5.jpg",
      "../upload_images/Talenti/Lamp/Tod Lamp/4.jpg",
      "../upload_images/Talenti/Lamp/Tod Lamp/3.jpg",
      "../upload_images/Talenti/Lamp/Tod Lamp/2.jpg",
      "../upload_images/Talenti/Lamp/Tod Lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tod-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 24670,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tofee Lamp": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Tofee Lamp/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Tofee Lamp/main.jpg",
      "../upload_images/Talenti/Lamp/Tofee Lamp/6.jpg",
      "../upload_images/Talenti/Lamp/Tofee Lamp/5.jpg",
      "../upload_images/Talenti/Lamp/Tofee Lamp/4.jpg",
      "../upload_images/Talenti/Lamp/Tofee Lamp/3.jpg",
      "../upload_images/Talenti/Lamp/Tofee Lamp/2.jpg",
      "../upload_images/Talenti/Lamp/Tofee Lamp/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tofee-lamp/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 18616,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tribal Big": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Tribal Big/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Tribal Big/main.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/12.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/11.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/10.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/9.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/8.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/7.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/6.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/5.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/4.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/3.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/2.jpg",
      "../upload_images/Talenti/Lamp/Tribal Big/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tribal-big/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 16878,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tribal Celin": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Tribal Celin/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Tribal Celin/main.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/12.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/11.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/10.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/9.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/8.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/7.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/6.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/5.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/4.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/3.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/2.jpg",
      "../upload_images/Talenti/Lamp/Tribal Celin/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tribal-celin/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 14627,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tribal Medium": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Tribal Medium/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Tribal Medium/main.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/12.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/11.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/10.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/9.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/8.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/7.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/6.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/5.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/4.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/3.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/2.jpg",
      "../upload_images/Talenti/Lamp/Tribal Medium/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tribal-medium/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 17657,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tribal Small": {
    "description": "",
    "image_url": "../upload_images/Talenti/Lamp/Tribal Small/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Lamp/Tribal Small/main.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/12.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/11.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/10.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/9.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/8.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/7.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/6.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/5.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/4.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/3.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/2.jpg",
      "../upload_images/Talenti/Lamp/Tribal Small/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tribal-small-en/",
    "company_name": "Talenti",
    "original_category": "Lamp",
    "price": 17624,
    "filter_category": "תאורת פנים וחוץ",
    "placement": "Outdoor"
  },
  "Abel Living armchair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Living Armchair/Abel Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Abel Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/abel-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 17938,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Adam Living armchair": {
    "description": "עם מושבו הגדול, כורסת ההתעמלות מסדרת אדם אידיאלית לרגע של הרפיה במרחב החיצוני שלך. המבנה מאלומיניום והמושב מבד הופכים את המוצר לא רק לנוח, אלא גם לעמיד בפני פגעי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Living Armchair/Adam Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Adam Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Adam Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Adam Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Adam Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Adam Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Adam Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Adam Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Adam Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/adam-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 24348,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Alabama-Alu Living Armchair": {
    "description": "המאפיין המתוחכם של העיצוב האיטלקי והאצילות של המסורת האומנותית מאפיינים את כיסא הזריחה החיצוני Alabama Alu. בזכות המושב הנוח והגודל הצנוע, הוא יכול לספק כל צורך של מרחב וסגנון, תוך יצירת אלכימיה מושלמת עם ההקשר הסובב. המבנה עשוי אלומיניום מצופה באבקה ומשטח עליון של משענות הידיים והמשענת עשוי מעץ טיק. רצועות אלסטיות סינתטיות המיועדות למרחבים חיצוניים תומכות במושב ובמשענת. הכריות עשויות מבד נשלף, קל לכביסה ועמיד בפני מזג האוויר. ריפוד ספוג המאפשר ייבוש מהיר.",
    "image_url": "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-alu-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 18740,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Alabama-Alu Rocking Chair": {
    "description": "זה קל לטבוע ברגעים נעימים של הרפיה בעודך מתנדנד בכורסת הנדנדה של אלבמה אלו. התוצאה של עבודה מורכבת וקפדנית כולה בעבודת יד, כורסת הנדנדה מתבלטת בעיצוב האיטלקי המתקדם שלה ובאצילות של מסורת האומנות. המבנה עשוי מאלומיניום בציפוי אבקה וחלק עליון של משענות הידיים ומשענת הגב עשויים עץ טיק. רצועות סינתטיות אלסטיות המיועדות במיוחד לשימוש חיצוני תומכות במושב ובמשענת הגב. הכריות עשויות מבד נשלף, קל לכיבוס ועמיד בתנאי מזג אוויר. המילוי בכריות הוא ספוג המתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Alu Rocking Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-alu-rocking-chair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 20522,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Alabama-Wood Living Armchair": {
    "description": "בזכות המושב הנוח והקומפקטיות שלו, כיסא היד מעץ \"ליווינג אלבמה\" מצליח לענות על כל צורך במרחב, ולהשתלב בצורה הרמונית עם החוץ הודות לשימוש בעץ אירוקו במבנה. \nכריות הבד ומילוי הקצף שמתייבש במהירות מאפשרים מקסימום נוחות בשימוש במוצר בסלון החיצוני שלכם, והאטימות והרכות של הצורות מעניקים לו נוחות ואמינות.",
    "image_url": "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Alabama-Wood Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-wood-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 12956,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Allure Lounge Armchair": {
    "description": "כיסא הטרקלין allure הוא שילוב אלגנטי של גיאומטריה, המעניק קלילות וסטייל. המבנה מפלדה ועור אקולוגי מועשר בגימורים מעץ. הקו הרך של הכריות משלים את העיצוב של כיסא הזרועות, ונותן אישיות לסביבה החיצונית.",
    "image_url": "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/16.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 19287,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Allure Lounge Armchair hight backrest": {
    "description": "כיסא הטרקלין אלור מתאפיין בגב גבוה מאוד ובהיעדר משענות יד, מה שהופך אותו לנוח ואלגנטי. הקו הרך של הכריות משלים את עיצוב הכיסא, ומעניק אופי לסביבה החיצונית.",
    "image_url": "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/main.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/16.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/15.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/14.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/13.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/12.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/11.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/10.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/9.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/8.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/7.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/6.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/5.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/4.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/3.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/2.jpg",
      "../upload_images/Talenti/Living Armchair/Allure Lounge Armchair hight backrest/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-lounge-armchair-hight-backrest/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 10806,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Argo-Alu Lounge armchair": {
    "description": "המחקר האסתטי המעולה שבוצע על ידי לודוביקה ורוברטו פלומבה מוצא את הביטוי המרבי שלו בכיסא הטרקלין של קו ארגו אלו. המבנה העוטף והיציב מאלומיניום משולב עם הנוחות והמרופדים המפוארים של הכריות, מה שהופך את הרהיט הזה למושלם לבילוי רגעים מרגיעים ונעימים במרחב המגורים החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Alu Lounge armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 18889,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Argo-Wood Living armchair": {
    "description": "כיסא העבודה ארגו הוא פריט ריהוט אידיאלי ליצירת שילובים אלגנטיים וטבעיים באזור החיצוני שלך. כריות הישיבה, בעלות נפחים גדולים ופסלים, מועשרות במרקמים הנועזים והעקביים של הבדים הנבחרים, ובהתאמה מושלמת לשריכת החבלים הכפולה העוטפת את המסעד ומשענות היד.",
    "image_url": "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Argo-Wood Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 19662,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Casilda Living Armchair": {
    "description": "כורסה חיה של קאסילדה נובעת, כמו כל הקולקציה, מרעיון הפרוק של רהיטים קלאסיים מבלי לוותר על אלגנטיות עכשווית. השלד, דק וקליל, מדגיש את המרכיבים המרופדים ומקנה אלמנט תעשייתי מעודן. הגיאומטריה של שלדת הפלדה האל-חלד ושל חגורות הפוליאסטר מהווה ניגוד לכריות הרכות שמבטיחות ישיבה נעימה ונוחה. שלדת הפלדה האל-חלד מצופה באבקה. המושבים והמשענות נתמכים על ידי חגורות פוליאסטר נוסחאות במיוחד לשימוש חוץ. כריות עם כיסויים נשלפים שקל לכבס ועמידים בפני מזג אוויר. ריפוד עם קצף שמתייבש מהר. חיפויי הידיות זמינים בעץ אירוקו, אבן עץ, טראוורטין טיטניום או טראוורטין כסף בהתאם לשילוב הצבעים הנבחר.",
    "image_url": "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Casilda Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 20431,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Living Armchair": {
    "description": "כיסא החוץ קליאוסופט אלומיניום הוא אלמנט בעל אופי נוקשה וגיאומטרי המוצע לצד אביזרים נוספים בסגנון גמיש יותר של כסאות הטרקלין. המבנה עשוי מאלומיניום בציפוי אבקה והכריות מבד נשלף, קל לניקוי ועמיד בפני תנאי מזג האוויר. ריפוד מקצף מתייבש מהר.",
    "image_url": "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 13508,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Lounge Armchair": {
    "description": "כיסא הטרקלין החיצוני CleoSoft Alu מציע מושב גמיש ונוח. הוא מתמזג בצורה מושלמת עם אלמנטים חיים מאותו צורה עגולה או לאלה הגיאומטריים והנפחיים יותר. המבנה עשוי מאלומיניום מצופה אבקה, הכריות מבד נשלף, קל לכביסה ועמיד בפני מזג האוויר. ריפוד קצף שמתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Lounge Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 22934,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Rocking Chair": {
    "description": "רכותו של CleoSoft Alu מתאפיינת באלגנטיות רבה בכורסה המתנדנדת שעיצב מרקו אקרביס בשילוב עם אלמנטים חיים יותר גאומטריים בחיפוש אחר איזון מושלם בין צורה ונפח. המבנה עשוי אלומיניום בציפוי אבקה והכריות עשויות מבד נשלף, קל לכביסה ועמידות לתנאי מזג האוויר. ריפוד מספוג שמתייבש מהר.",
    "image_url": "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/main.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/12.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/11.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/10.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/9.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/8.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/7.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/6.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/5.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/4.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/3.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/2.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Alu Rocking Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-rocking-chair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 18337,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Living armchair": {
    "description": "נפח, צורה ואיזון הם שלוש התכונות העיקריות של הכורסה החיה מקולקציית CleoSoft Wood. הצורות הגיאומטריות של משענת הגב ומשענות הידיים, יחד עם כריות רכות ונוחות מרופדות בבדים איכותיים, הופכות את רהיט זה לאידיאלי לכל חלל חיצוני.",
    "image_url": "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 15152,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Lounge Armchair": {
    "description": "כורסאת הטרקלין החיצונית CleoSoft Wood מאופיינת במושב גמיש ונוח. תואמת לחלוטין למודולים המעגליים האחרים של הקולקציה, וניתנת לשילוב עם המודולים הגאומטריים והנפחיים יותר. הכריות, מרופדות בקצף יבוש מהיר, נתמכות על ידי מסגרת עץ. הכיסויים הנשלפים קלים לכביסה ועמידים למזג האוויר.",
    "image_url": "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Lounge Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 16204,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Rocking chair": {
    "description": "כיסא הנדנדה מעץ של CleoSoft בולט באלגנטיות הרבה וברכות שלו, שהן מרכיבים מרכזיים בכל הקולקציה. רהיט זה תוכנן על ידי מרקו אצרביס כדי להשתלב עם המודולים הגיאומטריים של אותה סדרה, במטרה להגיע לאיזון מושלם בין צורות ונפחים. המבנה עשוי מעץ והכריות, הממולאות בקצף שמתייבש במהירות, כוללות כיסויים נשלפים, שהם קלים לכביסה ועמידים בפני גורמי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/main.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/17.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/16.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/15.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/14.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/13.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/12.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/11.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/10.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/9.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/8.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/7.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/6.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/5.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/4.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/3.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/2.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Rocking chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-rocking-chair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 21164,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Swing chair": {
    "description": "כיסא הנדנדה מקולקציית CleoSoft Wood הוא חלק ממרכיבי העיצוב המארחים והמזמינים, אשר מאזנים את האלמנטים הגדולים יותר כמו הספה המודולרית וספת השלושה מושבים. המושב מזכיר את הצורה של כיסא הטרקלין, ויוצר המשכיות משמחת ומשחקית של סגנון עליז. המבנה מעץ תומך בכרית, מרופדת בקצף מתייבש מהר.",
    "image_url": "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/main.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/12.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/11.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/10.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/9.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/8.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/7.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/6.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/5.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/4.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/3.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/2.jpg",
      "../upload_images/Talenti/Living Armchair/CleoSoft-Wood Swing chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-swing-chair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 16440,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cliff Dèco Lounge armchair": {
    "description": "כורסאת הטרקלין קליף דקו, רכה ומחבקת, מרשימה לעין. משענת הגב הגדולה, שמסגרת האלומיניום שלה מכוסה בחבל ימי סינתטי, יוצרת משחקי אור כתוצאה מצורות הגיאומטריות של החבל הקלוע. מושלמת לקישוט אזור החוץ שלכם הודות לחומרים בהם נעשה שימוש, היא מתאפיינת בריפודים עם קצף המתייבש במהירות ובבדים עמידים בפני תנאי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Dèco Lounge armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-deco-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 29906,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cliff Fabric lounge armchair": {
    "description": "כיסא הטרקלין קליף מאופיין במושב מרופד, נוח וגדול, שהופך אותו לרהיט מודרני ורב-שימושי היכול לשדרג את הסביבה החיצונית שבה הוא ממוקם.\nהכריות, מרופדות בקצף ייבוש מהיר, בעלות כיסויים נשלפים, קלות לניקוי ועמידות בפני מזג האוויר. הריפוד מורכב מבדים עמידים למים אשר עוצבו ויוצרו במיוחד לשימוש חיצוני.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Fabric lounge armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-fabric-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 16986,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cliff Living Armchair": {
    "description": "הכורסה המפורטת נתמכת על ידי מבנה פלדה עם כבלים קלועים, סימן מובהק לאלמנטים של אוסף זה. הכרית הדקה היא האלמנט השובר שמנוגד לכריות הרחבות האחרות של האוסף, שמקיפות את הרעיון של עליזות ומגוון שהמעצבים רצו לבטא עם קליף.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 19766,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cliff Lounge Armchair backrest rope": {
    "description": "כיסא הטרקלין המדופן חבל של קליף עוצב לשימוש חיצוני כדי להתאים לספה המודולרית של טאלנטי, לשולחנות, לכיסאות האוכל ולמיטות השיזוף מאותה הקולקציה. משענת הגב ומשענות הידיים, העשויות חבל ימי שזור, משולבות בכריות מרופדות עם כיסויים מבד נשלף, מה שמוסיף נגיעה סופר-גלאמורית.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/10.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Lounge Armchair backrest rope/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-lounge-armchair-backrest-rope/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 11913,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cliff Swing Chair": {
    "description": "כיסא הנדנדה \"The Cliff\" הוא המוצר האידיאלי להתאמה אישית של אזור החוץ שלך. האלמנטים המרכזיים של הקולקציה, כגון חבל ימי סינתטי המכסה את משענת הגב והמשענות, משולבים עם הצורה החדשה של המוצר. תנועת הנדנדה נתמכת על ידי חבלים שמחוברים ישירות לבסיס, והמסגרת מאלומיניום מבטיחה יציבות לכיסא. הכרית הנוחה לישיבה, הממולאת בקצף שמתייבש במהירות, מכוסה בבד עמיד למזג האוויר.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cliff Swing Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-swing-chair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 11969,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Coral Living armchair": {
    "description": "הכיסא הרחב והנוח של כורסת המגורים \"קורל\" מנוגד לחוסן של מסגרת האלומיניום ושל משענות הידיים. הכיסא זמין בצבעים שונים ומכוסה בחבל סינתטי ימי. הכריות המרופדות בנדיבות בקצף מהיר ייבוש ומרופדות בבדים עמידים בפני מזג אוויר הופכות את כורסת המגורים הזו למושלמת להשלמת הריהוט החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Living Armchair/Coral Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 29646,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Coral Lounge Armchair": {
    "description": "כיסא הטרקלין Coral, בהשראת המודולריות המאפיינת את כל הקולקציה, כולל מושב רחב ונדיב, אידיאלי להעשרת אזור המגורים החיצוני שלכם. הבדים הנועזים והעשירים, בניגוד לקווים הברורים והחיוניים של המסגרת, מרפדים את הכריות. הרגליים המיוחדות והחבלים הסינתטיים הארוגים סביב הידיות מוסיפים יופי למוצר כולו. הריפוד המרהיב בטכנולוגיית Quick Dry Foam כולל כיסויים נשלפים, קלים לכביסה ועמידים בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Lounge Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-lounge-harmchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 20433,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Coral Rope lounge armchair": {
    "description": "כיסא הטרקלין קורל כולל מושב רחב ונוח, מושלם להרגעתכם בחלל החיצוני שלכם. מסגרת האלומיניום, משענת הגב והידיות מחבלים סינתטיים משולבים עם כריות מרופדות בבדים איכותיים, מה שהופך את כיסא הטרקלין הזה לאלמנט המושלם להשלמת ריהוט החוץ שלכם.",
    "image_url": "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Coral Rope lounge armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-rope-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 22470,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cottage Living Armchair": {
    "description": "כיסא הזרועות החיצוני מקולקציית \"קוטג'\" מזכיר את המערב הרחוק, שם מושבים רחבים ומשענות גב גבוהות הוצבו במרפסת של החווה וברנצ'ות.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 11728,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cottage Living armchair luxury": {
    "description": "מאופיין במראה קליל, כורסת היוקרה בסגנון קוטג' בעלת מבנה קל אך מוצק. משענות הידיים מכוסות חבל ימי סינתטי והכריות הנוחות מרופדות בקצף המתייבש במהירות. המסגרת מאלומיניום מבטיחה יציבות למוצר יחד עם השימוש ברצועות האלסטיות. הממדים הגדולים שלה והעיצוב שלה מושלמים לעיצוב אזורי החוץ שלך.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Living armchair luxury/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-living-armchair-luxury/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 16415,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cottage Lounge Armchair": {
    "description": "כיסא הנוח החיצוני של קולקציית קוטג' מושפע ממרפסת החווה ומחוות, עם משענות גב גבוהות ומושבים רחבים.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cottage Lounge Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 23852,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cruise-Teak Living Armchair": {
    "description": "כיסא הנוח של קולקציית קרוז טיק מאופיין במושב רחב ונוח שהופך להיות שימושי לחלוטין הודות לבד הכריות. הבד, הניתן להסרה, לכביסה ועמיד בפני פגעי מזג האוויר, כמו גם החבלים המשמשים למשענות הידיים והמשענת, גורם למוצר להיות מושלם לסביבה חיצונית. הבסיס, מעץ מלא, יחד עם צבעי הכריות הבהירים, משדרים את הנושא הימי של הקולקציה.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-Teak Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 26849,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Cruise-alu Living Armchair": {
    "description": "כורסא מסדרת השייט של קולקציית אלומיניום מכילה את הגוף לרגע של הרפיה. המושב הגדול, שנעשה מקצף המתייבש במהירות ומכוסה בבד עמיד לתנאי מזג האוויר, נתמך על ידי מבנה אלומיניום. משענת הגב ומשענות הידיים, שיוצרות משחק מהנה של ריק ומלא, מכוסות בחבל ימי סינתטי.",
    "image_url": "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Cruise-alu Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 29435,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Dolcevita Living armchair": {
    "description": "מתאים במיוחד לאזור הרפיה, כורסת Dolcevita משדרת את העליזות של ערבי קיץ. ידיות המשענת ומשענת הגב מאופיינות באריג צפוף של חוטים שמדגיש את מרקם העץ. רהיט זה מתאים לסביבות חוץ ומעניק נגיעה של רעננות ומסתגל בקלות לסגנונות שונים בזכות הצבעים הרבים בהם הוא זמין.",
    "image_url": "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 22348,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Dolcevita Lounge armchair": {
    "description": "כיסא הטרקלין דולצ'ויטה מעורר את הקסם המרגיע של ערב קיץ. מבנה העץ טיק הוא יציב ואלגנטי, הגב והישיבה מועשרים במרקם עבה של חבלים. כל פרט מוסיף רעננות וקלילות, ומקרין בכל רחבי הגן. פתרון מעודן לשדרוג כל מרחב מחיה חיצוני.",
    "image_url": "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Dolcevita Lounge armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 27410,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Ever Living Chair": {
    "description": "כורסאת ה-Living Ever היא חגיגה של פשטות מעודנת. הקווים הנקיים של המבנה העשוי עץ מלא משתלבים עם הרכות העגולה של הכריות, מה שהופך את החללים החיצוניים לנוחים ואלגנטיים בו זמנית. מגוון הצבעים הנייטרליים הזמינים לכורסא הזו מעניקים נגיעה של טבעיות אותנטית וקסם על-זמני לחללי המגורים החיצוניים.",
    "image_url": "../upload_images/Talenti/Living Armchair/Ever Living Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Ever Living Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ever-living-chair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 21288,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Frame Living armchair": {
    "description": "הישיבה הרחבה והנוחה של כורסת המסגרת אידיאלית לקבל את פניכם ברגעי רוגע. המסגרת מאלומיניום בצינור עם הקווים הרכים והמעוגלים משתלבת בצורה מושלמת עם הכריות הנוחות ושילוב חבל המרופד על מסעדי הידיים והגב: כורסה זו היא המרכז של עיצוב חוץ על־זמני.",
    "image_url": "../upload_images/Talenti/Living Armchair/Frame Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Frame Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/frame-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 27451,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "George Living armchair": {
    "description": "כורסה החיה מקולקציית ג'ורג' היא כורסה מסתובבת שמסתובבת 360° על עצמה. הצורה העגולה והנוחה של המושב מוקפת בעמודי נירוסטה והיא עטופה ברצועות קלות ריפוד, שילוב שמאפיין את כל קולקציית ג'ורג'.",
    "image_url": "../upload_images/Talenti/Living Armchair/George Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/George Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/George Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 12246,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "George Lounge armchair": {
    "description": "כיסא הטרקלין ג'ורג' משלב את האלגנטיות של צורתו עם הנוחות של מוצר מתקפל. החבלים שמסמנים את המושב ואת משענת הגב משתלבים בצורה מושלמת במהלך התנועה הקיפולית. המבנה המוצק מנירוסטה הופך אותו לאידיאלי לרגיעה באוויר הפתוח.",
    "image_url": "../upload_images/Talenti/Living Armchair/George Lounge armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/George Lounge armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 12636,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Jackie Living Armchair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/20.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/19.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/18.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/17.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/16.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Jackie Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 26566,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Karen Living Armchair": {
    "description": "כורסה החיה של קולקציית קארן מתאפיינת באסתטיקה אומנותית המזכירה את אפריקה ואת יופיין של ארצותיה. משענות הידיים הטבעתיות והקווים המעוגלים של הגב שמקיפים את המושב, מעניקים לכורסה את המלכותיות של כס מלכות. מרקם הבדים והחוטים הרבים שתומכים בגב, מחקים את העיצוב של פקעת מגן, שמעניק לגינה אווירה אינטימית ומרגיעה.",
    "image_url": "../upload_images/Talenti/Living Armchair/Karen Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Karen Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 19106,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Key Living Armchair": {
    "description": "הצורה משלבת בתבונה קווים מעוקלים ואלכסוניים ליצירת קליעה ייחודית. המבנה עשוי מאלומיניום, משענת הגב עשויה מחבלים והמושב מטקסטילן.",
    "image_url": "../upload_images/Talenti/Living Armchair/Key Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Key Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/key-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 12956,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Lady Pouf": {
    "description": "מבנה אלומיניום חזק ותמיכת טקסטילן נוחה, הפוף של קולקציית ליידי הוא אביזר מושלם לחלל חוץ מודרני ואלגנטי. הצורה המרובעת של המוצר תואמת לקונספט של הקולקציה ומשתלבת בצורה מושלמת עם מוצרים נוספים מקולקציית ליידי.",
    "image_url": "../upload_images/Talenti/Living Armchair/Lady Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Lady Pouf/main.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Pouf/8.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Pouf/7.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Pouf/6.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Pouf/5.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Pouf/4.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Pouf/3.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Pouf/2.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lady-pouf/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 11634,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Lady Reclinable Armchair": {
    "description": "קל משקל, קל לנשיאה וניתן לערימה, כורסת השכיבה של קולקציית ליידי הופכת למוצר המושלם לכל חלל חיצוני. האלומיניום של המבנה והטקסטילן של המושב הופכים אותה לנוחה ויציבה. משענת הגב המתכווננת מבטיחה נוחות מרבית בכל עת, ומוסיפה אלגנטיות ופונקציונאליות לאזור מגורים חיצוני מושלם.",
    "image_url": "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Lady Reclinable Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lady-reclinable-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 29531,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Lake Living Armchair": {
    "description": "כיסא הכורסה מהאוסף של \"Lake\" מעניק לסביבת החוץ אלגנטיות ומקוריות בזכות העיצוב המיוחד של המסגרת, שמסוגר בהשראת צמח הבמבוק. המבנה עשוי מודולים של אלומיניום בצורת צינוריים, שמתחברים זה לזה באמצעות חיבור יצוק מעניין. החיבור מזכיר את הטבעות הנוקשות אך גם מעוקלות שמאפיינות את קנה הבמבוק.",
    "image_url": "../upload_images/Talenti/Living Armchair/Lake Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Lake Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 26456,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Leaf Living armchair": {
    "description": "כיסא המגורים ליף מאופיין במסגרת אלומיניום אלגנטית וקלה בשילוב עם כריות רכות וחושניות מאוד. המושב הנוח שלו יהיה מושלם לבלות ימים יפים או ערבי קיץ ארוכים בישיבה נוחה תחת שמיים מלאי כוכבים.\nכיסא המגורים הזה הוא המוצר האידיאלי להבליט את החלל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Living Armchair/Leaf Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/20.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/19.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/18.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/17.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/16.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 10503,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Leaf Lounge Armchair": {
    "description": "הקלילות של הקווים והעיצוב האלגנטי הם המרכיבים המרכזיים באוסף Leaf ובכורסה שמתאימה למנוחה. מסגרת האלומיניום והאיכות הגבוהה של הבדים המשמשים לריפוד הכריות הרכות הופכים את כורסת המנוחה של Leaf למתאימה לסביבה טבעית ומודרנית. \nהכריות הממולאות בספוג שמתייבש במהירות מרופדות בבד עמיד בפני פגעי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/19.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/18.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/17.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/16.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Leaf Lounge Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 11582,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Malè Living armchair": {
    "description": "הכורסה הנוחה Malè ממשיכה את הקווים האלגנטיים והקלילים המאפיינים את כל הקולקציה. המסגרת החזקה והעמידה מפלדה תומכת במושב פלסטיק רחב.\nהבחירה הקפדנית בחומרים עמידים בפני מזג האוויר וקלים לניקוי משולבת במוצר פרקטי וישר, מושלם לחלל החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Living Armchair/Malè Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Malè Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/male-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 11665,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Milo Living Armchair": {
    "description": "כיסא המילאוי של אוסף מילו לחיים בחוץ תוכנן עם אותה תשומת לב לפרטים שמאפיינת חייט. הכיסא גמיש אך גם קשיח, מאוזן בצבע, מודרני אך על זמני. מסגרת מאלומיניום מצופה באבקה, ריפוד טקסטילן וכריות. כריות ניתנות להסרה, קלה לכביסה ועמידה במזג האוויר. ריפוד קצף שמתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Living Armchair/Milo Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Milo Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 17913,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Moon-Alu Living Armchair": {
    "description": "המשענות הגב הארוכות והמחודדות של הכורסאות והספה מזכירות את צורת הסהר. וה\"Moon\" (ירח) הייתה בהשראת הירח ממש.",
    "image_url": "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 27716,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Moon-Alu Swing Armchair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Alu Swing Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-swing-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 24788,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Moon-Teak Living Armchair": {
    "description": "המשענות הארוכות והמחודדות של כורסאות הסלון והספה מזכירות את צורת החצי-סהר. והשם 'Moon' (ירח) הושפע באופן ישיר מהירח.",
    "image_url": "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Moon-Teak Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 15989,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Nova Living armchair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Living Armchair/Nova Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Nova Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Nova Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Nova Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Nova Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Nova Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Nova Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Nova Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nova-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 17936,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Nunù Living armchair": {
    "description": "",
    "image_url": "../upload_images/Talenti/Living Armchair/Nunù Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Nunù Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nunu-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 14360,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Oliver  lounge Armchair": {
    "description": "בעל מסגרת עץ מאסיבית וכריות חמות, כיסא הלונג' אוליבר מעביר תחושת נוחות וביטחון. היופי הטבעי של גרעיני הטיק משולב עם הלובן העוטף של הכריות הלבנות. העיצוב הוא קומפוזיציה מורכבת שמתחלפת בין מלא לריק בצורה רציפה אחת. התוצאה היא עיצוב סולידי ומעודן, המושלם לשדרוג הגינה והמרחבים החיצוניים עם משיכה טבעית אמיתית.",
    "image_url": "../upload_images/Talenti/Living Armchair/Oliver  lounge Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Oliver  lounge Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Oliver  lounge Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Oliver  lounge Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Oliver  lounge Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Oliver  lounge Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Oliver  lounge Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Oliver  lounge Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/oliver-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 21970,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Panama Berger Armrest": {
    "description": "כיסא הברגר פנמה עם משענות יד מתבלט בזכות העיצוב הנוח והפונקציונלי שלו. המבנה מאלומיניום משודרג בשזירה של חבלים ימיים העמידים בפני תנאי מזג האוויר. כיסא הברגר פנמה מושלם לרגעי הרפיה באוויר הפתוח, ויוצר נווה מדבר של נוחות וסטייל. הכריות עם בדים 100% חיצוניים, הזמינות במגוון צבעים, משלימות את הרהיט, ומעניקות לו אישיות ואלגנטיות.",
    "image_url": "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/main.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/20.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/19.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/18.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/17.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/16.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/15.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/14.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/13.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/12.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/11.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/10.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/9.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/8.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/7.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/6.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/5.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/4.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/3.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/2.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Berger Armrest/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-berger-armrest/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 14519,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Panama Egg chair with base": {
    "description": "הכיסא בצורת ביצה עם בסיס מסתובב מקולקציית פנמה מעניק תחושת אלגנטיות ונוחות חזקה למרחב המחיה החיצוני שלכם. המבנה מאלומיניום מכוסה בחבלים קלועים וכריות קצף מהירות, מספקים נוחות ונעימות ליהנות מרגעים נעימים של רגיעה בחוץ, תוך יצירת משחק אור וצל מרהיבים. הכיסא בצורת ביצה עם בסיס מסתובב הוא אלמנט ריהוט המותאם באופן מושלם לקווי הרהיטים החיצוניים המוצעים על ידי טלנטי.",
    "image_url": "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/main.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/20.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/19.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/18.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/17.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/16.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/15.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/14.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/13.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/12.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/11.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/10.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/9.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/8.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/7.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/6.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/5.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/4.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/3.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/2.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with base/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-egg-chair-with-base/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 20318,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Panama Egg chair with structure": {
    "description": "כיסא הביצה בצורת ביצה של פנמה עם מבנה מושעה הוא האלמנט המושלם להשלמת שטח המגורים החיצוני שלכם. המבנה מאלומיניום מכוסה בחבלים קלועים, המושב הרחב והנוח עם הכריות הגבוהות והרכות והבדים היקרים הזמינים בצבעים שונים הופכים את כיסא הביצה המושעה לאלמנט האידיאלי לכל חלל חיצוני.\nהאימפקט החזותי החזק בשילוב עם נוחות המושב והאפקט המרגיע הופכים את האלמנט הזה למושלם להנאה מרגעי רגיעה בחוץ.",
    "image_url": "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/main.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/20.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/19.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/18.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/17.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/16.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/15.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/14.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/13.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/12.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/11.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/10.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/9.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/8.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/7.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/6.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/5.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/4.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/3.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/2.jpg",
      "../upload_images/Talenti/Living Armchair/Panama Egg chair with structure/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-egg-chair-with-frame/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 26539,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Panama living Armchair": {
    "description": "כורסאת Living מקולקציית Panama מתגלה כמוצר קומפקטי ומעוצב. מבנה האלומיניום, מוצק אך קל, משמש כבסיס לזהר של חבלי ניילון סינתטיים ימייים, שמתאימים לרהיטי חוץ. הקווים הקלים והמעוגלים של הכורסא אינם מוותרים על פונקציונליות שכן היא קלה לערימה.",
    "image_url": "../upload_images/Talenti/Living Armchair/Panama living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/17.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/16.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 28519,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Panama living relax Armchair": {
    "description": "עגול ומקיף, מבנה כורסאת Living Relax מ- Panama Collection נועד לתמוך ולחבוק את הגוף. עם אלומיניום וחבלים סינתטיים לנאוטיקה, המוצר אידיאלי לריהוט חוץ, גם בזכות הצבעים השונים הזמינים. ריפודים (אופציה), התואמים את הצבעים השונים, עושים כל רגע אפילו יותר מרגיע. הפונקציונליות לא מוותרת על עיצוב הכורסא, בהשראת הצורות הרכות של הטבע.",
    "image_url": "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Panama living relax Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-living-relax-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 13681,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Panama lounge Armchair": {
    "description": "כיסא נוח פנמה מתוכנן לחבק את כל הגוף לרגע של רגיעה. נוח ופונקציונלי, הוא מתבלט בזכות הישיבה הנמוכה שלו, הנתמכת על ידי מבנה מאלומיניום, מכוסה באריג של חבלים סינתטיים מספנות. בזכות החומרים העמידים בפני מזג האוויר, כיסא הנוח אידיאלי לריהוט חוץ ומזכיר את צורות הטבע עם הקווים הרכים שלו.",
    "image_url": "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/16.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/15.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Panama lounge Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-lounge-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 23518,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Prichi Armchair living room": {
    "description": "כיסא המגורים Prichi מביא תחושת נוחות ורוגע האופייניים לסביבה פנימית וחיצונית. מבנה הטיק מקיף את המושב הנוח, ומציג שלוב מתוחכם של חבלים המעניקים לסלון החיצוני שלווה ואלגנטיות. הרכב המורכב הזה מסוגל לשלב את יופיו של הטבע עם עיצוב מודרני, כדי להעניק לגינתך סגנון מתוחכם ונעים, אופייני לסלון אנגלי.",
    "image_url": "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/main.jpg",
      "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/7.jpg",
      "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/6.jpg",
      "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/5.jpg",
      "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/4.jpg",
      "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/3.jpg",
      "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/2.jpg",
      "../upload_images/Talenti/Living Armchair/Prichi Armchair living room/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/prichi-armchair-living-room/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 12928,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Riviera Director lounge chair": {
    "description": "המרכיבים המרכזיים של האוסף, אלגנטיות ותשומת לב לפרטים, נראים בבירור בכורסה של חדר המנהלים הזה. המסגרת האלומיניום המעוצבת בעדינות, הגימור העור התומך במשענת הגב והטקסטורות הבולטות שנבחרו לכריות משתלבות במוצר המעודן הזה שמתאים בקלות למגוון מקומות. העיצוב המתוחכם שלו משתלב היטב עם הפונקציונליות של מוצר שתוכנן במיוחד עבור חללים חיצוניים.",
    "image_url": "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Director lounge chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-director-lounge-chair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 29979,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Riviera Living armchair": {
    "description": "כיסא הזריחה ריביירה, עם מושבו הרחב והעמוק, הוא הבחירה האידיאלית לקבל את גופך ברגע של רוגע. מסגרת האלומיניום, הקלה והאלגנטית, מדגישה את הנפח הנדיב של הכריות, המועשרות על ידי הטקסטורה הנועזת של הבדים שנבחרו. ידיות הגרס משלימות את הכיסא, ומוסיפות נגיעה מעודנת לכל הקולקציה: זהו הרהיט המושלם לשדרוג סגנון אזור המגורים החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Living Armchair/Riviera Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Riviera Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 11245,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Salinas Living Armchair": {
    "description": "כיסא הזרוע מהקולקציה של סלינס מתאפיין בעיצוב אלגנטי שבו הרכיב הטקסטילי הוא הבולט ביותר. השימוש ברצועה המרופדת יוצר משחק קומפוזיציוני שמקשט את פרטי המתכת ומדגיש את הקווים הרכים של הכריות. בזכות הסגנון המעודן, הוא מוסיף קסם לסביבת החוץ.",
    "image_url": "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Salinas Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 12235,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Slam Living armchair": {
    "description": "הכורסה של אוסף Slam לחיים בחוץ מתבלטת בזכות האופי הפשוט והליניארי שלה, והיא מוצעת כהשלמה לריהוט הגן שלך. המבנה מאלומיניום מכוסה בבד ומלווים בכריות רכות שמזכירות את כל מרכיבי האוסף.",
    "image_url": "../upload_images/Talenti/Living Armchair/Slam Living armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Slam Living armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 28521,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Slam-Rope Living Armchair": {
    "description": "כיסא הזרועות מהקולקציה Slam // Rope משתלב בסביבה החיצונית באלגנטיות ובקלילות, הודות לעיצוב המינימלי עם הקווים הנקיים, מה שהופך אותו למתאים לכל סביבה חיצונית. הגימורים מחבל סינתטי שזור והכריות הנשלפות והניתנות לכביסה משלבים סגנון ונוחות עבור סלון שניתן להשתמש בו לאורך זמן.",
    "image_url": "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Slam-Rope Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-rope-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 23295,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Step Living Armchair": {
    "description": "עם צורותיו הדינמיות והייחודיות, כורסת הישיבה של סטפ משלימה את אזור המגורים החיצוני בסגנון טלנטי מלא. הקשר בין הקלות של המושב והמשענת הופך את המוצר למעניין, תכונה לא שכיחה שמאפיינת את האוסף. המבנה כולו עשוי מאלומיניום בעוד שהכריות וריפודי משענות היד והגב עשויים מטקסטילן נושם. עמיד בפני פגעי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Living Armchair/Step Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Step Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/step-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 13741,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Swipe Armchair living room": {
    "description": "מתאים בצורה מושלמת לאזור מרגיע, כורסת הסלון \"סווייפ\" מציעה נוחות מרבית בזכות הכריות המפנקות שלה. ידיות המשענת ומשענת הגב מעוצבות בחבל מרופד ארוג בצורת גיאומטרית, המביע אופי ודינמיות. השימוש באלומיניום למבנה אינו מונע משילוב האלמנטים להתפתח בהעדר מוחלט של נוקשות ולהציע לסלון החיצוני שלכם אישיות וקצב ויזואלי.",
    "image_url": "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/main.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/14.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/13.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/12.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/11.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/10.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/9.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/8.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/7.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/6.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/5.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/4.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/3.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/2.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Armchair living room/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-armchair-living-room/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 26880,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Swipe Swivel armchair": {
    "description": "כיסא סווייפס סלילי הוא שובב ונוח, מושלם ליהנות מרגעים מרגיעים בגינה. מבנה האלומיניום מחבק את המושב המאפיין על ידי כריות רכות ונדיבות. מיתרים מרופדים שזורים עם קצב גיאומטרי ודינמי מסביב לאלומיניום הצינורי, מעניקים לגב ולמשענות הידיים נוחות נוספת. פתרון עיצובי שמעצים את חדר המגורים החיצוני עם קלילות ואישיות.",
    "image_url": "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Swipe Swivel armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-swivel-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 23062,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Touch Living Armchair": {
    "description": "בהתאם לקונספט של האוסף, כורסת הליווינג משתלבת בהרמוניה עם סגנון החוץ של Touch. המסגרת עשויה מאלומיניום והמושב עשוי מטקסטילן.",
    "image_url": "../upload_images/Talenti/Living Armchair/Touch Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/14.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/13.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 21738,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Touch Pouf": {
    "description": "הפוף, עם מבנה אלומיניום ומושב מסוג טקסטילן, מפתיע בשל האלמנטים הפשוטים אך המורכבים שלו. הצורה והחומרים מאפשרים שימוש מלא במרחבים חיצוניים.",
    "image_url": "../upload_images/Talenti/Living Armchair/Touch Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Touch Pouf/main.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/14.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/13.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/12.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/11.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/10.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/9.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/8.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/7.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/6.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/5.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/4.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/3.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/2.jpg",
      "../upload_images/Talenti/Living Armchair/Touch Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-pouf/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 10923,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Tressé Living Armchair": {
    "description": "מהחקר של הקובייה כצורה ראשונית, נובע העיצוב המתקדם של כורסת הטראסה (Tressè). רצועות העור האקולוגי השזור שמקיפות את היקף המושב הן המאפיין המובהק של רהיט זה, שמעביר תחושה מרגיעה של נוחות ויציבות. הכריות הרכות והמרשימות מודגשות על ידי הגימורים המעודנים ומבנה האלומיניום הצינורי. זמינה בצבעי אפור משי, חום בוץ וסיינה, כורסה זו היא הפתרון המושלם לחוץ הבית לגינתכם או לסלון החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Tressé Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 13442,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Tweet Living Armchair": {
    "description": "הכורסה החיים של קולקציית Tweet, עשויה בטכנולוגיה המודרנית של יציקה סיבובית, מציעה חוויה חדשה בעולם החוץ. העיצוב העכשווי מתאפיין בקווים מעוקלים חלקים, שמעניקים תחושת קבלה ואווירת חברותיות לסביבה החיצונית.",
    "image_url": "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/12.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/11.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Tweet Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tweet-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 23909,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Venice Armchair living": {
    "description": "אידיאלי לאזור מרגיע, כיסא הוונציה המציע נוחות מרבית הודות למושב הרחב וכריות הרכות. משענות היד ומשענת הגב מועשרות במרקמים אלגנטיים המזכירים את הסגנון הימי. רהיט זה משתלב בחן בסביבה החיצונית, בשל העיצוב הצף שלו. בסיס העץ המוצק מעץ טיק ואקויה, יוצר אשליה של ציפה כמו סירה על פני מים, ויוצר אפקט שמעביר קסם וקלילות.",
    "image_url": "../upload_images/Talenti/Living Armchair/Venice Armchair living/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/main.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/13.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/12.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/11.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/10.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/9.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/8.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/7.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/6.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/5.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/4.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/3.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/2.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Armchair living/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-armchair-living/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 18857,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Venice Lounge chair": {
    "description": "כיסא הטרקלין ונציה מושלם להנאה מרגעי רגיעה בגינה. עץ טיק ובדים בצבעים עוטפים מעניקים קסם וקלילות לפריט ריהוט זה שמכבד את העיר הלגונה ההומונית. מסגרת עץ מוצקה מחבקת את המושב הרחב והנוח. הגב שעוטף את הכריות עם קווים רכים מעוטר בחבל קלוע שמזכיר את הסגנון הימי. פתרון נוח ואלגנטי לשדרוג כל אזור מגורים חיצוני.",
    "image_url": "../upload_images/Talenti/Living Armchair/Venice Lounge chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/main.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/10.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/9.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/8.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/7.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/6.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/5.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/4.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/3.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/2.jpg",
      "../upload_images/Talenti/Living Armchair/Venice Lounge chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-lounge-chair/",
    "company_name": "Talenti",
    "original_category": "Living Armchair",
    "price": 18149,
    "filter_category": "כורסאות",
    "placement": "Outdoor"
  },
  "Allure Modular Sofa": {
    "description": "הספה המודולרית החיצונית \"אלור\" מתבלטת בזכות מסגרת עץ מוצקה, הנתמכת על ידי רגלי אלומיניום אלגנטיים. ספה מודרנית הקשורה למסורת. הגיאומטריה הקווית של הכריות, בשילוב עיצוב משענות הידיים, הזמינות בשתי גרסאות, מאפשרות אינספור שילובים, כל אחד עם אופי וסגנון משלו. בזכות המודולריות הבלתי שגרתית, הגיוון בעיצוב והחומרים העמידים, חלל החוץ נראה לא פורמלי אך אלגנטי.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/19.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Allure Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 10277,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu Modular sofa": {
    "description": "ישנן מספר אפשרויות שילוב שמציע הספה המודולרית מקולקציית Argo Alu, מה שהופך אותה למוצר המושלם ליצירת מרחב מחייה חיצוני ייחודי משלך. המחקר האסתטי, חופש ההרכבה, המבנה האלומיניום החזק עם הרצועות הגלויות בניגוד לכריות הרכות והמרופדות הופכים את הספה הזו ליצירת ריהוט מושלמת לבלות רגעים מיוחדים של מנוחה באוויר הפתוח.\nהכריות, עם כיסויים נשלפים ומילוי קצף מהיר יבוש, יחד עם הבדים האיכותיים והעמידים במים, מאפשרים לספה המודולרית להיות מתאימה לעיצוב של מקומות חיצוניים רבים.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Alu Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 16092,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Wood Modular Sofa": {
    "description": "השילובים השונים של הספה המודולרית הופכים את ארגו למוצר המושלם לעיצוב חלל חיצוני אידיאלי. הנושא של קופסת העץ, שממנו שואבת ההשראה הקולקציה, מופיע בבירור בכל אפשרות של שילוב ומודגש באמצעות השימוש החדשני בעץ Accoya במבנה. המושב העמוק והמחבק מרופד בבדים שנבחרו בקפידה עם כיסויים נשלפים ועמידים בפני תנאי מזג אוויר. בזכות תכונות אלו, הספה מושלמת לעיצוב מיקומיכם החיצוניים.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Argo-Wood Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 13352,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Casilda Modular Sofa": {
    "description": "ספת קאסילדה המודולרית היא הלב של הקולקציה המובחרת של רמון אסטבה, שנולדה מתוך רעיון הדה-קונסטרוקציה של רהיטים קלאסיים. הקווים הגרפיים הפשוטים של המסגרות משתלבים בצורה מושלמת עם האלמנטים הייחודיים שמגדירים את זהותה, כגון הרצועות של המושבים או השיבוצים של שיש ועץ במשענת היד.\n\nהספה המודולרית מורכבת מ-4 אלמנטים שמאפשרים שילובים רבים שונים על מנת להשיג את ההרמוניה המושלמת של האווירה: מודול מרכזי, פינה, צד שמאלי וצד ימני עם משענת יד. המסגרת מפלדת אל-חלד מצופה בציפוי אבקה. המושבים ומשענות הגב נתמכים על ידי רצועות פוליאסטר שפותחו במיוחד לשימוש חיצוני. הכריות עם כיסויים נשלפים קלים לכביסה ועמידים בפני מזג האוויר. ריפוד קצף שמתייבש במהירות. הלוחות של משענת היד עשויים עץ אירוקו, אולם אבן, טראוורטין טיטניום או טראוורטין כסף בהתאם לשילוב הצבעים שנבחר.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/27.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/26.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/25.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/24.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/23.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/22.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/21.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/20.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/19.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Casilda Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 13610,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Modular Sofa": {
    "description": "ספת החוץ המודולרית CleoSoft Alu היא חלק מהקולקציה שעוצבה על ידי מרקו אסרביס, שבה מבנים נוקשים וגאומטריים מאלומיניום תומכים במושבים מחבקים ומשמעותיים, ויוצרים איזון מושלם בין צורה ונפח. הספה המודולרית מורכבת מ-2 אלמנטים מרובעים ופוף שמאפשרים שילובים רבים כדי להשיג את הצורה המושלמת עבור החלל שלכם: מודול עם משענת גב כפולה שיכול לשמש כמודול ימני, שמאלי או פינתית; מודול עם משענת גב יחידה שבעזרתו תוכלו ליצור את האורכים הרצויים ואלמנט פוף שבעזרתו תוכלו ליצור ספות לונגה. הכריות עשויות מבד, ניתנות להסרה, קלות לכביסה ועמידות בתנאי מזג אוויר. המילוי עשוי מקצף שמתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Alu Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 28445,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Modular sofa": {
    "description": "המבנים הנוקשים והגיאומטריים המאופיינים בקולקציית CleoSoft Wood תומכים במושבים החובקים והחשובים של הספה המודולרית הזו לחוץ, יוצרים איזון מושלם בין צורה ונפח. הספה המודולרית מורכבת משני מודולי קצה מלבניים (שמאל וימין) ושני אלמנטים לשכיבה (שמאל וימין), מה שמאפשר ליצור הרבה שילובים כדי להשיג את הצורה הרצויה למרחב שלך. הכריות עם הכיסויים הנשלפים קלות לכביסה ועמידות בפני גורמים אטמוספיריים. הריפוד עשוי מקצף שמתייבש במהירות. המושבים הגדולים, הרכים והנוחים מושלמים לקשט עם סגנון כל חלל חיצוני.",
    "image_url": "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/19.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/CleoSoft-Wood Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 22595,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Dèco Modular Sofa": {
    "description": "ספת המודולרית Cliff Decò היא מוצר רב-תכליתי, שעוצב כך שניתן להרכיבו בדרכים מגוונות רבות. המבחר הרחב של המודולים שלה, יחד עם המגוון הגדול של הצבעים והחומרים הנבחרים, הופכים אותה למוצר המושלם לריהוט חוץ. המסגרת, עשויה מאלומיניום במלואה, מרופדת בבד עמיד בפני מזג-האוויר. הכריות הנוחות ממולאות בקצף המתייבש במהירות. המשענות, מאלומיניום, מכוסות בחבל סינטטי ימי או בבד, מה שמאפשר לך להתאים את אזורי החוץ שלך. תמיד בהתאם לסגנון האוסף, משענות היד של המודולים עם המשענת בבד מכוסות בחבל.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Dèco Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-deco-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 16623,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cliff Modular Sofa": {
    "description": "הגמישות המוחלטת של אוסף \"קליף\" מגיעה לשיאה בספה המודולרית. המגוון של החומרים והצורות של המודולים השונים הופכים את טווח האפשרויות להרכבה לרחב ביותר. יצירת ההרכב האישי שלך הופכת למשחק מהנה לעשות בזמן שאתה חושב על השטח החיצוני שלך. המודולים בגרסה עם חבלי קליעה כוללים מבנה טובולרי מתכתי בצבע זהה לזה של הכריות והחבל. באלמנטים הבדיים המבנה מוסתר.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/20.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/19.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Cliff Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 12811,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Coral Modular Sofa": {
    "description": "ספת המודולרית קורל מאפשרת ליצור שילובי ספות אלגנטיים ויצירתיים כדי להוסיף אופי למרחב המגורים החיצוני שלכם. הגיאומטריות הנקיות והמאוזנות שמאפיינות את כל האוסף, מדגישות את מסגרת האלומיניום הקלה והמינימליסטית, המשתלבת בצורה מושלמת עם משענת הגב ומשענות הידיים מחבל סינתטי. הכריות, עמידות בפני מזג האוויר ובעלות כיסויים נשלפים, מעשירות את המוצר עם הנפחים השופעים והמקבלים שלהן, כמו גם עם הבדים הנבחרים בקפידה. הכריות הדקורטיביות, הזמינות במגוון רחב של צבעים, מייפות ומרככות את המוצר, והופכות את המרחב החיצוני לאזור מגורים ייחודי.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Coral Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 23438,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-Teak Modular Sofa": {
    "description": "בעלת גמישות יוצאת דופן, ספת המודול מתוך קולקציית קרוז טיק היא מושלמת לעיצוב אזור המגורים החיצוני שלך. המוצר המודולרי לחלוטין שומר על האיכות והסגנון של הקולקציה. המבנה של המודולים עשוי מעץ אמיתי. חבל סינתטי משמש לכיסוי מסעדים ומשענת הגב. הבד של הכריות, שנבחר בקפידה, הופך את הספה לעמידה בפני מזג אוויר. הצבעים הטבעיים והבהירים שמוצעים על ידי הקולקציה הזו, יחד עם השילובים השונים שהמודולים של המוצר מספקים, הופכים את הספה המודולרית לאידיאלית עבור כל סביבה חיצונית.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/21.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/20.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/19.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-Teak Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 15041,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Cruise-alu modular Sofa": {
    "description": "בזכות צורותיו הפשוטות והמוקפדות, האופייניות לקולקציית Cruise Alu, הספה המודולרית מפתיעה בזכות מגוון האפשרויות שהיא מציעה. המוצר בנוי בכמה מצבים אשר מבטיחים יצירת ריהוט חוץ מקורי ומהנה. איכות החומרים המשמשים בו משולבת עם הפונקציונליות והמאפיינים החזקים. מבנה האלומיניום של המודולים נעשה בטכניקת יציקה בלחץ, מה שמעניק לו יציבות. המושב הנוח והרחב עשוי מקצף המתייבש במהירות, מכוסה בבד עמיד לתנאי מזג האוויר. והשונות בצבעי המודולים הופכות את הספה המודולרית לריהוט המושלם להשלמת אזור המחייה שלך.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Cruise-alu modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 19459,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "George Modular sofa": {
    "description": "ספת המודול של אוסף ג'ורג' מייצגת את המוצר המוביל של אוסף הגינה החדש של טלנטי. קלילות הקווים ונוחות המושבים מאוזנים על ידי החוזק ועמידות העמודים מפלדת האל-חלד של המבנה: הם נשארים גלויים מעבר לחבלים הסינתטיים המרופדים קלות המכסים את משענת הגב.\nהשילובים המגוונים המוצעים על ידי ספת המודול של ג'ורג', הבדים שנבחרו בקפידה, הכריות עם כיסויים ניתנים להסרה ועמידים למזג האוויר, הופכים את הספה הזו למוצר המושלם לקישוט החלל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Modular Sofa/George Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/George Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 19861,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Leaf Modular sofa": {
    "description": "הקומבינציות הרבות של ספת הליף המודולרית הופכות אותה לרהיט האידיאלי לקישוט המרחבים החיצוניים שלכם. הקווים הקלים, המרחפים והמעוגלים שלה משפרים את הנוחות ואת הרב-שימושיות שלה. המבנה האלומיניום מבטיח עמידות גבוהה והתנגדות לגורמים אטמוספיריים.\nהחומרים שנבחרו בקפידה עבור המבנה והכריות הופכים את ספת הליף המודולרית למתאימה לריהוט מקומות המוקפים בטבע.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/27.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/26.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/25.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/24.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/23.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/22.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/21.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/20.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/19.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Leaf Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 19111,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Malè Modular sofa": {
    "description": "הספה המודולרית מאלֶה היא המרכיב המרכזי של הקולקציה. מאופיינת בצורות אלגנטיות וגאומטריות, היא זמינה במגוון רחב של מודולים המאפשרים ליצור הרכבים שונים בתוך החלל החיצוני שלכם. המבנה הנמוך מפוליאתילן תומך בריפוד רך ונוח, דבר שהופך את הספה המודולרית למושלמת לרגעי רגיעה נעימים בחוץ.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/21.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/20.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/19.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Malè Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/male-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 25485,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Ocean Modular sofa": {
    "description": "עם הצורות המוצקות והפיסוליות שלו, מערכת הספות המודולרי אושן מציעה אפשרות לעצב את המרחב החיצוני לפי הצרכים שלך. הכריות, הממולאות בקצף המתייבש במהירות, כוללות כיסויים נשלפים, קלים לשטיפה ועמידים בפני מזג האוויר. הבדים הנועזים משולבים בחוכמה עם הנפחים המרשימים והנדיבים של הכריות, מה שהופך את הספה הזו לרהיט על-זמני שמשלב פונקציונליות עם עיצוב מעודן. פלטת הצבעים העשירה מתאימה היטב למודולאריות של החלקים הבודדים, ויוצרת משחקים של גוונים שמייחדים את המוצר הזה כחלק מובהק מהריהוט החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Ocean Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/ocean-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 28343,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Salinas Modular sofa": {
    "description": "הספה המודולרית מקולקציית סַלִינַס מעניקה קסם ועידון לסביבה החיצונית. הודות למרכיב הבד הדומיננטי, היא מציעה רציפות בין פנים לחוץ. הצבעים הטבעיים של האלמנטים השונים של הספה יוצרים טווח צבעים בהשראת אזור סַלִינַס, איביזה. העיצוב הרך של הכריות בשילוב עם פרטים מתכתיים, יוצרים קומפוזיציה מרשימה המבטאת אלגנטיות נצחית.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Salinas Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 10526,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Scacco modular Sofa": {
    "description": "המוצר המוביל של אוסף סקקו הוא הספה המודולרית הייחודית: בעיצוב מושלם בסגנון טאלנטי, היא מתאימה לכל דרישה. מאופיינת בצורות רכות ומעוגלות, היא מציעה מבחר רחב של מודולים. כריות הישיבה, הנשענות על מסגרת האלומיניום, מרופדות בקצף המתייבש במהירות ומכוסות בבדים עמידים בפני פגעי מזג אוויר. משענת הגב מציגה את המרכיב המרכזי של המוצר: שזירה שנוצרה על ידי החבל על מסגרת המתכת בעיצוב דוגמת \"שחמט\". המודולים המרכזיים מאפשרים למקסם את החלל, נותנים הזדמנות ליצור מבנה מעוקל. בזכות המודולים בעלי הצורה הטיפתית, יש למוצר מראה קליל ורך.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Scacco modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/scacco-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 13021,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam Modular sofa": {
    "description": "האלגנטיות של אוסף Slam היא האלמנט המרכזי של הספה המודולרית. האפשרות לשחק עם צורתה מאפשרת לך לשלב את המודולים כרצונך, וליצור ספה מותאמת אישית עבורך, מושלמת לכל סוג של צורך. הצורות הברורות והאורגניות שלה הן אידיאליות לכל סוג של קונטקסט, מבלי להתפשר על הנוחות והסגנון. המסגרת העמידה מאלומיניום מבטיחה את עמידות המוצר והכריות, קלות לכביסה ועם כיסויים נשלפים, אידיאליות ליהנות מהמרחב החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 15204,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Slam-Rope Modular Sofa": {
    "description": "Slam // Rope שֶׁרִיפָּה בְּרוּחַה סוֹפָה מוֹדוּלָרִית מִתְחָסֶרֶת עִם עִיצוּב נָקִי וָאֵלֶגָנטִי. הַקְּוִים הַחוֹשְׁבִּים שֶׁל הַסוֹפָה הַזֹּאת מַעֲבִירִים קַלּוּת וּמִזְרוֹן, אַך מַפְרִשִׁים אוֹתָהּ לַסְּבִיבָה חִיצונית כָּל הַיָּחוֹל. תוֹדָה לִגְמוּרוֹת הַכֶּבֶל הַסִּינְתֶּטִי הָאָרוּג וְהַכָּרִיּוֹת הַנִּתַּנוֹת לְהוֹצִיא וּלְכַבֵּס, סָפָה Slam Rope הִיא הַפִּתְרוֹן הַמֻשְׁלָם לְסָלוֹן שֶׁחַיִּים מָעַל הַזְּמַן בְּלִי לְווַתֵּר עַל נוֹחוּת וְסִגְנוֹן.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Slam-Rope Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-rope-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 12283,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Swipe Modular sofa": {
    "description": "ספת המודולרית Swipe היא שיר הלל לדינמיות הודות לניגוד בין הקווים הרכים של המושבים והגיאומטריות שנוצרות על ידי החוטים המרופדים, המשתלבים מסביב למבנה האלומיניום. הריפוד הנדיב מציע תחושת נוחות נעימה ומשפר את אזור הרגיעה בגינה עם סגנון ואופי. השילובים הרבים האפשריים, בשילוב עם הבחירה הרחבה של הצבעים הזמינים, מאפשרים לרהיט זה להתאים בגמישות לכל חלל חיצוני ולהתאים את המגורים החיצוניים לפי טעמכם.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Swipe Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 13470,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Tressé Modular Sofa": {
    "description": "ספת המודולרית טרסה מושלמת לשיפור המראה, בסגנון ואלגנטיות, של החיים החיצוניים שלכם. הקונספט האסתטי של רהיט מתוחכם זה נובע מלימוד צורת היסוד: הקובייה. זה מאפשר חופש קומפוזיציוני מוחלט בהתאמה אישית של ריהוט החוץ, בזכות הרבה אפשרויות השילוב וגיווני הצבע שנעים מאפור משי קר, דרך טון עמוק ונחוש של בוץ, ועד לבלוט עם האדמה החמה של סיינה. האלמנט המייחד, שמאפיין את כל הקולקציה, הוא מבנה אלומיניום צינורי, המעושר באריגת רצועות עור אקולוגיות בעבודת יד, שמחבקות את הכריות המרשימות, ונותנות תחושת נוחות עמוקה.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Tressé Modular Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 16385,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Venice Modular sofa": {
    "description": "הספה המודולרית ונציה מזכירה את התמונה של סירות המשייטות במעברים הרבים של ונציה, בזכות המושבים הרחבים, הנשענים על בסיסי העץ בעיצוב צף. הכריות מוגדרות בקווים רכים, גב ומסעדות הידיים מצופות בסגנון ימי מלא והבסיסים מעץ טיק ואקויה מזכירים את הגימורים האומנותיים של כלי השייט. השילוב של אלמנטים אלה מעביר תחושת קלילות וקסם שמקרינה לאורך כל הגינה. המבחר הרחב של החומרים וההרכבים המודולריים הרבים שבהם היא זמינה, מאפשרים לך להתאים את ספת ונציה לסלון החיצוני עם גמישות רבה.",
    "image_url": "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/main.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/18.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/17.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/16.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/15.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/14.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/13.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/12.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/11.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/10.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/9.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/8.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/7.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/6.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/5.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/4.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/3.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/2.jpg",
      "../upload_images/Talenti/Modular Sofa/Venice Modular sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-modular-sofa/",
    "company_name": "Talenti",
    "original_category": "Modular Sofa",
    "price": 13841,
    "filter_category": "ספות פנים וחוץ",
    "placement": "Outdoor"
  },
  "Argo-Alu Pouf": {
    "description": "הפוף Argo Alu משתלב בצורה מושלמת עם שאר האלמנטים בקולקציה. המבנה האלומיניום מאופיין ברצועות גלויים היוצרות משחק צבעים מסביב להיקף. הכריות, עם כיסויים נשלפים, ממולאות בקצף המתייבש במהירות ומרופדות בבדים ייעודיים שנועדו לעמוד בתנאי מזג האוויר. אלו הם המאפיינים של רהיט מושלם לעיצוב המרחבים החיצוניים שלכם.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Alu Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 13284,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Argo-Wood Pouf": {
    "description": "הפוף ארגו הוא רהיט אידיאלי להשלמת עיצוב החוץ שלך. הקווים הנקיים והחיוניים של מסגרת העץ יחד עם הצורה הפיסולית של הכרית המרופדת, מדגישים ומשפרים את המראה הגיאומטרי והקפדני של הקולקציה.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Argo-Wood Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 18578,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Casilda Pouf": {
    "description": "הפוף לחוץ מהקולקציה של קסילדה הוא התוספת המושלמת לשילוב עם הספה המודולרית או כורסת הישיבה.\nבדומה לפריטים אחרים בחדר המגורים, הפוף מעוצב עם משחק אלגנטי של ניגוד בין מסגרת קשה וגיאומטרית וכריות רכות וקלות.\nהמסגרת מפלדת אל-חלד מצופה באבקה.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/14.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/13.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Casilda Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 25358,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Pouf Living": {
    "description": "הפוף החיצוני מקולקציית CleoSoft Alu הוא האביזר המושלם עבור הספה המודולרית, הספות והכורסא. כמו שאר מרכיבי הסלון, גם הפוף עוצב במשחק אלגנטי של גיאומטריות פשוטות ואלגנטיות. המבנה עשוי מאלומיניום מצופה אבקה והכריות עשויות בד נשלף, קל לכביסה ועמיד בפני מזג האוויר. הריפוד עשוי מקצף שמתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/CleoSoft-Alu Pouf Living/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-pouf-living-en/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 26629,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Cliff Dèco Pouf": {
    "description": "הפוף הרך קליף דקו נמצא בהרמוניה מושלמת עם סגנון הקולקציה. אידיאלי להשלמת הספה המודולרית שלך, זהו פריט רב תכליתי ומעשי. השלד האלומיניום המוצק מכוסה כולו בכריות מרופדות עם קצף שמתייבש מהר, מרופדות בבד עמיד למזג האוויר.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Dèco Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-deco-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 16795,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Cliff Pouf": {
    "description": "הקימורים הרכים של האוסף הזה ניתנים למציאה בפוף הזה.\nטווח הצבעים של הבד הוא זהה עבור כל האוסף.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cliff Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 19406,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Coral Ottoman": {
    "description": "בהתאם לטעם של קולקציית הקורל, הפוף הוא רהיט אידיאלי להעשיר ולהשלים את ריהוט אזור המנוחה החיצוני שלך. השימוש בחבל הסינתטי הוא סימן ההיכר של המושב ומבטיח תפקודיות למוצר העמיד בפני מזג אוויר ללא פגיעה באלגנטיות של עיצובו.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Ottoman/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-ottoman/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 13037,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Coral Pouf": {
    "description": "הפוף קורל מאפשר לך ליצור שילובים אלגנטיים ויצירתיים של ספות כדי להוסיף אופי לחלל המגורים החיצוני שלך. הכריות, העמידות בפני מזג אוויר ועם כיסויים נשלפים, משדרגות את המוצר עם הנפחים המרווחים והמזמינים שלהן, וכן הבדים שנבחרו בקפידה.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Coral Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Coral Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 13848,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Cottage Pouf": {
    "description": "הפוף החיצוני משלים את הרוח הכפרית של בית הכפר ביחד עם הספה והכורסאות.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cottage Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 10328,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Cruise-Teak 150×150 Pouf": {
    "description": "הפוף של קולקציית קרוז עץ הטיק אידיאלי להתאמה אישית של ריהוט החוץ. הצורה המרובעת של החלק העליון, המיוצרת בעזרת רצועות סינתטיות אלסטיות, נתמכת על ידי מבנה עץ מוצק ומזכירה את הנושא בהשראת הטבע של הקולקציה.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-Teak 150×150 Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-150x150-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 17834,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Cruise-alu 150×150 Pouf": {
    "description": "טכניקת היציקה המשמשת למבנה האלומיניום של ה-150×150 Pouf מהאוסף Cruise Alu, מעניקה למוצר צורה מושלמת. גדול אך לא מגושם, הפוף מתאים לשימושים רבים אפילו בזכות כריות קצף הנוחות שמתייבשות מהר.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu 150×150 Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-150x150-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 24591,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Cruise-alu Bench": {
    "description": "הספסל של קְרוּז אַלוּ הוא מוצר מקורי ורב-שימושי מאוד. המבנה האלומיניום מאפיין את הסגנון הטיפוסי של האוסף ומתאים למושב נוח עם קצף שמתייבש במהירות. הבד שמכסה את הכריות, עמיד לחלוטין לתנאי מזג האוויר, אידיאלי לריהוט חוץ.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Cruise-alu Bench/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-bench/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 25723,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Frame Pouf": {
    "description": "פוף ה-Frame הוא רהיט אידיאלי לקישוט אזור המגורים החיצוני האלגנטי שלך. החומרים העמידים בפני תנאי מזג האוויר, כמו מסגרת האלומיניום, הריפוד מקצף המתייבש במהירות והכריות עם הציפויים הניתנים להסרה, יחד עם הבדים הניתנים לכביסה, מאפשרים למוצר הזה להיות פריט רב-שימושי שמוסיף אופי וסגנון לאזור המגורים החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Frame Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Frame Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/frame-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 17883,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "George Pouf": {
    "description": "ריפוד נדיב של הפוף ג'ורג' הופך אותו לרהיט המושלם להשלמת הספה המודולרית של אוסף זה.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/George Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/George Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/George Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 12392,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Lake Pouf": {
    "description": "אוסף Pouf of the Lake מתאפיין בעיצוב המקורי של מבנה התמיכה העשוי מאלומיניום, שהוא בהשראת האלגנטיות הטבעית של צמח הבמבוק. המסגרת מורכבת ממודולים צינוריים שמתחברים זה לזה והופכים את המרחב החיצוני למודרני ומקורי.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Lake Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Lake Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 23576,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Malè Pouf": {
    "description": "הפוף הרך דגם Malè הוא רהיט אידיאלי להשלמת הספה המודולרית. אלגנטי ונוח, בעל תשתית פוליאתילן מכוסה במושב גבוה ונוח מרופד בבד עמיד בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Malè Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/17.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/16.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/15.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/14.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/13.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Malè Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/male-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 22471,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Milo Bench": {
    "description": "אותו קו ואותה תשומת לב לפרטים הנמצאים בשולחן האוכל נמצאים גם בספסל מילו העשוי מאלומיניום בציפוי אבקה.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Milo Bench/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Milo Bench/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-bench/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 27664,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Panama Pouf": {
    "description": "בהתאם לכל מוצרי קולקציית פנמה, הפוף נראה אידיאלי להשלמת אזור הגינה. מיוצר בצבעים שונים, עם מבנה אלומיניום וחלק עליון מחבלי ניילון סינתטיים, הוא מבטיח עיצוב ופונקציונליות בזכות עמידותו לתנאי מזג האוויר ויכולת הערמה.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Panama Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/16.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/15.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/14.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/13.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Panama Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 12135,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Riviera Ottoman": {
    "description": "מסגרת הפוף הזה נוצרת משילוב של תרכובות אלומיניום שונות, אשר נבחרו במיוחד על מנת לשפר את היציבות, הפרקטיות ועמידות המוצר בפני תנאי מזג האוויר. ריפוד הקצף המתייבש במהירות מאפשר לך להשתמש בו במגוון מצבים בחוץ.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Riviera Ottoman/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-ottoman/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 28462,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Salinas Bench": {
    "description": "ספסל סלינס מתאפיין בעיצוב מעודן המעורר את האווירה של האי, שממנו נלקחה ההשראה לכל הקולקציה. צבעי החול והים של סלינס, באיביזה, מדגישים את הבדים ומעניקים קסם לסביבה החיצונית. פרטי המתכת היקרים נחשפים על ידי הרצועה שהופכת לאלמנט עיצובי.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Salinas Bench/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-bench/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 16017,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Salinas Bench with armrests": {
    "description": "הספסל מקולקציית סלינס מבטא אלגנטיות ועידון דרך משחק צבעים מתוחכם שנוצר על ידי בדים, רצועות ופרטי מתכת יוקרתיים. צבעי החול והים של סלינס, באיביזה, מעניקים לסביבה החיצונית קסם נצחי.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Bench with armrests/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-bench-with-armrests/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 12039,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Salinas Pouf": {
    "description": "הפוף סלינאס מבטא את העידון האופייני לעולם הפנימי החוצה, בזכות קו הבד הרך ועיצוב הרצועות האלגנטי. פלטת הצבעים המורכבת מעוררת את צבעי האזור הטבעי של סלינאס, באיביזה, ומביאה איתה קסם נצחי.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Salinas Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/salinas-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 24738,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Scacco round Pouf": {
    "description": "אוסף הפופים העגולים של סקקו אידיאלי להשלמת ריהוט חוץ. כריות הקצף המתייבשות במהירות ובד העמיד בפני מזג האוויר שמכסה אותן משדרים את הסגנון העגול והרך של כל האוסף.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco round Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/scacco-round-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 21051,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Scacco square Pouf": {
    "description": "רחב ופונקציונלי, הפוף המרובע מקולקציית Sacco רך בחומריו ויציב במבנהו. בסיס האלומיניום תומך בכריות קצף מתייבשות במהירות, המכוסות בבד עמיד לחלוטין בפני מזג אוויר, מה שהופך את הפוף לאידיאלי להשלמת ריהוט חוץ.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Scacco square Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/scacco-square-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 15537,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Slam Pouf": {
    "description": "פוף ה-Slam מושלם להשלמת עיצוב החוץ, בהתאם לספות של האוסף. הצורות הנקיות והחומרים העמידים תורמים ליצירת פריט חובה. מסגרת האלומיניום וריפוד הקצף המתייבש במהירות של הכריות הם הבחירה הטובה ביותר עבור פריט ריהוט חוץ זה.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Slam Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 23938,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Slam-Rope Pouf": {
    "description": "הסלאם // פוף החבל עם קווים רכים וחיוניים במבנה אלומיניום אלגנטי, הוא פריט ריהוט מושלם להשלמת פינת הישיבה החיצונית שלכם. העיצוב המאוזן והכריות הנשלפות והניתנות לכביסה הופכים את הפוף למתאים לכל הקשר, בלי לוותר על נוחות וסגנון.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Slam-Rope Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-rope-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 18962,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Swipe Pouf": {
    "description": "הפוף מקולקציית Swipe משלים את חדר המגורים החיצוני, מה שהופך אותו לנוח יותר. עיצוב הרהיט הזה מאופיין בקווים רכים. הריפוד נוח ושופע. בזכות מגוון צבעים עשיר, הוא משתלב בגמישות בכל גינה או חלל חיצוני.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Swipe Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 25185,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Tressé Pouf": {
    "description": "טְרֶסֶה עות'מאן מקרין גם יציבות וגם נוחות. העיצוב המתוחכם שלו הוא השילוב של מבנה אלומיניום צינורי קל משקל עם כריות רכות ומרשימות. זמין בגווני אפור משי, בוץ וסיינה, רהיט זה מתאים באלגנטיות לכל אזור חיצוני ופנימי.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Tressé Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 24818,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Venice Pouf": {
    "description": "הפוף מאוסף ונציה הופך את הסביבה החיצונית לנוחה יותר. הכרית עם צורותיה הרכות, נשענת בעדינות על בסיס העץ המוצק, שנראה כאילו מרחף בזכות המקוריות של עיצובו. פריט ריהוט פרקטי שמעניק לסלון החיצוני ולגן אווירה של אלגנטיות.",
    "image_url": "../upload_images/Talenti/Pouf and Bench/Venice Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/main.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/12.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/11.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/10.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/9.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/8.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/7.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/6.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/5.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/4.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/3.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/2.jpg",
      "../upload_images/Talenti/Pouf and Bench/Venice Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-pouf/",
    "company_name": "Talenti",
    "original_category": "Pouf and Bench",
    "price": 29252,
    "filter_category": "הדומים וספסלים",
    "placement": "Outdoor"
  },
  "Alabama-Alu Sunbed": {
    "description": "",
    "image_url": "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Alabama-Alu Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/alabama-alu-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 26691,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Allure Sunbed": {
    "description": "כיסא השיזוף מקולקציית Allure, משלב אלגנטיות ומודרניות הודות לסגנון גאומטרי עם קווים רכים. מסגרת העץ משולבת בחן עם ריפוד הבד. צבעי החומרים הטבעיים מדגישים את האופי המודרני והבלתי פורמלי של כיסא השיזוף, שמרהט את הגן עם אישיות.",
    "image_url": "../upload_images/Talenti/Relax/Allure Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Allure Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Allure Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/allure-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 21219,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Argo-Alu Sunbed": {
    "description": "מיטת השיזוף Argo Alu מאופיינת בכריות מרופדות ונוחות ובמסגרת אלומיניום מוצקה המכוסה ברצועות אלסטיות, בהתאמה מושלמת עם שאר אלמנטים של הקולקציה. \nהכריות, מרופדות בכיסויים נשלפים ועמידים למזג אוויר, יחד עם האיכות הגבוהה של הבדים, זמינים במגוון רחב של צבעים, ומשענת הגב הניתנת להטיה הופכים את מיטת השיזוף Argo Alu למושלמת להנאה מרגעי רוגע באוויר הפתוח.",
    "image_url": "../upload_images/Talenti/Relax/Argo-Alu Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/14.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Argo-Alu Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-alu-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 16154,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Argo-Wood Sunbed": {
    "description": "כריות גדולות ומרקמים צפופים מאפיינים את מיטת השמש ארגו. הבד העוטף את המבנה נתמך ברגליים חיוניות וקו ישר עשויות מעץ אקויה: תרגישו מרחפים באוויר.\nמושלם לרגעי מנוחה בחוץ, הבדים המשומשים עמידים לחלוטין בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Relax/Argo-Wood Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Argo-Wood Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/argo-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 21226,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Breez Sunbed": {
    "description": "מיטת השיזוף Breez נולדה בזכות השילוב בין הכישרון היצירתי של קארים ראשיד לבין המסורת הארטיזנית של תוצרת איטליה. פשטות וניקיון משולבים עם נוחות ואלגנטיות מעניקים חיים לאובייקט של עיצוב טהור, המתאים לריהוט חלל החוץ שלכם בצורה אקסקלוסיבית. מיטת השיזוף Breez עשויה מפלדה שעברה תהליכי טיפול בננו-קרמיקה, קתאפורה ואבק. היא זמינה בשני צבעים: לבן ו-Taupe. הכריות עשויות מבד לבן ויש להן כיסויים נשלפים, קלים לכביסה ועמידים מאוד בפני גורמים אטמוספיריים.",
    "image_url": "../upload_images/Talenti/Relax/Breez Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Breez Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Breez Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Breez Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Breez Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Breez Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Breez Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Breez Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Breez Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Breez Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/breez-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 28362,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Breez2.0 Sunbed": {
    "description": "הכיסא המרגיע Breez 2.0, הוא תוצאה של הגאון היצירתי של קארים ראשיד. זהו רהיט ייחודי. אקסטרווגנטי, אך באותו זמן נוח ואלגנטי, ומתאים להענקת תחושת גלאם ואופנתיות לכל מרחב חיצוני.",
    "image_url": "../upload_images/Talenti/Relax/Breez2.0 Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Breez2.0 Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Breez2.0 Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Breez2.0 Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Breez2.0 Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Breez2.0 Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Breez2.0 Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/breez2-0-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 19732,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Casilda Daybed": {
    "description": "המרכיבים המרכזיים של כל האוסף זורמים אל תוך מיטת השיזוף קסילדה. מסגרת הפלדה בציפוי אבקה נירוסטה בעלת טעם קל ומעודן, בניגוד לנפחים הנדיבים של הכריות: משחק אורות וקווים חדש נוצר. הרצועות האלסטיות המשמשות את משענת הגב והחופה מאפשרות לאור לחדור בעדינות ובאופן טבעי, בעוד שהבדים החמים והעוטפים המשמשים לווילונות מעניקים למוצר מראה אלגנטי ומזמין: זהו הבחירה הטובה ביותר ליהנות מרגע רגיעה בזמנכם הפנוי.",
    "image_url": "../upload_images/Talenti/Relax/Casilda Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Casilda Daybed/main.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/13.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/12.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/11.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/10.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/9.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/8.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/7.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/6.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/5.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/4.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/3.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/2.jpg",
      "../upload_images/Talenti/Relax/Casilda Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 25647,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Casilda Sunbed": {
    "description": "מיטת השיזוף Casilda ניתנת להטיה ולגלגלים. הפשטות של הקווים מדגישה את המדף האופציונלי מעץ איארוקו או אבן. השילוב של אלמנטים שונים עם העץ מוביל למיזוג של קווים אלגנטיים. השלדה מפלדת אל־חלד מצופה באבקה. המושב והגב נתמכים על ידי רצועות פוליאסטר המיועדות לשימוש חיצוני. הכריות עם כיסויים נשלפים שניתן לכבס בקלות ועמידים בפני מזג אוויר. ריפוד מקצף המתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Relax/Casilda Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Casilda Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/14.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Casilda Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/casilda-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 13300,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Daybed": {
    "description": "גם מיטת השמש הכפולה CleoSoft Alu וגם מיטת היום, יוצרים תחושת רוגע מיידית. מסגרת האלומיניום הקלה והגיאומטרית בולטת לעומת הוילונות הצללה הצפופים. המושב הרחב והמקבל פנים נוח מאוד בזכות האפשרות להטות את שתי גב התמיכה בזוויות שונות, לחוויה חיצונית נוחה ומותאמת אישית. האלגנטיות של הבדים שנבחרו אינה מתפשרת על הפונקציונליות, בזכות השימוש בסיבים עמידים למזג אוויר ופדינגים מקצף המתייבשים במהירות ועם כיסויי כריות נשלפים.",
    "image_url": "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/main.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/13.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/12.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/11.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/10.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/9.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/8.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/7.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/6.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/5.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/4.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/3.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/2.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-daybed-2/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 17921,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Double Sunbed": {
    "description": "",
    "image_url": "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/14.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Double Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-double-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 25950,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "CleoSoft-Alu Sunbed": {
    "description": "מיטת הגן CleoSoft Alu מזכירה את הקווים הגיאומטריים של האלמנטים החיים והמרשימים שמרכיבים את האוסף. המבנה עשוי מאלומיניום מצופה באבקה והמשענת מתכווננת. למיטה יש גלגלים וניתן לערום אותה. הכריות נשלפות, קלות לכביסה ועמידות בפני מזג האוויר. מרופדת בקצף המתייבש במהירות.",
    "image_url": "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Alu Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleo-alu-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 20782,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "CleoSoft-Wood Sunbed": {
    "description": "כיסא השיזוף מעץ CleoSoft מזכיר את הקווים הגיאומטריים של המודולים הנפחיים של האוסף. מאופיין במסגרת עץ, בעל גב נשען, מצויד בגלגלים וניתן לערום אותו. הכריות, מרופדות בקצף שמתייבש במהירות, בעלות כיסויים נשלפים, קלים לשטיפה ועמידים לתנאי מזג האוויר.",
    "image_url": "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/CleoSoft-Wood Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cleosoft-wood-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 22236,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Cliff Sunbed": {
    "description": "המבנה הצינורי העטוף בכבלים קלועים הופך את מיטת השיזוף לאלמנט המאפיין של כל האוסף. הכריות הרכות מזכירות את צורת מושבי הספה ומעצבות סגנון אידיאלי של קליעה.",
    "image_url": "../upload_images/Talenti/Relax/Cliff Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Cliff Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Cliff Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cliff-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 26291,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Coral Daybed": {
    "description": "מיטת השיזוף מהקולקציה קורל מהווה פתרון אלגנטי לשיפור המרחב החיצוני שלכם. הגאומטריות הנקיות והמאוזנות של הכריות, הניתנות להסרה ועומדות בפני מזג אוויר גרוע, יחד עם הפרט של משענת הגב העשויה מחבל סינתטי, מעניקות עידון למיטת השיזוף. הכריות הדקורטיביות, המגיעות במגוון צבעים רחב, נותנות למרחב הגינה מראה אישי ובעל אופי.",
    "image_url": "../upload_images/Talenti/Relax/Coral Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Coral Daybed/main.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/10.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/9.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/8.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/7.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/6.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/5.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/4.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/3.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/2.jpg",
      "../upload_images/Talenti/Relax/Coral Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 14183,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Coral Sunbed": {
    "description": "מיטת השמש קורל, עם הנפחים הניגודיים שלה, מציגה קווי מסגרת אווריריים וקלים בניגוד לכריות רחבות ומוצקות. הידית הקדמית, המכוסה בחבלים סינתטיים בצבע המתאים למסגרת, היא האלמנט המרכזי של הרהיט האלגנטי הזה.",
    "image_url": "../upload_images/Talenti/Relax/Coral Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Coral Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Coral Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Coral Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Coral Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Coral Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Coral Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Coral Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Coral Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Coral Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/coral-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 14994,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Cottage Sunbed": {
    "description": "כיסא השיזוף עם גלגלים מקו הקוטג' מזכיר את המערב הפרוע ובו בזמן עכשווי כמו כל שאר הפריטים באותה אוסף.",
    "image_url": "../upload_images/Talenti/Relax/Cottage Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Cottage Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Cottage Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cottage-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 22750,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Cruise-Teak Sunbed": {
    "description": "מיטת השיזוף קרוז טיק מאופיינת במבנה עץ שלם. גלגלי הגב הגדולים מזכירים את הסגנון הימי והטבעי של אוסף היוקרה הזה. הכריות, עם כיסויים נשלפים, מרופדות בקצף המתייבש במהירות, ומשלבות את הפונקציונליות של רהיט חוץ עם העיצוב המעודן של מוצר נצחי, המועשר בבדים שנבחרו בקפידה.",
    "image_url": "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Cruise-Teak Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-teak-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 26095,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Cruise-alu Sunbed": {
    "description": "השימוש במסגרת אלומיניום מעניק למיטת השיזוף Cruise Alu מראה עכשווי וקליל, המשולב עם הטקסטורת הנועזות והמוערכות של הבדים הנבחרים. החומרים העמידים במזג האוויר יחד עם ריפוד הקצף המתייבש במהירות מעניקים למיטת השיזוף Cruise Alu נופך יוקרתי ובלעדי לחלל החיים החיצוני שלך.\n",
    "image_url": "../upload_images/Talenti/Relax/Cruise-alu Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Cruise-alu Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/cruise-alu-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 25888,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Dolcevita Sunbed": {
    "description": "מיטת השיזוף דולצ'וויטה היא ביטוי של סגנון שמוסיף רעננות וקלילות לכל סביבה חיצונית. האריגה המעודנת של חבלים ארוגים היא האלמנט הדומיננטי של המיטה, שמעניק את התחושות המתוקות של ערב קיץ חמים. המבנה העשוי מעץ מוצק הוא פשוט בעיצובו אך מוקפד בפרטים. השילוב המושלם של אלמנטים אלו מעורר רגעים של רגיעה בלתי נשכחים שאפשר לבלות בגינה או ליד הבריכה.",
    "image_url": "../upload_images/Talenti/Relax/Dolcevita Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Dolcevita Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/dolcevita-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 20644,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "George Daybed": {
    "description": "מיטת השיזוף ג'ורג' משלבת את כל האלמנטים החשובים שמאפיינים את הקולקציה: העמודים מנירוסטה, הרצועות המרופדות שמכסות את המסגרת והמושב הרך והמרופד שמתאים במיוחד לרגעי הרפיה בחוץ. \nהמגוון הרחב של הצבעים הזמינים מאפשר למיטת השיזוף ג'ורג' להתאים לכל חלל חיצוני.",
    "image_url": "../upload_images/Talenti/Relax/George Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/George Daybed/main.jpg",
      "../upload_images/Talenti/Relax/George Daybed/11.jpg",
      "../upload_images/Talenti/Relax/George Daybed/10.jpg",
      "../upload_images/Talenti/Relax/George Daybed/9.jpg",
      "../upload_images/Talenti/Relax/George Daybed/8.jpg",
      "../upload_images/Talenti/Relax/George Daybed/7.jpg",
      "../upload_images/Talenti/Relax/George Daybed/6.jpg",
      "../upload_images/Talenti/Relax/George Daybed/5.jpg",
      "../upload_images/Talenti/Relax/George Daybed/4.jpg",
      "../upload_images/Talenti/Relax/George Daybed/3.jpg",
      "../upload_images/Talenti/Relax/George Daybed/2.jpg",
      "../upload_images/Talenti/Relax/George Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 18076,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "George Sunbed": {
    "description": "מיטת השיזוף ג'ורג' משתלבת בצורה מושלמת עם שאר אלמנטים מהאוסף. היא מאופיינת בקורות מנירוסטה, רצועות מרופדות קלועות ומושב נוח, וכריותיה עם כיסויים נשלפים ומרופדות בקצף מהיר ייבוש. הבדים עוצבו במיוחד לשימוש חיצוני, מה שהופך את מיטת השיזוף ג'ורג' לאלמנט אידיאלי להרגעות בחלל החיצוני שלכם.",
    "image_url": "../upload_images/Talenti/Relax/George Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/George Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/George Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/george-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 16194,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Jackie Bean bag": {
    "description": "",
    "image_url": "../upload_images/Talenti/Relax/Jackie Bean bag/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Jackie Bean bag/main.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/19.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/18.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/17.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/16.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/15.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/14.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/13.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/12.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/11.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/10.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/9.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/8.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/7.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/6.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/5.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/4.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/3.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/2.jpg",
      "../upload_images/Talenti/Relax/Jackie Bean bag/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/jackie-bean-bag/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 26543,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Karen Daybed": {
    "description": "הספה של קרן מעניקה לסביבה החיצונית אווירה אינטימית ומרגיעה, בזכות העיצוב בהשראת אפריקה שמזכיר את המראה של קונכיה מגוננת. המלאכה של הגב, הנתמך על ידי אין ספור חוטים שמשולבים בטבעות של המשענות, יוצרת מפגש בין תרבויות. הקווים המעוגלים והעוטפים של הריפוד והבדים של הכריות מקרינים את היופי הייחודי של אדמות אפריקה.",
    "image_url": "../upload_images/Talenti/Relax/Karen Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Karen Daybed/main.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/15.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/14.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/13.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/12.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/11.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/10.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/9.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/8.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/7.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/6.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/5.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/4.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/3.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/2.jpg",
      "../upload_images/Talenti/Relax/Karen Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 26810,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Karen Sunbed": {
    "description": "הלול של קארן מעניק תחושת שלווה הודות לקווים המעוגלים של הריפוד והבדים העוטפים, המעלים בזיכרון את היופי הייחודי של ארצות אפריקה, מקור ההשראה של כל הקולקציה. מושלם להענקת אופיו האמנותי לאזור הרוגע בגינה.",
    "image_url": "../upload_images/Talenti/Relax/Karen Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Karen Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Karen Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/karen-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 26983,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Lady Reclinable Sunbed": {
    "description": "איחוד של צורות גמישות ונוקשות יוצר את מיטת השיזוף של אוסף הליידי. אלגנטית ונוחה, זוהי פינה מושלמת ובלתי נמנעת בכל צד בריכה. משענת הגב המתכווננת מבטיחה הרפיה מרבית ואיכות החומרים, חתומה על ידי טלנטי, מאפשרת הנאה מרבית מהמוצר. האלומיניום עבור המבנה והטקסטילן עבור המושב, מקבלים את כל הגוף, גם בזכות השימוש בשרפרף שניתן להסיר מגוף המרכזי של מיטת השיזוף.",
    "image_url": "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Lady Reclinable Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lady-reclinable-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 28317,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Lake Sunbed": {
    "description": "כיסא השיזוף \"לייק\" מתאפיין בעיצוב מקורי של מסגרת האלומיניום, בהשראת היופי הטבעי והאלגנטי של צמח הבמבוק. המודולים הצינוריים מורכבים מצורות רכות וחינניות שמעניקות לסביבה החיצונית מראה מודרני ומקורי.",
    "image_url": "../upload_images/Talenti/Relax/Lake Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Lake Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Lake Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/lake-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 17943,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Leaf Sunbed": {
    "description": "מודרני ותחושתי, כסא הנוח מקולקציית עלה הוא קריאה ליהנות מרגעי הרפיה בגינה. הריפוד הרך והרכב מונח על מסגרת האלומיניום הקלת משקל, ומציע נוחות ועמידות. בהשראת עולם הטבע, לרהיט זה יש את היכולת לדו-שיח עם הסביבה החיצונית, להשתלב איתה ולהעניק נגיעה של אלגנטיות.",
    "image_url": "../upload_images/Talenti/Relax/Leaf Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Leaf Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/16.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/15.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/14.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Leaf Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/leaf-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 10301,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Milo Deck chair": {
    "description": "כיסא הנוח מילו מאופיין באותו עיצוב מודרני של כל האלמנטים בקולקציה. ניתן לערום אותו בקלות, יש לו מסגרת אלומיניום, משענת גב שנשענת עם מערכת החלקה ספציפית ומושב נוח. כיסא הנוח מילו הוא רהיט אידיאלי להשלמת החלל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Relax/Milo Deck chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Milo Deck chair/main.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/10.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/9.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/8.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/7.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/6.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/5.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/4.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/3.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/2.jpg",
      "../upload_images/Talenti/Relax/Milo Deck chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-deck-chair/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 23429,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Milo Sunbed": {
    "description": "מיטת השיזוף של קו מילו מזכירה את הסגנון הרומנטי של כל הפריטים האחרים באותה קולקציה. ניתן לערום אותה בקלות, יש לה מבנה אלומיניום מצופה באבקה ומושב ומשענת גב הניתנים להטיה באמצעות מערכת החלקה מיוחדת. השמשיה היא אופציונלית.",
    "image_url": "../upload_images/Talenti/Relax/Milo Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Milo Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Milo Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/milo-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 18359,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Moon-Alu Daybed": {
    "description": "הספה הנפתחת, בזכות צורתה החצי-עיגולית, מזכירה את ספת שני המושבים ויש לה את אותה מבנה משענת.\nכרית המושב הרחבה מאפשרת נוחות מלאה.",
    "image_url": "../upload_images/Talenti/Relax/Moon-Alu Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/main.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/10.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/9.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/8.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/7.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/6.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/5.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/4.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/3.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/2.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 17953,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Moon-Alu Sunbed": {
    "description": "הכיסא שיזוף \"הירח\" ניתן להטיה הודות למסגרת מנירוסטה ויש לו גלגלים. המבנה מאלומיניום מכוסה בשזירת חבלים היוצרת את המשענת והמושב.",
    "image_url": "../upload_images/Talenti/Relax/Moon-Alu Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Moon-Alu Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-alu-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 10494,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Moon-Teak Daybed": {
    "description": "\nמיטת השיזוף Moon Teak כוללת את כל האלמנטים המרכזיים של האוסף. המבנה מעץ, עם הקווים האלגנטיים והמעודנים שלו, משלים את הכריות הגבוהות והרכות, ומבטיח מושב נוח. השימוש בחבלים סינתטיים במשענת הגב תואם את הכריות, המורכבות מבדים משובחים ועמידים בפני מזג האוויר, מה שהופך אותה לאלמנט אידיאלי לרגעי הרפיה נעימים.",
    "image_url": "../upload_images/Talenti/Relax/Moon-Teak Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/main.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/11.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/10.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/9.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/8.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/7.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/6.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/5.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/4.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/3.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/2.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 20283,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Moon-Teak Sunbed": {
    "description": "כיסא השיזוף Moon ניתן להטיה בזכות מתקן מנירוסטה ויש לו גלגלים. הקווים הפשוטים מדגישים את העץ הטבעי של מבנה הטיק, הבולט כמו מסגרת מהטקסטילן השחור של המושב.",
    "image_url": "../upload_images/Talenti/Relax/Moon-Teak Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Moon-Teak Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/moon-teak-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 21099,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Nami Sunbed": {
    "description": "קומפקטי ומודרני, נראה הוא המיטה הרב-שימושית שמעשירה כל מרחב מנוחה. בזכות משענת הראש הניידת האיקונית שהופכת למשענת יד אמצעית אלגנטית, הוא מסוגל להתאים למגוון הקשרים ומצבים כדי להבטיח נוחות מרבית. מבחינה אסתטית ופונקציונלית, נראה הוא ייחודי. הבחירה הקפדנית של החומרים, כגון עץ טיק ועיצוב הבדים הופכים אותו לגיבור החיים בחוץ.",
    "image_url": "../upload_images/Talenti/Relax/Nami Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Nami Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Nami Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nami-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 24672,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Nunù Sunbed": {
    "description": "",
    "image_url": "../upload_images/Talenti/Relax/Nunù Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Nunù Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Nunù Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Nunù Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Nunù Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Nunù Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Nunù Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Nunù Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Nunù Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/nunu-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 19523,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Panama Daybed": {
    "description": "גדול ומקיף, הדייבד (Daybed) מאוסף פנמה הוא אידיאלי לריהוט חוץ. עם צורתו הנהדרת, המוצר יציב בזכות האלומיניום המשמש למבנה. המושב מיוצר כולו מחבלים נאוטיים סינתטיים והכרית, רכה ופונקציונלית, מיוצרת מחומרים עמידים בפני מזג אוויר. זמין בצבעים רבים, הדייבד משלים את אזור הרגיעה בגינה או ליד הבריכה.",
    "image_url": "../upload_images/Talenti/Relax/Panama Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Panama Daybed/main.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/17.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/16.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/15.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/14.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/13.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/12.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/11.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/10.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/9.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/8.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/7.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/6.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/5.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/4.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/3.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/2.jpg",
      "../upload_images/Talenti/Relax/Panama Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 27869,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Panama Hammock": {
    "description": "עם הצורה המקורית שלה, קולקציית הערסלים של פנמה מושלמת להתאמה אישית של הגינה שלך. הגדולה אך לא מגושמת, המבנה שלה מתברר קל הודות למבנה האלומיניום ולמושב העשוי מחבלים ימיים סינתטיים. התנועה המתנדנדת מובטחת בזכות החבלים המחוברים בחוזקה למבנה, מה שמבטיח רגע של רגיעה מוחלטת.",
    "image_url": "../upload_images/Talenti/Relax/Panama Hammock/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Panama Hammock/main.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/15.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/14.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/13.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/12.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/11.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/10.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/9.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/8.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/7.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/6.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/5.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/4.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/3.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/2.jpg",
      "../upload_images/Talenti/Relax/Panama Hammock/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-hammock/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 11372,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Panama Rocking Bed": {
    "description": "כמו גלי הים, מיטת התינוק המתנדנדת מהקולקציה של פנמה מעוררת את הזרימה החלקה של המים, הן בצורה והן בפונקציונליות. נִתְּנָהְ לְעַצְמְךָ לְהִיתְּנוֹדֵד עַל יָד הָרוּחַ כְּשֶׁאַתָּה אֲפִיפוֹר בְּקֶרֶנֵי הַשֶּׁמֶשׁ, זו חוויה של הרפיה שאין לה מחיר תוֹדוּת לְיֵסוֹד זֶה, שֶׁמְּצַיֵּר מִשְׂחַקִים מְסַקֶּרִים שֶׁל אוֹר וְצֵלִים בַּגִּינָּה וּבְמִסְתָּרוֹת חוּצוֹת.",
    "image_url": "../upload_images/Talenti/Relax/Panama Rocking Bed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Panama Rocking Bed/main.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/13.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/12.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/11.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/10.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/9.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/8.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/7.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/6.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/5.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/4.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/3.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/2.jpg",
      "../upload_images/Talenti/Relax/Panama Rocking Bed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-rocking-bed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 27798,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Panama Sunbed": {
    "description": "הכיסא השיזוף מאוסף פנמה הוא פשוט ואלגנטי. מבנה האלומיניום המוצק מאכסן מושב רך עשוי מחבלי ניילון סינתטיים, עמידים במים ובתנאי מזג האוויר. אידיאלי לצד הבריכה או לריהוט גן, כיסא השיזוף הופך לפונקציונלי בזכות האפשרות לערום ולאחסן אותו בנוחות.",
    "image_url": "../upload_images/Talenti/Relax/Panama Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Panama Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/19.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/18.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/17.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/16.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/15.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/14.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Panama Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/panama-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 13902,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Reef sunbed": {
    "description": "מיטת השיזוף מקולקציית Reef, שתוכננה על ידי מרקו אצ'רביס, אידיאלית לשיזוף בשטח החיצוני שלכם. קווים נקיים ועגולים וחומר פלסטי עמיד הזמין במגוון צבעים הם המרכיבים המרכזיים של מיטת השיזוף הזו. קלה לניקוי, הודות לכרית הרכה והנוחה שלה היא מושלמת להנאה מרגעי רגיעה ביום שמשי.",
    "image_url": "../upload_images/Talenti/Relax/Reef sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Reef sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/19.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/18.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/17.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/16.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/15.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/14.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Reef sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/reef-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 20670,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Riviera Deck chair": {
    "description": "כיסא החוף ריביירה, העשוי אלומיניום, מדגיש את הסגנון הברור והמתוחכם של המוצר. הצבעים השונים הקיימים, הן למבנה והן למושב, מאפשרים לחלקה לקשט בצורה מכובדת כל סוג של חלל סביבתי.",
    "image_url": "../upload_images/Talenti/Relax/Riviera Deck chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Riviera Deck chair/main.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/10.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/9.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/8.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/7.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/6.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/5.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/4.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/3.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/2.jpg",
      "../upload_images/Talenti/Relax/Riviera Deck chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-deck-chair/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 21936,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Riviera Sunbed": {
    "description": "מיטת השיזוף הזו, מצוידת בגלגלים, מדגישה את העיצוב האלגנטי והלינארי הטיפוסי של כל הקולקציה. הקווים האווריריים והמעוצבים היטב שמאפיינים את מבנה האלומיניום תופסים את העין, בעוד שנפח המינימלי של הכרית, עם כיסויים נשלפים וריפוד קצף מתייבש במהירות, מודגש על ידי האריגה הבולטת והחמה של המרקם הנבחר. עדינה ופונקציונלית, מיטת השיזוף הזו היא מושלמת ליהנות מרגע מרגיע בחוץ.",
    "image_url": "../upload_images/Talenti/Relax/Riviera Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Riviera Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Riviera Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/riviera-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 29280,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Sacco Living Armchair": {
    "description": "כורסאת הסאקו מסדרת Sacco, היא הסינתזה המושלמת בין נוחות לסגנון הייחודי של Talenti. צורתה מספקת נוחות ישיבה גבוהה בעוד צבעי הבדים מעניקים זוהר וחיות לכל חלל חיצוני, בין אם זה על שפת הבריכה או בגינתכם. היא עשויה מבד נושם, נשלף, קל לכביסה ועמיד בפני מזג האוויר. במילוי יש פתיתים של קצף מתייבש מהר וכדורי פוליסטירן. הבד זמין בצבעים הבאים: לבן, כחול, ירוק, טאופ ואפור.",
    "image_url": "../upload_images/Talenti/Relax/Sacco Living Armchair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Sacco Living Armchair/main.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/16.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/15.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/14.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/13.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/12.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/11.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/10.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/9.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/8.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/7.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/6.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/5.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/4.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/3.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/2.jpg",
      "../upload_images/Talenti/Relax/Sacco Living Armchair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/sacco-living-armchair/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 22820,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Sacco Pouf": {
    "description": "הפוף החיצוני מקולקציית Sacco הוא תוספת מושלמת להתאמה עם ספת דו-מושבית וכורסת המגורים. כמו האלמנטים האחרים שבקולקציה, הוא מעניק ניצוץ וחיוניות לכל חלל חיצוני. הוא עשוי מבד נושם, ניתן להסרה, קל לכביסה ועמיד בפני מזג האוויר.",
    "image_url": "../upload_images/Talenti/Relax/Sacco Pouf/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Sacco Pouf/main.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/16.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/15.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/14.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/13.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/12.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/11.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/10.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/9.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/8.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/7.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/6.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/5.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/4.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/3.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/2.jpg",
      "../upload_images/Talenti/Relax/Sacco Pouf/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/sacco-pouf/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 19387,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Sacco Two-seater Sofa": {
    "description": "ספת הדו-מושבית של קולקציית Sacco היא הסינתזה המושלמת בין נוחות וסגנון הייחודי של Talenti.\nהצורה שלה מספקת נוחות ישיבה גבוהה בעוד צבעי הבדים מעניקים ברק וחיוניות לכל חלל חיצוני, לצד הבריכה או בגינה שלך. היא עשויה מבד נושם, ניתן להסרה, קל לכביסה ועמיד בפני מזג האוויר. במילוי יש פתיתי קצף מתייבש מהר וכדורי פוליסטירן. הבד זמין בטונים מונוכרומיים הבאים: לבן, כחול, ירוק, חום אפרפר ואפור. בגרסה הדו-גונית השילובים הם: אפור ואפור מפוספס, ירוק וירוק מפוספס, חום אפרפר וחום אפרפר מפוספס, לבן וכחול מפוספס.",
    "image_url": "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/main.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/10.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/9.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/8.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/7.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/6.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/5.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/4.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/3.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/2.jpg",
      "../upload_images/Talenti/Relax/Sacco Two-seater Sofa/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/sacco-2-seater-sofa/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 18162,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Slam Daybed": {
    "description": "כמו הספה של Slam, בזכות הצורה העגולה שלה, היא מעניקה אלגנטיות ורכות למרחב המחיה החיצוני. על ידי שילוב של עיצוב עכשווי ופרטים קלאסיים, המוצר הזה לא מוותר על חומרים עמידים ופונקציונליים אשר הופכים אותו לרהיט מושלם להרפיה ולחברות. הכריות עם הכיסויים הנשלפים והקלים לכיבוס עוטפות את מבנה הרהיט הרב-שימושי הזה.",
    "image_url": "../upload_images/Talenti/Relax/Slam Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Slam Daybed/main.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/10.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/9.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/8.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/7.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/6.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/5.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/4.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/3.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/2.jpg",
      "../upload_images/Talenti/Relax/Slam Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 10392,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Slam Sunbed": {
    "description": "מיטת השיזוף \"סלאם\" היא המרכז של אזור שיזוף חיצוני אלגנטי. המסגרת הפונקציונלית המורכבת מסגסוגות אלומיניום, יחד עם כריות הנוחות והעמידות, הופכות את מיטת השיזוף הזו למוצר האידיאלי עבור החלל החיצוני שלך.",
    "image_url": "../upload_images/Talenti/Relax/Slam Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Slam Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Slam Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Slam Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Slam Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Slam Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Slam Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Slam Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Slam Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Slam Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 18946,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Slam-Rope Daybed": {
    "description": "הספה מהאוסף Slam // Rope מציעה רגעים של רוגע טהור מבלי לוותר על אלגנטיות. הקווים המעוגלים של משענת הגב, המתעשרים בשזירות בחבל סינתטי ובכריות מבד עמיד למזג האוויר, מעניקים לגינה סגנון ומסתגלים להקשרים מגוונים.",
    "image_url": "../upload_images/Talenti/Relax/Slam-Rope Daybed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/main.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/9.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/8.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/7.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/6.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/5.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/4.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/3.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/2.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Daybed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-rope-daybed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 12125,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Slam-Rope Sunbed": {
    "description": "The Slam // Rope sunbed משלב פונקציונליות ועיצוב באמצעות ריפודים רכים ועמידים למזג אוויר. הצורות החיוניות של רהיט זה מאפשרות לך ליהנות מרגעים של רוגע טהור בסלון שלך, מבלי לוותר על אלגנטיות.",
    "image_url": "../upload_images/Talenti/Relax/Slam-Rope Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Slam-Rope Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/slam-rope-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 28334,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Step Sunbed": {
    "description": "הצורות הרכות של המבנה משקפות את הנוחות של המושב. מיטת השמש מהאוסף של Step היא קלה ואלגנטית, מאופיינת בסגנון שמבדיל את Talenti. אידיאלית לבריכה יוקרתית, היא מוצר מעוצב אך פונקציונלי עם גב מתכוונן על מנת להבטיח נוחות מרבית לאזור החוץ שלך. המבנה כולו עשוי מאלומיניום והמושב והגב עשויים מטקסטילן.",
    "image_url": "../upload_images/Talenti/Relax/Step Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Step Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/16.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/15.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/14.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Step Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/step-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 25820,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Swipe Sunbed": {
    "description": "כיסא הנוח \"סוויפ\" מעביר תחושת קלילות ושובבות המלווים את רגעי ההרפיה בגינה או בצד הבריכה. הריפוד הנדיב מתאפיין בקווים רכים ומעוגלים, המעוררים תחושת נוחות במבט ראשון. אידיאלי לשיפור אזור ההרפיה שלכם, רהיט זה משתנה בתאימות לסביבות חוץ בזכות המגוון הרחב של הצבעים ובחירת הבדים העמידים והחסינים.",
    "image_url": "../upload_images/Talenti/Relax/Swipe Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Swipe Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Swipe Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/swipe-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 11896,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Touch Deck Chair": {
    "description": "כיסא השמש של Touch משלב את החוזק והפשטות של מבנה האלומיניום, עם הצורות הרכות והגליות של המושב הודות להרכב הטקסטילן שלו. העמידות למזג אוויר גרוע והעובדה שהוא מתקפל הופכים את המוצר לשימושי ונוח מאוד.",
    "image_url": "../upload_images/Talenti/Relax/Touch Deck Chair/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Touch Deck Chair/main.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/14.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/13.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/12.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/11.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/10.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/9.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/8.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/7.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/6.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/5.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/4.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/3.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/2.jpg",
      "../upload_images/Talenti/Relax/Touch Deck Chair/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/touch-deck-chair/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 28373,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Tressé Double Sunbed": {
    "description": "המיטה הכפולה מסוג טרסה מושלמת ליצירת אזור מרגיעה בגינה, לחלוק עם זוגות. הכריות הן האלמנט המובחן של הרהיט הזה, המעניק תחושת נוחות. הבד שמכסה את הצורות הרכות של המיטה הכפולה זמין בקנבוס וגרדניה. הודות לצד המשענת, ניתן להתאים כל ראש מיטה לגובה הרצוי, כדי ליהנות מהחיים החיצוניים עם נוחות מרבית.",
    "image_url": "../upload_images/Talenti/Relax/Tressé Double Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/14.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Tressé Double Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-double-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 13390,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Tressé Sunbed": {
    "description": "התינוק טְרֶסֶה, אלגנטי ומשוכלל, הוא הפתרון המושלם להפוך את הסלון החיצוני שלכם לנוח. רהיט זה, אשר עיצובו נועד להעניק רגיעה בלתי רגילה, מתאפיין בכריות מרשימות המצופות בבד המפ עמיד או בבד גרדניה. צד שניתן להטות מאפשר לכם למצוא את התמיכה המושלמת כדי ליהנות מהמרחבים החיצוניים או מהתחום שליד הבריכה.",
    "image_url": "../upload_images/Talenti/Relax/Tressé Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Tressé Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/14.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/13.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/12.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/11.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/10.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Tressé Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/tresse-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 12927,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Venice Double sunbed": {
    "description": "רומנטית כמו העיר שעל שמה נקרא, המיטה הזוגית ונציה אידיאלית לשיתוף רגעי הרפיה בגינה או ליד הבריכה. הכריות עם הקווים הרכים והעיצוב הצף של בסיסי העץ טיק מזכירים את הקלילות של הסירות המשייטות בתעלות הלגונה. הבדים נעימים למגע ובו זמנית עמידים. אלמנט העיצוב הזה מעשיר את הסלון החיצוני, ומעניק נוחות ואלגנטיות לסביבות החוץ.",
    "image_url": "../upload_images/Talenti/Relax/Venice Double sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Venice Double sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Venice Double sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-double-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 28479,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "Venice Sunbed": {
    "description": "מיטת ונציה בהשראת סירות המשייטות במימי ונציה. הכריות, שמונחות על בסיסי עץ עם עיצוב צף, מתבלטות בקווים רכים ובבד נעים למגע ועמיד. בסיסי עץ הטיק מזכירים את הגימורים האומנותיים של הכלים. כל האלמנטים הללו משדרים תחושה של קלילות וקסם שמלווה רגעי מנוחה בגינה או ליד הבריכה.",
    "image_url": "../upload_images/Talenti/Relax/Venice Sunbed/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Relax/Venice Sunbed/main.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/9.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/8.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/7.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/6.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/5.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/4.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/3.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/2.jpg",
      "../upload_images/Talenti/Relax/Venice Sunbed/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/venice-sunbed/",
    "company_name": "Talenti",
    "original_category": "Relax",
    "price": 10871,
    "filter_category": "מיטות שיזוף ומרבצים",
    "placement": "Outdoor"
  },
  "MrX": {
    "description": "מרX הוא רעיון חדש ומיוחד שתוכנן על ידי מרקו אצ'רביס. הוא מאפשר לך להצליל את הסלון שלך עם אלמנט חוסך מקום ובעיצוב ייחודי בסגנון טלנטי. מרX הוא קונספט אדריכלי הלוקח השראה מפרגולות קלאסיות ושמשיות, ומחדש את המבנה.\nהמבנה עשוי מאלומיניום מוקצן וזמין במגוון צבעים. כשהוא סגור, הוא נראה כמו שער מסתורי במיוחד, ואז מערכת הפתיחה כמו מצפן מאפשרת לסוכך להתרחב ולהעניק צל נעים ורחב.",
    "image_url": "../upload_images/Talenti/Umbrella/MrX/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Umbrella/MrX/main.jpg",
      "../upload_images/Talenti/Umbrella/MrX/7.jpg",
      "../upload_images/Talenti/Umbrella/MrX/6.jpg",
      "../upload_images/Talenti/Umbrella/MrX/5.jpg",
      "../upload_images/Talenti/Umbrella/MrX/4.jpg",
      "../upload_images/Talenti/Umbrella/MrX/3.jpg",
      "../upload_images/Talenti/Umbrella/MrX/2.jpg",
      "../upload_images/Talenti/Umbrella/MrX/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/mrx/",
    "company_name": "Talenti",
    "original_category": "Umbrella",
    "price": 28163,
    "filter_category": "פתרונות הצללה",
    "placement": "Outdoor"
  },
  "Parasol Apollo": {
    "description": "",
    "image_url": "../upload_images/Talenti/Umbrella/Parasol Apollo/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Umbrella/Parasol Apollo/main.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Apollo/5.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Apollo/4.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Apollo/3.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Apollo/2.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Apollo/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/parasol-apollo/",
    "company_name": "Talenti",
    "original_category": "Umbrella",
    "price": 13150,
    "filter_category": "פתרונות הצללה",
    "placement": "Outdoor"
  },
  "Parasol Athena": {
    "description": "",
    "image_url": "../upload_images/Talenti/Umbrella/Parasol Athena/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Umbrella/Parasol Athena/main.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Athena/8.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Athena/7.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Athena/6.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Athena/5.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Athena/4.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Athena/3.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Athena/2.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Athena/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/parasol-athena/",
    "company_name": "Talenti",
    "original_category": "Umbrella",
    "price": 21436,
    "filter_category": "פתרונות הצללה",
    "placement": "Outdoor"
  },
  "Parasol Mars": {
    "description": "",
    "image_url": "../upload_images/Talenti/Umbrella/Parasol Mars/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Umbrella/Parasol Mars/main.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/11.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/10.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/9.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/8.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/7.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/6.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/5.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/4.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/3.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/2.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Mars/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/parasol-mars/",
    "company_name": "Talenti",
    "original_category": "Umbrella",
    "price": 29531,
    "filter_category": "פתרונות הצללה",
    "placement": "Outdoor"
  },
  "Parasol Venus": {
    "description": "",
    "image_url": "../upload_images/Talenti/Umbrella/Parasol Venus/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Umbrella/Parasol Venus/main.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Venus/7.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Venus/6.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Venus/5.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Venus/4.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Venus/3.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Venus/2.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Venus/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/parasol-venus/",
    "company_name": "Talenti",
    "original_category": "Umbrella",
    "price": 20197,
    "filter_category": "פתרונות הצללה",
    "placement": "Outdoor"
  },
  "Parasol Volcano": {
    "description": "",
    "image_url": "../upload_images/Talenti/Umbrella/Parasol Volcano/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Umbrella/Parasol Volcano/main.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Volcano/3.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Volcano/2.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Volcano/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/parasol-volcano/",
    "company_name": "Talenti",
    "original_category": "Umbrella",
    "price": 10536,
    "filter_category": "פתרונות הצללה",
    "placement": "Outdoor"
  },
  "Parasol Zeus": {
    "description": "",
    "image_url": "../upload_images/Talenti/Umbrella/Parasol Zeus/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Umbrella/Parasol Zeus/main.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Zeus/5.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Zeus/4.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Zeus/3.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Zeus/2.jpg",
      "../upload_images/Talenti/Umbrella/Parasol Zeus/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/parasol-zeus/",
    "company_name": "Talenti",
    "original_category": "Umbrella",
    "price": 27395,
    "filter_category": "פתרונות הצללה",
    "placement": "Outdoor"
  },
  "Skyline": {
    "description": "אביזר שמסוגל למודול את חללי הגינה שלך בגמישות רבה, יוצר אזורים המוגנים מהשמש, מלאים בקסם ואלגנטיות. סקייליין היא הקו שנותן פרטיות לסלון החוץ ומתאים בחן לשאר הקולקציות. ממש חובה לאואזיס של רגיעה במרחבים החיצוניים.",
    "image_url": "../upload_images/Talenti/Umbrella/Skyline/main.jpg",
    "image_urls": [
      "../upload_images/Talenti/Umbrella/Skyline/main.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/10.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/9.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/8.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/7.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/6.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/5.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/4.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/3.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/2.jpg",
      "../upload_images/Talenti/Umbrella/Skyline/1.jpg"
    ],
    "product_url": "https://en.talentispa.com/prodotti/skyline/",
    "company_name": "Talenti",
    "original_category": "Umbrella",
    "price": 27383,
    "filter_category": "פתרונות הצללה",
    "placement": "Outdoor"
  }

}

  
